/**
 * TechSmith Smart Player v5.124.0
 */

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var pep = {exports: {}};

/*!
 * PEP v0.4.3 | https://github.com/jquery/PEP
 * Copyright jQuery Foundation and other contributors | http://jquery.org/license
 */
(function (module, exports) {
  (function (global, factory) {
    module.exports = factory() ;
  })(commonjsGlobal, function () {

    /**
     * This is the constructor for new PointerEvents.
     *
     * New Pointer Events must be given a type, and an optional dictionary of
     * initialization properties.
     *
     * Due to certain platform requirements, events returned from the constructor
     * identify as MouseEvents.
     *
     * @constructor
     * @param {String} inType The type of the event to create.
     * @param {Object} [inDict] An optional dictionary of initial event properties.
     * @return {Event} A new PointerEvent of type `inType`, initialized with properties from `inDict`.
     */
    var MOUSE_PROPS = ['bubbles', 'cancelable', 'view', 'detail', 'screenX', 'screenY', 'clientX', 'clientY', 'ctrlKey', 'altKey', 'shiftKey', 'metaKey', 'button', 'relatedTarget', 'pageX', 'pageY'];
    var MOUSE_DEFAULTS = [false, false, null, null, 0, 0, 0, 0, false, false, false, false, 0, null, 0, 0];
    function PointerEvent(inType, inDict) {
      inDict = inDict || Object.create(null);
      var e = document.createEvent('Event');
      e.initEvent(inType, inDict.bubbles || false, inDict.cancelable || false);

      // define inherited MouseEvent properties
      // skip bubbles and cancelable since they're set above in initEvent()
      for (var i = 2, p; i < MOUSE_PROPS.length; i++) {
        p = MOUSE_PROPS[i];
        e[p] = inDict[p] || MOUSE_DEFAULTS[i];
      }
      e.buttons = inDict.buttons || 0;

      // Spec requires that pointers without pressure specified use 0.5 for down
      // state and 0 for up state.
      var pressure = 0;
      if (inDict.pressure && e.buttons) {
        pressure = inDict.pressure;
      } else {
        pressure = e.buttons ? 0.5 : 0;
      }

      // add x/y properties aliased to clientX/Y
      e.x = e.clientX;
      e.y = e.clientY;

      // define the properties of the PointerEvent interface
      e.pointerId = inDict.pointerId || 0;
      e.width = inDict.width || 0;
      e.height = inDict.height || 0;
      e.pressure = pressure;
      e.tiltX = inDict.tiltX || 0;
      e.tiltY = inDict.tiltY || 0;
      e.twist = inDict.twist || 0;
      e.tangentialPressure = inDict.tangentialPressure || 0;
      e.pointerType = inDict.pointerType || '';
      e.hwTimestamp = inDict.hwTimestamp || 0;
      e.isPrimary = inDict.isPrimary || false;
      return e;
    }

    /**
     * This module implements a map of pointer states
     */
    var USE_MAP = window.Map && window.Map.prototype.forEach;
    var PointerMap = USE_MAP ? Map : SparseArrayMap;
    function SparseArrayMap() {
      this.array = [];
      this.size = 0;
    }
    SparseArrayMap.prototype = {
      set: function set(k, v) {
        if (v === undefined) {
          return this["delete"](k);
        }
        if (!this.has(k)) {
          this.size++;
        }
        this.array[k] = v;
      },
      has: function has(k) {
        return this.array[k] !== undefined;
      },
      "delete": function _delete(k) {
        if (this.has(k)) {
          delete this.array[k];
          this.size--;
        }
      },
      get: function get(k) {
        return this.array[k];
      },
      clear: function clear() {
        this.array.length = 0;
        this.size = 0;
      },
      // return value, key, map
      forEach: function forEach(callback, thisArg) {
        return this.array.forEach(function (v, k) {
          callback.call(thisArg, v, k, this);
        }, this);
      }
    };
    var CLONE_PROPS = [
    // MouseEvent
    'bubbles', 'cancelable', 'view', 'detail', 'screenX', 'screenY', 'clientX', 'clientY', 'ctrlKey', 'altKey', 'shiftKey', 'metaKey', 'button', 'relatedTarget',
    // DOM Level 3
    'buttons',
    // PointerEvent
    'pointerId', 'width', 'height', 'pressure', 'tiltX', 'tiltY', 'pointerType', 'hwTimestamp', 'isPrimary',
    // event instance
    'type', 'target', 'currentTarget', 'which', 'pageX', 'pageY', 'timeStamp'];
    var CLONE_DEFAULTS = [
    // MouseEvent
    false, false, null, null, 0, 0, 0, 0, false, false, false, false, 0, null,
    // DOM Level 3
    0,
    // PointerEvent
    0, 0, 0, 0, 0, 0, '', 0, false,
    // event instance
    '', null, null, 0, 0, 0, 0];
    var BOUNDARY_EVENTS = {
      'pointerover': 1,
      'pointerout': 1,
      'pointerenter': 1,
      'pointerleave': 1
    };
    var HAS_SVG_INSTANCE = typeof SVGElementInstance !== 'undefined';

    /**
     * This module is for normalizing events. Mouse and Touch events will be
     * collected here, and fire PointerEvents that have the same semantics, no
     * matter the source.
     * Events fired:
     *   - pointerdown: a pointing is added
     *   - pointerup: a pointer is removed
     *   - pointermove: a pointer is moved
     *   - pointerover: a pointer crosses into an element
     *   - pointerout: a pointer leaves an element
     *   - pointercancel: a pointer will no longer generate events
     */
    var dispatcher = {
      pointermap: new PointerMap(),
      eventMap: Object.create(null),
      captureInfo: Object.create(null),
      // Scope objects for native events.
      // This exists for ease of testing.
      eventSources: Object.create(null),
      eventSourceList: [],
      /**
       * Add a new event source that will generate pointer events.
       *
       * `inSource` must contain an array of event names named `events`, and
       * functions with the names specified in the `events` array.
       * @param {string} name A name for the event source
       * @param {Object} source A new source of platform events.
       */
      registerSource: function registerSource(name, source) {
        var s = source;
        var newEvents = s.events;
        if (newEvents) {
          newEvents.forEach(function (e) {
            if (s[e]) {
              this.eventMap[e] = s[e].bind(s);
            }
          }, this);
          this.eventSources[name] = s;
          this.eventSourceList.push(s);
        }
      },
      register: function register(element) {
        var l = this.eventSourceList.length;
        for (var i = 0, es; i < l && (es = this.eventSourceList[i]); i++) {
          // call eventsource register
          es.register.call(es, element);
        }
      },
      unregister: function unregister(element) {
        var l = this.eventSourceList.length;
        for (var i = 0, es; i < l && (es = this.eventSourceList[i]); i++) {
          // call eventsource register
          es.unregister.call(es, element);
        }
      },
      contains: /*scope.external.contains || */function contains(container, contained) {
        try {
          return container.contains(contained);
        } catch (ex) {
          // most likely: https://bugzilla.mozilla.org/show_bug.cgi?id=208427
          return false;
        }
      },
      // EVENTS
      down: function down(inEvent) {
        inEvent.bubbles = true;
        this.fireEvent('pointerdown', inEvent);
      },
      move: function move(inEvent) {
        inEvent.bubbles = true;
        this.fireEvent('pointermove', inEvent);
      },
      up: function up(inEvent) {
        inEvent.bubbles = true;
        this.fireEvent('pointerup', inEvent);
      },
      enter: function enter(inEvent) {
        inEvent.bubbles = false;
        this.fireEvent('pointerenter', inEvent);
      },
      leave: function leave(inEvent) {
        inEvent.bubbles = false;
        this.fireEvent('pointerleave', inEvent);
      },
      over: function over(inEvent) {
        inEvent.bubbles = true;
        this.fireEvent('pointerover', inEvent);
      },
      out: function out(inEvent) {
        inEvent.bubbles = true;
        this.fireEvent('pointerout', inEvent);
      },
      cancel: function cancel(inEvent) {
        inEvent.bubbles = true;
        this.fireEvent('pointercancel', inEvent);
      },
      leaveOut: function leaveOut(event) {
        this.out(event);
        this.propagate(event, this.leave, false);
      },
      enterOver: function enterOver(event) {
        this.over(event);
        this.propagate(event, this.enter, true);
      },
      // LISTENER LOGIC
      eventHandler: function eventHandler(inEvent) {
        // This is used to prevent multiple dispatch of pointerevents from
        // platform events. This can happen when two elements in different scopes
        // are set up to create pointer events, which is relevant to Shadow DOM.
        if (inEvent._handledByPE) {
          return;
        }
        var type = inEvent.type;
        var fn = this.eventMap && this.eventMap[type];
        if (fn) {
          fn(inEvent);
        }
        inEvent._handledByPE = true;
      },
      // set up event listeners
      listen: function listen(target, events) {
        events.forEach(function (e) {
          this.addEvent(target, e);
        }, this);
      },
      // remove event listeners
      unlisten: function unlisten(target, events) {
        events.forEach(function (e) {
          this.removeEvent(target, e);
        }, this);
      },
      addEvent: /*scope.external.addEvent || */function addEvent(target, eventName) {
        target.addEventListener(eventName, this.boundHandler);
      },
      removeEvent: /*scope.external.removeEvent || */function removeEvent(target, eventName) {
        target.removeEventListener(eventName, this.boundHandler);
      },
      // EVENT CREATION AND TRACKING
      /**
       * Creates a new Event of type `inType`, based on the information in
       * `inEvent`.
       *
       * @param {string} inType A string representing the type of event to create
       * @param {Event} inEvent A platform event with a target
       * @return {Event} A PointerEvent of type `inType`
       */
      makeEvent: function makeEvent(inType, inEvent) {
        // relatedTarget must be null if pointer is captured
        if (this.captureInfo[inEvent.pointerId]) {
          inEvent.relatedTarget = null;
        }
        var e = new PointerEvent(inType, inEvent);
        if (inEvent.preventDefault) {
          e.preventDefault = inEvent.preventDefault;
        }
        e._target = e._target || inEvent.target;
        return e;
      },
      // make and dispatch an event in one call
      fireEvent: function fireEvent(inType, inEvent) {
        var e = this.makeEvent(inType, inEvent);
        return this.dispatchEvent(e);
      },
      /**
       * Returns a snapshot of inEvent, with writable properties.
       *
       * @param {Event} inEvent An event that contains properties to copy.
       * @return {Object} An object containing shallow copies of `inEvent`'s
       *    properties.
       */
      cloneEvent: function cloneEvent(inEvent) {
        var eventCopy = Object.create(null);
        var p;
        for (var i = 0; i < CLONE_PROPS.length; i++) {
          p = CLONE_PROPS[i];
          eventCopy[p] = inEvent[p] || CLONE_DEFAULTS[i];

          // Work around SVGInstanceElement shadow tree
          // Return the <use> element that is represented by the instance for Safari, Chrome, IE.
          // This is the behavior implemented by Firefox.
          if (HAS_SVG_INSTANCE && (p === 'target' || p === 'relatedTarget')) {
            if (eventCopy[p] instanceof SVGElementInstance) {
              eventCopy[p] = eventCopy[p].correspondingUseElement;
            }
          }
        }

        // keep the semantics of preventDefault
        if (inEvent.preventDefault) {
          eventCopy.preventDefault = function () {
            inEvent.preventDefault();
          };
        }
        return eventCopy;
      },
      getTarget: function getTarget(inEvent) {
        var capture = this.captureInfo[inEvent.pointerId];
        if (!capture) {
          return inEvent._target;
        }
        if (inEvent._target === capture || !(inEvent.type in BOUNDARY_EVENTS)) {
          return capture;
        }
      },
      propagate: function propagate(event, fn, propagateDown) {
        var target = event.target;
        var targets = [];

        // Order of conditions due to document.contains() missing in IE.
        while (target !== document && !target.contains(event.relatedTarget)) {
          targets.push(target);
          target = target.parentNode;

          // Touch: Do not propagate if node is detached.
          if (!target) {
            return;
          }
        }
        if (propagateDown) {
          targets.reverse();
        }
        targets.forEach(function (target) {
          event.target = target;
          fn.call(this, event);
        }, this);
      },
      setCapture: function setCapture(inPointerId, inTarget, skipDispatch) {
        if (this.captureInfo[inPointerId]) {
          this.releaseCapture(inPointerId, skipDispatch);
        }
        this.captureInfo[inPointerId] = inTarget;
        this.implicitRelease = this.releaseCapture.bind(this, inPointerId, skipDispatch);
        document.addEventListener('pointerup', this.implicitRelease);
        document.addEventListener('pointercancel', this.implicitRelease);
        var e = new PointerEvent('gotpointercapture');
        e.pointerId = inPointerId;
        e._target = inTarget;
        if (!skipDispatch) {
          this.asyncDispatchEvent(e);
        }
      },
      releaseCapture: function releaseCapture(inPointerId, skipDispatch) {
        var t = this.captureInfo[inPointerId];
        if (!t) {
          return;
        }
        this.captureInfo[inPointerId] = undefined;
        document.removeEventListener('pointerup', this.implicitRelease);
        document.removeEventListener('pointercancel', this.implicitRelease);
        var e = new PointerEvent('lostpointercapture');
        e.pointerId = inPointerId;
        e._target = t;
        if (!skipDispatch) {
          this.asyncDispatchEvent(e);
        }
      },
      /**
       * Dispatches the event to its target.
       *
       * @param {Event} inEvent The event to be dispatched.
       * @return {Boolean} True if an event handler returns true, false otherwise.
       */
      dispatchEvent: /*scope.external.dispatchEvent || */function dispatchEvent(inEvent) {
        var t = this.getTarget(inEvent);
        if (t) {
          return t.dispatchEvent(inEvent);
        }
      },
      asyncDispatchEvent: function asyncDispatchEvent(inEvent) {
        requestAnimationFrame(this.dispatchEvent.bind(this, inEvent));
      }
    };
    dispatcher.boundHandler = dispatcher.eventHandler.bind(dispatcher);
    var targeting = {
      shadow: function shadow(inEl) {
        if (inEl) {
          return inEl.shadowRoot || inEl.webkitShadowRoot;
        }
      },
      canTarget: function canTarget(shadow) {
        return shadow && Boolean(shadow.elementFromPoint);
      },
      targetingShadow: function targetingShadow(inEl) {
        var s = this.shadow(inEl);
        if (this.canTarget(s)) {
          return s;
        }
      },
      olderShadow: function olderShadow(shadow) {
        var os = shadow.olderShadowRoot;
        if (!os) {
          var se = shadow.querySelector('shadow');
          if (se) {
            os = se.olderShadowRoot;
          }
        }
        return os;
      },
      allShadows: function allShadows(element) {
        var shadows = [];
        var s = this.shadow(element);
        while (s) {
          shadows.push(s);
          s = this.olderShadow(s);
        }
        return shadows;
      },
      searchRoot: function searchRoot(inRoot, x, y) {
        if (inRoot) {
          var t = inRoot.elementFromPoint(x, y);
          var st, sr;

          // is element a shadow host?
          sr = this.targetingShadow(t);
          while (sr) {
            // find the the element inside the shadow root
            st = sr.elementFromPoint(x, y);
            if (!st) {
              // check for older shadows
              sr = this.olderShadow(sr);
            } else {
              // shadowed element may contain a shadow root
              var ssr = this.targetingShadow(st);
              return this.searchRoot(ssr, x, y) || st;
            }
          }

          // light dom element is the target
          return t;
        }
      },
      owner: function owner(element) {
        var s = element;

        // walk up until you hit the shadow root or document
        while (s.parentNode) {
          s = s.parentNode;
        }

        // the owner element is expected to be a Document or ShadowRoot
        if (s.nodeType !== Node.DOCUMENT_NODE && s.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
          s = document;
        }
        return s;
      },
      findTarget: function findTarget(inEvent) {
        var x = inEvent.clientX;
        var y = inEvent.clientY;

        // if the listener is in the shadow root, it is much faster to start there
        var s = this.owner(inEvent.target);

        // if x, y is not in this root, fall back to document search
        if (!s.elementFromPoint(x, y)) {
          s = document;
        }
        return this.searchRoot(s, x, y);
      }
    };
    var forEach = Array.prototype.forEach.call.bind(Array.prototype.forEach);
    var map = Array.prototype.map.call.bind(Array.prototype.map);
    var toArray = Array.prototype.slice.call.bind(Array.prototype.slice);
    var filter = Array.prototype.filter.call.bind(Array.prototype.filter);
    var MO = window.MutationObserver || window.WebKitMutationObserver;
    var SELECTOR = '[touch-action]';
    var OBSERVER_INIT = {
      subtree: true,
      childList: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['touch-action']
    };
    function Installer(add, remove, changed, binder) {
      this.addCallback = add.bind(binder);
      this.removeCallback = remove.bind(binder);
      this.changedCallback = changed.bind(binder);
      if (MO) {
        this.observer = new MO(this.mutationWatcher.bind(this));
      }
    }
    Installer.prototype = {
      watchSubtree: function watchSubtree(target) {
        // Only watch scopes that can target find, as these are top-level.
        // Otherwise we can see duplicate additions and removals that add noise.
        //
        // TODO(dfreedman): For some instances with ShadowDOMPolyfill, we can see
        // a removal without an insertion when a node is redistributed among
        // shadows. Since it all ends up correct in the document, watching only
        // the document will yield the correct mutations to watch.
        if (this.observer && targeting.canTarget(target)) {
          this.observer.observe(target, OBSERVER_INIT);
        }
      },
      enableOnSubtree: function enableOnSubtree(target) {
        this.watchSubtree(target);
        if (target === document && document.readyState !== 'complete') {
          this.installOnLoad();
        } else {
          this.installNewSubtree(target);
        }
      },
      installNewSubtree: function installNewSubtree(target) {
        forEach(this.findElements(target), this.addElement, this);
      },
      findElements: function findElements(target) {
        if (target.querySelectorAll) {
          return target.querySelectorAll(SELECTOR);
        }
        return [];
      },
      removeElement: function removeElement(el) {
        this.removeCallback(el);
      },
      addElement: function addElement(el) {
        this.addCallback(el);
      },
      elementChanged: function elementChanged(el, oldValue) {
        this.changedCallback(el, oldValue);
      },
      concatLists: function concatLists(accum, list) {
        return accum.concat(toArray(list));
      },
      // register all touch-action = none nodes on document load
      installOnLoad: function installOnLoad() {
        document.addEventListener('readystatechange', function () {
          if (document.readyState === 'complete') {
            this.installNewSubtree(document);
          }
        }.bind(this));
      },
      isElement: function isElement(n) {
        return n.nodeType === Node.ELEMENT_NODE;
      },
      flattenMutationTree: function flattenMutationTree(inNodes) {
        // find children with touch-action
        var tree = map(inNodes, this.findElements, this);

        // make sure the added nodes are accounted for
        tree.push(filter(inNodes, this.isElement));

        // flatten the list
        return tree.reduce(this.concatLists, []);
      },
      mutationWatcher: function mutationWatcher(mutations) {
        mutations.forEach(this.mutationHandler, this);
      },
      mutationHandler: function mutationHandler(m) {
        if (m.type === 'childList') {
          var added = this.flattenMutationTree(m.addedNodes);
          added.forEach(this.addElement, this);
          var removed = this.flattenMutationTree(m.removedNodes);
          removed.forEach(this.removeElement, this);
        } else if (m.type === 'attributes') {
          this.elementChanged(m.target, m.oldValue);
        }
      }
    };
    function shadowSelector(v) {
      return 'body /shadow-deep/ ' + selector(v);
    }
    function selector(v) {
      return '[touch-action="' + v + '"]';
    }
    function rule(v) {
      return '{ -ms-touch-action: ' + v + '; touch-action: ' + v + '; }';
    }
    var attrib2css = ['none', 'auto', 'pan-x', 'pan-y', {
      rule: 'pan-x pan-y',
      selectors: ['pan-x pan-y', 'pan-y pan-x']
    }];
    var styles = '';

    // only install stylesheet if the browser has touch action support
    var hasNativePE = window.PointerEvent || window.MSPointerEvent;

    // only add shadow selectors if shadowdom is supported
    var hasShadowRoot = !window.ShadowDOMPolyfill && document.head.createShadowRoot;
    function applyAttributeStyles() {
      if (hasNativePE) {
        attrib2css.forEach(function (r) {
          if (String(r) === r) {
            styles += selector(r) + rule(r) + '\n';
            if (hasShadowRoot) {
              styles += shadowSelector(r) + rule(r) + '\n';
            }
          } else {
            styles += r.selectors.map(selector) + rule(r.rule) + '\n';
            if (hasShadowRoot) {
              styles += r.selectors.map(shadowSelector) + rule(r.rule) + '\n';
            }
          }
        });
        var el = document.createElement('style');
        el.textContent = styles;
        document.head.appendChild(el);
      }
    }
    var pointermap = dispatcher.pointermap;

    // radius around touchend that swallows mouse events
    var DEDUP_DIST = 25;

    // left, middle, right, back, forward
    var BUTTON_TO_BUTTONS = [1, 4, 2, 8, 16];
    var HAS_BUTTONS = false;
    try {
      HAS_BUTTONS = new MouseEvent('test', {
        buttons: 1
      }).buttons === 1;
    } catch (e) {}

    // handler block for native mouse events
    var mouseEvents = {
      POINTER_ID: 1,
      POINTER_TYPE: 'mouse',
      events: ['mousedown', 'mousemove', 'mouseup', 'mouseover', 'mouseout'],
      register: function register(target) {
        dispatcher.listen(target, this.events);
      },
      unregister: function unregister(target) {
        dispatcher.unlisten(target, this.events);
      },
      lastTouches: [],
      // collide with the global mouse listener
      isEventSimulatedFromTouch: function isEventSimulatedFromTouch(inEvent) {
        var lts = this.lastTouches;
        var x = inEvent.clientX;
        var y = inEvent.clientY;
        for (var i = 0, l = lts.length, t; i < l && (t = lts[i]); i++) {
          // simulated mouse events will be swallowed near a primary touchend
          var dx = Math.abs(x - t.x);
          var dy = Math.abs(y - t.y);
          if (dx <= DEDUP_DIST && dy <= DEDUP_DIST) {
            return true;
          }
        }
      },
      prepareEvent: function prepareEvent(inEvent) {
        var e = dispatcher.cloneEvent(inEvent);

        // forward mouse preventDefault
        var pd = e.preventDefault;
        e.preventDefault = function () {
          inEvent.preventDefault();
          pd();
        };
        e.pointerId = this.POINTER_ID;
        e.isPrimary = true;
        e.pointerType = this.POINTER_TYPE;
        return e;
      },
      prepareButtonsForMove: function prepareButtonsForMove(e, inEvent) {
        var p = pointermap.get(this.POINTER_ID);

        // Update buttons state after possible out-of-document mouseup.
        if (inEvent.which === 0 || !p) {
          e.buttons = 0;
        } else {
          e.buttons = p.buttons;
        }
        inEvent.buttons = e.buttons;
      },
      mousedown: function mousedown(inEvent) {
        if (!this.isEventSimulatedFromTouch(inEvent)) {
          var p = pointermap.get(this.POINTER_ID);
          var e = this.prepareEvent(inEvent);
          if (!HAS_BUTTONS) {
            e.buttons = BUTTON_TO_BUTTONS[e.button];
            if (p) {
              e.buttons |= p.buttons;
            }
            inEvent.buttons = e.buttons;
          }
          pointermap.set(this.POINTER_ID, inEvent);
          if (!p || p.buttons === 0) {
            dispatcher.down(e);
          } else {
            dispatcher.move(e);
          }
        }
      },
      mousemove: function mousemove(inEvent) {
        if (!this.isEventSimulatedFromTouch(inEvent)) {
          var e = this.prepareEvent(inEvent);
          if (!HAS_BUTTONS) {
            this.prepareButtonsForMove(e, inEvent);
          }
          e.button = -1;
          pointermap.set(this.POINTER_ID, inEvent);
          dispatcher.move(e);
        }
      },
      mouseup: function mouseup(inEvent) {
        if (!this.isEventSimulatedFromTouch(inEvent)) {
          var p = pointermap.get(this.POINTER_ID);
          var e = this.prepareEvent(inEvent);
          if (!HAS_BUTTONS) {
            var up = BUTTON_TO_BUTTONS[e.button];

            // Produces wrong state of buttons in Browsers without `buttons` support
            // when a mouse button that was pressed outside the document is released
            // inside and other buttons are still pressed down.
            e.buttons = p ? p.buttons & ~up : 0;
            inEvent.buttons = e.buttons;
          }
          pointermap.set(this.POINTER_ID, inEvent);

          // Support: Firefox <=44 only
          // FF Ubuntu includes the lifted button in the `buttons` property on
          // mouseup.
          // https://bugzilla.mozilla.org/show_bug.cgi?id=1223366
          e.buttons &= ~BUTTON_TO_BUTTONS[e.button];
          if (e.buttons === 0) {
            dispatcher.up(e);
          } else {
            dispatcher.move(e);
          }
        }
      },
      mouseover: function mouseover(inEvent) {
        if (!this.isEventSimulatedFromTouch(inEvent)) {
          var e = this.prepareEvent(inEvent);
          if (!HAS_BUTTONS) {
            this.prepareButtonsForMove(e, inEvent);
          }
          e.button = -1;
          pointermap.set(this.POINTER_ID, inEvent);
          dispatcher.enterOver(e);
        }
      },
      mouseout: function mouseout(inEvent) {
        if (!this.isEventSimulatedFromTouch(inEvent)) {
          var e = this.prepareEvent(inEvent);
          if (!HAS_BUTTONS) {
            this.prepareButtonsForMove(e, inEvent);
          }
          e.button = -1;
          dispatcher.leaveOut(e);
        }
      },
      cancel: function cancel(inEvent) {
        var e = this.prepareEvent(inEvent);
        dispatcher.cancel(e);
        this.deactivateMouse();
      },
      deactivateMouse: function deactivateMouse() {
        pointermap["delete"](this.POINTER_ID);
      }
    };
    var captureInfo = dispatcher.captureInfo;
    var findTarget = targeting.findTarget.bind(targeting);
    var allShadows = targeting.allShadows.bind(targeting);
    var pointermap$1 = dispatcher.pointermap;

    // This should be long enough to ignore compat mouse events made by touch
    var DEDUP_TIMEOUT = 2500;
    var CLICK_COUNT_TIMEOUT = 200;
    var ATTRIB = 'touch-action';
    var INSTALLER;

    // handler block for native touch events
    var touchEvents = {
      events: ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
      register: function register(target) {
        INSTALLER.enableOnSubtree(target);
      },
      unregister: function unregister() {

        // TODO(dfreedman): is it worth it to disconnect the MO?
      },
      elementAdded: function elementAdded(el) {
        var a = el.getAttribute(ATTRIB);
        var st = this.touchActionToScrollType(a);
        if (st) {
          el._scrollType = st;
          dispatcher.listen(el, this.events);

          // set touch-action on shadows as well
          allShadows(el).forEach(function (s) {
            s._scrollType = st;
            dispatcher.listen(s, this.events);
          }, this);
        }
      },
      elementRemoved: function elementRemoved(el) {
        el._scrollType = undefined;
        dispatcher.unlisten(el, this.events);

        // remove touch-action from shadow
        allShadows(el).forEach(function (s) {
          s._scrollType = undefined;
          dispatcher.unlisten(s, this.events);
        }, this);
      },
      elementChanged: function elementChanged(el, oldValue) {
        var a = el.getAttribute(ATTRIB);
        var st = this.touchActionToScrollType(a);
        var oldSt = this.touchActionToScrollType(oldValue);

        // simply update scrollType if listeners are already established
        if (st && oldSt) {
          el._scrollType = st;
          allShadows(el).forEach(function (s) {
            s._scrollType = st;
          }, this);
        } else if (oldSt) {
          this.elementRemoved(el);
        } else if (st) {
          this.elementAdded(el);
        }
      },
      scrollTypes: {
        EMITTER: 'none',
        XSCROLLER: 'pan-x',
        YSCROLLER: 'pan-y',
        SCROLLER: /^(?:pan-x pan-y)|(?:pan-y pan-x)|auto$/
      },
      touchActionToScrollType: function touchActionToScrollType(touchAction) {
        var t = touchAction;
        var st = this.scrollTypes;
        if (t === 'none') {
          return 'none';
        } else if (t === st.XSCROLLER) {
          return 'X';
        } else if (t === st.YSCROLLER) {
          return 'Y';
        } else if (st.SCROLLER.exec(t)) {
          return 'XY';
        }
      },
      POINTER_TYPE: 'touch',
      firstTouch: null,
      isPrimaryTouch: function isPrimaryTouch(inTouch) {
        return this.firstTouch === inTouch.identifier;
      },
      setPrimaryTouch: function setPrimaryTouch(inTouch) {
        // set primary touch if there no pointers, or the only pointer is the mouse
        if (pointermap$1.size === 0 || pointermap$1.size === 1 && pointermap$1.has(1)) {
          this.firstTouch = inTouch.identifier;
          this.firstXY = {
            X: inTouch.clientX,
            Y: inTouch.clientY
          };
          this.scrolling = false;
          this.cancelResetClickCount();
        }
      },
      removePrimaryPointer: function removePrimaryPointer(inPointer) {
        if (inPointer.isPrimary) {
          this.firstTouch = null;
          this.firstXY = null;
          this.resetClickCount();
        }
      },
      clickCount: 0,
      resetId: null,
      resetClickCount: function resetClickCount() {
        var fn = function () {
          this.clickCount = 0;
          this.resetId = null;
        }.bind(this);
        this.resetId = setTimeout(fn, CLICK_COUNT_TIMEOUT);
      },
      cancelResetClickCount: function cancelResetClickCount() {
        if (this.resetId) {
          clearTimeout(this.resetId);
        }
      },
      typeToButtons: function typeToButtons(type) {
        var ret = 0;
        if (type === 'touchstart' || type === 'touchmove') {
          ret = 1;
        }
        return ret;
      },
      touchToPointer: function touchToPointer(inTouch) {
        var cte = this.currentTouchEvent;
        var e = dispatcher.cloneEvent(inTouch);

        // We reserve pointerId 1 for Mouse.
        // Touch identifiers can start at 0.
        // Add 2 to the touch identifier for compatibility.
        var id = e.pointerId = inTouch.identifier + 2;
        e.target = captureInfo[id] || findTarget(e);
        e.bubbles = true;
        e.cancelable = true;
        e.detail = this.clickCount;
        e.button = 0;
        e.buttons = this.typeToButtons(cte.type);
        e.width = (inTouch.radiusX || inTouch.webkitRadiusX || 0) * 2;
        e.height = (inTouch.radiusY || inTouch.webkitRadiusY || 0) * 2;
        e.pressure = inTouch.force || inTouch.webkitForce || 0.5;
        e.isPrimary = this.isPrimaryTouch(inTouch);
        e.pointerType = this.POINTER_TYPE;

        // forward modifier keys
        e.altKey = cte.altKey;
        e.ctrlKey = cte.ctrlKey;
        e.metaKey = cte.metaKey;
        e.shiftKey = cte.shiftKey;

        // forward touch preventDefaults
        var self = this;
        e.preventDefault = function () {
          self.scrolling = false;
          self.firstXY = null;
          cte.preventDefault();
        };
        return e;
      },
      processTouches: function processTouches(inEvent, inFunction) {
        var tl = inEvent.changedTouches;
        this.currentTouchEvent = inEvent;
        for (var i = 0, t; i < tl.length; i++) {
          t = tl[i];
          inFunction.call(this, this.touchToPointer(t));
        }
      },
      // For single axis scrollers, determines whether the element should emit
      // pointer events or behave as a scroller
      shouldScroll: function shouldScroll(inEvent) {
        if (this.firstXY) {
          var ret;
          var scrollAxis = inEvent.currentTarget._scrollType;
          if (scrollAxis === 'none') {
            // this element is a touch-action: none, should never scroll
            ret = false;
          } else if (scrollAxis === 'XY') {
            // this element should always scroll
            ret = true;
          } else {
            var t = inEvent.changedTouches[0];

            // check the intended scroll axis, and other axis
            var a = scrollAxis;
            var oa = scrollAxis === 'Y' ? 'X' : 'Y';
            var da = Math.abs(t['client' + a] - this.firstXY[a]);
            var doa = Math.abs(t['client' + oa] - this.firstXY[oa]);

            // if delta in the scroll axis > delta other axis, scroll instead of
            // making events
            ret = da >= doa;
          }
          this.firstXY = null;
          return ret;
        }
      },
      findTouch: function findTouch(inTL, inId) {
        for (var i = 0, l = inTL.length, t; i < l && (t = inTL[i]); i++) {
          if (t.identifier === inId) {
            return true;
          }
        }
      },
      // In some instances, a touchstart can happen without a touchend. This
      // leaves the pointermap in a broken state.
      // Therefore, on every touchstart, we remove the touches that did not fire a
      // touchend event.
      // To keep state globally consistent, we fire a
      // pointercancel for this "abandoned" touch
      vacuumTouches: function vacuumTouches(inEvent) {
        var tl = inEvent.touches;

        // pointermap.size should be < tl.length here, as the touchstart has not
        // been processed yet.
        if (pointermap$1.size >= tl.length) {
          var d = [];
          pointermap$1.forEach(function (value, key) {
            // Never remove pointerId == 1, which is mouse.
            // Touch identifiers are 2 smaller than their pointerId, which is the
            // index in pointermap.
            if (key !== 1 && !this.findTouch(tl, key - 2)) {
              var p = value.out;
              d.push(p);
            }
          }, this);
          d.forEach(this.cancelOut, this);
        }
      },
      touchstart: function touchstart(inEvent) {
        this.vacuumTouches(inEvent);
        this.setPrimaryTouch(inEvent.changedTouches[0]);
        this.dedupSynthMouse(inEvent);
        if (!this.scrolling) {
          this.clickCount++;
          this.processTouches(inEvent, this.overDown);
        }
      },
      overDown: function overDown(inPointer) {
        pointermap$1.set(inPointer.pointerId, {
          target: inPointer.target,
          out: inPointer,
          outTarget: inPointer.target
        });
        dispatcher.enterOver(inPointer);
        dispatcher.down(inPointer);
      },
      touchmove: function touchmove(inEvent) {
        if (!this.scrolling) {
          if (this.shouldScroll(inEvent)) {
            this.scrolling = true;
            this.touchcancel(inEvent);
          } else {
            inEvent.preventDefault();
            this.processTouches(inEvent, this.moveOverOut);
          }
        }
      },
      moveOverOut: function moveOverOut(inPointer) {
        var event = inPointer;
        var pointer = pointermap$1.get(event.pointerId);

        // a finger drifted off the screen, ignore it
        if (!pointer) {
          return;
        }
        var outEvent = pointer.out;
        var outTarget = pointer.outTarget;
        dispatcher.move(event);
        if (outEvent && outTarget !== event.target) {
          outEvent.relatedTarget = event.target;
          event.relatedTarget = outTarget;

          // recover from retargeting by shadow
          outEvent.target = outTarget;
          if (event.target) {
            dispatcher.leaveOut(outEvent);
            dispatcher.enterOver(event);
          } else {
            // clean up case when finger leaves the screen
            event.target = outTarget;
            event.relatedTarget = null;
            this.cancelOut(event);
          }
        }
        pointer.out = event;
        pointer.outTarget = event.target;
      },
      touchend: function touchend(inEvent) {
        this.dedupSynthMouse(inEvent);
        this.processTouches(inEvent, this.upOut);
      },
      upOut: function upOut(inPointer) {
        if (!this.scrolling) {
          dispatcher.up(inPointer);
          dispatcher.leaveOut(inPointer);
        }
        this.cleanUpPointer(inPointer);
      },
      touchcancel: function touchcancel(inEvent) {
        this.processTouches(inEvent, this.cancelOut);
      },
      cancelOut: function cancelOut(inPointer) {
        dispatcher.cancel(inPointer);
        dispatcher.leaveOut(inPointer);
        this.cleanUpPointer(inPointer);
      },
      cleanUpPointer: function cleanUpPointer(inPointer) {
        pointermap$1["delete"](inPointer.pointerId);
        this.removePrimaryPointer(inPointer);
      },
      // prevent synth mouse events from creating pointer events
      dedupSynthMouse: function dedupSynthMouse(inEvent) {
        var lts = mouseEvents.lastTouches;
        var t = inEvent.changedTouches[0];

        // only the primary finger will synth mouse events
        if (this.isPrimaryTouch(t)) {
          // remember x/y of last touch
          var lt = {
            x: t.clientX,
            y: t.clientY
          };
          lts.push(lt);
          var fn = function (lts, lt) {
            var i = lts.indexOf(lt);
            if (i > -1) {
              lts.splice(i, 1);
            }
          }.bind(null, lts, lt);
          setTimeout(fn, DEDUP_TIMEOUT);
        }
      }
    };
    INSTALLER = new Installer(touchEvents.elementAdded, touchEvents.elementRemoved, touchEvents.elementChanged, touchEvents);
    var pointermap$2 = dispatcher.pointermap;
    var HAS_BITMAP_TYPE = window.MSPointerEvent && typeof window.MSPointerEvent.MSPOINTER_TYPE_MOUSE === 'number';
    var msEvents = {
      events: ['MSPointerDown', 'MSPointerMove', 'MSPointerUp', 'MSPointerOut', 'MSPointerOver', 'MSPointerCancel', 'MSGotPointerCapture', 'MSLostPointerCapture'],
      register: function register(target) {
        dispatcher.listen(target, this.events);
      },
      unregister: function unregister(target) {
        dispatcher.unlisten(target, this.events);
      },
      POINTER_TYPES: ['', 'unavailable', 'touch', 'pen', 'mouse'],
      prepareEvent: function prepareEvent(inEvent) {
        var e = inEvent;
        if (HAS_BITMAP_TYPE) {
          e = dispatcher.cloneEvent(inEvent);
          e.pointerType = this.POINTER_TYPES[inEvent.pointerType];
        }
        return e;
      },
      cleanup: function cleanup(id) {
        pointermap$2["delete"](id);
      },
      MSPointerDown: function MSPointerDown(inEvent) {
        pointermap$2.set(inEvent.pointerId, inEvent);
        var e = this.prepareEvent(inEvent);
        dispatcher.down(e);
      },
      MSPointerMove: function MSPointerMove(inEvent) {
        var e = this.prepareEvent(inEvent);
        dispatcher.move(e);
      },
      MSPointerUp: function MSPointerUp(inEvent) {
        var e = this.prepareEvent(inEvent);
        dispatcher.up(e);
        this.cleanup(inEvent.pointerId);
      },
      MSPointerOut: function MSPointerOut(inEvent) {
        var e = this.prepareEvent(inEvent);
        dispatcher.leaveOut(e);
      },
      MSPointerOver: function MSPointerOver(inEvent) {
        var e = this.prepareEvent(inEvent);
        dispatcher.enterOver(e);
      },
      MSPointerCancel: function MSPointerCancel(inEvent) {
        var e = this.prepareEvent(inEvent);
        dispatcher.cancel(e);
        this.cleanup(inEvent.pointerId);
      },
      MSLostPointerCapture: function MSLostPointerCapture(inEvent) {
        var e = dispatcher.makeEvent('lostpointercapture', inEvent);
        dispatcher.dispatchEvent(e);
      },
      MSGotPointerCapture: function MSGotPointerCapture(inEvent) {
        var e = dispatcher.makeEvent('gotpointercapture', inEvent);
        dispatcher.dispatchEvent(e);
      }
    };
    function applyPolyfill() {
      // only activate if this platform does not have pointer events
      if (!window.PointerEvent) {
        window.PointerEvent = PointerEvent;
        if (window.navigator.msPointerEnabled) {
          var tp = window.navigator.msMaxTouchPoints;
          Object.defineProperty(window.navigator, 'maxTouchPoints', {
            value: tp,
            enumerable: true
          });
          dispatcher.registerSource('ms', msEvents);
        } else {
          Object.defineProperty(window.navigator, 'maxTouchPoints', {
            value: 0,
            enumerable: true
          });
          dispatcher.registerSource('mouse', mouseEvents);
          if (window.ontouchstart !== undefined) {
            dispatcher.registerSource('touch', touchEvents);
          }
        }
        dispatcher.register(document);
      }
    }
    var n = window.navigator;
    var s;
    var r;
    var h;
    function assertActive(id) {
      if (!dispatcher.pointermap.has(id)) {
        var error = new Error('InvalidPointerId');
        error.name = 'InvalidPointerId';
        throw error;
      }
    }
    function assertConnected(elem) {
      var parent = elem.parentNode;
      while (parent && parent !== elem.ownerDocument) {
        parent = parent.parentNode;
      }
      if (!parent) {
        var error = new Error('InvalidStateError');
        error.name = 'InvalidStateError';
        throw error;
      }
    }
    function inActiveButtonState(id) {
      var p = dispatcher.pointermap.get(id);
      return p.buttons !== 0;
    }
    if (n.msPointerEnabled) {
      s = function s(pointerId) {
        assertActive(pointerId);
        assertConnected(this);
        if (inActiveButtonState(pointerId)) {
          dispatcher.setCapture(pointerId, this, true);
          this.msSetPointerCapture(pointerId);
        }
      };
      r = function r(pointerId) {
        assertActive(pointerId);
        dispatcher.releaseCapture(pointerId, true);
        this.msReleasePointerCapture(pointerId);
      };
    } else {
      s = function setPointerCapture(pointerId) {
        assertActive(pointerId);
        assertConnected(this);
        if (inActiveButtonState(pointerId)) {
          dispatcher.setCapture(pointerId, this);
        }
      };
      r = function releasePointerCapture(pointerId) {
        assertActive(pointerId);
        dispatcher.releaseCapture(pointerId);
      };
    }
    h = function hasPointerCapture(pointerId) {
      return !!dispatcher.captureInfo[pointerId];
    };
    function applyPolyfill$1() {
      if (window.Element && !Element.prototype.setPointerCapture) {
        Object.defineProperties(Element.prototype, {
          'setPointerCapture': {
            value: s
          },
          'releasePointerCapture': {
            value: r
          },
          'hasPointerCapture': {
            value: h
          }
        });
      }
    }
    applyAttributeStyles();
    applyPolyfill();
    applyPolyfill$1();
    var pointerevents = {
      dispatcher: dispatcher,
      Installer: Installer,
      PointerEvent: PointerEvent,
      PointerMap: PointerMap,
      targetFinding: targeting
    };
    return pointerevents;
  });
})(pep);

// external smart player events (value casing matters to maintain backward capability)
var _videoStartInitiated = 'VIDEO_START_INITIATED';
var _videoStart = 'VIDEO_START';
var _mediaReady = 'MEDIA_READY';
var _captionChange = 'CAPTION_CHANGE';
var _ready = 'READY';
var _videoPlayEvent = 'VIDEO_PLAY';
var _playerFullScreenModeChanged = 'PLAYER_FULL_SCREEN_MODE_CHANGED';
var _playerRumData = 'PLAYER_RUM_DATA';
var _videoEnd = 'tscspVideoEnd';
var _videoReplay = 'tscspVideoReplay';
var _externalMediaError = 'tscspMediaError';
var _playerSettingsOpenEvent = 'tscspPlayerSettingsOpen';
var _playerSettingsCloseEvent = 'tscspPlayerSettingsClose';
var _playerControlsHiddenEvent = 'tscspPlayerControlsHiddenEvent';
var _playerControlsVisibleEvent = 'tscspPlayerControlsVisibleEvent';
var _externalPlayerResize = 'tscspPlayerResize';
var _heroControlHidden = 'tscspHeroControlHidden';
var _imagePointerOver = 'tscspImagePointerOver';
var _imagePointerLeave = 'tscspImagePointerLeave';
var _displayModeChanged = 'tscspDisplayModeChanged';
var _captionsHidden = 'tscspCaptionsHidden';
var _captionsVisible = 'tscspCaptionsVisible';
var _captionsReady = 'tscspCaptionsReady';
// this is the overload to set up a listener for the playerConfiguration.useCustomEventTracking related to analytics.  this event will fire the handler for several
// when they would normally trigger internally (i.e. 'Video_Started', 'Video_Replay', 'Video_Loading_Time', 'Video_Finished', others?)
// the event will trigger with the related event name and data formatted for older version google-analytics events
var _googleAnalyticsCustomEvent = 'gacustomevents'; // deprecated
var _analyticsEvent = 'analyticsEvent';
var _googleAnalytics4Event = 'ga4event';

// external smart player html5 events
// these events are bubbled up from the html5 video element and _most_ are simulated by the youtube player in our code
var _videoLoadStart = 'loadstart';
var _videoLoadedMetadata = 'loadedmetadata';
var _videoLoadedData = 'loadeddata';
var _externalVideoCanPlay = 'canplay';
var _videoCanPlayThrough = 'canplaythrough';
var _videoPlaying = 'playing';
var _videoWaiting = 'waiting';
var _videoSeeking = 'seeking';
var _videoSeeked = 'seeked';
var _videoEnded = 'ended';
var _videoPlay = 'play';
var _videoPause = 'pause';
var _videoResize = 'resize';
var _videoError = 'error';
var _videoVolumeChange = 'volumechange';
var _videoDurationChange = 'durationchange';
var _videoRateChange = 'ratechange';
var _videoTimeUpdate = 'timeupdate';
var _videoProgress = 'progress';
var _initializeCurrent = 'initializecurrent';
var _sourceChanged = 'sourcechanged';
var _tryToAutoPlay = 'tscspTryToAutoPlay';
var _firstPlay = 'tscspFirstPlayer';
var _videoSuspend = 'suspend';
var _videoAbort = 'abort';
var _videoEmptied = 'emptied';
var _videoStalled = 'stalled';

// Player Events
var _mediaControlsReady = 'tscspMediaControlsReady';
var _mediaExtensionsReady = 'tscspMediaExtensionsReady';

// Control Events
var _clickPrevControl = 'tscspClickPrevControl';
var _clickNextControl = 'tscspClickNextControl';
var _toggleFullScreen = 'tscspToggleFullScreen';
var _fullScreenChange = 'tscspFullScreenChange';
var _expandVideo = 'tscspExpandVideo';
var _showToc = 'tscspShowToc';
var _hideToc = 'tscspHideToc';
var _tocScroll = 'tscspTocScroll';
var _disableControls$1 = 'tscspDisableControls';
var _enableControls = 'tscspEnableControls';
var _controlsUpdated = 'tscspControlsUpdated';
var _pipChanged = 'tscspPipChange';
var _theaterModeChanged = 'tscspTheaterModeChange';
var _playerResize = 'tscspPlayerResize';
var _mediaResize = 'tscspMediaResize';
var _controlsPlayerInitialized = 'tscspPlayerInitialized';
var _showVideoBufferingView = 'tscspShowVideoBufferingView';
var _hideVideoBufferingView = 'tscspHideVideoBufferingView';
var _switchToFullscreen = 'tscspSwitchToFullscreen';
var _exitFullscreen = 'tscspExitFullscreen';
var _videoControlsHidden = 'tscspVideoControlsHidden';
var _hideVideoControls = 'tscspHideVideoControls';
var _videoControlsVisible = 'tscspVideoControlsHVisible';
var _showVideoControls = 'tscspShowVideoControls';
var _displayCaptionControl = 'tscspDisplayCaptionControl';
var _displayTocControl = 'tscspDisplayTocControl';
var _tocDisplayToggled = 'tscspTocDisplayToggled';
var _focusTocButton = 'tscspFocusTocButton';
var _heroPlayControlClicked = 'tscspHeroPlayControlClicked';
var _heroPlayControlVisible = 'tscspHeroPlayControlVisible';
var _heroPlayControlHidden = 'tscspHeroPlayControlHidden';
var _replayControlVisible = 'tscspReplayControlVisible';
var _replayControlHidden = 'tscspReplayControlHidden';
var _startedPlayback = 'tscspStartedPlayback';
var _hideIOOverlay = 'tscspHideIOOverlay';
var _searchFocusChange = 'tscspSearchFocusChange';
var _hideLoadingMessage = 'tscspHideLoadingMessage';
var _playerSettingsOpen = 'tscspPlayerSettingsOpen';
var _playerSettingsClose = 'tscspPlayerSettingsClose';

// Media Element Events
var _seekMediaToTime = 'tscspSeekMediaToTime';
var _replayMedia = 'tscspReplayMedia';
var _endMedia = 'tscspEndMedia';
var _setVolume = 'tscspSetVolume';
var _setMutedState = 'tscspSetMutedState';
var _setPlaybackRate = 'tscspSetPlaybackRate';
var _mediaError = 'tscspMediaError';

// IFrame Events
var _enterFullFrame = 'ENTER-FULLFRAME';
var _exitFullFrame = 'EXIT-FULLFRAME';

// Update Events
var _updateQuizMarkers = 'tscspUpdateQuizMarkers';
var _updatePlayProgress = 'tscspUpdatePlayProgress';
var _updateLoadProgress = 'tscspUpdateLoadProgress';
var _updateNextQuestionPos = 'tscspUpdateNextQuestionXPos';

// Scrubbing Events
var _startedScrubbing = 'tscspStartedScrubbing';
var _endedScrubbing = 'tscspEndedScrubbing';

// Quiz Events
var _quizPaused = 'tscspMediaPaused';
var _quizComplete = 'tscspQuizComplete';
var _quizReview = 'tscspQuizReview';
var _quizStatus = 'tscspQuizStatus';
var _quizCreatedInstance = 'tscspCreatedInstance';
var _quizSubmitted = 'tscspQuizSubmitted';
var _quizHideLoadingMessage = 'tscspQuizHideLoadingMessage';
var _transitionImageQuizToAnswers = 'tscspTransitionImageQuizToAnswers';
var _hideQuiz = 'tscspHideQuiz';
var _showQuizBar = 'tscspShowQuizBar';
var _showStartQuizPrompt = 'tscspShowStartQuizPrompt';
var _hideStartQuizPrompt = 'tscspHideStartQuizPrompt';
var _showQuestionSetView = 'tscspShowQuestionSetView';
var _closeQuestionSetView = 'tscspCloseQuestionSetView';
var _submitQuestionSet = 'tscspSubmitQuestionSet';
var _rationaleActionLocation = 'tscspRationaleActionLocation';
var _rationaleActionJumpToTime = 'tscspRationaleActionJumpToTime';
var _quizVisible = 'tscspQuizVisible';
var _quizHidden = 'tscspQuizHidden';
var _minimizeQuizUI = 'tscspMinimizeQuizUI';
var _maximizeQuizUI = 'tscspMaximizeQuizUI';
var _quizUIVisible = 'tscspQuizUIVisible';
var _quizUIHidden = 'tscspQuizUIHidden';

// Captions
var _captionsToggled = 'tscpCaptionsToggled';
var _stateLoaded = 'tscpCaptionsStateLoaded';
var _captionsChanged = 'tscspCaptionChanged';
var _captionsLanguageChanged = 'tscspLanguageChanged';
var _captionsDragStart = 'tscspCaptionsDragStart';
var _captionsDragEnd = 'tscspCaptionsDragEnd';
var _captionsResized = 'tscspCaptionsResized';

// Caption Service
var _newCaptionTrack = 'tscspNewCaptionTrack';

// Audio Description
var _audioDescriptionChanged = 'tscspAudioDescriptionChanged';
var _audioDescriptionFailed = 'tscspAudioDescriptionFailed';

// Hotspots
var _hotspotPaused = 'tscspHotspotPaused';
var _hotspotResume = 'tscspHotspotResume';
var _hotspotClicked = 'tscspHotspotClicked';
var _hotspotAreaActive = 'tscspHotspotAreaActive';
var _hotspotAreaInactive = 'tscspHotspotAreaInactive';

// Modals
var _modalOpen = 'tscspModalOpen';
var _modalClosed = 'tscspModalClosed';

//Timing
var _smartPlayerInitialized = 'smart_player_initialized';
var _smartPlayerLoaded = 'smart_player_loaded';
var _videoMetadataLoaded = 'video_metadata_loaded';
var _videoLoadedDataTiming = 'video_loaded_data';
var _videoCanPlay = 'video_can_play';
var _videoHasEnoughData = 'video_has_enough_data';

// Analytics
var _analyticsVideoStarted = 'Video_Started';
var _analyticsContentLoaded = 'Content_Loaded';
var _analyticsVideoPercentViewed = 'Video_Percent_Viewed';
var _analyticsVideoFinishedAction = 'Video_Finished_Action';
var _analyticsVideoFinished = 'Video_Finished';
var _analyticsVideoReplay = 'Video_Replay';
var _analyticsVideoLoadingTimeInSeconds = 'Video_Loading_Time_In_Seconds';
var _analyticsVideoLoadingTime = 'Video_Loading_Time';
var _analyticsOpenExternalLinkView = 'Open_External_Link_View';
var _analyticsOpenExternalLinkClick = 'Open_External_Link_Click';
var _analyticsHotspotAction = 'Hotspot_Action';
var _analyticsVideoCouldNotPlaySmoothlyIn20Secs = 'Could_Not_Play_Smoothly_In_20_Secs';
var _analyticsVideoPlaybackWasStoppedToBuffer = 'Video_Stopped_To_Buffer';

// GA4 Analytics
var _ga4VideoStarted = 'video_started';
var _ga4PlayerInitialized = 'player_initialized';
var _ga4VideoLoadingTimeInSeconds = 'video_loading_time_secs';
var _ga4VideoLoadingTime = 'video_loading_time';
var _ga4VideoPercentViewed = 'video_percent_viewed';
var _ga4VideoFinishedAction = 'video_finished_action';
var _ga4VideoFinished = 'video_finished';
var _ga4VideoReplay = 'video_replayed';
var _ga4OpenExternalLinkView = 'open_external_link_view';
var _ga4OpenExternalLinkClick = 'open_external_link_click';
var _ga4HotspotAction = 'hotspot_open_url_action';
var _ga4VideoCouldNotPlaySmoothlyIn20Secs = 'bad_playback_twenty_secs';
var _ga4VideoPlaybackWasStoppedToBuffer = 'video_stopped_to_buffer';

// Plugins
var _pluginAdded = 'pluginAdded';
var _mediaAreaPluginMouseDown = 'mediaAreaPluginMouseDown';
var _mediaAreaPluginMouseUp = 'mediaAreaPluginMouseUp';
var _mediaAreaPluginKeyDown = 'mediaAreaPluginKeyDown';
var _mediaAreaPluginKeyUp = 'mediaAreaPluginKeyUp';

// Network
var _retryingRequest = 'retryingRequest';

// External link view
var _openUrlViewOpened = 'tscspExternalUrlViewOpen';
var _openUrlViewClosed = 'tscspExternalUrlViewClosed';
var _openUrlViewClicked = 'tscspExternalUrlViewClick';

// SCORM
var _exitScormSession = 'tscspExitScormSession';
var _exitScormSessionConfirmed = 'tscspExitScormSessionConfirmed';
var _exitScormSessionWithOutProgressConfirmed = 'tscspExitScormSessionWithOutProgressConfirmed';
var _resumeScormSession = 'tscspScormSession';
var _failedToFindApi = 'tscspScormFailedToFindApi';

// Images
var _imagesPointerOver = 'tscspImagesPointerOver';
var _imagesPointerLeave = 'tscspImagesPointerLeave';
var events = Object.freeze({
  External: {
    VideoStartInitiated: _videoStartInitiated,
    VideoStart: _videoStart,
    VideoEnd: _videoEnd,
    VideoReplay: _videoReplay,
    MediaError: _externalMediaError,
    MediaReady: _mediaReady,
    CaptionChange: _captionChange,
    Ready: _ready,
    VideoPlay: _videoPlayEvent,
    PlayerFullScreenModeChanged: _playerFullScreenModeChanged,
    PlayerRumData: _playerRumData,
    GoogleAnalyticsCustomEvent: _googleAnalyticsCustomEvent,
    AnalyticsEvent: _analyticsEvent,
    GoogleAnalytics4Event: _googleAnalytics4Event,
    QuizVisible: _quizVisible,
    QuizHidden: _quizHidden,
    ShowStartQuizPrompt: _showStartQuizPrompt,
    HideStartQuizPrompt: _hideStartQuizPrompt,
    SwitchToFullscreen: _switchToFullscreen,
    ExitFullscreen: _exitFullscreen,
    PlayerSettingsOpen: _playerSettingsOpenEvent,
    PlayerSettingsClose: _playerSettingsCloseEvent,
    PlayerControlsHidden: _playerControlsHiddenEvent,
    PlayerControlsVisible: _playerControlsVisibleEvent,
    PlayerResize: _externalPlayerResize,
    HeroControlHidden: _heroControlHidden,
    ImagePointerOver: _imagePointerOver,
    ImagePointerLeave: _imagePointerLeave,
    DisplayModeChanged: _displayModeChanged,
    CaptionsHidden: _captionsHidden,
    CaptionsVisible: _captionsVisible,
    CaptionsReady: _captionsReady
  },
  ExternalVideo: {
    VideoLoadStart: _videoLoadStart,
    VideoLoadedMetadata: _videoLoadedMetadata,
    VideoLoadedData: _videoLoadedData,
    VideoCanPlay: _externalVideoCanPlay,
    VideoCanPlayThrough: _videoCanPlayThrough,
    VideoPlaying: _videoPlaying,
    VideoWaiting: _videoWaiting,
    VideoSeeking: _videoSeeking,
    VideoSeeked: _videoSeeked,
    VideoEnded: _videoEnded,
    VideoPlay: _videoPlay,
    VideoPause: _videoPause,
    VideoResize: _videoResize,
    VideoError: _videoError,
    VideoVolumeChange: _videoVolumeChange,
    VideoDurationChange: _videoDurationChange,
    VideoRateChange: _videoRateChange,
    VideoTimeUpdate: _videoTimeUpdate,
    VideoProgress: _videoProgress
  },
  Player: {
    MediaControlsReady: _mediaControlsReady,
    MediaExtensionsReady: _mediaExtensionsReady
  },
  Controls: {
    ClickPrev: _clickPrevControl,
    ClickNext: _clickNextControl,
    FullScreenChange: _fullScreenChange,
    ToggleFullScreen: _toggleFullScreen,
    ExpandVideo: _expandVideo,
    ShowToc: _showToc,
    HideToc: _hideToc,
    TocScroll: _tocScroll,
    Disable: _disableControls$1,
    Enable: _enableControls,
    Updated: _controlsUpdated,
    HotspotClicked: _hotspotClicked,
    PipChanged: _pipChanged,
    TheaterModeChanged: _theaterModeChanged,
    PlayerResize: _playerResize,
    MediaResize: _mediaResize,
    PlayerInitialized: _controlsPlayerInitialized,
    ShowVideoBufferingView: _showVideoBufferingView,
    HideVideoBufferingView: _hideVideoBufferingView,
    VideoControlsHidden: _videoControlsHidden,
    HideVideoControls: _hideVideoControls,
    VideoControlsVisible: _videoControlsVisible,
    ShowVideoControls: _showVideoControls,
    DisplayCaptionControl: _displayCaptionControl,
    DisplayTocControl: _displayTocControl,
    TocDisplayToggled: _tocDisplayToggled,
    FocusTocButton: _focusTocButton,
    HeroPlayControlClicked: _heroPlayControlClicked,
    HeroPlayControlVisible: _heroPlayControlVisible,
    HeroPlayControlHidden: _heroPlayControlHidden,
    ReplayControlVisible: _replayControlVisible,
    ReplayControlHidden: _replayControlHidden,
    StartedPlayback: _startedPlayback,
    HideIOOverlay: _hideIOOverlay,
    SearchFocusChange: _searchFocusChange,
    HideLoadingMessage: _hideLoadingMessage,
    PlayerSettingsOpen: _playerSettingsOpen,
    PlayerSettingsClose: _playerSettingsClose
  },
  Hotspots: {
    Paused: _hotspotPaused,
    Resume: _hotspotResume,
    AreaActive: _hotspotAreaActive,
    AreaInactive: _hotspotAreaInactive
  },
  Media: {
    Play: _videoPlay,
    Playing: _videoPlaying,
    Pause: _videoPause,
    SeekToTime: _seekMediaToTime,
    Replay: _replayMedia,
    End: _endMedia,
    Abort: _videoAbort,
    Suspend: _videoSuspend,
    Emptied: _videoEmptied,
    Stalled: _videoStalled,
    Progress: _videoProgress,
    InitializeCurrent: _initializeCurrent,
    SourceChanged: _sourceChanged,
    TryToAutoPlay: _tryToAutoPlay,
    SetVolume: _setVolume,
    SetMutedState: _setMutedState,
    SetPlaybackRate: _setPlaybackRate,
    FirstPlay: _firstPlay,
    Error: _mediaError
  },
  IFrame: {
    EnterFullFrame: _enterFullFrame,
    ExitFullFrame: _exitFullFrame
  },
  Update: {
    QuizMarkers: _updateQuizMarkers,
    PlayProgress: _updatePlayProgress,
    LoadProgress: _updateLoadProgress,
    NextQuestionPosition: _updateNextQuestionPos
  },
  Scrubbing: {
    Started: _startedScrubbing,
    Ended: _endedScrubbing
  },
  Quizzing: {
    Paused: _quizPaused,
    Complete: _quizComplete,
    Review: _quizReview,
    Status: _quizStatus,
    CreatedInstance: _quizCreatedInstance,
    Submitted: _quizSubmitted,
    HideLoadingMessage: _quizHideLoadingMessage,
    TransitionImageQuizToAnswers: _transitionImageQuizToAnswers,
    HideQuiz: _hideQuiz,
    ShowQuizBar: _showQuizBar,
    ShowStartQuizPrompt: _showStartQuizPrompt,
    ShowQuestionSetView: _showQuestionSetView,
    CloseQuestionSetView: _closeQuestionSetView,
    SubmitQuestionSet: _submitQuestionSet,
    RationaleActionLocation: _rationaleActionLocation,
    RationaleActionJumpToTime: _rationaleActionJumpToTime,
    MinimizeUI: _minimizeQuizUI,
    MaximizeUI: _maximizeQuizUI,
    UIVisible: _quizUIVisible,
    UIHidden: _quizUIHidden
  },
  Captions: {
    Toggled: _captionsToggled,
    StateLoaded: _stateLoaded,
    Changed: _captionsChanged,
    LanguageChanged: _captionsLanguageChanged,
    DragStart: _captionsDragStart,
    DragEnd: _captionsDragEnd,
    Resized: _captionsResized
  },
  CaptionService: {
    NewCaptionTrack: _newCaptionTrack
  },
  AudioDescription: {
    Changed: _audioDescriptionChanged,
    Failed: _audioDescriptionFailed
  },
  Timing: {
    PlayerInitialized: _smartPlayerInitialized,
    PlayerLoaded: _smartPlayerLoaded,
    VideoMetadataLoaded: _videoMetadataLoaded,
    VideoLoadedData: _videoLoadedDataTiming,
    VideoCanPlay: _videoCanPlay,
    VideoHasEnoughData: _videoHasEnoughData
  },
  GA4: {
    PlayerInitialized: _ga4PlayerInitialized,
    VideoStarted: _ga4VideoStarted,
    VideoLoadingTimeInSeconds: _ga4VideoLoadingTimeInSeconds,
    VideoLoadingTime: _ga4VideoLoadingTime,
    VideoPercentViewed: _ga4VideoPercentViewed,
    VideoFinishedAction: _ga4VideoFinishedAction,
    VideoFinished: _ga4VideoFinished,
    VideoReplay: _ga4VideoReplay,
    OpenExternalLinkView: _ga4OpenExternalLinkView,
    OpenExternalLinkClick: _ga4OpenExternalLinkClick,
    HotspotAction: _ga4HotspotAction,
    CouldNotPlaySmoothlyIn20Secs: _ga4VideoCouldNotPlaySmoothlyIn20Secs,
    PlaybackWasStoppedToBuffer: _ga4VideoPlaybackWasStoppedToBuffer
  },
  Analytics: {
    VideoStarted: _analyticsVideoStarted,
    ContentLoaded: _analyticsContentLoaded,
    VideoPercentViewed: _analyticsVideoPercentViewed,
    VideoFinishedAction: _analyticsVideoFinishedAction,
    VideoFinished: _analyticsVideoFinished,
    VideoReplay: _analyticsVideoReplay,
    VideoLoadingTimeInSeconds: _analyticsVideoLoadingTimeInSeconds,
    VideoLoadingTime: _analyticsVideoLoadingTime,
    OpenExternalLinkView: _analyticsOpenExternalLinkView,
    OpenExternalLinkClick: _analyticsOpenExternalLinkClick,
    HotspotAction: _analyticsHotspotAction,
    CouldNotPlaySmoothlyIn20Secs: _analyticsVideoCouldNotPlaySmoothlyIn20Secs,
    PlaybackWasStoppedToBuffer: _analyticsVideoPlaybackWasStoppedToBuffer
  },
  Plugin: {
    Added: _pluginAdded,
    MediaAreaPluginMouseDown: _mediaAreaPluginMouseDown,
    MediaAreaPluginMouseUp: _mediaAreaPluginMouseUp,
    MediaAreaPluginKeyDown: _mediaAreaPluginKeyDown,
    MediaAreaPluginKeyUp: _mediaAreaPluginKeyUp
  },
  Network: {
    Retrying: _retryingRequest
  },
  Modals: {
    Open: _modalOpen,
    Closed: _modalClosed
  },
  ExternalLinkView: {
    Open: _openUrlViewOpened,
    Closed: _openUrlViewClosed,
    Clicked: _openUrlViewClicked
  },
  SCORM: {
    ExitSession: _exitScormSession,
    ExitSessionConfirmed: _exitScormSessionConfirmed,
    ExitSessionWithOutProgressConfirmed: _exitScormSessionWithOutProgressConfirmed,
    ResumeSession: _resumeScormSession,
    FailedToFindApi: _failedToFindApi
  },
  Images: {
    PointerOver: _imagesPointerOver,
    PointerLeave: _imagesPointerLeave
  }
});

var supportedPluginViewElements = Object.freeze({
  PROGRESS_BAR: 'progressBar',
  MEDIA: 'media',
  BEFORE_AFTER_PLAY_CONTROLS: 'beforeAfterPlayControls',
  PLAYER: 'player'
});

var _english = 'en-US';
var _german = 'de-DE';
var _japanese = 'ja-JP';
var _french = 'fr-FR';
var _spanish = 'es-ES';
var _chinese = 'zh-CN';
var _portuguese = 'pt-BR';
var _supportedLanguages = [_english, _german, _japanese, _french, _spanish, _chinese, _portuguese];
var languageCodes = Object.freeze({
  ENGLISH: _english,
  GERMAN: _german,
  JAPANESE: _japanese,
  FRENCH: _french,
  SPANISH: _spanish,
  CHINESE: _chinese,
  PORTUGUESE: _portuguese,
  ENU: _english,
  DEU: _german,
  JPN: _japanese,
  FRA: _french,
  SP: _spanish,
  ZH: _chinese,
  PT: _portuguese,
  isValid: function isValid(language) {
    return _supportedLanguages.some(function (supportedLanguage) {
      return supportedLanguage === language;
    });
  }
});

var mediaInterfaceConstants = Object.freeze({
  controls: {
    "true": 'true',
    "false": 'false',
    autohide: 'autohide',
    youtube: 'youtube'
  }
});

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof$1(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof$1(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var _Symbol = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag$1 && symToStringTag$1 in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof$1(value);
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
  objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$1 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof$1(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag:
      var convert = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof$1(value) == 'object';
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof$1(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && (typeof module === "undefined" ? "undefined" : _typeof$1(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = _typeof$1(value);
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag$1 = '[object Map]',
  numberTag$1 = '[object Number]',
  objectTag = '[object Object]',
  regexpTag$1 = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag$1 = '[object String]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = (typeof exports === "undefined" ? "undefined" : _typeof$1(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && (typeof module === "undefined" ? "undefined" : _typeof$1(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
    isArg = !isArr && isArguments(value),
    isBuff = !isArr && !isArg && isBuffer(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys$1, getSymbols);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$a.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$7.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative(root, 'Promise');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$2 = '[object Set]',
  weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$2),
  setCtorString = toSource(Set),
  weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$2 || Map$1 && getTag(new Map$1()) != mapTag$2 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag$2 || WeakMap && getTag(new WeakMap()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
    othIsArr = isArray$1(other),
    objTag = objIsArr ? arrayTag$1 : getTag$1(object),
    othTag = othIsArr ? arrayTag$1 : getTag$1(other);
  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;
  var objIsObj = objTag == objectTag$2,
    othIsObj = othTag == objectTag$2,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$8.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$8.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys$1(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return _typeof$1(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = _typeof$1(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (_typeof$1(value) == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys$1);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
      index = fromRight ? length : -1,
      iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
    result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray$1(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray$1(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate);
      collection = keys$1(collection);
      predicate = function predicate(key) {
        return iteratee(iterable[key], key, iterable);
      };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
    index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0,
  MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
    remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate), index);
}

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function (value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  return function () {
    var args = arguments;
    switch (args.length) {
      case 0:
        return !predicate.call(this);
      case 1:
        return !predicate.call(this, args[0]);
      case 2:
        return !predicate.call(this, args[0], args[1]);
      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject$1(collection, predicate) {
  var func = isArray$1(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate)));
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$1(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}
var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = baseRest(function (collection, path, args) {
  var index = -1,
    isFunc = typeof path == 'function',
    result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function (value) {
    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
  });
  return result;
});

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
    lastIndex = length - 1;
  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice$1.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
    indexes = [],
    length = array.length;
  predicate = baseIteratee(predicate);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}
var wellKnownNamespaces = {
  x: 'adobe:ns:meta/',
  xml: 'http://www.w3.org/1999/xhtml',
  rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  dc: 'http://purl.org/dc/elements/1.1/',
  exif: 'http://ns.adobe.com/exif/1.0',
  stDim: 'http://ns.adobe.com/xap/1.0/sType/Dimensions#',
  stFnt: 'http://ns.adobe.com/xap/1.0/sType/Font#',
  tsc: 'http://www.techsmith.com/xmp/tsc/',
  tscDM: 'http://www.techsmith.com/xmp/tscDM/',
  tscHS: 'http://www.techsmith.com/xmp/tscHS/',
  tscIQ: 'http://www.techsmith.com/xmp/tscIQ/',
  xmp: 'http://ns.adobe.com/xap/1.0/',
  xmpDM: 'http://ns.adobe.com/xmp/1.0/DynamicMedia/',
  xmpG: 'http://ns.adobe.com/xap/1.0/g/',
  xmpMM: 'http://ns.adobe.com/xap/1.0/mm/'
};

/**
 *  Namespace resolver for xmp namespaces.
 *  @function namespaceResolver
 *  @param {String} prefix - XML namespace prefix
 *  @static
 *  @return {String} The namespace corresponding to the prefix or null if not found
 */
var namespaceResolver = function namespaceResolver(prefix) {
  return wellKnownNamespaces[prefix] || null;
};

/** `Object#toString` result references. */
var stringTag$2 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray$1(value) && isObjectLike(value) && baseGetTag(value) == stringTag$2;
}

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}
var parseXml;

// Taken from http://stackoverflow.com/a/17604251
if (typeof window.DOMParser !== 'undefined') {
  var DOMParserProto = DOMParser.prototype;
  var realParseFromString = DOMParserProto.parseFromString;

  // Firefox/Opera/IE throw errors on unsupported types
  var canParseHtmlNatively;
  try {
    // WebKit returns null on unsupported types
    if (new DOMParser().parseFromString('', 'text/html')) {
      // text/html parsing is natively supported
      canParseHtmlNatively = true;
    }
  } catch (ex) {
    // nothing to do
  }
  if (!canParseHtmlNatively) {
    DOMParserProto.parseFromString = function (markup, type) {
      if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
        var doc = document.implementation.createHTMLDocument('');
        var docElement = doc.documentElement;
        var firstElement;
        docElement.innerHTML = markup;
        firstElement = docElement.firstElementChild;
        if (docElement.childElementCount === 1 && firstElement.localName.toLowerCase() === 'html') {
          doc.replaceChild(firstElement, docElement);
        }
        return doc;
      }
      return realParseFromString.apply(this, arguments);
    };
  }
  parseXml = function parseXml(xmlStr, contentType) {
    contentType = contentType || 'text/xml';
    return new window.DOMParser().parseFromString(xmlStr, contentType);
  };
} else if (typeof window.ActiveXObject !== 'undefined' && new window.ActiveXObject('Microsoft.XMLDOM')) {
  parseXml = function parseXml(xmlStr) {
    var xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
    xmlDoc.async = 'false';
    xmlDoc.loadXML(xmlStr);
    return xmlDoc;
  };
} else {
  throw new Error('No XML parser found');
}
var xmlDocFragmentToString = function xmlDocFragmentToString(xmlDoc) {
  var xmlSerializer = new XMLSerializer();
  return xmlSerializer.serializeToString(xmlDoc);
};
var xmlDocToString = function xmlDocToString(xmlDoc) {
  return '<?xml version="1.0" encoding="UTF-8"?>\n' + this.xmlDocFragmentToString(xmlDoc);
};
var getElementText = function getElementText(element) {
  return element.textContent;
};
var hasAttribute = function hasAttribute(element, attributeName) {
  var attrValue = element.getAttribute(attributeName);
  return !isNil(attrValue);
};
var hasAttributeWithValue = function hasAttributeWithValue(element, attributeName, value) {
  var attrValue = element.getAttribute(attributeName);
  return attrValue === value;
};
var createDocument = function createDocument() {
  var xmlDocument = document.implementation.createDocument('', '', null);
  return xmlDocument;
};
var createElement = function createElement(doc, name) {
  var element = doc.createElement(name);
  return element;
};
var createElementWithValue = function createElementWithValue(doc, name, value) {
  var element = doc.createElement(name);
  element.appendChild(doc.createTextNode(value));
  return element;
};
var getElementsByTagName = function getElementsByTagName(element, name) {
  var ns = '*';
  var childElements = element.getElementsByTagNameNS(ns, name);
  return childElements;
};
var getFirstElementByTagName = function getFirstElementByTagName(element, name) {
  var childElements = getElementsByTagName(element, name);
  return childElements && childElements[0] ? childElements[0] : null;
};
var getFirstChildElementTextByTagName = function getFirstChildElementTextByTagName(element, name) {
  var childElement = getFirstElementByTagName(element, name);
  return childElement ? getElementText(childElement) : null;
};
var XmlUtility = function XmlUtility() {}; // eslint-disable-line no-empty-function
XmlUtility.prototype.parseXml = parseXml;
XmlUtility.prototype.xmlDocFragmentToString = xmlDocFragmentToString;
XmlUtility.prototype.xmlDocToString = xmlDocToString;
XmlUtility.prototype.getElementText = getElementText;
XmlUtility.prototype.hasAttribute = hasAttribute;
XmlUtility.prototype.hasAttributeWithValue = hasAttributeWithValue;
XmlUtility.prototype.createDocument = createDocument;
XmlUtility.prototype.createElement = createElement;
XmlUtility.prototype.createElementWithValue = createElementWithValue;
XmlUtility.prototype.getElementsByTagName = getElementsByTagName;
XmlUtility.prototype.getFirstElementByTagName = getFirstElementByTagName;
XmlUtility.prototype.getFirstChildElementTextByTagName = getFirstChildElementTextByTagName;
var isDocument = function isDocument(docOrElement) {
  return isFunction(docOrElement.evaluate);
};
var getFirstElementByTagNameNSPrefix = function getFirstElementByTagNameNSPrefix(docOrElement, name) {
  if (isDocument(docOrElement)) {
    return docOrElement.evaluate('//' + name, docOrElement, this.namespaceResolver, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
  }
  var childElements = this.getElementsByTagNameNSPrefix(docOrElement, name);
  return childElements && childElements[0] ? childElements[0] : undefined;
};
var getElementsByTagNameNSPrefix = function getElementsByTagNameNSPrefix(element, name) {
  if (!element) {
    return null;
  }
  if (name.indexOf(':') === -1) {
    throw new Error('getElementsByTagNameNSPrefix requires the name passed in to have a namespace prefix. getElementsByTagName can be used if you do not know the prefix.');
  }
  var tokens = name.split(':');
  var ns = this.namespaceResolver(tokens[0]);
  var tagName = name.split(':')[1];
  var childElements = element.getElementsByTagNameNS(ns, tagName);
  return childElements;
};
var getFirstChildElementTextByTagNameNSPrefix = function getFirstChildElementTextByTagNameNSPrefix(element, name) {
  var childElement = this.getFirstElementByTagNameNSPrefix(element, name);
  return childElement ? this.getElementText(childElement) : undefined;
};
var createDocumentNS = function createDocumentNS(ns, prefix, name) {
  var xmlDocument = document.implementation.createDocument(ns, prefix + ':' + name, null);
  return xmlDocument;
};
var createElementNS = function createElementNS(doc, ns, prefix, name) {
  var element = doc.createElementNS(ns, prefix + ':' + name);
  return element;
};
var createElementNSWithValue = function createElementNSWithValue(doc, ns, prefix, name, value) {
  var element = createElementNS(doc, ns, prefix, name);
  element.appendChild(doc.createTextNode(value));
  return element;
};
var getNSInfo = function getNSInfo(tagName, namespaceResolver) {
  var nameParts = tagName.split(':', 2);
  if (nameParts.length !== 2) {
    throw new Error('invalid tag name [' + tagName + '] should contain \':\' to define namespace');
  } else if (!namespaceResolver(nameParts[0])) {
    throw new Error('invalid namespace prefix [' + nameParts[0] + '] was not able to be mapped to known namespace');
  }
  return {
    nsUrl: namespaceResolver(nameParts[0]),
    nsPrefix: nameParts[0],
    tagShortName: nameParts[1]
  };
};
var createElementFromObject = function createElementFromObject(tagInfo, doc) {
  doc = doc || this.createDocument();
  var that = this;
  if (isString(tagInfo)) {
    return createElement(doc, tagInfo);
  } else if (_typeof$1(tagInfo) === 'object' && typeof tagInfo.toXmp === 'function') {
    return tagInfo.toXmp();
  } else if (_typeof$1(tagInfo) === 'object' && tagInfo.name) {
    var nsInfo = getNSInfo(tagInfo.name, this.namespaceResolver);
    var newElement = createElementNS(doc, nsInfo.nsUrl, nsInfo.nsPrefix, nsInfo.tagShortName);
    if (tagInfo.atts && _typeof$1(tagInfo.atts) === 'object') {
      forEach(tagInfo.atts, function (attrVal, attrName) {
        if (!isNil(attrVal)) {
          var attNsInfo = getNSInfo(attrName, that.namespaceResolver);
          if (attNsInfo.nsPrefix !== 'xml') {
            newElement.setAttributeNS(attNsInfo.nsUrl, attrName, attrVal);
          } else {
            newElement.setAttribute(attrName, attrVal);
          }
        }
      });
    }
    if (tagInfo.children && Array.isArray(tagInfo.children)) {
      forEach(tagInfo.children, function (child) {
        if (child) {
          newElement.appendChild(that.createElementFromObject(child, doc));
        }
      });
    }
    if (tagInfo.text !== undefined && tagInfo.text !== null) {
      newElement.textContent = tagInfo.text;
    }
    return newElement;
  }
  throw new Error('invalid tag info');
};
var NamespaceXmlUtility = function NamespaceXmlUtility(namespaceResolver) {
  if (!namespaceResolver) {
    throw new Error('namespaceResolver is required');
  }
  this.namespaceResolver = namespaceResolver;
};
NamespaceXmlUtility.prototype = Object.create(XmlUtility.prototype);
NamespaceXmlUtility.prototype.getFirstElementByTagNameNSPrefix = getFirstElementByTagNameNSPrefix;
NamespaceXmlUtility.prototype.getElementsByTagNameNSPrefix = getElementsByTagNameNSPrefix;
NamespaceXmlUtility.prototype.getFirstChildElementTextByTagNameNSPrefix = getFirstChildElementTextByTagNameNSPrefix;
NamespaceXmlUtility.prototype.createDocumentNS = createDocumentNS;
NamespaceXmlUtility.prototype.createElementFromObject = createElementFromObject;
NamespaceXmlUtility.prototype.createElementNS = createElementNS;
NamespaceXmlUtility.prototype.createElementNSWithValue = createElementNSWithValue;
var LanguageIdentifier = function LanguageIdentifier(languageIdentifier) {
  if (typeof languageIdentifier !== 'string') {
    throw new Error('Language Identifier is expecting a string, but got (' + languageIdentifier + ')');
  }
  var _identifier = languageIdentifier.toLowerCase();
  var _language = '';
  var _region = '';
  var parseLanguageIdentifier = function parseLanguageIdentifier() {
    var languageIdentifierParts = _identifier.split('-');
    if (languageIdentifierParts.length > 1) {
      _region = languageIdentifierParts.pop();
    }
    _language = languageIdentifierParts.join('-');
  };
  var toPOJO = function toPOJO() {
    return {
      identifier: _identifier,
      language: _language,
      region: _region
    };
  };
  parseLanguageIdentifier();
  return Object.defineProperties({
    toPOJO: toPOJO
  }, {
    identifier: {
      get: function get() {
        return _identifier;
      }
    },
    language: {
      get: function get() {
        return _language;
      }
    },
    region: {
      get: function get() {
        return _region;
      }
    }
  });
};

/** @module LanguageIdentifier */
var LanguageIdentifier$1 = {
  /**
   *  Factory method that returns a new LanguageIdentifier object.
   *  @function create
   *  @param {string} languageIdentifier - RFC 3066 notation language string
   *  @static
   *  @return {module:LanguageIdentifier} new LanguageIdentifier instance
   */
  create: LanguageIdentifier
};
var _identifiers = Object.freeze({
  "default": 'default',
  af: {
    name: 'Afrikaans',
    displayName: 'Afrikaans',
    regions: {
      za: 'South Africa'
    }
  },
  sq: {
    name: 'Albanian',
    displayName: 'Shqip',
    regions: {
      al: 'Albania'
    }
  },
  ar: {
    name: 'Arabic',
    displayName: 'العربية',
    regions: {
      dz: 'Algeria',
      bh: 'Bahrain',
      eg: 'Egypt',
      iq: 'Iraq',
      jo: 'Jordan',
      kw: 'Kuwait',
      lb: 'Lebanon',
      ly: 'Libya',
      ma: 'Morocco',
      om: 'Oman',
      qa: 'Qatar',
      sa: 'Saudi Arabia',
      sy: 'Syria',
      tn: 'Tunisia',
      ae: 'United Arab Emirates',
      ye: 'Yemen'
    }
  },
  hy: {
    name: 'Armenian',
    displayName: 'Արևելահայերեն',
    regions: {
      am: 'Armenia'
    }
  },
  'cy-az': {
    name: 'Azeri (Cyrillic)',
    displayName: 'Азәрбајҹан дили',
    regions: {
      az: 'Azerbaijan'
    }
  },
  'lt-az': {
    name: 'Azeri (Latin)',
    displayName: 'Azərbaycanca',
    regions: {
      az: 'Azerbaijan'
    }
  },
  eu: {
    name: 'Basque',
    displayName: 'Euskara',
    regions: {
      es: 'Basque'
    }
  },
  be: {
    name: 'Belarusian',
    displayName: 'Беларуская',
    regions: {
      by: 'Belarus'
    }
  },
  bg: {
    name: 'Bulgarian',
    displayName: 'Български',
    regions: {
      bg: 'Bulgaria'
    }
  },
  ca: {
    name: 'Catalan',
    displayName: 'Català',
    regions: {
      es: 'Catalan'
    }
  },
  zh: {
    name: 'Chinese',
    displayName: '简体中文',
    regions: {
      cn: 'China',
      hk: 'Hong Kong SAR',
      mo: 'Macau SAR',
      sg: 'Singapore',
      tw: 'Taiwan',
      chs: '(Simplified)',
      cht: '(Traditional)'
    }
  },
  hr: {
    name: 'Croatian',
    displayName: 'hrvatski',
    regions: {
      hr: 'Croatia'
    }
  },
  cs: {
    name: 'Czech',
    displayName: 'Čeština',
    regions: {
      cz: 'Czech Republic'
    }
  },
  da: {
    name: 'Danish',
    displayName: 'Dansk',
    regions: {
      dk: 'Denmark'
    }
  },
  div: {
    name: 'Dhivehi',
    displayName: 'ދިވެހި',
    regions: {
      mv: 'Maldives'
    }
  },
  nl: {
    name: 'Dutch',
    displayName: 'Nederlands',
    regions: {
      be: 'Belgium',
      nl: 'The Netherlands'
    }
  },
  en: {
    name: 'English',
    displayName: 'English',
    regions: {
      au: 'Australia',
      bz: 'Belize',
      ca: 'Canada',
      cb: 'Caribbean',
      ie: 'Ireland',
      jm: 'Jamaica',
      nz: 'New Zealand',
      ph: 'Philippines',
      za: 'South Africa',
      tt: 'Trinidad and Tobago',
      gb: 'United Kingdom',
      us: 'United States',
      zw: 'Zimbabwe'
    }
  },
  et: {
    name: 'Estonian',
    displayName: 'Eesti',
    regions: {
      ee: 'Estonia'
    }
  },
  fo: {
    name: 'Faroese',
    displayName: 'Føroyskt',
    regions: {
      fo: 'Faroe Islands'
    }
  },
  fa: {
    name: 'Farsi',
    displayName: 'فارسی',
    regions: {
      ir: 'Iran'
    }
  },
  fi: {
    name: 'Finnish',
    displayName: 'Suomi',
    regions: {
      fi: 'Finland'
    }
  },
  fr: {
    name: 'French',
    displayName: 'Français',
    regions: {
      be: 'Belgium',
      ca: 'Canada',
      fr: 'France',
      lu: 'Luxembourg',
      mc: 'Monaco',
      ch: 'Switzerland'
    }
  },
  gl: {
    name: 'Galician',
    displayName: 'galego',
    regions: {
      es: 'Galician'
    }
  },
  ka: {
    name: 'Georgian',
    displayName: 'ქართული',
    regions: {
      ge: 'Georgia'
    }
  },
  de: {
    name: 'German',
    displayName: 'Deutsch',
    regions: {
      at: 'Austria',
      de: 'Germany',
      li: 'Liechtenstein',
      lu: 'Luxembourg',
      ch: 'Switzerland'
    }
  },
  el: {
    name: 'Greek',
    displayName: 'Ελληνικά',
    regions: {
      gr: 'Greece'
    }
  },
  gu: {
    name: 'Gujarati',
    displayName: 'ગુજરાતી',
    regions: {
      "in": 'India'
    }
  },
  he: {
    name: 'Hebrew',
    displayName: 'עברית',
    regions: {
      il: 'Israel'
    }
  },
  hi: {
    name: 'Hindi',
    displayName: 'हिन्दी',
    regions: {
      "in": 'India'
    }
  },
  hu: {
    name: 'Hungarian',
    displayName: 'Magyar',
    regions: {
      hu: 'Hungary'
    }
  },
  is: {
    name: 'Icelandic',
    displayName: 'Íslenska',
    regions: {
      is: 'Iceland'
    }
  },
  id: {
    name: 'Indonesian',
    displayName: 'Bahasa Indonesia',
    regions: {
      id: 'Indonesia'
    }
  },
  it: {
    name: 'Italian',
    displayName: 'Italiano',
    regions: {
      it: 'Italy',
      ch: 'Switzerland'
    }
  },
  ja: {
    name: 'Japanese',
    displayName: '日本語',
    regions: {
      jp: 'Japan'
    }
  },
  kn: {
    name: 'Kannada',
    displayName: 'ಕನ್ನಡ',
    regions: {
      "in": 'India'
    }
  },
  kk: {
    name: 'Kazakh',
    displayName: 'Қазақ Tілі',
    regions: {
      kz: 'Kazakhstan'
    }
  },
  kok: {
    name: 'Konkani',
    displayName: 'कोंकणी',
    regions: {
      "in": 'India'
    }
  },
  ko: {
    name: 'Korean',
    displayName: '한국어',
    regions: {
      kr: 'Korea'
    }
  },
  ky: {
    name: 'Kyrgyz',
    displayName: 'кыргызча',
    regions: {
      kz: 'Kazakhstan'
    }
  },
  lv: {
    name: 'Latvian',
    displayName: 'Latviešu',
    regions: {
      lv: 'Latvia'
    }
  },
  lt: {
    name: 'Lithuanian',
    displayName: 'Lietuvių',
    regions: {
      lt: 'Lithuania'
    }
  },
  mk: {
    name: 'Macedonian',
    displayName: 'Mакедонски',
    regions: {
      mk: '(FYROM)'
    }
  },
  ms: {
    name: 'Malay',
    displayName: 'Bahasa Melayu',
    regions: {
      bn: 'Brunei',
      my: 'Malaysia'
    }
  },
  mr: {
    name: 'Marathi',
    displayName: 'मराठी',
    regions: {
      "in": 'India'
    }
  },
  mn: {
    name: 'Mongolian',
    displayName: 'Монгол Хэл',
    regions: {
      mn: 'Mongolia'
    }
  },
  nb: {
    name: 'Norwegian (Bokmål)',
    displayName: 'Norsk (Bokmål)',
    regions: {
      no: 'Norway'
    }
  },
  nn: {
    name: 'Norwegian (Nynorsk)',
    displayName: 'Norsk (Nynorsk)',
    regions: {
      no: 'Norway'
    }
  },
  pl: {
    name: 'Polish',
    displayName: 'Polsk',
    regions: {
      pl: 'Poland'
    }
  },
  pt: {
    name: 'Portuguese',
    displayName: 'Português',
    regions: {
      br: 'Brazil',
      pt: 'Portugal'
    }
  },
  pa: {
    name: 'Punjabi',
    displayName: 'ਪੰਜਾਬੀ',
    regions: {
      "in": 'India'
    }
  },
  ro: {
    name: 'Romanian',
    displayName: 'Română',
    regions: {
      ro: 'Romania'
    }
  },
  ru: {
    name: 'Russian',
    displayName: 'Русский',
    regions: {
      ru: 'Russia'
    }
  },
  sa: {
    name: 'Sanskrit',
    displayName: 'संस्कृतम्',
    regions: {
      "in": 'India'
    }
  },
  'cy-sr': {
    name: 'Serbian (Cyrillic)',
    displayName: 'Српски',
    regions: {
      sp: 'Serbia'
    }
  },
  'lt-sr': {
    name: 'Serbian (Latin)',
    displayName: 'Srpski',
    regions: {
      sp: 'Serbia'
    }
  },
  sk: {
    name: 'Slovak',
    displayName: 'Slovenčina',
    regions: {
      sk: 'Slovakia'
    }
  },
  sl: {
    name: 'Slovenian',
    displayName: 'Slovenščina',
    regions: {
      si: 'Slovenia'
    }
  },
  es: {
    name: 'Spanish',
    displayName: 'Español',
    regions: {
      ar: 'Argentina',
      bo: 'Bolivia',
      cl: 'Chile',
      co: 'Colombia',
      cr: 'Costa Rica',
      "do": 'Dominican Republic',
      ec: 'Ecuador',
      sv: 'El Salvador',
      gt: 'Guatemala',
      hn: 'Honduras',
      mx: 'Mexico',
      ni: 'Nicaragua',
      pa: 'Panama',
      py: 'Paraguay',
      pe: 'Peru',
      pr: 'Puerto Rico',
      es: 'Spain',
      uy: 'Uruguay',
      ve: 'Venezuela'
    }
  },
  sw: {
    name: 'Swahili',
    displayName: 'Kiswahili',
    regions: {
      ke: 'Kenya'
    }
  },
  sv: {
    name: 'Swedish',
    displayName: 'Svenska',
    regions: {
      fi: 'Finland',
      se: 'Sweden'
    }
  },
  syr: {
    name: 'Syriac',
    displayName: 'ܠܫܢܐ ܣܘܪܝܝܐ‎',
    regions: {
      sy: 'Syria'
    }
  },
  ta: {
    name: 'Tamil',
    displayName: 'தமிழ்‎',
    regions: {
      "in": 'India'
    }
  },
  tt: {
    name: 'Tatar',
    displayName: 'татар теле',
    regions: {
      ru: 'Russia'
    }
  },
  te: {
    name: 'Telugu',
    displayName: 'తెలుగు',
    regions: {
      "in": 'India'
    }
  },
  th: {
    name: 'Thai',
    displayName: 'ไทย',
    regions: {
      th: 'Thailand'
    }
  },
  tr: {
    name: 'Turkish',
    displayName: 'Türkçe',
    regions: {
      tr: 'Turkey'
    }
  },
  uk: {
    name: 'Ukrainian',
    displayName: 'Українська',
    regions: {
      ua: 'Ukraine'
    }
  },
  ur: {
    name: 'Urdu',
    displayName: 'اُردُو',
    regions: {
      pk: 'Pakistan'
    }
  },
  'cy-uz': {
    name: 'Uzbek (Cyrillic)',
    displayName: 'Ўзбек',
    regions: {
      uz: 'Uzbekistan'
    }
  },
  'lt-uz': {
    name: 'Uzbek (Latin)',
    displayName: 'oʻzbek tili',
    regions: {
      uz: 'Uzbekistan'
    }
  },
  vi: {
    name: 'Vietnamese',
    displayName: 'Tiếng Việt',
    regions: {
      vn: 'Vietnam'
    }
  }
});

/** @module LanguageIdentifiers */

/**
 *  Check if a language is supported.
 *  @function isSupportedLanguage
 *  @param {string} languageIdentifierString - RFC 3066 notation language string
 *  @static
 *  @return {boolean} is the language found in the languageIdentifier is found.
 */
var isSupportedLanguage = function isSupportedLanguage(languageIdentifierString) {
  var identifier = LanguageIdentifier$1.create(languageIdentifierString);
  return _identifiers[identifier.language] !== undefined;
};
var languageIdentifiers = Object.defineProperties({
  isSupportedLanguage: isSupportedLanguage
}, {
  identifiers: {
    get: function get() {
      return _identifiers;
    }
  }
});

/**
 * @this {Promise}
 */
function finallyConstructor$1(callback) {
  var constructor = this.constructor;
  return this.then(function (value) {
    return constructor.resolve(callback()).then(function () {
      return value;
    });
  }, function (reason) {
    return constructor.resolve(callback()).then(function () {
      return constructor.reject(reason);
    });
  });
}

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc$1 = setTimeout;
function noop$2() {}

// Polyfill for Function.prototype.bind
function bind$1(fn, thisArg) {
  return function () {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise$1$1(fn) {
  if (!(this instanceof Promise$1$1)) throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];
  doResolve$1(fn, this);
}
function handle$1(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise$1$1._immediateFn(function () {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve$1 : reject$1$1)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject$1$1(deferred.promise, e);
      return;
    }
    resolve$1(deferred.promise, ret);
  });
}
function resolve$1(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
    if (newValue && (_typeof$1(newValue) === 'object' || typeof newValue === 'function')) {
      var then = newValue.then;
      if (newValue instanceof Promise$1$1) {
        self._state = 3;
        self._value = newValue;
        finale$1(self);
        return;
      } else if (typeof then === 'function') {
        doResolve$1(bind$1(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale$1(self);
  } catch (e) {
    reject$1$1(self, e);
  }
}
function reject$1$1(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale$1(self);
}
function finale$1(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise$1$1._immediateFn(function () {
      if (!self._handled) {
        Promise$1$1._unhandledRejectionFn(self._value);
      }
    });
  }
  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle$1(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler$1(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve$1(fn, self) {
  var done = false;
  try {
    fn(function (value) {
      if (done) return;
      done = true;
      resolve$1(self, value);
    }, function (reason) {
      if (done) return;
      done = true;
      reject$1$1(self, reason);
    });
  } catch (ex) {
    if (done) return;
    done = true;
    reject$1$1(self, ex);
  }
}
Promise$1$1.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise$1$1.prototype.then = function (onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop$2);
  handle$1(this, new Handler$1(onFulfilled, onRejected, prom));
  return prom;
};
Promise$1$1.prototype['finally'] = finallyConstructor$1;
Promise$1$1.all = function (arr) {
  return new Promise$1$1(function (resolve, reject) {
    if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      try {
        if (val && (_typeof$1(val) === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(val, function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};
Promise$1$1.resolve = function (value) {
  if (value && _typeof$1(value) === 'object' && value.constructor === Promise$1$1) {
    return value;
  }
  return new Promise$1$1(function (resolve) {
    resolve(value);
  });
};
Promise$1$1.reject = function (value) {
  return new Promise$1$1(function (resolve, reject) {
    reject(value);
  });
};
Promise$1$1.race = function (values) {
  return new Promise$1$1(function (resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise$1$1._immediateFn = typeof setImmediate === 'function' && function (fn) {
  setImmediate(fn);
} || function (fn) {
  setTimeoutFunc$1(fn, 0);
};
Promise$1$1._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};
var UndoAction = function UndoAction(undoFunc, undoParams, redoFunc, redoParams) {
  var execute = function execute() {
    return new Promise$1$1(function (resolve, reject) {
      try {
        undoFunc(undoParams);
      } catch (error) {
        reject(error);
      }
      var redo = UndoAction(redoFunc, redoParams, undoFunc, undoParams);
      resolve(redo);
    });
  };
  return {
    execute: execute
  };
};
var NoOpAction = function NoOpAction() {
  return {
    execute: function execute() {
      return Promise$1$1.resolve();
    }
  };
};

/** @module UndoAction */
var UndoAction$1 = {
  /**
   *  Factory method that returns a new UndoAction object.
   *  @function create
   *  @param {Function} undoFunc - The function that will be used to undo the action.
   *  @param {Object} undoParams - Parameters that will be passed to undo function.
   *  @param {Function} redoFunc - The function that will be use to redo the action.
   *  @param {Object} redoParams - Parameters that will be passed to redo function.
   *  @static
   *  @return {module:UndoAction} new Command instance
   */
  create: function create(undoFunc, undoParams, redoFunc, redoParams) {
    return UndoAction(undoFunc, undoParams, redoFunc, redoParams);
  },
  noOp: function noOp() {
    return NoOpAction();
  }
};
var ImageRectangle = function ImageRectangle(propertyInfo) {
  var _x;
  var _y;
  var _width;
  var _height;
  if (isString(propertyInfo)) {
    var tokens = propertyInfo.split(',');
    _x = Number(tokens[0]);
    _y = Number(tokens[1]);
    _width = Number(tokens[2]);
    _height = Number(tokens[3]);
  } else if (isObject(propertyInfo)) {
    _x = propertyInfo.x;
    _y = propertyInfo.y;
    _width = propertyInfo.width;
    _height = propertyInfo.height;
  } else {
    throw new Error('ImageRectangle is expecting a rectangle property string format: "x, y, width, height"');
  }
  var _public = Object.defineProperties({}, {
    x: {
      get: function get() {
        return _x;
      }
    },
    y: {
      get: function get() {
        return _y;
      }
    },
    width: {
      get: function get() {
        return _width;
      }
    },
    height: {
      get: function get() {
        return _height;
      }
    }
  });
  _public.toPOJO = function () {
    return {
      x: _x,
      y: _y,
      width: _width,
      height: _height
    };
  };
  _public.toXmpAtt = function () {
    return [_x, _y, _width, _height].join(', ');
  };
  return _public;
};

/** @module ImageRectangle */
var ImageRectangle$1 = {
  /**
   *  Factory method that returns a new ImageRectangle object.
   *  @function create
   *  @param {String|Object} propertyInfo - Required property string of the rectangle. A Rectangle object
   *  is an area defined by its position, as indicated by its top-left corner point (x, y) and by its width
   *  and its height. The properties should be comma separated in the following format "x, y, width, height".  Alternatively,
   *  this can be an object containing x,y,width,height properties (i.e. the object that comes out from .toPOJO())
   *  @static
   *  @return {module:ImageRectangle} new ImageRectangle instance
   */
  create: function create(propertyInfo) {
    return ImageRectangle(propertyInfo);
  }
};
var TAG_BEGIN_NOTATION = '\\';
var TAG_CLOSE_NOTATION = '0';
var TAG_END_NOTATION = ' ';
var TAG_SPACE = ' ';
var LOWER_CASE_A_CHAR_CODE = 97;
var LOWER_CASE_Z_CHAR_CODE = 122;
var isBlacklistedTag = function isBlacklistedTag(strTag) {
  var LINE_BREAK = 'par ';
  return strTag.toLowerCase() === LINE_BREAK;
};
var findNextTag = function findNextTag(strTextToSearch, nStartPoint) {
  if (nStartPoint === undefined) {
    nStartPoint = 0;
  }
  var nPosition = -1;
  // Make sure we're not null
  if (strTextToSearch) {
    // Get the first tag-looking sequence
    nPosition = strTextToSearch.indexOf(TAG_BEGIN_NOTATION, nStartPoint);
    // While we've got a tag-looking sequence....
    while (nPosition !== -1) {
      // As long as this point is not the last character in the string
      if (nPosition + 1 < strTextToSearch.length) {
        var nCode = strTextToSearch.toLowerCase().charCodeAt(nPosition + 1);
        // If the lower-case character is a lower-case alpha character
        if (LOWER_CASE_A_CHAR_CODE <= nCode && nCode <= LOWER_CASE_Z_CHAR_CODE) {
          break;
        }
      }
      // Get the next location of a tag-looking sequence
      nPosition = strTextToSearch.indexOf(TAG_BEGIN_NOTATION, nPosition + 1);
    }
  }

  // Return -1 of the position of the first valid tag
  return nPosition;
};
var getTagAt = function getTagAt(strText, nTagPosition) {
  var strTag;
  if (nTagPosition !== -1) {
    var nEnd = strText.indexOf(TAG_END_NOTATION, nTagPosition + 1);
    if (nEnd !== -1) {
      strTag = strText.substring(nTagPosition + 1, nEnd + 1);
    } else {
      strTag = strText.substring(nTagPosition + 1);
    }
  }
  return strTag;
};
var findNextTagNotBlacklisted = function findNextTagNotBlacklisted(strTextToSearch, nStartPoint) {
  if (nStartPoint === undefined) {
    nStartPoint = 0;
  }
  var nPosition = findNextTag(strTextToSearch, nStartPoint);
  while (nPosition !== -1) {
    var strTag = getTagAt(strTextToSearch, nPosition);
    if (strTag && !isBlacklistedTag(strTag)) {
      break;
    }
    nPosition = findNextTag(strTextToSearch, nPosition + 1);
  }
  return nPosition;
};
var getTextToCloseTag = function getTextToCloseTag(strTag, arrStack) {
  var strCloseTags = '';
  var arrOpenTags = [];
  var strCloseTagNeeded = arrStack.pop();
  while (strCloseTagNeeded && strCloseTagNeeded !== strTag && arrStack.length) {
    strCloseTags += TAG_BEGIN_NOTATION + strCloseTagNeeded;
    arrOpenTags.push(matchingTag(strCloseTagNeeded));
    if (arrStack.length) {
      strCloseTagNeeded = arrStack.pop();
    }
  }
  strCloseTags += TAG_BEGIN_NOTATION + strTag;
  while (arrOpenTags.length) {
    var strOpenTagNeeded = arrOpenTags.pop();
    if (strOpenTagNeeded) {
      strCloseTags += TAG_BEGIN_NOTATION + strOpenTagNeeded;
      arrStack.push(matchingTag(strOpenTagNeeded));
    }
  }
  return strCloseTags;
};
var isClosingTag = function isClosingTag(strTag) {
  return strTag.indexOf(TAG_CLOSE_NOTATION) !== -1;
};
var matchingTag = function matchingTag(strToMatch) {
  var strMatch = '';
  if (strToMatch !== '') {
    // An end tag
    if (isClosingTag(strToMatch)) {
      strMatch = strToMatch.substring(0, strToMatch.indexOf(TAG_CLOSE_NOTATION));
    } else {
      // Not an end tag
      // If we need to remove space (and we should)
      if (strToMatch.indexOf(TAG_SPACE) !== -1) {
        strMatch = strToMatch.substring(0, strToMatch.indexOf(TAG_SPACE));
      }
      strMatch += TAG_CLOSE_NOTATION;
    }
    strMatch += TAG_SPACE;
  }
  return strMatch;
};
var removeTag = function removeTag(strToFix, nTagPosition) {
  if (nTagPosition !== -1 && strToFix && nTagPosition < strToFix.length) {
    // Get the end of the tag
    var nTagEnd = strToFix.indexOf(TAG_END_NOTATION, nTagPosition);
    // If end exists
    if (nTagEnd !== -1) {
      // Remove it
      strToFix = strToFix.substring(0, nTagPosition) + strToFix.substring(nTagEnd + 1);
    } else {
      strToFix = strToFix.substring(0, nTagPosition);
    }
  }
  return strToFix;
};
var trimString = function trimString(strToFix) {
  while (strToFix.length > 1 && strToFix.charAt(0) === TAG_SPACE) {
    strToFix = strToFix.substring(1);
  }
  while (strToFix.length > 1 && strToFix.charAt(strToFix.length - 1) === TAG_SPACE) {
    strToFix = strToFix.substring(0, strToFix.length - 1);
  }
  if (strToFix === TAG_SPACE) {
    strToFix = '';
  }
  return strToFix;
};
var nestTags = function nestTags(strToFix) {
  if (strToFix) {
    var arrTagStack = [];
    var nPosition = findNextTagNotBlacklisted(strToFix);
    while (nPosition !== -1) {
      // Please note: the "tag" is considered to be what follows the backslash that signals it's beginning.
      var strTag = getTagAt(strToFix, nPosition);
      if (strTag && isClosingTag(strTag)) {
        // Get the new tag set required to add it in to the string
        var strCloseTags = getTextToCloseTag(strTag, arrTagStack);

        // Insert the tags and don't forget the rest of the original, if there is any
        var nTagEnd = strToFix.indexOf(TAG_END_NOTATION, nPosition);
        if (nTagEnd !== -1) {
          strToFix = strToFix.substring(0, nPosition) + strCloseTags + strToFix.substring(nTagEnd + 1);
        } else {
          strToFix = strToFix.substring(0, nPosition) + strCloseTags;
        }

        // Increment this so that we're not going through the stuff we just inserted
        nPosition += strCloseTags.length;
      } else {
        if (strTag && !isBlacklistedTag(strTag)) {
          arrTagStack.push(matchingTag(strTag));
        }
        nPosition = Number(nPosition) + 1;
      }
      nPosition = findNextTag(strToFix, nPosition);
    }
  }
  return strToFix;
};
var removeEmptyTags = function removeEmptyTags(strToFix) {
  var strFixed = strToFix;
  if (strFixed) {
    // Loop through the entire string as long as there were corrections made last time
    // (in case more can be made based on the previous ones)
    var nCountCorrectedThisLoop = 1;
    while (nCountCorrectedThisLoop > 0) {
      nCountCorrectedThisLoop = 0;
      // Get the first tag that isn't blacklisted
      var nPosition = findNextTagNotBlacklisted(strFixed);
      while (nPosition !== -1) {
        // Get the next tag that's not blacklisted
        var nNextPosition = findNextTagNotBlacklisted(strFixed, nPosition + 1);

        // Get the actual tag
        var strTag = getTagAt(strFixed, nPosition);
        // If the actual tag exists
        if (strTag) {
          // As long as that next tag is actually found
          if (nNextPosition !== -1) {
            // Set up the alternate tag that we're trying to match with
            var strAlternateTag = matchingTag(strTag);

            // Get the actual next tag
            var strNextTag = getTagAt(strFixed, nNextPosition);
            // If the actual next tag exists and is the same as what we're looking for
            if (strNextTag && strNextTag === strAlternateTag) {
              // Get the string between the two tags
              var nStringBetweenBegin = nPosition + 1 + strTag.length;
              var strBetween = strFixed.substring(nStringBetweenBegin, nNextPosition);
              // If the trimmed string is empty
              if (!trimString(strBetween).length) {
                // Remove the ending tag
                strFixed = removeTag(strFixed, nNextPosition);
                // Then remove the beginning tag that we're actually at
                strFixed = removeTag(strFixed, nPosition);

                // Adjust the position of that next tag by the amount of space we've reduced
                nNextPosition -= strTag.length + 1;
                // Note that we've made a correction
                nCountCorrectedThisLoop++;
              }
            }
          }
        }

        // Set the actual next position for the inner loop
        nPosition = nNextPosition;
      }
    }
  }
  return strFixed;
};
var toText = function toText(str) {
  if (str.match(/{\\rtf1 /)) {
    str = str.replace(/{\\rtf1 /, '');
    if (str.charAt(str.length - 1) === '}') {
      str = str.substring(0, str.length - 1);
    }
  }
  str = str.replace(/\\i /g, '');
  str = str.replace(/\\i0 /g, '');
  str = str.replace(/\\b /g, '');
  str = str.replace(/\\b0 /g, '');
  str = str.replace(/\\ul /g, '');
  str = str.replace(/\\ul0 /g, '');
  str = str.replace(/\\par/g, '');
  str = str.replace(/\\{/g, '{');
  str = str.replace(/\\}/g, '}');
  str = str.replace(/\\\\/g, '\\');
  return str;
};
var toHtml = function toHtml(str) {
  str = nestTags(str);
  str = removeEmptyTags(str);
  str = str.split('<').join('&lt;');
  str = str.split('>').join('&gt;');
  var removeLastBracket = false;

  //  remove the RTF and Replace with HTML
  if (str.indexOf('{\\rtf1') !== -1) {
    str = str.split('{\\rtf1 ').join('');
    removeLastBracket = true;
  }
  str = str.split('\\i0 ').join('</i>');
  str = str.split('\\b0 ').join('</b>');
  str = str.split("\\ul0 ").join('</u>');
  str = str.split('\\i ').join('<i>');
  str = str.split('\\b ').join('<b>');
  str = str.split("\\ul ").join('<u>');
  str = str.split('\\par ').join('<br/>');
  str = str.split('\\{').join('{');
  str = str.split('\\}').join('}');
  str = str.split('\\\\').join('\\');
  if (removeLastBracket && str.charAt(str.length - 1) === '}') {
    str = str.substring(0, str.length - 1);
  }

  // convert these so they are displayed and not used as HTML Tags ( exception <br> )
  str = str.split('&lt;br&gt;').join('<br/>');
  str = str.split('&lt;BR&gt;').join('<br/>');
  return str;
};

/** @module Rtf */
var Rtf = {
  /**
   *  Take a string with rtf markup and translate it to text
   *  @function toText
   *  @param {String} str - The rtf formatted input string to parse.
   *  @static
   *  @return {String} The string as text-only
   */
  toText: toText,
  /**
   *  Take a string with rtf markup and translate it to html
   *  @function toHtml
   *  @param {String} str - The rtf formatted input string to parse.
   *  @static
   *  @return {String} The string with html markup aligning to the rtf markup
   */
  toHtml: toHtml
};
var validateParams = function validateParams(params) {
  return params && typeof params.text === 'string' && (!params.languageIdentifierString || typeof params.languageIdentifierString === 'string');
};
var CaptionText = function CaptionText(params) {
  var _languageIdentifier = LanguageIdentifier$1.create(languageIdentifiers.identifiers["default"]);
  var _text;
  var _plainText;
  var _markupText;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var setLanguageIdentifier = function setLanguageIdentifier(languageIdentifierString) {
    if (!languageIdentifiers.isSupportedLanguage(languageIdentifierString)) {
      languageIdentifierString = languageIdentifiers.identifiers["default"];
    }
    var previousLanguageIdentifierString = _languageIdentifier.identifier;
    _languageIdentifier = LanguageIdentifier$1.create(languageIdentifierString);
    return UndoAction$1.create(setLanguageIdentifier, previousLanguageIdentifierString, setLanguageIdentifier, languageIdentifierString);
  };
  var setText = function setText(text) {
    if (typeof text !== 'string') {
      throw new Error('Caption text is expecting a string, but got (' + text + ')');
    }
    var previous = _text;
    _text = text;
    _plainText = Rtf.toText(_text);
    _markupText = Rtf.toHtml(_text);
    return UndoAction$1.create(setText, previous, setText, _text);
  };
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      atts: {
        'xml:lang': _languageIdentifier.identifier
      },
      text: _text
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    languageIdentifier: {
      get: function get() {
        return _languageIdentifier;
      }
    },
    language: {
      get: function get() {
        return _languageIdentifier.language;
      }
    },
    text: {
      get: function get() {
        return _text;
      }
    },
    plainText: {
      get: function get() {
        return _plainText;
      }
    },
    markupText: {
      get: function get() {
        return _markupText;
      }
    }
  });
  _public.setLanguageIdentifier = setLanguageIdentifier;
  _public.setText = setText;
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      languageIdentifier: _languageIdentifier.toPOJO(),
      language: _languageIdentifier.language,
      text: _text,
      plainText: _plainText,
      markupText: _markupText
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  if (validateParams(params)) {
    forEach(keys$1(params), function (key) {
      if (key === 'languageIdentifierString') {
        setLanguageIdentifier(params.languageIdentifierString);
      } else if (key === 'text') {
        setText(params.text);
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  } else {
    throw new Error('CaptionText expects text and language parameters');
  }
  return _public;
};
var createFromXmpElement = function createFromXmpElement(textElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var rtfText = _xmlUtility.getElementText(textElement);
  var params = {
    languageIdentifierString: textElement.getAttribute('xml:lang'),
    text: rtfText
  };
  return CaptionText(params);
};

/** @module CaptionText */
var CaptionText$1 = {
  /**
   *  Factory method that returns a new CaptionText object.
   *  @function create
   *  @param {Object} params - Optional params for caption
   *  @param {String} [params.languageIdentifierString] - RFC 3066 notation language string
   *  @param {String} [params.text] - Text of caption item.
   *  @static
   *  @return {module:CaptionText} new CaptionText instance
   */
  create: function create(params) {
    return CaptionText(params);
  },
  /**
   *  Factory method that returns a new CaptionText object from an XMP caption element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP caption item element.
   *  @static
   *  @return {module:CaptionText} new CaptionText instance
   */
  createFromXmpElement: createFromXmpElement
};
var decoratorFunctions = [];
var nullCaptionText = {
  text: undefined,
  plainText: undefined,
  markupText: undefined
};
var Caption = function Caption(params) {
  var _startTime;
  var _duration;
  var _captionTextList = [];
  var _horizontalAlignment;
  var _verticalAlignment;
  var _file;
  var _image;
  var _imageIndex;
  var _imageOffset;
  var _imageRectangle;
  var _activeLanguageIdentifier = LanguageIdentifier$1.create(languageIdentifiers.identifiers["default"]);
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var getAvailableLanguages = function getAvailableLanguages() {
    return map(_captionTextList, function (captionText) {
      return captionText.languageIdentifier.identifier;
    });
  };
  var setStartTime = function setStartTime(startTime) {
    if (typeof startTime !== 'number') {
      throw new Error('Caption startTime is expecting a number, but got (' + startTime + ')');
    }
    var previous = _startTime;
    _startTime = Math.floor(startTime);
    return UndoAction$1.create(setStartTime, previous, setStartTime, _startTime);
  };
  var setDuration = function setDuration(duration) {
    if (typeof duration !== 'number') {
      throw new Error('Caption duration is expecting a number, but got (' + duration + ')');
    }
    var previous = _duration;
    _duration = Math.floor(duration);
    return UndoAction$1.create(setDuration, previous, setDuration, _duration);
  };
  var addOrReplaceCaptionText = function addOrReplaceCaptionText(newCaptionText) {
    var existingCaptionItemIndex = findIndex(_captionTextList, function (captionItem) {
      return captionItem.languageIdentifier.identifier === newCaptionText.languageIdentifier.identifier;
    });
    if (existingCaptionItemIndex !== -1) {
      var oldCaptionItem = _captionTextList[existingCaptionItemIndex];
      _captionTextList.splice(existingCaptionItemIndex, 1, newCaptionText);
      return UndoAction$1.create(addOrReplaceCaptionText, oldCaptionItem, addOrReplaceCaptionText, newCaptionText);
    }
    if (newCaptionText.toPOJO) {
      _captionTextList.push(newCaptionText);
    } else {
      _captionTextList.push(CaptionText$1.create(newCaptionText));
    }
    return UndoAction$1.create(removeCaptionText, newCaptionText, addOrReplaceCaptionText, newCaptionText);
  };
  var removeCaptionText = function removeCaptionText(captionText) {
    var removedCaptionItems = remove(_captionTextList, function (captionTextItem) {
      return captionTextItem.languageIdentifier.identifier === captionText.languageIdentifier.identifier && captionTextItem.text === captionText.text;
    });
    var removedCaptionItem = removedCaptionItems.length > 0 ? removedCaptionItems[0] : undefined;
    return UndoAction$1.create(addOrReplaceCaptionText, removedCaptionItem, removeCaptionText, captionText);
  };
  var setHorizontalAlignment = function setHorizontalAlignment(horizontalAlignment) {
    if (typeof horizontalAlignment !== 'string') {
      throw new Error('Caption horizontalAlignment is expecting a string, but got (' + horizontalAlignment + ')');
    }
    var previous = _horizontalAlignment;
    _horizontalAlignment = horizontalAlignment;
    return UndoAction$1.create(setHorizontalAlignment, previous, setHorizontalAlignment, _horizontalAlignment);
  };
  var setVerticalAlignment = function setVerticalAlignment(verticalAlignment) {
    if (typeof verticalAlignment !== 'string') {
      throw new Error('Caption verticalAlignment is expecting a string, but got (' + verticalAlignment + ')');
    }
    var previous = _verticalAlignment;
    _verticalAlignment = verticalAlignment;
    return UndoAction$1.create(setVerticalAlignment, previous, setVerticalAlignment, _verticalAlignment);
  };
  var setFile = function setFile(file) {
    if (typeof file !== 'string') {
      throw new Error('Caption file is expecting a string, but got (' + file + ')');
    }
    var previous = _file;
    _file = file;
    return UndoAction$1.create(setFile, previous, setFile, _file);
  };
  var setImage = function setImage(image) {
    if (typeof image !== 'string') {
      throw new Error('Caption image is expecting a string, but got (' + image + ')');
    }
    var previous = _image;
    _image = image;
    return UndoAction$1.create(setImage, previous, setImage, _image);
  };
  var setImageIndex = function setImageIndex(imageIndex) {
    if (typeof imageIndex !== 'number') {
      throw new Error('Caption imageIndex is expecting a number, but got (' + imageIndex + ')');
    }
    var previous = _imageIndex;
    _imageIndex = imageIndex;
    return UndoAction$1.create(setImageIndex, previous, setImageIndex, _imageIndex);
  };
  var setImageOffset = function setImageOffset(imageOffset) {
    if (typeof imageOffset !== 'number') {
      throw new Error('Caption imageOffset is expecting a number, but got (' + imageOffset + ')');
    }
    var previous = _imageOffset;
    _imageOffset = imageOffset;
    return UndoAction$1.create(setImageOffset, previous, setImageOffset, _imageOffset);
  };
  var setImageRectangle = function setImageRectangle(imageRectangle) {
    if (_typeof$1(imageRectangle) !== 'object') {
      throw new Error('Caption imageRectangle is expecting an object, but got (' + imageRectangle + ')');
    }
    var previous = _imageRectangle;
    _imageRectangle = imageRectangle;
    return UndoAction$1.create(setImageRectangle, previous, setImageRectangle, _imageRectangle);
  };
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:startTime': _startTime,
          'xmpDM:duration': _duration,
          'tscDM:halign': _horizontalAlignment,
          'tscDM:valign': _verticalAlignment,
          'tscDM:file': _file,
          'tscDM:image': _image,
          'tscDM:imageindex': _imageIndex,
          'tscDM:imageoffset': _imageOffset,
          'tscDM:imagerect': _imageRectangle ? [_imageRectangle.x, _imageRectangle.y, _imageRectangle.width, _imageRectangle.height].join(', ') : undefined
        },
        children: [{
          name: 'xmpDM:name',
          children: [{
            name: 'rdf:Alt',
            children: _captionTextList
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var getCaptionText = function getCaptionText() {
    if (_captionTextList.length === 0) {
      return nullCaptionText;
    }
    if (_activeLanguageIdentifier.identifier === languageIdentifiers.identifiers["default"]) {
      return _captionTextList[0];
    }
    var preferredCaptionText = find(_captionTextList, function (captionText) {
      return captionText.languageIdentifier.identifier === _activeLanguageIdentifier.identifier;
    });
    if (!preferredCaptionText) {
      preferredCaptionText = find(_captionTextList, function (captionText) {
        return captionText.language === _activeLanguageIdentifier.language;
      });
    }
    return preferredCaptionText || nullCaptionText;
  };
  var _public = Object.defineProperties({}, {
    startTime: {
      get: function get() {
        return _startTime;
      }
    },
    duration: {
      get: function get() {
        return _duration;
      }
    },
    endTime: {
      get: function get() {
        return _startTime + _duration;
      }
    },
    captionTextList: {
      get: function get() {
        return _captionTextList;
      }
    },
    text: {
      get: function get() {
        return getCaptionText().text;
      }
    },
    plainText: {
      get: function get() {
        return getCaptionText().plainText;
      }
    },
    markupText: {
      get: function get() {
        return getCaptionText().markupText;
      }
    },
    horizontalAlignment: {
      get: function get() {
        return _horizontalAlignment;
      }
    },
    verticalAlignment: {
      get: function get() {
        return _verticalAlignment;
      }
    },
    file: {
      get: function get() {
        return _file;
      }
    },
    image: {
      get: function get() {
        return _image;
      }
    },
    imageIndex: {
      get: function get() {
        return _imageIndex;
      }
    },
    imageOffset: {
      get: function get() {
        return _imageOffset;
      }
    },
    imageRectangle: {
      get: function get() {
        return _imageRectangle;
      }
    },
    activeLanguageIdentifier: {
      get: function get() {
        return _activeLanguageIdentifier;
      },
      set: function set(languageIdentifier) {
        _activeLanguageIdentifier = languageIdentifier;
      }
    }
  });
  _public.getAvailableLanguages = getAvailableLanguages;
  _public.setStartTime = setStartTime;
  _public.setDuration = setDuration;
  _public.addOrReplaceCaptionText = addOrReplaceCaptionText;
  _public.removeCaptionText = removeCaptionText;
  _public.setHorizontalAlignment = setHorizontalAlignment;
  _public.setVerticalAlignment = setVerticalAlignment;
  _public.setFile = setFile;
  _public.setImage = setImage;
  _public.setImageIndex = setImageIndex;
  _public.setImageOffset = setImageOffset;
  _public.setImageRectangle = setImageRectangle;
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      startTime: _startTime,
      duration: _duration,
      captionTextList: invokeMap(_captionTextList, 'toPOJO'),
      horizontalAlignment: _horizontalAlignment,
      verticalAlignment: _verticalAlignment,
      file: _file,
      image: _image,
      imageIndex: _imageIndex,
      imageOffset: _imageOffset,
      imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : _imageRectangle
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'startTime' && typeof params.startTime === 'number') {
        setStartTime(params.startTime);
      } else if (key === 'duration' && typeof params.duration === 'number') {
        setDuration(params.duration);
      } else if (key === 'captionTextList' && params.captionTextList) {
        map(params.captionTextList, addOrReplaceCaptionText);
      } else if (key === 'horizontalAlignment' && params.horizontalAlignment) {
        setHorizontalAlignment(params.horizontalAlignment);
      } else if (key === 'verticalAlignment' && params.verticalAlignment) {
        setVerticalAlignment(params.verticalAlignment);
      } else if (key === 'file' && params.file) {
        setFile(params.file);
      } else if (key === 'image' && params.image) {
        setImage(params.image);
      } else if (key === 'imageIndex' && typeof params.imageIndex === 'number') {
        setImageIndex(params.imageIndex);
      } else if (key === 'imageOffset' && typeof params.imageOffset === 'number') {
        setImageOffset(params.imageOffset);
      } else if (key === 'imageRectangle' && params.imageRectangle) {
        if (!params.imageRectangle.toPOJO) {
          params.imageRectangle = ImageRectangle$1.create(params.imageRectangle);
        }
        setImageRectangle(params.imageRectangle);
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  forEach(decoratorFunctions, function (func) {
    func(_public);
  });
  return _public;
};
var createFromXmpElement$1 = function createFromXmpElement$1(captionElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var captionTextElements = _xmlUtility.getElementsByTagNameNSPrefix(captionElement, 'rdf:li');
  var captionTextList = map(captionTextElements, CaptionText$1.createFromXmpElement);
  var params = {
    startTime: Number(captionElement.getAttribute('xmpDM:startTime')),
    duration: Number(captionElement.getAttribute('xmpDM:duration')),
    captionTextList: captionTextList,
    horizontalAlignment: captionElement.getAttribute('tscDM:halign'),
    verticalAlignment: captionElement.getAttribute('tscDM:valign')
  };
  if (captionElement.getAttribute('tscDM:file')) {
    params.file = captionElement.getAttribute('tscDM:file');
  }
  if (captionElement.getAttribute('tscDM:image')) {
    params.image = captionElement.getAttribute('tscDM:image');
  }
  if (captionElement.getAttribute('tscDM:imageindex')) {
    params.imageIndex = Number(captionElement.getAttribute('tscDM:imageindex'));
  }
  if (captionElement.getAttribute('tscDM:imageoffset')) {
    params.imageOffset = Number(captionElement.getAttribute('tscDM:imageoffset'));
  }
  if (captionElement.getAttribute('tscDM:imagerect')) {
    params.imageRectangle = ImageRectangle$1.create(captionElement.getAttribute('tscDM:imagerect'));
  }
  return Caption(params);
};
var registerDecorator = function registerDecorator(decorator) {
  if (decorator && typeof decorator === 'function') {
    decoratorFunctions.push(decorator);
  } else {
    throw new Error('decorator must be a function');
  }
};
var clearDecorators = function clearDecorators() {
  decoratorFunctions = [];
};

/** @module Caption */
var Caption$1 = {
  /**
   *  Factory method that returns a new Caption object.
   *  @function create
   *  @param {Object} params - Optional params for caption
   *  @param {Number} [params.startTime] - Start time of caption.
   *  @param {Number} [params.duration] - Duration of caption.
   *  @param {module:CaptionText[]} [params.captionTextList] - List of CaptionText objects.
   *  @param {String} [params.horizontalAlignment] - Horizontal alignment of caption text.
   *  @param {String} [params.verticalAlignment] - Vertical alignment of caption text.
   *  @param {String} [params.file] - Reference to a specific file as String.
   *  @param {String} [params.image] - Url for caption thumbnail.
   *  @param {Number} [params.imageIndex] - Index of image within file consisting of one or more images.
   *  @param {Number} [params.imageOffset] - Number of bytes this image begins at, relative to the beginning of the entire file
   *  @param {module:ImageRectangle} [params.imageRectangle] - Image Rectangle for image sprite map
   *  @static
   *  @return {module:Caption} new Caption instance
   */
  create: function create(params) {
    return Caption(params);
  },
  /**
   *  Factory method that returns a new Caption object from an XMP caption element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP caption element.
   *  @static
   *  @return {module:Caption} new Caption instance
   */
  createFromXmpElement: createFromXmpElement$1,
  /**
   *  Method to allow registration of decorator function that can extend the caption
   *  object before it is returned in the create functions.
   *  @function registerDecorator
   *  @param {Function} decorator - Function that will be used to decorate the caption.
   *  The function should take a caption parameter.
   *  @static
   */
  registerDecorator: registerDecorator,
  /**
   *  Method to allow clearing decorator functions
   *  @function clearDecorators
   *  @static
   */
  clearDecorators: clearDecorators
};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var tinycolor$1 = createCommonjsModule(function (module) {
  // TinyColor v1.4.1
  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  (function (Math) {
    var trimLeft = /^\s+/,
      trimRight = /\s+$/,
      tinyCounter = 0,
      mathRound = Math.round,
      mathMin = Math.min,
      mathMax = Math.max,
      mathRandom = Math.random;
    function tinycolor(color, opts) {
      color = color ? color : '';
      opts = opts || {};

      // If input is already a tinycolor, return itself
      if (color instanceof tinycolor) {
        return color;
      }
      // If we are called as a function, call using new instead
      if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
      }
      var rgb = inputToRGB(color);
      this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
      this._gradientType = opts.gradientType;

      // Don't let the range of [0,255] come back in [0,1].
      // Potentially lose a little bit of precision here, but will fix issues where
      // .5 gets interpreted as half of the total, instead of half of 1
      // If it was supposed to be 128, this was already taken care of by `inputToRgb`
      if (this._r < 1) {
        this._r = mathRound(this._r);
      }
      if (this._g < 1) {
        this._g = mathRound(this._g);
      }
      if (this._b < 1) {
        this._b = mathRound(this._b);
      }
      this._ok = rgb.ok;
      this._tc_id = tinyCounter++;
    }
    tinycolor.prototype = {
      isDark: function isDark() {
        return this.getBrightness() < 128;
      },
      isLight: function isLight() {
        return !this.isDark();
      },
      isValid: function isValid() {
        return this._ok;
      },
      getOriginalInput: function getOriginalInput() {
        return this._originalInput;
      },
      getFormat: function getFormat() {
        return this._format;
      },
      getAlpha: function getAlpha() {
        return this._a;
      },
      getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
      },
      getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) {
          R = RsRGB / 12.92;
        } else {
          R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        }
        if (GsRGB <= 0.03928) {
          G = GsRGB / 12.92;
        } else {
          G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        }
        if (BsRGB <= 0.03928) {
          B = BsRGB / 12.92;
        } else {
          B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
      },
      setAlpha: function setAlpha(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100 * this._a) / 100;
        return this;
      },
      toHsv: function toHsv() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return {
          h: hsv.h * 360,
          s: hsv.s,
          v: hsv.v,
          a: this._a
        };
      },
      toHsvString: function toHsvString() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360),
          s = mathRound(hsv.s * 100),
          v = mathRound(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
      },
      toHsl: function toHsl() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return {
          h: hsl.h * 360,
          s: hsl.s,
          l: hsl.l,
          a: this._a
        };
      },
      toHslString: function toHslString() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360),
          s = mathRound(hsl.s * 100),
          l = mathRound(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
      },
      toHex: function toHex(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
      },
      toHexString: function toHexString(allow3Char) {
        return '#' + this.toHex(allow3Char);
      },
      toHex8: function toHex8(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
      },
      toHex8String: function toHex8String(allow4Char) {
        return '#' + this.toHex8(allow4Char);
      },
      toRgb: function toRgb() {
        return {
          r: mathRound(this._r),
          g: mathRound(this._g),
          b: mathRound(this._b),
          a: this._a
        };
      },
      toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function toPercentageRgb() {
        return {
          r: mathRound(bound01(this._r, 255) * 100) + "%",
          g: mathRound(bound01(this._g, 255) * 100) + "%",
          b: mathRound(bound01(this._b, 255) * 100) + "%",
          a: this._a
        };
      },
      toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function toName() {
        if (this._a === 0) {
          return "transparent";
        }
        if (this._a < 1) {
          return false;
        }
        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
      },
      toFilter: function toFilter(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
          var s = tinycolor(secondColor);
          secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
      },
      toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
          // Special case for "transparent", all other non-alpha formats
          // will return rgba when there is transparency.
          if (format === "name" && this._a === 0) {
            return this.toName();
          }
          return this.toRgbString();
        }
        if (format === "rgb") {
          formattedString = this.toRgbString();
        }
        if (format === "prgb") {
          formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
          formattedString = this.toHexString();
        }
        if (format === "hex3") {
          formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
          formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
          formattedString = this.toHex8String();
        }
        if (format === "name") {
          formattedString = this.toName();
        }
        if (format === "hsl") {
          formattedString = this.toHslString();
        }
        if (format === "hsv") {
          formattedString = this.toHsvString();
        }
        return formattedString || this.toHexString();
      },
      clone: function clone() {
        return tinycolor(this.toString());
      },
      _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
      },
      lighten: function lighten() {
        return this._applyModification(_lighten, arguments);
      },
      brighten: function brighten() {
        return this._applyModification(_brighten, arguments);
      },
      darken: function darken() {
        return this._applyModification(_darken, arguments);
      },
      desaturate: function desaturate() {
        return this._applyModification(_desaturate, arguments);
      },
      saturate: function saturate() {
        return this._applyModification(_saturate, arguments);
      },
      greyscale: function greyscale() {
        return this._applyModification(_greyscale, arguments);
      },
      spin: function spin() {
        return this._applyModification(_spin, arguments);
      },
      _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
      },
      analogous: function analogous() {
        return this._applyCombination(_analogous, arguments);
      },
      complement: function complement() {
        return this._applyCombination(_complement, arguments);
      },
      monochromatic: function monochromatic() {
        return this._applyCombination(_monochromatic, arguments);
      },
      splitcomplement: function splitcomplement() {
        return this._applyCombination(_splitcomplement, arguments);
      },
      triad: function triad() {
        return this._applyCombination(_triad, arguments);
      },
      tetrad: function tetrad() {
        return this._applyCombination(_tetrad, arguments);
      }
    };

    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function (color, opts) {
      if (_typeof$1(color) == "object") {
        var newColor = {};
        for (var i in color) {
          if (color.hasOwnProperty(i)) {
            if (i === "a") {
              newColor[i] = color[i];
            } else {
              newColor[i] = convertToPercentage(color[i]);
            }
          }
        }
        color = newColor;
      }
      return tinycolor(color, opts);
    };

    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
      var rgb = {
        r: 0,
        g: 0,
        b: 0
      };
      var a = 1;
      var s = null;
      var v = null;
      var l = null;
      var ok = false;
      var format = false;
      if (typeof color == "string") {
        color = stringInputToObject(color);
      }
      if (_typeof$1(color) == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
          rgb = rgbToRgb(color.r, color.g, color.b);
          ok = true;
          format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
          s = convertToPercentage(color.s);
          v = convertToPercentage(color.v);
          rgb = hsvToRgb(color.h, s, v);
          ok = true;
          format = "hsv";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
          s = convertToPercentage(color.s);
          l = convertToPercentage(color.l);
          rgb = hslToRgb(color.h, s, l);
          ok = true;
          format = "hsl";
        }
        if (color.hasOwnProperty("a")) {
          a = color.a;
        }
      }
      a = boundAlpha(a);
      return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
      };
    }

    // Conversion Functions
    // --------------------

    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
      return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
      };
    }

    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
      var max = mathMax(r, g, b),
        min = mathMin(r, g, b);
      var h,
        s,
        l = (max + min) / 2;
      if (max == min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }
      return {
        h: h,
        s: s,
        l: l
      };
    }

    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
      var r, g, b;
      h = bound01(h, 360);
      s = bound01(s, 100);
      l = bound01(l, 100);
      function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }
      if (s === 0) {
        r = g = b = l; // achromatic
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return {
        r: r * 255,
        g: g * 255,
        b: b * 255
      };
    }

    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
      var max = mathMax(r, g, b),
        min = mathMin(r, g, b);
      var h,
        s,
        v = max;
      var d = max - min;
      s = max === 0 ? 0 : d / max;
      if (max == min) {
        h = 0; // achromatic
      } else {
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }
      return {
        h: h,
        s: s,
        v: v
      };
    }

    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
      h = bound01(h, 360) * 6;
      s = bound01(s, 100);
      v = bound01(v, 100);
      var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];
      return {
        r: r * 255,
        g: g * 255,
        b: b * 255
      };
    }

    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
      var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))];

      // Return a 3 character hex if possible
      if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
      }
      return hex.join("");
    }

    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
      var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16)), pad2(convertDecimalToHex(a))];

      // Return a 4 character hex if possible
      if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
      }
      return hex.join("");
    }

    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
      var hex = [pad2(convertDecimalToHex(a)), pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))];
      return hex.join("");
    }

    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
      if (!color1 || !color2) {
        return false;
      }
      return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function () {
      return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
      });
    };

    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function _desaturate(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.s -= amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }
    function _saturate(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.s += amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }
    function _greyscale(color) {
      return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.l += amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    }
    function _brighten(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var rgb = tinycolor(color).toRgb();
      rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
      rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
      rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
      return tinycolor(rgb);
    }
    function _darken(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.l -= amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    }

    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
      var hsl = tinycolor(color).toHsl();
      var hue = (hsl.h + amount) % 360;
      hsl.h = hue < 0 ? 360 + hue : hue;
      return tinycolor(hsl);
    }

    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function _complement(color) {
      var hsl = tinycolor(color).toHsl();
      hsl.h = (hsl.h + 180) % 360;
      return tinycolor(hsl);
    }
    function _triad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 120) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 240) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }
    function _tetrad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 90) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 180) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 270) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }
    function _splitcomplement(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 72) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 216) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }
    function _analogous(color, results, slices) {
      results = results || 6;
      slices = slices || 30;
      var hsl = tinycolor(color).toHsl();
      var part = 360 / slices;
      var ret = [tinycolor(color)];
      for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
      }
      return ret;
    }
    function _monochromatic(color, results) {
      results = results || 6;
      var hsv = tinycolor(color).toHsv();
      var h = hsv.h,
        s = hsv.s,
        v = hsv.v;
      var ret = [];
      var modification = 1 / results;
      while (results--) {
        ret.push(tinycolor({
          h: h,
          s: s,
          v: v
        }));
        v = (v + modification) % 1;
      }
      return ret;
    }

    // Utility Functions
    // ---------------------

    tinycolor.mix = function (color1, color2, amount) {
      amount = amount === 0 ? 0 : amount || 50;
      var rgb1 = tinycolor(color1).toRgb();
      var rgb2 = tinycolor(color2).toRgb();
      var p = amount / 100;
      var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
      };
      return tinycolor(rgba);
    };

    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function (color1, color2) {
      var c1 = tinycolor(color1);
      var c2 = tinycolor(color2);
      return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };

    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function (color1, color2, wcag2) {
      var readability = tinycolor.readability(color1, color2);
      var wcag2Parms, out;
      out = false;
      wcag2Parms = validateWCAG2Parms(wcag2);
      switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
          out = readability >= 4.5;
          break;
        case "AAlarge":
          out = readability >= 3;
          break;
        case "AAAsmall":
          out = readability >= 7;
          break;
      }
      return out;
    };

    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function (baseColor, colorList, args) {
      var bestColor = null;
      var bestScore = 0;
      var readability;
      var includeFallbackColors, level, size;
      args = args || {};
      includeFallbackColors = args.includeFallbackColors;
      level = args.level;
      size = args.size;
      for (var i = 0; i < colorList.length; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
          bestScore = readability;
          bestColor = tinycolor(colorList[i]);
        }
      }
      if (tinycolor.isReadable(baseColor, bestColor, {
        "level": level,
        "size": size
      }) || !includeFallbackColors) {
        return bestColor;
      } else {
        args.includeFallbackColors = false;
        return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
      }
    };

    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    };

    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);

    // Utilities
    // ---------

    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
      var flipped = {};
      for (var i in o) {
        if (o.hasOwnProperty(i)) {
          flipped[o[i]] = i;
        }
      }
      return flipped;
    }

    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
      a = parseFloat(a);
      if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
      }
      return a;
    }

    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
      if (isOnePointZero(n)) {
        n = "100%";
      }
      var processPercent = isPercentage(n);
      n = mathMin(max, mathMax(0, parseFloat(n)));

      // Automatically convert percentage into number
      if (processPercent) {
        n = parseInt(n * max, 10) / 100;
      }

      // Handle floating point rounding errors
      if (Math.abs(n - max) < 0.000001) {
        return 1;
      }

      // Convert into [0, 1] range if it isn't already
      return n % max / parseFloat(max);
    }

    // Force a number between 0 and 1
    function clamp01(val) {
      return mathMin(1, mathMax(0, val));
    }

    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
      return parseInt(val, 16);
    }

    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
      return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

    // Check to see if string passed in is a percentage
    function isPercentage(n) {
      return typeof n === "string" && n.indexOf('%') != -1;
    }

    // Force a hex value to have 2 characters
    function pad2(c) {
      return c.length == 1 ? '0' + c : '' + c;
    }

    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
      if (n <= 1) {
        n = n * 100 + "%";
      }
      return n;
    }

    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
      return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
      return parseIntFromHex(h) / 255;
    }
    var matchers = function () {
      // <http://www.w3.org/TR/css3-values/#integers>
      var CSS_INTEGER = "[-\\+]?\\d+%?";

      // <http://www.w3.org/TR/css3-values/#number-value>
      var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

      // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
      var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

      // Actual matching.
      // Parentheses and commas are optional, but not required.
      // Whitespace can take the place of commas or opening paren
      var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }();

    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
      return !!matchers.CSS_UNIT.exec(color);
    }

    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
      color = color.replace(trimLeft, '').replace(trimRight, '').toLowerCase();
      var named = false;
      if (names[color]) {
        color = names[color];
        named = true;
      } else if (color == 'transparent') {
        return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          format: "name"
        };
      }

      // Try to match string input using regular expressions.
      // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
      // Just return an object and let the conversion functions handle that.
      // This way the result will be the same whether the tinycolor is initialized with string or object.
      var match;
      if (match = matchers.rgb.exec(color)) {
        return {
          r: match[1],
          g: match[2],
          b: match[3]
        };
      }
      if (match = matchers.rgba.exec(color)) {
        return {
          r: match[1],
          g: match[2],
          b: match[3],
          a: match[4]
        };
      }
      if (match = matchers.hsl.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          l: match[3]
        };
      }
      if (match = matchers.hsla.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          l: match[3],
          a: match[4]
        };
      }
      if (match = matchers.hsv.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          v: match[3]
        };
      }
      if (match = matchers.hsva.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          v: match[3],
          a: match[4]
        };
      }
      if (match = matchers.hex8.exec(color)) {
        return {
          r: parseIntFromHex(match[1]),
          g: parseIntFromHex(match[2]),
          b: parseIntFromHex(match[3]),
          a: convertHexToDecimal(match[4]),
          format: named ? "name" : "hex8"
        };
      }
      if (match = matchers.hex6.exec(color)) {
        return {
          r: parseIntFromHex(match[1]),
          g: parseIntFromHex(match[2]),
          b: parseIntFromHex(match[3]),
          format: named ? "name" : "hex"
        };
      }
      if (match = matchers.hex4.exec(color)) {
        return {
          r: parseIntFromHex(match[1] + '' + match[1]),
          g: parseIntFromHex(match[2] + '' + match[2]),
          b: parseIntFromHex(match[3] + '' + match[3]),
          a: convertHexToDecimal(match[4] + '' + match[4]),
          format: named ? "name" : "hex8"
        };
      }
      if (match = matchers.hex3.exec(color)) {
        return {
          r: parseIntFromHex(match[1] + '' + match[1]),
          g: parseIntFromHex(match[2] + '' + match[2]),
          b: parseIntFromHex(match[3] + '' + match[3]),
          format: named ? "name" : "hex"
        };
      }
      return false;
    }
    function validateWCAG2Parms(parms) {
      // return valid WCAG2 parms for isReadable.
      // If input parms are invalid, return {"level":"AA", "size":"small"}
      var level, size;
      parms = parms || {
        "level": "AA",
        "size": "small"
      };
      level = (parms.level || "AA").toUpperCase();
      size = (parms.size || "small").toLowerCase();
      if (level !== "AA" && level !== "AAA") {
        level = "AA";
      }
      if (size !== "small" && size !== "large") {
        size = "small";
      }
      return {
        "level": level,
        "size": size
      };
    }

    // Node: Export function
    if (module.exports) {
      module.exports = tinycolor;
    }
    // AMD/requirejs: Define the module
    else {
      window.tinycolor = tinycolor;
    }
  })(Math);
});

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295,
  MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
  nativeMin = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  value = iteratee(value);
  var low = 0,
    high = array == null ? 0 : array.length,
    valIsNaN = value !== value,
    valIsNull = value === null,
    valIsSymbol = isSymbol(value),
    valIsUndefined = value === undefined;
  while (low < high) {
    var mid = nativeFloor((low + high) / 2),
      computed = iteratee(array[mid]),
      othIsDefined = computed !== undefined,
      othIsNull = computed === null,
      othIsReflexive = computed === computed,
      othIsSymbol = isSymbol(computed);
    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? computed <= value : computed < value;
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return nativeMin(high, MAX_ARRAY_INDEX);
}

/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee(iteratee));
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$9.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys$1(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$a.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn$1(source), object);
}

/** Detect free variable `exports`. */
var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof$1(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && (typeof module === "undefined" ? "undefined" : _typeof$1(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root.Buffer : undefined,
  allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$b.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  mapTag$3 = '[object Map]',
  numberTag$2 = '[object Number]',
  regexpTag$2 = '[object RegExp]',
  setTag$3 = '[object Set]',
  stringTag$3 = '[object String]',
  symbolTag$2 = '[object Symbol]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);
    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);
    case dataViewTag$3:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$3:
      return new Ctor();
    case numberTag$2:
    case stringTag$3:
      return new Ctor(object);
    case regexpTag$2:
      return cloneRegExp(object);
    case setTag$3:
      return new Ctor();
    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$4;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$4 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$4;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$3 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  errorTag$2 = '[object Error]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  mapTag$5 = '[object Map]',
  numberTag$3 = '[object Number]',
  objectTag$3 = '[object Object]',
  regexpTag$3 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$4 = '[object String]',
  symbolTag$3 = '[object Symbol]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] = cloneableTags[boolTag$3] = cloneableTags[dateTag$3] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$5] = cloneableTags[numberTag$3] = cloneableTags[objectTag$3] = cloneableTags[regexpTag$3] = cloneableTags[setTag$5] = cloneableTags[stringTag$4] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG,
    isFlat = bitmask & CLONE_FLAT_FLAG,
    isFull = bitmask & CLONE_SYMBOLS_FLAG;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray$1(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
      isFunc = tag == funcTag$2 || tag == genTag$1;
    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$3 || tag == argsTag$3 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys$1;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$1);
}

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray$1(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
      valIsNull = value === null,
      valIsReflexive = value === value,
      valIsSymbol = isSymbol(value);
    var othIsDefined = other !== undefined,
      othIsNull = other === null,
      othIsReflexive = other === other,
      othIsSymbol = isSymbol(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
    objCriteria = object.criteria,
    othCriteria = other.criteria,
    length = objCriteria.length,
    ordersLength = orders.length;
  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
  var result = baseMap(collection, function (value, key, collection) {
    var criteria = arrayMap(iteratees, function (iteratee) {
      return iteratee(value);
    });
    return {
      'criteria': criteria,
      'index': ++index,
      'value': value
    };
  });
  return baseSortBy(result, function (object, other) {
    return compareMultiple(object, other, orders);
  });
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = _typeof$1(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function (collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
var CaptionCollection = function CaptionCollection(params) {
  var _captions = [];
  var _activeLanguageIdentifier = LanguageIdentifier$1.create(languageIdentifiers.identifiers["default"]);
  var _captionLanguages = {};
  var addCaptionFromLanguageCodeCache = function addCaptionFromLanguageCodeCache(caption) {
    caption.getAvailableLanguages().forEach(function (language) {
      if (!_captionLanguages[language]) {
        _captionLanguages[language] = 1;
      } else {
        _captionLanguages[language]++;
      }
    });
  };
  var removeCaptionFromLanguageCodeCache = function removeCaptionFromLanguageCodeCache(caption) {
    caption.getAvailableLanguages().forEach(function (language) {
      if (_captionLanguages[language]) {
        _captionLanguages[language]--;
      }
      if (_captionLanguages[language] === 0) {
        delete _captionLanguages[language];
      }
    });
  };
  var addCaption = function addCaption(caption) {
    addCaptionFromLanguageCodeCache(caption);
    caption.activeLanguageIdentifier = _activeLanguageIdentifier;
    var index = sortedIndexBy(_captions, caption, 'startTime');
    _captions.splice(index, 0, caption);
    return UndoAction$1.create(removeCaption, caption, addCaption, caption);
  };
  var removeCaption = function removeCaption(caption) {
    removeCaptionFromLanguageCodeCache(caption);
    var index = findIndex(_captions, caption);
    if (index !== -1) {
      _captions.splice(index, 1);
      return UndoAction$1.create(addCaption, caption, removeCaption, caption);
    }
    return UndoAction$1.noOp();
  };
  var setCaptions = function setCaptions(captions) {
    _captions = captions;
    _captionLanguages = [];
    _captions.forEach(function (caption) {
      addCaptionFromLanguageCodeCache(caption);
    });
  };
  var mergeCaptions = function mergeCaptions(captionsToMerge) {
    captionsToMerge.forEach(function (captionToMerge) {
      var matchingCaption = find(_captions, function (existingCaption) {
        return existingCaption.startTime === captionToMerge.startTime;
      });
      if (matchingCaption) {
        addCaptionFromLanguageCodeCache(captionToMerge);
        captionToMerge.captionTextList.forEach(function (captionText) {
          matchingCaption.addOrReplaceCaptionText(captionText);
        });
      }
    });
  };
  var clear = function clear() {
    var captionsClone = clone(_captions);
    _captions = [];
    _captionLanguages = [];
    return UndoAction$1.create(setCaptions, captionsClone, setCaptions, []);
  };
  var getAvailableLanguages = function getAvailableLanguages() {
    return Object.keys(_captionLanguages);
  };
  var setActiveLanguageIdentifier = function setActiveLanguageIdentifier(languageIdentifierString) {
    if (!languageIdentifiers.isSupportedLanguage(languageIdentifierString)) {
      languageIdentifierString = languageIdentifiers.identifiers["default"];
    }
    var languageIdentifier = LanguageIdentifier$1.create(languageIdentifierString);
    var previousActiveLanguageIdentifierString = _activeLanguageIdentifier.identifier;
    _activeLanguageIdentifier = languageIdentifier;
    forEach(_captions, function (caption) {
      caption.activeLanguageIdentifier = languageIdentifier;
    });
    return UndoAction$1.create(setActiveLanguageIdentifier, previousActiveLanguageIdentifierString, setActiveLanguageIdentifier, languageIdentifierString);
  };
  var getActiveLanguageIdentifier = function getActiveLanguageIdentifier() {
    return _activeLanguageIdentifier;
  };
  if (params) {
    if (params.hasOwnProperty('captions') && isArray$1(params.captions)) {
      _captions = sortBy(params.captions, ['startTime']);
      _captions.forEach(function (caption) {
        addCaptionFromLanguageCodeCache(caption);
      });
    } else {
      throw new Error('CaptionCollection params is expecting an object eg. { captions: [caption1Object, ...] }');
    }
  }
  var _public = Object.defineProperties({}, {
    captions: {
      get: function get() {
        return _captions;
      }
    }
  });
  _public.setActiveLanguageIdentifier = setActiveLanguageIdentifier;
  _public.getActiveLanguageIdentifier = getActiveLanguageIdentifier;
  _public.getAvailableLanguages = getAvailableLanguages;
  _public.addCaption = addCaption;
  _public.removeCaption = removeCaption;
  _public.mergeCaptions = mergeCaptions;
  _public.clear = clear;
  _public.toPOJO = function () {
    return {
      captions: _captions
    };
  };
  return _public;
};

/** @module CaptionCollection */
var CaptionCollection$1 = {
  /**
   *  Factory method that returns a new CaptionCollection object.
   *  @function create
   *  @param {Object} params - Optional params for caption
   *  @param {Array} [params.captions] - array containing {module:Caption} objects.
   *  @static
   *  @return {module:CaptionCollection} new CaptionCollection instance
   */
  create: function create(params) {
    return CaptionCollection(params);
  }
};
var _defaults$1 = Object.freeze({
  fontFamily: 'Arial, Helvetica, sans-serif;',
  fontSize: 24,
  fgColor: tinycolor$1({
    r: 255,
    g: 255,
    b: 255
  }),
  bgColor: tinycolor$1({
    r: 0,
    g: 0,
    b: 0,
    a: 0.9
  })
});
var CaptionTrack = function CaptionTrack(params) {
  params = params || {};
  var _languageIdentifier = params.languageIdentifierString ? LanguageIdentifier$1.create(params.languageIdentifierString) : LanguageIdentifier$1.create(languageIdentifiers.identifiers["default"]);
  var _fgColor = params.fgColor ? tinycolor$1(params.fgColor) : _defaults$1.fgColor.clone();
  var _bgColor = params.bgColor ? tinycolor$1(params.bgColor) : _defaults$1.bgColor.clone();
  var _fontFamily = params.fontFamily ? params.fontFamily : _defaults$1.fontFamily;
  var _fontSize = parseFontSize(params, _defaults$1.fontSize);
  var _position = params.position ? params.position : undefined;
  var _barHeight = params.barHeight ? params.barHeight : undefined;
  var _captionCollection = params.captions ? CaptionCollection$1.create({
    captions: params.captions
  }) : CaptionCollection$1.create();
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:trackType': 'Caption',
          'xmpDM:frameRate': 'f1000',
          'xmpDM:trackName': 'Captioning',
          'stFnt:fontFamily': _fontFamily,
          'tscDM:fontSize': _fontSize,
          'tscDM:bgOpacity': _bgColor.getAlpha(),
          'tscDM:position': _position,
          'tscDM:captionbarheight': _barHeight
        },
        children: [{
          name: 'xmpDM:markers',
          children: [{
            name: 'rdf:Seq',
            children: _captionCollection.captions
          }]
        }, {
          name: 'tsc:fgColor',
          atts: attsFromColor(_fgColor.toRgb())
        }, {
          name: 'tsc:bgColor',
          atts: attsFromColor(_bgColor.toRgb())
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var attsFromColor = function attsFromColor(color) {
    return {
      'xmpG:red': color.r,
      'xmpG:green': color.g,
      'xmpG:blue': color.b,
      'xmpG:mode': 'RGB'
    };
  };
  var tinycolorToSimpleRgb = function tinycolorToSimpleRgb(tinycolorObj) {
    var rgbaColorObj = tinycolorObj.toRgb();
    return {
      r: rgbaColorObj.r,
      g: rgbaColorObj.g,
      b: rgbaColorObj.b
    };
  };
  var _public = Object.defineProperties({}, {
    languageIdentifier: {
      get: function get() {
        return _languageIdentifier;
      }
    },
    fgColor: {
      get: function get() {
        return tinycolorToSimpleRgb(_fgColor);
      }
    },
    fgHexColor: {
      get: function get() {
        return _fgColor.toHexString();
      }
    },
    bgColor: {
      get: function get() {
        return tinycolorToSimpleRgb(_bgColor);
      }
    },
    bgOpacity: {
      get: function get() {
        return _bgColor.getAlpha();
      }
    },
    bgHexColor: {
      get: function get() {
        return _bgColor.toHexString();
      }
    },
    bgRGBACssColor: {
      get: function get() {
        return _bgColor.toRgbString();
      }
    },
    fontFamily: {
      get: function get() {
        return _fontFamily;
      }
    },
    fontSize: {
      get: function get() {
        return _fontSize;
      }
    },
    position: {
      get: function get() {
        return _position;
      }
    },
    barHeight: {
      get: function get() {
        return _barHeight;
      }
    },
    captionCollection: {
      get: function get() {
        return _captionCollection;
      }
    }
  });
  _public.setActiveLanguageIdentifier = _captionCollection.setActiveLanguageIdentifier;
  _public.getActiveLanguageIdentifier = _captionCollection.getActiveLanguageIdentifier;
  _public.getAvailableLanguages = _captionCollection.getAvailableLanguages;
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      fgColor: _fgColor.toRgb(),
      bgColor: _bgColor.toRgb(),
      bgOpacity: _bgColor.getAlpha(),
      fontFamily: _fontFamily,
      fontSize: _fontSize,
      position: _position,
      barHeight: _barHeight,
      captions: invokeMap(_captionCollection.captions, 'toPOJO')
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    return pojo;
  };
  return _public;
};
var getRGBColor = function getRGBColor(element) {
  return {
    r: Number(element.getAttribute('xmpG:red')),
    g: Number(element.getAttribute('xmpG:green')),
    b: Number(element.getAttribute('xmpG:blue'))
  };
};
var parseFontSize = function parseFontSize(params, defaultFontSize) {
  if (!params.fontSize) {
    return defaultFontSize;
  }
  var parsedFontSize = +params.fontSize;
  if (isString(params.fontSize)) {
    parsedFontSize = +params.fontSize.replace('px', '').replace('pt', '');
  }
  return parsedFontSize ? parsedFontSize : defaultFontSize;
};
var createFromXmpElement$2 = function createFromXmpElement$2(captionTrackElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var captionTrack = new CaptionTrack();
  if (captionTrackElement) {
    var fgColorElement = _xmlUtility.getFirstElementByTagNameNSPrefix(captionTrackElement, 'tsc:fgColor');
    var bgColorElement = _xmlUtility.getFirstElementByTagNameNSPrefix(captionTrackElement, 'tsc:bgColor');
    var captionElements = _xmlUtility.getElementsByTagNameNSPrefix(captionTrackElement, 'rdf:Description');
    var captions = map(captionElements, Caption$1.createFromXmpElement);
    var params = {
      fgColor: getRGBColor(fgColorElement),
      bgColor: getRGBColor(bgColorElement),
      fontFamily: captionTrackElement.getAttribute('stFnt:fontFamily'),
      fontSize: Number(captionTrackElement.getAttribute('tscDM:fontSize')),
      position: captionTrackElement.getAttribute('tscDM:position'),
      barHeight: Number(captionTrackElement.getAttribute('tscDM:captionbarheight')),
      captions: captions
    };
    params.bgColor.a = !isNil(captionTrackElement.getAttribute('tscDM:bgOpacity')) ? Number(captionTrackElement.getAttribute('tscDM:bgOpacity')) : _defaults$1.bgColor.getAlpha();
    captionTrack = new CaptionTrack(params);
  }
  return captionTrack;
};

/** @module CaptionTrack */
var CaptionTrack$1 = {
  /**
   *  Factory method that returns a new CaptionTrack object.
   *  @function create
   *  @param {Object} params - Optional params for caption track
   *  @param {String} [params.languageIdentifierString] - Local identifier string for caption track
   *  @param {Object} [params.fgColor] - RGB values for foreground color.
   *  @param {Number} [params.bgOpacity] - Opacity of background.
   *  @param {String} [params.fontFamily] - Font family for caption track.
   *  @param {String} [params.fontSize] - Font size for caption track.
   *  @param {String} [params.position] - Position for caption track.
   *  @param {String} [params.barHeight] - Bar height for caption track.
   *  @static
   *  @return {module:CaptionTrack} new CaptionTrack instance
   */
  create: function create(params) {
    return CaptionTrack(params);
  },
  /**
   *  Factory method that returns a new CaptionTrack object from an XMP caption track element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP caption track element.
   *  @static
   *  @return {module:CaptionTrack} new CaptionTrack instance
   */
  createFromXmpElement: createFromXmpElement$2
};

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray$1(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate));
}
var CaptionController$2 = function CaptionController() {
  var _activeLanguageIdentifier = LanguageIdentifier$1.create(languageIdentifiers.identifiers["default"]);
  var _activeCaptionTrack = null;
  var _captionTracks = [];
  var _captionLanguages = {};
  var storeCaptionLanguage = function storeCaptionLanguage(languageIdentifier) {
    _captionLanguages[languageIdentifier.identifier] = languageIdentifier.identifier;
  };
  var removeCaptionLanguage = function removeCaptionLanguage(languageIdentifier) {
    if (_captionLanguages[languageIdentifier.identifier]) {
      delete _captionLanguages[languageIdentifier.identifier];
    }
  };
  var getAvailableLanguages = function getAvailableLanguages() {
    return Object.keys(_captionLanguages);
  };
  var cacheActiveCaptionTrack = function cacheActiveCaptionTrack() {
    if (_captionTracks.length === 0) {
      _activeCaptionTrack = null;
      return;
    }
    if (_activeLanguageIdentifier.identifier === languageIdentifiers.identifiers["default"]) {
      _activeCaptionTrack = _captionTracks[0];
    }
    var preferredCaptionTrack = find(_captionTracks, function (captionTrack) {
      return captionTrack.languageIdentifier.identifier === _activeLanguageIdentifier.identifier;
    });
    if (preferredCaptionTrack) {
      _activeCaptionTrack = preferredCaptionTrack;
    } else {
      _activeCaptionTrack = _captionTracks[0];
    }
  };
  var setActiveLanguageIdentifier = function setActiveLanguageIdentifier(languageIdentifierString) {
    if (!languageIdentifiers.isSupportedLanguage(languageIdentifierString)) {
      languageIdentifierString = languageIdentifiers.identifiers["default"];
    }
    var previousLanguageIdentifierString = _activeLanguageIdentifier.identifier;
    _activeLanguageIdentifier = LanguageIdentifier$1.create(languageIdentifierString);
    cacheActiveCaptionTrack();
    return UndoAction$1.create(setActiveLanguageIdentifier, previousLanguageIdentifierString, setActiveLanguageIdentifier, languageIdentifierString);
  };
  var getActiveLanguageIdentifier = function getActiveLanguageIdentifier() {
    return _activeLanguageIdentifier;
  };
  var doesCaptionTrackExistForLanguageIdentifier = function doesCaptionTrackExistForLanguageIdentifier(languageIdentifier) {
    return _captionTracks.some(function (captionTrack) {
      return captionTrack.languageIdentifier.identifier === languageIdentifier.identifier;
    });
  };
  var addCaptionTrack = function addCaptionTrack(captionTrack) {
    if (doesCaptionTrackExistForLanguageIdentifier(captionTrack.languageIdentifier)) {
      throw new Error('CaptionController::addCaptionTrack - Caption track already exist for the ', captionTrack.languageIdentifier.identifier, ' langauge identifier.');
    }
    storeCaptionLanguage(captionTrack.languageIdentifier);
    _captionTracks.push(captionTrack);
    cacheActiveCaptionTrack();
    return UndoAction$1.create(removeCaptionTrack, captionTrack, addCaptionTrack, captionTrack);
  };
  var removeCaptionTrack = function removeCaptionTrack(captionTrackToRemove) {
    var removedCaptionTracks = remove(_captionTracks, function (captionTrack) {
      return captionTrack.languageIdentifier.identifier === captionTrackToRemove.languageIdentifier.identifier;
    });
    var removedCaptionTrack = removedCaptionTracks.length > 0 ? removedCaptionTracks[0] : undefined;
    if (removedCaptionTrack) {
      removeCaptionLanguage(removedCaptionTrack.languageIdentifier);
      cacheActiveCaptionTrack();
    }
    return UndoAction$1.create(addCaptionTrack, removedCaptionTrack, removeCaptionTrack, captionTrackToRemove);
  };
  var addCaptionTrackFromXmpElement = function addCaptionTrackFromXmpElement(captionTrackElement) {
    var parsedCaptionTrack = CaptionTrack$1.createFromXmpElement(captionTrackElement);
    var availableLanguages = parsedCaptionTrack.getAvailableLanguages();
    if (availableLanguages.length > 1) {
      availableLanguages.forEach(function (language) {
        var captionTrackParams = {
          languageIdentifierString: language,
          fgColor: parsedCaptionTrack.fgColor,
          bgColor: parsedCaptionTrack.bgColor,
          bgOpacity: parsedCaptionTrack.bgOpacity,
          fontFamily: parsedCaptionTrack.fontFamily,
          fontSize: parsedCaptionTrack.fontSize,
          position: parsedCaptionTrack.position,
          barHeight: parsedCaptionTrack.barHeight
        };
        var captionTrack = CaptionTrack$1.create(captionTrackParams);
        parsedCaptionTrack.captionCollection.captions.forEach(function (caption) {
          var filteredCaptionTextList = filter(caption.captionTextList, function (captionText) {
            return captionText.languageIdentifier.identifier === language;
          });
          var captionParams = {
            startTime: caption.startTime,
            duration: caption.duration,
            captionTextList: filteredCaptionTextList
          };
          if (caption.horizontalAlignment) {
            captionParams.horizontalAlignment = caption.horizontalAlignment;
          }
          if (caption.verticalAlignment) {
            captionParams.verticalAlignment = caption.verticalAlignment;
          }
          if (caption.file) {
            captionParams.file = caption.file;
          }
          if (caption.image) {
            captionParams.image = caption.image;
          }
          if (caption.imageIndex) {
            captionParams.imageIndex = caption.imageIndex;
          }
          if (caption.imageOffset) {
            captionParams.imageOffset = caption.imageOffset;
          }
          if (caption.imageRectangle) {
            captionParams.imageRectangle = caption.imageRectangle;
          }
          var newCaption = Caption$1.create(captionParams);
          captionTrack.captionCollection.addCaption(newCaption);
        });
        addCaptionTrack(captionTrack);
      });
    } else {
      addCaptionTrack(parsedCaptionTrack);
    }
  };
  var getMergedCaptionTrack = function getMergedCaptionTrack() {
    var captionTrackParams = {
      languageIdentifierString: _activeCaptionTrack ? _activeCaptionTrack.languageIdentifierString : undefined,
      fgColor: _activeCaptionTrack ? _activeCaptionTrack.fgColor : undefined,
      bgOpacity: _activeCaptionTrack ? _activeCaptionTrack.bgOpacity : undefined,
      fontFamily: _activeCaptionTrack ? _activeCaptionTrack.fontFamily : undefined,
      fontSize: _activeCaptionTrack ? _activeCaptionTrack.fontSize : undefined,
      position: _activeCaptionTrack ? _activeCaptionTrack.position : undefined,
      barHeight: _activeCaptionTrack ? _activeCaptionTrack.barHeight : undefined
    };
    var mergedCaptionTrack = CaptionTrack$1.create(captionTrackParams);
    _captionTracks.forEach(function (captionTrack) {
      mergedCaptionTrack.captionCollection.mergeCaptions(captionTrack.captionCollection.captions);
    });
    return mergedCaptionTrack;
  };
  var toXmp = function toXmp() {
    return getMergedCaptionTrack().toXmp();
  };
  var toPOJO = function toPOJO() {
    return getMergedCaptionTrack().toPOJO();
  };
  var getActiveCaptionTrack = function getActiveCaptionTrack() {
    return _activeCaptionTrack;
  };
  var clearCaptions = function clearCaptions() {
    _captionTracks = [];
    _captionLanguages = {};
    _activeLanguageIdentifier = LanguageIdentifier$1.create(languageIdentifiers.identifiers["default"]);
    _activeCaptionTrack = null;
  };
  var activeCaptionTrackIsDefinedWithCaptions = function activeCaptionTrackIsDefinedWithCaptions() {
    return _activeCaptionTrack !== null && _activeCaptionTrack.captionCollection.captions.length > 0;
  };
  var getActiveCaptionsTocThumbnailImage = function getActiveCaptionsTocThumbnailImage() {
    return activeCaptionTrackIsDefinedWithCaptions() ? _activeCaptionTrack.captionCollection.captions[0].image : null;
  };
  var _public = Object.defineProperties({}, {
    activeCaptionTrack: {
      get: getActiveCaptionTrack
    },
    numberCaptionTracks: {
      get: function get() {
        return _captionTracks.length;
      }
    },
    containsCaptions: {
      get: activeCaptionTrackIsDefinedWithCaptions
    },
    captionsContainsTocThumbnails: {
      get: function get() {
        return activeCaptionTrackIsDefinedWithCaptions() && _activeCaptionTrack.captionCollection.captions[0].image !== undefined;
      }
    }
  });
  _public.setActiveLanguageIdentifier = setActiveLanguageIdentifier;
  _public.getActiveLanguageIdentifier = getActiveLanguageIdentifier;
  _public.clearCaptions = clearCaptions;
  _public.addCaptionTrackFromXmpElement = addCaptionTrackFromXmpElement;
  _public.addCaptionTrack = addCaptionTrack;
  _public.removeCaptionTrack = removeCaptionTrack;
  _public.getAvailableLanguages = getAvailableLanguages;
  _public.getActiveCaptionsTocThumbnailImage = getActiveCaptionsTocThumbnailImage;
  _public.toXmp = toXmp;
  _public.toPOJO = toPOJO;
  return _public;
};

/** @module CaptionController */
var CaptionController$1$1 = {
  /**
   *  Factory method that returns a new CaptionController object.
   *  @function create
   *  @static
   *  @return {module:CaptionController} new CaptionController instance
   */
  create: function create() {
    return CaptionController$2();
  }
};
var TableOfContentsItem = function TableOfContentsItem(params) {
  var _name;
  var _startTime;
  var _image;
  var _imageIndex;
  var _imageOffset;
  var _imageRectangle;
  var _file;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'name') {
        _name = params.name;
      } else if (key === 'startTime') {
        _startTime = params.startTime;
      } else if (key === 'image') {
        _image = params.image;
      } else if (key === 'imageIndex') {
        _imageIndex = params.imageIndex;
      } else if (key === 'imageOffset') {
        _imageOffset = params.imageOffset;
      } else if (key === 'imageRectangle') {
        _imageRectangle = params.imageRectangle;
      } else if (key === 'file') {
        _file = params.file;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:name': _name,
          'xmpDM:startTime': _startTime,
          'tscDM:image': _image,
          'tscDM:imageindex': _imageIndex,
          'tscDM:imageoffset': _imageOffset,
          'tscDM:imagerect': _imageRectangle ? _imageRectangle.toXmpAtt() : null,
          'tscDM:file': _file
        }
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    name: {
      get: function get() {
        return _name;
      }
    },
    startTime: {
      get: function get() {
        return _startTime;
      }
    },
    image: {
      get: function get() {
        return _image;
      }
    },
    imageIndex: {
      get: function get() {
        return _imageIndex;
      }
    },
    imageOffset: {
      get: function get() {
        return _imageOffset;
      }
    },
    imageRectangle: {
      get: function get() {
        return _imageRectangle;
      }
    },
    file: {
      get: function get() {
        return _file;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      name: _name,
      startTime: _startTime,
      image: _image,
      imageIndex: _imageIndex,
      imageOffset: _imageOffset,
      imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : undefined,
      file: _file
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$3 = function createFromXmpElement$3(tableOfContentsItemElement) {
  var params = {
    name: tableOfContentsItemElement.getAttribute('xmpDM:name'),
    startTime: Number(tableOfContentsItemElement.getAttribute('xmpDM:startTime'))
  };

  // optional attributes below

  params.image = tableOfContentsItemElement.getAttribute('tscDM:image') || undefined;
  if (tableOfContentsItemElement.getAttribute('tscDM:imageindex')) {
    params.imageIndex = Number(tableOfContentsItemElement.getAttribute('tscDM:imageindex'));
  }
  if (tableOfContentsItemElement.getAttribute('tscDM:imageoffset')) {
    params.imageOffset = Number(tableOfContentsItemElement.getAttribute('tscDM:imageoffset'));
  }
  params.file = tableOfContentsItemElement.getAttribute('tscDM:file') || undefined;
  if (tableOfContentsItemElement.getAttribute('tscDM:imagerect')) {
    params.imageRectangle = ImageRectangle$1.create(tableOfContentsItemElement.getAttribute('tscDM:imagerect'));
  }
  return new TableOfContentsItem(params);
};

/** @module TableOfContentsItem */
var TableOfContentsItem$1 = {
  /**
   *  Factory method that returns a new TableOfContentsItem object.
   *  @function create
   *  @param {Object} params - Required params for table of contents item
   *  @param {String} [params.name] - Table of contents item name.
   *  @param {Number} [params.startTime] - Start time of table of contents item (milliseconds).
   *  @param {String} [params.image] - Table of contents item image.
   *  @param {Number} [params.imageIndex] - Table of contents item image index.
   *  @param {Number} [params.imageOffset] - Table of contents item image offset.
   *  @param {module:ImageRectangle} [params.imageRectangle] - Table of contents item image rectangle.
   *  @param {String} [params.file] - File string associated with toc item.
   *  @static
   *  @return {module:TableOfContentsItem} new TableOfContentsItem instance
   */
  create: function create(params) {
    return TableOfContentsItem(params);
  },
  /**
   *  Factory method that returns a new TableOfContentsItem object from an XMP tableOfContentsItem element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP tableOfContentsItem element.
   *  @static
   *  @return {module:TableOfContentsItem} new TableOfContentsItem instance
   */
  createFromXmpElement: createFromXmpElement$3
};
var TableOfContentsTrack = function TableOfContentsTrack(params) {
  var _items = [];
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    if (params.hasOwnProperty('items') && isArray$1(params.items)) {
      _items = params.items;
    } else {
      throw new Error('TableOfContentsTrack params is expecting an object eg. { items: [item1Object, ...] }');
    }
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:trackType': 'TableOfContents',
          'xmpDM:trackName': 'Table of Contents',
          'xmpDM:frameRate': 'f1000',
          'tscDM:image': params ? params.image : undefined,
          'tscDM:tocCellLayout': params ? params.cellLayout : undefined
        },
        children: [{
          name: 'xmpDM:markers',
          children: [{
            name: 'rdf:Seq',
            children: _items
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    image: {
      get: function get() {
        return params.image;
      }
    },
    cellLayout: {
      get: function get() {
        return params.cellLayout;
      }
    },
    items: {
      get: function get() {
        return _items;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      image: params.image,
      cellLayout: params.cellLayout,
      items: invokeMap(_items, 'toPOJO')
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$4 = function createFromXmpElement$4(tableOfContentsTrackElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var tableOfContentsTrack = new TableOfContentsTrack();
  if (tableOfContentsTrackElement) {
    var tableOfContentsItemElements = _xmlUtility.getElementsByTagNameNSPrefix(tableOfContentsTrackElement, 'rdf:Description');
    var image = tableOfContentsTrackElement.getAttribute('tscDM:image');
    var cellLayout = tableOfContentsTrackElement.getAttribute('tscDM:tocCellLayout');
    var items = map(tableOfContentsItemElements, TableOfContentsItem$1.createFromXmpElement);
    var params = {
      image: image,
      cellLayout: cellLayout,
      items: items
    };
    tableOfContentsTrack = new TableOfContentsTrack(params);
  }
  return tableOfContentsTrack;
};

/** @module TableOfContentsTrack */
var TableOfContentsTrack$1 = {
  /**
   *  Factory method that returns a new TableOfContentsTrack object.
   *  @function create
   *  @param {Object} params - Optional params for table of contents track
   *  @param {module:TableOfContentsItem[]} [params.items] - Array of table of content items.
   *  @static
   *  @return {module:TableOfContentsTrack} new TableOfContentsTrack instance
   */
  create: function create(params) {
    return TableOfContentsTrack(params);
  },
  /**
   *  Factory method that returns a new TableOfContentsTrack object from an XMP table of contents track element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP table of contents track element.
   *  @static
   *  @return {module:TableOfContentsTrack} new TableOfContentsTrack instance
   */
  createFromXmpElement: createFromXmpElement$4
};

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var BoundingPoly = function BoundingPoly(coordinatesString) {
  var _coordinates = [];
  var createCoordinate = function createCoordinate(coordinateString) {
    var tokens = coordinateString.split(',');
    return {
      x: Number(tokens[0]),
      y: Number(tokens[1])
    };
  };
  if (coordinatesString && isString(coordinatesString)) {
    var coordinateTokens = compact(coordinatesString.split(';'));
    _coordinates = map(coordinateTokens, createCoordinate);
  } else {
    throw new Error('BoundingPoly is expecting a coordinate string eg. "0,94;111,90;112,191;0,194;"');
  }
  var _public = Object.defineProperties({}, {
    coordinates: {
      get: function get() {
        return _coordinates;
      }
    }
  });
  _public.toPOJO = function () {
    return {
      coordinates: _coordinates
    };
  };
  _public.toXmpAtt = function () {
    return map(_coordinates, function (coord) {
      return coord.x + ',' + coord.y;
    }).join(';') + ';';
  };
  return _public;
};

/** @module BoundingPoly */
var BoundingPoly$1 = {
  /**
   *  Factory method that returns a new BoundingPoly object.
   *  @function create
   *  @param {String} coordinatesString - Required coordinate string of the bounding poly eg. "0,94;111,90;112,191;0,194;"
   *  @static
   *  @return {module:BoundingPoly} new BoundingPoly instance
   */
  create: function create(coordinatesString) {
    return BoundingPoly(coordinatesString);
  }
};
var Hotspot = function Hotspot(params) {
  var _label;
  var _startTime;
  var _duration;
  var _boundingPoly;
  var _rotate;
  var _pause;
  var _jumpTime;
  var _location;
  var _newWindow;
  var _jumpFile;
  var _file;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'label') {
        _label = params.label;
      } else if (key === 'startTime') {
        _startTime = params.startTime;
      } else if (key === 'duration') {
        _duration = params.duration;
      } else if (key === 'boundingPoly') {
        _boundingPoly = params.boundingPoly;
      } else if (key === 'rotate') {
        _rotate = params.rotate;
      } else if (key === 'pause') {
        _pause = params.pause;
      } else if (key === 'jumpTime') {
        _jumpTime = params.jumpTime;
      } else if (key === 'location') {
        _location = params.location;
      } else if (key === 'newWindow') {
        _newWindow = params.newWindow;
      } else if (key === 'jumpFile') {
        _jumpFile = params.jumpFile;
      } else if (key === 'file') {
        _file = params.file;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:label': _label,
          'xmpDM:duration': _duration,
          'xmpDM:startTime': _startTime,
          'tscDM:boundingPoly': _boundingPoly ? _boundingPoly.toXmpAtt() : undefined,
          'tscDM:rotate': _rotate,
          'tscHS:pause': _pause ? '1' : '0',
          'tscHS:jumpTime': _jumpTime,
          'tscHS:jumpFile': _jumpFile,
          'xmpDM:location': _location,
          'tscDM:file': _file,
          'tscHS:newWindow': _newWindow ? '1' : '0'
        }
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    label: {
      get: function get() {
        return _label;
      }
    },
    startTime: {
      get: function get() {
        return _startTime;
      }
    },
    endTime: {
      get: function get() {
        return _startTime + _duration;
      }
    },
    duration: {
      get: function get() {
        return _duration;
      }
    },
    boundingPoly: {
      get: function get() {
        return _boundingPoly;
      }
    },
    rotate: {
      get: function get() {
        return _rotate;
      }
    },
    pause: {
      get: function get() {
        return _pause;
      }
    },
    jumpTime: {
      get: function get() {
        return _jumpTime;
      }
    },
    location: {
      get: function get() {
        return _location;
      }
    },
    newWindow: {
      get: function get() {
        return _newWindow;
      }
    },
    jumpFile: {
      get: function get() {
        return _jumpFile;
      }
    },
    file: {
      get: function get() {
        return _file;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      label: _label,
      startTime: _startTime,
      duration: _duration,
      boundingPoly: _boundingPoly,
      rotate: _rotate,
      pause: _pause,
      jumpTime: _jumpTime,
      location: _location,
      newWindow: _newWindow,
      jumpFile: _jumpFile,
      file: _file
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$5 = function createFromXmpElement$5(hotspotElement) {
  var params = {
    label: hotspotElement.getAttribute('xmp:label'),
    startTime: Number(hotspotElement.getAttribute('xmpDM:startTime')),
    duration: Number(hotspotElement.getAttribute('xmpDM:duration')),
    boundingPoly: BoundingPoly$1.create(hotspotElement.getAttribute('tscDM:boundingPoly')),
    rotate: Number(hotspotElement.getAttribute('tscDM:rotate')),
    pause: hotspotElement.getAttribute('tscHS:pause') === '1',
    newWindow: hotspotElement.getAttribute('tscHS:newWindow') === '1'
  };
  if (hotspotElement.getAttribute('tscHS:jumpTime')) {
    params.jumpTime = Number(hotspotElement.getAttribute('tscHS:jumpTime'));
  }
  params.jumpFile = hotspotElement.getAttribute('tscHS:jumpFile') || undefined;
  params.location = hotspotElement.getAttribute('xmpDM:location') || undefined;
  params.file = hotspotElement.getAttribute('tscDM:file') || undefined;
  return new Hotspot(params);
};

/** @module Hotspot */
var Hotspot$1 = {
  /**
   *  Factory method that returns a new Hotspot object.
   *  @function create
   *  @param {Object} params - Required params for hotspot
   *  @param {String} [params.label] - Hotspot label.
   *  @param {Number} [params.startTime] - Start time of hotspot (milliseconds).
   *  @param {Number} [params.duration] - Duration of hotspot (milliseconds).
   *  @param {module:BoundingPoly} [params.boundingPoly] - Bounding polygon of hotspot.
   *  @param {Number} [params.rotate] - Rotation value of polygon.
   *  @param {Boolean} [params.pause] - Boolean if hotspot should pause at end.
   *  @param {Number} [params.jumpTime] - Specific time within video that hotspot will jump to (milliseconds)
   *  @param {Number} [params.jumpTime] - Specific time within video that hotspot will jump to (milliseconds)
   *  @param {String} [params.location] - URL to launch for hotspot.
   *  @param {Boolean} [params.newWindow] - True if the hotspot location should open in a new window.
   *  @param {String} [params.jumpFile] - Url to file.
   *  @param {String} [params.file] - Url to file.
   *  @static
   *  @return {module:Hotspot} new Hotspot instance
   */
  create: function create(params) {
    return Hotspot(params);
  },
  /**
   *  Factory method that returns a new Hotspot object from an XMP hotspot element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP hotspot element.
   *  @static
   *  @return {module:Hotspot} new Hotspot instance
   */
  createFromXmpElement: createFromXmpElement$5
};
var HotspotTrack = function HotspotTrack(params) {
  var _hotspots = [];
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    if (params.hasOwnProperty('hotspots') && isArray$1(params.hotspots)) {
      _hotspots = params.hotspots;
    } else {
      throw new Error('HotspotTrack params is expecting an object eg. { hotspots: [hotspot1Object, ...] }');
    }
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:trackType': 'Hotspot',
          'xmpDM:trackName': 'Hotspots',
          'xmpDM:frameRate': 'f1000'
        },
        children: [{
          name: 'xmpDM:markers',
          children: [{
            name: 'rdf:Seq',
            children: _hotspots
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    hotspots: {
      get: function get() {
        return _hotspots;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      hotspots: invokeMap(_hotspots, 'toPOJO')
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$6 = function createFromXmpElement$6(hotspotTrackElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var hotspotTrack = new HotspotTrack();
  if (hotspotTrackElement) {
    var hotspotElements = _xmlUtility.getElementsByTagNameNSPrefix(hotspotTrackElement, 'rdf:Description');
    var hotspots = map(hotspotElements, Hotspot$1.createFromXmpElement);
    var params = {
      hotspots: hotspots
    };
    hotspotTrack = new HotspotTrack(params);
  }
  return hotspotTrack;
};

/** @module HotspotTrack */
var HotspotTrack$1 = {
  /**
   *  Factory method that returns a new HotspotTrack object.
   *  @function create
   *  @param {Object} params - Optional params for caption track
   *  @param {module:Hotspot[]} [params.hotspots] - Array of hotspots.
   *  @static
   *  @return {module:HotspotTrack} new HotspotTrack instance
   */
  create: function create(params) {
    return HotspotTrack(params);
  },
  /**
   *  Factory method that returns a new HotspotTrack object from an XMP hotspot track element.
   *  @function create
   *  @param {Object} element - XMP hotspot track element.
   *  @static
   *  @return {module:HotspotTrack} new HotspotTrack instance
   */
  createFromXmpElement: createFromXmpElement$6
};
var Answer = function Answer(params) {
  var _orderId;
  var _text;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'orderId') {
        _orderId = params.orderId;
      } else if (key === 'text') {
        _text = params.text;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'tscIQ:orderId': _orderId
        },
        children: [{
          name: 'tscIQ:answer',
          text: _text
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    orderId: {
      get: function get() {
        return _orderId;
      }
    },
    text: {
      get: function get() {
        return _text;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      orderId: _orderId,
      text: _text
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$7 = function createFromXmpElement$7(answerElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var answerText = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(answerElement, 'tscIQ:answer');
  var params = {
    orderId: Number(answerElement.getAttribute('tscIQ:orderId')),
    text: answerText
  };
  return new Answer(params);
};

/** @module Answer */
var Answer$1 = {
  /**
   *  Factory method that returns a new Answer object.
   *  @function create
   *  @param {Object} params - Required params for answer
   *  @param {Number} [params.orderId] - Answer order id.
   *  @param {String} [params.text] - Answer text.
   *  @static
   *  @return {module:Answer} new Answer instance
   */
  create: function create(params) {
    return Answer(params);
  },
  /**
   *  Factory method that returns a new Answer object from an XMP answer element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP answer element.
   *  @static
   *  @return {module:Answer} new Answer instance
   */
  createFromXmpElement: createFromXmpElement$7
};
var Feedback = function Feedback(params) {
  var _reason;
  var _jumpToTime;
  var _location;
  var _text;
  var _plainText;
  var _markupText;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'reason') {
        _reason = params.reason;
      } else if (key === 'text') {
        _text = params.text;
        _plainText = Rtf.toText(_text);
        _markupText = Rtf.toHtml(_text);
      } else if (key === 'jumpToTime') {
        _jumpToTime = params.jumpToTime;
      } else if (key === 'location') {
        _location = params.location;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'tscIQ:reason': _reason,
          'tscIQ:jumpToTime': _jumpToTime,
          'tscIQ:location': _location
        },
        children: [{
          name: 'xmpDM:name',
          children: [{
            name: 'rdf:Alt',
            // todo: according to the latest branch this is now a language collection of strings
            // for now i hardcoded a single english version to match the expected output
            children: [{
              name: 'rdf:li',
              atts: {
                'xml:lang': 'en-US'
              },
              text: _text
            }]
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    reason: {
      get: function get() {
        return _reason;
      }
    },
    jumpToTime: {
      get: function get() {
        return _jumpToTime;
      }
    },
    location: {
      get: function get() {
        return _location;
      }
    },
    text: {
      get: function get() {
        return _text;
      }
    },
    plainText: {
      get: function get() {
        return _plainText;
      }
    },
    markupText: {
      get: function get() {
        return _markupText;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      reason: _reason,
      jumpToTime: _jumpToTime,
      location: _location,
      text: _text,
      plainText: _plainText,
      markupText: _markupText
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$8 = function createFromXmpElement$8(feedbackElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var feedbackText = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(feedbackElement, 'rdf:li');
  var params = {
    reason: feedbackElement.getAttribute('tscIQ:reason'),
    text: feedbackText
  };
  if (feedbackElement.getAttribute('tscIQ:jumpToTime')) {
    params.jumpToTime = Number(feedbackElement.getAttribute('tscIQ:jumpToTime'));
  }
  params.location = feedbackElement.getAttribute('tscIQ:location') || undefined;
  return Feedback(params);
};

/** @module Feedback */
var Feedback$1 = {
  /**
   *  Factory method that returns a new Feedback object.
   *  @function create
   *  @param {Object} params - Required params for feedback
   *  @param {String} [params.reason] - Feedback reason type.
   *  @param {String} [params.text] - Feedback text.
   *  @param {Number} [params.jumpToTime] - Feedback jumpToTime.
   *  @param {String} [params.location] - Feedback location.
   *  @static
   *  @return {module:Feedback} new Feedback instance
   */
  create: function create(params) {
    return Feedback(params);
  },
  /**
   *  Factory method that returns a new Feedback object from an XMP feedback element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP feedback element.
   *  @static
   *  @return {module:Feedback} new Feedback instance
   */
  createFromXmpElement: createFromXmpElement$8
};
var Question$2 = function Question(params) {
  var _id;
  var _type;
  var _text;
  var _correctAnswer;
  var _answers = [];
  var _feedback = [];
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'id') {
        _id = params.id;
      } else if (key === 'type') {
        _type = params.type;
      } else if (key === 'text') {
        _text = params.text;
      } else if (key === 'correctAnswer') {
        _correctAnswer = params.correctAnswer;
      } else if (key === 'answers') {
        _answers = params.answers;
      } else if (key === 'feedback') {
        _feedback = params.feedback;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'tscIQ:id': _id,
          'tscIQ:type': _type
        },
        children: [{
          name: 'tscIQ:question',
          text: _text
        }, {
          name: 'tscIQ:correctAnswer',
          text: _type === 'MC' ? _correctAnswer : null
        }, {
          name: 'tscIQ:answerArray',
          children: [{
            name: 'rdf:Seq',
            children: _answers
          }]
        }, {
          name: 'tscIQ:feedback',
          children: [{
            name: 'rdf:Bag',
            children: _feedback
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    id: {
      get: function get() {
        return _id;
      }
    },
    type: {
      get: function get() {
        return _type;
      }
    },
    text: {
      get: function get() {
        return _text;
      }
    },
    correctAnswer: {
      get: function get() {
        return _correctAnswer;
      }
    },
    answers: {
      get: function get() {
        return _answers;
      }
    },
    feedback: {
      get: function get() {
        return _feedback;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      id: _id,
      type: _type,
      text: _text,
      correctAnswer: _correctAnswer,
      answers: invokeMap(_answers, 'toPOJO'),
      feedback: _feedback !== undefined ? invokeMap(_feedback, 'toPOJO') : undefined
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$9 = function createFromXmpElement$9(questionElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var text = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(questionElement, 'tscIQ:question');
  var correctAnswerText = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(questionElement, 'tscIQ:correctAnswer');
  var descriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(questionElement, 'rdf:Description');
  var answerElements = filter(descriptionElements, function (element) {
    return _xmlUtility.hasAttribute(element, 'tscIQ:orderId');
  });
  var answers = map(answerElements, Answer$1.createFromXmpElement);
  var feedbackElements = filter(descriptionElements, function (element) {
    return _xmlUtility.hasAttribute(element, 'tscIQ:reason');
  });
  var feedback = map(feedbackElements, Feedback$1.createFromXmpElement);
  var params = {
    id: Number(questionElement.getAttribute('tscIQ:id')),
    type: questionElement.getAttribute('tscIQ:type'),
    text: text,
    correctAnswer: correctAnswerText ? Number(correctAnswerText) : undefined,
    answers: answers,
    feedback: feedback
  };
  return Question$2(params);
};

/** @module Question */
var Question$1$1 = {
  /**
   *  Factory method that returns a new Question object.
   *  @function create
   *  @param {Object} params - Required params for question
   *  @param {Number} [params.id] - Question id.
   *  @param {String} [params.text] - Question text.
   *  @param {Number} [params.correctAnswer] - Index of the correct answer within answer array (1 based).
   *  @param {module:Answer[]} [params.answers] - Question answer array.
   *  @param {module:Feedback[]} [params.feedback] - Question feedback array.
   *  @static
   *  @return {module:Question} new Question instance
   */
  create: function create(params) {
    return Question$2(params);
  },
  /**
   *  Factory method that returns a new Question object from an XMP question element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP question element.
   *  @static
   *  @return {module:Question} new Question instance
   */
  createFromXmpElement: createFromXmpElement$9
};
var QuestionSet$2 = function QuestionSet(params) {
  var _name;
  var _feedback;
  var _startTime;
  var _questions;
  var _file;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'name') {
        _name = params.name;
      } else if (key === 'feedback') {
        _feedback = params.feedback;
      } else if (key === 'startTime') {
        _startTime = params.startTime;
      } else if (key === 'file') {
        _file = params.file;
      } else if (key === 'questions') {
        _questions = params.questions;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'tscIQ:questionSetName': _name,
          'tscIQ:feedback': _feedback ? '1' : '0',
          'tscDM:file': _file,
          'xmpDM:startTime': _startTime
        },
        children: [{
          name: 'tscIQ:questions',
          children: [{
            name: 'rdf:Seq',
            children: _questions
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    name: {
      get: function get() {
        return _name;
      }
    },
    feedback: {
      get: function get() {
        return _feedback;
      }
    },
    startTime: {
      get: function get() {
        return _startTime;
      }
    },
    file: {
      get: function get() {
        return _file;
      }
    },
    questions: {
      get: function get() {
        return _questions;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      name: _name,
      feedback: _feedback,
      startTime: _startTime,
      file: _file,
      questions: invokeMap(_questions, 'toPOJO')
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$a = function createFromXmpElement$a(questionSetElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var descriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(questionSetElement, 'rdf:Description');
  var questionElements = filter(descriptionElements, function (element) {
    return _xmlUtility.hasAttribute(element, 'tscIQ:type');
  });
  var questions = map(questionElements, Question$1$1.createFromXmpElement);
  var params = {
    name: questionSetElement.getAttribute('tscIQ:questionSetName'),
    feedback: questionSetElement.getAttribute('tscIQ:feedback') === '1',
    startTime: Number(questionSetElement.getAttribute('xmpDM:startTime')),
    questions: questions
  };
  params.file = questionSetElement.getAttribute('tscDM:file') || undefined;
  return new QuestionSet$2(params);
};

/** @module QuestionSet */
var QuestionSet$1$1 = {
  /**
   *  Factory method that returns a new QuestionSet object.
   *  @function create
   *  @param {Object} params - Required params for question set
   *  @param {String} [params.questionsSetName] - Question set name.
   *  @param {Boolean} [params.feedback] - Question set feedback.
   *  @param {Number} [params.startTime] - Question set start time (milliseconds)
   *  @param {String} [params.file] - Associated file
   *  @param {module:Question[]} [params.questions] - Question set questions.
   *  @static
   *  @return {module:QuestionSet} new QuestionSet instance
   */
  create: function create(params) {
    return QuestionSet$2(params);
  },
  /**
   *  Factory method that returns a new QuestionSet object from an XMP questionSet element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP questionSet element.
   *  @static
   *  @return {module:QuestionSet} new QuestionSet instance
   */
  createFromXmpElement: createFromXmpElement$a
};
var QuizTrack = function QuizTrack(params) {
  var _quizGuid;
  var _authoredEmail;
  var _requireUserId;
  var _locale;
  var _reportMethod;
  var _clientId;
  var _quizHash;
  var _hideReplay;
  var _allowSkipQuiz;
  var _questionSets = [];
  var _parameters;
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'quizGuid') {
        _quizGuid = params.quizGuid;
      } else if (key === 'authoredEmail') {
        _authoredEmail = params.authoredEmail;
      } else if (key === 'requireUserId') {
        _requireUserId = params.requireUserId;
      } else if (key === 'locale') {
        _locale = params.locale;
      } else if (key === 'reportMethod') {
        _reportMethod = params.reportMethod;
      } else if (key === 'clientId') {
        _clientId = params.clientId;
      } else if (key === 'quizHash') {
        _quizHash = params.quizHash;
      } else if (key === 'hideReplay') {
        _hideReplay = params.hideReplay;
      } else if (key === 'allowSkipQuiz') {
        _allowSkipQuiz = params.allowSkipQuiz;
      } else if (key === 'parameters' && isArray$1(params.parameters)) {
        _parameters = params.parameters;
      } else if (key === 'questionSets' && isArray$1(params.questionSets)) {
        _questionSets = params.questionSets;
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:trackType': 'Quiz',
          'xmpDM:trackName': 'Quiz',
          'xmpDM:frameRate': 'f1000',
          'tscIQ:clientId': _clientId,
          'tscIQ:quizHash': _quizHash,
          'tscIQ:quizGuid': _quizGuid,
          'tscIQ:authoredEmail': _authoredEmail,
          'tscIQ:requireUserId': _requireUserId ? '1' : '0',
          'tscIQ:locale': _locale,
          'tscIQ:reportMethod': _reportMethod,
          'tscIQ:hideReplay': _hideReplay ? '1' : '0',
          'tscIQ:allowSkipQuiz': _allowSkipQuiz ? '1' : '0'
        },
        children: [{
          name: 'xmpDM:markers',
          children: [{
            name: 'rdf:Seq',
            children: _questionSets
          }]
        }, {
          name: 'tscIQ:QuizParams',
          children: [{
            name: 'rdf:Bag',
            children: map(_parameters, function (param) {
              return {
                name: 'rdf:li',
                atts: {
                  'xmpDM:name': param.name,
                  'xmpDM:value': param.value
                }
              };
            })
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    quizGuid: {
      get: function get() {
        return _quizGuid;
      }
    },
    authoredEmail: {
      get: function get() {
        return _authoredEmail;
      }
    },
    requireUserId: {
      get: function get() {
        return _requireUserId;
      }
    },
    locale: {
      get: function get() {
        return _locale;
      }
    },
    reportMethod: {
      get: function get() {
        return _reportMethod;
      }
    },
    clientId: {
      get: function get() {
        return _clientId;
      }
    },
    quizHash: {
      get: function get() {
        return _quizHash;
      }
    },
    hideReplay: {
      get: function get() {
        return _hideReplay;
      }
    },
    allowSkipQuiz: {
      get: function get() {
        return _allowSkipQuiz;
      }
    },
    parameters: {
      get: function get() {
        return _parameters;
      }
    },
    questionSets: {
      get: function get() {
        return _questionSets;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      quizGuid: _quizGuid,
      authoredEmail: _authoredEmail,
      requireUserId: _requireUserId,
      locale: _locale,
      reportMethod: _reportMethod,
      clientId: _clientId,
      quizHash: _quizHash,
      hideReplay: _hideReplay,
      allowSkipQuiz: _allowSkipQuiz,
      questionSets: invokeMap(_questionSets, 'toPOJO'),
      parameters: _parameters || undefined
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    return pojo;
  };
  return _public;
};
var parseParameter = function parseParameter(parameterElement) {
  return {
    name: parameterElement.getAttribute('xmpDM:name'),
    value: parameterElement.getAttribute('xmpDM:value')
  };
};
var parseParameters = function parseParameters(quizParametersElement, xmlUtility) {
  if (quizParametersElement) {
    var parameterElements = xmlUtility.getElementsByTagNameNSPrefix(quizParametersElement, 'rdf:li');
    var parameters = map(parameterElements, parseParameter);
    return parameters;
  }
  return undefined;
};
var createFromXmpElement$b = function createFromXmpElement$b(quizTrackElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var quizTrack = new QuizTrack();
  if (quizTrackElement) {
    var descriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(quizTrackElement, 'rdf:Description');
    var questionSetElements = filter(descriptionElements, function (element) {
      return _xmlUtility.hasAttribute(element, 'tscIQ:questionSetName');
    });
    var questionSets = map(questionSetElements, QuestionSet$1$1.createFromXmpElement);
    var quizParametersElement = _xmlUtility.getFirstElementByTagNameNSPrefix(quizTrackElement, 'tscIQ:QuizParams');
    var params = {
      quizGuid: quizTrackElement.getAttribute('tscIQ:quizGuid'),
      authoredEmail: quizTrackElement.getAttribute('tscIQ:authoredEmail'),
      requireUserId: quizTrackElement.getAttribute('tscIQ:requireUserId') === '1',
      locale: quizTrackElement.getAttribute('tscIQ:locale'),
      reportMethod: quizTrackElement.getAttribute('tscIQ:reportMethod'),
      clientId: quizTrackElement.getAttribute('tscIQ:clientId'),
      quizHash: quizTrackElement.getAttribute('tscIQ:quizHash'),
      hideReplay: quizTrackElement.getAttribute('tscIQ:hideReplay') === '1',
      allowSkipQuiz: quizTrackElement.getAttribute('tscIQ:allowSkipQuiz') !== '0',
      parameters: parseParameters(quizParametersElement, _xmlUtility),
      questionSets: questionSets
    };
    quizTrack = new QuizTrack(params);
  }
  return quizTrack;
};

/** @module QuizTrack */
var QuizTrack$1 = {
  /**
   *  Factory method that returns a new QuizTrack object.
   *  @function create
   *  @param {Object} params - Optional params for caption track
   *  @param {module:QuestionSet[]} [params.questionSets] - Array of question sets.
   *  @static
   *  @return {module:QuizTrack} new QuizTrack instance
   */
  create: function create(params) {
    return QuizTrack(params);
  },
  /**
   *  Factory method that returns a new QuizTrack object from an XMP quiz track element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP quiz track element.
   *  @static
   *  @return {module:QuizTrack} new QuizTrack instance
   */
  createFromXmpElement: createFromXmpElement$b
};
var SpeechMarker = function SpeechMarker(params) {
  var _startTime;
  var _duration;
  var _name;
  var _probability;
  var _image;
  var _imageIndex;
  var _imageOffset;
  var _file;
  var _imageRectangle;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'startTime') {
        _startTime = params.startTime;
      } else if (key === 'duration') {
        _duration = params.duration;
      } else if (key === 'name') {
        _name = params.name;
      } else if (key === 'probability') {
        _probability = params.probability;
      } else if (key === 'image') {
        _image = params.image;
      } else if (key === 'imageIndex') {
        _imageIndex = params.imageIndex;
      } else if (key === 'imageOffset') {
        _imageOffset = params.imageOffset;
      } else if (key === 'file') {
        _file = params.file;
      } else if (key === 'imageRectangle') {
        _imageRectangle = params.imageRectangle;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:name': _name,
          'xmpDM:startTime': _startTime,
          'xmpDM:duration': _duration,
          'xmpDM:probability': _probability,
          'tscDM:image': _image,
          'tscDM:imageindex': _imageIndex,
          'tscDM:imageoffset': _imageOffset,
          'tscDM:imagerect': _imageRectangle ? _imageRectangle.toXmpAtt() : null,
          'tscDM:file': _file
        }
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    startTime: {
      get: function get() {
        return _startTime;
      }
    },
    duration: {
      get: function get() {
        return _duration;
      }
    },
    name: {
      get: function get() {
        return _name;
      }
    },
    probability: {
      get: function get() {
        return _probability;
      }
    },
    image: {
      get: function get() {
        return _image;
      }
    },
    imageIndex: {
      get: function get() {
        return _imageIndex;
      }
    },
    imageOffset: {
      get: function get() {
        return _imageOffset;
      }
    },
    file: {
      get: function get() {
        return _file;
      }
    },
    imageRectangle: {
      get: function get() {
        return _imageRectangle;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      startTime: _startTime,
      duration: _duration,
      name: _name,
      probability: _probability,
      image: _image,
      imageIndex: _imageIndex,
      imageOffset: _imageOffset,
      file: _file,
      imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : undefined
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$c = function createFromXmpElement$c(speechMarkerElement) {
  var params = {
    startTime: Number(speechMarkerElement.getAttribute('xmpDM:startTime')),
    duration: Number(speechMarkerElement.getAttribute('xmpDM:duration')),
    name: speechMarkerElement.getAttribute('xmpDM:name'),
    probability: Number(speechMarkerElement.getAttribute('xmpDM:probability'))
  };

  // optional attributes below

  params.image = speechMarkerElement.getAttribute('tscDM:image') || undefined;
  if (speechMarkerElement.getAttribute('tscDM:imageindex')) {
    params.imageIndex = Number(speechMarkerElement.getAttribute('tscDM:imageindex'));
  }
  if (speechMarkerElement.getAttribute('tscDM:imageoffset')) {
    params.imageOffset = Number(speechMarkerElement.getAttribute('tscDM:imageoffset'));
  }
  params.file = speechMarkerElement.getAttribute('tscDM:file') || undefined;
  if (speechMarkerElement.getAttribute('tscDM:imagerect')) {
    params.imageRectangle = ImageRectangle$1.create(speechMarkerElement.getAttribute('tscDM:imagerect'));
  }
  return new SpeechMarker(params);
};

/** @module SpeechMarker */
var SpeechMarker$1 = {
  /**
   *  Factory method that returns a new SpeechMarker object.
   *  @function create
   *  @param {Object} params - Required params for table of contents item
   *  @param {Number} [params.startTime] - Start time of the speech marker (milliseconds).
   *  @param {Number} [params.duration] - Duration of the speech marker (milliseconds).
   *  @param {String} [params.name] - Speech marker name.
   *  @param {String} [params.image] - Speech marker image.
   *  @param {Number} [params.imageIndex] - Speech marker image index.
   *  @param {Number} [params.imageOffset] - Speech marker image offset.
   *  @param {module:ImageRectangle} [params.imageRectangle] - Speech marker image rectangle.
   *  @static
   *  @return {module:SpeechMarker} new SpeechMarker instance
   */
  create: function create(params) {
    return SpeechMarker(params);
  },
  /**
   *  Factory method that returns a new SpeechMarker object from an XMP speech marker element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP speechMarker element.
   *  @static
   *  @return {module:SpeechMarker} new SpeechMarker instance
   */
  createFromXmpElement: createFromXmpElement$c
};
var SpeechTrack = function SpeechTrack(params) {
  var _markers = [];
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    if (params.hasOwnProperty('markers') && isArray$1(params.markers)) {
      _markers = params.markers;
    } else {
      throw new Error('SpeechTrack params is expecting an object eg. { markers: [marker1Object, ...] }');
    }
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:trackType': 'Speech',
          'xmpDM:trackName': 'Speech to Text',
          'xmpDM:frameRate': 'f1000'
        },
        children: [{
          name: 'xmpDM:markers',
          children: [{
            name: 'rdf:Seq',
            children: _markers
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    markers: {
      get: function get() {
        return _markers;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      markers: invokeMap(_markers, 'toPOJO')
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$d = function createFromXmpElement$d(speechTrackElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var speechTrack = new SpeechTrack();
  if (speechTrackElement) {
    var markerElements = _xmlUtility.getElementsByTagNameNSPrefix(speechTrackElement, 'rdf:li');
    var markers = map(markerElements, SpeechMarker$1.createFromXmpElement);
    var params = {
      markers: markers
    };
    speechTrack = new SpeechTrack(params);
  }
  return speechTrack;
};

/** @module SpeechTrack */
var SpeechTrack$1 = {
  /**
   *  Factory method that returns a new SpeechTrack object.
   *  @function create
   *  @param {Object} params - Optional params for speech track
   *  @param {module:SpeechMarker[]} [params.markers] - Array of speech marker items.
   *  @static
   *  @return {module:SpeechTrack} new SpeechTrack instance
   */
  create: function create(params) {
    return SpeechTrack(params);
  },
  /**
   *  Factory method that returns a new SpeechTrack object from an XMP speech track element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP speech track element.
   *  @static
   *  @return {module:SpeechTrack} new SpeechTrack instance
   */
  createFromXmpElement: createFromXmpElement$d
};
var ScreenTextMarker = function ScreenTextMarker(params) {
  var _name;
  var _startTime;
  var _duration;
  var _tableOfContentsEntry;
  var _image;
  var _imageIndex;
  var _imageOffset;
  var _imageRectangle;
  var _file;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'name') {
        _name = params.name;
      } else if (key === 'startTime') {
        _startTime = params.startTime;
      } else if (key === 'duration') {
        _duration = params.duration;
      } else if (key === 'tableOfContentsEntry') {
        _tableOfContentsEntry = params.tableOfContentsEntry;
      } else if (key === 'image') {
        _image = params.image;
      } else if (key === 'imageIndex') {
        _imageIndex = params.imageIndex;
      } else if (key === 'imageOffset') {
        _imageOffset = params.imageOffset;
      } else if (key === 'imageRectangle') {
        _imageRectangle = params.imageRectangle;
      } else if (key === 'file') {
        _file = params.file;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:name': _name,
          'xmpDM:startTime': _startTime,
          'xmpDM:duration': _duration,
          'tscDM:tocEntry': _tableOfContentsEntry,
          'tscDM:image': _image,
          'tscDM:imageindex': _imageIndex,
          'tscDM:imageoffset': _imageOffset,
          'tscDM:imagerect': _imageRectangle ? _imageRectangle.toXmpAtt() : null,
          'tscDM:file': _file
        }
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    name: {
      get: function get() {
        return _name;
      }
    },
    startTime: {
      get: function get() {
        return _startTime;
      }
    },
    duration: {
      get: function get() {
        return _duration;
      }
    },
    tableOfContentsEntry: {
      get: function get() {
        return _tableOfContentsEntry;
      }
    },
    image: {
      get: function get() {
        return _image;
      }
    },
    imageIndex: {
      get: function get() {
        return _imageIndex;
      }
    },
    imageOffset: {
      get: function get() {
        return _imageOffset;
      }
    },
    imageRectangle: {
      get: function get() {
        return _imageRectangle;
      }
    },
    file: {
      get: function get() {
        return _file;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      name: _name,
      startTime: _startTime,
      duration: _duration,
      tableOfContentsEntry: _tableOfContentsEntry,
      image: _image,
      imageIndex: _imageIndex,
      imageOffset: _imageOffset,
      imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : _imageRectangle,
      file: _file
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$e = function createFromXmpElement$e(screenTextMarkerElement) {
  var params = {
    name: screenTextMarkerElement.getAttribute('xmpDM:name'),
    startTime: Number(screenTextMarkerElement.getAttribute('xmpDM:startTime')),
    duration: Number(screenTextMarkerElement.getAttribute('xmpDM:duration'))
  };

  // optional attributes below

  if (screenTextMarkerElement.getAttribute('tscDM:tocEntry')) {
    params.tableOfContentsEntry = Number(screenTextMarkerElement.getAttribute('tscDM:tocEntry'));
  }
  params.image = screenTextMarkerElement.getAttribute('tscDM:image') || undefined;
  if (screenTextMarkerElement.getAttribute('tscDM:imageindex')) {
    params.imageIndex = Number(screenTextMarkerElement.getAttribute('tscDM:imageindex'));
  }
  if (screenTextMarkerElement.getAttribute('tscDM:imageoffset')) {
    params.imageOffset = Number(screenTextMarkerElement.getAttribute('tscDM:imageoffset'));
  }
  if (screenTextMarkerElement.getAttribute('tscDM:imagerect')) {
    params.imageRectangle = ImageRectangle$1.create(screenTextMarkerElement.getAttribute('tscDM:imagerect'));
  }
  params.file = screenTextMarkerElement.getAttribute('tscDM:file') || undefined;
  return new ScreenTextMarker(params);
};

/** @module ScreenTextMarker */
var ScreenTextMarker$1 = {
  /**
   *  Factory method that returns a new ScreenTextMarker object.
   *  @function create
   *  @param {Object} params - Required params for table of contents item
   *  @param {String} [params.name] - ScreenText marker name.
   *  @param {Number} [params.startTime] - Start time of the screenText marker (milliseconds).
   *  @param {Number} [params.duration] - Duration of the screenText marker (milliseconds).
   *  @param {String} [params.tableOfContentsEntry] - Index of the table of contents entry corresponding to this screen text marker.
   *  @param {String} [params.image] - ScreenText marker image.
   *  @param {Number} [params.imageIndex] - ScreenText marker image index.
   *  @param {Number} [params.imageOffset] - ScreenText marker image offset.
   *  @param {module:ImageRectangle} [params.imageRectangle] - ScreenText marker image rectangle.
   *  @param {String} [params.file] - file associated with ScreenText marker.
   *  @static
   *  @return {module:ScreenTextMarker} new ScreenTextMarker instance
   */
  create: function create(params) {
    return ScreenTextMarker(params);
  },
  /**
   *  Factory method that returns a new ScreenTextMarker object from an XMP screenText marker element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP screenTextMarker element.
   *  @static
   *  @return {module:ScreenTextMarker} new ScreenTextMarker instance
   */
  createFromXmpElement: createFromXmpElement$e
};
var ScreenTextTrack = function ScreenTextTrack(params) {
  var _markers = [];
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    if (params.hasOwnProperty('markers') && isArray$1(params.markers)) {
      _markers = params.markers;
    } else {
      throw new Error('ScreenTextTrack params is expecting an object eg. { markers: [marker1Object, ...] }');
    }
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'rdf:li',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:trackType': 'ScreenText',
          'xmpDM:trackName': 'Screen Text',
          'xmpDM:frameRate': 'f1000'
        },
        children: [{
          name: 'xmpDM:markers',
          children: [{
            name: 'rdf:Seq',
            children: _markers
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    markers: {
      get: function get() {
        return _markers;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      markers: invokeMap(_markers, 'toPOJO')
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    return pojo;
  };
  return _public;
};
var createFromXmpElement$f = function createFromXmpElement$f(screenTextTrackElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var screenTextTrack = new ScreenTextTrack();
  if (screenTextTrackElement) {
    var markerElements = _xmlUtility.getElementsByTagNameNSPrefix(screenTextTrackElement, 'rdf:Description');
    var markers = map(markerElements, ScreenTextMarker$1.createFromXmpElement);
    var params = {
      markers: markers
    };
    screenTextTrack = new ScreenTextTrack(params);
  }
  return screenTextTrack;
};

/** @module ScreenTextTrack */
var ScreenTextTrack$1 = {
  /**
   *  Factory method that returns a new ScreenTextTrack object.
   *  @function create
   *  @param {Object} params - Optional params for screenText track
   *  @param {module:ScreenTextMarker[]} [params.markers] - Array of screenText marker items.
   *  @static
   *  @return {module:ScreenTextTrack} new ScreenTextTrack instance
   */
  create: function create(params) {
    return ScreenTextTrack(params);
  },
  /**
   *  Factory method that returns a new ScreenTextTrack object from an XMP screenText track element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP screenText track element.
   *  @static
   *  @return {module:ScreenTextTrack} new ScreenTextTrack instance
   */
  createFromXmpElement: createFromXmpElement$f
};
var _xmlUtility;
var getXmlUtility = function getXmlUtility() {
  return _xmlUtility || (_xmlUtility = new NamespaceXmlUtility(namespaceResolver));
};
var Controller = function Controller(params) {
  var _name;
  var _parameters;
  var _controllerTextItems;
  var _additionalParamProperties = {};
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'name') {
        _name = params.name;
      } else if (key === 'parameters') {
        _parameters = params.parameters;
      } else if (key === 'controllerTextItems') {
        _controllerTextItems = params.controllerTextItems;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var localizedTextTree = map(_controllerTextItems, function (item) {
      return {
        name: 'rdf:li',
        children: [{
          name: 'rdf:Description',
          atts: {
            'xmp:label': item.label
          },
          children: [{
            name: 'tscDM:localizedText',
            children: [{
              name: 'rdf:Alt',
              children: map(item.localizedTexts, function (localizedText) {
                return {
                  name: 'rdf:li',
                  atts: {
                    'xml:lang': localizedText.lang
                  },
                  text: localizedText.text
                };
              })
            }]
          }]
        }]
      };
    });
    var treeDesc = {
      name: 'tscDM:controller',
      children: [{
        name: 'rdf:Description',
        atts: {
          'xmpDM:name': _name
        },
        children: [{
          name: 'tscDM:parameters',
          children: [{
            name: 'rdf:Bag',
            children: map(_parameters, function (param) {
              return {
                name: 'rdf:li',
                atts: {
                  'xmpDM:name': param.name,
                  'xmpDM:value': param.value
                }
              };
            })
          }]
        }, {
          name: 'tscDM:controllerText',
          children: [{
            name: 'rdf:Bag',
            children: localizedTextTree
          }]
        }]
      }]
    };
    return getXmlUtility().createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    name: {
      get: function get() {
        return _name;
      }
    },
    parameters: {
      get: function get() {
        return _parameters;
      }
    },
    controllerTextItems: {
      get: function get() {
        return _controllerTextItems;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      name: _name,
      parameters: _parameters,
      controllerTextItems: _controllerTextItems
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var parseParameter$1 = function parseParameter$1(parameterElement) {
  return {
    name: parameterElement.getAttribute('xmpDM:name'),
    value: parameterElement.getAttribute('xmpDM:value')
  };
};
var parseParameters$1 = function parseParameters$1(parametersElement) {
  if (parametersElement) {
    var parameterElements = getXmlUtility().getElementsByTagNameNSPrefix(parametersElement, 'rdf:li');
    var parameters = map(parameterElements, parseParameter$1);
    return parameters;
  }
  return undefined;
};
var parseLocalizedTextItem = function parseLocalizedTextItem(textElement) {
  if (textElement) {
    return {
      lang: textElement.getAttribute('xml:lang'),
      text: getXmlUtility().getElementText(textElement)
    };
  }
  return undefined;
};
var parseControllerText = function parseControllerText(controllerTextItemElement) {
  var textElements = getXmlUtility().getElementsByTagNameNSPrefix(controllerTextItemElement, 'rdf:li');
  return {
    label: controllerTextItemElement.getAttribute('xmp:label'),
    localizedTexts: map(textElements, parseLocalizedTextItem)
  };
};
var parseControllerTextItems = function parseControllerTextItems(controllerTextElement) {
  if (controllerTextElement) {
    var controllerTextElements = getXmlUtility().getElementsByTagNameNSPrefix(controllerTextElement, 'rdf:Description');
    var controllerTextItems = map(controllerTextElements, parseControllerText);
    return controllerTextItems;
  }
  return undefined;
};
var createFromXmpElement$g = function createFromXmpElement$g(controllerElement) {
  if (controllerElement) {
    var descriptionElement = getXmlUtility().getFirstElementByTagNameNSPrefix(controllerElement, 'rdf:Description');
    var parametersElement = getXmlUtility().getFirstElementByTagNameNSPrefix(descriptionElement, 'tscDM:parameters');
    var controllerTextElement = getXmlUtility().getFirstElementByTagNameNSPrefix(descriptionElement, 'tscDM:controllerText');
    var params = {
      name: descriptionElement.getAttribute('xmpDM:name'),
      parameters: parseParameters$1(parametersElement),
      controllerTextItems: parseControllerTextItems(controllerTextElement)
    };
    return new Controller(params);
  }
  return undefined;
};

/** @module Controller */
var Controller$1 = {
  /**
   *  Factory method that returns a new Controller object.
   *  @function create
   *  @param {Object} params - Required params for controller
   *  @param {String} [params.name] - Controller label.
   *  @param {Object[]} [params.parameters] - Array of Objects with name and value properties.
   *  @param {Object[]} [params.controllerTextItems] - Array of localized controller text items.
   *  @static
   *  @return {module:Controller} new Controller instance
   */
  create: function create(params) {
    return Controller(params);
  },
  /**
   *  Factory method that returns a new Controller object from an XMP controller element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP controller element.
   *  @static
   *  @return {module:Controller} new Controller instance
   */
  createFromXmpElement: createFromXmpElement$g
};
var ContentList = function ContentList(params) {
  var _items;
  var _additionalParamProperties = {};
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (params) {
    forEach(keys$1(params), function (key) {
      if (key === 'items') {
        _items = params.items;
      } else if (!isFunction(_additionalParamProperties[key])) {
        _additionalParamProperties[key] = params[key];
      }
    });
  }
  var toXmp = function toXmp() {
    var treeDesc = {
      name: 'tscDM:contentList',
      children: [{
        name: 'rdf:Description',
        children: [{
          name: 'tscDM:files',
          children: [{
            name: 'rdf:Seq',
            children: map(_items, function (item) {
              return {
                name: 'rdf:li',
                atts: {
                  'xmpDM:name': item.name,
                  'xmpDM:value': item.value
                }
              };
            })
          }]
        }]
      }]
    };
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var _public = Object.defineProperties({}, {
    items: {
      get: function get() {
        return _items;
      }
    }
  });
  _public.toXmp = toXmp;
  _public.toPOJO = function () {
    var pojo = {
      items: _items
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    forEach(keys$1(_additionalParamProperties), function (key) {
      pojo[key] = _additionalParamProperties[key];
    });
    return pojo;
  };
  return _public;
};
var parseContentListItems = function parseContentListItems(contentListItemElements) {
  if (contentListItemElements) {
    var items = map(contentListItemElements, function (itemElement) {
      return {
        name: itemElement.getAttribute('xmpDM:name'),
        value: itemElement.getAttribute('xmpDM:value')
      };
    });
    return items;
  }
  return undefined;
};
var createFromXmpElement$h = function createFromXmpElement$h(contentListElement) {
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  if (contentListElement) {
    var contentListItemElements = _xmlUtility.getElementsByTagNameNSPrefix(contentListElement, 'rdf:li');
    var params = {
      items: parseContentListItems(contentListItemElements)
    };
    return new ContentList(params);
  }
  return undefined;
};

/** @module ContentList */
var ContentList$1 = {
  /**
   *  Factory method that returns a new ContentList object.
   *  @function create
   *  @param {Object} params - Required params for contentList
   *  @param {Object[]} [params.items] - Array of content list items.
   *  @static
   *  @return {module:ContentList} new ContentList instance
   */
  create: function create(params) {
    return ContentList(params);
  },
  /**
   *  Factory method that returns a new ContentList object from an XMP contentList element.
   *  @function createFromXmpElement
   *  @param {Object} element - XMP contentList element.
   *  @static
   *  @return {module:ContentList} new ContentList instance
   */
  createFromXmpElement: createFromXmpElement$h
};

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
    length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
    length = strSymbols.length;
  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/** Used to compose unicode character classes. */
var rsAstralRange = "\\ud800-\\udfff",
  rsComboMarksRange = "\\u0300-\\u036f",
  reComboHalfMarksRange = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange = "\\u20d0-\\u20ff",
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = "\\ufe0e\\ufe0f";

/** Used to compose unicode capture groups. */
var rsZWJ = "\\u200d";

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/** Used to compose unicode character classes. */
var rsAstralRange$1 = "\\ud800-\\udfff",
  rsComboMarksRange$1 = "\\u0300-\\u036f",
  reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f",
  rsComboSymbolsRange$1 = "\\u20d0-\\u20ff",
  rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
  rsVarRange$1 = "\\ufe0e\\ufe0f";

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']',
  rsCombo = '[' + rsComboRange$1 + ']',
  rsFitz = "\\ud83c[\\udffb-\\udfff]",
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange$1 + ']',
  rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  rsZWJ$1 = "\\u200d";

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange$1 + ']?',
  rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}

/** Used to match leading and trailing whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
    start = charsStartIndex(strSymbols, stringToArray(chars));
  return castSlice(strSymbols, start).join('');
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys$1(object));
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax$2(length + fromIndex, 0);
  }
  return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}
var _parsers = [];
function trimLeadingDot(extension) {
  return trimStart(extension, '.');
}
var registerParser = function registerParser(name, supportedExtensions, parserCreator) {
  _parsers.push({
    name: name,
    extensions: map(supportedExtensions, trimLeadingDot),
    create: parserCreator
  });
};
var resolveParser = function resolveParser(extension) {
  var parser = find(_parsers, function (theParser) {
    return includes(theParser.extensions, trimLeadingDot(extension));
  });
  return parser ? parser.create() : null;
};
var captionParsers = {
  register: registerParser,
  resolveByExtension: resolveParser
};

/**
 *  Factory method that returns a new CaptionText object.
 *  @function importFromFile
 *  @param {module:CaptionController} captionController - CaptionController object
 *  @param {String} fileName - Name of caption file
 *  @param {String} fileContents - Contents of the caption file
 *  @param {String} [languageIdentifierString='en-US'] - RFC 3066 notation language string
 *  @static
 *  @return {boolean} Did import succeed
 */
var importFromFile = function importFromFile(captionController, fileName, fileContents, languageIdentifierString) {
  try {
    var extension = fileName.toLowerCase().split('.').pop();
    var parser = captionParsers.resolveByExtension(extension);
    if (parser) {
      var parsedCaptionTrack = parser.deserialize(fileContents, languageIdentifierString);
      captionController.addCaptionTrack(parsedCaptionTrack);
      return true;
    }
    return false;
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
    return false;
  }
};
var captionImporter = {
  importFromFile: importFromFile
};
var Xmp$1 = function Xmp(xmpXml) {
  var _version;
  var _title;
  var _date;
  var _creator;
  var _presenterEmail;
  var _description;
  var _source;
  var _about;
  var _keywords;
  var _thumbnail;
  var _firstFrame;
  var _project;
  var _originId;
  var _iPodExplicit;
  var _documentId;
  var _duration;
  var _videoFrameSize;
  var _captionController = CaptionController$1$1.create();
  var _hotspotTrack = null;
  var _tableOfContentsTrack = null;
  var _quizTrack = null;
  var _speechTrack = null;
  var _screenTextTrack = null;
  var _controller;
  var _contentList;
  var _languages = [];
  var _containsTocThumbnails = false;
  var _containsToc = false;
  var _containsCaptions = false;
  var _containsHotspots = false;
  var _containsQuiz = false;
  var _containsQuizQuestions = false;
  var _containsScreenText = false;
  var _containsSpeechText = false;
  var _xmlUtility = new NamespaceXmlUtility(namespaceResolver);
  var toXmp = function toXmp() {
    var _captionXmpProvider = _captionController.containsCaptions ? _captionController : null;
    var tracksContainer = filter([_captionXmpProvider, _hotspotTrack, _quizTrack, _screenTextTrack, _speechTrack, _tableOfContentsTrack], function (track) {
      return track !== null;
    });
    var treeDesc = {
      name: 'rdf:Description',
      atts: {
        'tsc:version': _version,
        'dc:title': _title,
        'tscDM:presenteremail': _presenterEmail,
        'dc:source': _source,
        'dc:date': _date,
        'rdf:about': _about,
        'dc:creator': _creator,
        'dc:description': _description,
        'tscDM:keywords': _keywords,
        'tscDM:thumbnail': _thumbnail,
        'tscDM:firstFrame': _firstFrame,
        'tscDM:project': _project,
        'tscDM:originId': _originId,
        'tscDM:iPodExplicit': _iPodExplicit,
        'xmpMM:DocumentID': _documentId
      },
      children: [{
        name: 'xmpDM:Tracks',
        children: [{
          name: 'rdf:Bag',
          children: tracksContainer
        }]
      }, {
        name: 'tscDM:controller',
        children: [_controller]
      }, {
        name: 'tscDM:contentList',
        children: [_contentList]
      }, {
        name: 'tsc:langName',
        children: [{
          name: 'rdf:Bag',
          children: map(_languages, function (language) {
            return {
              name: 'rdf:li',
              atts: {
                'xml:lang': language.langName
              },
              text: language.langValue
            };
          })
        }]
      }, {
        name: 'xmpDM:videoFrameSize',
        atts: {
          'stDim:unit': _videoFrameSize.unit,
          'stDim:w': _videoFrameSize.width,
          'stDim:h': _videoFrameSize.height
        }
      }]
    };
    if (_duration) {
      treeDesc.children.push({
        name: 'xmpDM:duration',
        atts: {
          'xmpDM:scale': _duration.scale,
          'xmpDM:value': _duration.value
        }
      });
    }
    return _xmlUtility.createElementFromObject(treeDesc);
  };
  var toString = function toString() {
    var doc = _xmlUtility.createDocument();
    var nsElement = _xmlUtility.createElementNS(doc, namespaceResolver('x'), 'x', 'xmpmeta');
    forEach(wellKnownNamespaces, function (nsUrl, nsPrefix) {
      if (nsPrefix !== 'xml') {
        nsElement.setAttributeNS('http://www.w3.org/2000/xmlns/', ['xmlns', nsPrefix].join(':'), nsUrl);
      }
    });
    var rdfElement = _xmlUtility.createElementNS(doc, namespaceResolver('rdf'), 'rdf', 'RDF');
    rdfElement.appendChild(toXmp());
    nsElement.appendChild(rdfElement);
    doc.appendChild(nsElement);
    return _xmlUtility.xmlDocToString(doc);
  };
  var _public = Object.defineProperties({}, {
    version: {
      get: function get() {
        return _version;
      }
    },
    title: {
      get: function get() {
        return _title;
      }
    },
    date: {
      get: function get() {
        return _date;
      }
    },
    creator: {
      get: function get() {
        return _creator;
      }
    },
    presenterEmail: {
      get: function get() {
        return _presenterEmail;
      }
    },
    description: {
      get: function get() {
        return _description;
      }
    },
    source: {
      get: function get() {
        return _source;
      }
    },
    about: {
      get: function get() {
        return _about;
      }
    },
    keywords: {
      get: function get() {
        return _keywords;
      }
    },
    thumbnail: {
      get: function get() {
        return _thumbnail;
      }
    },
    firstFrame: {
      get: function get() {
        return _firstFrame;
      }
    },
    project: {
      get: function get() {
        return _project;
      }
    },
    originId: {
      get: function get() {
        return _originId;
      }
    },
    iPodExplicit: {
      get: function get() {
        return _iPodExplicit;
      }
    },
    documentId: {
      get: function get() {
        return _documentId;
      }
    },
    duration: {
      get: function get() {
        return _duration;
      }
    },
    videoFrameSize: {
      get: function get() {
        return _videoFrameSize;
      }
    },
    tocThumbnailImageSrc: {
      get: function get() {
        if (_containsToc && _tableOfContentsTrack.items[0].image !== undefined) {
          return _tableOfContentsTrack.items[0].image;
        } else if (_containsSpeechText && _speechTrack.markers[0].image !== undefined) {
          return _speechTrack.markers[0].image;
        } else if (_containsScreenText && _screenTextTrack.markers[0].image !== undefined) {
          return _screenTextTrack.markers[0].image;
        } else if (_captionController.captionsContainsTocThumbnails) {
          return _captionController.getActiveCaptionsTocThumbnailImage();
        }
        return '';
      }
    },
    containsTocThumbnails: {
      get: function get() {
        return _containsTocThumbnails;
      }
    },
    containsToc: {
      get: function get() {
        return _containsToc;
      }
    },
    containsCaptions: {
      get: function get() {
        return _containsCaptions;
      }
    },
    containsHotspots: {
      get: function get() {
        return _containsHotspots;
      }
    },
    containsQuiz: {
      get: function get() {
        return _containsQuiz;
      }
    },
    containsQuizQuestions: {
      get: function get() {
        return _containsQuizQuestions;
      }
    },
    containsScreenText: {
      get: function get() {
        return _containsScreenText;
      }
    },
    containsSpeechText: {
      get: function get() {
        return _containsSpeechText;
      }
    },
    captionController: {
      get: function get() {
        return _captionController;
      }
    },
    captionTrack: {
      get: function get() {
        return _captionController.activeCaptionTrack;
      }
    },
    hotspotTrack: {
      get: function get() {
        return _hotspotTrack;
      },
      set: function set(value) {
        _hotspotTrack = value;
      }
    },
    tableOfContentsTrack: {
      get: function get() {
        return _tableOfContentsTrack;
      },
      set: function set(value) {
        _tableOfContentsTrack = value;
      }
    },
    quizTrack: {
      get: function get() {
        return _quizTrack;
      },
      set: function set(value) {
        _quizTrack = value;
      }
    },
    speechTrack: {
      get: function get() {
        return _speechTrack;
      }
    },
    screenTextTrack: {
      get: function get() {
        return _screenTextTrack;
      }
    },
    controller: {
      get: function get() {
        return _controller;
      }
    },
    contentList: {
      get: function get() {
        return _contentList;
      }
    }
  });
  var parseLanguageName = function parseLanguageName(languageNameElement) {
    return {
      langName: languageNameElement.getAttribute('xml:lang'),
      langValue: _xmlUtility.getElementText(languageNameElement)
    };
  };
  var parseLanguages = function parseLanguages(langNameElement) {
    if (langNameElement) {
      var languageNameElements = _xmlUtility.getElementsByTagNameNSPrefix(langNameElement, 'rdf:li');
      var languageNames = map(languageNameElements, parseLanguageName);
      return languageNames;
    }
    return null;
  };
  var parseProductionDetails = function parseProductionDetails(doc) {
    var rootDescriptionElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'rdf:Description');
    _version = rootDescriptionElement.getAttribute('tsc:version');
    _title = rootDescriptionElement.getAttribute('dc:title');
    _documentId = rootDescriptionElement.getAttribute('xmpMM:DocumentID');
    var videoFrameSizeElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'xmpDM:videoFrameSize');
    _videoFrameSize = {
      unit: videoFrameSizeElement ? videoFrameSizeElement.getAttribute('stDim:unit') : 'pixel',
      width: videoFrameSizeElement ? Number(videoFrameSizeElement.getAttribute('stDim:w')) : 0,
      height: videoFrameSizeElement ? Number(videoFrameSizeElement.getAttribute('stDim:h')) : 0
    };
    var langNameElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'tsc:langName');
    _languages = parseLanguages(langNameElement);

    // optional attributes below

    _presenterEmail = rootDescriptionElement.getAttribute('tscDM:presenteremail') || undefined;
    _source = rootDescriptionElement.getAttribute('dc:source') || undefined;
    _date = rootDescriptionElement.getAttribute('dc:date') || undefined;
    _about = rootDescriptionElement.getAttribute('rdf:about') || undefined;
    _creator = rootDescriptionElement.getAttribute('dc:creator') || undefined;
    _description = rootDescriptionElement.getAttribute('dc:description') || undefined;
    _keywords = rootDescriptionElement.getAttribute('tscDM:keywords') || undefined;
    _thumbnail = rootDescriptionElement.getAttribute('tscDM:thumbnail') || undefined;
    _firstFrame = rootDescriptionElement.getAttribute('tscDM:firstFrame') || undefined;
    _project = rootDescriptionElement.getAttribute('tscDM:project') || undefined;
    _originId = rootDescriptionElement.getAttribute('tscDM:originId') || undefined;
    _iPodExplicit = rootDescriptionElement.getAttribute('tscDM:iPodExplicit') || undefined;
    var durationElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'xmpDM:duration') || undefined;
    if (durationElement) {
      _duration = {
        scale: durationElement.getAttribute('xmpDM:scale'),
        value: Number(durationElement.getAttribute('xmpDM:value'))
      };
    }
  };
  var getElementForTrackType = function getElementForTrackType(elements, trackType) {
    return find(elements, function (element) {
      return _xmlUtility.hasAttributeWithValue(element, 'xmpDM:trackType', trackType);
    });
  };
  var parseCaptionTrack = function parseCaptionTrack(tracksDescriptionElements) {
    var captionTrackElement = getElementForTrackType(tracksDescriptionElements, 'Caption');
    if (captionTrackElement) {
      _captionController.addCaptionTrackFromXmpElement(captionTrackElement);
    }
  };
  var parseHotspotTrack = function parseHotspotTrack(tracksDescriptionElements) {
    var hotspotTrackElement = getElementForTrackType(tracksDescriptionElements, 'Hotspot');
    if (hotspotTrackElement) {
      return HotspotTrack$1.createFromXmpElement(hotspotTrackElement);
    }
    return null;
  };
  var parseTableOfContentsTrack = function parseTableOfContentsTrack(tracksDescriptionElements) {
    var tableOfContentsTrackElement = getElementForTrackType(tracksDescriptionElements, 'TableOfContents');
    if (tableOfContentsTrackElement) {
      return TableOfContentsTrack$1.createFromXmpElement(tableOfContentsTrackElement);
    }
    return null;
  };
  var parseQuizTrack = function parseQuizTrack(tracksDescriptionElements) {
    var quizTrackElement = getElementForTrackType(tracksDescriptionElements, 'Quiz');
    if (quizTrackElement) {
      return QuizTrack$1.createFromXmpElement(quizTrackElement);
    }
    return null;
  };
  var parseSpeechTrack = function parseSpeechTrack(tracksDescriptionElements) {
    var speechTrackElement = getElementForTrackType(tracksDescriptionElements, 'Speech');
    if (speechTrackElement) {
      return SpeechTrack$1.createFromXmpElement(speechTrackElement);
    }
    return null;
  };
  var parseScreenTextTrack = function parseScreenTextTrack(tracksDescriptionElements) {
    var screenTextTrackElement = getElementForTrackType(tracksDescriptionElements, 'ScreenText');
    if (screenTextTrackElement) {
      return ScreenTextTrack$1.createFromXmpElement(screenTextTrackElement);
    }
    return null;
  };
  var parseTracks = function parseTracks(doc) {
    var tracksElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'xmpDM:Tracks');
    var tracksDescriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(tracksElement, 'rdf:Description');
    parseCaptionTrack(tracksDescriptionElements);
    _hotspotTrack = parseHotspotTrack(tracksDescriptionElements);
    _tableOfContentsTrack = parseTableOfContentsTrack(tracksDescriptionElements);
    _quizTrack = parseQuizTrack(tracksDescriptionElements);
    _speechTrack = parseSpeechTrack(tracksDescriptionElements);
    _screenTextTrack = parseScreenTextTrack(tracksDescriptionElements);
    var controllerElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'tscDM:controller');
    _controller = Controller$1.createFromXmpElement(controllerElement);
    var contentListElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'tscDM:contentList');
    _contentList = ContentList$1.createFromXmpElement(contentListElement);
    recordXmpContentFlags();
  };
  var recordXmpContentFlags = function recordXmpContentFlags() {
    _containsToc = _tableOfContentsTrack !== null && _tableOfContentsTrack.items.length > 0;
    _containsCaptions = _captionController.containsCaptions;
    _containsHotspots = _hotspotTrack !== null && _hotspotTrack.hotspots.length > 0;
    _containsQuiz = _quizTrack !== null;
    _containsQuizQuestions = _quizTrack !== null && _quizTrack.questionSets.length > 0;
    _containsScreenText = _screenTextTrack !== null && _screenTextTrack.markers.length > 0;
    _containsSpeechText = _speechTrack !== null && _speechTrack.markers.length > 0;
    _containsTocThumbnails = _containsToc && _tableOfContentsTrack.items[0].image !== undefined || _containsSpeechText && _speechTrack.markers[0].image !== undefined || _containsScreenText && _screenTextTrack.markers[0].image !== undefined || _captionController.captionsContainsTocThumbnails;
  };
  var importCaptionsFromFile = function importCaptionsFromFile(fileName, fileContents, languageIdentifierString) {
    var importedCaptionTrack = captionImporter.importFromFile(_captionController, fileName, fileContents, languageIdentifierString);
    if (importedCaptionTrack) {
      recordXmpContentFlags();
    }
  };
  var parse = function parse() {
    // current 'parse' does NOT deal with different versions of the TSC-XMP schema, as far as we have tested
    // all existing versions of the schema from 2.0.0 - 2.1.0 will parse using this mechanism, but neither parser
    // nor output formatter attempt to take a 2.0.0 and formally migrate it forward to 2.1.0.  Nor is the 'version'
    // property of the xml doc ever modified during reading a writing of a particular source.  this note is here
    // because will have to deal with versioning someday.  (JMD: 2016-05)
    var doc = _xmlUtility.parseXml(xmpXml);
    parseProductionDetails(doc);
    parseTracks(doc);
  };
  if (xmpXml) {
    parse();
  }
  _public.toXmp = toXmp;
  _public.toString = toString;
  _public.importCaptionsFromFile = importCaptionsFromFile;
  _public.toPOJO = function () {
    var pojo = {
      version: _version,
      title: _title,
      documentId: _documentId,
      languages: _languages,
      videoFrameSize: _videoFrameSize,
      source: _source,
      presenterEmail: _presenterEmail,
      date: _date,
      about: _about,
      creator: _creator,
      description: _description,
      keywords: _keywords,
      thumbnail: _thumbnail,
      firstFrame: _firstFrame,
      project: _project,
      originId: _originId,
      iPodExplicit: _iPodExplicit,
      duration: _duration,
      captionTrack: _captionController.toPOJO(),
      hotspotTrack: _hotspotTrack ? _hotspotTrack.toPOJO() : undefined,
      quizTrack: _quizTrack ? _quizTrack.toPOJO() : undefined,
      speechTrack: _speechTrack ? _speechTrack.toPOJO() : undefined,
      screenTextTrack: _screenTextTrack ? _screenTextTrack.toPOJO() : undefined,
      controller: _controller ? _controller.toPOJO() : undefined,
      contentList: _contentList ? _contentList.toPOJO() : undefined
    };
    var that = this;
    var additionalProperties = reject$1(keys$1(that), function (key) {
      return isFunction(that[key]);
    });
    forEach(additionalProperties, function (key) {
      pojo[key] = that[key];
    });
    return pojo;
  };
  return _public;
};

/** @module Xmp */
var xmp = {
  /**
   *  Factory method that returns a new Xmp object.
   *  @function create
   *  @param {String=} xmpXml - XMP XML string to parse.
   *  @static
   *  @return {module:Xmp} new Xmp instance
   */
  create: function create(xmpXml) {
    return Xmp$1(xmpXml);
  }
};

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$f.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty$c.call(object, key);
}

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

/** Used for built-in method references. */
var arrayProto$2 = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto$2.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;
  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim$1, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
    chrSymbols = stringToArray(chars),
    start = charsStartIndex(strSymbols, chrSymbols),
    end = charsEndIndex(strSymbols, chrSymbols) + 1;
  return castSlice(strSymbols, start, end).join('');
}

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return array && array.length ? array[0] : undefined;
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function (string) {
    string = toString(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
    return chr[methodName]() + trailing;
  };
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
    length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function (value, index, collection) {
    accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray$1(collection) ? arrayReduce : baseReduce,
    initAccum = arguments.length < 3;
  return func(collection, baseIteratee(iteratee), accumulator, initAccum, baseEach);
}

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap();

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function (func, data) {
  metaMap.set(func, data);
  return func;
};

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function () {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0:
        return new Ctor();
      case 1:
        return new Ctor(args[0]);
      case 2:
        return new Ctor(args[0], args[1]);
      case 3:
        return new Ctor(args[0], args[1], args[2]);
      case 4:
        return new Ctor(args[0], args[1], args[2], args[3]);
      case 5:
        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7:
        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
      result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
    Ctor = createCtor(func);
  function wrapper() {
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
    argsLength = args.length,
    holdersLength = holders.length,
    leftIndex = -1,
    leftLength = partials.length,
    rangeLength = nativeMax$3(argsLength - holdersLength, 0),
    result = Array(leftLength + rangeLength),
    isUncurried = !isCurried;
  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$4 = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
    argsLength = args.length,
    holdersIndex = -1,
    holdersLength = holders.length,
    rightIndex = -1,
    rightLength = partials.length,
    rangeLength = nativeMax$4(argsLength - holdersLength, 0),
    result = Array(rangeLength + rightLength),
    isUncurried = !isCurried;
  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
    result = 0;
  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$1 = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH$1;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop$1$1() {
  // No operation performed.
}

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop$1$1 : function (func) {
  return metaMap.get(func);
};

/** Used to lookup unminified function names. */
var realNames = {};

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$g.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = func.name + '',
    array = realNames[result],
    length = hasOwnProperty$d.call(realNames, result) ? array.length : 0;
  while (length--) {
    var data = array[length],
      otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__ = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray$1(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty$e.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
    other = lodash[funcName];
  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
  reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$1 = 1,
  WRAP_BIND_KEY_FLAG = 2,
  WRAP_CURRY_FLAG = 8,
  WRAP_CURRY_RIGHT_FLAG = 16,
  WRAP_PARTIAL_FLAG = 32,
  WRAP_PARTIAL_RIGHT_FLAG = 64,
  WRAP_ARY_FLAG = 128,
  WRAP_REARG_FLAG = 256,
  WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG$1], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function (pair) {
    var value = '_.' + pair[0];
    if (bitmask & pair[1] && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = reference + '';
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$2 = 1,
  WRAP_BIND_KEY_FLAG$1 = 2,
  WRAP_CURRY_BOUND_FLAG = 4,
  WRAP_CURRY_FLAG$1 = 8,
  WRAP_PARTIAL_FLAG$1 = 32,
  WRAP_PARTIAL_RIGHT_FLAG$1 = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG$1,
    newHolders = isCurry ? holders : undefined,
    newHoldersRight = isCurry ? undefined : holders,
    newPartials = isCurry ? partials : undefined,
    newPartialsRight = isCurry ? undefined : partials;
  bitmask |= isCurry ? WRAP_PARTIAL_FLAG$1 : WRAP_PARTIAL_RIGHT_FLAG$1;
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG$1 : WRAP_PARTIAL_FLAG$1);
  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG$2 | WRAP_BIND_KEY_FLAG$1);
  }
  var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
    length = nativeMin$1(indexes.length, arrLength),
    oldArray = copyArray(array);
  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
    length = array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$3 = 1,
  WRAP_BIND_KEY_FLAG$2 = 2,
  WRAP_CURRY_FLAG$2 = 8,
  WRAP_CURRY_RIGHT_FLAG$1 = 16,
  WRAP_ARY_FLAG$1 = 128,
  WRAP_FLIP_FLAG$1 = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG$1,
    isBind = bitmask & WRAP_BIND_FLAG$3,
    isBindKey = bitmask & WRAP_BIND_KEY_FLAG$2,
    isCurried = bitmask & (WRAP_CURRY_FLAG$2 | WRAP_CURRY_RIGHT_FLAG$1),
    isFlip = bitmask & WRAP_FLIP_FLAG$1,
    Ctor = isBindKey ? undefined : createCtor(func);
  function wrapper() {
    var length = arguments.length,
      args = Array(length),
      index = length;
    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
        holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
    }
    var thisBinding = isBind ? thisArg : this,
      fn = isBindKey ? thisBinding[func] : func;
    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);
  function wrapper() {
    var length = arguments.length,
      args = Array(length),
      index = length,
      placeholder = getHolder(wrapper);
    while (index--) {
      args[index] = arguments[index];
    }
    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
    length -= holders.length;
    if (length < arity) {
      return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
    }
    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$4 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG$4,
    Ctor = createCtor(func);
  function wrapper() {
    var argsIndex = -1,
      argsLength = arguments.length,
      leftIndex = -1,
      leftLength = partials.length,
      args = Array(leftLength + argsLength),
      fn = this && this !== root && this instanceof wrapper ? Ctor : func;
    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/** Used as the internal argument placeholder. */
var PLACEHOLDER$1 = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$5 = 1,
  WRAP_BIND_KEY_FLAG$3 = 2,
  WRAP_CURRY_BOUND_FLAG$1 = 4,
  WRAP_CURRY_FLAG$3 = 8,
  WRAP_ARY_FLAG$2 = 128,
  WRAP_REARG_FLAG$1 = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$2 = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
    srcBitmask = source[1],
    newBitmask = bitmask | srcBitmask,
    isCommon = newBitmask < (WRAP_BIND_FLAG$5 | WRAP_BIND_KEY_FLAG$3 | WRAP_ARY_FLAG$2);
  var isCombo = srcBitmask == WRAP_ARY_FLAG$2 && bitmask == WRAP_CURRY_FLAG$3 || srcBitmask == WRAP_ARY_FLAG$2 && bitmask == WRAP_REARG_FLAG$1 && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG$2 | WRAP_REARG_FLAG$1) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG$3;

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG$5) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG$5 ? 0 : WRAP_CURRY_BOUND_FLAG$1;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER$1) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER$1) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG$2) {
    data[8] = data[8] == null ? source[8] : nativeMin$2(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;
  return data;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$6 = 1,
  WRAP_BIND_KEY_FLAG$4 = 2,
  WRAP_CURRY_FLAG$4 = 8,
  WRAP_CURRY_RIGHT_FLAG$2 = 16,
  WRAP_PARTIAL_FLAG$2 = 32,
  WRAP_PARTIAL_RIGHT_FLAG$2 = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$5 = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG$4;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG$2 | WRAP_PARTIAL_RIGHT_FLAG$2);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax$5(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;
  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG$2) {
    var partialsRight = partials,
      holdersRight = holders;
    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);
  var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax$5(newData[9] - length, 0);
  if (!arity && bitmask & (WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2)) {
    bitmask &= ~(WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG$6) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG$4 || bitmask == WRAP_CURRY_RIGHT_FLAG$2) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG$2 || bitmask == (WRAP_BIND_FLAG$6 | WRAP_PARTIAL_FLAG$2)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG$5 = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG$5, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}
var DEFAULT_CAPTION_LANGUAGE_IDENTIFIER_STRING = 'en-US';

// Simple function to convert HH:MM:SS,MMM or HH:MM:SS.MMM to SS.MMM
// Assume valid, returns 0 on error
/* eslint-disable no-magic-numbers, no-mixed-operators */
function toSeconds(timeIn) {
  var t = timeIn.split(':');
  try {
    var s = t[2].split(',');

    // Just in case a . is decimal separator
    if (s.length === 1) {
      s = t[2].split('.');
    }
    return parseFloat(t[0], 10) * 3600 + parseFloat(t[1], 10) * 60 + parseFloat(s[0], 10) + parseFloat(s[1], 10) / 1000;
  } catch (e) {
    return 0;
  }
}
/* eslint-enable no-magic-numbers, no-mixed-operators */

function nextNonEmptyLine(linesArray, position) {
  var idx = position;
  while (!linesArray[idx] && idx < linesArray.length) {
    idx++;
  }
  return idx;
}
function lastNonEmptyLine(linesArray) {
  var idx = linesArray.length - 1;
  while (idx >= 0 && !linesArray[idx]) {
    idx--;
  }
  return idx;
}
function _readCaptionsFromString(input, timeDelimiter, hasIdRow, languageIdentifierString) {
  languageIdentifierString = languageIdentifierString || DEFAULT_CAPTION_LANGUAGE_IDENTIFIER_STRING;
  var captionCollection = CaptionCollection$1.create();
  var i = 0;
  var index = 0;
  var lines;
  var time;
  var text;
  var endIndex;
  var caption;
  var timeSplitRegex = new RegExp('[\\t ]*' + timeDelimiter + '[\\t ]*');
  var SSATagRegex = /\{(\\[\w]+\(?([\w\d]+,?)+\)?)+\}/gi;
  var lessThanRegex = /</g;
  var greaterThanRegex = />/g;
  var newlinePlaceholderRegex = /\\N/gi;

  // Here is where the magic happens
  // Split on line breaks
  lines = input.split(/(?:\r\n|\r|\n)/gm);
  endIndex = lastNonEmptyLine(lines) + 1;
  for (i = 0; i < endIndex; i++) {
    caption = {};
    text = [];
    i = nextNonEmptyLine(lines, i);
    if (hasIdRow) {
      caption.id = parseInt(lines[i++], 10);
    } else {
      caption.id = i;
    }

    // Split on delimiter (often '-->' or ','), trimming spaces as well
    time = lines[i++].split(timeSplitRegex);
    caption.start = toSeconds(time[0]);

    // So as to trim positioning information from end
    index = time[1].indexOf(' ');
    if (index !== -1) {
      time[1] = time[1].substring(0, index);
    }
    caption.end = toSeconds(time[1]);

    // Build single line of text from multi-line subtitle in file
    while (i < endIndex && lines[i]) {
      text.push(lines[i++]);
    }

    // Join into 1 line, SSA-style linebreaks
    // Strip out other SSA-style tags
    caption.text = text.join('\\N').replace(SSATagRegex, '');

    // Escape HTML entities
    caption.text = caption.text.replace(lessThanRegex, '&lt;').replace(greaterThanRegex, '&gt;');

    // Unescape great than and less than when it makes a valid html tag of a supported style (font, b, u, s, i)
    // Modified version of regex from Phil Haack's blog: http://haacked.com/archive/2004/10/25/usingregularexpressionstomatchhtml.aspx
    // Later modified by kev: http://kevin.deldycke.com/2007/03/ultimate-regular-expression-for-html-tag-parsing-with-php/
    //caption.text = caption.text.replace( /&lt;(\/?(font|b|u|i|s))((\s+(\w|\w[\w\-]*\w)(\s*=\s*(?:\".*?\"|'.*?'|[^'\">\s]+))?)+\s*|\s*)(\/?)&gt;/gi, "<$1$3$7>" );
    caption.text = caption.text.replace(newlinePlaceholderRegex, '\n');
    captionCollection.addCaption(Caption$1.create({
      startTime: caption.start * 1000,
      duration: caption.end * 1000 - caption.start * 1000,
      captionTextList: [CaptionText$1.create({
        text: caption.text,
        languageIdentifierString: languageIdentifierString
      })],
      horizontalAlignment: 'Center',
      verticalAlignment: 'Bottom'
    }));
  }
  var captionTrack = CaptionTrack$1.create({
    captions: captionCollection.captions,
    languageIdentifierString: languageIdentifierString
  });
  return captionTrack;
}
function padWithZero(inputNumber, width) {
  inputNumber = inputNumber + '';
  return inputNumber.length >= width ? inputNumber : new Array(width - inputNumber.length + 1).join('0') + inputNumber;
}
function formatMillisecondsToTimeCode(inputMilliseconds, options) {
  var date = new Date(inputMilliseconds);
  var hoursPaddingIsSet = options.hoursPadding || options.hoursPadding === 0;
  var hoursPadding = hoursPaddingIsSet ? options.hoursPadding : 2;
  var hours = padWithZero(date.getUTCHours(), hoursPadding);
  var minutes = padWithZero(date.getUTCMinutes(), 2);
  var seconds = padWithZero(date.getUTCSeconds(), 2);
  var rawMilliseconds = date.getUTCMilliseconds().toFixed(3).split('.')[0]; // eslint-disable-line no-magic-numbers
  var milliseconds = padWithZero(rawMilliseconds, 3); // eslint-disable-line no-magic-numbers

  var millisecondDelimiter = options.millisecondDelimiter ? options.millisecondDelimiter : ',';
  return hours + ':' + minutes + ':' + seconds + millisecondDelimiter + milliseconds;
}
function captionsToString(captionTrack, options) {
  function captionToString(output, caption, index) {
    var isBeginningOfString = index === 0;
    if (!isBeginningOfString) {
      output += '\n\n';
    }
    if (options.hasIdRow) {
      var oneBasedIndex = index + 1;
      output += oneBasedIndex;
      output += '\n';
    }
    output += formatMillisecondsToTimeCode(caption.startTime, options) + options.timeDelimiter + formatMillisecondsToTimeCode(caption.endTime, options);
    output += '\n';
    output += caption.text;
    return output;
  }
  return reduce(captionTrack.captionCollection.captions, captionToString, options.accumulator);
}
var baseNewlineParser = {
  readCaptionsFromStringWithIdRow: function readCaptionsFromStringWithIdRow(input, timeDelimiter, languageIdentifierString) {
    return _readCaptionsFromString(input, timeDelimiter, true, languageIdentifierString);
  },
  readCaptionsFromString: function readCaptionsFromString(input, timeDelimiter, languageIdentifierString) {
    return _readCaptionsFromString(input, timeDelimiter, false, languageIdentifierString);
  },
  captionsToString: captionsToString,
  DEFAULT_CAPTION_LANGUAGE_IDENTIFIER_STRING: DEFAULT_CAPTION_LANGUAGE_IDENTIFIER_STRING
};
var registerParser$1 = function registerParser$1() {
  captionParsers.register('SAMI', ['.sami', '.smi'], function () {
    var _xmlUtility = new XmlUtility();
    function getElementText(textElement) {
      var nonBreakingSpace = String.fromCharCode(0xA0); //eslint-disable-line no-magic-numbers
      var text = _xmlUtility.getElementText(textElement).replace(nonBreakingSpace, ' ');
      return text;
    }
    function getSyncTagText(tag) {
      var textElements = _xmlUtility.getElementsByTagName(tag, 'p');
      if (textElements.length < 1) {
        return getElementText(tag);
      }
      var elementsText = map(textElements, getElementText);
      return join(elementsText, '\n');
    }
    function parseSyncTagToCaption(horizontalAlignment, languageIdentifierString, captionCollection, tag) {
      var startTime = +tag.getAttribute('start');
      var captionText = CaptionText$1.create({
        languageIdentifierString: languageIdentifierString,
        text: getSyncTagText(tag)
      });
      var createParams = {
        startTime: startTime,
        duration: 0,
        captionTextList: [captionText],
        horizontalAlignment: capitalize(horizontalAlignment.toLowerCase()),
        verticalAlignment: 'Bottom'
      };
      captionCollection.addCaption(Caption$1.create(createParams));
      return captionCollection;
    }
    function assignCaptionDurationsByFillingCaptionStartTimeGaps(captionCollection) {
      for (var i = 0; i < captionCollection.captions.length; i++) {
        var currentCaption = captionCollection.captions[i];
        var nextCaption = null;
        if (i + 1 < captionCollection.captions.length) {
          nextCaption = captionCollection.captions[i + 1];
        }
        var defaultDuration = 3000;
        var duration = nextCaption ? nextCaption.startTime - currentCaption.endTime : defaultDuration;
        currentCaption.setDuration(duration);
      }
      return captionCollection;
    }
    function removeHtmlComments(input) {
      return input.replace(/<!--|-->/g, '');
    }
    function cssColorToRGB(cssColorValue) {
      if (!cssColorValue) {
        return null;
      }
      var result = tinycolor$1(cssColorValue);
      if (!result.isValid()) {
        return null;
      }
      return result.toRgb();
    }
    function parseStyle(text) {
      var fontSizeNoDescriptorRegex = /font-size: *(\d+);/g;
      text = text.replace(fontSizeNoDescriptorRegex, 'font-size: $1px;');
      var doc = document.implementation.createHTMLDocument('');
      var styleElement = doc.createElement('style');
      styleElement.textContent = text;
      doc.body.appendChild(styleElement);
      return styleElement.sheet.cssRules;
    }
    function getCaptionTrackCreateParams(xmlDoc) {
      var styleElements = xmlDoc.getElementsByTagName('style');
      if (styleElements.length < 1) {
        return {};
      }
      var styles = parseStyle(removeHtmlComments(styleElements[0].textContent));
      var captionStyle = find(styles, function (s) {
        return s.selectorText.toLowerCase() === 'p';
      });
      captionStyle = captionStyle || head(styles);
      return {
        fgColor: cssColorToRGB(captionStyle.style.color),
        bgColor: cssColorToRGB(captionStyle.style.backgroundColor),
        fontFamily: trim(captionStyle.style.fontFamily, '"\''),
        fontSize: captionStyle.style.fontSize,
        horizontalAlignment: captionStyle.style.textAlign || 'Center'
      };
    }
    function readCaptionsFromString(input, languageIdentifierString) {
      languageIdentifierString = languageIdentifierString || baseNewlineParser.DEFAULT_CAPTION_LANGUAGE_IDENTIFIER_STRING;
      var captionCollection = CaptionCollection$1.create();
      var xmlDoc = _xmlUtility.parseXml(input, 'text/html');
      if (!xmlDoc) {
        throw new Error('xmlDoc is null');
      }
      var syncElements = xmlDoc.getElementsByTagName('sync');
      var createCaptionTrackParams = getCaptionTrackCreateParams(xmlDoc);
      var parseSyncTagToCaptionWithHorizontalAlignment = curry(parseSyncTagToCaption)(createCaptionTrackParams.horizontalAlignment, languageIdentifierString);
      captionCollection = reduce(syncElements, parseSyncTagToCaptionWithHorizontalAlignment, captionCollection);
      captionCollection = assignCaptionDurationsByFillingCaptionStartTimeGaps(captionCollection);
      createCaptionTrackParams.captions = captionCollection.captions;
      createCaptionTrackParams.languageIdentifierString = languageIdentifierString;
      var captionTrack = CaptionTrack$1.create(createCaptionTrackParams);
      return captionTrack;
    }
    function captionToString(output, caption, nextCaption) {
      var text = caption.text;
      if (text) {
        text += '\n';
      }
      output += '<SYNC start="' + caption.startTime + '"><P class="ENCC">' + text + '</P></SYNC>';
      if (nextCaption && nextCaption.startTime > caption.endTime) {
        output += '<SYNC start="' + caption.endTime + '"><P class="ENCC"></P></SYNC>';
      }
      return output;
    }
    function getTextAlignment(captionTrack) {
      var textAlignments = reduce(captionTrack.captionCollection.captions, function (alignments, caption) {
        var alignment = caption.horizontalAlignment;
        if (!alignment || has(alignments, alignment)) {
          return alignments;
        }
        alignments[alignment] = true;
        return alignments;
      }, {});
      var allAlignments = keys$1(textAlignments);
      return allAlignments.length === 1 ? allAlignments[0].toLowerCase() : 'center';
    }
    function captionsToString(captionTrack) {
      var fontSize = isInteger(captionTrack.fontSize) ? captionTrack.fontSize + 'pt' : captionTrack.fontSize;
      var fontFamily = captionTrack.fontFamily;
      var fgHexColor = captionTrack.fgHexColor;
      var bgHexColor = captionTrack.bgHexColor;
      var textAlign = getTextAlignment(captionTrack);

      /* eslint-disable no-tabs */
      var samiCaptionHeader = '<SAMI>' + '<HEAD><TITLE>Captions</TITLE><STYLE TYPE="text/css">' + '<!--' + 'P {	margin-left:  1pt;' + 'margin-right: 1pt;' + 'margin-bottom: 2pt;' + 'margin-top: 2pt;' + 'text-align: ' + textAlign + ';' + 'font-size: ' + fontSize + ';' + 'font-family: ' + fontFamily + ';' + 'font-weight: normal;' + 'font-style: normal;' + 'background-color: ' + bgHexColor + ';' + 'color: ' + fgHexColor + '; }' + '.ENCC {Name: English; lang: en-US; SAMI_Type: CC;}' + '-->' + '</STYLE></HEAD>' + '<BODY>';
      var samiCaptionFooter = '</BODY>' + '</SAMI>';
      /* eslint-enable no-tabs */

      var output = samiCaptionHeader;
      var captionCollection = captionTrack.captionCollection;
      for (var i = 0; i < captionCollection.captions.length; i++) {
        var currentCaption = captionCollection.captions[i];
        var isLastCaption = i === captionCollection.captions.length - 1;
        var nextCaption = isLastCaption ? null : captionCollection.captions[i + 1];
        output = captionToString(output, currentCaption, nextCaption);
      }
      output += samiCaptionFooter;
      return output;
    }
    return {
      deserialize: readCaptionsFromString,
      serialize: captionsToString
    };
  });
};
var samiParser = {
  registerParser: registerParser$1
};
var registerParser$2 = function registerParser$2() {
  captionParsers.register('SBV', ['.sbv'], function () {
    var sbvTimeDelimiter = ',';
    function readCaptionsFromString(input, languageIdentifierString) {
      return baseNewlineParser.readCaptionsFromString(input, sbvTimeDelimiter, languageIdentifierString);
    }
    function captionsToString(captionCollection) {
      return baseNewlineParser.captionsToString(captionCollection, {
        timeDelimiter: sbvTimeDelimiter,
        accumulator: '',
        hoursPadding: 1
      });
    }
    return {
      deserialize: readCaptionsFromString,
      serialize: captionsToString
    };
  });
};
var sbvParser = {
  registerParser: registerParser$2
};
var registerParser$3 = function registerParser$3() {
  captionParsers.register('SRT', ['.srt'], function () {
    var srtEndOfFileMarker = '\n\n\n';
    var srtTimeDelimiter = ' --> ';
    function readCaptionsFromString(input, languageIdentifierString) {
      return baseNewlineParser.readCaptionsFromStringWithIdRow(input, srtTimeDelimiter.trim(), languageIdentifierString);
    }
    function captionsToString(captionCollection) {
      var captionString = baseNewlineParser.captionsToString(captionCollection, {
        timeDelimiter: srtTimeDelimiter,
        accumulator: '\n\n',
        hasIdRow: true
      });
      return captionString + srtEndOfFileMarker;
    }
    return {
      deserialize: readCaptionsFromString,
      serialize: captionsToString
    };
  });
};
var srtParser = {
  registerParser: registerParser$3
};
var registerParser$4 = function registerParser$4() {
  captionParsers.register('TTML', ['.ttml', '.dfxp'], function () {
    // Code below is taken from https://github.com/mozilla/popcorn-js/blob/master/parsers/parserTTML/popcorn.parserTTML.js

    var rWhitespace = /^[\s]+|[\s]+$/gm;
    var rLineBreak = /(?:\r\n|\r|\n)/gm;
    var rBreakTag = /(<br *\/?>)/gm;

    // Parse the children of the given node
    function parseChildren(node, timeOffset, region) {
      var currNode = node.firstChild;
      var currRegion = getNodeRegion(node, region);
      var retVal = [];
      var newOffset;
      while (currNode) {
        if (currNode.nodeType === 1) {
          if (currNode.nodeName === 'p') {
            // p is a textual node, process contents as subtitle
            retVal.push(parseNode(currNode, timeOffset, currRegion));
          } else if (currNode.nodeName === 'div') {
            // div is container for subtitles, recurse
            newOffset = toSeconds(currNode.getAttribute('begin'));
            if (newOffset < 0) {
              newOffset = timeOffset;
            }
            retVal.push.apply(retVal, parseChildren(currNode, newOffset, currRegion));
          }
        }
        currNode = currNode.nextSibling;
      }
      return retVal;
    }

    // Get the "region" attribute of a node, to know where to put the subtitles
    function getNodeRegion(node, defaultTo) {
      var region = node.getAttribute('region');
      if (region !== null) {
        return region;
      }
      return defaultTo || '';
    }

    // Parse a node for text content
    function parseNode(node, timeOffset, region) {
      var sub = {};

      // Trim left and right whitespace from text and convert non-explicit line breaks
      sub.text = (node.textContent || node.text).replace(rWhitespace, '').replace(rLineBreak, '<br />');
      sub.id = node.getAttribute('xml:id') || node.getAttribute('id');
      sub.start = toSeconds(node.getAttribute('begin'), timeOffset);
      sub.end = toSeconds(node.getAttribute('end'), timeOffset);
      sub.target = getNodeRegion(node, region);
      if (sub.end < 0) {
        // No end given, infer duration if possible
        // Otherwise, give end as MAX_VALUE
        sub.end = toSeconds(node.getAttribute('duration'), 0);
        if (sub.end >= 0) {
          sub.end += sub.start;
        } else {
          sub.end = Number.MAX_VALUE;
        }
      }
      return {
        subtitle: sub
      };
    }
    function toTimelineSeconds(timeStr, framerate) {
      // Hours and minutes are optional
      // Seconds must be specified
      // Seconds can be followed by milliseconds OR by the frame information
      var validTimeFormat = /^([0-9]+:){0,2}[0-9]+([.;][0-9]+)?$/;
      var errorMessage = 'Invalid time format';
      var digitPairs;
      var lastIndex;
      var lastPair;
      var firstPair;
      var frameInfo;
      var frameTime;
      if (typeof timeStr === 'number') {
        return timeStr;
      }
      if (typeof timeStr === 'string' && !validTimeFormat.test(timeStr)) {
        throw errorMessage;
      }
      digitPairs = timeStr.split(':');
      lastIndex = digitPairs.length - 1;
      lastPair = digitPairs[lastIndex];

      // Fix last element:
      if (lastPair.indexOf(';') > -1) {
        frameInfo = lastPair.split(';');
        frameTime = 0;
        if (framerate && typeof framerate === 'number') {
          frameTime = parseFloat(frameInfo[1], 10) / framerate;
        }
        digitPairs[lastIndex] = parseInt(frameInfo[0], 10) + frameTime;
      }
      firstPair = digitPairs[0];

      /* eslint-disable no-magic-numbers, no-mixed-operators */
      return {
        1: parseFloat(firstPair, 10),
        2: parseInt(firstPair, 10) * 60 + parseFloat(digitPairs[1], 10),
        3: parseInt(firstPair, 10) * 3600 + parseInt(digitPairs[1], 10) * 60 + parseFloat(digitPairs[2], 10)
      }[digitPairs.length || 1];
      /* eslint-enable no-magic-numbers, no-mixed-operators */
    }

    // Convert time expression to SS.mmm
    // Expression may be absolute to timeline (hh:mm:ss.ms)
    //   or relative ( decimal followed by metric ) ex: 3.4s, 5.7m
    // Returns -1 if invalid
    function toSeconds(timeIn, offset) {
      var i;
      if (!timeIn) {
        return -1;
      }
      try {
        return toTimelineSeconds(timeIn);
      } catch (e) {
        i = getMetricIndex(timeIn);
        return parseFloat(timeIn.substring(0, i)) * getMultipler(timeIn.substring(i)) + (offset || 0);
      }
    }

    // In a time string such as 3.4ms, get the index of the first character (m) of the time metric (ms)
    function getMetricIndex(timeIn) {
      var i = timeIn.length - 1;
      while (i >= 0 && timeIn[i] <= '9' && timeIn[i] >= '0') {
        i--;
      }
      return i;
    }

    // Determine multiplier for metric relative to seconds
    function getMultipler(metric) {
      return {
        h: 3600,
        m: 60,
        s: 1,
        ms: 0.001
      }[metric] || -1;
    }
    function readCaptionsFromString(input, languageIdentifierString) {
      languageIdentifierString = languageIdentifierString || baseNewlineParser.DEFAULT_CAPTION_LANGUAGE_IDENTIFIER_STRING;
      var captionCollection = CaptionCollection$1.create();
      var node;
      var xmlDocument;

      // Null checks
      if (!input) {
        return null;
      }
      input = input.replace(/<head>.*<\/head>/, '');
      input = input.replace(rBreakTag, '\\N');
      var _xmlUtility = new XmlUtility();
      xmlDocument = _xmlUtility.parseXml(input);
      if (!xmlDocument) {
        return captionCollection;
      }
      node = xmlDocument.documentElement.firstChild;

      // Find body tag
      while (node.nodeName !== 'body') {
        node = node.nextSibling;
      }
      if (node) {
        var captions = parseChildren(node, 0);
        map(captions, function (caption) {
          caption = caption.subtitle;
          var createParams = {
            startTime: caption.start * 1000,
            duration: caption.end * 1000 - caption.start * 1000,
            captionTextList: [CaptionText$1.create({
              text: caption.text.replace('\\N', '\n'),
              languageIdentifierString: languageIdentifierString
            })],
            horizontalAlignment: 'Center',
            verticalAlignment: 'Bottom'
          };
          captionCollection.addCaption(Caption$1.create(createParams));
        });
      }
      var captionTrack = CaptionTrack$1.create({
        captions: captionCollection.captions,
        languageIdentifierString: languageIdentifierString
      });
      return captionTrack;
    }
    function captionToString(output, caption, index) {
      var oneBasedIndex = index + 1;
      output += '<p xml:id="subtitle' + oneBasedIndex + '" begin="' + caption.startTime / 1000 + 's" end="' + caption.endTime / 1000 + 's">' + caption.text + '</p>';
      return output;
    }
    function captionsToString(captionTrack) {
      var ttmlHeader = '<?xml version="1.0" encoding="UTF-8"?><tt xmlns:tts="http://www.w3.org/2006/04/ttaf1#styling" xmlns="http://www.w3.org/2006/04/ttaf1">' + '<head>' + '<metadata xmlns:ttm="http://www.w3.org/ns/ttml#metadata"><ttm:title>Captions</ttm:title></metadata>' + '<styling xmlns:tts="http://www.w3.org/ns/ttml#styling"><style xml:id="s1" tts:color="white" tts:fontFamily="proportionalSansSerif" tts:fontSize="22px" tts:textAlign="center" /></styling>' + '<layout xmlns:tts="http://www.w3.org/ns/ttml#styling"><region xml:id="subtitleArea" style="s1" tts:extent="560px 62px" tts:padding="5px 3px" tts:backgroundColor="black" tts:displayAlign="after" /></layout>' + '</head>' + '<body region="subtitleArea">' + '<div>';
      var ttmlFooter = '</div></body></tt>';
      var output = ttmlHeader;
      for (var i = 0; i < captionTrack.captionCollection.captions.length; i++) {
        var currentCaption = captionTrack.captionCollection.captions[i];
        output = captionToString(output, currentCaption, i);
      }
      output += ttmlFooter;
      return output;
    }
    return {
      deserialize: readCaptionsFromString,
      serialize: captionsToString
    };
  });
};
var ttmlParser = {
  registerParser: registerParser$4
};
var registerParser$5 = function registerParser$5() {
  captionParsers.register('VTT', ['.vtt'], function () {
    var vttTimeDelimiter = '-->';

    // [HH:]MM:SS.mmm string to SS.mmm float
    // Throws exception if invalid
    /* eslint-disable no-magic-numbers, no-mixed-operators */
    function toSeconds(timeIn) {
      var t = timeIn.split(':');
      var l = timeIn.length;
      var time;

      // Invalid time string provided
      if (l !== 12 && l !== 9) {
        throw new Error('Bad cue');
      }
      l = t.length - 1;
      try {
        time = parseInt(t[l - 1], 10) * 60 + parseFloat(t[l], 10);

        // Hours were given
        if (l === 2) {
          time += parseInt(t[0], 10) * 3600;
        }
      } catch (e) {
        throw new Error('Bad cue');
      }
      return time;
    }
    /* eslint-enable no-magic-numbers, no-mixed-operators */

    function parseCueHeader(line) {
      var lineSegments;
      var sub = {};
      var rToken = /-->/;
      var rWhitespace = /[\t ]+/;
      if (!line || line.indexOf(vttTimeDelimiter) === -1) {
        throw new Error('Bad cue');
      }
      lineSegments = line.replace(rToken, ' ' + vttTimeDelimiter + ' ').split(rWhitespace);
      if (lineSegments.length < 2) {
        throw new Error('Bad cue');
      }
      sub.id = line;
      sub.start = toSeconds(lineSegments[0]);
      sub.end = toSeconds(lineSegments[2]);
      return sub;
    }
    function skipWhitespace(lines, len, i) {
      while (i < len && !lines[i]) {
        i++;
      }
      return i;
    }
    function skipNonWhitespace(lines, len, i) {
      while (i < len && lines[i]) {
        i++;
      }
      return i;
    }
    function skipToCueHeader(lines, len, i) {
      while (i < len && lines[i].indexOf(vttTimeDelimiter) === -1) {
        i++;
      }
      return i;
    }
    function readCaptionsFromString(input, languageIdentifierString) {
      languageIdentifierString = languageIdentifierString || baseNewlineParser.DEFAULT_CAPTION_LANGUAGE_IDENTIFIER_STRING;
      var captionCollection = CaptionCollection$1.create();
      var i = 0;
      var len = 0;
      var lines;
      var text;
      var sub;
      var newlineRegex = /(?:\r\n|\r|\n)/gm;
      var breakTagRegex = /(<br *\/?>)/gm;

      // Here is where the magic happens
      // Split on line breaks
      lines = input.split(newlineRegex);
      len = lines.length;

      // Check for BOF token
      if (len === 0 || lines[0] !== 'WEBVTT') {
        return captionCollection;
      }
      i++;
      while (i < len) {
        text = [];
        try {
          i = skipWhitespace(lines, len, i);
          i = skipToCueHeader(lines, len, i);
          sub = parseCueHeader(lines[i++]);

          // Build single line of text from multi-line subtitle in file
          while (i < len && lines[i]) {
            text.push(lines[i++]);
          }

          // Join lines together to one and build subtitle text
          sub.text = text.join('\n').replace(breakTagRegex, '\n');
          sub.text = new window.DOMParser().parseFromString(sub.text, 'text/html').documentElement.textContent;
          var createParams = {
            startTime: sub.start * 1000,
            duration: sub.end * 1000 - sub.start * 1000,
            captionTextList: [CaptionText$1.create({
              text: sub.text,
              languageIdentifierString: languageIdentifierString
            })],
            horizontalAlignment: 'Center',
            verticalAlignment: 'Bottom'
          };
          captionCollection.addCaption(Caption$1.create(createParams));
        } catch (e) {
          i = skipNonWhitespace(lines, len, i);
        }
      }
      var captionTrack = CaptionTrack$1.create({
        captions: captionCollection.captions,
        languageIdentifierString: languageIdentifierString
      });
      return captionTrack;
    }
    function captionsToString(captionCollection) {
      var captionString = baseNewlineParser.captionsToString(captionCollection, {
        timeDelimiter: vttTimeDelimiter,
        accumulator: 'WEBVTT\n\n',
        hasIdRow: false,
        millisecondDelimiter: '.'
      });
      return captionString;
    }
    return {
      deserialize: readCaptionsFromString,
      serialize: captionsToString
    };
  });
};
var vttParser = {
  registerParser: registerParser$5
};
samiParser.registerParser();
sbvParser.registerParser();
srtParser.registerParser();
ttmlParser.registerParser();
vttParser.registerParser();

var _registeredExceptionListeners = [];
var _registeredMessageListeners = [];
var removeValueFromArray = function removeValueFromArray(array, value) {
  var index = -1;
  for (var i = 0; i < array.length; i++) {
    if (array[i] === value) {
      index = i;
      break;
    }
  }
  if (index !== -1) {
    array.splice(index, 1);
    return true;
  }
  return false;
};
var log = {
  logException: function logException(error) {
    _registeredExceptionListeners.forEach(function (callback) {
      callback(new Error(error));
    });
  },
  logMessage: function logMessage(message) {
    _registeredMessageListeners.forEach(function (callback) {
      callback(message);
    });
  },
  addEventListener: function addEventListener(type, listener) {
    if (listener && typeof listener === 'function') {
      if (type === 'EXCEPTION') {
        _registeredExceptionListeners.push(listener);
      } else if (type === 'MESSAGE') {
        _registeredMessageListeners.push(listener);
      } else {
        throw new Error('log.js: addEventListener() Type argument was not EXCEPTION or MESSAGE');
      }
    } else {
      throw new Error('log.js: addEventListener() Listener argument was not a function');
    }
  },
  removeEventListener: function removeEventListener(type, listener) {
    var throwError = function throwError() {
      throw new Error('log.js: removeEventListener() ' + listener + ' was not found within the ' + type + ' callbacks.');
    };
    if (type === 'EXCEPTION') {
      if (!removeValueFromArray(_registeredExceptionListeners, listener)) {
        throwError();
      }
    } else if (type === 'MESSAGE') {
      if (!removeValueFromArray(_registeredMessageListeners, listener)) {
        throwError();
      }
    } else {
      throw new Error('log.js: removeEventListener() Type argument was not EXCEPTION or MESSAGE');
    }
  },
  removeAllEventListeners: function removeAllEventListeners() {
    _registeredExceptionListeners = [];
    _registeredMessageListeners = [];
  }
};

var playerStringNames = Object.freeze({
  accessBtnAnswersSubmitted: 'accessBtnAnswersSubmitted',
  accessBtnAudioDescription: 'accessBtnAudioDescription',
  accessBtnClearSearch: 'accessBtnClearSearch',
  accessBtnClickToReplayLink: 'accessBtnClickToReplayLink',
  accessBtnClosedCaption: 'accessBtnClosedCaption',
  accessBtnCorrectOutOf: 'accessBtnCorrectOutOf',
  accessResultsLabelCorrectSuffix: 'accessResultsLabelCorrectSuffix',
  accessResultsLabelIncorrectSuffix: 'accessResultsLabelIncorrectSuffix',
  accessResultsLabelNoResponseSuffix: 'accessResultsLabelNoResponseSuffix',
  accessResultsLabelNoResponseGradedSuffix: 'accessResultsLabelNoResponseGradedSuffix',
  accessBtnFullScreen: 'accessBtnFullScreen',
  accessBtnFullScreenExpand: 'accessBtnFullScreenExpand',
  accessBtnGradedQuestions: 'accessBtnGradedQuestions',
  accessBtnHideAnswer: 'accessBtnHideAnswer',
  accessBtnHideQuiz: 'accessBtnHideQuiz',
  accessBtnPreviousQuestion: 'accessBtnPreviousQuestion',
  accessBtnNextQuestion: 'accessBtnNextQuestion',
  accessBtnNext: 'accessBtnNext',
  accessBtnPip: 'accessBtnPip',
  accessBtnPlay: 'accessBtnPlay',
  accessBtnPrevious: 'accessBtnPrevious',
  accessBtnProgressBar: 'accessBtnProgressBar',
  accessBtnRewind: 'accessBtnRewind',
  accessBtnForward: 'accessBtnForward',
  accessBtnSettings: 'accessBtnSettings',
  accessBtnShowAnswer: 'accessBtnShowAnswer',
  accessBtnShowQuiz: 'accessBtnShowQuiz',
  accessBtnTableOfContents: 'accessBtnTableOfContents',
  accessBtnTakeQuiz: 'accessBtnTakeQuiz',
  accessBtnVolume: 'accessBtnVolume',
  accessBtnWasNotGraded: 'accessBtnWasNotGraded',
  accessBtnWereNotGraded: 'accessBtnWereNotGraded',
  accessListNoSearchResults: 'accessListNoSearchResults',
  accessListSearchResults: 'accessListSearchResults',
  accessListTableOfContents: 'accessListTableOfContents',
  accessQuestionSetConfirmationTitle: 'accessQuestionSetConfirmationTitle',
  accessQuizResults: 'accessQuizResults',
  accessQuestionFeedbackContext: 'accessQuestionFeedbackContext',
  accessTxtVolume: 'accessTxtVolume',
  accessVideoPausedForQuiz: 'accessVideoPausedForQuiz',
  accessQuizHidden: 'accessQuizHidden',
  accessQuizShown: 'accessQuizShown',
  accessProgressBarTimeConjunction: 'accessProgressBarTimeConjunction',
  accessPlayerSettingsClose: 'accessPlayerSettingsClose',
  accessBtnTheaterMode: 'accessBtnTheaterMode',
  accessBtnExitTheaterMode: 'accessBtnExitTheaterMode',
  ccLanguageText: 'ccLanguageText',
  close: 'close',
  mediaNotFound: 'mediaNotFound',
  noWebMSupport: 'noWebMSupport',
  playerRateOptionsText: 'playerRateOptionsText',
  playerRateText: 'playerRateText',
  scormApiNotFoundMessage: 'scormApiNotFoundMessage',
  search: 'search',
  searchDisabledFullScreen: 'searchDisabledFullScreen',
  searchPlaceholder: 'searchPlaceholder',
  txtAnswerQuestion: 'txtAnswerQuestion',
  txtContinue: 'txtContinue',
  txtCorrect: 'txtCorrect',
  txtCorrectAnswer: 'txtCorrectAnswer',
  txtCorrectString: 'txtCorrectString',
  txtHotspot: 'txtHotspot',
  txtHotspotScreenReaderAlert: 'txtHotspotScreenReaderAlert',
  txtHotspotScreenReaderAlertPlural: 'txtHotspotScreenReaderAlertPlural',
  txtIncorrect: 'txtIncorrect',
  txtIncorrectString: 'txtIncorrectString',
  txtJumpToMedia: 'txtJumpToMedia',
  txtJumpToTime: 'txtJumpToTime',
  txtLoaderMessageDefinition: 'txtLoaderMessageDefinition',
  txtNext: 'txtNext',
  txtHideQuiz: 'txtHideQuiz',
  txtOpenLink: 'txtOpenLink',
  txtOpenLinkHeader: 'txtOpenLinkHeader',
  txtOpenLinkSubHeader: 'txtOpenLinkSubHeader',
  txtPrev: 'txtPrev',
  txtQuestionCount: 'txtQuestionCount',
  txtReplayVideo: 'txtReplayVideo',
  txtResults: 'txtResults',
  txtReview: 'txtReview',
  txtReviewAnswer: 'txtReviewAnswer',
  txtSubmit: 'txtSubmit',
  txtSubmittingAnswers: 'txtSubmittingAnswers',
  txtVisitSite: 'txtVisitSite',
  txtYourAnswer: 'txtYourAnswer',
  videoLoading: 'videoLoading',
  videoNotSupported: 'videoNotSupported',
  xmpSecurity: 'xmpSecurity',
  xmpError: 'xmpError',
  confirmOpenUrlModalScreenReaderAlertText: 'confirmOpenUrlModalScreenReaderAlertText',
  confirmOpenUrlConfirmButtonScreenReaderText: 'confirmOpenUrlConfirmButtonScreenReaderText',
  fastForwardDisabledScreenReaderText: 'fastForwardDisabledScreenReaderText',
  scormCompleteVideoLater: 'scormCompleteVideoLater',
  scormCompleteVideo: 'scormCompleteVideo',
  scormExitVideo: 'scormExitVideo',
  scormConfirmCompleteModalText: 'scormConfirmCompleteModalText',
  scormConfirmCompleteModalRestartVideoText: 'scormConfirmCompleteModalRestartVideoText',
  scormConfirmCompleteModalResumeVideoText: 'scormConfirmCompleteModalResumeVideoText',
  scormConfirmCompleteModalFailedToSaveProgressText: 'scormConfirmCompleteModalFailedToSaveProgressText',
  scormConfirmCompleteModalDismissButtonText: 'scormConfirmCompleteModalDismissButtonText',
  scormConfirmCompleteModalDismissButtonScreenReaderText: 'scormConfirmCompleteModalDismissButtonScreenReaderText',
  scormConfirmCompleteModalConfirmButtonText: 'scormConfirmCompleteModalConfirmButtonText',
  scormConfirmCompleteModalConfirmButtonScreenReaderText: 'scormConfirmCompleteModalConfirmButtonScreenReaderText',
  scormSessionEndedText: 'scormSessionEndedText',
  searchOrJumpTo: 'searchOrJumpTo',
  searchTextCleared: 'searchTextCleared',
  searchResultsUpdated: 'searchResultsUpdated',
  tableOfContentsDisplayed: 'tableOfContentsDisplayed',
  tableOfContentsHidden: 'tableOfContentsHidden',
  defaultMediaTitle: 'defaultMediaTitle',
  hideThumbnailDueToQuiz: 'hideThumbnailDueToQuiz',
  defaultFirstChapterName: 'defaultFirstChapterName',
  acknowledgementLinkName: 'acknowledgementLinkName',
  quizAtTimeHeading: 'quizAtTimeHeading'
});

var strings$7 = {};
strings$7[playerStringNames.xmpError] = 'There seems to be a problem accessing certain features of this video. Please contact the video Author.';
strings$7[playerStringNames.xmpSecurity] = 'Certain features in your video are currently disabled due to Local Network Security. These features work correctly when the video is played from a Website or Server.';
strings$7[playerStringNames.videoNotSupported] = 'Your browser cannot play this video.';
strings$7[playerStringNames.noWebMSupport] = 'This browser does not support WebM video.';
strings$7[playerStringNames.search] = 'Search';
strings$7[playerStringNames.searchPlaceholder] = 'Search...';
strings$7[playerStringNames.playerRateText] = 'Playback Speed';
strings$7[playerStringNames.playerRateOptionsText] = {
  0.25: '0.25',
  0.5: '0.5',
  0.75: '0.75',
  1: 'normal',
  1.25: '1.25',
  1.5: '1.5',
  1.75: '1.75',
  2.0: '2.0'
};
strings$7[playerStringNames.ccLanguageText] = 'Closed Captions';
strings$7[playerStringNames.searchDisabledFullScreen] = 'Search is disabled in fullscreen mode.';
strings$7[playerStringNames.mediaNotFound] = 'We\'re sorry, but we are unable to connect to this content. Please try refreshing the page or <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer\' target=\'_blank\'> click here for more help.</a>';
strings$7[playerStringNames.videoLoading] = 'The video is loading.';
strings$7[playerStringNames.close] = 'Close';
strings$7[playerStringNames.txtHotspot] = 'Hotspot';
strings$7[playerStringNames.txtHotspotScreenReaderAlert] = '{{numberOfHotspots}} new Hotspot';
strings$7[playerStringNames.txtHotspotScreenReaderAlertPlural] = '{{numberOfHotspots}} new Hotspots';
strings$7[playerStringNames.txtJumpToMedia] = 'Jump to media';
strings$7[playerStringNames.txtJumpToTime] = 'Jump to time';
strings$7[playerStringNames.txtOpenLink] = 'Open link';
strings$7[playerStringNames.txtOpenLinkHeader] = 'This video would like to send you to:';
strings$7[playerStringNames.txtOpenLinkSubHeader] = '';
strings$7[playerStringNames.txtReview] = 'Replay Last Section';
strings$7[playerStringNames.txtReplayVideo] = 'Replay Video';
strings$7[playerStringNames.txtAnswerQuestion] = 'Take Quiz Now';
strings$7[playerStringNames.txtPrev] = 'Previous';
strings$7[playerStringNames.txtNext] = 'Next';
strings$7[playerStringNames.txtHideQuiz] = 'Hide';
strings$7[playerStringNames.txtSubmit] = 'Submit Answers';
strings$7[playerStringNames.txtSubmittingAnswers] = 'Submitting answers.';
strings$7[playerStringNames.txtContinue] = 'Continue';
strings$7[playerStringNames.txtReviewAnswer] = 'View Answers';
strings$7[playerStringNames.txtLoaderMessageDefinition] = 'The quiz is loading.';
strings$7[playerStringNames.txtQuestionCount] = 'Question {{currentQuestion}} of {{totalQuestions}}';
strings$7[playerStringNames.txtResults] = 'Results: ';
strings$7[playerStringNames.txtCorrectString] = 'Correct';
strings$7[playerStringNames.txtIncorrectString] = 'Incorrect';
strings$7[playerStringNames.txtCorrect] = '{{numberCorrect}} Correct';
strings$7[playerStringNames.txtIncorrect] = '{{numberIncorrect}} Incorrect';
strings$7[playerStringNames.txtYourAnswer] = 'Your answer: ';
strings$7[playerStringNames.txtCorrectAnswer] = 'Correct answer: ';
strings$7[playerStringNames.txtVisitSite] = 'Visit Site';
strings$7[playerStringNames.accessBtnAudioDescription] = 'Audio Description';
strings$7[playerStringNames.accessBtnClearSearch] = 'Clear Search';
strings$7[playerStringNames.accessBtnRewind] = 'Skip back {{duration}} seconds';
strings$7[playerStringNames.accessBtnForward] = 'Skip forward {{duration}} seconds';
strings$7[playerStringNames.accessBtnPlay] = 'Play Video';
strings$7[playerStringNames.accessBtnPrevious] = 'Previous';
strings$7[playerStringNames.accessBtnNext] = 'Next';
strings$7[playerStringNames.accessBtnProgressBar] = 'Progress bar slider';
strings$7[playerStringNames.accessBtnVolume] = 'Mute';
strings$7[playerStringNames.accessTxtVolume] = 'Volume';
strings$7[playerStringNames.accessBtnClosedCaption] = 'Closed Caption';
strings$7[playerStringNames.accessBtnTableOfContents] = 'Show Chapters (T)';
strings$7[playerStringNames.accessBtnSettings] = 'Player Settings';
strings$7[playerStringNames.accessBtnPip] = 'Picture-in-Picture';
strings$7[playerStringNames.accessBtnFullScreen] = 'Full Screen';
strings$7[playerStringNames.accessBtnFullScreenExpand] = 'Open in new tab';
strings$7[playerStringNames.accessBtnTakeQuiz] = 'Click to take the quiz.';
strings$7[playerStringNames.accessBtnShowQuiz] = 'Show Quiz';
strings$7[playerStringNames.accessBtnHideQuiz] = 'Hide Quiz';
strings$7[playerStringNames.accessBtnPreviousQuestion] = 'Previous question';
strings$7[playerStringNames.accessBtnNextQuestion] = 'Next question';
strings$7[playerStringNames.accessQuizHidden] = 'Quiz has been hidden';
strings$7[playerStringNames.accessQuizShown] = 'Quiz is now displayed';
strings$7[playerStringNames.accessBtnShowAnswer] = 'Show Answers';
strings$7[playerStringNames.accessBtnHideAnswer] = 'Hide Answers';
strings$7[playerStringNames.accessBtnAnswersSubmitted] = 'Answers Submitted!';
strings$7[playerStringNames.accessBtnWereNotGraded] = ' were not graded.';
strings$7[playerStringNames.accessBtnWasNotGraded] = ' was not graded.';
strings$7[playerStringNames.accessBtnCorrectOutOf] = ' correct out of ';
strings$7[playerStringNames.accessBtnGradedQuestions] = ' graded questions.';
strings$7[playerStringNames.accessBtnClickToReplayLink] = 'Replay';
strings$7[playerStringNames.accessResultsLabelCorrectSuffix] = 'is correct.';
strings$7[playerStringNames.accessResultsLabelIncorrectSuffix] = 'is incorrect.';
strings$7[playerStringNames.accessResultsLabelNoResponseSuffix] = 'you did not answer this question.';
strings$7[playerStringNames.accessResultsLabelNoResponseGradedSuffix] = 'you did not answer this question and it has been marked incorrect.';
strings$7[playerStringNames.scormApiNotFoundMessage] = 'Unable to locate the LMS\'s API Implementation.\nCommunication with the LMS will not occur.';
strings$7[playerStringNames.accessListTableOfContents] = 'Chapters';
strings$7[playerStringNames.accessListSearchResults] = 'Search results in order of appearance';
strings$7[playerStringNames.accessListNoSearchResults] = 'No results found';
strings$7[playerStringNames.accessQuestionSetConfirmationTitle] = 'Quiz';
strings$7[playerStringNames.accessVideoPausedForQuiz] = 'Video paused for quiz';
strings$7[playerStringNames.accessQuizResults] = 'Quiz results';
strings$7[playerStringNames.accessQuestionFeedbackContext] = 'Question feedback: ';
strings$7[playerStringNames.accessProgressBarTimeConjunction] = ' of ';
strings$7[playerStringNames.accessPlayerSettingsClose] = 'Close Player Settings';
strings$7[playerStringNames.accessBtnTheaterMode] = 'Theater Mode';
strings$7[playerStringNames.accessBtnExitTheaterMode] = 'Default Mode';
strings$7[playerStringNames.confirmOpenUrlModalScreenReaderAlertText] = 'The video would like to open the following url URL_TOKEN.';
strings$7[playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText] = 'Continue to new website';
strings$7[playerStringNames.fastForwardDisabledScreenReaderText] = 'Fast forward has been disabled for this video';
strings$7[playerStringNames.scormCompleteVideoLater] = 'Complete video later';
strings$7[playerStringNames.scormCompleteVideo] = 'Complete video';
strings$7[playerStringNames.scormExitVideo] = 'Exit video';
strings$7[playerStringNames.scormConfirmCompleteModalText] = 'Are you sure you want to exit the video?';
strings$7[playerStringNames.scormConfirmCompleteModalResumeVideoText] = 'The video will resume where you left off next time you open the video.';
strings$7[playerStringNames.scormConfirmCompleteModalRestartVideoText] = 'The video will restart at the beginning the next time. You will lose your current progress.';
strings$7[playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText] = 'There was a problem saving your progress. The video will start from the beginning the next time you watch this video.';
strings$7[playerStringNames.scormConfirmCompleteModalDismissButtonText] = 'Return to video';
strings$7[playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText] = 'Return to video';
strings$7[playerStringNames.scormConfirmCompleteModalConfirmButtonText] = 'Exit video';
strings$7[playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText] = 'Exit video';
strings$7[playerStringNames.scormSessionEndedText] = 'You can close the tab or head back to your course.';
strings$7[playerStringNames.searchOrJumpTo] = 'Search or jump to.';
strings$7[playerStringNames.searchTextCleared] = 'Search text cleared.';
strings$7[playerStringNames.searchResultsUpdated] = 'Search results updated. {{number}} results.';
strings$7[playerStringNames.tableOfContentsDisplayed] = 'Chapters displayed.';
strings$7[playerStringNames.tableOfContentsHidden] = 'Chapters hidden.';
strings$7[playerStringNames.defaultMediaTitle] = 'TechSmith Smart Player';
strings$7[playerStringNames.hideThumbnailDueToQuiz] = 'Take quiz to preview';
strings$7[playerStringNames.quizAtTimeHeading] = 'Quiz at';
strings$7[playerStringNames.defaultFirstChapterName] = 'Intro';
strings$7[playerStringNames.acknowledgementLinkName] = 'Acknowledgements';
var getLanguage$7 = function getLanguage() {
  return languageCodes.ENGLISH;
};
var getReadableTimeByLocale$7 = function getReadableTimeByLocale(hours, minutes, seconds) {
  var timeStringList = [];
  if (hours > 0) {
    var hoursReadableString = hours + ' hour';
    hoursReadableString += hours > 1 ? 's' : '';
    timeStringList.push(hoursReadableString);
  }
  if (minutes > 0) {
    var minutesReadableString = minutes + ' minute';
    minutesReadableString += minutes > 1 ? 's' : '';
    timeStringList.push(minutesReadableString);
  }
  if (seconds > 0) {
    var secondsReadableString = seconds + ' second';
    secondsReadableString += seconds > 1 ? 's' : '';
    timeStringList.push(secondsReadableString);
  }
  return timeStringList.join(' and ');
};
var enUsLocale = Object.defineProperties({
  getReadableTimeByLocale: getReadableTimeByLocale$7
}, {
  language: {
    get: getLanguage$7
  },
  strings: {
    get: function get() {
      return strings$7;
    }
  }
});

var strings$6 = {};
strings$6[playerStringNames.xmpError] = 'Einige Merkmale dieses Videos sind offenbar nicht zugänglich. Bitte setzen Sie sich mit dem Autor des Videos in Verbindung.';
strings$6[playerStringNames.xmpSecurity] = 'Einige Merkmale Ihrem Video sind zurzeit aufgrund der Sicherheitseinstellungen im lokalen Netzwerk deaktiviert. Diese Merkmale funktionieren wie vorgesehen, wenn das Video über eine Website oder einen Server wiedergegeben wird.';
strings$6[playerStringNames.videoNotSupported] = 'Ihr Browser kann dieses Video nicht wiedergeben.';
strings$6[playerStringNames.noWebMSupport] = 'Dieser Browser bietet keine WebM-Video-Unterstützung.';
strings$6[playerStringNames.search] = 'Suchen';
strings$6[playerStringNames.searchPlaceholder] = 'Suchen...';
strings$6[playerStringNames.playerRateText] = 'Wiedergabe-Geschwindigkeit';
strings$6[playerStringNames.playerRateOptionsText] = {
  0.25: '0,25',
  0.5: '0,5',
  0.75: '0,75',
  1: 'normal',
  1.25: '1,25',
  1.5: '1,5',
  1.75: '1,75',
  2.0: '2,0'
};
strings$6[playerStringNames.ccLanguageText] = 'Geschlossene Untertitel';
strings$6[playerStringNames.searchDisabledFullScreen] = 'Die Suche ist im Vollbildmodus deaktiviert.';
strings$6[playerStringNames.mediaNotFound] = 'Leider können wir im Moment keine Verbindung zu diesen Inhalten herstellen. Bitte versuchen Sie die Seite neu zu laden oder <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=deu&os=na&product=smartplayer\' target=\'_blank\'>klicken Sie hier für weitere Hilfe.</a>';
strings$6[playerStringNames.videoLoading] = 'Das Video wird geladen.';
strings$6[playerStringNames.close] = 'Schließen';
strings$6[playerStringNames.txtHotspot] = 'Hotspot';
strings$6[playerStringNames.txtHotspotScreenReaderAlert] = '{{numberOfHotspots}} neuer Hotspot';
strings$6[playerStringNames.txtHotspotScreenReaderAlertPlural] = '{{numberOfHotspots}} neue Hotspots';
strings$6[playerStringNames.txtJumpToMedia] = 'Zu Medien springen';
strings$6[playerStringNames.txtJumpToTime] = 'Zu Zeitpunkt springen';
strings$6[playerStringNames.txtOpenLink] = 'Link öffnen';
strings$6[playerStringNames.txtOpenLinkHeader] = 'Sie werden aus diesem Video an folgende Website weitergeleitet:';
strings$6[playerStringNames.txtOpenLinkSubHeader] = '';
strings$6[playerStringNames.txtReview] = 'Letzten Abschnitt erneut wiedergeben';
strings$6[playerStringNames.txtReplayVideo] = 'Video erneut abspielen';
strings$6[playerStringNames.txtAnswerQuestion] = 'Jetzt am Quiz teilnehmen';
strings$6[playerStringNames.txtPrev] = 'Zurück';
strings$6[playerStringNames.txtNext] = 'Weiter';
strings$6[playerStringNames.txtHideQuiz] = 'Ausblenden';
strings$6[playerStringNames.txtSubmit] = 'Antworten abschicken';
strings$6[playerStringNames.txtSubmittingAnswers] = 'Antwort wird gesendet.';
strings$6[playerStringNames.txtContinue] = 'Fortsetzen';
strings$6[playerStringNames.txtReviewAnswer] = 'Antworten anzeigen';
strings$6[playerStringNames.txtLoaderMessageDefinition] = 'Das Quiz wird geladen.';
strings$6[playerStringNames.txtQuestionCount] = 'Frage {{currentQuestion}} von {{totalQuestions}}';
strings$6[playerStringNames.txtResults] = 'Ergebnisse: ';
strings$6[playerStringNames.txtCorrectString] = 'Richtig';
strings$6[playerStringNames.txtIncorrectString] = 'Falsch';
strings$6[playerStringNames.txtCorrect] = '{{numberCorrect}} Richtig';
strings$6[playerStringNames.txtIncorrect] = '{{numberIncorrect}} Falsch';
strings$6[playerStringNames.txtYourAnswer] = 'Ihre Antwort: ';
strings$6[playerStringNames.txtCorrectAnswer] = 'Richtige Antwort: ';
strings$6[playerStringNames.txtVisitSite] = 'Website besuchen';
strings$6[playerStringNames.accessBtnAudioDescription] = 'Audio-Beschreibung';
strings$6[playerStringNames.accessBtnClearSearch] = 'Suche löschen';
strings$6[playerStringNames.accessBtnRewind] = '{{duration}} Sekunden zurück';
strings$6[playerStringNames.accessBtnForward] = '{{duration}} Sekunden vor';
strings$6[playerStringNames.accessBtnPlay] = 'Video wiedergeben';
strings$6[playerStringNames.accessBtnPrevious] = 'Zurück';
strings$6[playerStringNames.accessBtnNext] = 'Weiter';
strings$6[playerStringNames.accessBtnProgressBar] = 'Fortschrittsbalken';
strings$6[playerStringNames.accessBtnVolume] = 'Stumm';
strings$6[playerStringNames.accessTxtVolume] = 'Volumen';
strings$6[playerStringNames.accessBtnClosedCaption] = 'Geschlossene Beschriftung';
strings$6[playerStringNames.accessBtnTableOfContents] = 'Kapitel anzeigen (T)';
strings$6[playerStringNames.accessBtnSettings] = 'Einstellungen';
strings$6[playerStringNames.accessBtnPip] = 'PIP';
strings$6[playerStringNames.accessBtnFullScreen] = 'Vollbild';
strings$6[playerStringNames.accessBtnFullScreenExpand] = 'In neuem Tab öffnen';
strings$6[playerStringNames.accessBtnTakeQuiz] = 'Klicken Sie hier, um die Quizfragen zu beantworten.';
strings$6[playerStringNames.accessBtnShowQuiz] = 'Quiz anzeigen';
strings$6[playerStringNames.accessBtnHideQuiz] = 'Quiz ausblenden';
strings$6[playerStringNames.accessBtnPreviousQuestion] = 'Vorherige Frage';
strings$6[playerStringNames.accessBtnNextQuestion] = 'Nächste Frage';
strings$6[playerStringNames.accessQuizHidden] = 'Quiz wurde ausgeblendet';
strings$6[playerStringNames.accessQuizShown] = 'Quiz wird jetzt angezeigt';
strings$6[playerStringNames.accessBtnShowAnswer] = 'Antworten anzeigen';
strings$6[playerStringNames.accessBtnHideAnswer] = 'Antworten ausblenden';
strings$6[playerStringNames.accessBtnAnswersSubmitted] = 'Antworten wurden übermittelt!';
strings$6[playerStringNames.accessBtnWereNotGraded] = ' wurden nicht bewertet.';
strings$6[playerStringNames.accessBtnWasNotGraded] = ' wurden nicht bewertet.';
strings$6[playerStringNames.accessBtnCorrectOutOf] = ' korrekte Antworten von ';
strings$6[playerStringNames.accessBtnGradedQuestions] = ' bewerteten Antworten.';
strings$6[playerStringNames.accessBtnClickToReplayLink] = 'Wiederholen';
strings$6[playerStringNames.accessResultsLabelCorrectSuffix] = 'ist richtig.';
strings$6[playerStringNames.accessResultsLabelIncorrectSuffix] = 'ist falsch.';
strings$6[playerStringNames.accessResultsLabelNoResponseSuffix] = 'Sie haben diese Frage nicht beantwortet.';
strings$6[playerStringNames.accessResultsLabelNoResponseGradedSuffix] = 'Sie haben diese Frage nicht beantwortet und sie wurde als falsch markiert.';
strings$6[playerStringNames.accessBtnTheaterMode] = 'Theatermodus';
strings$6[playerStringNames.accessBtnExitTheaterMode] = 'Standardmodus';
strings$6[playerStringNames.scormApiNotFoundMessage] = 'Die API-Implementierung des LMS-Systems kann nicht gefunden werden.\nDie Kommunikation mit dem LMS-System kann nicht hergestellt werden.';
strings$6[playerStringNames.accessListTableOfContents] = 'Kapitel';
strings$6[playerStringNames.accessListSearchResults] = 'Suchergebnisse nach Zeitpunkt der Anzeige';
strings$6[playerStringNames.accessListNoSearchResults] = 'Keine Ergebnisse gefunden';
strings$6[playerStringNames.accessQuestionSetConfirmationTitle] = 'Quiz';
strings$6[playerStringNames.accessVideoPausedForQuiz] = 'Video wird angehalten - es folgt ein Quiz';
strings$6[playerStringNames.accessQuizResults] = 'Quizergebnisse';
strings$6[playerStringNames.accessQuestionFeedbackContext] = 'Feedback zur Frage: ';
strings$6[playerStringNames.accessProgressBarTimeConjunction] = ' von ';
strings$6[playerStringNames.accessPlayerSettingsClose] = 'SmartPlayer-Einstellungen schließen';
strings$6[playerStringNames.confirmOpenUrlModalScreenReaderAlertText] = 'Das Video leitet auf den folgenden Link weiter URL_TOKEN:';
strings$6[playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText] = 'Weiter zur neuen Website';
strings$6[playerStringNames.fastForwardDisabledScreenReaderText] = 'Der Schnellvorlauf wurde für dieses Video deaktiviert.';
strings$6[playerStringNames.scormCompleteVideoLater] = 'Video später abschließen';
strings$6[playerStringNames.scormCompleteVideo] = 'Abgeschlossenes Video';
strings$6[playerStringNames.scormExitVideo] = 'Video beenden';
strings$6[playerStringNames.scormConfirmCompleteModalText] = 'Wollen Sie das Video wirklich beenden?';
strings$6[playerStringNames.scormConfirmCompleteModalResumeVideoText] = 'Das Video wird beim nächsten Öffnen dort fortgesetzt, wo Sie es angehalten haben.';
strings$6[playerStringNames.scormConfirmCompleteModalRestartVideoText] = 'Das Video wird beim nächsten Mal von Beginn an abgespielt. Ihr bisheriger Fortschritt geht verloren.';
strings$6[playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText] = 'Beim Speichern Ihres Fortschritts ist ein Problem aufgetreten. Das Video beginnt von Anfang an, wenn Sie es das nächste Mal abspielen.';
strings$6[playerStringNames.scormConfirmCompleteModalDismissButtonText] = 'Zurück zum Video';
strings$6[playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText] = 'Zurück zum Video';
strings$6[playerStringNames.scormConfirmCompleteModalConfirmButtonText] = 'Video beenden';
strings$6[playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText] = 'Video beenden';
strings$6[playerStringNames.scormSessionEndedText] = 'Sie können die Registerkarte schließen oder zu Ihrem Kurs zurückkehren.';
strings$6[playerStringNames.searchOrJumpTo] = 'Suchen oder springen zu.';
strings$6[playerStringNames.searchTextCleared] = 'Suchtext gelöscht.';
strings$6[playerStringNames.searchResultsUpdated] = 'Suchergebnisse aktualisiert. {{number}} Ergebnisse.';
strings$6[playerStringNames.tableOfContentsDisplayed] = 'Kapitel werden angezeigt.';
strings$6[playerStringNames.tableOfContentsHidden] = 'Kapitel sind ausgeblendet.';
strings$6[playerStringNames.defaultMediaTitle] = 'TechSmith Smart Player';
strings$6[playerStringNames.hideThumbnailDueToQuiz] = 'Lösen Sie das Quiz, um die Vorschau anzuzeigen';
strings$6[playerStringNames.quizAtTimeHeading] = 'Quizfrage bei';
strings$6[playerStringNames.defaultFirstChapterName] = 'Einleitung';
strings$6[playerStringNames.acknowledgementLinkName] = 'Lizenzhinweise';
var getLanguage$6 = function getLanguage() {
  return languageCodes.GERMAN;
};
var getReadableTimeByLocale$6 = function getReadableTimeByLocale(hours, minutes, seconds) {
  var timeStringList = [];
  if (hours > 0) {
    var hoursReadableString = hours + ' Stunde';
    hoursReadableString += hours > 1 ? 'n' : '';
    timeStringList.push(hoursReadableString);
  }
  if (minutes > 0) {
    var minutesReadableString = minutes + ' Minute';
    minutesReadableString += minutes > 1 ? 'n' : '';
    timeStringList.push(minutesReadableString);
  }
  if (seconds > 0) {
    var secondsReadableString = seconds + ' Sekunde';
    secondsReadableString += seconds > 1 ? 'n' : '';
    timeStringList.push(secondsReadableString);
  }
  return timeStringList.join(' und ');
};
var deDeLocale = Object.defineProperties({
  getReadableTimeByLocale: getReadableTimeByLocale$6
}, {
  language: {
    get: getLanguage$6
  },
  strings: {
    get: function get() {
      return strings$6;
    }
  }
});

var strings$5 = {};
strings$5[playerStringNames.xmpError] = 'このビデオの特定機能にアクセスする時に問題が発生したようです。ビデオの作成者に連絡してください。';
strings$5[playerStringNames.xmpSecurity] = 'ローカル ネットワークのセキュリティのために、ビデオの特定機能が現在無効になっています。これらの機能は、Web サイトまたはサーバーからビデオを再生すると正しく動作します。';
strings$5[playerStringNames.videoNotSupported] = 'お使いのブラウザではこのビデオを再生できません。';
strings$5[playerStringNames.noWebMSupport] = 'このブラウザは WebM ビデオをサポートしていません。';
strings$5[playerStringNames.search] = '検索';
strings$5[playerStringNames.searchPlaceholder] = '検索...';
strings$5[playerStringNames.playerRateText] = '再生速度';
strings$5[playerStringNames.playerRateOptionsText] = {
  0.25: '0.25',
  0.5: '0.5',
  0.75: '0.75',
  1: '標準',
  1.25: '1.25',
  1.5: '1.5',
  1.75: '1.75',
  2.0: '2.0'
};
strings$5[playerStringNames.ccLanguageText] = 'クローズド キャプション';
strings$5[playerStringNames.searchDisabledFullScreen] = 'フル画面モードでは検索機能は無効です。';
strings$5[playerStringNames.mediaNotFound] = '申し訳ありません。このコンテンツに接続できません。ページを再読み込みするか、<a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=jpn&os=na&product=smartplayer\' target=\'_blank\'>ここをクリックしてヘルプをご参照ください。</a>';
strings$5[playerStringNames.videoLoading] = 'ビデオを読み込んでいます。';
strings$5[playerStringNames.close] = '閉じる';
strings$5[playerStringNames.txtHotspot] = 'ホットスポット';
strings$5[playerStringNames.txtHotspotScreenReaderAlert] = '{{numberOfHotspots}} 個の新しいホットスポット';
strings$5[playerStringNames.txtHotspotScreenReaderAlertPlural] = '{{numberOfHotspots}} 個の新しいホットスポット';
strings$5[playerStringNames.txtJumpToMedia] = 'メディアへジャンプ';
strings$5[playerStringNames.txtJumpToTime] = '時間へジャンプ';
strings$5[playerStringNames.txtOpenLink] = 'リンクを開く';
strings$5[playerStringNames.txtOpenLinkHeader] = 'このビデオは次の';
strings$5[playerStringNames.txtOpenLinkSubHeader] = 'を開こうとしています。';
strings$5[playerStringNames.txtReview] = '最後に選択した範囲をもう一度再生';
strings$5[playerStringNames.txtReplayVideo] = 'ビデオをもう一度再生';
strings$5[playerStringNames.txtAnswerQuestion] = '今すぐクイズに解答する';
strings$5[playerStringNames.txtPrev] = '前へ';
strings$5[playerStringNames.txtNext] = '次へ';
strings$5[playerStringNames.txtHideQuiz] = '非表示';
strings$5[playerStringNames.txtSubmit] = '解答・回答の送信';
strings$5[playerStringNames.txtSubmittingAnswers] = '回答を送信中です。';
strings$5[playerStringNames.txtContinue] = '続行';
strings$5[playerStringNames.txtReviewAnswer] = '解答・回答を表示';
strings$5[playerStringNames.txtLoaderMessageDefinition] = 'クイズを読み込んでいます。';
strings$5[playerStringNames.txtQuestionCount] = '問 {{currentQuestion}} ({{totalQuestions}} 問中)';
strings$5[playerStringNames.txtResults] = '結果: ';
strings$5[playerStringNames.txtCorrectString] = '正解';
strings$5[playerStringNames.txtIncorrectString] = '不正解';
strings$5[playerStringNames.txtCorrect] = '正解 {{numberCorrect}}';
strings$5[playerStringNames.txtIncorrect] = '不正解 {{numberIncorrect}}';
strings$5[playerStringNames.txtYourAnswer] = '解答/回答: ';
strings$5[playerStringNames.txtCorrectAnswer] = '正解: ';
strings$5[playerStringNames.txtVisitSite] = 'サイトを開く';
strings$5[playerStringNames.accessBtnAudioDescription] = '音声ガイド';
strings$5[playerStringNames.accessBtnClearSearch] = '検索をクリア';
strings$5[playerStringNames.accessBtnRewind] = '{{duration}} 秒戻します';
strings$5[playerStringNames.accessBtnForward] = '{{duration}} 秒送ります';
strings$5[playerStringNames.accessBtnPlay] = 'ビデオを再生する';
strings$5[playerStringNames.accessBtnPrevious] = '前へ';
strings$5[playerStringNames.accessBtnNext] = '次へ';
strings$5[playerStringNames.accessBtnProgressBar] = '進行状況バー スライダー';
strings$5[playerStringNames.accessBtnVolume] = 'ミュート';
strings$5[playerStringNames.accessTxtVolume] = '音量';
strings$5[playerStringNames.accessBtnClosedCaption] = 'クローズド キャプション';
strings$5[playerStringNames.accessBtnTableOfContents] = 'チャプターを表示(T)';
strings$5[playerStringNames.accessBtnSettings] = 'プレーヤー設定';
strings$5[playerStringNames.accessBtnPip] = 'Picture-In-Picture';
strings$5[playerStringNames.accessBtnFullScreen] = '全画面';
strings$5[playerStringNames.accessBtnFullScreenExpand] = '新しいタブで開く';
strings$5[playerStringNames.accessBtnTakeQuiz] = 'クリックしてクイズに答える。';
strings$5[playerStringNames.accessBtnShowQuiz] = 'クイズの表示';
strings$5[playerStringNames.accessBtnHideQuiz] = 'クイズの非表示';
strings$5[playerStringNames.accessBtnPreviousQuestion] = '前の問題';
strings$5[playerStringNames.accessBtnNextQuestion] = '次の問題';
strings$5[playerStringNames.accessQuizHidden] = 'クイズが非表示になりました';
strings$5[playerStringNames.accessQuizShown] = 'クイズが表示されました';
strings$5[playerStringNames.accessBtnShowAnswer] = '解答・回答の表示';
strings$5[playerStringNames.accessBtnHideAnswer] = '解答・回答の非表示';
strings$5[playerStringNames.accessBtnAnswersSubmitted] = '解答・回答を送信しました!';
strings$5[playerStringNames.accessBtnWereNotGraded] = ' スコアに含まれない質問。';
strings$5[playerStringNames.accessBtnWasNotGraded] = ' スコアに含まれない質問。';
strings$5[playerStringNames.accessBtnCorrectOutOf] = ' 問中 ';
strings$5[playerStringNames.accessBtnGradedQuestions] = ' スコアに含まれる質問。';
strings$5[playerStringNames.accessBtnClickToReplayLink] = '再生';
strings$5[playerStringNames.accessResultsLabelCorrectSuffix] = 'は正解です。';
strings$5[playerStringNames.accessResultsLabelIncorrectSuffix] = 'は不正解です。';
strings$5[playerStringNames.accessResultsLabelNoResponseSuffix] = 'この問題に答えていません。';
strings$5[playerStringNames.accessResultsLabelNoResponseGradedSuffix] = 'この問題に答えていないため、不正解と判定されました。';
strings$5[playerStringNames.scormApiNotFoundMessage] = 'LMS の API 実装が見つかりません\nLMS とコミュニケーションできません';
strings$5[playerStringNames.accessListTableOfContents] = 'チャプター';
strings$5[playerStringNames.accessListSearchResults] = '検索結果 (出現順)';
strings$5[playerStringNames.accessListNoSearchResults] = '結果が見つかりません';
strings$5[playerStringNames.accessQuestionSetConfirmationTitle] = 'クイズ';
strings$5[playerStringNames.accessVideoPausedForQuiz] = 'クイズの場所でビデオを一時停止しました';
strings$5[playerStringNames.accessQuizResults] = 'クイズの結果';
strings$5[playerStringNames.accessQuestionFeedbackContext] = '問題のフィードバック: ';
strings$5[playerStringNames.accessProgressBarTimeConjunction] = '/';
strings$5[playerStringNames.accessPlayerSettingsClose] = 'Player の設定を閉じる';
strings$5[playerStringNames.accessBtnTheaterMode] = 'シアター モード';
strings$5[playerStringNames.accessBtnExitTheaterMode] = 'デフォルト モード';
strings$5[playerStringNames.confirmOpenUrlModalScreenReaderAlertText] = 'ビデオは次の URL URL_TOKEN を開こうとしています。';
strings$5[playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText] = '新しい Web サイトに進む';
strings$5[playerStringNames.fastForwardDisabledScreenReaderText] = 'このビデオでは早送りが無効になっています';
strings$5[playerStringNames.scormCompleteVideoLater] = '後でビデオを完成させる';
strings$5[playerStringNames.scormCompleteVideo] = 'ビデオを完成させる';
strings$5[playerStringNames.scormExitVideo] = 'ビデオを閉じる';
strings$5[playerStringNames.scormConfirmCompleteModalText] = 'ビデオを閉じますか?';
strings$5[playerStringNames.scormConfirmCompleteModalResumeVideoText] = '次に開いたとき、ビデオは閉じた場所から再開されます。';
strings$5[playerStringNames.scormConfirmCompleteModalRestartVideoText] = '次に開いたとき、ビデオは先頭から再開されます。現在の進行状況は失われます。';
strings$5[playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText] = '進行状況を保存する際に問題がありました。次にこのビデオを見るとき、ビデオは先頭から再生されます。';
strings$5[playerStringNames.scormConfirmCompleteModalDismissButtonText] = 'ビデオに戻る';
strings$5[playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText] = 'ビデオに戻る';
strings$5[playerStringNames.scormConfirmCompleteModalConfirmButtonText] = 'ビデオを閉じる';
strings$5[playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText] = 'ビデオを閉じる';
strings$5[playerStringNames.scormSessionEndedText] = 'タブを閉じるか、コースに戻ることができます。';
strings$5[playerStringNames.searchOrJumpTo] = '検索するかジャンプ先を指定してください。';
strings$5[playerStringNames.searchTextCleared] = '検索文字をクリアしました。';
strings$5[playerStringNames.searchResultsUpdated] = '検索結果を更新しました。結果は {{number}} 件です。';
strings$5[playerStringNames.tableOfContentsDisplayed] = 'チャプターが表示されました。';
strings$5[playerStringNames.tableOfContentsHidden] = 'チャプターが非表示になりました。';
strings$5[playerStringNames.defaultMediaTitle] = 'TechSmith Smart Player';
strings$5[playerStringNames.hideThumbnailDueToQuiz] = 'プレビューするにはクイズに答えてください';
strings$5[playerStringNames.quizAtTimeHeading] = 'クイズ:';
strings$5[playerStringNames.defaultFirstChapterName] = 'イントロ';
strings$5[playerStringNames.acknowledgementLinkName] = '謝辞';
var getLanguage$5 = function getLanguage() {
  return languageCodes.JAPANESE;
};
var getReadableTimeByLocale$5 = function getReadableTimeByLocale(hours, minutes, seconds) {
  var timeStringList = [];
  if (hours > 0) {
    var hoursReadableString = hours + '時間';
    timeStringList.push(hoursReadableString);
  }
  if (minutes > 0) {
    var minutesReadableString = minutes + '分1';
    timeStringList.push(minutesReadableString);
  }
  if (seconds > 0) {
    var secondsReadableString = seconds + '秒';
    timeStringList.push(secondsReadableString);
  }
  return timeStringList.join('');
};
var jaJpLocale = Object.defineProperties({
  getReadableTimeByLocale: getReadableTimeByLocale$5
}, {
  language: {
    get: getLanguage$5
  },
  strings: {
    get: function get() {
      return strings$5;
    }
  }
});

var strings$4 = {};
strings$4[playerStringNames.xmpError] = 'Il semblerait qu\'il y ait un problème pour accéder à certaines fonctionnalités de cette vidéo. Veuillez contacter l\'auteur de la vidéo.';
strings$4[playerStringNames.xmpSecurity] = 'Certaines fonctionnalités de votre vidéo sont actuellement désactivées pour des raisons de sécurité du réseau local. Elles fonctionnent correctement lorsque la vidéo est lue à partir d\'un site Web ou d\'un serveur.';
strings$4[playerStringNames.videoNotSupported] = 'Votre navigateur ne peut pas lire cette vidéo.';
strings$4[playerStringNames.noWebMSupport] = 'Ce navigateur ne prend pas en charge la vidéo WebM.';
strings$4[playerStringNames.search] = 'Rechercher';
strings$4[playerStringNames.searchPlaceholder] = 'Rechercher...';
strings$4[playerStringNames.playerRateText] = 'Vitesse de lecture';
strings$4[playerStringNames.playerRateOptionsText] = {
  0.25: '0,25',
  0.5: '0,5',
  0.75: '0,75',
  1: 'normale',
  1.25: '1,25',
  1.5: '1,5',
  1.75: '1,75',
  2.0: '2,0'
};
strings$4[playerStringNames.ccLanguageText] = 'Sous-titres activables';
strings$4[playerStringNames.searchDisabledFullScreen] = 'La recherche est désactivée en mode Plein écran.';
strings$4[playerStringNames.mediaNotFound] = 'Nous sommes désolés, nous n\'avons pas pu établir de connexion avec ce contenu. Essayez d\'actualiser la page ou <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer\' target=\'_blank\'>cliquez ici pour obtenir de l\'aide.</a>';
strings$4[playerStringNames.videoLoading] = 'La vidéo est en cours de chargement.';
strings$4[playerStringNames.close] = 'Fermer';
strings$4[playerStringNames.txtHotspot] = 'Zone dynamique';
strings$4[playerStringNames.txtHotspotScreenReaderAlert] = '{{numberOfHotspots}} nouvelle zone interactive';
strings$4[playerStringNames.txtHotspotScreenReaderAlertPlural] = '{{numberOfHotspots}} nouvelles zones interactives';
strings$4[playerStringNames.txtJumpToMedia] = 'Atteindre un élément multimédia';
strings$4[playerStringNames.txtJumpToTime] = 'Atteindre une heure';
strings$4[playerStringNames.txtOpenLink] = 'Ouvrir le lien';
strings$4[playerStringNames.txtOpenLinkHeader] = 'Cette vidéo souhaite vous renvoyer vers :';
strings$4[playerStringNames.txtOpenLinkSubHeader] = '';
strings$4[playerStringNames.txtReview] = 'Revoir la dernière section';
strings$4[playerStringNames.txtReplayVideo] = 'Revoir la vidéo';
strings$4[playerStringNames.txtAnswerQuestion] = 'Répondre au questionnaire';
strings$4[playerStringNames.txtPrev] = 'Précédent';
strings$4[playerStringNames.txtNext] = 'Suivant';
strings$4[playerStringNames.txtHideQuiz] = 'Masquer';
strings$4[playerStringNames.txtSubmit] = 'Envoyer les réponses';
strings$4[playerStringNames.txtSubmittingAnswers] = 'Envoi des réponses en cours.';
strings$4[playerStringNames.txtContinue] = 'Continuer';
strings$4[playerStringNames.txtReviewAnswer] = 'Afficher les réponses';
strings$4[playerStringNames.txtLoaderMessageDefinition] = 'Le questionnaire est en cours de chargement.';
strings$4[playerStringNames.txtQuestionCount] = 'Question {{currentQuestion}} sur {{totalQuestions}}';
strings$4[playerStringNames.txtResults] = 'Résultats : ';
strings$4[playerStringNames.txtCorrectString] = 'Correct';
strings$4[playerStringNames.txtIncorrectString] = 'Incorrect';
strings$4[playerStringNames.txtCorrect] = '{{numberCorrect}} Correct';
strings$4[playerStringNames.txtIncorrect] = '{{numberIncorrect}} Incorrect';
strings$4[playerStringNames.txtYourAnswer] = 'Votre réponse : ';
strings$4[playerStringNames.txtCorrectAnswer] = 'Réponse correcte : ';
strings$4[playerStringNames.txtVisitSite] = 'Consulter le site';
strings$4[playerStringNames.accessBtnAudioDescription] = 'Description audio';
strings$4[playerStringNames.accessBtnClearSearch] = 'Effacer la recherche';
strings$4[playerStringNames.accessBtnRewind] = 'Reculer de {{duration}} secondes';
strings$4[playerStringNames.accessBtnForward] = 'Avancer de {{duration}} secondes';
strings$4[playerStringNames.accessBtnPlay] = 'Lire la vidéo';
strings$4[playerStringNames.accessBtnPrevious] = 'Précédent';
strings$4[playerStringNames.accessBtnNext] = 'Suivant';
strings$4[playerStringNames.accessBtnProgressBar] = 'Curseur de progression';
strings$4[playerStringNames.accessBtnVolume] = 'Désactiver le son';
strings$4[playerStringNames.accessTxtVolume] = 'Volume';
strings$4[playerStringNames.accessBtnClosedCaption] = 'Sous-titre activable';
strings$4[playerStringNames.accessBtnTableOfContents] = 'Afficher les chapitres (T)';
strings$4[playerStringNames.accessBtnSettings] = 'Paramètres du Player';
strings$4[playerStringNames.accessBtnPip] = 'Incrustation d’images';
strings$4[playerStringNames.accessBtnFullScreen] = 'Plein écran';
strings$4[playerStringNames.accessBtnFullScreenExpand] = 'Ouvrir dans un nouvel onglet';
strings$4[playerStringNames.accessBtnTakeQuiz] = 'Cliquez pour répondre au questionnaire.';
strings$4[playerStringNames.accessBtnShowQuiz] = 'Afficher le questionnaire';
strings$4[playerStringNames.accessBtnHideQuiz] = 'Masquer le questionnaire';
strings$4[playerStringNames.accessBtnPreviousQuestion] = 'Question précédente';
strings$4[playerStringNames.accessBtnNextQuestion] = 'Question suivante';
strings$4[playerStringNames.accessQuizHidden] = 'Le questionnaire a été masqué';
strings$4[playerStringNames.accessQuizShown] = 'Le questionnaire est maintenant affiché';
strings$4[playerStringNames.accessBtnShowAnswer] = 'Afficher les réponses';
strings$4[playerStringNames.accessBtnHideAnswer] = 'Masquer les réponses';
strings$4[playerStringNames.accessBtnAnswersSubmitted] = 'Réponses envoyées.';
strings$4[playerStringNames.accessBtnWereNotGraded] = ' n\'ont pas été notées.';
strings$4[playerStringNames.accessBtnWasNotGraded] = ' n\'a pas été notée.';
strings$4[playerStringNames.accessBtnCorrectOutOf] = ' « Correct » sur ';
strings$4[playerStringNames.accessBtnGradedQuestions] = ' questions notées.';
strings$4[playerStringNames.accessBtnClickToReplayLink] = 'Relire';
strings$4[playerStringNames.accessResultsLabelCorrectSuffix] = 'est correcte.';
strings$4[playerStringNames.accessResultsLabelIncorrectSuffix] = 'est incorrecte.';
strings$4[playerStringNames.accessResultsLabelNoResponseSuffix] = 'vous n’avez pas répondu à cette question.';
strings$4[playerStringNames.accessResultsLabelNoResponseGradedSuffix] = 'vous n’avez pas répondu à cette question, qui a été marquée comme incorrecte.';
strings$4[playerStringNames.scormApiNotFoundMessage] = 'Impossible de localiser l\'implémentation API du LMS.\nLa communication avec le LMS sera impossible.';
strings$4[playerStringNames.accessListTableOfContents] = 'Chapitres';
strings$4[playerStringNames.accessListSearchResults] = 'Résultats de la recherche par ordre d\'affichage';
strings$4[playerStringNames.accessListNoSearchResults] = 'Aucun résultat';
strings$4[playerStringNames.accessQuestionSetConfirmationTitle] = 'Questionnaire';
strings$4[playerStringNames.accessVideoPausedForQuiz] = 'Vidéo sur pause pour le questionnaire';
strings$4[playerStringNames.accessQuizResults] = 'Résultats du questionnaire';
strings$4[playerStringNames.accessQuestionFeedbackContext] = 'Commentaires sur la question : ';
strings$4[playerStringNames.accessProgressBarTimeConjunction] = ' sur ';
strings$4[playerStringNames.accessPlayerSettingsClose] = 'Fermer les paramètres du Player';
strings$4[playerStringNames.accessBtnTheaterMode] = 'Mode cinéma';
strings$4[playerStringNames.accessBtnExitTheaterMode] = 'Mode standard';
strings$4[playerStringNames.confirmOpenUrlModalScreenReaderAlertText] = 'La vidéo tente d’ouvrir l’URL suivante URL_TOKEN.';
strings$4[playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText] = 'Continuer vers l’autre site Web';
strings$4[playerStringNames.fastForwardDisabledScreenReaderText] = 'L’avance rapide est désactivée pour cette vidéo';
strings$4[playerStringNames.scormCompleteVideoLater] = 'Terminer la vidéo plus tard';
strings$4[playerStringNames.scormCompleteVideo] = 'Terminer la vidéo';
strings$4[playerStringNames.scormExitVideo] = 'Quitter la vidéo';
strings$4[playerStringNames.scormConfirmCompleteModalText] = 'Voulez-vous vraiment quitter cette vidéo ?';
strings$4[playerStringNames.scormConfirmCompleteModalResumeVideoText] = 'Elle reprendra au même endroit la prochaine fois que vous la visionnerez.';
strings$4[playerStringNames.scormConfirmCompleteModalRestartVideoText] = 'Elle reprendra au début la prochaine fois que vous la visionnerez. Tout progrès sera perdu.';
strings$4[playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText] = 'Un problème est survenu lors de l’enregistrement de la progression. La lecture reprendra au début la prochaine fois que vous regarderez cette vidéo.';
strings$4[playerStringNames.scormConfirmCompleteModalDismissButtonText] = 'Revenir à la vidéo';
strings$4[playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText] = 'Revenir à la vidéo';
strings$4[playerStringNames.scormConfirmCompleteModalConfirmButtonText] = 'Quitter la vidéo';
strings$4[playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText] = 'Quitter la vidéo';
strings$4[playerStringNames.scormSessionEndedText] = 'Vous pouvez fermer l’onglet ou revenir à votre cours.';
strings$4[playerStringNames.searchOrJumpTo] = 'Rechercher ou accéder à un élément.';
strings$4[playerStringNames.searchTextCleared] = 'Texte de recherche supprimé.';
strings$4[playerStringNames.searchResultsUpdated] = 'Résultats de recherche mis à jour. {{number}} résultats.';
strings$4[playerStringNames.tableOfContentsDisplayed] = 'Chapitres affichés.';
strings$4[playerStringNames.tableOfContentsHidden] = 'Chapitres masqués.';
strings$4[playerStringNames.defaultMediaTitle] = 'TechSmith Smart Player';
strings$4[playerStringNames.hideThumbnailDueToQuiz] = 'Répondez au questionnaire pour afficher l’aperçu';
strings$4[playerStringNames.quizAtTimeHeading] = 'Questionnaire situé à';
strings$4[playerStringNames.defaultFirstChapterName] = 'introduction';
strings$4[playerStringNames.acknowledgementLinkName] = 'Crédits';
var getLanguage$4 = function getLanguage() {
  return languageCodes.FRENCH;
};
var getReadableTimeByLocale$4 = function getReadableTimeByLocale(hours, minutes, seconds) {
  var timeStringList = [];
  if (hours > 0) {
    var hoursReadableString = hours + ' heure';
    hoursReadableString += hours > 1 ? 's' : '';
    timeStringList.push(hoursReadableString);
  }
  if (minutes > 0) {
    var minutesReadableString = minutes + ' minute';
    minutesReadableString += minutes > 1 ? 's' : '';
    timeStringList.push(minutesReadableString);
  }
  if (seconds > 0) {
    var secondsReadableString = seconds + ' seconde';
    secondsReadableString += seconds > 1 ? 's' : '';
    timeStringList.push(secondsReadableString);
  }
  return timeStringList.join(' et ');
};
var frFrLocale = Object.defineProperties({
  getReadableTimeByLocale: getReadableTimeByLocale$4
}, {
  language: {
    get: getLanguage$4
  },
  strings: {
    get: function get() {
      return strings$4;
    }
  }
});

var strings$3 = {};
strings$3[playerStringNames.xmpError] = 'Parece que hay problemas para acceder a determinadas funciones de este vídeo. Póngase en contacto con el autor.';
strings$3[playerStringNames.xmpSecurity] = 'Actualmente determinadas funciones del vídeo están desactivadas debido a la configuración de seguridad de la red local. Funcionarán correctamente cuando el vídeo se reproduzca desde un sitio web o un servidor.';
strings$3[playerStringNames.videoNotSupported] = 'Su explorador no puede reproducir este vídeo.';
strings$3[playerStringNames.noWebMSupport] = 'Este explorador no admite vídeo WebM.';
strings$3[playerStringNames.search] = 'Buscar';
strings$3[playerStringNames.searchPlaceholder] = 'Buscar...';
strings$3[playerStringNames.playerRateText] = 'Velocidad de reproducción';
strings$3[playerStringNames.playerRateOptionsText] = {
  0.25: '0,25',
  0.5: '0,5',
  0.75: '0,75',
  1: 'normal',
  1.25: '1,25',
  1.5: '1,5',
  1.75: '1,75',
  2.0: '2,0'
};
strings$3[playerStringNames.ccLanguageText] = 'Subtítulos';
strings$3[playerStringNames.searchDisabledFullScreen] = 'La función Buscar está desactivada en el modo de pantalla completa.';
strings$3[playerStringNames.mediaNotFound] = 'Lo lamentamos, pero no hemos podido conectarnos a este contenido. Pruebe a actualizar la página o <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer\' target=\'_blank\'> pulse aquí para obtener ayuda.</a>';
strings$3[playerStringNames.videoLoading] = 'El vídeo se está cargando.';
strings$3[playerStringNames.close] = 'Cerrar';
strings$3[playerStringNames.txtHotspot] = 'Zona activa';
strings$3[playerStringNames.txtHotspotScreenReaderAlert] = '{{numberOfHotspots}} zona activa nueva';
strings$3[playerStringNames.txtHotspotScreenReaderAlertPlural] = '{{numberOfHotspots}} zonas activas nuevas';
strings$3[playerStringNames.txtJumpToMedia] = 'Saltar al medio';
strings$3[playerStringNames.txtJumpToTime] = 'Saltar al tiempo';
strings$3[playerStringNames.txtOpenLink] = 'Abrir vínculo';
strings$3[playerStringNames.txtOpenLinkHeader] = 'Este vídeo quiere enviarte a:';
strings$3[playerStringNames.txtOpenLinkSubHeader] = '';
strings$3[playerStringNames.txtReview] = 'Reproducir última sección';
strings$3[playerStringNames.txtReplayVideo] = 'Volver a ver';
strings$3[playerStringNames.txtAnswerQuestion] = 'Responder al cuestionario ahora';
strings$3[playerStringNames.txtPrev] = 'Anterior';
strings$3[playerStringNames.txtNext] = 'Siguiente';
strings$3[playerStringNames.txtHideQuiz] = 'Ocultar';
strings$3[playerStringNames.txtSubmit] = 'Enviar respuestas';
strings$3[playerStringNames.txtSubmittingAnswers] = 'Enviando respuestas.';
strings$3[playerStringNames.txtContinue] = 'Continuar';
strings$3[playerStringNames.txtReviewAnswer] = 'Ver respuestas';
strings$3[playerStringNames.txtLoaderMessageDefinition] = 'El cuestionario se está cargando.';
strings$3[playerStringNames.txtQuestionCount] = 'Pregunta {{currentQuestion}} de {{totalQuestions}}';
strings$3[playerStringNames.txtResults] = 'Resultados: ';
strings$3[playerStringNames.txtCorrectString] = 'Correcto';
strings$3[playerStringNames.txtIncorrectString] = 'Incorrecto';
strings$3[playerStringNames.txtCorrect] = '{{numberCorrect}} respuestas correctas';
strings$3[playerStringNames.txtIncorrect] = '{{numberIncorrect}} respuestas incorrectas';
strings$3[playerStringNames.txtYourAnswer] = 'Su respuesta: ';
strings$3[playerStringNames.txtCorrectAnswer] = 'Respuesta correcta: ';
strings$3[playerStringNames.txtVisitSite] = 'Visitar el sitio';
strings$3[playerStringNames.accessBtnAudioDescription] = 'Descripción de audio';
strings$3[playerStringNames.accessBtnClearSearch] = 'Borrar búsqueda';
strings$3[playerStringNames.accessBtnRewind] = 'Retroceder {{duration}} segundos';
strings$3[playerStringNames.accessBtnForward] = 'Avanzar {{duration}} segundos';
strings$3[playerStringNames.accessBtnPlay] = 'Reproducir vídeo';
strings$3[playerStringNames.accessBtnPrevious] = 'Anterior';
strings$3[playerStringNames.accessBtnNext] = 'Siguiente';
strings$3[playerStringNames.accessBtnProgressBar] = 'Control de barra de progreso';
strings$3[playerStringNames.accessBtnVolume] = 'Silencio';
strings$3[playerStringNames.accessTxtVolume] = 'Volumen';
strings$3[playerStringNames.accessBtnClosedCaption] = 'Subtítulo';
strings$3[playerStringNames.accessBtnTableOfContents] = 'Mostrar capítulos (T)';
strings$3[playerStringNames.accessBtnSettings] = 'Ajustes del reproductor';
strings$3[playerStringNames.accessBtnPip] = 'Imagen dentro de imagen';
strings$3[playerStringNames.accessBtnFullScreen] = 'Pantalla completa';
strings$3[playerStringNames.accessBtnFullScreenExpand] = 'Abrir en una nueva pestaña';
strings$3[playerStringNames.accessBtnTakeQuiz] = 'Pulse para responder al cuestionario.';
strings$3[playerStringNames.accessBtnShowQuiz] = 'Mostrar cuestionario';
strings$3[playerStringNames.accessBtnHideQuiz] = 'Ocultar cuestionario';
strings$3[playerStringNames.accessBtnPreviousQuestion] = 'Pregunta anterior';
strings$3[playerStringNames.accessBtnNextQuestion] = 'Pregunta siguiente';
strings$3[playerStringNames.accessQuizHidden] = 'El cuestionario se ha ocultado';
strings$3[playerStringNames.accessQuizShown] = 'El cuestionario se muestra ahora';
strings$3[playerStringNames.accessBtnShowAnswer] = 'Mostrar respuestas';
strings$3[playerStringNames.accessBtnHideAnswer] = 'Ocultar respuestas';
strings$3[playerStringNames.accessBtnAnswersSubmitted] = '¡Respuestas enviadas!';
strings$3[playerStringNames.accessBtnWereNotGraded] = ' no han sido calificadas.';
strings$3[playerStringNames.accessBtnWasNotGraded] = ' no ha sido calificada.';
strings$3[playerStringNames.accessBtnCorrectOutOf] = ' correcta(s) de ';
strings$3[playerStringNames.accessBtnGradedQuestions] = ' preguntas calificadas.';
strings$3[playerStringNames.accessBtnClickToReplayLink] = 'Reproducir';
strings$3[playerStringNames.accessResultsLabelCorrectSuffix] = 'es correcto.';
strings$3[playerStringNames.accessResultsLabelIncorrectSuffix] = 'es incorrecto.';
strings$3[playerStringNames.accessResultsLabelNoResponseSuffix] = 'no respondiste a esta pregunta.';
strings$3[playerStringNames.accessResultsLabelNoResponseGradedSuffix] = 'no respondiste a esta pregunta y se ha marcado como incorrecta.';
strings$3[playerStringNames.scormApiNotFoundMessage] = 'No es posible localizar la implementación de la API de LMS.\nNo se establecerá ninguna conexión con LMS.';
strings$3[playerStringNames.accessListTableOfContents] = 'Capítulos';
strings$3[playerStringNames.accessListSearchResults] = 'Resultados de la búsqueda en orden de aparición';
strings$3[playerStringNames.accessListNoSearchResults] = 'No se encontró ningún resultado';
strings$3[playerStringNames.accessQuestionSetConfirmationTitle] = 'Cuestionario';
strings$3[playerStringNames.accessVideoPausedForQuiz] = 'Vídeo en pausa para el cuestionario';
strings$3[playerStringNames.accessQuizResults] = 'Resultados del cuestionario';
strings$3[playerStringNames.accessQuestionFeedbackContext] = 'Comentarios de la pregunta: ';
strings$3[playerStringNames.accessProgressBarTimeConjunction] = ' de ';
strings$3[playerStringNames.accessPlayerSettingsClose] = 'Cerrar ajustes del reproductor';
strings$3[playerStringNames.accessBtnTheaterMode] = 'Modo de pantalla completa';
strings$3[playerStringNames.accessBtnExitTheaterMode] = 'Modo predeterminado';
strings$3[playerStringNames.confirmOpenUrlModalScreenReaderAlertText] = 'El vídeo quiere abrir la siguiente dirección url URL_TOKEN.';
strings$3[playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText] = 'Continuar al nuevo sitio web';
strings$3[playerStringNames.fastForwardDisabledScreenReaderText] = 'Se ha desactivado el avance rápido en este vídeo';
strings$3[playerStringNames.scormCompleteVideoLater] = 'Terminar el vídeo más tarde';
strings$3[playerStringNames.scormCompleteVideo] = 'Terminar el vídeo';
strings$3[playerStringNames.scormExitVideo] = 'Salir del vídeo';
strings$3[playerStringNames.scormConfirmCompleteModalText] = '¿Seguro que quieres salir del vídeo?';
strings$3[playerStringNames.scormConfirmCompleteModalResumeVideoText] = 'La próxima vez que lo abras, el vídeo se reanudará en el punto en que lo dejaste.';
strings$3[playerStringNames.scormConfirmCompleteModalRestartVideoText] = 'La próxima vez que lo abras, el vídeo se volverá a reproducir desde el principio. No se conservará el progreso actual.';
strings$3[playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText] = 'Ha habido un problema al guardar tu progreso. El vídeo comenzará desde el principio la próxima vez que lo veas.';
strings$3[playerStringNames.scormConfirmCompleteModalDismissButtonText] = 'Volver al vídeo';
strings$3[playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText] = 'Volver al vídeo';
strings$3[playerStringNames.scormConfirmCompleteModalConfirmButtonText] = 'Salir del vídeo';
strings$3[playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText] = 'Salir del vídeo';
strings$3[playerStringNames.scormSessionEndedText] = 'Puedes cerrar la pestaña o volver al curso.';
strings$3[playerStringNames.searchOrJumpTo] = 'Buscar o acceder.';
strings$3[playerStringNames.searchTextCleared] = 'Texto de búsqueda borrado.';
strings$3[playerStringNames.searchResultsUpdated] = 'Resultados de búsqueda actualizados. {{number}} resultados.';
strings$3[playerStringNames.tableOfContentsDisplayed] = 'Capítulos mostrados.';
strings$3[playerStringNames.tableOfContentsHidden] = 'Capítulos ocultos.';
strings$3[playerStringNames.defaultMediaTitle] = 'TechSmith Smart Player';
strings$3[playerStringNames.hideThumbnailDueToQuiz] = 'Responder el cuestionario para ver vista previa';
strings$3[playerStringNames.quizAtTimeHeading] = 'Cuestionario en';
strings$3[playerStringNames.defaultFirstChapterName] = 'introducción';
strings$3[playerStringNames.acknowledgementLinkName] = 'Agradecimientos';
var getLanguage$3 = function getLanguage() {
  return languageCodes.SPANISH;
};
var getReadableTimeByLocale$3 = function getReadableTimeByLocale(hours, minutes, seconds) {
  var timeStringList = [];
  if (hours > 0) {
    var hoursReadableString = hours + ' hora';
    hoursReadableString += hours > 1 ? 's' : '';
    timeStringList.push(hoursReadableString);
  }
  if (minutes > 0) {
    var minutesReadableString = minutes + ' minuto';
    minutesReadableString += minutes > 1 ? 's' : '';
    timeStringList.push(minutesReadableString);
  }
  if (seconds > 0) {
    var secondsReadableString = seconds + ' segundo';
    secondsReadableString += seconds > 1 ? 's' : '';
    timeStringList.push(secondsReadableString);
  }
  return timeStringList.join(' y ');
};
var esEsLocale = Object.defineProperties({
  getReadableTimeByLocale: getReadableTimeByLocale$3
}, {
  language: {
    get: getLanguage$3
  },
  strings: {
    get: function get() {
      return strings$3;
    }
  }
});

var strings$2 = {};
strings$2[playerStringNames.xmpError] = '访问此视频的某些功能似乎存在问题。请联系视频作者。';
strings$2[playerStringNames.xmpSecurity] = '由于本地网络安全，您视频中的某些功能当前已被禁用。从网站或服务器播放此视频时，这些功能正常工作。';
strings$2[playerStringNames.videoNotSupported] = '您的浏览器无法播放此视频。';
strings$2[playerStringNames.noWebMSupport] = '此浏览器不支持 WebM 视频。';
strings$2[playerStringNames.search] = '搜索';
strings$2[playerStringNames.searchPlaceholder] = '搜索...';
strings$2[playerStringNames.playerRateText] = '播放速度';
strings$2[playerStringNames.playerRateOptionsText] = {
  0.25: '0.25',
  0.5: '0.5',
  0.75: '0.75',
  1: '正常',
  1.25: '1.25',
  1.5: '1.5',
  1.75: '1.75',
  2.0: '2.0'
};
strings$2[playerStringNames.ccLanguageText] = '隐藏式字幕';
strings$2[playerStringNames.searchDisabledFullScreen] = '搜索在全屏模式下被禁用。';
strings$2[playerStringNames.mediaNotFound] = '很抱歉，我们无法连接到此内容。请尝试刷新页面或<a href= \'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer \' target= \'_blank \'>单击此处获取更多帮助。</a>';
strings$2[playerStringNames.videoLoading] = '视频正在加载';
strings$2[playerStringNames.close] = '关闭';
strings$2[playerStringNames.txtHotspot] = '热点';
strings$2[playerStringNames.txtHotspotScreenReaderAlert] = '{{numberOfHotspots}}新热点';
strings$2[playerStringNames.txtHotspotScreenReaderAlertPlural] = '{{numberOfHotspots}}新热点';
strings$2[playerStringNames.txtJumpToMedia] = '跳转到媒体';
strings$2[playerStringNames.txtJumpToTime] = '跳转到时间';
strings$2[playerStringNames.txtOpenLink] = '打开链接';
strings$2[playerStringNames.txtOpenLinkHeader] = '本视频希望发送至：';
strings$2[playerStringNames.txtOpenLinkSubHeader] = '';
strings$2[playerStringNames.txtReview] = '重播最后一部分';
strings$2[playerStringNames.txtReplayVideo] = '重播视频';
strings$2[playerStringNames.txtAnswerQuestion] = '立即进行测验';
strings$2[playerStringNames.txtPrev] = '上一个';
strings$2[playerStringNames.txtNext] = '下一个';
strings$2[playerStringNames.txtHideQuiz] = '隐藏';
strings$2[playerStringNames.txtSubmit] = '提交答案';
strings$2[playerStringNames.txtSubmittingAnswers] = '正在提交答案。';
strings$2[playerStringNames.txtContinue] = '继续';
strings$2[playerStringNames.txtReviewAnswer] = '查看答案';
strings$2[playerStringNames.txtLoaderMessageDefinition] = '测验正在加载。';
strings$2[playerStringNames.txtQuestionCount] = '问题 {{currentQuestion}}/{{totalQuestions}}';
strings$2[playerStringNames.txtResults] = '结果：';
strings$2[playerStringNames.txtCorrectString] = '正确';
strings$2[playerStringNames.txtIncorrectString] = '不正确';
strings$2[playerStringNames.txtCorrect] = '{{numberCorrect}}正确';
strings$2[playerStringNames.txtIncorrect] = '{{numberIncorrect}}不正确';
strings$2[playerStringNames.txtYourAnswer] = '您的答案：';
strings$2[playerStringNames.txtCorrectAnswer] = '正确答案：';
strings$2[playerStringNames.txtVisitSite] = '访问网站';
strings$2[playerStringNames.accessBtnAudioDescription] = '音频描述';
strings$2[playerStringNames.accessBtnClearSearch] = '清除搜索';
strings$2[playerStringNames.accessBtnRewind] = '向后退回 {{duration}} 秒';
strings$2[playerStringNames.accessBtnForward] = '向前跳过 {{duration}} 秒';
strings$2[playerStringNames.accessBtnPlay] = '播放视频';
strings$2[playerStringNames.accessBtnPrevious] = '上一个';
strings$2[playerStringNames.accessBtnNext] = '下一个';
strings$2[playerStringNames.accessBtnProgressBar] = '进度滑块';
strings$2[playerStringNames.accessBtnVolume] = '静音';
strings$2[playerStringNames.accessTxtVolume] = '音量';
strings$2[playerStringNames.accessBtnClosedCaption] = '隐藏式字幕';
strings$2[playerStringNames.accessBtnTableOfContents] = '显示章节(T)';
strings$2[playerStringNames.accessBtnSettings] = '播放器设置';
strings$2[playerStringNames.accessBtnPip] = '画中画';
strings$2[playerStringNames.accessBtnFullScreen] = '全屏';
strings$2[playerStringNames.accessBtnFullScreenExpand] = '在新选项卡中打开';
strings$2[playerStringNames.accessBtnTakeQuiz] = '单击以参加测验。';
strings$2[playerStringNames.accessBtnShowQuiz] = '显示测验';
strings$2[playerStringNames.accessBtnHideQuiz] = '隐藏测验';
strings$2[playerStringNames.accessBtnPreviousQuestion] = '上一个问题';
strings$2[playerStringNames.accessBtnNextQuestion] = '下一个问题';
strings$2[playerStringNames.accessQuizHidden] = '已隐藏测验';
strings$2[playerStringNames.accessQuizShown] = '已显示测验';
strings$2[playerStringNames.accessBtnShowAnswer] = '显示答案';
strings$2[playerStringNames.accessBtnHideAnswer] = '隐藏答案';
strings$2[playerStringNames.accessBtnAnswersSubmitted] = '答案已提交！';
strings$2[playerStringNames.accessBtnWereNotGraded] = ' 未分级。';
strings$2[playerStringNames.accessBtnWasNotGraded] = ' 未分级。';
strings$2[playerStringNames.accessBtnCorrectOutOf] = ' 正确答案比例';
strings$2[playerStringNames.accessBtnGradedQuestions] = ' 已分级问题。';
strings$2[playerStringNames.accessBtnClickToReplayLink] = '重播';
strings$2[playerStringNames.accessResultsLabelCorrectSuffix] = '是正确的';
strings$2[playerStringNames.accessResultsLabelIncorrectSuffix] = '是错误的';
strings$2[playerStringNames.accessResultsLabelNoResponseSuffix] = '您没有回答这个问题。';
strings$2[playerStringNames.accessResultsLabelNoResponseGradedSuffix] = '您没有回答此问题，并且已被标记为错误。';
strings$2[playerStringNames.scormApiNotFoundMessage] = '无法找到 LMS 的 API Implementation。\n不会发生与 LMS 的通信。';
strings$2[playerStringNames.accessListTableOfContents] = '章节';
strings$2[playerStringNames.accessListSearchResults] = '按外观顺序搜索结果';
strings$2[playerStringNames.accessListNoSearchResults] = '未找到结果';
strings$2[playerStringNames.accessQuestionSetConfirmationTitle] = '测验';
strings$2[playerStringNames.accessVideoPausedForQuiz] = '视频因测验而暂停';
strings$2[playerStringNames.accessQuizResults] = '测验结果';
strings$2[playerStringNames.accessQuestionFeedbackContext] = '问题反馈：';
strings$2[playerStringNames.accessProgressBarTimeConjunction] = ' 的 ';
strings$2[playerStringNames.accessPlayerSettingsClose] = '关闭播放器设置';
strings$2[playerStringNames.accessBtnTheaterMode] = '剧院模式';
strings$2[playerStringNames.accessBtnExitTheaterMode] = '默认模式';
strings$2[playerStringNames.confirmOpenUrlModalScreenReaderAlertText] = '该视频想要打开以下网址 URL_TOKEN。';
strings$2[playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText] = '继续到新网站';
strings$2[playerStringNames.fastForwardDisabledScreenReaderText] = '该视频的快进功能已被禁用';
strings$2[playerStringNames.scormCompleteVideoLater] = '稍后完成视频';
strings$2[playerStringNames.scormCompleteVideo] = '完成视频';
strings$2[playerStringNames.scormExitVideo] = '退出视频';
strings$2[playerStringNames.scormConfirmCompleteModalText] = '您确定要退出视频吗？';
strings$2[playerStringNames.scormConfirmCompleteModalResumeVideoText] = '视频将在您下次打开视频时从上次停播的地方继续播放。';
strings$2[playerStringNames.scormConfirmCompleteModalRestartVideoText] = '视频将在下一次开始时重新播放。您将失去当前的进度。';
strings$2[playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText] = '保存您的进度时出现问题。该视频将在您下次观看时将从头开始播放。';
strings$2[playerStringNames.scormConfirmCompleteModalDismissButtonText] = '返回视频';
strings$2[playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText] = '返回视频';
strings$2[playerStringNames.scormConfirmCompleteModalConfirmButtonText] = '退出视频';
strings$2[playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText] = '退出视频';
strings$2[playerStringNames.scormSessionEndedText] = '您可以关闭选项卡或返回课程。';
strings$2[playerStringNames.searchOrJumpTo] = '搜索或跳转到';
strings$2[playerStringNames.searchTextCleared] = '搜索文字已清除。';
strings$2[playerStringNames.searchResultsUpdated] = '搜索结果已更新。{{number}} 结果。';
strings$2[playerStringNames.tableOfContentsDisplayed] = '显示的章节。';
strings$2[playerStringNames.tableOfContentsHidden] = '隐藏的章节。';
strings$2[playerStringNames.defaultMediaTitle] = 'TechSmith Smart Player';
strings$2[playerStringNames.hideThumbnailDueToQuiz] = '进行测验以预览';
strings$2[playerStringNames.quizAtTimeHeading] = '测验所在位置：';
strings$2[playerStringNames.defaultFirstChapterName] = '介绍';
strings$2[playerStringNames.acknowledgementLinkName] = '致谢';
var getLanguage$2 = function getLanguage() {
  return languageCodes.CHINESE;
};
var getReadableTimeByLocale$2 = function getReadableTimeByLocale(hours, minutes, seconds) {
  var timeStringList = [];
  if (hours > 0) {
    var hoursReadableString = hours + '小时';
    timeStringList.push(hoursReadableString);
  }
  if (minutes > 0) {
    var minutesReadableString = minutes + '分';
    timeStringList.push(minutesReadableString);
  }
  if (seconds > 0) {
    var secondsReadableString = seconds + '秒';
    timeStringList.push(secondsReadableString);
  }
  return timeStringList.join('');
};
var zhCnLocale = Object.defineProperties({
  getReadableTimeByLocale: getReadableTimeByLocale$2
}, {
  language: {
    get: getLanguage$2
  },
  strings: {
    get: function get() {
      return strings$2;
    }
  }
});

var strings$1 = {};
strings$1[playerStringNames.xmpError] = 'Parece que há um problema no acesso a certos recursos deste vídeo. Entre em contato com o autor do vídeo.';
strings$1[playerStringNames.xmpSecurity] = 'Certos recursos do seu vídeo estão atualmente desativados devido à Segurança da Rede Local. Esses recursos funcionam corretamente quando o vídeo é reproduzido a partir de um site ou servidor.';
strings$1[playerStringNames.videoNotSupported] = 'Seu navegador não pode reproduzir este vídeo.';
strings$1[playerStringNames.noWebMSupport] = 'Este navegador não aceita vídeo WebM.';
strings$1[playerStringNames.search] = 'Pesquisar';
strings$1[playerStringNames.searchPlaceholder] = 'Pesquisar...';
strings$1[playerStringNames.playerRateText] = 'Velocidade de Reprodução';
strings$1[playerStringNames.playerRateOptionsText] = {
  0.25: '0,25',
  0.5: '0,5',
  0.75: '0,75',
  1: 'normal',
  1.25: '1,25',
  1.5: '1,5',
  1.75: '1,75',
  2.0: '2,0'
};
strings$1[playerStringNames.ccLanguageText] = 'Closed Captions';
strings$1[playerStringNames.searchDisabledFullScreen] = 'A pesquisa é desativada no modo de tela cheia.';
strings$1[playerStringNames.mediaNotFound] = 'Desculpe, mas não é possível conectar a este conteúdo. Tente atualizar a página ou <a href=\'https://www.techsmith.com/redirect.asp?target=media_not_found&ver=4.*.*&lang=enu&os=na&product=smartplayer\' target=\'_blank\'> clique aqui para obter mais ajuda.</a>';
strings$1[playerStringNames.videoLoading] = 'O vídeo está carregando.';
strings$1[playerStringNames.close] = 'Fechar';
strings$1[playerStringNames.txtHotspot] = 'Hotspot';
strings$1[playerStringNames.txtHotspotScreenReaderAlert] = '{{numberOfHotspots}} novo hotspot';
strings$1[playerStringNames.txtHotspotScreenReaderAlertPlural] = '{{numberOfHotspots}} novos hotspots';
strings$1[playerStringNames.txtJumpToMedia] = 'Ir para mídia';
strings$1[playerStringNames.txtJumpToTime] = 'Ir para tempo';
strings$1[playerStringNames.txtOpenLink] = 'Abrir link';
strings$1[playerStringNames.txtOpenLinkHeader] = 'Este vídeo gostaria de direcionar você a:';
strings$1[playerStringNames.txtOpenLinkSubHeader] = '';
strings$1[playerStringNames.txtReview] = 'Repetir última seção';
strings$1[playerStringNames.txtReplayVideo] = 'Repetir vídeo';
strings$1[playerStringNames.txtAnswerQuestion] = 'Fazer o teste agora';
strings$1[playerStringNames.txtPrev] = 'Anterior';
strings$1[playerStringNames.txtNext] = 'Próximo';
strings$1[playerStringNames.txtHideQuiz] = 'Ocultar';
strings$1[playerStringNames.txtSubmit] = 'Enviar respostas';
strings$1[playerStringNames.txtSubmittingAnswers] = 'Enviando respostas.';
strings$1[playerStringNames.txtContinue] = 'Continuar';
strings$1[playerStringNames.txtReviewAnswer] = 'Ver respostas';
strings$1[playerStringNames.txtLoaderMessageDefinition] = 'O teste está carregando.';
strings$1[playerStringNames.txtQuestionCount] = 'Pergunta {{currentQuestion}} de {{totalQuestions}}';
strings$1[playerStringNames.txtResults] = 'Resultados: ';
strings$1[playerStringNames.txtCorrectString] = 'Correto';
strings$1[playerStringNames.txtIncorrectString] = 'Incorreto';
strings$1[playerStringNames.txtCorrect] = '{{numberCorrect}} Correto';
strings$1[playerStringNames.txtIncorrect] = '{{numberIncorrect}} Incorreto';
strings$1[playerStringNames.txtYourAnswer] = 'Sua resposta: ';
strings$1[playerStringNames.txtCorrectAnswer] = 'Resposta correta: ';
strings$1[playerStringNames.txtVisitSite] = 'Visitar site';
strings$1[playerStringNames.accessBtnAudioDescription] = 'Descrição do áudio';
strings$1[playerStringNames.accessBtnClearSearch] = 'Limpar pesquisa';
strings$1[playerStringNames.accessBtnRewind] = 'Retroceder {{duration}} segundos';
strings$1[playerStringNames.accessBtnForward] = 'Avançar {{duration}} segundos';
strings$1[playerStringNames.accessBtnPlay] = 'Reproduzir vídeo';
strings$1[playerStringNames.accessBtnPrevious] = 'Anterior';
strings$1[playerStringNames.accessBtnNext] = 'Próximo';
strings$1[playerStringNames.accessBtnProgressBar] = 'Barra deslizante de andamento';
strings$1[playerStringNames.accessBtnVolume] = 'Mudo';
strings$1[playerStringNames.accessTxtVolume] = 'Volume';
strings$1[playerStringNames.accessBtnClosedCaption] = 'Closed Caption';
strings$1[playerStringNames.accessBtnTableOfContents] = 'Mostrar Capítulos (T)';
strings$1[playerStringNames.accessBtnSettings] = 'Configurações do player';
strings$1[playerStringNames.accessBtnPip] = 'Picture-in-Picture';
strings$1[playerStringNames.accessBtnFullScreen] = 'Tela cheia';
strings$1[playerStringNames.accessBtnFullScreenExpand] = 'Abrir em uma nova guia';
strings$1[playerStringNames.accessBtnTakeQuiz] = 'Clique para fazer o teste.';
strings$1[playerStringNames.accessBtnShowQuiz] = 'Mostrar teste';
strings$1[playerStringNames.accessBtnHideQuiz] = 'Ocultar teste';
strings$1[playerStringNames.accessBtnPreviousQuestion] = 'Pergunta anterior';
strings$1[playerStringNames.accessBtnNextQuestion] = 'Próxima pergunta';
strings$1[playerStringNames.accessQuizHidden] = 'O teste foi ocultado';
strings$1[playerStringNames.accessQuizShown] = 'O teste está sendo exibido';
strings$1[playerStringNames.accessBtnShowAnswer] = 'Mostrar respostas';
strings$1[playerStringNames.accessBtnHideAnswer] = 'Ocultar respostas';
strings$1[playerStringNames.accessBtnAnswersSubmitted] = 'Respostas enviadas!';
strings$1[playerStringNames.accessBtnWereNotGraded] = ' não foram avaliadas.';
strings$1[playerStringNames.accessBtnWasNotGraded] = ' não foi avaliada.';
strings$1[playerStringNames.accessBtnCorrectOutOf] = ' correta(s) de ';
strings$1[playerStringNames.accessBtnGradedQuestions] = ' perguntas avaliadas.';
strings$1[playerStringNames.accessBtnClickToReplayLink] = 'Repetir';
strings$1[playerStringNames.accessResultsLabelCorrectSuffix] = 'está correta.';
strings$1[playerStringNames.accessResultsLabelIncorrectSuffix] = 'está incorreta.';
strings$1[playerStringNames.accessResultsLabelNoResponseSuffix] = 'você não respondeu a pergunta.';
strings$1[playerStringNames.accessResultsLabelNoResponseGradedSuffix] = 'você não respondeu a pergunta e sua resposta será considerada incorreta.';
strings$1[playerStringNames.scormApiNotFoundMessage] = 'Não é possível localizar a implementação da API do LMS.\nA comunicação com o LMS não ocorrerá.';
strings$1[playerStringNames.accessListTableOfContents] = 'Capítulos';
strings$1[playerStringNames.accessListSearchResults] = 'Resultados da pesquisa na ordem em que aparecem';
strings$1[playerStringNames.accessListNoSearchResults] = 'Nenhum resultado encontrado';
strings$1[playerStringNames.accessQuestionSetConfirmationTitle] = 'Teste';
strings$1[playerStringNames.accessVideoPausedForQuiz] = 'Vídeo pausado para teste';
strings$1[playerStringNames.accessQuizResults] = 'Resultados do teste';
strings$1[playerStringNames.accessQuestionFeedbackContext] = 'Resultado do teste: ';
strings$1[playerStringNames.accessProgressBarTimeConjunction] = ' de ';
strings$1[playerStringNames.accessPlayerSettingsClose] = 'Fechar configurações do player';
strings$1[playerStringNames.accessBtnTheaterMode] = 'Modo Cinema';
strings$1[playerStringNames.accessBtnExitTheaterMode] = 'Modo Padrão';
strings$1[playerStringNames.confirmOpenUrlModalScreenReaderAlertText] = 'O vídeo gostaria de abrir o seguinte URL URL_TOKEN.';
strings$1[playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText] = 'Continuar para novo site';
strings$1[playerStringNames.fastForwardDisabledScreenReaderText] = 'A função de avanço rápido foi desativada para este vídeo';
strings$1[playerStringNames.scormCompleteVideoLater] = 'Concluir o vídeo mais tarde';
strings$1[playerStringNames.scormCompleteVideo] = 'Concluir o vídeo';
strings$1[playerStringNames.scormExitVideo] = 'Sair do vídeo';
strings$1[playerStringNames.scormConfirmCompleteModalText] = 'Tem certeza de que deseja sair do vídeo?';
strings$1[playerStringNames.scormConfirmCompleteModalResumeVideoText] = 'O vídeo será retomado de onde você parou na próxima vez que ele for aberto.';
strings$1[playerStringNames.scormConfirmCompleteModalRestartVideoText] = 'O vídeo será reiniciado do começo na próxima vez. Você perderá o andamento atual.';
strings$1[playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText] = 'Houve um problema ao salvar seu progresso. O vídeo começará do início na próxima vez que você assisti-lo.';
strings$1[playerStringNames.scormConfirmCompleteModalDismissButtonText] = 'Retornar ao vídeo';
strings$1[playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText] = 'Retornar ao vídeo';
strings$1[playerStringNames.scormConfirmCompleteModalConfirmButtonText] = 'Sair do vídeo';
strings$1[playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText] = 'Sair do vídeo';
strings$1[playerStringNames.scormSessionEndedText] = 'Você pode fechar a guia ou voltar para o seu curso.';
strings$1[playerStringNames.searchOrJumpTo] = 'Pesquisar ou pular para.';
strings$1[playerStringNames.searchTextCleared] = 'Texto de pesquisa apagado.';
strings$1[playerStringNames.searchResultsUpdated] = 'Resultados da pesquisa atualizados. {{number}} resultados.';
strings$1[playerStringNames.tableOfContentsDisplayed] = 'Capítulos exibidos.';
strings$1[playerStringNames.tableOfContentsHidden] = 'Capítulos ocultos.';
strings$1[playerStringNames.defaultMediaTitle] = 'TechSmith Smart Player';
strings$1[playerStringNames.hideThumbnailDueToQuiz] = 'Faça o teste para visualizar';
strings$1[playerStringNames.quizAtTimeHeading] = 'Teste às';
strings$1[playerStringNames.defaultFirstChapterName] = 'introdução';
strings$1[playerStringNames.acknowledgementLinkName] = 'Créditos';
var getLanguage$1 = function getLanguage() {
  return languageCodes.PORTUGUESE;
};
var getReadableTimeByLocale$1 = function getReadableTimeByLocale(hours, minutes, seconds) {
  var timeStringList = [];
  if (hours > 0) {
    var hoursReadableString = hours + ' hora';
    hoursReadableString += hours > 1 ? 's' : '';
    timeStringList.push(hoursReadableString);
  }
  if (minutes > 0) {
    var minutesReadableString = minutes + ' minuto';
    minutesReadableString += minutes > 1 ? 's' : '';
    timeStringList.push(minutesReadableString);
  }
  if (seconds > 0) {
    var secondsReadableString = seconds + ' segundo';
    secondsReadableString += seconds > 1 ? 's' : '';
    timeStringList.push(secondsReadableString);
  }
  return timeStringList.join(' e ');
};
var ptBrLocale = Object.defineProperties({
  getReadableTimeByLocale: getReadableTimeByLocale$1
}, {
  language: {
    get: getLanguage$1
  },
  strings: {
    get: function get() {
      return strings$1;
    }
  }
});

var getLocaleByLanguageCode = function getLocaleByLanguageCode(languageCode) {
  switch (languageCode) {
    case languageCodes.ENGLISH:
      return enUsLocale;
    case languageCodes.GERMAN:
      return deDeLocale;
    case languageCodes.JAPANESE:
      return jaJpLocale;
    case languageCodes.FRENCH:
      return frFrLocale;
    case languageCodes.SPANISH:
      return esEsLocale;
    case languageCodes.CHINESE:
      return zhCnLocale;
    case languageCodes.PORTUGUESE:
      return ptBrLocale;
    default:
      return enUsLocale;
  }
};
var localeFactory = Object.defineProperties({
  getLocaleByLanguageCode: getLocaleByLanguageCode
}, {});

var strings = {};
var setString = function setString(stringKey, value) {
  if (!playerStringNames[stringKey]) {
    throw new Error('Player string not found');
  }
  strings[playerStringNames[stringKey]] = value;
};
var clearStrings = function clearStrings() {
  strings = {};
};
var customStrings = Object.defineProperties({
  setString: setString,
  clearStrings: clearStrings
}, {
  strings: {
    get: function get() {
      return strings;
    }
  }
});

var CURRENT_QUESTION_TOKEN = '{{currentQuestion}}';
var TOTAL_QUESTIONS_TOKEN = '{{totalQuestions}}';
var _language = null;
var _currentLocale = null;
var setLanguage = function setLanguage(language) {
  if (languageCodes.isValid(language)) {
    _language = language;
    _currentLocale = localeFactory.getLocaleByLanguageCode(_language);
  }
};
var getLanguage = function getLanguage() {
  return _language;
};
var getPlayerString = function getPlayerString(stringName) {
  if (customStrings.strings[stringName]) {
    return customStrings.strings[stringName];
  } else if (_currentLocale.strings[stringName]) {
    return _currentLocale.strings[stringName];
  }
  return '';
};
var getLanguageNameFromIdentifierString = function getLanguageNameFromIdentifierString(languageIdentifierString) {
  var languageIdentifier = LanguageIdentifier$1.create(languageIdentifierString);
  return languageIdentifiers.identifiers[languageIdentifier.language] ? languageIdentifiers.identifiers[languageIdentifier.language].displayName : languageIdentifierString;
};
var getQuestionCountString = function getQuestionCountString(currentQuestionNumber, totalNumberQuestions) {
  var questionCountString = getPlayerString(playerStringNames.txtQuestionCount);
  questionCountString = questionCountString.replace(CURRENT_QUESTION_TOKEN, currentQuestionNumber);
  return questionCountString.replace(TOTAL_QUESTIONS_TOKEN, totalNumberQuestions);
};
var configureLanguageFromXmp = function configureLanguageFromXmp(xmp) {
  xmp.controllerParameters.forEach(function (controllerParameter) {
    if (controllerParameter.name.toLowerCase() === 'locale') {
      setLanguage(controllerParameter.value);
    }
  });
};
var configureCustomStringsFromXmp = function configureCustomStringsFromXmp(xmp) {
  xmp.quizParameters.forEach(function (quizParameter) {
    try {
      customStrings.setString(quizParameter.name, quizParameter.value);
    } catch (e) {
      log.logMessage(e.message);
    }
  });
};
var configureFromXmp$1 = function configureFromXmp(xmp) {
  configureLanguageFromXmp(xmp); //Configure language first so that _language is properly set
  configureCustomStringsFromXmp(xmp);
};
var getReadableTimeByLocale = function getReadableTimeByLocale(hours, minutes, seconds) {
  return _currentLocale.getReadableTimeByLocale(hours, minutes, seconds);
};
var reset = function reset() {
  customStrings.clearStrings();
  setLanguage(languageCodes.ENGLISH);
};
setLanguage(languageCodes.ENGLISH);
var localizationStrings = Object.defineProperties({
  setLanguage: setLanguage,
  getLanguage: getLanguage,
  getLanguageNameFromIdentifierString: getLanguageNameFromIdentifierString,
  configureFromXmp: configureFromXmp$1,
  getReadableTimeByLocale: getReadableTimeByLocale,
  getPlayerString: getPlayerString,
  getQuestionCountString: getQuestionCountString,
  reset: reset
}, {});

var mediaMimeType = Object.freeze({
  JSON: 'application/json',
  M3U: 'application/mpegurl',
  MP4: 'video/mp4',
  WEBM: 'video/webm',
  OGV: 'video/ogg',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  GIF: 'image/gif',
  UNKNOWN: ''
});

var jquery = {exports: {}};

(function (module) {
  (function (global, factory) {

    {
      // For CommonJS and CommonJS-like environments where a proper `window`
      // is present, execute the factory and get jQuery.
      // For environments that do not have a `window` with a `document`
      // (such as Node.js), expose a factory as module.exports.
      // This accentuates the need for the creation of a real `window`.
      // e.g. var jQuery = require("jquery")(window);
      // See ticket trac-14549 for more info.
      module.exports = global.document ? factory(global, true) : function (w) {
        if (!w.document) {
          throw new Error("jQuery requires a window with a document");
        }
        return factory(w);
      };
    }

    // Pass this if window is not defined yet
  })(typeof window !== "undefined" ? window : commonjsGlobal, function (window, noGlobal) {

    var arr = [];
    var getProto = Object.getPrototypeOf;
    var _slice = arr.slice;
    var flat = arr.flat ? function (array) {
      return arr.flat.call(array);
    } : function (array) {
      return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
      // Plus for old WebKit, typeof returns "function" for HTML collections
      // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
      return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
      return obj != null && obj === obj.window;
    };
    var document = window.document;
    var preservedScriptAttributes = {
      type: true,
      src: true,
      nonce: true,
      noModule: true
    };
    function DOMEval(code, node, doc) {
      doc = doc || document;
      var i,
        val,
        script = doc.createElement("script");
      script.text = code;
      if (node) {
        for (i in preservedScriptAttributes) {
          // Support: Firefox 64+, Edge 18+
          // Some browsers don't support the "nonce" property on scripts.
          // On the other hand, just using `getAttribute` is not enough as
          // the `nonce` attribute is reset to an empty string whenever it
          // becomes browsing-context connected.
          // See https://github.com/whatwg/html/issues/2369
          // See https://html.spec.whatwg.org/#nonce-attributes
          // The `node.getAttribute` check was added for the sake of
          // `jQuery.globalEval` so that it can fake a nonce-containing node
          // via an object.
          val = node[i] || node.getAttribute && node.getAttribute(i);
          if (val) {
            script.setAttribute(i, val);
          }
        }
      }
      doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
      if (obj == null) {
        return obj + "";
      }

      // Support: Android <=2.3 only (functionish RegExp)
      return _typeof$1(obj) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : _typeof$1(obj);
    }
    /* global Symbol */
    // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module

    var version = "3.7.1",
      rhtmlSuffix = /HTML$/i,
      // Define a local copy of jQuery
      jQuery = function jQuery(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
      };
    jQuery.fn = jQuery.prototype = {
      // The current version of jQuery being used
      jquery: version,
      constructor: jQuery,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function toArray() {
        return _slice.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function get(num) {
        // Return all the elements in a clean array
        if (num == null) {
          return _slice.call(this);
        }

        // Return just the one element from the set
        return num < 0 ? this[num + this.length] : this[num];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function pushStack(elems) {
        // Build a new jQuery matched element set
        var ret = jQuery.merge(this.constructor(), elems);

        // Add the old object onto the stack (as a reference)
        ret.prevObject = this;

        // Return the newly-formed element set
        return ret;
      },
      // Execute a callback for every element in the matched set.
      each: function each(callback) {
        return jQuery.each(this, callback);
      },
      map: function map(callback) {
        return this.pushStack(jQuery.map(this, function (elem, i) {
          return callback.call(elem, i, elem);
        }));
      },
      slice: function slice() {
        return this.pushStack(_slice.apply(this, arguments));
      },
      first: function first() {
        return this.eq(0);
      },
      last: function last() {
        return this.eq(-1);
      },
      even: function even() {
        return this.pushStack(jQuery.grep(this, function (_elem, i) {
          return (i + 1) % 2;
        }));
      },
      odd: function odd() {
        return this.pushStack(jQuery.grep(this, function (_elem, i) {
          return i % 2;
        }));
      },
      eq: function eq(i) {
        var len = this.length,
          j = +i + (i < 0 ? len : 0);
        return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
      },
      end: function end() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push: push,
      sort: arr.sort,
      splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function () {
      var options,
        name,
        src,
        copy,
        copyIsArray,
        clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false;

      // Handle a deep copy situation
      if (typeof target === "boolean") {
        deep = target;

        // Skip the boolean and the target
        target = arguments[i] || {};
        i++;
      }

      // Handle case when target is a string or something (possible in deep copy)
      if (_typeof$1(target) !== "object" && !isFunction(target)) {
        target = {};
      }

      // Extend jQuery itself if only one argument is passed
      if (i === length) {
        target = this;
        i--;
      }
      for (; i < length; i++) {
        // Only deal with non-null/undefined values
        if ((options = arguments[i]) != null) {
          // Extend the base object
          for (name in options) {
            copy = options[name];

            // Prevent Object.prototype pollution
            // Prevent never-ending loop
            if (name === "__proto__" || target === copy) {
              continue;
            }

            // Recurse if we're merging plain objects or arrays
            if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
              src = target[name];

              // Ensure proper type for the source value
              if (copyIsArray && !Array.isArray(src)) {
                clone = [];
              } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                clone = {};
              } else {
                clone = src;
              }
              copyIsArray = false;

              // Never move original objects, clone them
              target[name] = jQuery.extend(deep, clone, copy);

              // Don't bring in undefined values
            } else if (copy !== undefined) {
              target[name] = copy;
            }
          }
        }
      }

      // Return the modified object
      return target;
    };
    jQuery.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: true,
      error: function error(msg) {
        throw new Error(msg);
      },
      noop: function noop() {},
      isPlainObject: function isPlainObject(obj) {
        var proto, Ctor;

        // Detect obvious negatives
        // Use toString instead of jQuery.type to catch host objects
        if (!obj || toString.call(obj) !== "[object Object]") {
          return false;
        }
        proto = getProto(obj);

        // Objects with no prototype (e.g., `Object.create( null )`) are plain
        if (!proto) {
          return true;
        }

        // Objects with prototype are plain iff they were constructed by a global Object function
        Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
        return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
      },
      isEmptyObject: function isEmptyObject(obj) {
        var name;
        for (name in obj) {
          return false;
        }
        return true;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function globalEval(code, options, doc) {
        DOMEval(code, {
          nonce: options && options.nonce
        }, doc);
      },
      each: function each(obj, callback) {
        var length,
          i = 0;
        if (isArrayLike(obj)) {
          length = obj.length;
          for (; i < length; i++) {
            if (callback.call(obj[i], i, obj[i]) === false) {
              break;
            }
          }
        } else {
          for (i in obj) {
            if (callback.call(obj[i], i, obj[i]) === false) {
              break;
            }
          }
        }
        return obj;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function text(elem) {
        var node,
          ret = "",
          i = 0,
          nodeType = elem.nodeType;
        if (!nodeType) {
          // If no nodeType, this is expected to be an array
          while (node = elem[i++]) {
            // Do not traverse comment nodes
            ret += jQuery.text(node);
          }
        }
        if (nodeType === 1 || nodeType === 11) {
          return elem.textContent;
        }
        if (nodeType === 9) {
          return elem.documentElement.textContent;
        }
        if (nodeType === 3 || nodeType === 4) {
          return elem.nodeValue;
        }

        // Do not include comment or processing instruction nodes

        return ret;
      },
      // results is for internal usage only
      makeArray: function makeArray(arr, results) {
        var ret = results || [];
        if (arr != null) {
          if (isArrayLike(Object(arr))) {
            jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
          } else {
            push.call(ret, arr);
          }
        }
        return ret;
      },
      inArray: function inArray(elem, arr, i) {
        return arr == null ? -1 : indexOf.call(arr, elem, i);
      },
      isXMLDoc: function isXMLDoc(elem) {
        var namespace = elem && elem.namespaceURI,
          docElem = elem && (elem.ownerDocument || elem).documentElement;

        // Assume HTML when documentElement doesn't yet exist, such as inside
        // document fragments.
        return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function merge(first, second) {
        var len = +second.length,
          j = 0,
          i = first.length;
        for (; j < len; j++) {
          first[i++] = second[j];
        }
        first.length = i;
        return first;
      },
      grep: function grep(elems, callback, invert) {
        var callbackInverse,
          matches = [],
          i = 0,
          length = elems.length,
          callbackExpect = !invert;

        // Go through the array, only saving the items
        // that pass the validator function
        for (; i < length; i++) {
          callbackInverse = !callback(elems[i], i);
          if (callbackInverse !== callbackExpect) {
            matches.push(elems[i]);
          }
        }
        return matches;
      },
      // arg is for internal usage only
      map: function map(elems, callback, arg) {
        var length,
          value,
          i = 0,
          ret = [];

        // Go through the array, translating each of the items to their new values
        if (isArrayLike(elems)) {
          length = elems.length;
          for (; i < length; i++) {
            value = callback(elems[i], i, arg);
            if (value != null) {
              ret.push(value);
            }
          }

          // Go through every key on the object,
        } else {
          for (i in elems) {
            value = callback(elems[i], i, arg);
            if (value != null) {
              ret.push(value);
            }
          }
        }

        // Flatten any nested arrays
        return flat(ret);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support: support
    });
    if (typeof Symbol === "function") {
      jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    }

    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
      class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
      // Support: real iOS 8.2 only (not reproducible in simulator)
      // `in` check used to prevent JIT error (gh-2145)
      // hasOwn isn't used here due to false negatives
      // regarding Nodelist length in IE
      var length = !!obj && "length" in obj && obj.length,
        type = toType(obj);
      if (isFunction(obj) || isWindow(obj)) {
        return false;
      }
      return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
      return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");

    // Note: an element does not contain itself
    jQuery.contains = function (a, b) {
      var bup = b && b.parentNode;
      return a === bup || !!(bup && bup.nodeType === 1 && (
      // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };

    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
      if (asCodePoint) {
        // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
        if (ch === "\0") {
          return "\uFFFD";
        }

        // Control characters and (dependent upon position) numbers get escaped as code points
        return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
      }

      // Other potentially-special ASCII characters get backslash-escaped
      return "\\" + ch;
    }
    jQuery.escapeSelector = function (sel) {
      return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document,
      pushNative = push;
    (function () {
      var i,
        Expr,
        outermostContext,
        sortInput,
        hasDuplicate,
        push = pushNative,
        // Local document vars
        document,
        documentElement,
        documentIsHTML,
        rbuggyQSA,
        matches,
        // Instance-specific data
        expando = jQuery.expando,
        dirruns = 0,
        done = 0,
        classCache = createCache(),
        tokenCache = createCache(),
        compilerCache = createCache(),
        nonnativeSelectorCache = createCache(),
        sortOrder = function sortOrder(a, b) {
          if (a === b) {
            hasDuplicate = true;
          }
          return 0;
        },
        booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" + "loop|multiple|open|readonly|required|scoped",
        // Regular expressions

        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
        // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace +
        // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
        pseudos = ":(" + identifier + ")(?:\\((" +
        // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
        // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
        // 3. anything else (capture 2)
        ".*" + ")\\)|)",
        // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"),
        rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
        rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
        rdescend = new RegExp(whitespace + "|>"),
        rpseudo = new RegExp(pseudos),
        ridentifier = new RegExp("^" + identifier + "$"),
        matchExpr = {
          ID: new RegExp("^#(" + identifier + ")"),
          CLASS: new RegExp("^\\.(" + identifier + ")"),
          TAG: new RegExp("^(" + identifier + "|[*])"),
          ATTR: new RegExp("^" + attributes),
          PSEUDO: new RegExp("^" + pseudos),
          CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
          bool: new RegExp("^(?:" + booleans + ")$", "i"),
          // For use in libraries implementing .is()
          // We use this for POS matching in `select`
          needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        },
        rinputs = /^(?:input|select|textarea|button)$/i,
        rheader = /^h\d$/i,
        // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        rsibling = /[+~]/,
        // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
        funescape = function funescape(escape, nonHex) {
          var high = "0x" + escape.slice(1) - 0x10000;
          if (nonHex) {
            // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
          }

          // Replace a hexadecimal escape sequence with the encoded Unicode code point
          // Support: IE <=11+
          // For values outside the Basic Multilingual Plane (BMP), manually construct a
          // surrogate pair
          return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        },
        // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
          setDocument();
        },
        inDisabledFieldset = addCombinator(function (elem) {
          return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
          dir: "parentNode",
          next: "legend"
        });

      // Support: IE <=9 only
      // Accessing document.activeElement can throw unexpectedly
      // https://bugs.jquery.com/ticket/13393
      function safeActiveElement() {
        try {
          return document.activeElement;
        } catch (err) {}
      }

      // Optimize for push.apply( _, NodeList )
      try {
        push.apply(arr = _slice.call(preferredDoc.childNodes), preferredDoc.childNodes);

        // Support: Android <=4.0
        // Detect silently failing push.apply
        // eslint-disable-next-line no-unused-expressions
        arr[preferredDoc.childNodes.length].nodeType;
      } catch (e) {
        push = {
          apply: function apply(target, els) {
            pushNative.apply(target, _slice.call(els));
          },
          call: function call(target) {
            pushNative.apply(target, _slice.call(arguments, 1));
          }
        };
      }
      function find(selector, context, results, seed) {
        var m,
          i,
          elem,
          nid,
          match,
          groups,
          newSelector,
          newContext = context && context.ownerDocument,
          // nodeType defaults to 9, since context defaults to document
          nodeType = context ? context.nodeType : 9;
        results = results || [];

        // Return early from calls with invalid selector or context
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
          return results;
        }

        // Try to shortcut find operations (as opposed to filters) in HTML documents
        if (!seed) {
          setDocument(context);
          context = context || document;
          if (documentIsHTML) {
            // If the selector is sufficiently simple, try using a "get*By*" DOM method
            // (excepting DocumentFragment context, where the methods don't exist)
            if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
              // ID selector
              if (m = match[1]) {
                // Document context
                if (nodeType === 9) {
                  if (elem = context.getElementById(m)) {
                    // Support: IE 9 only
                    // getElementById can match elements by name instead of ID
                    if (elem.id === m) {
                      push.call(results, elem);
                      return results;
                    }
                  } else {
                    return results;
                  }

                  // Element context
                } else {
                  // Support: IE 9 only
                  // getElementById can match elements by name instead of ID
                  if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                    push.call(results, elem);
                    return results;
                  }
                }

                // Type selector
              } else if (match[2]) {
                push.apply(results, context.getElementsByTagName(selector));
                return results;

                // Class selector
              } else if ((m = match[3]) && context.getElementsByClassName) {
                push.apply(results, context.getElementsByClassName(m));
                return results;
              }
            }

            // Take advantage of querySelectorAll
            if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
              newSelector = selector;
              newContext = context;

              // qSA considers elements outside a scoping root when evaluating child or
              // descendant combinators, which is not what we want.
              // In such cases, we work around the behavior by prefixing every selector in the
              // list with an ID selector referencing the scope context.
              // The technique has to be used as well when a leading combinator is used
              // as such selectors are not recognized by querySelectorAll.
              // Thanks to Andrew Dupont for this technique.
              if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                // Expand context for sibling selectors
                newContext = rsibling.test(selector) && testContext(context.parentNode) || context;

                // We can use :scope instead of the ID hack if the browser
                // supports it & if we're not changing the context.
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when
                // strict-comparing two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (newContext != context || !support.scope) {
                  // Capture the context ID, setting it first if necessary
                  if (nid = context.getAttribute("id")) {
                    nid = jQuery.escapeSelector(nid);
                  } else {
                    context.setAttribute("id", nid = expando);
                  }
                }

                // Prefix every selector in the list
                groups = tokenize(selector);
                i = groups.length;
                while (i--) {
                  groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                }
                newSelector = groups.join(",");
              }
              try {
                push.apply(results, newContext.querySelectorAll(newSelector));
                return results;
              } catch (qsaError) {
                nonnativeSelectorCache(selector, true);
              } finally {
                if (nid === expando) {
                  context.removeAttribute("id");
                }
              }
            }
          }
        }

        // All others
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
      }

      /**
       * Create key-value caches of limited size
       * @returns {function(string, object)} Returns the Object data after storing it on itself with
       *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
       *	deleting the oldest entry
       */
      function createCache() {
        var keys = [];
        function cache(key, value) {
          // Use (key + " ") to avoid collision with native prototype properties
          // (see https://github.com/jquery/sizzle/issues/157)
          if (keys.push(key + " ") > Expr.cacheLength) {
            // Only keep the most recent entries
            delete cache[keys.shift()];
          }
          return cache[key + " "] = value;
        }
        return cache;
      }

      /**
       * Mark a function for special use by jQuery selector module
       * @param {Function} fn The function to mark
       */
      function markFunction(fn) {
        fn[expando] = true;
        return fn;
      }

      /**
       * Support testing using an element
       * @param {Function} fn Passed the created element and returns a boolean result
       */
      function assert(fn) {
        var el = document.createElement("fieldset");
        try {
          return !!fn(el);
        } catch (e) {
          return false;
        } finally {
          // Remove from its parent by default
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }

          // release memory in IE
          el = null;
        }
      }

      /**
       * Returns a function to use in pseudos for input types
       * @param {String} type
       */
      function createInputPseudo(type) {
        return function (elem) {
          return nodeName(elem, "input") && elem.type === type;
        };
      }

      /**
       * Returns a function to use in pseudos for buttons
       * @param {String} type
       */
      function createButtonPseudo(type) {
        return function (elem) {
          return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
      }

      /**
       * Returns a function to use in pseudos for :enabled/:disabled
       * @param {Boolean} disabled true for :disabled; false for :enabled
       */
      function createDisabledPseudo(disabled) {
        // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
        return function (elem) {
          // Only certain elements can match :enabled or :disabled
          // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
          // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
          if ("form" in elem) {
            // Check for inherited disabledness on relevant non-disabled elements:
            // * listed form-associated elements in a disabled fieldset
            //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
            //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
            // * option elements in a disabled optgroup
            //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
            // All such elements have a "form" property.
            if (elem.parentNode && elem.disabled === false) {
              // Option elements defer to a parent optgroup if present
              if ("label" in elem) {
                if ("label" in elem.parentNode) {
                  return elem.parentNode.disabled === disabled;
                } else {
                  return elem.disabled === disabled;
                }
              }

              // Support: IE 6 - 11+
              // Use the isDisabled shortcut property to check for disabled fieldset ancestors
              return elem.isDisabled === disabled ||
              // Where there is no isDisabled, check manually
              elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
            }
            return elem.disabled === disabled;

            // Try to winnow out elements that can't be disabled before trusting the disabled property.
            // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
            // even exist on them, let alone have a boolean value.
          } else if ("label" in elem) {
            return elem.disabled === disabled;
          }

          // Remaining elements are neither :enabled nor :disabled
          return false;
        };
      }

      /**
       * Returns a function to use in pseudos for positionals
       * @param {Function} fn
       */
      function createPositionalPseudo(fn) {
        return markFunction(function (argument) {
          argument = +argument;
          return markFunction(function (seed, matches) {
            var j,
              matchIndexes = fn([], seed.length, argument),
              i = matchIndexes.length;

            // Match elements found at the specified indexes
            while (i--) {
              if (seed[j = matchIndexes[i]]) {
                seed[j] = !(matches[j] = seed[j]);
              }
            }
          });
        });
      }

      /**
       * Checks a node for validity as a jQuery selector context
       * @param {Element|Object=} context
       * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
       */
      function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
      }

      /**
       * Sets document-related variables once based on the current document
       * @param {Element|Object} [node] An element or document object to use to set the document
       * @returns {Object} Returns the current document
       */
      function setDocument(node) {
        var subWindow,
          doc = node ? node.ownerDocument || node : preferredDoc;

        // Return early if doc is invalid or already selected
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
          return document;
        }

        // Update global variables
        document = doc;
        documentElement = document.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document);

        // Support: iOS 7 only, IE 9 - 11+
        // Older browsers didn't support unprefixed `matches`.
        matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;

        // Support: IE 9 - 11+, Edge 12 - 18+
        // Accessing iframe documents after unload throws "permission denied" errors
        // (see trac-13936).
        // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
        // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
        if (documentElement.msMatchesSelector &&
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
          // Support: IE 9 - 11+, Edge 12 - 18+
          subWindow.addEventListener("unload", unloadHandler);
        }

        // Support: IE <10
        // Check if getElementById returns elements by name
        // The broken getElementById methods don't pick up programmatically-set names,
        // so use a roundabout getElementsByName test
        support.getById = assert(function (el) {
          documentElement.appendChild(el).id = jQuery.expando;
          return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
        });

        // Support: IE 9 only
        // Check to see if it's possible to do matchesSelector
        // on a disconnected node.
        support.disconnectedMatch = assert(function (el) {
          return matches.call(el, "*");
        });

        // Support: IE 9 - 11+, Edge 12 - 18+
        // IE/Edge don't support the :scope pseudo-class.
        support.scope = assert(function () {
          return document.querySelectorAll(":scope");
        });

        // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
        // Make sure the `:has()` argument is parsed unforgivingly.
        // We include `*` in the test to detect buggy implementations that are
        // _selectively_ forgiving (specifically when the list includes at least
        // one valid selector).
        // Note that we treat complete lack of support for `:has()` as if it were
        // spec-compliant support, which is fine because use of `:has()` in such
        // environments will fail in the qSA path and fall back to jQuery traversal
        // anyway.
        support.cssHas = assert(function () {
          try {
            document.querySelector(":has(*,:jqfake)");
            return false;
          } catch (e) {
            return true;
          }
        });

        // ID filter and find
        if (support.getById) {
          Expr.filter.ID = function (id) {
            var attrId = id.replace(runescape, funescape);
            return function (elem) {
              return elem.getAttribute("id") === attrId;
            };
          };
          Expr.find.ID = function (id, context) {
            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
              var elem = context.getElementById(id);
              return elem ? [elem] : [];
            }
          };
        } else {
          Expr.filter.ID = function (id) {
            var attrId = id.replace(runescape, funescape);
            return function (elem) {
              var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
              return node && node.value === attrId;
            };
          };

          // Support: IE 6 - 7 only
          // getElementById is not reliable as a find shortcut
          Expr.find.ID = function (id, context) {
            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
              var node,
                i,
                elems,
                elem = context.getElementById(id);
              if (elem) {
                // Verify the id attribute
                node = elem.getAttributeNode("id");
                if (node && node.value === id) {
                  return [elem];
                }

                // Fall back on getElementsByName
                elems = context.getElementsByName(id);
                i = 0;
                while (elem = elems[i++]) {
                  node = elem.getAttributeNode("id");
                  if (node && node.value === id) {
                    return [elem];
                  }
                }
              }
              return [];
            }
          };
        }

        // Tag
        Expr.find.TAG = function (tag, context) {
          if (typeof context.getElementsByTagName !== "undefined") {
            return context.getElementsByTagName(tag);

            // DocumentFragment nodes don't have gEBTN
          } else {
            return context.querySelectorAll(tag);
          }
        };

        // Class
        Expr.find.CLASS = function (className, context) {
          if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
            return context.getElementsByClassName(className);
          }
        };

        /* QSA/matchesSelector
        ---------------------------------------------------------------------- */

        // QSA and matchesSelector support

        rbuggyQSA = [];

        // Build QSA regex
        // Regex strategy adopted from Diego Perini
        assert(function (el) {
          var input;
          documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";

          // Support: iOS <=7 - 8 only
          // Boolean attributes and "value" are not treated correctly in some XML documents
          if (!el.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          }

          // Support: iOS <=7 - 8 only
          if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          }

          // Support: iOS 8 only
          // https://bugs.webkit.org/show_bug.cgi?id=136851
          // In-page `selector#id sibling-combinator selector` fails
          if (!el.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          }

          // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
          // In some of the document kinds, these selectors wouldn't work natively.
          // This is probably OK but for backwards compatibility we want to maintain
          // handling them through jQuery traversal in jQuery 3.x.
          if (!el.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          }

          // Support: Windows 8 Native Apps
          // The type and name attributes are restricted during .innerHTML assignment
          input = document.createElement("input");
          input.setAttribute("type", "hidden");
          el.appendChild(input).setAttribute("name", "D");

          // Support: IE 9 - 11+
          // IE's :disabled selector does not pick up the children of disabled fieldsets
          // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
          // In some of the document kinds, these selectors wouldn't work natively.
          // This is probably OK but for backwards compatibility we want to maintain
          // handling them through jQuery traversal in jQuery 3.x.
          documentElement.appendChild(el).disabled = true;
          if (el.querySelectorAll(":disabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          }

          // Support: IE 11+, Edge 15 - 18+
          // IE 11/Edge don't find elements on a `[name='']` query in some cases.
          // Adding a temporary attribute to the document before the selection works
          // around the issue.
          // Interestingly, IE 10 & older don't seem to have the issue.
          input = document.createElement("input");
          input.setAttribute("name", "");
          el.appendChild(input);
          if (!el.querySelectorAll("[name='']").length) {
            rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
          }
        });
        if (!support.cssHas) {
          // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
          // Our regular `try-catch` mechanism fails to detect natively-unsupported
          // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
          // in browsers that parse the `:has()` argument as a forgiving selector list.
          // https://drafts.csswg.org/selectors/#relational now requires the argument
          // to be parsed unforgivingly, but browsers have not yet fully adjusted.
          rbuggyQSA.push(":has");
        }
        rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));

        /* Sorting
        ---------------------------------------------------------------------- */

        // Document order sorting
        sortOrder = function sortOrder(a, b) {
          // Flag for duplicate removal
          if (a === b) {
            hasDuplicate = true;
            return 0;
          }

          // Sort on method existence if only one input has compareDocumentPosition
          var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
          if (compare) {
            return compare;
          }

          // Calculate position if both inputs belong to the same document
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) :
          // Otherwise we know they are disconnected
          1;

          // Disconnected nodes
          if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
            // Choose the first element that is related to our preferred document
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
              return -1;
            }

            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
              return 1;
            }

            // Maintain original order
            return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
          }
          return compare & 4 ? -1 : 1;
        };
        return document;
      }
      find.matches = function (expr, elements) {
        return find(expr, null, null, elements);
      };
      find.matchesSelector = function (elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
          try {
            var ret = matches.call(elem, expr);

            // IE 9's matchesSelector returns false on disconnected nodes
            if (ret || support.disconnectedMatch ||
            // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            elem.document && elem.document.nodeType !== 11) {
              return ret;
            }
          } catch (e) {
            nonnativeSelectorCache(expr, true);
          }
        }
        return find(expr, document, null, [elem]).length > 0;
      };
      find.contains = function (context, elem) {
        // Set document vars if needed
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if ((context.ownerDocument || context) != document) {
          setDocument(context);
        }
        return jQuery.contains(context, elem);
      };
      find.attr = function (elem, name) {
        // Set document vars if needed
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if ((elem.ownerDocument || elem) != document) {
          setDocument(elem);
        }
        var fn = Expr.attrHandle[name.toLowerCase()],
          // Don't get fooled by Object.prototype properties (see trac-13807)
          val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
        if (val !== undefined) {
          return val;
        }
        return elem.getAttribute(name);
      };
      find.error = function (msg) {
        throw new Error("Syntax error, unrecognized expression: " + msg);
      };

      /**
       * Document sorting and removing duplicates
       * @param {ArrayLike} results
       */
      jQuery.uniqueSort = function (results) {
        var elem,
          duplicates = [],
          j = 0,
          i = 0;

        // Unless we *know* we can detect duplicates, assume their presence
        //
        // Support: Android <=4.0+
        // Testing for detecting duplicates is unpredictable so instead assume we can't
        // depend on duplicate detection in all browsers without a stable sort.
        hasDuplicate = !support.sortStable;
        sortInput = !support.sortStable && _slice.call(results, 0);
        sort.call(results, sortOrder);
        if (hasDuplicate) {
          while (elem = results[i++]) {
            if (elem === results[i]) {
              j = duplicates.push(i);
            }
          }
          while (j--) {
            splice.call(results, duplicates[j], 1);
          }
        }

        // Clear input after sorting to release objects
        // See https://github.com/jquery/sizzle/pull/225
        sortInput = null;
        return results;
      };
      jQuery.fn.uniqueSort = function () {
        return this.pushStack(jQuery.uniqueSort(_slice.apply(this)));
      };
      Expr = jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        attrHandle: {},
        find: {},
        relative: {
          ">": {
            dir: "parentNode",
            first: true
          },
          " ": {
            dir: "parentNode"
          },
          "+": {
            dir: "previousSibling",
            first: true
          },
          "~": {
            dir: "previousSibling"
          }
        },
        preFilter: {
          ATTR: function ATTR(match) {
            match[1] = match[1].replace(runescape, funescape);

            // Move the given value to match[3] whether quoted or unquoted
            match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
            if (match[2] === "~=") {
              match[3] = " " + match[3] + " ";
            }
            return match.slice(0, 4);
          },
          CHILD: function CHILD(match) {
            /* matches from matchExpr["CHILD"]
            	1 type (only|nth|...)
            	2 what (child|of-type)
            	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
            	4 xn-component of xn+y argument ([+-]?\d*n|)
            	5 sign of xn-component
            	6 x of xn-component
            	7 sign of y-component
            	8 y of y-component
            */
            match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
              // nth-* requires argument
              if (!match[3]) {
                find.error(match[0]);
              }

              // numeric x and y parameters for Expr.filter.CHILD
              // remember that false/true cast respectively to 0/1
              match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
              match[5] = +(match[7] + match[8] || match[3] === "odd");

              // other types prohibit arguments
            } else if (match[3]) {
              find.error(match[0]);
            }
            return match;
          },
          PSEUDO: function PSEUDO(match) {
            var excess,
              unquoted = !match[6] && match[2];
            if (matchExpr.CHILD.test(match[0])) {
              return null;
            }

            // Accept quoted arguments as-is
            if (match[3]) {
              match[2] = match[4] || match[5] || "";

              // Strip excess characters from unquoted arguments
            } else if (unquoted && rpseudo.test(unquoted) && (
            // Get excess from tokenize (recursively)
            excess = tokenize(unquoted, true)) && (
            // advance to the next closing parenthesis
            excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
              // excess is a negative index
              match[0] = match[0].slice(0, excess);
              match[2] = unquoted.slice(0, excess);
            }

            // Return only captures needed by the pseudo filter method (type and argument)
            return match.slice(0, 3);
          }
        },
        filter: {
          TAG: function TAG(nodeNameSelector) {
            var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
            return nodeNameSelector === "*" ? function () {
              return true;
            } : function (elem) {
              return nodeName(elem, expectedNodeName);
            };
          },
          CLASS: function CLASS(className) {
            var pattern = classCache[className + " "];
            return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
              return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
            });
          },
          ATTR: function ATTR(name, operator, check) {
            return function (elem) {
              var result = find.attr(elem, name);
              if (result == null) {
                return operator === "!=";
              }
              if (!operator) {
                return true;
              }
              result += "";
              if (operator === "=") {
                return result === check;
              }
              if (operator === "!=") {
                return result !== check;
              }
              if (operator === "^=") {
                return check && result.indexOf(check) === 0;
              }
              if (operator === "*=") {
                return check && result.indexOf(check) > -1;
              }
              if (operator === "$=") {
                return check && result.slice(-check.length) === check;
              }
              if (operator === "~=") {
                return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
              }
              if (operator === "|=") {
                return result === check || result.slice(0, check.length + 1) === check + "-";
              }
              return false;
            };
          },
          CHILD: function CHILD(type, what, _argument, first, last) {
            var simple = type.slice(0, 3) !== "nth",
              forward = type.slice(-4) !== "last",
              ofType = what === "of-type";
            return first === 1 && last === 0 ?
            // Shortcut for :nth-*(n)
            function (elem) {
              return !!elem.parentNode;
            } : function (elem, _context, xml) {
              var cache,
                outerCache,
                node,
                nodeIndex,
                start,
                dir = simple !== forward ? "nextSibling" : "previousSibling",
                parent = elem.parentNode,
                name = ofType && elem.nodeName.toLowerCase(),
                useCache = !xml && !ofType,
                diff = false;
              if (parent) {
                // :(first|last|only)-(child|of-type)
                if (simple) {
                  while (dir) {
                    node = elem;
                    while (node = node[dir]) {
                      if (ofType ? nodeName(node, name) : node.nodeType === 1) {
                        return false;
                      }
                    }

                    // Reverse direction for :only-* (if we haven't yet done so)
                    start = dir = type === "only" && !start && "nextSibling";
                  }
                  return true;
                }
                start = [forward ? parent.firstChild : parent.lastChild];

                // non-xml :nth-child(...) stores cache data on `parent`
                if (forward && useCache) {
                  // Seek `elem` from a previously-cached index
                  outerCache = parent[expando] || (parent[expando] = {});
                  cache = outerCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = nodeIndex && cache[2];
                  node = nodeIndex && parent.childNodes[nodeIndex];
                  while (node = ++nodeIndex && node && node[dir] || (
                  // Fallback to seeking `elem` from the start
                  diff = nodeIndex = 0) || start.pop()) {
                    // When found, cache indexes on `parent` and break
                    if (node.nodeType === 1 && ++diff && node === elem) {
                      outerCache[type] = [dirruns, nodeIndex, diff];
                      break;
                    }
                  }
                } else {
                  // Use previously-cached element index if available
                  if (useCache) {
                    outerCache = elem[expando] || (elem[expando] = {});
                    cache = outerCache[type] || [];
                    nodeIndex = cache[0] === dirruns && cache[1];
                    diff = nodeIndex;
                  }

                  // xml :nth-child(...)
                  // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                  if (diff === false) {
                    // Use the same loop as above to seek `elem` from the start
                    while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                      if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                        // Cache the index of each encountered element
                        if (useCache) {
                          outerCache = node[expando] || (node[expando] = {});
                          outerCache[type] = [dirruns, diff];
                        }
                        if (node === elem) {
                          break;
                        }
                      }
                    }
                  }
                }

                // Incorporate the offset, then check against cycle size
                diff -= last;
                return diff === first || diff % first === 0 && diff / first >= 0;
              }
            };
          },
          PSEUDO: function PSEUDO(pseudo, argument) {
            // pseudo-class names are case-insensitive
            // https://www.w3.org/TR/selectors/#pseudo-classes
            // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
            // Remember that setFilters inherits from pseudos
            var args,
              fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);

            // The user may use createPseudo to indicate that
            // arguments are needed to create the filter function
            // just as jQuery does
            if (fn[expando]) {
              return fn(argument);
            }

            // But maintain support for old signatures
            if (fn.length > 1) {
              args = [pseudo, pseudo, "", argument];
              return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
                var idx,
                  matched = fn(seed, argument),
                  i = matched.length;
                while (i--) {
                  idx = indexOf.call(seed, matched[i]);
                  seed[idx] = !(matches[idx] = matched[i]);
                }
              }) : function (elem) {
                return fn(elem, 0, args);
              };
            }
            return fn;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: markFunction(function (selector) {
            // Trim the selector passed to compile
            // to avoid treating leading and trailing
            // spaces as combinators
            var input = [],
              results = [],
              matcher = compile(selector.replace(rtrimCSS, "$1"));
            return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
              var elem,
                unmatched = matcher(seed, null, xml, []),
                i = seed.length;

              // Match elements unmatched by `matcher`
              while (i--) {
                if (elem = unmatched[i]) {
                  seed[i] = !(matches[i] = elem);
                }
              }
            }) : function (elem, _context, xml) {
              input[0] = elem;
              matcher(input, null, xml, results);

              // Don't keep the element
              // (see https://github.com/jquery/sizzle/issues/299)
              input[0] = null;
              return !results.pop();
            };
          }),
          has: markFunction(function (selector) {
            return function (elem) {
              return find(selector, elem).length > 0;
            };
          }),
          contains: markFunction(function (text) {
            text = text.replace(runescape, funescape);
            return function (elem) {
              return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: markFunction(function (lang) {
            // lang value must be a valid identifier
            if (!ridentifier.test(lang || "")) {
              find.error("unsupported lang: " + lang);
            }
            lang = lang.replace(runescape, funescape).toLowerCase();
            return function (elem) {
              var elemLang;
              do {
                if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                  elemLang = elemLang.toLowerCase();
                  return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                }
              } while ((elem = elem.parentNode) && elem.nodeType === 1);
              return false;
            };
          }),
          // Miscellaneous
          target: function target(elem) {
            var hash = window.location && window.location.hash;
            return hash && hash.slice(1) === elem.id;
          },
          root: function root(elem) {
            return elem === documentElement;
          },
          focus: function focus(elem) {
            return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
          },
          // Boolean properties
          enabled: createDisabledPseudo(false),
          disabled: createDisabledPseudo(true),
          checked: function checked(elem) {
            // In CSS3, :checked should return both checked and selected elements
            // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
            return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
          },
          selected: function selected(elem) {
            // Support: IE <=11+
            // Accessing the selectedIndex property
            // forces the browser to treat the default option as
            // selected when in an optgroup.
            if (elem.parentNode) {
              // eslint-disable-next-line no-unused-expressions
              elem.parentNode.selectedIndex;
            }
            return elem.selected === true;
          },
          // Contents
          empty: function empty(elem) {
            // https://www.w3.org/TR/selectors/#empty-pseudo
            // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
            //   but not by others (comment: 8; processing instruction: 7; etc.)
            // nodeType < 6 works because attributes (2) do not appear as children
            for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
              if (elem.nodeType < 6) {
                return false;
              }
            }
            return true;
          },
          parent: function parent(elem) {
            return !Expr.pseudos.empty(elem);
          },
          // Element/input types
          header: function header(elem) {
            return rheader.test(elem.nodeName);
          },
          input: function input(elem) {
            return rinputs.test(elem.nodeName);
          },
          button: function button(elem) {
            return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
          },
          text: function text(elem) {
            var attr;
            return nodeName(elem, "input") && elem.type === "text" && (
            // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
          },
          // Position-in-collection
          first: createPositionalPseudo(function () {
            return [0];
          }),
          last: createPositionalPseudo(function (_matchIndexes, length) {
            return [length - 1];
          }),
          eq: createPositionalPseudo(function (_matchIndexes, length, argument) {
            return [argument < 0 ? argument + length : argument];
          }),
          even: createPositionalPseudo(function (matchIndexes, length) {
            var i = 0;
            for (; i < length; i += 2) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          }),
          odd: createPositionalPseudo(function (matchIndexes, length) {
            var i = 1;
            for (; i < length; i += 2) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          }),
          lt: createPositionalPseudo(function (matchIndexes, length, argument) {
            var i;
            if (argument < 0) {
              i = argument + length;
            } else if (argument > length) {
              i = length;
            } else {
              i = argument;
            }
            for (; --i >= 0;) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          }),
          gt: createPositionalPseudo(function (matchIndexes, length, argument) {
            var i = argument < 0 ? argument + length : argument;
            for (; ++i < length;) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          })
        }
      };
      Expr.pseudos.nth = Expr.pseudos.eq;

      // Add button/input type pseudos
      for (i in {
        radio: true,
        checkbox: true,
        file: true,
        password: true,
        image: true
      }) {
        Expr.pseudos[i] = createInputPseudo(i);
      }
      for (i in {
        submit: true,
        reset: true
      }) {
        Expr.pseudos[i] = createButtonPseudo(i);
      }

      // Easy API for creating new setFilters
      function setFilters() {}
      setFilters.prototype = Expr.filters = Expr.pseudos;
      Expr.setFilters = new setFilters();
      function tokenize(selector, parseOnly) {
        var matched,
          match,
          tokens,
          type,
          soFar,
          groups,
          preFilters,
          cached = tokenCache[selector + " "];
        if (cached) {
          return parseOnly ? 0 : cached.slice(0);
        }
        soFar = selector;
        groups = [];
        preFilters = Expr.preFilter;
        while (soFar) {
          // Comma and first run
          if (!matched || (match = rcomma.exec(soFar))) {
            if (match) {
              // Don't consume trailing commas as valid
              soFar = soFar.slice(match[0].length) || soFar;
            }
            groups.push(tokens = []);
          }
          matched = false;

          // Combinators
          if (match = rleadingCombinator.exec(soFar)) {
            matched = match.shift();
            tokens.push({
              value: matched,
              // Cast descendant combinators to space
              type: match[0].replace(rtrimCSS, " ")
            });
            soFar = soFar.slice(matched.length);
          }

          // Filters
          for (type in Expr.filter) {
            if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
              matched = match.shift();
              tokens.push({
                value: matched,
                type: type,
                matches: match
              });
              soFar = soFar.slice(matched.length);
            }
          }
          if (!matched) {
            break;
          }
        }

        // Return the length of the invalid excess
        // if we're just parsing
        // Otherwise, throw an error or return tokens
        if (parseOnly) {
          return soFar.length;
        }
        return soFar ? find.error(selector) :
        // Cache the tokens
        tokenCache(selector, groups).slice(0);
      }
      function toSelector(tokens) {
        var i = 0,
          len = tokens.length,
          selector = "";
        for (; i < len; i++) {
          selector += tokens[i].value;
        }
        return selector;
      }
      function addCombinator(matcher, combinator, base) {
        var dir = combinator.dir,
          skip = combinator.next,
          key = skip || dir,
          checkNonElements = base && key === "parentNode",
          doneName = done++;
        return combinator.first ?
        // Check against closest ancestor/preceding element
        function (elem, context, xml) {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              return matcher(elem, context, xml);
            }
          }
          return false;
        } :
        // Check against all ancestor/preceding elements
        function (elem, context, xml) {
          var oldCache,
            outerCache,
            newCache = [dirruns, doneName];

          // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
          if (xml) {
            while (elem = elem[dir]) {
              if (elem.nodeType === 1 || checkNonElements) {
                if (matcher(elem, context, xml)) {
                  return true;
                }
              }
            }
          } else {
            while (elem = elem[dir]) {
              if (elem.nodeType === 1 || checkNonElements) {
                outerCache = elem[expando] || (elem[expando] = {});
                if (skip && nodeName(elem, skip)) {
                  elem = elem[dir] || elem;
                } else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                  // Assign to newCache so results back-propagate to previous elements
                  return newCache[2] = oldCache[2];
                } else {
                  // Reuse newcache so results back-propagate to previous elements
                  outerCache[key] = newCache;

                  // A match means we're done; a fail means we have to keep checking
                  if (newCache[2] = matcher(elem, context, xml)) {
                    return true;
                  }
                }
              }
            }
          }
          return false;
        };
      }
      function elementMatcher(matchers) {
        return matchers.length > 1 ? function (elem, context, xml) {
          var i = matchers.length;
          while (i--) {
            if (!matchers[i](elem, context, xml)) {
              return false;
            }
          }
          return true;
        } : matchers[0];
      }
      function multipleContexts(selector, contexts, results) {
        var i = 0,
          len = contexts.length;
        for (; i < len; i++) {
          find(selector, contexts[i], results);
        }
        return results;
      }
      function condense(unmatched, map, filter, context, xml) {
        var elem,
          newUnmatched = [],
          i = 0,
          len = unmatched.length,
          mapped = map != null;
        for (; i < len; i++) {
          if (elem = unmatched[i]) {
            if (!filter || filter(elem, context, xml)) {
              newUnmatched.push(elem);
              if (mapped) {
                map.push(i);
              }
            }
          }
        }
        return newUnmatched;
      }
      function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[expando]) {
          postFilter = setMatcher(postFilter);
        }
        if (postFinder && !postFinder[expando]) {
          postFinder = setMatcher(postFinder, postSelector);
        }
        return markFunction(function (seed, results, context, xml) {
          var temp,
            i,
            elem,
            matcherOut,
            preMap = [],
            postMap = [],
            preexisting = results.length,
            // Get initial elements from seed or context
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
            // Prefilter to get matcher input, preserving a map for seed-results synchronization
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
          if (matcher) {
            // If we have a postFinder, or filtered seed, or non-seed postFilter
            // or preexisting results,
            matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ?
            // ...intermediate processing is necessary
            [] :
            // ...otherwise use results directly
            results;

            // Find primary matches
            matcher(matcherIn, matcherOut, context, xml);
          } else {
            matcherOut = matcherIn;
          }

          // Apply postFilter
          if (postFilter) {
            temp = condense(matcherOut, postMap);
            postFilter(temp, [], context, xml);

            // Un-match failing elements by moving them back to matcherIn
            i = temp.length;
            while (i--) {
              if (elem = temp[i]) {
                matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
              }
            }
          }
          if (seed) {
            if (postFinder || preFilter) {
              if (postFinder) {
                // Get the final matcherOut by condensing this intermediate into postFinder contexts
                temp = [];
                i = matcherOut.length;
                while (i--) {
                  if (elem = matcherOut[i]) {
                    // Restore matcherIn since elem is not yet a final match
                    temp.push(matcherIn[i] = elem);
                  }
                }
                postFinder(null, matcherOut = [], temp, xml);
              }

              // Move matched elements from seed to results to keep them synchronized
              i = matcherOut.length;
              while (i--) {
                if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {
                  seed[temp] = !(results[temp] = elem);
                }
              }
            }

            // Add elements to results, through postFinder if defined
          } else {
            matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
            if (postFinder) {
              postFinder(null, results, matcherOut, xml);
            } else {
              push.apply(results, matcherOut);
            }
          }
        });
      }
      function matcherFromTokens(tokens) {
        var checkContext,
          matcher,
          j,
          len = tokens.length,
          leadingRelative = Expr.relative[tokens[0].type],
          implicitRelative = leadingRelative || Expr.relative[" "],
          i = leadingRelative ? 1 : 0,
          // The foundational matcher ensures that elements are reachable from top-level context(s)
          matchContext = addCombinator(function (elem) {
            return elem === checkContext;
          }, implicitRelative, true),
          matchAnyContext = addCombinator(function (elem) {
            return indexOf.call(checkContext, elem) > -1;
          }, implicitRelative, true),
          matchers = [function (elem, context, xml) {
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));

            // Avoid hanging onto element
            // (see https://github.com/jquery/sizzle/issues/299)
            checkContext = null;
            return ret;
          }];
        for (; i < len; i++) {
          if (matcher = Expr.relative[tokens[i].type]) {
            matchers = [addCombinator(elementMatcher(matchers), matcher)];
          } else {
            matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

            // Return special upon seeing a positional matcher
            if (matcher[expando]) {
              // Find the next relative operator (if any) for proper handling
              j = ++i;
              for (; j < len; j++) {
                if (Expr.relative[tokens[j].type]) {
                  break;
                }
              }
              return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
              // If the preceding token was a descendant combinator, insert an implicit any-element `*`
              tokens.slice(0, i - 1).concat({
                value: tokens[i - 2].type === " " ? "*" : ""
              })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
            }
            matchers.push(matcher);
          }
        }
        return elementMatcher(matchers);
      }
      function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0,
          byElement = elementMatchers.length > 0,
          superMatcher = function superMatcher(seed, context, xml, results, outermost) {
            var elem,
              j,
              matcher,
              matchedCount = 0,
              i = "0",
              unmatched = seed && [],
              setMatched = [],
              contextBackup = outermostContext,
              // We must always have either seed elements or outermost context
              elems = seed || byElement && Expr.find.TAG("*", outermost),
              // Use integer dirruns iff this is the outermost matcher
              dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
              len = elems.length;
            if (outermost) {
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              outermostContext = context == document || context || outermost;
            }

            // Add elements passing elementMatchers directly to results
            // Support: iOS <=7 - 9 only
            // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
            // elements by id. (see trac-14142)
            for (; i !== len && (elem = elems[i]) != null; i++) {
              if (byElement && elem) {
                j = 0;

                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (!context && elem.ownerDocument != document) {
                  setDocument(elem);
                  xml = !documentIsHTML;
                }
                while (matcher = elementMatchers[j++]) {
                  if (matcher(elem, context || document, xml)) {
                    push.call(results, elem);
                    break;
                  }
                }
                if (outermost) {
                  dirruns = dirrunsUnique;
                }
              }

              // Track unmatched elements for set filters
              if (bySet) {
                // They will have gone through all possible matchers
                if (elem = !matcher && elem) {
                  matchedCount--;
                }

                // Lengthen the array for every element, matched or not
                if (seed) {
                  unmatched.push(elem);
                }
              }
            }

            // `i` is now the count of elements visited above, and adding it to `matchedCount`
            // makes the latter nonnegative.
            matchedCount += i;

            // Apply set filters to unmatched elements
            // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
            // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
            // no element matchers and no seed.
            // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
            // case, which will result in a "00" `matchedCount` that differs from `i` but is also
            // numerically zero.
            if (bySet && i !== matchedCount) {
              j = 0;
              while (matcher = setMatchers[j++]) {
                matcher(unmatched, setMatched, context, xml);
              }
              if (seed) {
                // Reintegrate element matches to eliminate the need for sorting
                if (matchedCount > 0) {
                  while (i--) {
                    if (!(unmatched[i] || setMatched[i])) {
                      setMatched[i] = pop.call(results);
                    }
                  }
                }

                // Discard index placeholder values to get only actual matches
                setMatched = condense(setMatched);
              }

              // Add matches to results
              push.apply(results, setMatched);

              // Seedless set matches succeeding multiple successful matchers stipulate sorting
              if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
                jQuery.uniqueSort(results);
              }
            }

            // Override manipulation of globals by nested matchers
            if (outermost) {
              dirruns = dirrunsUnique;
              outermostContext = contextBackup;
            }
            return unmatched;
          };
        return bySet ? markFunction(superMatcher) : superMatcher;
      }
      function compile(selector, match /* Internal Use Only */) {
        var i,
          setMatchers = [],
          elementMatchers = [],
          cached = compilerCache[selector + " "];
        if (!cached) {
          // Generate a function of recursive functions that can be used to check each element
          if (!match) {
            match = tokenize(selector);
          }
          i = match.length;
          while (i--) {
            cached = matcherFromTokens(match[i]);
            if (cached[expando]) {
              setMatchers.push(cached);
            } else {
              elementMatchers.push(cached);
            }
          }

          // Cache the compiled function
          cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

          // Save selector and tokenization
          cached.selector = selector;
        }
        return cached;
      }

      /**
       * A low-level selection function that works with jQuery's compiled
       *  selector functions
       * @param {String|Function} selector A selector or a pre-compiled
       *  selector function built with jQuery selector compile
       * @param {Element} context
       * @param {Array} [results]
       * @param {Array} [seed] A set of elements to match against
       */
      function select(selector, context, results, seed) {
        var i,
          tokens,
          token,
          type,
          find,
          compiled = typeof selector === "function" && selector,
          match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];

        // Try to minimize operations if there is only one selector in the list and no seed
        // (the latter of which guarantees us context)
        if (match.length === 1) {
          // Reduce context if the leading compound selector is an ID
          tokens = match[0] = match[0].slice(0);
          if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
            context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
            if (!context) {
              return results;

              // Precompiled matchers will still verify ancestry, so step up a level
            } else if (compiled) {
              context = context.parentNode;
            }
            selector = selector.slice(tokens.shift().value.length);
          }

          // Fetch a seed set for right-to-left matching
          i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
          while (i--) {
            token = tokens[i];

            // Abort if we hit a combinator
            if (Expr.relative[type = token.type]) {
              break;
            }
            if (find = Expr.find[type]) {
              // Search, expanding context for leading sibling combinators
              if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                // If seed is empty or no tokens remain, we can return early
                tokens.splice(i, 1);
                selector = seed.length && toSelector(tokens);
                if (!selector) {
                  push.apply(results, seed);
                  return results;
                }
                break;
              }
            }
          }
        }

        // Compile and execute a filtering function if one is not provided
        // Provide `match` to avoid retokenization if we modified the selector above
        (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
        return results;
      }

      // One-time assignments

      // Support: Android <=4.0 - 4.1+
      // Sort stability
      support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

      // Initialize against the default document
      setDocument();

      // Support: Android <=4.0 - 4.1+
      // Detached nodes confoundingly follow *each other*
      support.sortDetached = assert(function (el) {
        // Should return 1, but returns 4 (following)
        return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
      });
      jQuery.find = find;

      // Deprecated
      jQuery.expr[":"] = jQuery.expr.pseudos;
      jQuery.unique = jQuery.uniqueSort;

      // These have always been private, but they used to be documented as part of
      // Sizzle so let's maintain them for now for backwards compatibility purposes.
      find.compile = compile;
      find.select = select;
      find.setDocument = setDocument;
      find.tokenize = tokenize;
      find.escape = jQuery.escapeSelector;
      find.getText = jQuery.text;
      find.isXML = jQuery.isXMLDoc;
      find.selectors = jQuery.expr;
      find.support = jQuery.support;
      find.uniqueSort = jQuery.uniqueSort;

      /* eslint-enable */
    })();
    var dir = function dir(elem, _dir, until) {
      var matched = [],
        truncate = until !== undefined;
      while ((elem = elem[_dir]) && elem.nodeType !== 9) {
        if (elem.nodeType === 1) {
          if (truncate && jQuery(elem).is(until)) {
            break;
          }
          matched.push(elem);
        }
      }
      return matched;
    };
    var _siblings = function siblings(n, elem) {
      var matched = [];
      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== elem) {
          matched.push(n);
        }
      }
      return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
      if (isFunction(qualifier)) {
        return jQuery.grep(elements, function (elem, i) {
          return !!qualifier.call(elem, i, elem) !== not;
        });
      }

      // Single element
      if (qualifier.nodeType) {
        return jQuery.grep(elements, function (elem) {
          return elem === qualifier !== not;
        });
      }

      // Arraylike of elements (jQuery, arguments, Array)
      if (typeof qualifier !== "string") {
        return jQuery.grep(elements, function (elem) {
          return indexOf.call(qualifier, elem) > -1 !== not;
        });
      }

      // Filtered directly for both simple and complex selectors
      return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function (expr, elems, not) {
      var elem = elems[0];
      if (not) {
        expr = ":not(" + expr + ")";
      }
      if (elems.length === 1 && elem.nodeType === 1) {
        return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
      }
      return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
        return elem.nodeType === 1;
      }));
    };
    jQuery.fn.extend({
      find: function find(selector) {
        var i,
          ret,
          len = this.length,
          self = this;
        if (typeof selector !== "string") {
          return this.pushStack(jQuery(selector).filter(function () {
            for (i = 0; i < len; i++) {
              if (jQuery.contains(self[i], this)) {
                return true;
              }
            }
          }));
        }
        ret = this.pushStack([]);
        for (i = 0; i < len; i++) {
          jQuery.find(selector, self[i], ret);
        }
        return len > 1 ? jQuery.uniqueSort(ret) : ret;
      },
      filter: function filter(selector) {
        return this.pushStack(winnow(this, selector || [], false));
      },
      not: function not(selector) {
        return this.pushStack(winnow(this, selector || [], true));
      },
      is: function is(selector) {
        return !!winnow(this,
        // If this is a positional/relative selector, check membership in the returned set
        // so $("p:first").is("p:last") won't return true for a doc with two "p".
        typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
      }
    });

    // Initialize a jQuery object

    // A central reference to the root jQuery(document)
    var rootjQuery,
      // A simple way to check for HTML strings
      // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
      // Strict HTML recognition (trac-11290: must start with <)
      // Shortcut simple #id case for speed
      rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
      init = jQuery.fn.init = function (selector, context, root) {
        var match, elem;

        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) {
          return this;
        }

        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;

        // Handle HTML strings
        if (typeof selector === "string") {
          if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
            // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [null, selector, null];
          } else {
            match = rquickExpr.exec(selector);
          }

          // Match html or make sure no context is specified for #id
          if (match && (match[1] || !context)) {
            // HANDLE: $(html) -> $(array)
            if (match[1]) {
              context = context instanceof jQuery ? context[0] : context;

              // Option to run scripts is true for back-compat
              // Intentionally let the error be thrown if parseHTML is not present
              jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

              // HANDLE: $(html, props)
              if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                for (match in context) {
                  // Properties of context are called as methods if possible
                  if (isFunction(this[match])) {
                    this[match](context[match]);

                    // ...and otherwise set as attributes
                  } else {
                    this.attr(match, context[match]);
                  }
                }
              }
              return this;

              // HANDLE: $(#id)
            } else {
              elem = document.getElementById(match[2]);
              if (elem) {
                // Inject the element directly into the jQuery object
                this[0] = elem;
                this.length = 1;
              }
              return this;
            }

            // HANDLE: $(expr, $(...))
          } else if (!context || context.jquery) {
            return (context || root).find(selector);

            // HANDLE: $(expr, context)
            // (which is just equivalent to: $(context).find(expr)
          } else {
            return this.constructor(context).find(selector);
          }

          // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
          this[0] = selector;
          this.length = 1;
          return this;

          // HANDLE: $(function)
          // Shortcut for document ready
        } else if (isFunction(selector)) {
          return root.ready !== undefined ? root.ready(selector) :
          // Execute immediately if ready is not present
          selector(jQuery);
        }
        return jQuery.makeArray(selector, this);
      };

    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;

    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/,
      // Methods guaranteed to produce a unique set when starting from a unique set
      guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
      };
    jQuery.fn.extend({
      has: function has(target) {
        var targets = jQuery(target, this),
          l = targets.length;
        return this.filter(function () {
          var i = 0;
          for (; i < l; i++) {
            if (jQuery.contains(this, targets[i])) {
              return true;
            }
          }
        });
      },
      closest: function closest(selectors, context) {
        var cur,
          i = 0,
          l = this.length,
          matched = [],
          targets = typeof selectors !== "string" && jQuery(selectors);

        // Positional selectors never match, since there's no _selection_ context
        if (!rneedsContext.test(selectors)) {
          for (; i < l; i++) {
            for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
              // Always skip document fragments
              if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :
              // Don't pass non-elements to jQuery#find
              cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                matched.push(cur);
                break;
              }
            }
          }
        }
        return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
      },
      // Determine the position of an element within the set
      index: function index(elem) {
        // No argument, return index in parent
        if (!elem) {
          return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        }

        // Index in selector
        if (typeof elem === "string") {
          return indexOf.call(jQuery(elem), this[0]);
        }

        // Locate the position of the desired element
        return indexOf.call(this,
        // If it receives a jQuery object, the first element is used
        elem.jquery ? elem[0] : elem);
      },
      add: function add(selector, context) {
        return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
      },
      addBack: function addBack(selector) {
        return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
      }
    });
    function sibling(cur, dir) {
      while ((cur = cur[dir]) && cur.nodeType !== 1) {}
      return cur;
    }
    jQuery.each({
      parent: function parent(elem) {
        var parent = elem.parentNode;
        return parent && parent.nodeType !== 11 ? parent : null;
      },
      parents: function parents(elem) {
        return dir(elem, "parentNode");
      },
      parentsUntil: function parentsUntil(elem, _i, until) {
        return dir(elem, "parentNode", until);
      },
      next: function next(elem) {
        return sibling(elem, "nextSibling");
      },
      prev: function prev(elem) {
        return sibling(elem, "previousSibling");
      },
      nextAll: function nextAll(elem) {
        return dir(elem, "nextSibling");
      },
      prevAll: function prevAll(elem) {
        return dir(elem, "previousSibling");
      },
      nextUntil: function nextUntil(elem, _i, until) {
        return dir(elem, "nextSibling", until);
      },
      prevUntil: function prevUntil(elem, _i, until) {
        return dir(elem, "previousSibling", until);
      },
      siblings: function siblings(elem) {
        return _siblings((elem.parentNode || {}).firstChild, elem);
      },
      children: function children(elem) {
        return _siblings(elem.firstChild);
      },
      contents: function contents(elem) {
        if (elem.contentDocument != null &&
        // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        getProto(elem.contentDocument)) {
          return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if (nodeName(elem, "template")) {
          elem = elem.content || elem;
        }
        return jQuery.merge([], elem.childNodes);
      }
    }, function (name, fn) {
      jQuery.fn[name] = function (until, selector) {
        var matched = jQuery.map(this, fn, until);
        if (name.slice(-5) !== "Until") {
          selector = until;
        }
        if (selector && typeof selector === "string") {
          matched = jQuery.filter(selector, matched);
        }
        if (this.length > 1) {
          // Remove duplicates
          if (!guaranteedUnique[name]) {
            jQuery.uniqueSort(matched);
          }

          // Reverse order for parents* and prev-derivatives
          if (rparentsprev.test(name)) {
            matched.reverse();
          }
        }
        return this.pushStack(matched);
      };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
      var object = {};
      jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
        object[flag] = true;
      });
      return object;
    }

    /*
     * Create a callback list using the following parameters:
     *
     *	options: an optional list of space-separated options that will change how
     *			the callback list behaves or a more traditional option object
     *
     * By default a callback list will act like an event callback list and can be
     * "fired" multiple times.
     *
     * Possible options:
     *
     *	once:			will ensure the callback list can only be fired once (like a Deferred)
     *
     *	memory:			will keep track of previous values and will call any callback added
     *					after the list has been fired right away with the latest "memorized"
     *					values (like a Deferred)
     *
     *	unique:			will ensure a callback can only be added once (no duplicate in the list)
     *
     *	stopOnFalse:	interrupt callings when a callback returns false
     *
     */
    jQuery.Callbacks = function (options) {
      // Convert options from String-formatted to Object-formatted if needed
      // (we check in cache first)
      options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
      var
        // Flag to know if list is currently firing
        firing,
        // Last fire value for non-forgettable lists
        memory,
        // Flag to know if list was already fired
        _fired,
        // Flag to prevent firing
        _locked,
        // Actual callback list
        list = [],
        // Queue of execution data for repeatable lists
        queue = [],
        // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1,
        // Fire callbacks
        fire = function fire() {
          // Enforce single-firing
          _locked = _locked || options.once;

          // Execute callbacks for all pending executions,
          // respecting firingIndex overrides and runtime changes
          _fired = firing = true;
          for (; queue.length; firingIndex = -1) {
            memory = queue.shift();
            while (++firingIndex < list.length) {
              // Run callback and check for early termination
              if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                // Jump to end and forget the data so .add doesn't re-fire
                firingIndex = list.length;
                memory = false;
              }
            }
          }

          // Forget the data if we're done with it
          if (!options.memory) {
            memory = false;
          }
          firing = false;

          // Clean up if we're done firing for good
          if (_locked) {
            // Keep an empty list if we have data for future add calls
            if (memory) {
              list = [];

              // Otherwise, this object is spent
            } else {
              list = "";
            }
          }
        },
        // Actual Callbacks object
        self = {
          // Add a callback or a collection of callbacks to the list
          add: function add() {
            if (list) {
              // If we have memory from a past run, we should fire after adding
              if (memory && !firing) {
                firingIndex = list.length - 1;
                queue.push(memory);
              }
              (function add(args) {
                jQuery.each(args, function (_, arg) {
                  if (isFunction(arg)) {
                    if (!options.unique || !self.has(arg)) {
                      list.push(arg);
                    }
                  } else if (arg && arg.length && toType(arg) !== "string") {
                    // Inspect recursively
                    add(arg);
                  }
                });
              })(arguments);
              if (memory && !firing) {
                fire();
              }
            }
            return this;
          },
          // Remove a callback from the list
          remove: function remove() {
            jQuery.each(arguments, function (_, arg) {
              var index;
              while ((index = jQuery.inArray(arg, list, index)) > -1) {
                list.splice(index, 1);

                // Handle firing indexes
                if (index <= firingIndex) {
                  firingIndex--;
                }
              }
            });
            return this;
          },
          // Check if a given callback is in the list.
          // If no argument is given, return whether or not list has callbacks attached.
          has: function has(fn) {
            return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
          },
          // Remove all callbacks from the list
          empty: function empty() {
            if (list) {
              list = [];
            }
            return this;
          },
          // Disable .fire and .add
          // Abort any current/pending executions
          // Clear all callbacks and values
          disable: function disable() {
            _locked = queue = [];
            list = memory = "";
            return this;
          },
          disabled: function disabled() {
            return !list;
          },
          // Disable .fire
          // Also disable .add unless we have memory (since it would have no effect)
          // Abort any pending executions
          lock: function lock() {
            _locked = queue = [];
            if (!memory && !firing) {
              list = memory = "";
            }
            return this;
          },
          locked: function locked() {
            return !!_locked;
          },
          // Call all callbacks with the given context and arguments
          fireWith: function fireWith(context, args) {
            if (!_locked) {
              args = args || [];
              args = [context, args.slice ? args.slice() : args];
              queue.push(args);
              if (!firing) {
                fire();
              }
            }
            return this;
          },
          // Call all the callbacks with the given arguments
          fire: function fire() {
            self.fireWith(this, arguments);
            return this;
          },
          // To know if the callbacks have already been called at least once
          fired: function fired() {
            return !!_fired;
          }
        };
      return self;
    };
    function Identity(v) {
      return v;
    }
    function Thrower(ex) {
      throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
      var method;
      try {
        // Check for promise aspect first to privilege synchronous behavior
        if (value && isFunction(method = value.promise)) {
          method.call(value).done(resolve).fail(reject);

          // Other thenables
        } else if (value && isFunction(method = value.then)) {
          method.call(value, resolve, reject);

          // Other non-thenables
        } else {
          // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
          // * false: [ value ].slice( 0 ) => resolve( value )
          // * true: [ value ].slice( 1 ) => resolve()
          resolve.apply(undefined, [value].slice(noValue));
        }

        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
      } catch (value) {
        // Support: Android 4.0 only
        // Strict mode functions invoked without .call/.apply get global-object context
        reject.apply(undefined, [value]);
      }
    }
    jQuery.extend({
      Deferred: function Deferred(func) {
        var tuples = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
          _state = "pending",
          _promise = {
            state: function state() {
              return _state;
            },
            always: function always() {
              deferred.done(arguments).fail(arguments);
              return this;
            },
            "catch": function _catch(fn) {
              return _promise.then(null, fn);
            },
            // Keep pipe for back-compat
            pipe: function pipe( /* fnDone, fnFail, fnProgress */
            ) {
              var fns = arguments;
              return jQuery.Deferred(function (newDefer) {
                jQuery.each(tuples, function (_i, tuple) {
                  // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                  var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                  // deferred.progress(function() { bind to newDefer or newDefer.notify })
                  // deferred.done(function() { bind to newDefer or newDefer.resolve })
                  // deferred.fail(function() { bind to newDefer or newDefer.reject })
                  deferred[tuple[1]](function () {
                    var returned = fn && fn.apply(this, arguments);
                    if (returned && isFunction(returned.promise)) {
                      returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                    } else {
                      newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
                    }
                  });
                });
                fns = null;
              }).promise();
            },
            then: function then(onFulfilled, onRejected, onProgress) {
              var maxDepth = 0;
              function resolve(depth, deferred, handler, special) {
                return function () {
                  var that = this,
                    args = arguments,
                    mightThrow = function mightThrow() {
                      var returned, then;

                      // Support: Promises/A+ section 2.3.3.3.3
                      // https://promisesaplus.com/#point-59
                      // Ignore double-resolution attempts
                      if (depth < maxDepth) {
                        return;
                      }
                      returned = handler.apply(that, args);

                      // Support: Promises/A+ section 2.3.1
                      // https://promisesaplus.com/#point-48
                      if (returned === deferred.promise()) {
                        throw new TypeError("Thenable self-resolution");
                      }

                      // Support: Promises/A+ sections 2.3.3.1, 3.5
                      // https://promisesaplus.com/#point-54
                      // https://promisesaplus.com/#point-75
                      // Retrieve `then` only once
                      then = returned && (
                      // Support: Promises/A+ section 2.3.4
                      // https://promisesaplus.com/#point-64
                      // Only check objects and functions for thenability
                      _typeof$1(returned) === "object" || typeof returned === "function") && returned.then;

                      // Handle a returned thenable
                      if (isFunction(then)) {
                        // Special processors (notify) just wait for resolution
                        if (special) {
                          then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

                          // Normal processors (resolve) also hook into progress
                        } else {
                          // ...and disregard older resolution values
                          maxDepth++;
                          then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                        }

                        // Handle all other returned values
                      } else {
                        // Only substitute handlers pass on context
                        // and multiple values (non-spec behavior)
                        if (handler !== Identity) {
                          that = undefined;
                          args = [returned];
                        }

                        // Process the value(s)
                        // Default process is resolve
                        (special || deferred.resolveWith)(that, args);
                      }
                    },
                    // Only normal processors (resolve) catch and reject exceptions
                    process = special ? mightThrow : function () {
                      try {
                        mightThrow();
                      } catch (e) {
                        if (jQuery.Deferred.exceptionHook) {
                          jQuery.Deferred.exceptionHook(e, process.error);
                        }

                        // Support: Promises/A+ section 2.3.3.3.4.1
                        // https://promisesaplus.com/#point-61
                        // Ignore post-resolution exceptions
                        if (depth + 1 >= maxDepth) {
                          // Only substitute handlers pass on context
                          // and multiple values (non-spec behavior)
                          if (handler !== Thrower) {
                            that = undefined;
                            args = [e];
                          }
                          deferred.rejectWith(that, args);
                        }
                      }
                    };

                  // Support: Promises/A+ section 2.3.3.3.1
                  // https://promisesaplus.com/#point-57
                  // Re-resolve promises immediately to dodge false rejection from
                  // subsequent errors
                  if (depth) {
                    process();
                  } else {
                    // Call an optional hook to record the error, in case of exception
                    // since it's otherwise lost when execution goes async
                    if (jQuery.Deferred.getErrorHook) {
                      process.error = jQuery.Deferred.getErrorHook();

                      // The deprecated alias of the above. While the name suggests
                      // returning the stack, not an error instance, jQuery just passes
                      // it directly to `console.warn` so both will work; an instance
                      // just better cooperates with source maps.
                    } else if (jQuery.Deferred.getStackHook) {
                      process.error = jQuery.Deferred.getStackHook();
                    }
                    window.setTimeout(process);
                  }
                };
              }
              return jQuery.Deferred(function (newDefer) {
                // progress_handlers.add( ... )
                tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

                // fulfilled_handlers.add( ... )
                tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

                // rejected_handlers.add( ... )
                tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
              }).promise();
            },
            // Get a promise for this deferred
            // If obj is provided, the promise aspect is added to the object
            promise: function promise(obj) {
              return obj != null ? jQuery.extend(obj, _promise) : _promise;
            }
          },
          deferred = {};

        // Add list-specific methods
        jQuery.each(tuples, function (i, tuple) {
          var list = tuple[2],
            stateString = tuple[5];

          // promise.progress = list.add
          // promise.done = list.add
          // promise.fail = list.add
          _promise[tuple[1]] = list.add;

          // Handle state
          if (stateString) {
            list.add(function () {
              // state = "resolved" (i.e., fulfilled)
              // state = "rejected"
              _state = stateString;
            },
            // rejected_callbacks.disable
            // fulfilled_callbacks.disable
            tuples[3 - i][2].disable,
            // rejected_handlers.disable
            // fulfilled_handlers.disable
            tuples[3 - i][3].disable,
            // progress_callbacks.lock
            tuples[0][2].lock,
            // progress_handlers.lock
            tuples[0][3].lock);
          }

          // progress_handlers.fire
          // fulfilled_handlers.fire
          // rejected_handlers.fire
          list.add(tuple[3].fire);

          // deferred.notify = function() { deferred.notifyWith(...) }
          // deferred.resolve = function() { deferred.resolveWith(...) }
          // deferred.reject = function() { deferred.rejectWith(...) }
          deferred[tuple[0]] = function () {
            deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
            return this;
          };

          // deferred.notifyWith = list.fireWith
          // deferred.resolveWith = list.fireWith
          // deferred.rejectWith = list.fireWith
          deferred[tuple[0] + "With"] = list.fireWith;
        });

        // Make the deferred a promise
        _promise.promise(deferred);

        // Call given func if any
        if (func) {
          func.call(deferred, deferred);
        }

        // All done!
        return deferred;
      },
      // Deferred helper
      when: function when(singleValue) {
        var
          // count of uncompleted subordinates
          remaining = arguments.length,
          // count of unprocessed arguments
          i = remaining,
          // subordinate fulfillment data
          resolveContexts = Array(i),
          resolveValues = _slice.call(arguments),
          // the primary Deferred
          primary = jQuery.Deferred(),
          // subordinate callback factory
          updateFunc = function updateFunc(i) {
            return function (value) {
              resolveContexts[i] = this;
              resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
              if (! --remaining) {
                primary.resolveWith(resolveContexts, resolveValues);
              }
            };
          };

        // Single- and empty arguments are adopted like Promise.resolve
        if (remaining <= 1) {
          adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);

          // Use .then() to unwrap secondary thenables (cf. gh-3000)
          if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
            return primary.then();
          }
        }

        // Multiple arguments are aggregated like Promise.all array elements
        while (i--) {
          adoptValue(resolveValues[i], updateFunc(i), primary.reject);
        }
        return primary.promise();
      }
    });

    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function (error, asyncError) {
      // Support: IE 8 - 9 only
      // Console exists when dev tools are open, which can happen at any time
      if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
        window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
      }
    };
    jQuery.readyException = function (error) {
      window.setTimeout(function () {
        throw error;
      });
    };

    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function (fn) {
      readyList.then(fn)

      // Wrap jQuery.readyException in a function so that the lookup
      // happens at the time of error handling instead of callback
      // registration.
      ["catch"](function (error) {
        jQuery.readyException(error);
      });
      return this;
    };
    jQuery.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: false,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function ready(wait) {
        // Abort if there are pending holds or we're already ready
        if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
          return;
        }

        // Remember that the DOM is ready
        jQuery.isReady = true;

        // If a normal DOM Ready event fired, decrement, and wait if need be
        if (wait !== true && --jQuery.readyWait > 0) {
          return;
        }

        // If there are functions bound, to execute
        readyList.resolveWith(document, [jQuery]);
      }
    });
    jQuery.ready.then = readyList.then;

    // The ready event handler and self cleanup method
    function completed() {
      document.removeEventListener("DOMContentLoaded", completed);
      window.removeEventListener("load", completed);
      jQuery.ready();
    }

    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
      // Handle it asynchronously to allow scripts the opportunity to delay ready
      window.setTimeout(jQuery.ready);
    } else {
      // Use the handy event callback
      document.addEventListener("DOMContentLoaded", completed);

      // A fallback to window.onload, that will always work
      window.addEventListener("load", completed);
    }

    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
      var i = 0,
        len = elems.length,
        bulk = key == null;

      // Sets many values
      if (toType(key) === "object") {
        chainable = true;
        for (i in key) {
          access(elems, fn, i, key[i], true, emptyGet, raw);
        }

        // Sets one value
      } else if (value !== undefined) {
        chainable = true;
        if (!isFunction(value)) {
          raw = true;
        }
        if (bulk) {
          // Bulk operations run against the entire set
          if (raw) {
            fn.call(elems, value);
            fn = null;

            // ...except when executing function values
          } else {
            bulk = fn;
            fn = function fn(elem, _key, value) {
              return bulk.call(jQuery(elem), value);
            };
          }
        }
        if (fn) {
          for (; i < len; i++) {
            fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
          }
        }
      }
      if (chainable) {
        return elems;
      }

      // Gets
      if (bulk) {
        return fn.call(elems);
      }
      return len ? fn(elems[0], key) : emptyGet;
    };

    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/,
      rdashAlpha = /-([a-z])/g;

    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
      return letter.toUpperCase();
    }

    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
      return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
      // Accepts only:
      //  - Node
      //    - Node.ELEMENT_NODE
      //    - Node.DOCUMENT_NODE
      //  - Object
      //    - Any
      return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
      this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
      cache: function cache(owner) {
        // Check if the owner object already has a cache
        var value = owner[this.expando];

        // If not, create one
        if (!value) {
          value = {};

          // We can accept data for non-element nodes in modern browsers,
          // but we should not, see trac-8335.
          // Always return an empty object.
          if (acceptData(owner)) {
            // If it is a node unlikely to be stringify-ed or looped over
            // use plain assignment
            if (owner.nodeType) {
              owner[this.expando] = value;

              // Otherwise secure it in a non-enumerable property
              // configurable must be true to allow the property to be
              // deleted when data is removed
            } else {
              Object.defineProperty(owner, this.expando, {
                value: value,
                configurable: true
              });
            }
          }
        }
        return value;
      },
      set: function set(owner, data, value) {
        var prop,
          cache = this.cache(owner);

        // Handle: [ owner, key, value ] args
        // Always use camelCase key (gh-2257)
        if (typeof data === "string") {
          cache[camelCase(data)] = value;

          // Handle: [ owner, { properties } ] args
        } else {
          // Copy the properties one-by-one to the cache object
          for (prop in data) {
            cache[camelCase(prop)] = data[prop];
          }
        }
        return cache;
      },
      get: function get(owner, key) {
        return key === undefined ? this.cache(owner) :
        // Always use camelCase key (gh-2257)
        owner[this.expando] && owner[this.expando][camelCase(key)];
      },
      access: function access(owner, key, value) {
        // In cases where either:
        //
        //   1. No key was specified
        //   2. A string key was specified, but no value provided
        //
        // Take the "read" path and allow the get method to determine
        // which value to return, respectively either:
        //
        //   1. The entire cache object
        //   2. The data stored at the key
        //
        if (key === undefined || key && typeof key === "string" && value === undefined) {
          return this.get(owner, key);
        }

        // When the key is not a string, or both a key and value
        // are specified, set or extend (existing objects) with either:
        //
        //   1. An object of properties
        //   2. A key and value
        //
        this.set(owner, key, value);

        // Since the "set" path can have two possible entry points
        // return the expected data based on which path was taken[*]
        return value !== undefined ? value : key;
      },
      remove: function remove(owner, key) {
        var i,
          cache = owner[this.expando];
        if (cache === undefined) {
          return;
        }
        if (key !== undefined) {
          // Support array or space separated string of keys
          if (Array.isArray(key)) {
            // If key is an array of keys...
            // We always set camelCase keys, so remove that.
            key = key.map(camelCase);
          } else {
            key = camelCase(key);

            // If a key with the spaces exists, use it.
            // Otherwise, create an array by matching non-whitespace
            key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
          }
          i = key.length;
          while (i--) {
            delete cache[key[i]];
          }
        }

        // Remove the expando if there's no more data
        if (key === undefined || jQuery.isEmptyObject(cache)) {
          // Support: Chrome <=35 - 45
          // Webkit & Blink performance suffers when deleting properties
          // from DOM nodes, so set to undefined instead
          // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
          if (owner.nodeType) {
            owner[this.expando] = undefined;
          } else {
            delete owner[this.expando];
          }
        }
      },
      hasData: function hasData(owner) {
        var cache = owner[this.expando];
        return cache !== undefined && !jQuery.isEmptyObject(cache);
      }
    };
    var dataPriv = new Data();
    var dataUser = new Data();

    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      rmultiDash = /[A-Z]/g;
    function getData(data) {
      if (data === "true") {
        return true;
      }
      if (data === "false") {
        return false;
      }
      if (data === "null") {
        return null;
      }

      // Only convert to a number if it doesn't change the string
      if (data === +data + "") {
        return +data;
      }
      if (rbrace.test(data)) {
        return JSON.parse(data);
      }
      return data;
    }
    function dataAttr(elem, key, data) {
      var name;

      // If nothing was found internally, try to fetch any
      // data from the HTML5 data-* attribute
      if (data === undefined && elem.nodeType === 1) {
        name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
        data = elem.getAttribute(name);
        if (typeof data === "string") {
          try {
            data = getData(data);
          } catch (e) {}

          // Make sure we set the data so it isn't changed later
          dataUser.set(elem, key, data);
        } else {
          data = undefined;
        }
      }
      return data;
    }
    jQuery.extend({
      hasData: function hasData(elem) {
        return dataUser.hasData(elem) || dataPriv.hasData(elem);
      },
      data: function data(elem, name, _data) {
        return dataUser.access(elem, name, _data);
      },
      removeData: function removeData(elem, name) {
        dataUser.remove(elem, name);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function _data(elem, name, data) {
        return dataPriv.access(elem, name, data);
      },
      _removeData: function _removeData(elem, name) {
        dataPriv.remove(elem, name);
      }
    });
    jQuery.fn.extend({
      data: function data(key, value) {
        var i,
          name,
          data,
          elem = this[0],
          attrs = elem && elem.attributes;

        // Gets all values
        if (key === undefined) {
          if (this.length) {
            data = dataUser.get(elem);
            if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
              i = attrs.length;
              while (i--) {
                // Support: IE 11 only
                // The attrs elements can be null (trac-14894)
                if (attrs[i]) {
                  name = attrs[i].name;
                  if (name.indexOf("data-") === 0) {
                    name = camelCase(name.slice(5));
                    dataAttr(elem, name, data[name]);
                  }
                }
              }
              dataPriv.set(elem, "hasDataAttrs", true);
            }
          }
          return data;
        }

        // Sets multiple values
        if (_typeof$1(key) === "object") {
          return this.each(function () {
            dataUser.set(this, key);
          });
        }
        return access(this, function (value) {
          var data;

          // The calling jQuery object (element matches) is not empty
          // (and therefore has an element appears at this[ 0 ]) and the
          // `value` parameter was not undefined. An empty jQuery object
          // will result in `undefined` for elem = this[ 0 ] which will
          // throw an exception if an attempt to read a data cache is made.
          if (elem && value === undefined) {
            // Attempt to get data from the cache
            // The key will always be camelCased in Data
            data = dataUser.get(elem, key);
            if (data !== undefined) {
              return data;
            }

            // Attempt to "discover" the data in
            // HTML5 custom data-* attrs
            data = dataAttr(elem, key);
            if (data !== undefined) {
              return data;
            }

            // We tried really hard, but the data doesn't exist.
            return;
          }

          // Set the data...
          this.each(function () {
            // We always store the camelCased key
            dataUser.set(this, key, value);
          });
        }, null, value, arguments.length > 1, null, true);
      },
      removeData: function removeData(key) {
        return this.each(function () {
          dataUser.remove(this, key);
        });
      }
    });
    jQuery.extend({
      queue: function queue(elem, type, data) {
        var queue;
        if (elem) {
          type = (type || "fx") + "queue";
          queue = dataPriv.get(elem, type);

          // Speed up dequeue by getting out quickly if this is just a lookup
          if (data) {
            if (!queue || Array.isArray(data)) {
              queue = dataPriv.access(elem, type, jQuery.makeArray(data));
            } else {
              queue.push(data);
            }
          }
          return queue || [];
        }
      },
      dequeue: function dequeue(elem, type) {
        type = type || "fx";
        var queue = jQuery.queue(elem, type),
          startLength = queue.length,
          fn = queue.shift(),
          hooks = jQuery._queueHooks(elem, type),
          next = function next() {
            jQuery.dequeue(elem, type);
          };

        // If the fx queue is dequeued, always remove the progress sentinel
        if (fn === "inprogress") {
          fn = queue.shift();
          startLength--;
        }
        if (fn) {
          // Add a progress sentinel to prevent the fx queue from being
          // automatically dequeued
          if (type === "fx") {
            queue.unshift("inprogress");
          }

          // Clear up the last queue stop function
          delete hooks.stop;
          fn.call(elem, next, hooks);
        }
        if (!startLength && hooks) {
          hooks.empty.fire();
        }
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function _queueHooks(elem, type) {
        var key = type + "queueHooks";
        return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
          empty: jQuery.Callbacks("once memory").add(function () {
            dataPriv.remove(elem, [type + "queue", key]);
          })
        });
      }
    });
    jQuery.fn.extend({
      queue: function queue(type, data) {
        var setter = 2;
        if (typeof type !== "string") {
          data = type;
          type = "fx";
          setter--;
        }
        if (arguments.length < setter) {
          return jQuery.queue(this[0], type);
        }
        return data === undefined ? this : this.each(function () {
          var queue = jQuery.queue(this, type, data);

          // Ensure a hooks for this queue
          jQuery._queueHooks(this, type);
          if (type === "fx" && queue[0] !== "inprogress") {
            jQuery.dequeue(this, type);
          }
        });
      },
      dequeue: function dequeue(type) {
        return this.each(function () {
          jQuery.dequeue(this, type);
        });
      },
      clearQueue: function clearQueue(type) {
        return this.queue(type || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function promise(type, obj) {
        var tmp,
          count = 1,
          defer = jQuery.Deferred(),
          elements = this,
          i = this.length,
          resolve = function resolve() {
            if (! --count) {
              defer.resolveWith(elements, [elements]);
            }
          };
        if (typeof type !== "string") {
          obj = type;
          type = undefined;
        }
        type = type || "fx";
        while (i--) {
          tmp = dataPriv.get(elements[i], type + "queueHooks");
          if (tmp && tmp.empty) {
            count++;
            tmp.empty.add(resolve);
          }
        }
        resolve();
        return defer.promise(obj);
      }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = ["Top", "Right", "Bottom", "Left"];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
      },
      composed = {
        composed: true
      };

    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) {
      isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
      };
    }
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
      // isHiddenWithinTree might be called from jQuery#filter function;
      // in that case, element will be second argument
      elem = el || elem;

      // Inline style trumps all
      return elem.style.display === "none" || elem.style.display === "" &&
      // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
      var adjusted,
        scale,
        maxIterations = 20,
        currentValue = tween ? function () {
          return tween.cur();
        } : function () {
          return jQuery.css(elem, prop, "");
        },
        initial = currentValue(),
        unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
        // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
      if (initialInUnit && initialInUnit[3] !== unit) {
        // Support: Firefox <=54
        // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
        initial = initial / 2;

        // Trust units reported by jQuery.css
        unit = unit || initialInUnit[3];

        // Iteratively approximate from a nonzero starting point
        initialInUnit = +initial || 1;
        while (maxIterations--) {
          // Evaluate and update our best guess (doubling guesses that zero out).
          // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
          jQuery.style(elem, prop, initialInUnit + unit);
          if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
            maxIterations = 0;
          }
          initialInUnit = initialInUnit / scale;
        }
        initialInUnit = initialInUnit * 2;
        jQuery.style(elem, prop, initialInUnit + unit);

        // Make sure we update the tween properties later on
        valueParts = valueParts || [];
      }
      if (valueParts) {
        initialInUnit = +initialInUnit || +initial || 0;

        // Apply relative offset (+=/-=) if specified
        adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
        if (tween) {
          tween.unit = unit;
          tween.start = initialInUnit;
          tween.end = adjusted;
        }
      }
      return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
      var temp,
        doc = elem.ownerDocument,
        nodeName = elem.nodeName,
        display = defaultDisplayMap[nodeName];
      if (display) {
        return display;
      }
      temp = doc.body.appendChild(doc.createElement(nodeName));
      display = jQuery.css(temp, "display");
      temp.parentNode.removeChild(temp);
      if (display === "none") {
        display = "block";
      }
      defaultDisplayMap[nodeName] = display;
      return display;
    }
    function showHide(elements, show) {
      var display,
        elem,
        values = [],
        index = 0,
        length = elements.length;

      // Determine new display value for elements that need to change
      for (; index < length; index++) {
        elem = elements[index];
        if (!elem.style) {
          continue;
        }
        display = elem.style.display;
        if (show) {
          // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
          // check is required in this first loop unless we have a nonempty display value (either
          // inline or about-to-be-restored)
          if (display === "none") {
            values[index] = dataPriv.get(elem, "display") || null;
            if (!values[index]) {
              elem.style.display = "";
            }
          }
          if (elem.style.display === "" && isHiddenWithinTree(elem)) {
            values[index] = getDefaultDisplay(elem);
          }
        } else {
          if (display !== "none") {
            values[index] = "none";

            // Remember what we're overwriting
            dataPriv.set(elem, "display", display);
          }
        }
      }

      // Set the display of the elements in a second loop to avoid constant reflow
      for (index = 0; index < length; index++) {
        if (values[index] != null) {
          elements[index].style.display = values[index];
        }
      }
      return elements;
    }
    jQuery.fn.extend({
      show: function show() {
        return showHide(this, true);
      },
      hide: function hide() {
        return showHide(this);
      },
      toggle: function toggle(state) {
        if (typeof state === "boolean") {
          return state ? this.show() : this.hide();
        }
        return this.each(function () {
          if (isHiddenWithinTree(this)) {
            jQuery(this).show();
          } else {
            jQuery(this).hide();
          }
        });
      }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function () {
      var fragment = document.createDocumentFragment(),
        div = fragment.appendChild(document.createElement("div")),
        input = document.createElement("input");

      // Support: Android 4.0 - 4.3 only
      // Check state lost if the name is set (trac-11217)
      // Support: Windows Web Apps (WWA)
      // `name` and `type` must use .setAttribute for WWA (trac-14901)
      input.setAttribute("type", "radio");
      input.setAttribute("checked", "checked");
      input.setAttribute("name", "t");
      div.appendChild(input);

      // Support: Android <=4.1 only
      // Older WebKit doesn't clone checked state correctly in fragments
      support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

      // Support: IE <=11 only
      // Make sure textarea (and checkbox) defaultValue is properly cloned
      div.innerHTML = "<textarea>x</textarea>";
      support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

      // Support: IE <=9 only
      // IE <=9 replaces <option> tags with their contents when inserted outside of
      // the select element.
      div.innerHTML = "<option></option>";
      support.option = !!div.lastChild;
    })();

    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;

    // Support: IE <=9 only
    if (!support.option) {
      wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
    }
    function getAll(context, tag) {
      // Support: IE <=9 - 11 only
      // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
      var ret;
      if (typeof context.getElementsByTagName !== "undefined") {
        ret = context.getElementsByTagName(tag || "*");
      } else if (typeof context.querySelectorAll !== "undefined") {
        ret = context.querySelectorAll(tag || "*");
      } else {
        ret = [];
      }
      if (tag === undefined || tag && nodeName(context, tag)) {
        return jQuery.merge([context], ret);
      }
      return ret;
    }

    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
      var i = 0,
        l = elems.length;
      for (; i < l; i++) {
        dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
      }
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
      var elem,
        tmp,
        tag,
        wrap,
        attached,
        j,
        fragment = context.createDocumentFragment(),
        nodes = [],
        i = 0,
        l = elems.length;
      for (; i < l; i++) {
        elem = elems[i];
        if (elem || elem === 0) {
          // Add nodes directly
          if (toType(elem) === "object") {
            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

            // Convert non-html into a text node
          } else if (!rhtml.test(elem)) {
            nodes.push(context.createTextNode(elem));

            // Convert html into DOM nodes
          } else {
            tmp = tmp || fragment.appendChild(context.createElement("div"));

            // Deserialize a standard representation
            tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
            wrap = wrapMap[tag] || wrapMap._default;
            tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

            // Descend through wrappers to the right content
            j = wrap[0];
            while (j--) {
              tmp = tmp.lastChild;
            }

            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            jQuery.merge(nodes, tmp.childNodes);

            // Remember the top-level container
            tmp = fragment.firstChild;

            // Ensure the created nodes are orphaned (trac-12392)
            tmp.textContent = "";
          }
        }
      }

      // Remove wrapper from fragment
      fragment.textContent = "";
      i = 0;
      while (elem = nodes[i++]) {
        // Skip elements already in the context collection (trac-4087)
        if (selection && jQuery.inArray(elem, selection) > -1) {
          if (ignored) {
            ignored.push(elem);
          }
          continue;
        }
        attached = isAttached(elem);

        // Append to fragment
        tmp = getAll(fragment.appendChild(elem), "script");

        // Preserve script evaluation history
        if (attached) {
          setGlobalEval(tmp);
        }

        // Capture executables
        if (scripts) {
          j = 0;
          while (elem = tmp[j++]) {
            if (rscriptType.test(elem.type || "")) {
              scripts.push(elem);
            }
          }
        }
      }
      return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
      return true;
    }
    function returnFalse() {
      return false;
    }
    function _on(elem, types, selector, data, fn, one) {
      var origFn, type;

      // Types can be a map of types/handlers
      if (_typeof$1(types) === "object") {
        // ( types-Object, selector, data )
        if (typeof selector !== "string") {
          // ( types-Object, data )
          data = data || selector;
          selector = undefined;
        }
        for (type in types) {
          _on(elem, type, selector, data, types[type], one);
        }
        return elem;
      }
      if (data == null && fn == null) {
        // ( types, fn )
        fn = selector;
        data = selector = undefined;
      } else if (fn == null) {
        if (typeof selector === "string") {
          // ( types, selector, fn )
          fn = data;
          data = undefined;
        } else {
          // ( types, data, fn )
          fn = data;
          data = selector;
          selector = undefined;
        }
      }
      if (fn === false) {
        fn = returnFalse;
      } else if (!fn) {
        return elem;
      }
      if (one === 1) {
        origFn = fn;
        fn = function fn(event) {
          // Can use an empty set, since event contains the info
          jQuery().off(event);
          return origFn.apply(this, arguments);
        };

        // Use same guid so caller can remove using origFn
        fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
      }
      return elem.each(function () {
        jQuery.event.add(this, types, fn, data, selector);
      });
    }

    /*
     * Helper functions for managing events -- not part of the public interface.
     * Props to Dean Edwards' addEvent library for many of the ideas.
     */
    jQuery.event = {
      global: {},
      add: function add(elem, types, handler, data, selector) {
        var handleObjIn,
          eventHandle,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.get(elem);

        // Only attach events to objects that accept data
        if (!acceptData(elem)) {
          return;
        }

        // Caller can pass in an object of custom data in lieu of the handler
        if (handler.handler) {
          handleObjIn = handler;
          handler = handleObjIn.handler;
          selector = handleObjIn.selector;
        }

        // Ensure that invalid selectors throw exceptions at attach time
        // Evaluate against documentElement in case elem is a non-element node (e.g., document)
        if (selector) {
          jQuery.find.matchesSelector(documentElement, selector);
        }

        // Make sure that the handler has a unique ID, used to find/remove it later
        if (!handler.guid) {
          handler.guid = jQuery.guid++;
        }

        // Init the element's event structure and main handler, if this is the first
        if (!(events = elemData.events)) {
          events = elemData.events = Object.create(null);
        }
        if (!(eventHandle = elemData.handle)) {
          eventHandle = elemData.handle = function (e) {
            // Discard the second event of a jQuery.event.trigger() and
            // when an event is called after a page has unloaded
            return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
          };
        }

        // Handle multiple events separated by a space
        types = (types || "").match(rnothtmlwhite) || [""];
        t = types.length;
        while (t--) {
          tmp = rtypenamespace.exec(types[t]) || [];
          type = origType = tmp[1];
          namespaces = (tmp[2] || "").split(".").sort();

          // There *must* be a type, no attaching namespace-only handlers
          if (!type) {
            continue;
          }

          // If event changes its type, use the special event handlers for the changed type
          special = jQuery.event.special[type] || {};

          // If selector defined, determine special event api type, otherwise given type
          type = (selector ? special.delegateType : special.bindType) || type;

          // Update special based on newly reset type
          special = jQuery.event.special[type] || {};

          // handleObj is passed to all event handlers
          handleObj = jQuery.extend({
            type: type,
            origType: origType,
            data: data,
            handler: handler,
            guid: handler.guid,
            selector: selector,
            needsContext: selector && jQuery.expr.match.needsContext.test(selector),
            namespace: namespaces.join(".")
          }, handleObjIn);

          // Init the event handler queue if we're the first
          if (!(handlers = events[type])) {
            handlers = events[type] = [];
            handlers.delegateCount = 0;

            // Only use addEventListener if the special events handler returns false
            if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
              if (elem.addEventListener) {
                elem.addEventListener(type, eventHandle);
              }
            }
          }
          if (special.add) {
            special.add.call(elem, handleObj);
            if (!handleObj.handler.guid) {
              handleObj.handler.guid = handler.guid;
            }
          }

          // Add to the element's handler list, delegates in front
          if (selector) {
            handlers.splice(handlers.delegateCount++, 0, handleObj);
          } else {
            handlers.push(handleObj);
          }

          // Keep track of which events have ever been used, for event optimization
          jQuery.event.global[type] = true;
        }
      },
      // Detach an event or set of events from an element
      remove: function remove(elem, types, handler, selector, mappedTypes) {
        var j,
          origCount,
          tmp,
          events,
          t,
          handleObj,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
        if (!elemData || !(events = elemData.events)) {
          return;
        }

        // Once for each type.namespace in types; type may be omitted
        types = (types || "").match(rnothtmlwhite) || [""];
        t = types.length;
        while (t--) {
          tmp = rtypenamespace.exec(types[t]) || [];
          type = origType = tmp[1];
          namespaces = (tmp[2] || "").split(".").sort();

          // Unbind all events (on this namespace, if provided) for the element
          if (!type) {
            for (type in events) {
              jQuery.event.remove(elem, type + types[t], handler, selector, true);
            }
            continue;
          }
          special = jQuery.event.special[type] || {};
          type = (selector ? special.delegateType : special.bindType) || type;
          handlers = events[type] || [];
          tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

          // Remove matching events
          origCount = j = handlers.length;
          while (j--) {
            handleObj = handlers[j];
            if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
              handlers.splice(j, 1);
              if (handleObj.selector) {
                handlers.delegateCount--;
              }
              if (special.remove) {
                special.remove.call(elem, handleObj);
              }
            }
          }

          // Remove generic event handler if we removed something and no more handlers exist
          // (avoids potential for endless recursion during removal of special event handlers)
          if (origCount && !handlers.length) {
            if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
              jQuery.removeEvent(elem, type, elemData.handle);
            }
            delete events[type];
          }
        }

        // Remove data and the expando if it's no longer used
        if (jQuery.isEmptyObject(events)) {
          dataPriv.remove(elem, "handle events");
        }
      },
      dispatch: function dispatch(nativeEvent) {
        var i,
          j,
          ret,
          matched,
          handleObj,
          handlerQueue,
          args = new Array(arguments.length),
          // Make a writable jQuery.Event from the native event object
          event = jQuery.event.fix(nativeEvent),
          handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
          special = jQuery.event.special[event.type] || {};

        // Use the fix-ed jQuery.Event rather than the (read-only) native event
        args[0] = event;
        for (i = 1; i < arguments.length; i++) {
          args[i] = arguments[i];
        }
        event.delegateTarget = this;

        // Call the preDispatch hook for the mapped type, and let it bail if desired
        if (special.preDispatch && special.preDispatch.call(this, event) === false) {
          return;
        }

        // Determine handlers
        handlerQueue = jQuery.event.handlers.call(this, event, handlers);

        // Run delegates first; they may want to stop propagation beneath us
        i = 0;
        while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
          event.currentTarget = matched.elem;
          j = 0;
          while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
            // If the event is namespaced, then each handler is only invoked if it is
            // specially universal or its namespaces are a superset of the event's.
            if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
              event.handleObj = handleObj;
              event.data = handleObj.data;
              ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
              if (ret !== undefined) {
                if ((event.result = ret) === false) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              }
            }
          }
        }

        // Call the postDispatch hook for the mapped type
        if (special.postDispatch) {
          special.postDispatch.call(this, event);
        }
        return event.result;
      },
      handlers: function handlers(event, _handlers) {
        var i,
          handleObj,
          sel,
          matchedHandlers,
          matchedSelectors,
          handlerQueue = [],
          delegateCount = _handlers.delegateCount,
          cur = event.target;

        // Find delegate handlers
        if (delegateCount &&
        // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        cur.nodeType &&
        // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(event.type === "click" && event.button >= 1)) {
          for (; cur !== this; cur = cur.parentNode || this) {
            // Don't check non-elements (trac-13208)
            // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
            if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
              matchedHandlers = [];
              matchedSelectors = {};
              for (i = 0; i < delegateCount; i++) {
                handleObj = _handlers[i];

                // Don't conflict with Object.prototype properties (trac-13203)
                sel = handleObj.selector + " ";
                if (matchedSelectors[sel] === undefined) {
                  matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
                }
                if (matchedSelectors[sel]) {
                  matchedHandlers.push(handleObj);
                }
              }
              if (matchedHandlers.length) {
                handlerQueue.push({
                  elem: cur,
                  handlers: matchedHandlers
                });
              }
            }
          }
        }

        // Add the remaining (directly-bound) handlers
        cur = this;
        if (delegateCount < _handlers.length) {
          handlerQueue.push({
            elem: cur,
            handlers: _handlers.slice(delegateCount)
          });
        }
        return handlerQueue;
      },
      addProp: function addProp(name, hook) {
        Object.defineProperty(jQuery.Event.prototype, name, {
          enumerable: true,
          configurable: true,
          get: isFunction(hook) ? function () {
            if (this.originalEvent) {
              return hook(this.originalEvent);
            }
          } : function () {
            if (this.originalEvent) {
              return this.originalEvent[name];
            }
          },
          set: function set(value) {
            Object.defineProperty(this, name, {
              enumerable: true,
              configurable: true,
              writable: true,
              value: value
            });
          }
        });
      },
      fix: function fix(originalEvent) {
        return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: true
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function setup(data) {
            // For mutual compressibility with _default, replace `this` access with a local var.
            // `|| data` is dead code meant only to preserve the variable through minification.
            var el = this || data;

            // Claim the first handler
            if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
              // dataPriv.set( el, "click", ... )
              leverageNative(el, "click", true);
            }

            // Return false to allow normal processing in the caller
            return false;
          },
          trigger: function trigger(data) {
            // For mutual compressibility with _default, replace `this` access with a local var.
            // `|| data` is dead code meant only to preserve the variable through minification.
            var el = this || data;

            // Force setup before triggering a click
            if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
              leverageNative(el, "click");
            }

            // Return non-false to allow normal event-path propagation
            return true;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function _default(event) {
            var target = event.target;
            return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
          }
        },
        beforeunload: {
          postDispatch: function postDispatch(event) {
            // Support: Firefox 20+
            // Firefox doesn't alert if the returnValue field is not set.
            if (event.result !== undefined && event.originalEvent) {
              event.originalEvent.returnValue = event.result;
            }
          }
        }
      }
    };

    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
      // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
      if (!isSetup) {
        if (dataPriv.get(el, type) === undefined) {
          jQuery.event.add(el, type, returnTrue);
        }
        return;
      }

      // Register the controller as a special universal handler for all event namespaces
      dataPriv.set(el, type, false);
      jQuery.event.add(el, type, {
        namespace: false,
        handler: function handler(event) {
          var result,
            saved = dataPriv.get(this, type);
          if (event.isTrigger & 1 && this[type]) {
            // Interrupt processing of the outer synthetic .trigger()ed event
            if (!saved) {
              // Store arguments for use when handling the inner native event
              // There will always be at least one argument (an event object), so this array
              // will not be confused with a leftover capture object.
              saved = _slice.call(arguments);
              dataPriv.set(this, type, saved);

              // Trigger the native event and capture its result
              this[type]();
              result = dataPriv.get(this, type);
              dataPriv.set(this, type, false);
              if (saved !== result) {
                // Cancel the outer synthetic event
                event.stopImmediatePropagation();
                event.preventDefault();
                return result;
              }

              // If this is an inner synthetic event for an event with a bubbling surrogate
              // (focus or blur), assume that the surrogate already propagated from triggering
              // the native event and prevent that from happening again here.
              // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
              // bubbling surrogate propagates *after* the non-bubbling base), but that seems
              // less bad than duplication.
            } else if ((jQuery.event.special[type] || {}).delegateType) {
              event.stopPropagation();
            }

            // If this is a native event triggered above, everything is now in order
            // Fire an inner synthetic event with the original arguments
          } else if (saved) {
            // ...and capture the result
            dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));

            // Abort handling of the native event by all jQuery handlers while allowing
            // native handlers on the same element to run. On target, this is achieved
            // by stopping immediate propagation just on the jQuery event. However,
            // the native event is re-wrapped by a jQuery one on each level of the
            // propagation so the only way to stop it for jQuery is to stop it for
            // everyone via native `stopPropagation()`. This is not a problem for
            // focus/blur which don't bubble, but it does also stop click on checkboxes
            // and radios. We accept this limitation.
            event.stopPropagation();
            event.isImmediatePropagationStopped = returnTrue;
          }
        }
      });
    }
    jQuery.removeEvent = function (elem, type, handle) {
      // This "if" is needed for plain objects
      if (elem.removeEventListener) {
        elem.removeEventListener(type, handle);
      }
    };
    jQuery.Event = function (src, props) {
      // Allow instantiation without the 'new' keyword
      if (!(this instanceof jQuery.Event)) {
        return new jQuery.Event(src, props);
      }

      // Event object
      if (src && src.type) {
        this.originalEvent = src;
        this.type = src.type;

        // Events bubbling up the document may have been marked as prevented
        // by a handler lower down the tree; reflect the correct value.
        this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&
        // Support: Android <=2.3 only
        src.returnValue === false ? returnTrue : returnFalse;

        // Create target properties
        // Support: Safari <=6 - 7 only
        // Target should not be a text node (trac-504, trac-13143)
        this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
        this.currentTarget = src.currentTarget;
        this.relatedTarget = src.relatedTarget;

        // Event type
      } else {
        this.type = src;
      }

      // Put explicitly provided properties onto the event object
      if (props) {
        jQuery.extend(this, props);
      }

      // Create a timestamp if incoming event doesn't have one
      this.timeStamp = src && src.timeStamp || Date.now();

      // Mark it as fixed
      this[jQuery.expando] = true;
    };

    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
      constructor: jQuery.Event,
      isDefaultPrevented: returnFalse,
      isPropagationStopped: returnFalse,
      isImmediatePropagationStopped: returnFalse,
      isSimulated: false,
      preventDefault: function preventDefault() {
        var e = this.originalEvent;
        this.isDefaultPrevented = returnTrue;
        if (e && !this.isSimulated) {
          e.preventDefault();
        }
      },
      stopPropagation: function stopPropagation() {
        var e = this.originalEvent;
        this.isPropagationStopped = returnTrue;
        if (e && !this.isSimulated) {
          e.stopPropagation();
        }
      },
      stopImmediatePropagation: function stopImmediatePropagation() {
        var e = this.originalEvent;
        this.isImmediatePropagationStopped = returnTrue;
        if (e && !this.isSimulated) {
          e.stopImmediatePropagation();
        }
        this.stopPropagation();
      }
    };

    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
      altKey: true,
      bubbles: true,
      cancelable: true,
      changedTouches: true,
      ctrlKey: true,
      detail: true,
      eventPhase: true,
      metaKey: true,
      pageX: true,
      pageY: true,
      shiftKey: true,
      view: true,
      "char": true,
      code: true,
      charCode: true,
      key: true,
      keyCode: true,
      button: true,
      buttons: true,
      clientX: true,
      clientY: true,
      offsetX: true,
      offsetY: true,
      pointerId: true,
      pointerType: true,
      screenX: true,
      screenY: true,
      targetTouches: true,
      toElement: true,
      touches: true,
      which: true
    }, jQuery.event.addProp);
    jQuery.each({
      focus: "focusin",
      blur: "focusout"
    }, function (type, delegateType) {
      function focusMappedHandler(nativeEvent) {
        if (document.documentMode) {
          // Support: IE 11+
          // Attach a single focusin/focusout handler on the document while someone wants
          // focus/blur. This is because the former are synchronous in IE while the latter
          // are async. In other browsers, all those handlers are invoked synchronously.

          // `handle` from private data would already wrap the event, but we need
          // to change the `type` here.
          var handle = dataPriv.get(this, "handle"),
            event = jQuery.event.fix(nativeEvent);
          event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
          event.isSimulated = true;

          // First, handle focusin/focusout
          handle(nativeEvent);

          // ...then, handle focus/blur
          //
          // focus/blur don't bubble while focusin/focusout do; simulate the former by only
          // invoking the handler at the lower level.
          if (event.target === event.currentTarget) {
            // The setup part calls `leverageNative`, which, in turn, calls
            // `jQuery.event.add`, so event handle will already have been set
            // by this point.
            handle(event);
          }
        } else {
          // For non-IE browsers, attach a single capturing handler on the document
          // while someone wants focusin/focusout.
          jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
      }
      jQuery.event.special[type] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function setup() {
          var attaches;

          // Claim the first handler
          // dataPriv.set( this, "focus", ... )
          // dataPriv.set( this, "blur", ... )
          leverageNative(this, type, true);
          if (document.documentMode) {
            // Support: IE 9 - 11+
            // We use the same native handler for focusin & focus (and focusout & blur)
            // so we need to coordinate setup & teardown parts between those events.
            // Use `delegateType` as the key as `type` is already used by `leverageNative`.
            attaches = dataPriv.get(this, delegateType);
            if (!attaches) {
              this.addEventListener(delegateType, focusMappedHandler);
            }
            dataPriv.set(this, delegateType, (attaches || 0) + 1);
          } else {
            // Return false to allow normal processing in the caller
            return false;
          }
        },
        trigger: function trigger() {
          // Force setup before trigger
          leverageNative(this, type);

          // Return non-false to allow normal event-path propagation
          return true;
        },
        teardown: function teardown() {
          var attaches;
          if (document.documentMode) {
            attaches = dataPriv.get(this, delegateType) - 1;
            if (!attaches) {
              this.removeEventListener(delegateType, focusMappedHandler);
              dataPriv.remove(this, delegateType);
            } else {
              dataPriv.set(this, delegateType, attaches);
            }
          } else {
            // Return false to indicate standard teardown should be applied
            return false;
          }
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function _default(event) {
          return dataPriv.get(event.target, type);
        },
        delegateType: delegateType
      };

      // Support: Firefox <=44
      // Firefox doesn't have focus(in | out) events
      // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
      //
      // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
      // focus(in | out) events fire after focus & blur events,
      // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
      // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
      //
      // Support: IE 9 - 11+
      // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
      // attach a single handler for both events in IE.
      jQuery.event.special[delegateType] = {
        setup: function setup() {
          // Handle: regular nodes (via `this.ownerDocument`), window
          // (via `this.document`) & document (via `this`).
          var doc = this.ownerDocument || this.document || this,
            dataHolder = document.documentMode ? this : doc,
            attaches = dataPriv.get(dataHolder, delegateType);

          // Support: IE 9 - 11+
          // We use the same native handler for focusin & focus (and focusout & blur)
          // so we need to coordinate setup & teardown parts between those events.
          // Use `delegateType` as the key as `type` is already used by `leverageNative`.
          if (!attaches) {
            if (document.documentMode) {
              this.addEventListener(delegateType, focusMappedHandler);
            } else {
              doc.addEventListener(type, focusMappedHandler, true);
            }
          }
          dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
        },
        teardown: function teardown() {
          var doc = this.ownerDocument || this.document || this,
            dataHolder = document.documentMode ? this : doc,
            attaches = dataPriv.get(dataHolder, delegateType) - 1;
          if (!attaches) {
            if (document.documentMode) {
              this.removeEventListener(delegateType, focusMappedHandler);
            } else {
              doc.removeEventListener(type, focusMappedHandler, true);
            }
            dataPriv.remove(dataHolder, delegateType);
          } else {
            dataPriv.set(dataHolder, delegateType, attaches);
          }
        }
      };
    });

    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function (orig, fix) {
      jQuery.event.special[orig] = {
        delegateType: fix,
        bindType: fix,
        handle: function handle(event) {
          var ret,
            target = this,
            related = event.relatedTarget,
            handleObj = event.handleObj;

          // For mouseenter/leave call the handler if related is outside the target.
          // NB: No relatedTarget if the mouse left/entered the browser window
          if (!related || related !== target && !jQuery.contains(target, related)) {
            event.type = handleObj.origType;
            ret = handleObj.handler.apply(this, arguments);
            event.type = fix;
          }
          return ret;
        }
      };
    });
    jQuery.fn.extend({
      on: function on(types, selector, data, fn) {
        return _on(this, types, selector, data, fn);
      },
      one: function one(types, selector, data, fn) {
        return _on(this, types, selector, data, fn, 1);
      },
      off: function off(types, selector, fn) {
        var handleObj, type;
        if (types && types.preventDefault && types.handleObj) {
          // ( event )  dispatched jQuery.Event
          handleObj = types.handleObj;
          jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
          return this;
        }
        if (_typeof$1(types) === "object") {
          // ( types-object [, selector] )
          for (type in types) {
            this.off(type, selector, types[type]);
          }
          return this;
        }
        if (selector === false || typeof selector === "function") {
          // ( types [, fn] )
          fn = selector;
          selector = undefined;
        }
        if (fn === false) {
          fn = returnFalse;
        }
        return this.each(function () {
          jQuery.event.remove(this, types, fn, selector);
        });
      }
    });
    var
      // Support: IE <=10 - 11, Edge 12 - 13 only
      // In IE/Edge using regex groups here causes severe slowdowns.
      // See https://connect.microsoft.com/IE/feedback/details/1736512/
      rnoInnerhtml = /<script|<style|<link/i,
      // checked="checked" or checked
      rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
      rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
      if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
        return jQuery(elem).children("tbody")[0] || elem;
      }
      return elem;
    }

    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
      elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
      return elem;
    }
    function restoreScript(elem) {
      if ((elem.type || "").slice(0, 5) === "true/") {
        elem.type = elem.type.slice(5);
      } else {
        elem.removeAttribute("type");
      }
      return elem;
    }
    function cloneCopyEvent(src, dest) {
      var i, l, type, pdataOld, udataOld, udataCur, events;
      if (dest.nodeType !== 1) {
        return;
      }

      // 1. Copy private data: events, handlers, etc.
      if (dataPriv.hasData(src)) {
        pdataOld = dataPriv.get(src);
        events = pdataOld.events;
        if (events) {
          dataPriv.remove(dest, "handle events");
          for (type in events) {
            for (i = 0, l = events[type].length; i < l; i++) {
              jQuery.event.add(dest, type, events[type][i]);
            }
          }
        }
      }

      // 2. Copy user data
      if (dataUser.hasData(src)) {
        udataOld = dataUser.access(src);
        udataCur = jQuery.extend({}, udataOld);
        dataUser.set(dest, udataCur);
      }
    }

    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
      var nodeName = dest.nodeName.toLowerCase();

      // Fails to persist the checked state of a cloned checkbox or radio button.
      if (nodeName === "input" && rcheckableType.test(src.type)) {
        dest.checked = src.checked;

        // Fails to return the selected option to the default selected state when cloning options
      } else if (nodeName === "input" || nodeName === "textarea") {
        dest.defaultValue = src.defaultValue;
      }
    }
    function domManip(collection, args, callback, ignored) {
      // Flatten any nested arrays
      args = flat(args);
      var fragment,
        first,
        scripts,
        hasScripts,
        node,
        doc,
        i = 0,
        l = collection.length,
        iNoClone = l - 1,
        value = args[0],
        valueIsFunction = isFunction(value);

      // We can't cloneNode fragments that contain checked, in WebKit
      if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
        return collection.each(function (index) {
          var self = collection.eq(index);
          if (valueIsFunction) {
            args[0] = value.call(this, index, self.html());
          }
          domManip(self, args, callback, ignored);
        });
      }
      if (l) {
        fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
        first = fragment.firstChild;
        if (fragment.childNodes.length === 1) {
          fragment = first;
        }

        // Require either new content or an interest in ignored elements to invoke the callback
        if (first || ignored) {
          scripts = jQuery.map(getAll(fragment, "script"), disableScript);
          hasScripts = scripts.length;

          // Use the original fragment for the last item
          // instead of the first because it can end up
          // being emptied incorrectly in certain situations (trac-8070).
          for (; i < l; i++) {
            node = fragment;
            if (i !== iNoClone) {
              node = jQuery.clone(node, true, true);

              // Keep references to cloned scripts for later restoration
              if (hasScripts) {
                // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(scripts, getAll(node, "script"));
              }
            }
            callback.call(collection[i], node, i);
          }
          if (hasScripts) {
            doc = scripts[scripts.length - 1].ownerDocument;

            // Re-enable scripts
            jQuery.map(scripts, restoreScript);

            // Evaluate executable scripts on first document insertion
            for (i = 0; i < hasScripts; i++) {
              node = scripts[i];
              if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                if (node.src && (node.type || "").toLowerCase() !== "module") {
                  // Optional AJAX dependency, but won't run scripts if not present
                  if (jQuery._evalUrl && !node.noModule) {
                    jQuery._evalUrl(node.src, {
                      nonce: node.nonce || node.getAttribute("nonce")
                    }, doc);
                  }
                } else {
                  // Unwrap a CDATA section containing script contents. This shouldn't be
                  // needed as in XML documents they're already not visible when
                  // inspecting element contents and in HTML documents they have no
                  // meaning but we're preserving that logic for backwards compatibility.
                  // This will be removed completely in 4.0. See gh-4904.
                  DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                }
              }
            }
          }
        }
      }
      return collection;
    }
    function _remove(elem, selector, keepData) {
      var node,
        nodes = selector ? jQuery.filter(selector, elem) : elem,
        i = 0;
      for (; (node = nodes[i]) != null; i++) {
        if (!keepData && node.nodeType === 1) {
          jQuery.cleanData(getAll(node));
        }
        if (node.parentNode) {
          if (keepData && isAttached(node)) {
            setGlobalEval(getAll(node, "script"));
          }
          node.parentNode.removeChild(node);
        }
      }
      return elem;
    }
    jQuery.extend({
      htmlPrefilter: function htmlPrefilter(html) {
        return html;
      },
      clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
        var i,
          l,
          srcElements,
          destElements,
          clone = elem.cloneNode(true),
          inPage = isAttached(elem);

        // Fix IE cloning issues
        if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
          // We eschew jQuery#find here for performance reasons:
          // https://jsperf.com/getall-vs-sizzle/2
          destElements = getAll(clone);
          srcElements = getAll(elem);
          for (i = 0, l = srcElements.length; i < l; i++) {
            fixInput(srcElements[i], destElements[i]);
          }
        }

        // Copy the events from the original to the clone
        if (dataAndEvents) {
          if (deepDataAndEvents) {
            srcElements = srcElements || getAll(elem);
            destElements = destElements || getAll(clone);
            for (i = 0, l = srcElements.length; i < l; i++) {
              cloneCopyEvent(srcElements[i], destElements[i]);
            }
          } else {
            cloneCopyEvent(elem, clone);
          }
        }

        // Preserve script evaluation history
        destElements = getAll(clone, "script");
        if (destElements.length > 0) {
          setGlobalEval(destElements, !inPage && getAll(elem, "script"));
        }

        // Return the cloned set
        return clone;
      },
      cleanData: function cleanData(elems) {
        var data,
          elem,
          type,
          special = jQuery.event.special,
          i = 0;
        for (; (elem = elems[i]) !== undefined; i++) {
          if (acceptData(elem)) {
            if (data = elem[dataPriv.expando]) {
              if (data.events) {
                for (type in data.events) {
                  if (special[type]) {
                    jQuery.event.remove(elem, type);

                    // This is a shortcut to avoid jQuery.event.remove's overhead
                  } else {
                    jQuery.removeEvent(elem, type, data.handle);
                  }
                }
              }

              // Support: Chrome <=35 - 45+
              // Assign undefined instead of using delete, see Data#remove
              elem[dataPriv.expando] = undefined;
            }
            if (elem[dataUser.expando]) {
              // Support: Chrome <=35 - 45+
              // Assign undefined instead of using delete, see Data#remove
              elem[dataUser.expando] = undefined;
            }
          }
        }
      }
    });
    jQuery.fn.extend({
      detach: function detach(selector) {
        return _remove(this, selector, true);
      },
      remove: function remove(selector) {
        return _remove(this, selector);
      },
      text: function text(value) {
        return access(this, function (value) {
          return value === undefined ? jQuery.text(this) : this.empty().each(function () {
            if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
              this.textContent = value;
            }
          });
        }, null, value, arguments.length);
      },
      append: function append() {
        return domManip(this, arguments, function (elem) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var target = manipulationTarget(this, elem);
            target.appendChild(elem);
          }
        });
      },
      prepend: function prepend() {
        return domManip(this, arguments, function (elem) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var target = manipulationTarget(this, elem);
            target.insertBefore(elem, target.firstChild);
          }
        });
      },
      before: function before() {
        return domManip(this, arguments, function (elem) {
          if (this.parentNode) {
            this.parentNode.insertBefore(elem, this);
          }
        });
      },
      after: function after() {
        return domManip(this, arguments, function (elem) {
          if (this.parentNode) {
            this.parentNode.insertBefore(elem, this.nextSibling);
          }
        });
      },
      empty: function empty() {
        var elem,
          i = 0;
        for (; (elem = this[i]) != null; i++) {
          if (elem.nodeType === 1) {
            // Prevent memory leaks
            jQuery.cleanData(getAll(elem, false));

            // Remove any remaining nodes
            elem.textContent = "";
          }
        }
        return this;
      },
      clone: function clone(dataAndEvents, deepDataAndEvents) {
        dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
        deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
        return this.map(function () {
          return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
        });
      },
      html: function html(value) {
        return access(this, function (value) {
          var elem = this[0] || {},
            i = 0,
            l = this.length;
          if (value === undefined && elem.nodeType === 1) {
            return elem.innerHTML;
          }

          // See if we can take a shortcut and just use innerHTML
          if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
            value = jQuery.htmlPrefilter(value);
            try {
              for (; i < l; i++) {
                elem = this[i] || {};

                // Remove element nodes and prevent memory leaks
                if (elem.nodeType === 1) {
                  jQuery.cleanData(getAll(elem, false));
                  elem.innerHTML = value;
                }
              }
              elem = 0;

              // If using innerHTML throws an exception, use the fallback method
            } catch (e) {}
          }
          if (elem) {
            this.empty().append(value);
          }
        }, null, value, arguments.length);
      },
      replaceWith: function replaceWith() {
        var ignored = [];

        // Make the changes, replacing each non-ignored context element with the new content
        return domManip(this, arguments, function (elem) {
          var parent = this.parentNode;
          if (jQuery.inArray(this, ignored) < 0) {
            jQuery.cleanData(getAll(this));
            if (parent) {
              parent.replaceChild(elem, this);
            }
          }

          // Force callback invocation
        }, ignored);
      }
    });
    jQuery.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function (name, original) {
      jQuery.fn[name] = function (selector) {
        var elems,
          ret = [],
          insert = jQuery(selector),
          last = insert.length - 1,
          i = 0;
        for (; i <= last; i++) {
          elems = i === last ? this : this.clone(true);
          jQuery(insert[i])[original](elems);

          // Support: Android <=4.0 only, PhantomJS 1 only
          // .get() because push.apply(_, arraylike) throws on ancient WebKit
          push.apply(ret, elems.get());
        }
        return this.pushStack(ret);
      };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
      // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
      // IE throws on elements created in popups
      // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
      var view = elem.ownerDocument.defaultView;
      if (!view || !view.opener) {
        view = window;
      }
      return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
      var ret,
        name,
        old = {};

      // Remember the old values, and insert the new ones
      for (name in options) {
        old[name] = elem.style[name];
        elem.style[name] = options[name];
      }
      ret = callback.call(elem);

      // Revert the old values
      for (name in options) {
        elem.style[name] = old[name];
      }
      return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function () {
      // Executing both pixelPosition & boxSizingReliable tests require only one layout
      // so they're executed at the same time to save the second computation.
      function computeStyleTests() {
        // This is a singleton, we need to execute it only once
        if (!div) {
          return;
        }
        container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
        div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
        documentElement.appendChild(container).appendChild(div);
        var divStyle = window.getComputedStyle(div);
        pixelPositionVal = divStyle.top !== "1%";

        // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
        reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

        // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
        // Some styles come back with percentage values, even though they shouldn't
        div.style.right = "60%";
        pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

        // Support: IE 9 - 11 only
        // Detect misreporting of content dimensions for box-sizing:border-box elements
        boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

        // Support: IE 9 only
        // Detect overflow:scroll screwiness (gh-3699)
        // Support: Chrome <=64
        // Don't get tricked when zoom affects offsetWidth (gh-4029)
        div.style.position = "absolute";
        scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
        documentElement.removeChild(container);

        // Nullify the div so it wouldn't be stored in the memory and
        // it will also be a sign that checks already performed
        div = null;
      }
      function roundPixelMeasures(measure) {
        return Math.round(parseFloat(measure));
      }
      var pixelPositionVal,
        boxSizingReliableVal,
        scrollboxSizeVal,
        pixelBoxStylesVal,
        reliableTrDimensionsVal,
        reliableMarginLeftVal,
        container = document.createElement("div"),
        div = document.createElement("div");

      // Finish early in limited (non-browser) environments
      if (!div.style) {
        return;
      }

      // Support: IE <=9 - 11 only
      // Style of cloned element affects source element cloned (trac-8908)
      div.style.backgroundClip = "content-box";
      div.cloneNode(true).style.backgroundClip = "";
      support.clearCloneStyle = div.style.backgroundClip === "content-box";
      jQuery.extend(support, {
        boxSizingReliable: function boxSizingReliable() {
          computeStyleTests();
          return boxSizingReliableVal;
        },
        pixelBoxStyles: function pixelBoxStyles() {
          computeStyleTests();
          return pixelBoxStylesVal;
        },
        pixelPosition: function pixelPosition() {
          computeStyleTests();
          return pixelPositionVal;
        },
        reliableMarginLeft: function reliableMarginLeft() {
          computeStyleTests();
          return reliableMarginLeftVal;
        },
        scrollboxSize: function scrollboxSize() {
          computeStyleTests();
          return scrollboxSizeVal;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function reliableTrDimensions() {
          var table, tr, trChild, trStyle;
          if (reliableTrDimensionsVal == null) {
            table = document.createElement("table");
            tr = document.createElement("tr");
            trChild = document.createElement("div");
            table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
            tr.style.cssText = "box-sizing:content-box;border:1px solid";

            // Support: Chrome 86+
            // Height set through cssText does not get applied.
            // Computed height then comes back as 0.
            tr.style.height = "1px";
            trChild.style.height = "9px";

            // Support: Android 8 Chrome 86+
            // In our bodyBackground.html iframe,
            // display for all div elements is set to "inline",
            // which causes a problem only in Android 8 Chrome 86.
            // Ensuring the div is `display: block`
            // gets around this issue.
            trChild.style.display = "block";
            documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
            trStyle = window.getComputedStyle(tr);
            reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
            documentElement.removeChild(table);
          }
          return reliableTrDimensionsVal;
        }
      });
    })();
    function curCSS(elem, name, computed) {
      var width,
        minWidth,
        maxWidth,
        ret,
        isCustomProp = rcustomProp.test(name),
        // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
      computed = computed || getStyles(elem);

      // getPropertyValue is needed for:
      //   .css('filter') (IE 9 only, trac-12537)
      //   .css('--customProperty) (gh-3144)
      if (computed) {
        // Support: IE <=9 - 11+
        // IE only supports `"float"` in `getPropertyValue`; in computed styles
        // it's only available as `"cssFloat"`. We no longer modify properties
        // sent to `.css()` apart from camelCasing, so we need to check both.
        // Normally, this would create difference in behavior: if
        // `getPropertyValue` returns an empty string, the value returned
        // by `.css()` would be `undefined`. This is usually the case for
        // disconnected elements. However, in IE even disconnected elements
        // with no styles return `"none"` for `getPropertyValue( "float" )`
        ret = computed.getPropertyValue(name) || computed[name];
        if (isCustomProp && ret) {
          // Support: Firefox 105+, Chrome <=105+
          // Spec requires trimming whitespace for custom properties (gh-4926).
          // Firefox only trims leading whitespace. Chrome just collapses
          // both leading & trailing whitespace to a single space.
          //
          // Fall back to `undefined` if empty string returned.
          // This collapses a missing definition with property defined
          // and set to an empty string but there's no standard API
          // allowing us to differentiate them without a performance penalty
          // and returning `undefined` aligns with older jQuery.
          //
          // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
          // as whitespace while CSS does not, but this is not a problem
          // because CSS preprocessing replaces them with U+000A LINE FEED
          // (which *is* CSS whitespace)
          // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
          ret = ret.replace(rtrimCSS, "$1") || undefined;
        }
        if (ret === "" && !isAttached(elem)) {
          ret = jQuery.style(elem, name);
        }

        // A tribute to the "awesome hack by Dean Edwards"
        // Android Browser returns percentage for some values,
        // but width seems to be reliably pixels.
        // This is against the CSSOM draft spec:
        // https://drafts.csswg.org/cssom/#resolved-values
        if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
          // Remember the original values
          width = style.width;
          minWidth = style.minWidth;
          maxWidth = style.maxWidth;

          // Put in the new values to get a computed value out
          style.minWidth = style.maxWidth = style.width = ret;
          ret = computed.width;

          // Revert the changed values
          style.width = width;
          style.minWidth = minWidth;
          style.maxWidth = maxWidth;
        }
      }
      return ret !== undefined ?
      // Support: IE <=9 - 11 only
      // IE returns zIndex value as an integer.
      ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
      // Define the hook, we'll check on the first run if it's really needed.
      return {
        get: function get() {
          if (conditionFn()) {
            // Hook not needed (or it's not possible to use it due
            // to missing dependency), remove it.
            delete this.get;
            return;
          }

          // Hook needed; redefine it so that the support test is not executed again.
          return (this.get = hookFn).apply(this, arguments);
        }
      };
    }
    var cssPrefixes = ["Webkit", "Moz", "ms"],
      emptyStyle = document.createElement("div").style,
      vendorProps = {};

    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
      // Check for vendor prefixed names
      var capName = name[0].toUpperCase() + name.slice(1),
        i = cssPrefixes.length;
      while (i--) {
        name = cssPrefixes[i] + capName;
        if (name in emptyStyle) {
          return name;
        }
      }
    }

    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
      var _final = jQuery.cssProps[name] || vendorProps[name];
      if (_final) {
        return _final;
      }
      if (name in emptyStyle) {
        return name;
      }
      return vendorProps[name] = vendorPropName(name) || name;
    }
    var
      // Swappable if display is none or starts with table
      // except "table", "table-cell", or "table-caption"
      // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
      rdisplayswap = /^(none|table(?!-c[ea]).+)/,
      cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
      cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
      };
    function setPositiveNumber(_elem, value, subtract) {
      // Any relative (+/-) values have already been
      // normalized at this point
      var matches = rcssNum.exec(value);
      return matches ?
      // Guard against undefined "subtract", e.g., when used as in cssHooks
      Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
      var i = dimension === "width" ? 1 : 0,
        extra = 0,
        delta = 0,
        marginDelta = 0;

      // Adjustment may not be necessary
      if (box === (isBorderBox ? "border" : "content")) {
        return 0;
      }
      for (; i < 4; i += 2) {
        // Both box models exclude margin
        // Count margin delta separately to only add it after scroll gutter adjustment.
        // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
        if (box === "margin") {
          marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
        }

        // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
        if (!isBorderBox) {
          // Add padding
          delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

          // For "border" or "margin", add border
          if (box !== "padding") {
            delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

            // But still keep track of it otherwise
          } else {
            extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
          }

          // If we get here with a border-box (content + padding + border), we're seeking "content" or
          // "padding" or "margin"
        } else {
          // For "content", subtract padding
          if (box === "content") {
            delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
          }

          // For "content" or "padding", subtract border
          if (box !== "margin") {
            delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
          }
        }
      }

      // Account for positive content-box scroll gutter when requested by providing computedVal
      if (!isBorderBox && computedVal >= 0) {
        // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
        // Use an explicit zero to avoid NaN (gh-3964)
        )) || 0;
      }
      return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
      // Start with computed style
      var styles = getStyles(elem),
        // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra,
        isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
        valueIsBorderBox = isBorderBox,
        val = curCSS(elem, dimension, styles),
        offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

      // Support: Firefox <=54
      // Return a confounding non-pixel value or feign ignorance, as appropriate.
      if (rnumnonpx.test(val)) {
        if (!extra) {
          return val;
        }
        val = "auto";
      }

      // Support: IE 9 - 11 only
      // Use offsetWidth/offsetHeight for when box sizing is unreliable.
      // In those cases, the computed value can be trusted to be border-box.
      if ((!support.boxSizingReliable() && isBorderBox ||
      // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !support.reliableTrDimensions() && nodeName(elem, "tr") ||
      // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      val === "auto" ||
      // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&
      // Make sure the element is visible & connected
      elem.getClientRects().length) {
        isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

        // Where available, offsetWidth/offsetHeight approximate border box dimensions.
        // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
        // retrieved value as a content box dimension.
        valueIsBorderBox = offsetProp in elem;
        if (valueIsBorderBox) {
          val = elem[offsetProp];
        }
      }

      // Normalize "" and auto
      val = parseFloat(val) || 0;

      // Adjust for the element's box model
      return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,
      // Provide the current computed size to request scroll gutter calculation (gh-3589)
      val) + "px";
    }
    jQuery.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function get(elem, computed) {
            if (computed) {
              // We should always get a number back from opacity
              var ret = curCSS(elem, "opacity");
              return ret === "" ? "1" : ret;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageSlice: true,
        columnCount: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        gridArea: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnStart: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowStart: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        scale: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeMiterlimit: true,
        strokeOpacity: true
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function style(elem, name, value, extra) {
        // Don't set styles on text and comment nodes
        if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
          return;
        }

        // Make sure that we're working with the right name
        var ret,
          type,
          hooks,
          origName = camelCase(name),
          isCustomProp = rcustomProp.test(name),
          style = elem.style;

        // Make sure that we're working with the right name. We don't
        // want to query the value if it is a CSS custom property
        // since they are user-defined.
        if (!isCustomProp) {
          name = finalPropName(origName);
        }

        // Gets hook for the prefixed version, then unprefixed version
        hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

        // Check if we're setting a value
        if (value !== undefined) {
          type = _typeof$1(value);

          // Convert "+=" or "-=" to relative numbers (trac-7345)
          if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
            value = adjustCSS(elem, name, ret);

            // Fixes bug trac-9237
            type = "number";
          }

          // Make sure that null and NaN values aren't set (trac-7116)
          if (value == null || value !== value) {
            return;
          }

          // If a number was passed in, add the unit (except for certain CSS properties)
          // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
          // "px" to a few hardcoded values.
          if (type === "number" && !isCustomProp) {
            value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
          }

          // background-* props affect original clone's values
          if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
            style[name] = "inherit";
          }

          // If a hook was provided, use that value, otherwise just set the specified value
          if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
            if (isCustomProp) {
              style.setProperty(name, value);
            } else {
              style[name] = value;
            }
          }
        } else {
          // If a hook was provided get the non-computed value from there
          if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
            return ret;
          }

          // Otherwise just get the value from the style object
          return style[name];
        }
      },
      css: function css(elem, name, extra, styles) {
        var val,
          num,
          hooks,
          origName = camelCase(name),
          isCustomProp = rcustomProp.test(name);

        // Make sure that we're working with the right name. We don't
        // want to modify the value if it is a CSS custom property
        // since they are user-defined.
        if (!isCustomProp) {
          name = finalPropName(origName);
        }

        // Try prefixed name followed by the unprefixed name
        hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

        // If a hook was provided get the computed value from there
        if (hooks && "get" in hooks) {
          val = hooks.get(elem, true, extra);
        }

        // Otherwise, if a way to get the computed value exists, use that
        if (val === undefined) {
          val = curCSS(elem, name, styles);
        }

        // Convert "normal" to computed value
        if (val === "normal" && name in cssNormalTransform) {
          val = cssNormalTransform[name];
        }

        // Make numeric if forced or a qualifier was provided and val looks numeric
        if (extra === "" || extra) {
          num = parseFloat(val);
          return extra === true || isFinite(num) ? num || 0 : val;
        }
        return val;
      }
    });
    jQuery.each(["height", "width"], function (_i, dimension) {
      jQuery.cssHooks[dimension] = {
        get: function get(elem, computed, extra) {
          if (computed) {
            // Certain elements can have dimension info if we invisibly show them
            // but it must have a current display style that would benefit
            return rdisplayswap.test(jQuery.css(elem, "display")) && (
            // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            !elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
              return getWidthOrHeight(elem, dimension, extra);
            }) : getWidthOrHeight(elem, dimension, extra);
          }
        },
        set: function set(elem, value, extra) {
          var matches,
            styles = getStyles(elem),
            // Only read styles.position if the test has a chance to fail
            // to avoid forcing a reflow.
            scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",
            // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
            boxSizingNeeded = scrollboxSizeBuggy || extra,
            isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
            subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

          // Account for unreliable border-box dimensions by comparing offset* to computed and
          // faking a content-box to get border and padding (gh-3699)
          if (isBorderBox && scrollboxSizeBuggy) {
            subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
          }

          // Convert to pixels if value adjustment is needed
          if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
            elem.style[dimension] = value;
            value = jQuery.css(elem, dimension);
          }
          return setPositiveNumber(elem, value, subtract);
        }
      };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
      if (computed) {
        return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
          marginLeft: 0
        }, function () {
          return elem.getBoundingClientRect().left;
        })) + "px";
      }
    });

    // These hooks are used by animate to expand properties
    jQuery.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function (prefix, suffix) {
      jQuery.cssHooks[prefix + suffix] = {
        expand: function expand(value) {
          var i = 0,
            expanded = {},
            // Assumes a single number if not a string
            parts = typeof value === "string" ? value.split(" ") : [value];
          for (; i < 4; i++) {
            expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
          }
          return expanded;
        }
      };
      if (prefix !== "margin") {
        jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
      }
    });
    jQuery.fn.extend({
      css: function css(name, value) {
        return access(this, function (elem, name, value) {
          var styles,
            len,
            map = {},
            i = 0;
          if (Array.isArray(name)) {
            styles = getStyles(elem);
            len = name.length;
            for (; i < len; i++) {
              map[name[i]] = jQuery.css(elem, name[i], false, styles);
            }
            return map;
          }
          return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
        }, name, value, arguments.length > 1);
      }
    });
    function Tween(elem, options, prop, end, easing) {
      return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
      constructor: Tween,
      init: function init(elem, options, prop, end, easing, unit) {
        this.elem = elem;
        this.prop = prop;
        this.easing = easing || jQuery.easing._default;
        this.options = options;
        this.start = this.now = this.cur();
        this.end = end;
        this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
      },
      cur: function cur() {
        var hooks = Tween.propHooks[this.prop];
        return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
      },
      run: function run(percent) {
        var eased,
          hooks = Tween.propHooks[this.prop];
        if (this.options.duration) {
          this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
        } else {
          this.pos = eased = percent;
        }
        this.now = (this.end - this.start) * eased + this.start;
        if (this.options.step) {
          this.options.step.call(this.elem, this.now, this);
        }
        if (hooks && hooks.set) {
          hooks.set(this);
        } else {
          Tween.propHooks._default.set(this);
        }
        return this;
      }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
      _default: {
        get: function get(tween) {
          var result;

          // Use a property on the element directly when it is not a DOM element,
          // or when there is no matching style property that exists.
          if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
            return tween.elem[tween.prop];
          }

          // Passing an empty string as a 3rd parameter to .css will automatically
          // attempt a parseFloat and fallback to a string if the parse fails.
          // Simple values such as "10px" are parsed to Float;
          // complex values such as "rotate(1rad)" are returned as-is.
          result = jQuery.css(tween.elem, tween.prop, "");

          // Empty strings, null, undefined and "auto" are converted to 0.
          return !result || result === "auto" ? 0 : result;
        },
        set: function set(tween) {
          // Use step hook for back compat.
          // Use cssHook if its there.
          // Use .style if available and use plain properties where available.
          if (jQuery.fx.step[tween.prop]) {
            jQuery.fx.step[tween.prop](tween);
          } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
            jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
          } else {
            tween.elem[tween.prop] = tween.now;
          }
        }
      }
    };

    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
      set: function set(tween) {
        if (tween.elem.nodeType && tween.elem.parentNode) {
          tween.elem[tween.prop] = tween.now;
        }
      }
    };
    jQuery.easing = {
      linear: function linear(p) {
        return p;
      },
      swing: function swing(p) {
        return 0.5 - Math.cos(p * Math.PI) / 2;
      },
      _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;

    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow,
      inProgress,
      rfxtypes = /^(?:toggle|show|hide)$/,
      rrun = /queueHooks$/;
    function schedule() {
      if (inProgress) {
        if (document.hidden === false && window.requestAnimationFrame) {
          window.requestAnimationFrame(schedule);
        } else {
          window.setTimeout(schedule, jQuery.fx.interval);
        }
        jQuery.fx.tick();
      }
    }

    // Animations created synchronously will run synchronously
    function createFxNow() {
      window.setTimeout(function () {
        fxNow = undefined;
      });
      return fxNow = Date.now();
    }

    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
      var which,
        i = 0,
        attrs = {
          height: type
        };

      // If we include width, step value is 1 to do all cssExpand values,
      // otherwise step value is 2 to skip over Left and Right
      includeWidth = includeWidth ? 1 : 0;
      for (; i < 4; i += 2 - includeWidth) {
        which = cssExpand[i];
        attrs["margin" + which] = attrs["padding" + which] = type;
      }
      if (includeWidth) {
        attrs.opacity = attrs.width = type;
      }
      return attrs;
    }
    function createTween(value, prop, animation) {
      var tween,
        collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
        index = 0,
        length = collection.length;
      for (; index < length; index++) {
        if (tween = collection[index].call(animation, prop, value)) {
          // We're done with this property
          return tween;
        }
      }
    }
    function defaultPrefilter(elem, props, opts) {
      var prop,
        value,
        toggle,
        hooks,
        oldfire,
        propTween,
        restoreDisplay,
        display,
        isBox = "width" in props || "height" in props,
        anim = this,
        orig = {},
        style = elem.style,
        hidden = elem.nodeType && isHiddenWithinTree(elem),
        dataShow = dataPriv.get(elem, "fxshow");

      // Queue-skipping animations hijack the fx hooks
      if (!opts.queue) {
        hooks = jQuery._queueHooks(elem, "fx");
        if (hooks.unqueued == null) {
          hooks.unqueued = 0;
          oldfire = hooks.empty.fire;
          hooks.empty.fire = function () {
            if (!hooks.unqueued) {
              oldfire();
            }
          };
        }
        hooks.unqueued++;
        anim.always(function () {
          // Ensure the complete handler is called before this completes
          anim.always(function () {
            hooks.unqueued--;
            if (!jQuery.queue(elem, "fx").length) {
              hooks.empty.fire();
            }
          });
        });
      }

      // Detect show/hide animations
      for (prop in props) {
        value = props[prop];
        if (rfxtypes.test(value)) {
          delete props[prop];
          toggle = toggle || value === "toggle";
          if (value === (hidden ? "hide" : "show")) {
            // Pretend to be hidden if this is a "show" and
            // there is still data from a stopped show/hide
            if (value === "show" && dataShow && dataShow[prop] !== undefined) {
              hidden = true;

              // Ignore all other no-op show/hide data
            } else {
              continue;
            }
          }
          orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
        }
      }

      // Bail out if this is a no-op like .hide().hide()
      propTween = !jQuery.isEmptyObject(props);
      if (!propTween && jQuery.isEmptyObject(orig)) {
        return;
      }

      // Restrict "overflow" and "display" styles during box animations
      if (isBox && elem.nodeType === 1) {
        // Support: IE <=9 - 11, Edge 12 - 15
        // Record all 3 overflow attributes because IE does not infer the shorthand
        // from identically-valued overflowX and overflowY and Edge just mirrors
        // the overflowX value there.
        opts.overflow = [style.overflow, style.overflowX, style.overflowY];

        // Identify a display type, preferring old show/hide data over the CSS cascade
        restoreDisplay = dataShow && dataShow.display;
        if (restoreDisplay == null) {
          restoreDisplay = dataPriv.get(elem, "display");
        }
        display = jQuery.css(elem, "display");
        if (display === "none") {
          if (restoreDisplay) {
            display = restoreDisplay;
          } else {
            // Get nonempty value(s) by temporarily forcing visibility
            showHide([elem], true);
            restoreDisplay = elem.style.display || restoreDisplay;
            display = jQuery.css(elem, "display");
            showHide([elem]);
          }
        }

        // Animate inline elements as inline-block
        if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
          if (jQuery.css(elem, "float") === "none") {
            // Restore the original display value at the end of pure show/hide animations
            if (!propTween) {
              anim.done(function () {
                style.display = restoreDisplay;
              });
              if (restoreDisplay == null) {
                display = style.display;
                restoreDisplay = display === "none" ? "" : display;
              }
            }
            style.display = "inline-block";
          }
        }
      }
      if (opts.overflow) {
        style.overflow = "hidden";
        anim.always(function () {
          style.overflow = opts.overflow[0];
          style.overflowX = opts.overflow[1];
          style.overflowY = opts.overflow[2];
        });
      }

      // Implement show/hide animations
      propTween = false;
      for (prop in orig) {
        // General show/hide setup for this element animation
        if (!propTween) {
          if (dataShow) {
            if ("hidden" in dataShow) {
              hidden = dataShow.hidden;
            }
          } else {
            dataShow = dataPriv.access(elem, "fxshow", {
              display: restoreDisplay
            });
          }

          // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
          if (toggle) {
            dataShow.hidden = !hidden;
          }

          // Show elements before animating them
          if (hidden) {
            showHide([elem], true);
          }

          /* eslint-disable no-loop-func */

          anim.done(function () {
            /* eslint-enable no-loop-func */

            // The final step of a "hide" animation is actually hiding the element
            if (!hidden) {
              showHide([elem]);
            }
            dataPriv.remove(elem, "fxshow");
            for (prop in orig) {
              jQuery.style(elem, prop, orig[prop]);
            }
          });
        }

        // Per-property setup
        propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
        if (!(prop in dataShow)) {
          dataShow[prop] = propTween.start;
          if (hidden) {
            propTween.end = propTween.start;
            propTween.start = 0;
          }
        }
      }
    }
    function propFilter(props, specialEasing) {
      var index, name, easing, value, hooks;

      // camelCase, specialEasing and expand cssHook pass
      for (index in props) {
        name = camelCase(index);
        easing = specialEasing[name];
        value = props[index];
        if (Array.isArray(value)) {
          easing = value[1];
          value = props[index] = value[0];
        }
        if (index !== name) {
          props[name] = value;
          delete props[index];
        }
        hooks = jQuery.cssHooks[name];
        if (hooks && "expand" in hooks) {
          value = hooks.expand(value);
          delete props[name];

          // Not quite $.extend, this won't overwrite existing keys.
          // Reusing 'index' because we have the correct "name"
          for (index in value) {
            if (!(index in props)) {
              props[index] = value[index];
              specialEasing[index] = easing;
            }
          }
        } else {
          specialEasing[name] = easing;
        }
      }
    }
    function Animation(elem, properties, options) {
      var result,
        stopped,
        index = 0,
        length = Animation.prefilters.length,
        deferred = jQuery.Deferred().always(function () {
          // Don't match elem in the :animated selector
          delete tick.elem;
        }),
        tick = function tick() {
          if (stopped) {
            return false;
          }
          var currentTime = fxNow || createFxNow(),
            remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
            // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0,
            percent = 1 - temp,
            index = 0,
            length = animation.tweens.length;
          for (; index < length; index++) {
            animation.tweens[index].run(percent);
          }
          deferred.notifyWith(elem, [animation, percent, remaining]);

          // If there's more to do, yield
          if (percent < 1 && length) {
            return remaining;
          }

          // If this was an empty animation, synthesize a final progress notification
          if (!length) {
            deferred.notifyWith(elem, [animation, 1, 0]);
          }

          // Resolve the animation and report its conclusion
          deferred.resolveWith(elem, [animation]);
          return false;
        },
        animation = deferred.promise({
          elem: elem,
          props: jQuery.extend({}, properties),
          opts: jQuery.extend(true, {
            specialEasing: {},
            easing: jQuery.easing._default
          }, options),
          originalProperties: properties,
          originalOptions: options,
          startTime: fxNow || createFxNow(),
          duration: options.duration,
          tweens: [],
          createTween: function createTween(prop, end) {
            var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
            animation.tweens.push(tween);
            return tween;
          },
          stop: function stop(gotoEnd) {
            var index = 0,
              // If we are going to the end, we want to run all the tweens
              // otherwise we skip this part
              length = gotoEnd ? animation.tweens.length : 0;
            if (stopped) {
              return this;
            }
            stopped = true;
            for (; index < length; index++) {
              animation.tweens[index].run(1);
            }

            // Resolve when we played the last frame; otherwise, reject
            if (gotoEnd) {
              deferred.notifyWith(elem, [animation, 1, 0]);
              deferred.resolveWith(elem, [animation, gotoEnd]);
            } else {
              deferred.rejectWith(elem, [animation, gotoEnd]);
            }
            return this;
          }
        }),
        props = animation.props;
      propFilter(props, animation.opts.specialEasing);
      for (; index < length; index++) {
        result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
        if (result) {
          if (isFunction(result.stop)) {
            jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
          }
          return result;
        }
      }
      jQuery.map(props, createTween, animation);
      if (isFunction(animation.opts.start)) {
        animation.opts.start.call(elem, animation);
      }

      // Attach callbacks from options
      animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
      jQuery.fx.timer(jQuery.extend(tick, {
        elem: elem,
        anim: animation,
        queue: animation.opts.queue
      }));
      return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
      tweeners: {
        "*": [function (prop, value) {
          var tween = this.createTween(prop, value);
          adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
          return tween;
        }]
      },
      tweener: function tweener(props, callback) {
        if (isFunction(props)) {
          callback = props;
          props = ["*"];
        } else {
          props = props.match(rnothtmlwhite);
        }
        var prop,
          index = 0,
          length = props.length;
        for (; index < length; index++) {
          prop = props[index];
          Animation.tweeners[prop] = Animation.tweeners[prop] || [];
          Animation.tweeners[prop].unshift(callback);
        }
      },
      prefilters: [defaultPrefilter],
      prefilter: function prefilter(callback, prepend) {
        if (prepend) {
          Animation.prefilters.unshift(callback);
        } else {
          Animation.prefilters.push(callback);
        }
      }
    });
    jQuery.speed = function (speed, easing, fn) {
      var opt = speed && _typeof$1(speed) === "object" ? jQuery.extend({}, speed) : {
        complete: fn || !fn && easing || isFunction(speed) && speed,
        duration: speed,
        easing: fn && easing || easing && !isFunction(easing) && easing
      };

      // Go to the end state if fx are off
      if (jQuery.fx.off) {
        opt.duration = 0;
      } else {
        if (typeof opt.duration !== "number") {
          if (opt.duration in jQuery.fx.speeds) {
            opt.duration = jQuery.fx.speeds[opt.duration];
          } else {
            opt.duration = jQuery.fx.speeds._default;
          }
        }
      }

      // Normalize opt.queue - true/undefined/null -> "fx"
      if (opt.queue == null || opt.queue === true) {
        opt.queue = "fx";
      }

      // Queueing
      opt.old = opt.complete;
      opt.complete = function () {
        if (isFunction(opt.old)) {
          opt.old.call(this);
        }
        if (opt.queue) {
          jQuery.dequeue(this, opt.queue);
        }
      };
      return opt;
    };
    jQuery.fn.extend({
      fadeTo: function fadeTo(speed, to, easing, callback) {
        // Show any hidden elements after setting opacity to 0
        return this.filter(isHiddenWithinTree).css("opacity", 0).show()

        // Animate to the value specified
        .end().animate({
          opacity: to
        }, speed, easing, callback);
      },
      animate: function animate(prop, speed, easing, callback) {
        var empty = jQuery.isEmptyObject(prop),
          optall = jQuery.speed(speed, easing, callback),
          doAnimation = function doAnimation() {
            // Operate on a copy of prop so per-property easing won't be lost
            var anim = Animation(this, jQuery.extend({}, prop), optall);

            // Empty animations, or finishing resolves immediately
            if (empty || dataPriv.get(this, "finish")) {
              anim.stop(true);
            }
          };
        doAnimation.finish = doAnimation;
        return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
      },
      stop: function stop(type, clearQueue, gotoEnd) {
        var stopQueue = function stopQueue(hooks) {
          var stop = hooks.stop;
          delete hooks.stop;
          stop(gotoEnd);
        };
        if (typeof type !== "string") {
          gotoEnd = clearQueue;
          clearQueue = type;
          type = undefined;
        }
        if (clearQueue) {
          this.queue(type || "fx", []);
        }
        return this.each(function () {
          var dequeue = true,
            index = type != null && type + "queueHooks",
            timers = jQuery.timers,
            data = dataPriv.get(this);
          if (index) {
            if (data[index] && data[index].stop) {
              stopQueue(data[index]);
            }
          } else {
            for (index in data) {
              if (data[index] && data[index].stop && rrun.test(index)) {
                stopQueue(data[index]);
              }
            }
          }
          for (index = timers.length; index--;) {
            if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
              timers[index].anim.stop(gotoEnd);
              dequeue = false;
              timers.splice(index, 1);
            }
          }

          // Start the next in the queue if the last step wasn't forced.
          // Timers currently will call their complete callbacks, which
          // will dequeue but only if they were gotoEnd.
          if (dequeue || !gotoEnd) {
            jQuery.dequeue(this, type);
          }
        });
      },
      finish: function finish(type) {
        if (type !== false) {
          type = type || "fx";
        }
        return this.each(function () {
          var index,
            data = dataPriv.get(this),
            queue = data[type + "queue"],
            hooks = data[type + "queueHooks"],
            timers = jQuery.timers,
            length = queue ? queue.length : 0;

          // Enable finishing flag on private data
          data.finish = true;

          // Empty the queue first
          jQuery.queue(this, type, []);
          if (hooks && hooks.stop) {
            hooks.stop.call(this, true);
          }

          // Look for any active animations, and finish them
          for (index = timers.length; index--;) {
            if (timers[index].elem === this && timers[index].queue === type) {
              timers[index].anim.stop(true);
              timers.splice(index, 1);
            }
          }

          // Look for any animations in the old queue and finish them
          for (index = 0; index < length; index++) {
            if (queue[index] && queue[index].finish) {
              queue[index].finish.call(this);
            }
          }

          // Turn off finishing flag
          delete data.finish;
        });
      }
    });
    jQuery.each(["toggle", "show", "hide"], function (_i, name) {
      var cssFn = jQuery.fn[name];
      jQuery.fn[name] = function (speed, easing, callback) {
        return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
      };
    });

    // Generate shortcuts for custom animations
    jQuery.each({
      slideDown: genFx("show"),
      slideUp: genFx("hide"),
      slideToggle: genFx("toggle"),
      fadeIn: {
        opacity: "show"
      },
      fadeOut: {
        opacity: "hide"
      },
      fadeToggle: {
        opacity: "toggle"
      }
    }, function (name, props) {
      jQuery.fn[name] = function (speed, easing, callback) {
        return this.animate(props, speed, easing, callback);
      };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function () {
      var timer,
        i = 0,
        timers = jQuery.timers;
      fxNow = Date.now();
      for (; i < timers.length; i++) {
        timer = timers[i];

        // Run the timer and safely remove it when done (allowing for external removal)
        if (!timer() && timers[i] === timer) {
          timers.splice(i--, 1);
        }
      }
      if (!timers.length) {
        jQuery.fx.stop();
      }
      fxNow = undefined;
    };
    jQuery.fx.timer = function (timer) {
      jQuery.timers.push(timer);
      jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function () {
      if (inProgress) {
        return;
      }
      inProgress = true;
      schedule();
    };
    jQuery.fx.stop = function () {
      inProgress = null;
    };
    jQuery.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    };

    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function (time, type) {
      time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
      type = type || "fx";
      return this.queue(type, function (next, hooks) {
        var timeout = window.setTimeout(next, time);
        hooks.stop = function () {
          window.clearTimeout(timeout);
        };
      });
    };
    (function () {
      var input = document.createElement("input"),
        select = document.createElement("select"),
        opt = select.appendChild(document.createElement("option"));
      input.type = "checkbox";

      // Support: Android <=4.3 only
      // Default value for a checkbox should be "on"
      support.checkOn = input.value !== "";

      // Support: IE <=11 only
      // Must access selectedIndex to make default options select
      support.optSelected = opt.selected;

      // Support: IE <=11 only
      // An input loses its value after becoming a radio
      input = document.createElement("input");
      input.value = "t";
      input.type = "radio";
      support.radioValue = input.value === "t";
    })();
    var boolHook,
      attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
      attr: function attr(name, value) {
        return access(this, jQuery.attr, name, value, arguments.length > 1);
      },
      removeAttr: function removeAttr(name) {
        return this.each(function () {
          jQuery.removeAttr(this, name);
        });
      }
    });
    jQuery.extend({
      attr: function attr(elem, name, value) {
        var ret,
          hooks,
          nType = elem.nodeType;

        // Don't get/set attributes on text, comment and attribute nodes
        if (nType === 3 || nType === 8 || nType === 2) {
          return;
        }

        // Fallback to prop when attributes are not supported
        if (typeof elem.getAttribute === "undefined") {
          return jQuery.prop(elem, name, value);
        }

        // Attribute hooks are determined by the lowercase version
        // Grab necessary hook if one is defined
        if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
          hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
        }
        if (value !== undefined) {
          if (value === null) {
            jQuery.removeAttr(elem, name);
            return;
          }
          if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
            return ret;
          }
          elem.setAttribute(name, value + "");
          return value;
        }
        if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
          return ret;
        }
        ret = jQuery.find.attr(elem, name);

        // Non-existent attributes return null, we normalize to undefined
        return ret == null ? undefined : ret;
      },
      attrHooks: {
        type: {
          set: function set(elem, value) {
            if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
              var val = elem.value;
              elem.setAttribute("type", value);
              if (val) {
                elem.value = val;
              }
              return value;
            }
          }
        }
      },
      removeAttr: function removeAttr(elem, value) {
        var name,
          i = 0,
          // Attribute names can contain non-HTML whitespace characters
          // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
          attrNames = value && value.match(rnothtmlwhite);
        if (attrNames && elem.nodeType === 1) {
          while (name = attrNames[i++]) {
            elem.removeAttribute(name);
          }
        }
      }
    });

    // Hooks for boolean attributes
    boolHook = {
      set: function set(elem, value, name) {
        if (value === false) {
          // Remove boolean attributes when set to false
          jQuery.removeAttr(elem, name);
        } else {
          elem.setAttribute(name, name);
        }
        return name;
      }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
      var getter = attrHandle[name] || jQuery.find.attr;
      attrHandle[name] = function (elem, name, isXML) {
        var ret,
          handle,
          lowercaseName = name.toLowerCase();
        if (!isXML) {
          // Avoid an infinite loop by temporarily removing this function from the getter
          handle = attrHandle[lowercaseName];
          attrHandle[lowercaseName] = ret;
          ret = getter(elem, name, isXML) != null ? lowercaseName : null;
          attrHandle[lowercaseName] = handle;
        }
        return ret;
      };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i,
      rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
      prop: function prop(name, value) {
        return access(this, jQuery.prop, name, value, arguments.length > 1);
      },
      removeProp: function removeProp(name) {
        return this.each(function () {
          delete this[jQuery.propFix[name] || name];
        });
      }
    });
    jQuery.extend({
      prop: function prop(elem, name, value) {
        var ret,
          hooks,
          nType = elem.nodeType;

        // Don't get/set properties on text, comment and attribute nodes
        if (nType === 3 || nType === 8 || nType === 2) {
          return;
        }
        if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
          // Fix name and attach hooks
          name = jQuery.propFix[name] || name;
          hooks = jQuery.propHooks[name];
        }
        if (value !== undefined) {
          if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
            return ret;
          }
          return elem[name] = value;
        }
        if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
          return ret;
        }
        return elem[name];
      },
      propHooks: {
        tabIndex: {
          get: function get(elem) {
            // Support: IE <=9 - 11 only
            // elem.tabIndex doesn't always return the
            // correct value when it hasn't been explicitly set
            // Use proper attribute retrieval (trac-12072)
            var tabindex = jQuery.find.attr(elem, "tabindex");
            if (tabindex) {
              return parseInt(tabindex, 10);
            }
            if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
              return 0;
            }
            return -1;
          }
        }
      },
      propFix: {
        "for": "htmlFor",
        "class": "className"
      }
    });

    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) {
      jQuery.propHooks.selected = {
        get: function get(elem) {
          /* eslint no-unused-expressions: "off" */

          var parent = elem.parentNode;
          if (parent && parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
          return null;
        },
        set: function set(elem) {
          /* eslint no-unused-expressions: "off" */

          var parent = elem.parentNode;
          if (parent) {
            parent.selectedIndex;
            if (parent.parentNode) {
              parent.parentNode.selectedIndex;
            }
          }
        }
      };
    }
    jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
      jQuery.propFix[this.toLowerCase()] = this;
    });

    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
      var tokens = value.match(rnothtmlwhite) || [];
      return tokens.join(" ");
    }
    function getClass(elem) {
      return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === "string") {
        return value.match(rnothtmlwhite) || [];
      }
      return [];
    }
    jQuery.fn.extend({
      addClass: function addClass(value) {
        var classNames, cur, curValue, className, i, finalValue;
        if (isFunction(value)) {
          return this.each(function (j) {
            jQuery(this).addClass(value.call(this, j, getClass(this)));
          });
        }
        classNames = classesToArray(value);
        if (classNames.length) {
          return this.each(function () {
            curValue = getClass(this);
            cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
            if (cur) {
              for (i = 0; i < classNames.length; i++) {
                className = classNames[i];
                if (cur.indexOf(" " + className + " ") < 0) {
                  cur += className + " ";
                }
              }

              // Only assign if different to avoid unneeded rendering.
              finalValue = stripAndCollapse(cur);
              if (curValue !== finalValue) {
                this.setAttribute("class", finalValue);
              }
            }
          });
        }
        return this;
      },
      removeClass: function removeClass(value) {
        var classNames, cur, curValue, className, i, finalValue;
        if (isFunction(value)) {
          return this.each(function (j) {
            jQuery(this).removeClass(value.call(this, j, getClass(this)));
          });
        }
        if (!arguments.length) {
          return this.attr("class", "");
        }
        classNames = classesToArray(value);
        if (classNames.length) {
          return this.each(function () {
            curValue = getClass(this);

            // This expression is here for better compressibility (see addClass)
            cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
            if (cur) {
              for (i = 0; i < classNames.length; i++) {
                className = classNames[i];

                // Remove *all* instances
                while (cur.indexOf(" " + className + " ") > -1) {
                  cur = cur.replace(" " + className + " ", " ");
                }
              }

              // Only assign if different to avoid unneeded rendering.
              finalValue = stripAndCollapse(cur);
              if (curValue !== finalValue) {
                this.setAttribute("class", finalValue);
              }
            }
          });
        }
        return this;
      },
      toggleClass: function toggleClass(value, stateVal) {
        var classNames,
          className,
          i,
          self,
          type = _typeof$1(value),
          isValidValue = type === "string" || Array.isArray(value);
        if (isFunction(value)) {
          return this.each(function (i) {
            jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
          });
        }
        if (typeof stateVal === "boolean" && isValidValue) {
          return stateVal ? this.addClass(value) : this.removeClass(value);
        }
        classNames = classesToArray(value);
        return this.each(function () {
          if (isValidValue) {
            // Toggle individual class names
            self = jQuery(this);
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i];

              // Check each className given, space separated list
              if (self.hasClass(className)) {
                self.removeClass(className);
              } else {
                self.addClass(className);
              }
            }

            // Toggle whole class name
          } else if (value === undefined || type === "boolean") {
            className = getClass(this);
            if (className) {
              // Store className if set
              dataPriv.set(this, "__className__", className);
            }

            // If the element has a class name or if we're passed `false`,
            // then remove the whole classname (if there was one, the above saved it).
            // Otherwise bring back whatever was previously saved (if anything),
            // falling back to the empty string if nothing was stored.
            if (this.setAttribute) {
              this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
            }
          }
        });
      },
      hasClass: function hasClass(selector) {
        var className,
          elem,
          i = 0;
        className = " " + selector + " ";
        while (elem = this[i++]) {
          if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
            return true;
          }
        }
        return false;
      }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
      val: function val(value) {
        var hooks,
          ret,
          valueIsFunction,
          elem = this[0];
        if (!arguments.length) {
          if (elem) {
            hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
            if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
              return ret;
            }
            ret = elem.value;

            // Handle most common string cases
            if (typeof ret === "string") {
              return ret.replace(rreturn, "");
            }

            // Handle cases where value is null/undef or number
            return ret == null ? "" : ret;
          }
          return;
        }
        valueIsFunction = isFunction(value);
        return this.each(function (i) {
          var val;
          if (this.nodeType !== 1) {
            return;
          }
          if (valueIsFunction) {
            val = value.call(this, i, jQuery(this).val());
          } else {
            val = value;
          }

          // Treat null/undefined as ""; convert numbers to string
          if (val == null) {
            val = "";
          } else if (typeof val === "number") {
            val += "";
          } else if (Array.isArray(val)) {
            val = jQuery.map(val, function (value) {
              return value == null ? "" : value + "";
            });
          }
          hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

          // If set returns undefined, fall back to normal setting
          if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
            this.value = val;
          }
        });
      }
    });
    jQuery.extend({
      valHooks: {
        option: {
          get: function get(elem) {
            var val = jQuery.find.attr(elem, "value");
            return val != null ? val :
            // Support: IE <=10 - 11 only
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            stripAndCollapse(jQuery.text(elem));
          }
        },
        select: {
          get: function get(elem) {
            var value,
              option,
              i,
              options = elem.options,
              index = elem.selectedIndex,
              one = elem.type === "select-one",
              values = one ? null : [],
              max = one ? index + 1 : options.length;
            if (index < 0) {
              i = max;
            } else {
              i = one ? index : 0;
            }

            // Loop through all the selected options
            for (; i < max; i++) {
              option = options[i];

              // Support: IE <=9 only
              // IE8-9 doesn't update selected after form reset (trac-2551)
              if ((option.selected || i === index) &&
              // Don't return options that are disabled or in a disabled optgroup
              !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                // Get the specific value for the option
                value = jQuery(option).val();

                // We don't need an array for one selects
                if (one) {
                  return value;
                }

                // Multi-Selects return an array
                values.push(value);
              }
            }
            return values;
          },
          set: function set(elem, value) {
            var optionSet,
              option,
              options = elem.options,
              values = jQuery.makeArray(value),
              i = options.length;
            while (i--) {
              option = options[i];

              /* eslint-disable no-cond-assign */

              if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
                optionSet = true;
              }

              /* eslint-enable no-cond-assign */
            }

            // Force browsers to behave consistently when non-matching value is set
            if (!optionSet) {
              elem.selectedIndex = -1;
            }
            return values;
          }
        }
      }
    });

    // Radios and checkboxes getter/setter
    jQuery.each(["radio", "checkbox"], function () {
      jQuery.valHooks[this] = {
        set: function set(elem, value) {
          if (Array.isArray(value)) {
            return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
          }
        }
      };
      if (!support.checkOn) {
        jQuery.valHooks[this].get = function (elem) {
          return elem.getAttribute("value") === null ? "on" : elem.value;
        };
      }
    });

    // Return jQuery for attributes-only inclusion
    var location = window.location;
    var nonce = {
      guid: Date.now()
    };
    var rquery = /\?/;

    // Cross-browser xml parsing
    jQuery.parseXML = function (data) {
      var xml, parserErrorElem;
      if (!data || typeof data !== "string") {
        return null;
      }

      // Support: IE 9 - 11 only
      // IE throws on parseFromString with invalid input.
      try {
        xml = new window.DOMParser().parseFromString(data, "text/xml");
      } catch (e) {}
      parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
      if (!xml || parserErrorElem) {
        jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function (el) {
          return el.textContent;
        }).join("\n") : data));
      }
      return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
      stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
      };
    jQuery.extend(jQuery.event, {
      trigger: function trigger(event, data, elem, onlyHandlers) {
        var i,
          cur,
          tmp,
          bubbleType,
          ontype,
          handle,
          special,
          lastElement,
          eventPath = [elem || document],
          type = hasOwn.call(event, "type") ? event.type : event,
          namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
        cur = lastElement = tmp = elem = elem || document;

        // Don't do events on text and comment nodes
        if (elem.nodeType === 3 || elem.nodeType === 8) {
          return;
        }

        // focus/blur morphs to focusin/out; ensure we're not firing them right now
        if (rfocusMorph.test(type + jQuery.event.triggered)) {
          return;
        }
        if (type.indexOf(".") > -1) {
          // Namespaced trigger; create a regexp to match event type in handle()
          namespaces = type.split(".");
          type = namespaces.shift();
          namespaces.sort();
        }
        ontype = type.indexOf(":") < 0 && "on" + type;

        // Caller can pass in a jQuery.Event object, Object, or just an event type string
        event = event[jQuery.expando] ? event : new jQuery.Event(type, _typeof$1(event) === "object" && event);

        // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
        event.isTrigger = onlyHandlers ? 2 : 3;
        event.namespace = namespaces.join(".");
        event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

        // Clean up the event in case it is being reused
        event.result = undefined;
        if (!event.target) {
          event.target = elem;
        }

        // Clone any incoming data and prepend the event, creating the handler arg list
        data = data == null ? [event] : jQuery.makeArray(data, [event]);

        // Allow special events to draw outside the lines
        special = jQuery.event.special[type] || {};
        if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
          return;
        }

        // Determine event propagation path in advance, per W3C events spec (trac-9951)
        // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
        if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
          bubbleType = special.delegateType || type;
          if (!rfocusMorph.test(bubbleType + type)) {
            cur = cur.parentNode;
          }
          for (; cur; cur = cur.parentNode) {
            eventPath.push(cur);
            tmp = cur;
          }

          // Only add window if we got to document (e.g., not plain obj or detached DOM)
          if (tmp === (elem.ownerDocument || document)) {
            eventPath.push(tmp.defaultView || tmp.parentWindow || window);
          }
        }

        // Fire handlers on the event path
        i = 0;
        while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
          lastElement = cur;
          event.type = i > 1 ? bubbleType : special.bindType || type;

          // jQuery handler
          handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
          if (handle) {
            handle.apply(cur, data);
          }

          // Native handler
          handle = ontype && cur[ontype];
          if (handle && handle.apply && acceptData(cur)) {
            event.result = handle.apply(cur, data);
            if (event.result === false) {
              event.preventDefault();
            }
          }
        }
        event.type = type;

        // If nobody prevented the default action, do it now
        if (!onlyHandlers && !event.isDefaultPrevented()) {
          if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
            // Call a native DOM method on the target with the same name as the event.
            // Don't do default actions on window, that's where global variables be (trac-6170)
            if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
              // Don't re-trigger an onFOO event when we call its FOO() method
              tmp = elem[ontype];
              if (tmp) {
                elem[ontype] = null;
              }

              // Prevent re-triggering of the same event, since we already bubbled it above
              jQuery.event.triggered = type;
              if (event.isPropagationStopped()) {
                lastElement.addEventListener(type, stopPropagationCallback);
              }
              elem[type]();
              if (event.isPropagationStopped()) {
                lastElement.removeEventListener(type, stopPropagationCallback);
              }
              jQuery.event.triggered = undefined;
              if (tmp) {
                elem[ontype] = tmp;
              }
            }
          }
        }
        return event.result;
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function simulate(type, elem, event) {
        var e = jQuery.extend(new jQuery.Event(), event, {
          type: type,
          isSimulated: true
        });
        jQuery.event.trigger(e, null, elem);
      }
    });
    jQuery.fn.extend({
      trigger: function trigger(type, data) {
        return this.each(function () {
          jQuery.event.trigger(type, data, this);
        });
      },
      triggerHandler: function triggerHandler(type, data) {
        var elem = this[0];
        if (elem) {
          return jQuery.event.trigger(type, data, elem, true);
        }
      }
    });
    var rbracket = /\[\]$/,
      rCRLF = /\r?\n/g,
      rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
      rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
      var name;
      if (Array.isArray(obj)) {
        // Serialize array item.
        jQuery.each(obj, function (i, v) {
          if (traditional || rbracket.test(prefix)) {
            // Treat each array item as a scalar.
            add(prefix, v);
          } else {
            // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (_typeof$1(v) === "object" && v != null ? i : "") + "]", v, traditional, add);
          }
        });
      } else if (!traditional && toType(obj) === "object") {
        // Serialize object item.
        for (name in obj) {
          buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        }
      } else {
        // Serialize scalar item.
        add(prefix, obj);
      }
    }

    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function (a, traditional) {
      var prefix,
        s = [],
        add = function add(key, valueOrFunction) {
          // If value is a function, invoke it and use its return value
          var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
          s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
      if (a == null) {
        return "";
      }

      // If an array was passed in, assume that it is an array of form elements.
      if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
        // Serialize the form elements
        jQuery.each(a, function () {
          add(this.name, this.value);
        });
      } else {
        // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for (prefix in a) {
          buildParams(prefix, a[prefix], traditional, add);
        }
      }

      // Return the resulting serialization
      return s.join("&");
    };
    jQuery.fn.extend({
      serialize: function serialize() {
        return jQuery.param(this.serializeArray());
      },
      serializeArray: function serializeArray() {
        return this.map(function () {
          // Can add propHook for "elements" to filter or add form elements
          var elements = jQuery.prop(this, "elements");
          return elements ? jQuery.makeArray(elements) : this;
        }).filter(function () {
          var type = this.type;

          // Use .is( ":disabled" ) so that fieldset[disabled] works
          return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
        }).map(function (_i, elem) {
          var val = jQuery(this).val();
          if (val == null) {
            return null;
          }
          if (Array.isArray(val)) {
            return jQuery.map(val, function (val) {
              return {
                name: elem.name,
                value: val.replace(rCRLF, "\r\n")
              };
            });
          }
          return {
            name: elem.name,
            value: val.replace(rCRLF, "\r\n")
          };
        }).get();
      }
    });
    var r20 = /%20/g,
      rhash = /#.*$/,
      rantiCache = /([?&])_=[^&]*/,
      rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
      // trac-7653, trac-8125, trac-8152: local protocol detection
      rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      rnoContent = /^(?:GET|HEAD)$/,
      rprotocol = /^\/\//,
      /* Prefilters
       * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
       * 2) These are called:
       *    - BEFORE asking for a transport
       *    - AFTER param serialization (s.data is a string if s.processData is true)
       * 3) key is the dataType
       * 4) the catchall symbol "*" can be used
       * 5) execution will start with transport dataType and THEN continue down to "*" if needed
       */
      prefilters = {},
      /* Transports bindings
       * 1) key is the dataType
       * 2) the catchall symbol "*" can be used
       * 3) selection will start with transport dataType and THEN go to "*" if needed
       */
      transports = {},
      // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
      allTypes = "*/".concat("*"),
      // Anchor tag for parsing the document origin
      originAnchor = document.createElement("a");
    originAnchor.href = location.href;

    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
      // dataTypeExpression is optional and defaults to "*"
      return function (dataTypeExpression, func) {
        if (typeof dataTypeExpression !== "string") {
          func = dataTypeExpression;
          dataTypeExpression = "*";
        }
        var dataType,
          i = 0,
          dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
        if (isFunction(func)) {
          // For each dataType in the dataTypeExpression
          while (dataType = dataTypes[i++]) {
            // Prepend if requested
            if (dataType[0] === "+") {
              dataType = dataType.slice(1) || "*";
              (structure[dataType] = structure[dataType] || []).unshift(func);

              // Otherwise append
            } else {
              (structure[dataType] = structure[dataType] || []).push(func);
            }
          }
        }
      };
    }

    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
      var inspected = {},
        seekingTransport = structure === transports;
      function inspect(dataType) {
        var selected;
        inspected[dataType] = true;
        jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
          var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
          if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
            options.dataTypes.unshift(dataTypeOrTransport);
            inspect(dataTypeOrTransport);
            return false;
          } else if (seekingTransport) {
            return !(selected = dataTypeOrTransport);
          }
        });
        return selected;
      }
      return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }

    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
      var key,
        deep,
        flatOptions = jQuery.ajaxSettings.flatOptions || {};
      for (key in src) {
        if (src[key] !== undefined) {
          (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        }
      }
      if (deep) {
        jQuery.extend(true, target, deep);
      }
      return target;
    }

    /* Handles responses to an ajax request:
     * - finds the right dataType (mediates between content-type and expected dataType)
     * - returns the corresponding response
     */
    function ajaxHandleResponses(s, jqXHR, responses) {
      var ct,
        type,
        finalDataType,
        firstDataType,
        contents = s.contents,
        dataTypes = s.dataTypes;

      // Remove auto dataType and get content-type in the process
      while (dataTypes[0] === "*") {
        dataTypes.shift();
        if (ct === undefined) {
          ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
      }

      // Check if we're dealing with a known content-type
      if (ct) {
        for (type in contents) {
          if (contents[type] && contents[type].test(ct)) {
            dataTypes.unshift(type);
            break;
          }
        }
      }

      // Check to see if we have a response for the expected dataType
      if (dataTypes[0] in responses) {
        finalDataType = dataTypes[0];
      } else {
        // Try convertible dataTypes
        for (type in responses) {
          if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
            finalDataType = type;
            break;
          }
          if (!firstDataType) {
            firstDataType = type;
          }
        }

        // Or just use first one
        finalDataType = finalDataType || firstDataType;
      }

      // If we found a dataType
      // We add the dataType to the list if needed
      // and return the corresponding response
      if (finalDataType) {
        if (finalDataType !== dataTypes[0]) {
          dataTypes.unshift(finalDataType);
        }
        return responses[finalDataType];
      }
    }

    /* Chain conversions given the request and the original response
     * Also sets the responseXXX fields on the jqXHR instance
     */
    function ajaxConvert(s, response, jqXHR, isSuccess) {
      var conv2,
        current,
        conv,
        tmp,
        prev,
        converters = {},
        // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();

      // Create converters map with lowercased keys
      if (dataTypes[1]) {
        for (conv in s.converters) {
          converters[conv.toLowerCase()] = s.converters[conv];
        }
      }
      current = dataTypes.shift();

      // Convert to each sequential dataType
      while (current) {
        if (s.responseFields[current]) {
          jqXHR[s.responseFields[current]] = response;
        }

        // Apply the dataFilter if provided
        if (!prev && isSuccess && s.dataFilter) {
          response = s.dataFilter(response, s.dataType);
        }
        prev = current;
        current = dataTypes.shift();
        if (current) {
          // There's only work to do if current dataType is non-auto
          if (current === "*") {
            current = prev;

            // Convert response if prev dataType is non-auto and differs from current
          } else if (prev !== "*" && prev !== current) {
            // Seek a direct converter
            conv = converters[prev + " " + current] || converters["* " + current];

            // If none found, seek a pair
            if (!conv) {
              for (conv2 in converters) {
                // If conv2 outputs current
                tmp = conv2.split(" ");
                if (tmp[1] === current) {
                  // If prev can be converted to accepted input
                  conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                  if (conv) {
                    // Condense equivalence converters
                    if (conv === true) {
                      conv = converters[conv2];

                      // Otherwise, insert the intermediate dataType
                    } else if (converters[conv2] !== true) {
                      current = tmp[0];
                      dataTypes.unshift(tmp[1]);
                    }
                    break;
                  }
                }
              }
            }

            // Apply converter (if not an equivalence)
            if (conv !== true) {
              // Unless errors are allowed to bubble, catch and return them
              if (conv && s["throws"]) {
                response = conv(response);
              } else {
                try {
                  response = conv(response);
                } catch (e) {
                  return {
                    state: "parsererror",
                    error: conv ? e : "No conversion from " + prev + " to " + current
                  };
                }
              }
            }
          }
        }
      }
      return {
        state: "success",
        data: response
      };
    }
    jQuery.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: location.href,
        type: "GET",
        isLocal: rlocalProtocol.test(location.protocol),
        global: true,
        processData: true,
        async: true,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */

        accepts: {
          "*": allTypes,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": true,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": jQuery.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: true,
          context: true
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function ajaxSetup(target, settings) {
        return settings ?
        // Building a settings object
        ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :
        // Extending ajaxSettings
        ajaxExtend(jQuery.ajaxSettings, target);
      },
      ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
      ajaxTransport: addToPrefiltersOrTransports(transports),
      // Main method
      ajax: function ajax(url, options) {
        // If url is an object, simulate pre-1.5 signature
        if (_typeof$1(url) === "object") {
          options = url;
          url = undefined;
        }

        // Force options to be an object
        options = options || {};
        var transport,
          // URL without anti-cache param
          cacheURL,
          // Response headers
          responseHeadersString,
          responseHeaders,
          // timeout handle
          timeoutTimer,
          // Url cleanup var
          urlAnchor,
          // Request state (becomes false upon send and true upon completion)
          completed,
          // To know if global events are to be dispatched
          fireGlobals,
          // Loop variable
          i,
          // uncached part of the url
          uncached,
          // Create the final options object
          s = jQuery.ajaxSetup({}, options),
          // Callbacks context
          callbackContext = s.context || s,
          // Context for global events is callbackContext if it is a DOM node or jQuery collection
          globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
          // Deferreds
          deferred = jQuery.Deferred(),
          completeDeferred = jQuery.Callbacks("once memory"),
          // Status-dependent callbacks
          _statusCode = s.statusCode || {},
          // Headers (they are sent all at once)
          requestHeaders = {},
          requestHeadersNames = {},
          // Default abort message
          strAbort = "canceled",
          // Fake xhr
          jqXHR = {
            readyState: 0,
            // Builds headers hashtable if needed
            getResponseHeader: function getResponseHeader(key) {
              var match;
              if (completed) {
                if (!responseHeaders) {
                  responseHeaders = {};
                  while (match = rheaders.exec(responseHeadersString)) {
                    responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                  }
                }
                match = responseHeaders[key.toLowerCase() + " "];
              }
              return match == null ? null : match.join(", ");
            },
            // Raw string
            getAllResponseHeaders: function getAllResponseHeaders() {
              return completed ? responseHeadersString : null;
            },
            // Caches the header
            setRequestHeader: function setRequestHeader(name, value) {
              if (completed == null) {
                name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                requestHeaders[name] = value;
              }
              return this;
            },
            // Overrides response content-type header
            overrideMimeType: function overrideMimeType(type) {
              if (completed == null) {
                s.mimeType = type;
              }
              return this;
            },
            // Status-dependent callbacks
            statusCode: function statusCode(map) {
              var code;
              if (map) {
                if (completed) {
                  // Execute the appropriate callbacks
                  jqXHR.always(map[jqXHR.status]);
                } else {
                  // Lazy-add the new callbacks in a way that preserves old ones
                  for (code in map) {
                    _statusCode[code] = [_statusCode[code], map[code]];
                  }
                }
              }
              return this;
            },
            // Cancel the request
            abort: function abort(statusText) {
              var finalText = statusText || strAbort;
              if (transport) {
                transport.abort(finalText);
              }
              done(0, finalText);
              return this;
            }
          };

        // Attach deferreds
        deferred.promise(jqXHR);

        // Add protocol if not provided (prefilters might expect it)
        // Handle falsy url in the settings object (trac-10093: consistency with old signature)
        // We also use the url parameter if available
        s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

        // Alias method option to type as per ticket trac-12004
        s.type = options.method || options.type || s.method || s.type;

        // Extract dataTypes list
        s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

        // A cross-domain request is in order when the origin doesn't match the current origin.
        if (s.crossDomain == null) {
          urlAnchor = document.createElement("a");

          // Support: IE <=8 - 11, Edge 12 - 15
          // IE throws exception on accessing the href property if url is malformed,
          // e.g. http://example.com:80x/
          try {
            urlAnchor.href = s.url;

            // Support: IE <=8 - 11 only
            // Anchor's host property isn't correctly set when s.url is relative
            urlAnchor.href = urlAnchor.href;
            s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
          } catch (e) {
            // If there is an error parsing the URL, assume it is crossDomain,
            // it can be rejected by the transport if it is invalid
            s.crossDomain = true;
          }
        }

        // Convert data if not already a string
        if (s.data && s.processData && typeof s.data !== "string") {
          s.data = jQuery.param(s.data, s.traditional);
        }

        // Apply prefilters
        inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

        // If request was aborted inside a prefilter, stop there
        if (completed) {
          return jqXHR;
        }

        // We can fire global events as of now if asked to
        // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
        fireGlobals = jQuery.event && s.global;

        // Watch for a new set of requests
        if (fireGlobals && jQuery.active++ === 0) {
          jQuery.event.trigger("ajaxStart");
        }

        // Uppercase the type
        s.type = s.type.toUpperCase();

        // Determine if request has content
        s.hasContent = !rnoContent.test(s.type);

        // Save the URL in case we're toying with the If-Modified-Since
        // and/or If-None-Match header later on
        // Remove hash to simplify url manipulation
        cacheURL = s.url.replace(rhash, "");

        // More options handling for requests with no content
        if (!s.hasContent) {
          // Remember the hash so we can put it back
          uncached = s.url.slice(cacheURL.length);

          // If data is available and should be processed, append data to url
          if (s.data && (s.processData || typeof s.data === "string")) {
            cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

            // trac-9682: remove data so that it's not used in an eventual retry
            delete s.data;
          }

          // Add or update anti-cache param if needed
          if (s.cache === false) {
            cacheURL = cacheURL.replace(rantiCache, "$1");
            uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
          }

          // Put hash and anti-cache on the URL that will be requested (gh-1732)
          s.url = cacheURL + uncached;

          // Change '%20' to '+' if this is encoded form body content (gh-2658)
        } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
          s.data = s.data.replace(r20, "+");
        }

        // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
        if (s.ifModified) {
          if (jQuery.lastModified[cacheURL]) {
            jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
          }
          if (jQuery.etag[cacheURL]) {
            jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
          }
        }

        // Set the correct header, if data is being sent
        if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
          jqXHR.setRequestHeader("Content-Type", s.contentType);
        }

        // Set the Accepts header for the server, depending on the dataType
        jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

        // Check for headers option
        for (i in s.headers) {
          jqXHR.setRequestHeader(i, s.headers[i]);
        }

        // Allow custom headers/mimetypes and early abort
        if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
          // Abort if not done already and return
          return jqXHR.abort();
        }

        // Aborting is no longer a cancellation
        strAbort = "abort";

        // Install callbacks on deferreds
        completeDeferred.add(s.complete);
        jqXHR.done(s.success);
        jqXHR.fail(s.error);

        // Get transport
        transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

        // If no transport, we auto-abort
        if (!transport) {
          done(-1, "No Transport");
        } else {
          jqXHR.readyState = 1;

          // Send global event
          if (fireGlobals) {
            globalEventContext.trigger("ajaxSend", [jqXHR, s]);
          }

          // If request was aborted inside ajaxSend, stop there
          if (completed) {
            return jqXHR;
          }

          // Timeout
          if (s.async && s.timeout > 0) {
            timeoutTimer = window.setTimeout(function () {
              jqXHR.abort("timeout");
            }, s.timeout);
          }
          try {
            completed = false;
            transport.send(requestHeaders, done);
          } catch (e) {
            // Rethrow post-completion exceptions
            if (completed) {
              throw e;
            }

            // Propagate others as results
            done(-1, e);
          }
        }

        // Callback for when everything is done
        function done(status, nativeStatusText, responses, headers) {
          var isSuccess,
            success,
            error,
            response,
            modified,
            statusText = nativeStatusText;

          // Ignore repeat invocations
          if (completed) {
            return;
          }
          completed = true;

          // Clear timeout if it exists
          if (timeoutTimer) {
            window.clearTimeout(timeoutTimer);
          }

          // Dereference transport for early garbage collection
          // (no matter how long the jqXHR object will be used)
          transport = undefined;

          // Cache response headers
          responseHeadersString = headers || "";

          // Set readyState
          jqXHR.readyState = status > 0 ? 4 : 0;

          // Determine if successful
          isSuccess = status >= 200 && status < 300 || status === 304;

          // Get response data
          if (responses) {
            response = ajaxHandleResponses(s, jqXHR, responses);
          }

          // Use a noop converter for missing script but not if jsonp
          if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
            s.converters["text script"] = function () {};
          }

          // Convert no matter what (that way responseXXX fields are always set)
          response = ajaxConvert(s, response, jqXHR, isSuccess);

          // If successful, handle type chaining
          if (isSuccess) {
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
              modified = jqXHR.getResponseHeader("Last-Modified");
              if (modified) {
                jQuery.lastModified[cacheURL] = modified;
              }
              modified = jqXHR.getResponseHeader("etag");
              if (modified) {
                jQuery.etag[cacheURL] = modified;
              }
            }

            // if no content
            if (status === 204 || s.type === "HEAD") {
              statusText = "nocontent";

              // if not modified
            } else if (status === 304) {
              statusText = "notmodified";

              // If we have data, let's convert it
            } else {
              statusText = response.state;
              success = response.data;
              error = response.error;
              isSuccess = !error;
            }
          } else {
            // Extract error from statusText and normalize for non-aborts
            error = statusText;
            if (status || !statusText) {
              statusText = "error";
              if (status < 0) {
                status = 0;
              }
            }
          }

          // Set data for the fake xhr object
          jqXHR.status = status;
          jqXHR.statusText = (nativeStatusText || statusText) + "";

          // Success/Error
          if (isSuccess) {
            deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
          } else {
            deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
          }

          // Status-dependent callbacks
          jqXHR.statusCode(_statusCode);
          _statusCode = undefined;
          if (fireGlobals) {
            globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
          }

          // Complete
          completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
          if (fireGlobals) {
            globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

            // Handle the global AJAX counter
            if (! --jQuery.active) {
              jQuery.event.trigger("ajaxStop");
            }
          }
        }
        return jqXHR;
      },
      getJSON: function getJSON(url, data, callback) {
        return jQuery.get(url, data, callback, "json");
      },
      getScript: function getScript(url, callback) {
        return jQuery.get(url, undefined, callback, "script");
      }
    });
    jQuery.each(["get", "post"], function (_i, method) {
      jQuery[method] = function (url, data, callback, type) {
        // Shift arguments if data argument was omitted
        if (isFunction(data)) {
          type = type || callback;
          callback = data;
          data = undefined;
        }

        // The url can be an options object (which then must have .url)
        return jQuery.ajax(jQuery.extend({
          url: url,
          type: method,
          dataType: type,
          data: data,
          success: callback
        }, jQuery.isPlainObject(url) && url));
      };
    });
    jQuery.ajaxPrefilter(function (s) {
      var i;
      for (i in s.headers) {
        if (i.toLowerCase() === "content-type") {
          s.contentType = s.headers[i] || "";
        }
      }
    });
    jQuery._evalUrl = function (url, options, doc) {
      return jQuery.ajax({
        url: url,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: true,
        async: false,
        global: false,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function textScript() {}
        },
        dataFilter: function dataFilter(response) {
          jQuery.globalEval(response, options, doc);
        }
      });
    };
    jQuery.fn.extend({
      wrapAll: function wrapAll(html) {
        var wrap;
        if (this[0]) {
          if (isFunction(html)) {
            html = html.call(this[0]);
          }

          // The elements to wrap the target around
          wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
          if (this[0].parentNode) {
            wrap.insertBefore(this[0]);
          }
          wrap.map(function () {
            var elem = this;
            while (elem.firstElementChild) {
              elem = elem.firstElementChild;
            }
            return elem;
          }).append(this);
        }
        return this;
      },
      wrapInner: function wrapInner(html) {
        if (isFunction(html)) {
          return this.each(function (i) {
            jQuery(this).wrapInner(html.call(this, i));
          });
        }
        return this.each(function () {
          var self = jQuery(this),
            contents = self.contents();
          if (contents.length) {
            contents.wrapAll(html);
          } else {
            self.append(html);
          }
        });
      },
      wrap: function wrap(html) {
        var htmlIsFunction = isFunction(html);
        return this.each(function (i) {
          jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
        });
      },
      unwrap: function unwrap(selector) {
        this.parent(selector).not("body").each(function () {
          jQuery(this).replaceWith(this.childNodes);
        });
        return this;
      }
    });
    jQuery.expr.pseudos.hidden = function (elem) {
      return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function (elem) {
      return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function () {
      try {
        return new window.XMLHttpRequest();
      } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
      },
      xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function (options) {
      var _callback, errorCallback;

      // Cross domain only allowed if supported through XMLHttpRequest
      if (support.cors || xhrSupported && !options.crossDomain) {
        return {
          send: function send(headers, complete) {
            var i,
              xhr = options.xhr();
            xhr.open(options.type, options.url, options.async, options.username, options.password);

            // Apply custom fields if provided
            if (options.xhrFields) {
              for (i in options.xhrFields) {
                xhr[i] = options.xhrFields[i];
              }
            }

            // Override mime type if needed
            if (options.mimeType && xhr.overrideMimeType) {
              xhr.overrideMimeType(options.mimeType);
            }

            // X-Requested-With header
            // For cross-domain requests, seeing as conditions for a preflight are
            // akin to a jigsaw puzzle, we simply never set it to be sure.
            // (it can always be set on a per-request basis or even using ajaxSetup)
            // For same-domain requests, won't change header if already provided.
            if (!options.crossDomain && !headers["X-Requested-With"]) {
              headers["X-Requested-With"] = "XMLHttpRequest";
            }

            // Set headers
            for (i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }

            // Callback
            _callback = function callback(type) {
              return function () {
                if (_callback) {
                  _callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                  if (type === "abort") {
                    xhr.abort();
                  } else if (type === "error") {
                    // Support: IE <=9 only
                    // On a manual native abort, IE9 throws
                    // errors on any property access that is not readyState
                    if (typeof xhr.status !== "number") {
                      complete(0, "error");
                    } else {
                      complete(
                      // File: protocol always yields status 0; see trac-8605, trac-14207
                      xhr.status, xhr.statusText);
                    }
                  } else {
                    complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,
                    // Support: IE <=9 only
                    // IE9 has no XHR2 but throws on binary (trac-11426)
                    // For XHR2 non-text, let the caller handle it (gh-2498)
                    (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                      binary: xhr.response
                    } : {
                      text: xhr.responseText
                    }, xhr.getAllResponseHeaders());
                  }
                }
              };
            };

            // Listen to events
            xhr.onload = _callback();
            errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

            // Support: IE 9 only
            // Use onreadystatechange to replace onabort
            // to handle uncaught aborts
            if (xhr.onabort !== undefined) {
              xhr.onabort = errorCallback;
            } else {
              xhr.onreadystatechange = function () {
                // Check readyState before timeout as it changes
                if (xhr.readyState === 4) {
                  // Allow onerror to be called first,
                  // but that will not handle a native abort
                  // Also, save errorCallback to a variable
                  // as xhr.onerror cannot be accessed
                  window.setTimeout(function () {
                    if (_callback) {
                      errorCallback();
                    }
                  });
                }
              };
            }

            // Create the abort callback
            _callback = _callback("abort");
            try {
              // Do send the request (this may raise an exception)
              xhr.send(options.hasContent && options.data || null);
            } catch (e) {
              // trac-14683: Only rethrow if this hasn't been notified as an error yet
              if (_callback) {
                throw e;
              }
            }
          },
          abort: function abort() {
            if (_callback) {
              _callback();
            }
          }
        };
      }
    });

    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function (s) {
      if (s.crossDomain) {
        s.contents.script = false;
      }
    });

    // Install script dataType
    jQuery.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function textScript(text) {
          jQuery.globalEval(text);
          return text;
        }
      }
    });

    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function (s) {
      if (s.cache === undefined) {
        s.cache = false;
      }
      if (s.crossDomain) {
        s.type = "GET";
      }
    });

    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function (s) {
      // This transport only deals with cross domain or forced-by-attrs requests
      if (s.crossDomain || s.scriptAttrs) {
        var script, _callback2;
        return {
          send: function send(_, complete) {
            script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
              charset: s.scriptCharset,
              src: s.url
            }).on("load error", _callback2 = function callback(evt) {
              script.remove();
              _callback2 = null;
              if (evt) {
                complete(evt.type === "error" ? 404 : 200, evt.type);
              }
            });

            // Use native DOM manipulation to avoid our domManip AJAX trickery
            document.head.appendChild(script[0]);
          },
          abort: function abort() {
            if (_callback2) {
              _callback2();
            }
          }
        };
      }
    });
    var oldCallbacks = [],
      rjsonp = /(=)\?(?=&|$)|\?\?/;

    // Default jsonp settings
    jQuery.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function jsonpCallback() {
        var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
        this[callback] = true;
        return callback;
      }
    });

    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
      var callbackName,
        overwritten,
        responseContainer,
        jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

      // Handle iff the expected data type is "jsonp" or we have a parameter to set
      if (jsonProp || s.dataTypes[0] === "jsonp") {
        // Get callback name, remembering preexisting value associated with it
        callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

        // Insert callback into url or form data
        if (jsonProp) {
          s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
        } else if (s.jsonp !== false) {
          s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
        }

        // Use data converter to retrieve json after script execution
        s.converters["script json"] = function () {
          if (!responseContainer) {
            jQuery.error(callbackName + " was not called");
          }
          return responseContainer[0];
        };

        // Force json dataType
        s.dataTypes[0] = "json";

        // Install callback
        overwritten = window[callbackName];
        window[callbackName] = function () {
          responseContainer = arguments;
        };

        // Clean-up function (fires after converters)
        jqXHR.always(function () {
          // If previous value didn't exist - remove it
          if (overwritten === undefined) {
            jQuery(window).removeProp(callbackName);

            // Otherwise restore preexisting value
          } else {
            window[callbackName] = overwritten;
          }

          // Save back as free
          if (s[callbackName]) {
            // Make sure that re-using the options doesn't screw things around
            s.jsonpCallback = originalSettings.jsonpCallback;

            // Save the callback name for future use
            oldCallbacks.push(callbackName);
          }

          // Call if it was a function and we have a response
          if (responseContainer && isFunction(overwritten)) {
            overwritten(responseContainer[0]);
          }
          responseContainer = overwritten = undefined;
        });

        // Delegate to script
        return "script";
      }
    });

    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function () {
      var body = document.implementation.createHTMLDocument("").body;
      body.innerHTML = "<form></form><form></form>";
      return body.childNodes.length === 2;
    }();

    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function (data, context, keepScripts) {
      if (typeof data !== "string") {
        return [];
      }
      if (typeof context === "boolean") {
        keepScripts = context;
        context = false;
      }
      var base, parsed, scripts;
      if (!context) {
        // Stop scripts or inline event handlers from being executed immediately
        // by using document.implementation
        if (support.createHTMLDocument) {
          context = document.implementation.createHTMLDocument("");

          // Set the base href for the created document
          // so any parsed elements with URLs
          // are based on the document's URL (gh-2965)
          base = context.createElement("base");
          base.href = document.location.href;
          context.head.appendChild(base);
        } else {
          context = document;
        }
      }
      parsed = rsingleTag.exec(data);
      scripts = !keepScripts && [];

      // Single tag
      if (parsed) {
        return [context.createElement(parsed[1])];
      }
      parsed = buildFragment([data], context, scripts);
      if (scripts && scripts.length) {
        jQuery(scripts).remove();
      }
      return jQuery.merge([], parsed.childNodes);
    };

    /**
     * Load a url into a page
     */
    jQuery.fn.load = function (url, params, callback) {
      var selector,
        type,
        response,
        self = this,
        off = url.indexOf(" ");
      if (off > -1) {
        selector = stripAndCollapse(url.slice(off));
        url = url.slice(0, off);
      }

      // If it's a function
      if (isFunction(params)) {
        // We assume that it's the callback
        callback = params;
        params = undefined;

        // Otherwise, build a param string
      } else if (params && _typeof$1(params) === "object") {
        type = "POST";
      }

      // If we have elements to modify, make the request
      if (self.length > 0) {
        jQuery.ajax({
          url: url,
          // If "type" variable is undefined, then "GET" method will be used.
          // Make value of this field explicit since
          // user can override it through ajaxSetup method
          type: type || "GET",
          dataType: "html",
          data: params
        }).done(function (responseText) {
          // Save response for use in complete callback
          response = arguments;
          self.html(selector ?
          // If a selector was specified, locate the right elements in a dummy div
          // Exclude scripts to avoid IE 'Permission Denied' errors
          jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :
          // Otherwise use the full result
          responseText);

          // If the request succeeds, this function gets "data", "status", "jqXHR"
          // but they are ignored because response was set above.
          // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function (jqXHR, status) {
          self.each(function () {
            callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
          });
        });
      }
      return this;
    };
    jQuery.expr.pseudos.animated = function (elem) {
      return jQuery.grep(jQuery.timers, function (fn) {
        return elem === fn.elem;
      }).length;
    };
    jQuery.offset = {
      setOffset: function setOffset(elem, options, i) {
        var curPosition,
          curLeft,
          curCSSTop,
          curTop,
          curOffset,
          curCSSLeft,
          calculatePosition,
          position = jQuery.css(elem, "position"),
          curElem = jQuery(elem),
          props = {};

        // Set position first, in-case top/left are set even on static elem
        if (position === "static") {
          elem.style.position = "relative";
        }
        curOffset = curElem.offset();
        curCSSTop = jQuery.css(elem, "top");
        curCSSLeft = jQuery.css(elem, "left");
        calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

        // Need to be able to calculate position if either
        // top or left is auto and position is either absolute or fixed
        if (calculatePosition) {
          curPosition = curElem.position();
          curTop = curPosition.top;
          curLeft = curPosition.left;
        } else {
          curTop = parseFloat(curCSSTop) || 0;
          curLeft = parseFloat(curCSSLeft) || 0;
        }
        if (isFunction(options)) {
          // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
          options = options.call(elem, i, jQuery.extend({}, curOffset));
        }
        if (options.top != null) {
          props.top = options.top - curOffset.top + curTop;
        }
        if (options.left != null) {
          props.left = options.left - curOffset.left + curLeft;
        }
        if ("using" in options) {
          options.using.call(elem, props);
        } else {
          curElem.css(props);
        }
      }
    };
    jQuery.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function offset(options) {
        // Preserve chaining for setter
        if (arguments.length) {
          return options === undefined ? this : this.each(function (i) {
            jQuery.offset.setOffset(this, options, i);
          });
        }
        var rect,
          win,
          elem = this[0];
        if (!elem) {
          return;
        }

        // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
        // Support: IE <=11 only
        // Running getBoundingClientRect on a
        // disconnected node in IE throws an error
        if (!elem.getClientRects().length) {
          return {
            top: 0,
            left: 0
          };
        }

        // Get document-relative position by adding viewport scroll to viewport-relative gBCR
        rect = elem.getBoundingClientRect();
        win = elem.ownerDocument.defaultView;
        return {
          top: rect.top + win.pageYOffset,
          left: rect.left + win.pageXOffset
        };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function position() {
        if (!this[0]) {
          return;
        }
        var offsetParent,
          offset,
          doc,
          elem = this[0],
          parentOffset = {
            top: 0,
            left: 0
          };

        // position:fixed elements are offset from the viewport, which itself always has zero offset
        if (jQuery.css(elem, "position") === "fixed") {
          // Assume position:fixed implies availability of getBoundingClientRect
          offset = elem.getBoundingClientRect();
        } else {
          offset = this.offset();

          // Account for the *real* offset parent, which can be the document or its root element
          // when a statically positioned element is identified
          doc = elem.ownerDocument;
          offsetParent = elem.offsetParent || doc.documentElement;
          while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
            offsetParent = offsetParent.parentNode;
          }
          if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
            // Incorporate borders into its offset, since they are outside its content origin
            parentOffset = jQuery(offsetParent).offset();
            parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
            parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
          }
        }

        // Subtract parent offsets and element margins
        return {
          top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
          left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
        };
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function offsetParent() {
        return this.map(function () {
          var offsetParent = this.offsetParent;
          while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
            offsetParent = offsetParent.offsetParent;
          }
          return offsetParent || documentElement;
        });
      }
    });

    // Create scrollLeft and scrollTop methods
    jQuery.each({
      scrollLeft: "pageXOffset",
      scrollTop: "pageYOffset"
    }, function (method, prop) {
      var top = "pageYOffset" === prop;
      jQuery.fn[method] = function (val) {
        return access(this, function (elem, method, val) {
          // Coalesce documents and windows
          var win;
          if (isWindow(elem)) {
            win = elem;
          } else if (elem.nodeType === 9) {
            win = elem.defaultView;
          }
          if (val === undefined) {
            return win ? win[prop] : elem[method];
          }
          if (win) {
            win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
          } else {
            elem[method] = val;
          }
        }, method, val, arguments.length);
      };
    });

    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each(["top", "left"], function (_i, prop) {
      jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
        if (computed) {
          computed = curCSS(elem, prop);

          // If curCSS returns percentage, fallback to offset
          return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
        }
      });
    });

    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
      Height: "height",
      Width: "width"
    }, function (name, type) {
      jQuery.each({
        padding: "inner" + name,
        content: type,
        "": "outer" + name
      }, function (defaultExtra, funcName) {
        // Margin is only for outerHeight, outerWidth
        jQuery.fn[funcName] = function (margin, value) {
          var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
            extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
          return access(this, function (elem, type, value) {
            var doc;
            if (isWindow(elem)) {
              // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
              return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
            }

            // Get document width or height
            if (elem.nodeType === 9) {
              doc = elem.documentElement;

              // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
              // whichever is greatest
              return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
            }
            return value === undefined ?
            // Get width or height on the element, requesting but not forcing parseFloat
            jQuery.css(elem, type, extra) :
            // Set width or height on the element
            jQuery.style(elem, type, value, extra);
          }, type, chainable ? margin : undefined, chainable);
        };
      });
    });
    jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
      jQuery.fn[type] = function (fn) {
        return this.on(type, fn);
      };
    });
    jQuery.fn.extend({
      bind: function bind(types, data, fn) {
        return this.on(types, null, data, fn);
      },
      unbind: function unbind(types, fn) {
        return this.off(types, null, fn);
      },
      delegate: function delegate(selector, types, data, fn) {
        return this.on(types, selector, data, fn);
      },
      undelegate: function undelegate(selector, types, fn) {
        // ( namespace ) or ( selector, types [, fn] )
        return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
      },
      hover: function hover(fnOver, fnOut) {
        return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
      }
    });
    jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {
      // Handle event binding
      jQuery.fn[name] = function (data, fn) {
        return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
      };
    });

    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function (fn, context) {
      var tmp, args, proxy;
      if (typeof context === "string") {
        tmp = fn[context];
        context = fn;
        fn = tmp;
      }

      // Quick check to determine if target is callable, in the spec
      // this throws a TypeError, but we will just return undefined.
      if (!isFunction(fn)) {
        return undefined;
      }

      // Simulated bind
      args = _slice.call(arguments, 2);
      proxy = function proxy() {
        return fn.apply(context || this, args.concat(_slice.call(arguments)));
      };

      // Set the guid of unique handler to the same of original handler, so it can be removed
      proxy.guid = fn.guid = fn.guid || jQuery.guid++;
      return proxy;
    };
    jQuery.holdReady = function (hold) {
      if (hold) {
        jQuery.readyWait++;
      } else {
        jQuery.ready(true);
      }
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function (obj) {
      // As of jQuery 3.0, isNumeric is limited to
      // strings and numbers (primitives or objects)
      // that can be coerced to finite numbers (gh-2662)
      var type = jQuery.type(obj);
      return (type === "number" || type === "string") &&
      // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function (text) {
      return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    var
      // Map over jQuery in case of overwrite
      _jQuery = window.jQuery,
      // Map over the $ in case of overwrite
      _$ = window.$;
    jQuery.noConflict = function (deep) {
      if (window.$ === jQuery) {
        window.$ = _$;
      }
      if (deep && window.jQuery === jQuery) {
        window.jQuery = _jQuery;
      }
      return jQuery;
    };

    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") {
      window.jQuery = window.$ = jQuery;
    }
    return jQuery;
  });
})(jquery);
var jqueryExports = jquery.exports;
var $ = /*@__PURE__*/getDefaultExportFromCjs(jqueryExports);

var windowWrapper = {
  getLocationHref: function getLocationHref() {
    return window.location.href;
  },
  getLocation: function getLocation() {
    return window.location;
  },
  getNavigator: function getNavigator() {
    return window.navigator;
  },
  getWindow: function getWindow() {
    return window;
  },
  getDocument: function getDocument(wrapInJQuery) {
    return wrapInJQuery ? $(window.document) : window.document;
  },
  open: function open(url, features) {
    if (features) {
      window.open(url, features);
    } else {
      window.open(url);
    }
  }
};

var documentWrapper = {
  getDocument: function getDocument() {
    return window.document;
  }
};

var IPAD_OS_INITIAL_VERSION = 13;
var _supportsHTML5 = false;
var _supportsMP4 = false;
var _supportOgg = false;
var _supportWebM = false;
var _isIE = false;
var _isEdge = false;
var _ieVersion = null;
var _safariMajorVersion = null;
var _isFirefox = false;
var _isChrome = false;
var _isIPad = false;
var _isIPhone = false;
var _isIPod = false;
var _isIOS = false;
var _isAndroid = false;
var _isSafari = false;
var _isRetinaDisplay = false;
var _isSmallScreen = false;
var checkLocationProtocol = function checkLocationProtocol() {
  switch (windowWrapper.getLocation().protocol) {
    case 'http:':
    case 'https:':
      return false;
    case 'file:':
      return true;
  }
};
var isTouchIEInterface = function isTouchIEInterface() {
  var navigator = windowWrapper.getNavigator();
  return navigator.msMaxTouchPoints;
};
var isTouchInterface = function isTouchInterface() {
  return 'ontouchstart' in documentWrapper.getDocument().documentElement || isTouchIEInterface();
};
var _lookAtDevice = function lookAtDevice() {
  var detect = documentWrapper.getDocument().createElement('video') || false;
  _supportsHTML5 = detect && typeof detect.canPlayType !== 'undefined';
  _supportsMP4 = _supportsHTML5 && detect.canPlayType(mediaMimeType.MP4);
  _supportOgg = _supportsHTML5 && detect.canPlayType(mediaMimeType.OGG);
  _supportWebM = _supportsHTML5 && detect.canPlayType(mediaMimeType.WEBM);
  var navigator = windowWrapper.getNavigator();
  _isIPad = navigator.userAgent.match(/iPad/i) !== null;
  _isIPhone = navigator.userAgent.match(/iPhone/i) !== null;
  _isIPod = navigator.userAgent.match(/iPod/i) !== null;
  _isIOS = _isIPad || _isIPhone || _isIPod;
  _isAndroid = navigator.userAgent.toLowerCase().indexOf('android') !== -1;
  _isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') !== -1;
  _isIE = navigator.appName === 'Microsoft Internet Explorer' || navigator.appName === 'Netscape' && new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})').exec(navigator.userAgent) !== null;
  _isEdge = navigator.userAgent.match(/Edge/i) !== null;
  _isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  // Chrome contains safari in it's user agent string, but safari doesn't include chrome
  _isSafari = navigator.userAgent.match(/Safari/i) !== null && !_isChrome;

  // chrome for iOS will match as safari, so we need to do an additional check
  var iOSChromeMatchExp = new RegExp('CriOS\/(.*)');
  if (navigator.appVersion.match(iOSChromeMatchExp)) {
    _isChrome = true;
    _isSafari = false;
  }

  // get IE version if IE
  if (_isIE) {
    var ua = navigator.userAgent;
    var re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
    if (re.exec(ua) !== null) {
      _ieVersion = parseFloat(RegExp.$1);
    }
  }
  if (_isSafari) {
    var matchExp = new RegExp('Version\/(.*) Safari');
    if (navigator.appVersion.match(matchExp)) {
      var safariVersion = navigator.appVersion.match(matchExp).slice(1)[0];
      _safariMajorVersion = safariVersion.substring(0, safariVersion.indexOf('.'));

      // iPad OS 13.x user agent does not contain information to ID the device as an iPad
      if (+_safariMajorVersion >= IPAD_OS_INITIAL_VERSION && !_isIPhone && !_isIPod && isTouchInterface()) {
        _isIPad = true;
        _isIOS = true;
      }
    }
  }

  // Portrait or landscape
  _isSmallScreen = windowWrapper.getWindow().screen.availWidth < 640 && windowWrapper.getWindow().screen.availHeight < 480 || windowWrapper.getWindow().screen.availWidth < 480 && windowWrapper.getWindow().screen.availHeight < 640;

  // Retina display is same res, but higher DPI, this detects that
  _isRetinaDisplay = windowWrapper.getWindow().devicePixelRatio && windowWrapper.getWindow().devicePixelRatio > 1;
};
var supportsFullScreen = function supportsFullScreen() {
  var documentRef = documentWrapper.getDocument();
  return documentRef.fullscreenEnabled || documentRef.webkitFullscreenEnabled;
};
var supportsLegacyIOSFullScreen = function supportsLegacyIOSFullScreen(videoElement) {
  return _isIOS && videoElement && videoElement.webkitSupportsFullscreen;
};
var deviceInfo = {
  isSmallScreen: function isSmallScreen() {
    return _isSmallScreen;
  },
  isRetinaDisplay: function isRetinaDisplay() {
    return _isRetinaDisplay;
  },
  isIPad: function isIPad() {
    return _isIPad;
  },
  isIPhoneOrIPod: function isIPhoneOrIPod() {
    return _isIPhone || _isIPod;
  },
  isIOS: function isIOS() {
    return _isIOS;
  },
  isIE: function isIE() {
    return _isIE;
  },
  isEdge: function isEdge() {
    return _isEdge;
  },
  getIEVersion: function getIEVersion() {
    return _ieVersion;
  },
  getSafariMajorVersion: function getSafariMajorVersion() {
    return _safariMajorVersion;
  },
  isFirefox: function isFirefox() {
    return _isFirefox;
  },
  isChrome: function isChrome() {
    return _isChrome;
  },
  isSafari: function isSafari() {
    return _isSafari;
  },
  isAndroid: function isAndroid() {
    return _isAndroid;
  },
  canPlayHTML5Video: function canPlayHTML5Video() {
    return _supportsHTML5;
  },
  canPlayMP4: function canPlayMP4() {
    return _supportsMP4;
  },
  canPlayOgg: function canPlayOgg() {
    return _supportOgg;
  },
  canPlayWebM: function canPlayWebM() {
    return _supportWebM;
  },
  isTouchInterface: isTouchInterface,
  isTouchIEInterface: isTouchIEInterface,
  getFullScreenChangeEventNames: function getFullScreenChangeEventNames() {
    var documentRef = documentWrapper.getDocument();
    if (typeof documentRef.onfullscreenchange !== 'undefined') {
      return 'fullscreenchange';
    } else if (typeof documentRef.onwebkitfullscreenchange !== 'undefined') {
      return 'webkitfullscreenchange';
    }
  },
  requiresManualPreload: function requiresManualPreload() {
    return _isIOS || _isAndroid;
  },
  supportsFullScreen: supportsFullScreen,
  supportsLegacyIOSFullScreen: supportsLegacyIOSFullScreen,
  mediaLocation: function mediaLocation() {
    var path = windowWrapper.getLocation().href;
    var baseindex = path.lastIndexOf('/');
    var basex = path.substring(0, baseindex + 1);
    if (_isIE) {
      basex = encodeURI(basex);
    }
    basex = basex.split('%25').join('%');
    return basex;
  },
  isLocal: function isLocal() {
    return checkLocationProtocol();
  },
  lookAtDevice: function lookAtDevice() {
    _lookAtDevice();
  }
};

var themeNames = Object.freeze({
  DAWN: 'dawn',
  DUSK: 'dusk'
});

var preloadOptions = Object.freeze({
  none: 'none',
  metadata: 'metadata',
  auto: 'auto'
});
var isValidPreloadOption = function isValidPreloadOption(preloadOption) {
  return Object.keys(preloadOptions).some(function (option) {
    return preloadOption === preloadOptions[option];
  });
};

var DEFAULT_SKIP_DURATION_IN_SECONDS = 5;
var _mediaSources = [];
var _xmpSrc;
var _posterImageSrc;
var _mediaTitle = '';
var _tocSpriteSrc;
var _tocTitle = null;
var _mediaRotation = 0;
var _endActionType = 'stop';
var _endActionParam = true;
var _ignoreXmpControllerParameters = [];
var _ignoreQuizQuestions = false;
var _isSearchable = true; // make it undefined for initial value
var _autoPlayMedia = false;
var _forceAutoPlayMedia = false;
var _skipVideoDuration = -1;
var _skipVideoControlsEnabled = true;
var _captionsEnabled = null;
var _ignoreStoredCaptionVisibleSetting = false;
var _sidebarEnabled = false;
var _sidebarLocation = 'left';
var _backgroundColor = '#000';
var _useUnicode = false;
var _autoHideControls = true;
var _reportScormComplete = false;
var _isScormLesson = false;
var _enforceLinearAssessment = true;
var _disableFullframeMode = true;
var _disableControls = false;
var _disableYouTubeControls = true;
var _disablePictureInPicture = false;
var _disableContinueWithoutQuestions = false;
var _mobileWebViewCanAutoPlay = false;
var _googleAnalyticsID;
var _gaPageViewTrack = true;
var _gaEventTrack = true;
var _customEventTracking = false;
var _customEventCallback;
var _ga4EventCallback;
var _altEventCategoryAsFilename = false;
var _altLoadTimeAsSeconds = false;
var _jumpToTime;
var _embedIFrameId;
var _additionalAppQueryString = '';
var _useSlimAppSplashScreen = true;
var _showYouTubeAnnotations = false;
var _preRollSrc;
var _contentType = '';
var _preload = preloadOptions.none;
var _fullViewPort = true;
var _webConnector;
var _contentBasePath = '';
var _disableContextMenuForVideo = false;
var _theme = themeNames.DUSK;
var _enableSingleClickControl = true;
var _enableDoubleClickControl = true;
var _pluginController$1 = null;
var _useLargerProgressBar = false;
var _displayHotspotsShape = false;
var _audioDescriptionMediaSrc = null;
var _captionSrcList = [];
var _disableInteractions = false;
var _allowFastForward = true;
var _showADACompliantCaptions = false;
var _logScormApiCalls = false;
var _videoThumbnailsSrc = null;
var _videoThumbnailWidth = 0;
var _videoThumbnailHeight = 0;
var _videoThumbnailInterval = 0;
var _videoThumbnailColumns = 0;
var _tocModelFromDescription = null;
var _completeScormOnRequirementsComplete = true;
var _customFullScreenDomElement = null;
var _enableTheaterMode = false;
var _showAcknowledgementLink = true;
var isValidTheme = function isValidTheme(themeName) {
  return Object.keys(themeNames).some(function (themeKey) {
    return themeNames[themeKey] === themeName;
  });
};
var decodedApostrophe = function decodedApostrophe(val) {
  //if runs on a server and is IE
  return val.replace(/&#8217;/g, '\'');
};
var containsNonLatinCodepoints = function containsNonLatinCodepoints(str) {
  return /[^\u0000-\u00ff]/.test(str); // eslint-disable-line no-control-regex
};
var runOnServer = function runOnServer() {
  return window.document.location.href.indexOf('http') === 0;
};
var getUnicodeSafeString = function getUnicodeSafeString(val) {
  if (val === undefined) {
    return val;
  }
  if (!_useUnicode) {
    return val;
  }
  if (!deviceInfo.isIE()) {
    return encodeURI(val);
  }
  if (!runOnServer()) {
    return decodeURI(val);
  }
  if (containsNonLatinCodepoints(val)) {
    return encodeURI(val);
  }
  return val;
};
var clearConfiguration = function clearConfiguration() {
  _mediaSources = [];
  _preload = preloadOptions.none;
  _ignoreStoredCaptionVisibleSetting = false;
  _captionsEnabled = null;
  _pluginController$1 = null;
  _ignoreXmpControllerParameters = [];
  _ignoreQuizQuestions = false;
  _captionSrcList = [];
  _skipVideoControlsEnabled = true;
  _skipVideoDuration = -1;
  _allowFastForward = true;
  _showADACompliantCaptions = false;
  _mediaTitle = '';
  _tocTitle = null;
  _logScormApiCalls = false;
  _videoThumbnailsSrc = null;
  _videoThumbnailWidth = 0;
  _videoThumbnailHeight = 0;
  _videoThumbnailInterval = 0;
  _videoThumbnailColumns = 0;
  _tocModelFromDescription = null;
  _completeScormOnRequirementsComplete = true;
  _customFullScreenDomElement = null;
  _enableTheaterMode = false;
  _ga4EventCallback = null;
  _showAcknowledgementLink = true;
};
var getUnableToDisplayContentString = function getUnableToDisplayContentString() {
  return localizationStrings.getPlayerString(playerStringNames.videoNotSupported);
};
var useCustomEventTracking = function useCustomEventTracking(customEventTracking, customEventCallback) {
  _customEventTracking = customEventTracking;
  _customEventCallback = customEventCallback;
};
var getGA4EventCallback = function getGA4EventCallback() {
  return _ga4EventCallback;
};
var setGA4EventCallback = function setGA4EventCallback(ga4EventCallback) {
  _ga4EventCallback = ga4EventCallback;
};
var getTrackEvents = function getTrackEvents() {
  return _customEventTracking || _googleAnalyticsID !== undefined;
};
var getCustomEventTracking = function getCustomEventTracking() {
  return _customEventTracking;
};
var getCustomEventCallback = function getCustomEventCallback() {
  return _customEventCallback;
};
var setAdditionalAppQueryParamsFromJson = function setAdditionalAppQueryParamsFromJson(params) {
  var queryString = '';
  for (var key in params) {
    queryString += '&' + key + '=' + params[key];
  }
  _additionalAppQueryString = queryString;
};
var getAdditionalAppQueryString = function getAdditionalAppQueryString() {
  return _additionalAppQueryString;
};
var addMediaSrc$1 = function addMediaSrc(mediaSrc) {
  if (typeof mediaSrc === 'string') {
    _mediaSources.push(decodedApostrophe(mediaSrc));
  } else {
    _mediaSources.push(mediaSrc);
  }
};
var getMediaSources = function getMediaSources() {
  return _mediaSources;
};
var getMediaFileName = function getMediaFileName() {
  var mediaSource = _mediaSources.length > 0 ? _mediaSources[0] : undefined;
  if (mediaSource) {
    var splitEl = mediaSource.split('/');
    var mediaFileName = splitEl[splitEl.length - 1];
    return mediaFileName.split('?')[0] || 'Unnamed Media';
  }
  return 'No Media';
};
var saveConfigurationFromQueryString = function saveConfigurationFromQueryString(configParams) {
  if (!(configParams instanceof Array)) {
    return;
  }
  var param;
  var numberParams = configParams.length;
  for (var i = 0; i < numberParams; i++) {
    param = configParams[i].split('=');
    if (param.length === 2) {
      switch (param[0].toLowerCase()) {
        case 'embediframeid':
          {
            _embedIFrameId = param[1];
            break;
          }
        case 't':
          {
            _jumpToTime = param[1];
            break;
          }
        case 'autoplay':
          {
            if (param[1].toLowerCase() === 'true') {
              _autoPlayMedia = true;
            } else if (param[1].toLowerCase() === 'false') {
              _autoPlayMedia = false;
            }
            break;
          }
        case 'forceautoplay':
          {
            if (param[1].toLowerCase() === 'true') {
              _forceAutoPlayMedia = true;
            } else if (param[1].toLowerCase() === 'false') {
              _forceAutoPlayMedia = false;
            }
            break;
          }
        case 'autohidecontrols':
          {
            if (param[1].toLowerCase() === 'true') {
              _autoHideControls = true;
            } else if (param[1].toLowerCase() === 'false') {
              _autoHideControls = false;
            }
            break;
          }
        case 'theme':
          {
            if (isValidTheme(param[1])) {
              _theme = param[1];
            }
          }
      }
    }
  }
};
var isParamBeingIgnored = function isParamBeingIgnored(param) {
  for (var i = 0; i < _ignoreXmpControllerParameters.length; i++) {
    if (param === _ignoreXmpControllerParameters[i]) {
      return true;
    }
  }
  return false;
};
var shouldLoadXmpParam = function shouldLoadXmpParam(param1, param2) {
  if (param1 !== param2) {
    return false;
  }
  return !isParamBeingIgnored(param1);
};
var configureFromXmp = function configureFromXmp(xmp) {
  if (isParamBeingIgnored('*')) {
    return;
  }
  xmp.controllerParameters.forEach(function (controllerParameter) {
    var param = controllerParameter.name.toUpperCase();
    switch (true) {
      case shouldLoadXmpParam('AUTOHIDE', param):
        _autoHideControls = controllerParameter.value === 'true';
        break;
      case shouldLoadXmpParam('AUTOSTART', param):
      case shouldLoadXmpParam('AUTOPLAY', param):
        if (!_autoPlayMedia) {
          _autoPlayMedia = controllerParameter.value === 'true';
        }
        break;
      case shouldLoadXmpParam('SEARCHABLE', param):
        _isSearchable = controllerParameter.value === 'true';
        break;
      case shouldLoadXmpParam('CAPTIONSENABLED', param):
        if (!_ignoreStoredCaptionVisibleSetting) {
          _captionsEnabled = controllerParameter.value === 'true';
        }
        break;
      case shouldLoadXmpParam('SIDEBARENABLED', param):
        _sidebarEnabled = controllerParameter.value === 'true';
        break;
      case shouldLoadXmpParam('UNICODEENABLED', param):
        _useUnicode = controllerParameter.value === 'true';
        break;
      case shouldLoadXmpParam('BACKGROUNDCOLOR', param):
        var bgColor = controllerParameter.value;
        if (bgColor.indexOf('#') === -1) {
          bgColor = '#' + bgColor;
        }
        _backgroundColor = bgColor;
        break;
      case shouldLoadXmpParam('SIDEBARLOCATION', param):
        _sidebarLocation = controllerParameter.value === 'right' || controllerParameter.value === 'r' ? 'right' : 'left';
        break;
      case shouldLoadXmpParam('ENDACTION', param):
        _endActionType = controllerParameter.value;
        break;
      case shouldLoadXmpParam('ENDACTIONPARAM', param):
        _endActionParam = controllerParameter.value;
        break;
    }
  });
  // Only allow URLs that start with http:// or https:// so that
  // javascript: URLs cannot be used maliciously.
  var endActionType = _endActionType.toLowerCase();
  if (endActionType === 'jumptourl' || endActionType === 'jumptourlnew') {
    var endActionParam = _endActionParam.toLowerCase();
    if (endActionParam.indexOf('http://') !== 0 && endActionParam.indexOf('https://') !== 0) {
      _endActionType = 'stop';
      _endActionParam = 'true';
    }
  }
};
var getMediaSrc = function getMediaSrc() {
  // pull the first media source from the list.  Maintain backward compliance with version 1.0.20 and earlier
  return _mediaSources.length > 0 ? _mediaSources[0] : '';
};
var setMediaSrc = function setMediaSrc(mediaSrc) {
  _mediaSources[0] = decodedApostrophe(mediaSrc);
};
var getXMPSrc = function getXMPSrc() {
  return getUnicodeSafeString(_xmpSrc);
};
var setXMPSrc = function setXMPSrc(xmpSrc) {
  _xmpSrc = decodedApostrophe(xmpSrc);
};
var getDisableInteractions = function getDisableInteractions() {
  return _disableInteractions;
};
var setDisableInteractions$1 = function setDisableInteractions(disableInteractions) {
  _disableInteractions = disableInteractions;
};
var getPosterImageSrc = function getPosterImageSrc() {
  return getUnicodeSafeString(_posterImageSrc);
};
var setPosterImageSrc = function setPosterImageSrc(posterImageSrc) {
  _posterImageSrc = posterImageSrc;
};
var getTOCSpriteSrc = function getTOCSpriteSrc() {
  return getUnicodeSafeString(_tocSpriteSrc);
};
var setTOCSpriteSrc = function setTOCSpriteSrc(tocSpriteSrc) {
  _tocSpriteSrc = tocSpriteSrc;
};
var getMediaTitle = function getMediaTitle() {
  return _mediaTitle;
};
var setMediaTitle = function setMediaTitle(mediaTitle) {
  _mediaTitle = mediaTitle;
};
var getTOCTitle = function getTOCTitle() {
  return _tocTitle;
};
var setTOCTitle = function setTOCTitle(tocTitle) {
  _tocTitle = tocTitle;
};
var getMediaRotation = function getMediaRotation() {
  return _mediaRotation;
};
var setMediaRotation = function setMediaRotation(rotation) {
  _mediaRotation = rotation;
};
var getEndActionType$1 = function getEndActionType() {
  return _endActionType;
};
var setEndActionType = function setEndActionType(endActionType) {
  _endActionType = endActionType;
};
var getEndActionParam = function getEndActionParam() {
  return _endActionParam;
};
var setEndActionParam = function setEndActionParam(endActionParam) {
  _endActionParam = endActionParam;
};
var getIgnoreXmpControllerParameters = function getIgnoreXmpControllerParameters() {
  return _ignoreXmpControllerParameters;
};
var setIgnoreXmpControllerParameters = function setIgnoreXmpControllerParameters(ignoreXmpControllerParameters) {
  var upperCasedIgnores = ignoreXmpControllerParameters.map(function (p) {
    return p.toUpperCase();
  });
  _ignoreXmpControllerParameters = upperCasedIgnores;
};
var getIgnoreQuizQuestions = function getIgnoreQuizQuestions() {
  return _ignoreQuizQuestions;
};
var setIgnoreQuizQuestions = function setIgnoreQuizQuestions(ignoreQuizQuestions) {
  _ignoreQuizQuestions = ignoreQuizQuestions;
};
var getIsSearchable = function getIsSearchable() {
  return _isSearchable;
};
var setIsSearchable = function setIsSearchable(isSearchable) {
  _isSearchable = isSearchable;
};
var getAutoPlayMedia = function getAutoPlayMedia() {
  return _autoPlayMedia;
};
var setAutoPlayMedia = function setAutoPlayMedia(autoPlayMedia) {
  _autoPlayMedia = autoPlayMedia;
};
var getForceAutoPlayMedia = function getForceAutoPlayMedia() {
  return _forceAutoPlayMedia;
};
var setForceAutoPlayMedia = function setForceAutoPlayMedia(forceAutoPlayMedia) {
  _forceAutoPlayMedia = forceAutoPlayMedia;
};
var getCaptionsEnabled = function getCaptionsEnabled() {
  return _captionsEnabled === true;
};
var setCaptionsEnabled = function setCaptionsEnabled(captionsEnabled) {
  _captionsEnabled = captionsEnabled;
};
var getIgnoreStoredCaptionVisibleSetting = function getIgnoreStoredCaptionVisibleSetting() {
  return _ignoreStoredCaptionVisibleSetting;
};
var setIgnoreStoredCaptionVisibleSetting = function setIgnoreStoredCaptionVisibleSetting(ignoreStored) {
  _ignoreStoredCaptionVisibleSetting = ignoreStored;
};
var getSidebarEnabled = function getSidebarEnabled() {
  return _sidebarEnabled;
};
var setSidebarEnabled = function setSidebarEnabled(sidebarEnabled) {
  _sidebarEnabled = sidebarEnabled;
};
var getSidebarLocation = function getSidebarLocation() {
  return _sidebarLocation;
};
var setSidebarLocation = function setSidebarLocation(sidebarLocation) {
  _sidebarLocation = sidebarLocation;
};
var getBackgroundColor = function getBackgroundColor() {
  return _backgroundColor;
};
var setBackgroundColor = function setBackgroundColor(backgroundColor) {
  _backgroundColor = backgroundColor;
};
var getAutoHideControls = function getAutoHideControls() {
  return _autoHideControls;
};
var setAutoHideControls = function setAutoHideControls(autoHideControls) {
  _autoHideControls = autoHideControls;
};
var getProcessUnicodeNames = function getProcessUnicodeNames() {
  return _useUnicode;
};
var setProcessUnicodeNames = function setProcessUnicodeNames(useUnicode) {
  _useUnicode = useUnicode;
};
var getEnforceLinearAssessment = function getEnforceLinearAssessment() {
  return _enforceLinearAssessment;
};
var setEnforceLinearAssessment = function setEnforceLinearAssessment(enforceLinearAssessment) {
  _enforceLinearAssessment = enforceLinearAssessment;
};
var getDisableFullframeMode = function getDisableFullframeMode() {
  return _disableFullframeMode;
};
var setDisableFullframeMode = function setDisableFullframeMode(disableFullframeMode) {
  _disableFullframeMode = disableFullframeMode;
};
var getDisableControls = function getDisableControls() {
  return _disableControls;
};
var setDisableControls = function setDisableControls(disableControls) {
  _disableControls = disableControls;
};
var getDisableYouTubeControls = function getDisableYouTubeControls() {
  return _disableYouTubeControls;
};
var setDisableYouTubeControls = function setDisableYouTubeControls(disableYouTubeControls) {
  _disableYouTubeControls = disableYouTubeControls;
};
var getDisablePictureInPicture = function getDisablePictureInPicture() {
  return _disablePictureInPicture;
};
var setDisablePictureInPicture = function setDisablePictureInPicture(disablePictureInPicture) {
  _disablePictureInPicture = disablePictureInPicture;
};
var getDisableContinueWithoutQuestions = function getDisableContinueWithoutQuestions() {
  return _disableContinueWithoutQuestions;
};
var setDisableContinueWithoutQuestions = function setDisableContinueWithoutQuestions(disableContinueWithoutQuestions) {
  _disableContinueWithoutQuestions = disableContinueWithoutQuestions;
};
var getMobileWebViewCanAutoPlay = function getMobileWebViewCanAutoPlay() {
  return _mobileWebViewCanAutoPlay;
};
var setMobileWebViewCanAutoPlay = function setMobileWebViewCanAutoPlay(canAutoPlay) {
  _mobileWebViewCanAutoPlay = canAutoPlay;
};
var getGoogleAnalyticsID = function getGoogleAnalyticsID() {
  return _googleAnalyticsID;
};
var setGoogleAnalyticsID = function setGoogleAnalyticsID(id) {
  console.warn('Setting custom Google Analytics has been removed'); // eslint-disable-line
  _googleAnalyticsID = id;
};
var getGAPageViewTracking = function getGAPageViewTracking() {
  return _gaPageViewTrack;
};
var setGAPageViewTracking = function setGAPageViewTracking(gaPageViewTrack) {
  _gaPageViewTrack = gaPageViewTrack;
};
var getGAEventTracking = function getGAEventTracking() {
  return _gaEventTrack;
};
var setGAEventTracking = function setGAEventTracking(gaEventTrack) {
  _gaEventTrack = gaEventTrack;
};
var getAltEventCategoryAsFilename = function getAltEventCategoryAsFilename() {
  return _altEventCategoryAsFilename;
};
var setAltEventCategoryAsFilename = function setAltEventCategoryAsFilename(altEventCategoryAsFilename) {
  _altEventCategoryAsFilename = altEventCategoryAsFilename;
};
var getAltLoadTimeAsSeconds = function getAltLoadTimeAsSeconds() {
  return _altLoadTimeAsSeconds;
};
var setAltLoadTimeAsSeconds = function setAltLoadTimeAsSeconds(altLoadTimeAsSeconds) {
  _altLoadTimeAsSeconds = altLoadTimeAsSeconds;
};
var getJumpToTime = function getJumpToTime() {
  return _jumpToTime;
};
var setJumpToTime = function setJumpToTime(time) {
  _jumpToTime = time;
};
var getEmbedIFrameId = function getEmbedIFrameId() {
  return _embedIFrameId;
};
var setEmbedIFrameId = function setEmbedIFrameId(embedIFrameId) {
  _embedIFrameId = embedIFrameId;
};
var getUseSlimAppSplashScreen = function getUseSlimAppSplashScreen() {
  return _useSlimAppSplashScreen;
};
var setUseSlimAppSplashScreen = function setUseSlimAppSplashScreen(useSlimAppSplashScreen) {
  _useSlimAppSplashScreen = useSlimAppSplashScreen;
};
var getDisableContextMenuForVideo = function getDisableContextMenuForVideo() {
  return _disableContextMenuForVideo;
};
var setDisableContextMenuForVideo = function setDisableContextMenuForVideo(disableContextMenuForVideo) {
  _disableContextMenuForVideo = disableContextMenuForVideo;
};
var getShowYouTubeAnnotations = function getShowYouTubeAnnotations() {
  return _showYouTubeAnnotations;
};
var setShowYouTubeAnnotations = function setShowYouTubeAnnotations(showAnnotations) {
  _showYouTubeAnnotations = showAnnotations;
};
var getPreRollSrc = function getPreRollSrc() {
  return _preRollSrc;
};
var setPreRollSrc = function setPreRollSrc(preRollSrc) {
  _preRollSrc = preRollSrc;
};
var getContentBase = function getContentBase() {
  return _contentBasePath;
};
var setContentBase = function setContentBase(value) {
  _contentBasePath = value;
};
var getContentType = function getContentType() {
  return _contentType;
};
var setContentType = function setContentType(contentType) {
  _contentType = contentType;
};
var getPreload = function getPreload() {
  return _preload;
};
var setPreload = function setPreload(preloadOption) {
  if (isValidPreloadOption(preloadOption)) {
    _preload = preloadOption;
  }
};
var getFullViewPort = function getFullViewPort() {
  return _fullViewPort;
};
var setFullViewPort = function setFullViewPort(value) {
  _fullViewPort = value;
};
var getWebConnector = function getWebConnector() {
  return _webConnector;
};
var setWebConnector = function setWebConnector(value) {
  _webConnector = value;
};
var getTheme = function getTheme() {
  return _theme;
};
var setTheme$2 = function setTheme(value) {
  if (isValidTheme(value)) {
    _theme = value;
  }
};
var getEnableSingleClickControl = function getEnableSingleClickControl() {
  return _enableSingleClickControl;
};
var setEnableSingleClickControl = function setEnableSingleClickControl(value) {
  _enableSingleClickControl = value;
};
var getEnableDoubleClickControl = function getEnableDoubleClickControl() {
  return _enableDoubleClickControl;
};
var setEnableDoubleClickControl = function setEnableDoubleClickControl(value) {
  _enableDoubleClickControl = value;
};
var getPluginController = function getPluginController() {
  return _pluginController$1;
};
var setPluginController = function setPluginController(pluginController) {
  _pluginController$1 = pluginController;
};
var getUseLargerProgressBar = function getUseLargerProgressBar() {
  return _useLargerProgressBar;
};
var setUseLargerProgressBar = function setUseLargerProgressBar(useLargerProgressBar) {
  _useLargerProgressBar = useLargerProgressBar;
};

// legacy scorm support
var getReportScormComplete = function getReportScormComplete() {
  return _reportScormComplete;
};
var setReportScormComplete = function setReportScormComplete(reportScorm) {
  _reportScormComplete = reportScorm;
};

// built in scorm support
var getIsScormLesson = function getIsScormLesson() {
  return _isScormLesson;
};
var setIsScormLesson = function setIsScormLesson(isScormLesson) {
  _isScormLesson = isScormLesson;
};
var getDisplayHotspotsShape = function getDisplayHotspotsShape() {
  return _displayHotspotsShape;
};
var setDisplayHotspotsShape = function setDisplayHotspotsShape(displayHotspotsShape) {
  _displayHotspotsShape = displayHotspotsShape;
};
var getAudioDescriptionMediaSrc = function getAudioDescriptionMediaSrc() {
  return _audioDescriptionMediaSrc;
};
var setAudioDescriptionMediaSrc = function setAudioDescriptionMediaSrc(audioDescriptionMediaSrc) {
  _audioDescriptionMediaSrc = audioDescriptionMediaSrc;
};
var addCaptionSrc = function addCaptionSrc(captionSrc, languageIdentifierString) {
  _captionSrcList.push({
    src: captionSrc,
    languageIdentifier: languageIdentifierString
  });
};
var getCaptionSrcList = function getCaptionSrcList() {
  return _captionSrcList;
};
var getSkipVideoControlsEnabled = function getSkipVideoControlsEnabled() {
  return _skipVideoControlsEnabled;
};
var setSkipVideoControlsEnabled = function setSkipVideoControlsEnabled(skipVideoControlsEnabled) {
  _skipVideoControlsEnabled = skipVideoControlsEnabled;
};
var getSkipVideoDuration = function getSkipVideoDuration() {
  return _skipVideoDuration === -1 ? DEFAULT_SKIP_DURATION_IN_SECONDS : _skipVideoDuration;
};
var setSkipVideoDuration = function setSkipVideoDuration(skipVideoDuration) {
  if (typeof skipVideoDuration !== 'number') {
    return;
  }
  _skipVideoDuration = skipVideoDuration;
};
var getAllowFastForward = function getAllowFastForward() {
  return _allowFastForward;
};
var setAllowFastForward = function setAllowFastForward(allowFastForward) {
  _allowFastForward = allowFastForward;
};
var getShowADACompliantCaptions = function getShowADACompliantCaptions() {
  return _showADACompliantCaptions;
};
var setShowADACompliantCaptions = function setShowADACompliantCaptions(showADACompliantCaptions) {
  _showADACompliantCaptions = showADACompliantCaptions;
};
var getLogScormApiCalls = function getLogScormApiCalls() {
  return _logScormApiCalls;
};
var setLogScormApiCalls = function setLogScormApiCalls(logScormApiCalls) {
  _logScormApiCalls = logScormApiCalls;
};
var getVideoThumbnailSrc = function getVideoThumbnailSrc() {
  return _videoThumbnailsSrc;
};
var setVideoThumbnailSrc = function setVideoThumbnailSrc(videoThumbnailSrc) {
  _videoThumbnailsSrc = videoThumbnailSrc;
};
var getVideoThumbnailWidth = function getVideoThumbnailWidth() {
  return _videoThumbnailWidth;
};
var setVideoThumbnailWidth = function setVideoThumbnailWidth(videoThumbnailWidth) {
  _videoThumbnailWidth = videoThumbnailWidth;
};
var getVideoThumbnailHeight = function getVideoThumbnailHeight() {
  return _videoThumbnailHeight;
};
var setVideoThumbnailHeight = function setVideoThumbnailHeight(videoThumbnailHeight) {
  _videoThumbnailHeight = videoThumbnailHeight;
};
var getVideoThumbnailInterval = function getVideoThumbnailInterval() {
  return _videoThumbnailInterval;
};
var setVideoThumbnailInterval = function setVideoThumbnailInterval(videoThumbnailInterval) {
  _videoThumbnailInterval = videoThumbnailInterval;
};
var getVideoThumbnailColumns = function getVideoThumbnailColumns() {
  return _videoThumbnailColumns;
};
var setVideoThumbnailColumns = function setVideoThumbnailColumns(videoThumbnailColumns) {
  _videoThumbnailColumns = videoThumbnailColumns;
};
var getTocModelFromDescription = function getTocModelFromDescription() {
  return _tocModelFromDescription;
};
var setTocModelFromDescription = function setTocModelFromDescription(tocModelFromDescription) {
  _tocModelFromDescription = tocModelFromDescription;
};
var getCompleteScormOnRequirementsComplete = function getCompleteScormOnRequirementsComplete() {
  return _completeScormOnRequirementsComplete;
};
var setCompleteScormOnRequirementsComplete = function setCompleteScormOnRequirementsComplete(completeScormOnRequirementsComplete) {
  _completeScormOnRequirementsComplete = completeScormOnRequirementsComplete;
};
var getCustomFullScreenDomElement = function getCustomFullScreenDomElement() {
  return _customFullScreenDomElement;
};
var setCustomFullScreenDomElement = function setCustomFullScreenDomElement(customFullScreenDomElement) {
  _customFullScreenDomElement = customFullScreenDomElement;
};
var getEnableTheaterMode = function getEnableTheaterMode() {
  return _enableTheaterMode;
};
var setEnableTheaterMode = function setEnableTheaterMode(enabled) {
  _enableTheaterMode = enabled;
};
var getShowAcknowledgementLink = function getShowAcknowledgementLink() {
  return _showAcknowledgementLink;
};
var setShowAcknowledgementLink = function setShowAcknowledgementLink(showAcknowledgementLink) {
  _showAcknowledgementLink = showAcknowledgementLink;
};
var deprecatedNoOp = function deprecatedNoOp() {}; // eslint-disable-line

var playerConfiguration = Object.defineProperties({
  clearConfiguration: clearConfiguration,
  runOnServer: runOnServer,
  addMediaSrc: addMediaSrc$1,
  getMediaSources: getMediaSources,
  addCaptionSrc: addCaptionSrc,
  getMediaFileName: getMediaFileName,
  getUnicodeSafeString: getUnicodeSafeString,
  getUnableToDisplayContentString: getUnableToDisplayContentString,
  useCustomEventTracking: useCustomEventTracking,
  getTrackEvents: getTrackEvents,
  getCustomEventTracking: getCustomEventTracking,
  getCustomEventCallback: getCustomEventCallback,
  setAdditionalAppQueryParamsFromJson: setAdditionalAppQueryParamsFromJson,
  getAdditionalAppQueryString: getAdditionalAppQueryString,
  saveConfigurationFromQueryString: saveConfigurationFromQueryString,
  configureFromXmp: configureFromXmp,
  getMediaSrc: getMediaSrc,
  setMediaSrc: setMediaSrc,
  getXMPSrc: getXMPSrc,
  setXMPSrc: setXMPSrc,
  getPosterImageSrc: getPosterImageSrc,
  setPosterImageSrc: setPosterImageSrc,
  getMediaTitle: getMediaTitle,
  setMediaTitle: setMediaTitle,
  getTOCSpriteSrc: getTOCSpriteSrc,
  setTOCSpriteSrc: setTOCSpriteSrc,
  getTOCTitle: getTOCTitle,
  setTOCTitle: setTOCTitle,
  getAudioDescriptionMediaSrc: getAudioDescriptionMediaSrc,
  setAudioDescriptionMediaSrc: setAudioDescriptionMediaSrc,
  getMediaRotation: getMediaRotation,
  setMediaRotation: setMediaRotation,
  getEndActionType: getEndActionType$1,
  setEndActionType: setEndActionType,
  getEndActionParam: getEndActionParam,
  setEndActionParam: setEndActionParam,
  getIgnoreXmpControllerParameters: getIgnoreXmpControllerParameters,
  setIgnoreXmpControllerParameters: setIgnoreXmpControllerParameters,
  getIgnoreQuizQuestions: getIgnoreQuizQuestions,
  setIgnoreQuizQuestions: setIgnoreQuizQuestions,
  getIsSearchable: getIsSearchable,
  setIsSearchable: setIsSearchable,
  getDisableInteractions: getDisableInteractions,
  setDisableInteractions: setDisableInteractions$1,
  getAutoPlayMedia: getAutoPlayMedia,
  setAutoPlayMedia: setAutoPlayMedia,
  getForceAutoPlayMedia: getForceAutoPlayMedia,
  setForceAutoPlayMedia: setForceAutoPlayMedia,
  getCaptionsEnabled: getCaptionsEnabled,
  setCaptionsEnabled: setCaptionsEnabled,
  getIgnoreStoredCaptionVisibleSetting: getIgnoreStoredCaptionVisibleSetting,
  setIgnoreStoredCaptionVisibleSetting: setIgnoreStoredCaptionVisibleSetting,
  getSidebarEnabled: getSidebarEnabled,
  setSidebarEnabled: setSidebarEnabled,
  getSidebarLocation: getSidebarLocation,
  setSidebarLocation: setSidebarLocation,
  getBackgroundColor: getBackgroundColor,
  setBackgroundColor: setBackgroundColor,
  getAutoHideControls: getAutoHideControls,
  setAutoHideControls: setAutoHideControls,
  getProcessUnicodeNames: getProcessUnicodeNames,
  setProcessUnicodeNames: setProcessUnicodeNames,
  getReportScormComplete: getReportScormComplete,
  setReportScormComplete: setReportScormComplete,
  getEnforceLinearAssessment: getEnforceLinearAssessment,
  setEnforceLinearAssessment: setEnforceLinearAssessment,
  getDisableFullframeMode: getDisableFullframeMode,
  setDisableFullframeMode: setDisableFullframeMode,
  getDisableControls: getDisableControls,
  setDisableControls: setDisableControls,
  getDisableYouTubeControls: getDisableYouTubeControls,
  setDisableYouTubeControls: setDisableYouTubeControls,
  getDisablePictureInPicture: getDisablePictureInPicture,
  setDisablePictureInPicture: setDisablePictureInPicture,
  getDisableContinueWithoutQuestions: getDisableContinueWithoutQuestions,
  setDisableContinueWithoutQuestions: setDisableContinueWithoutQuestions,
  getMobileWebViewCanAutoPlay: getMobileWebViewCanAutoPlay,
  setMobileWebViewCanAutoPlay: setMobileWebViewCanAutoPlay,
  getGoogleAnalyticsID: getGoogleAnalyticsID,
  setGoogleAnalyticsID: setGoogleAnalyticsID,
  getGAPageViewTracking: getGAPageViewTracking,
  setGAPageViewTracking: setGAPageViewTracking,
  getGAEventTracking: getGAEventTracking,
  setGAEventTracking: setGAEventTracking,
  getAltEventCategoryAsFilename: getAltEventCategoryAsFilename,
  setAltEventCategoryAsFilename: setAltEventCategoryAsFilename,
  getAltLoadTimeAsSeconds: getAltLoadTimeAsSeconds,
  setAltLoadTimeAsSeconds: setAltLoadTimeAsSeconds,
  getJumpToTime: getJumpToTime,
  setJumpToTime: setJumpToTime,
  getEmbedIFrameId: getEmbedIFrameId,
  setEmbedIFrameId: setEmbedIFrameId,
  getUseSlimAppSplashScreen: getUseSlimAppSplashScreen,
  setUseSlimAppSplashScreen: setUseSlimAppSplashScreen,
  getDisableContextMenuForVideo: getDisableContextMenuForVideo,
  setDisableContextMenuForVideo: setDisableContextMenuForVideo,
  getShowYouTubeAnnotations: getShowYouTubeAnnotations,
  setShowYouTubeAnnotations: setShowYouTubeAnnotations,
  getPreRollSrc: getPreRollSrc,
  setPreRollSrc: setPreRollSrc,
  getContentBase: getContentBase,
  setContentBase: setContentBase,
  getContentType: getContentType,
  setContentType: setContentType,
  getPreload: getPreload,
  setPreload: setPreload,
  getFullViewPort: getFullViewPort,
  setFullViewPort: setFullViewPort,
  getWebConnector: getWebConnector,
  setWebConnector: setWebConnector,
  getTheme: getTheme,
  setTheme: setTheme$2,
  getEnableSingleClickControl: getEnableSingleClickControl,
  setEnableSingleClickControl: setEnableSingleClickControl,
  getEnableDoubleClickControl: getEnableDoubleClickControl,
  setEnableDoubleClickControl: setEnableDoubleClickControl,
  getPluginController: getPluginController,
  setPluginController: setPluginController,
  getUseLargerProgressBar: getUseLargerProgressBar,
  setUseLargerProgressBar: setUseLargerProgressBar,
  getDisplayHotspotsShape: getDisplayHotspotsShape,
  setDisplayHotspotsShape: setDisplayHotspotsShape,
  getSkipVideoControlsEnabled: getSkipVideoControlsEnabled,
  setSkipVideoControlsEnabled: setSkipVideoControlsEnabled,
  getSkipVideoDuration: getSkipVideoDuration,
  setSkipVideoDuration: setSkipVideoDuration,
  getAllowFastForward: getAllowFastForward,
  setAllowFastForward: setAllowFastForward,
  getShowADACompliantCaptions: getShowADACompliantCaptions,
  setShowADACompliantCaptions: setShowADACompliantCaptions,
  getLogScormApiCalls: getLogScormApiCalls,
  setLogScormApiCalls: setLogScormApiCalls,
  getVideoThumbnailSrc: getVideoThumbnailSrc,
  setVideoThumbnailSrc: setVideoThumbnailSrc,
  getVideoThumbnailWidth: getVideoThumbnailWidth,
  setVideoThumbnailWidth: setVideoThumbnailWidth,
  getVideoThumbnailHeight: getVideoThumbnailHeight,
  setVideoThumbnailHeight: setVideoThumbnailHeight,
  getVideoThumbnailInterval: getVideoThumbnailInterval,
  setVideoThumbnailInterval: setVideoThumbnailInterval,
  getVideoThumbnailColumns: getVideoThumbnailColumns,
  setVideoThumbnailColumns: setVideoThumbnailColumns,
  getTocModelFromDescription: getTocModelFromDescription,
  setTocModelFromDescription: setTocModelFromDescription,
  getCompleteScormOnRequirementsComplete: getCompleteScormOnRequirementsComplete,
  setCompleteScormOnRequirementsComplete: setCompleteScormOnRequirementsComplete,
  getCustomFullScreenDomElement: getCustomFullScreenDomElement,
  setCustomFullScreenDomElement: setCustomFullScreenDomElement,
  getEnableTheaterMode: getEnableTheaterMode,
  setEnableTheaterMode: setEnableTheaterMode,
  getGA4EventCallback: getGA4EventCallback,
  setGA4EventCallback: setGA4EventCallback,
  getShowAcknowledgementLink: getShowAcknowledgementLink,
  setShowAcknowledgementLink: setShowAcknowledgementLink,
  // deprecated methods
  setSwfBase: setContentBase,
  isIEOnServerWithUnicode: deprecatedNoOp,
  setFlashUpdateBootstrapSwf: deprecatedNoOp,
  getAdvancedSeeking: deprecatedNoOp,
  setAdvancedSeeking: deprecatedNoOp,
  getDebugUIMode: deprecatedNoOp,
  setDebugUIMode: deprecatedNoOp,
  getPlayerWidth: deprecatedNoOp,
  setPlayerWidth: deprecatedNoOp,
  getPlayerHeight: deprecatedNoOp,
  setPlayerHeight: deprecatedNoOp,
  setFlashPlayerSwf: deprecatedNoOp,
  setForceFlashPlayer: deprecatedNoOp,
  setForceHtml5Player: deprecatedNoOp,
  setConfigurationSrc: deprecatedNoOp,
  setPrioritizeFullScreen: deprecatedNoOp,
  getDisableYouTubeFullscreen: deprecatedNoOp,
  setDisableYouTubeFullscreen: deprecatedNoOp,
  setAllowRewind: deprecatedNoOp
}, {
  mediaSrc: {
    get: getMediaSrc,
    set: setMediaSrc
  },
  xmpSrc: {
    get: getXMPSrc,
    set: setXMPSrc
  },
  posterImageSrc: {
    get: getPosterImageSrc,
    set: setPosterImageSrc
  },
  mediaTitle: {
    get: getMediaTitle,
    set: setMediaTitle
  },
  tocSpriteSrc: {
    get: getTOCSpriteSrc,
    set: setTOCSpriteSrc
  },
  tocTitle: {
    get: getTOCTitle,
    set: setTOCTitle
  },
  mediaRotation: {
    get: getMediaRotation,
    set: setMediaRotation
  },
  endActionType: {
    get: getEndActionType$1,
    set: setEndActionType
  },
  endActionParam: {
    get: getEndActionParam,
    set: setEndActionParam
  },
  ignoreXmpControllerParameters: {
    get: getIgnoreXmpControllerParameters,
    set: setIgnoreXmpControllerParameters
  },
  ignoreQuizQuestions: {
    get: getIgnoreQuizQuestions,
    set: setIgnoreQuizQuestions
  },
  disableInteractions: {
    get: getDisableInteractions,
    set: setDisableInteractions$1
  },
  isSearchable: {
    get: getIsSearchable,
    set: setIsSearchable
  },
  autoPlayMedia: {
    get: getAutoPlayMedia,
    set: setAutoPlayMedia
  },
  forceAutoPlayMedia: {
    get: getForceAutoPlayMedia,
    set: setForceAutoPlayMedia
  },
  captionsEnabled: {
    get: getCaptionsEnabled,
    set: setCaptionsEnabled
  },
  ignoreStoredCaptionVisibleSetting: {
    get: getIgnoreStoredCaptionVisibleSetting,
    set: setIgnoreStoredCaptionVisibleSetting
  },
  sidebarEnabled: {
    get: getSidebarEnabled,
    set: setSidebarEnabled
  },
  sidebarLocation: {
    get: getSidebarLocation,
    set: setSidebarLocation
  },
  backgroundColor: {
    get: getBackgroundColor,
    set: setBackgroundColor
  },
  autoHideControls: {
    get: getAutoHideControls,
    set: setAutoHideControls
  },
  processUnicodeNames: {
    get: getProcessUnicodeNames,
    set: setProcessUnicodeNames
  },
  enforceLinearAssessment: {
    get: getEnforceLinearAssessment,
    set: setEnforceLinearAssessment
  },
  disableFullframeMode: {
    get: getDisableFullframeMode,
    set: setDisableFullframeMode
  },
  disableControls: {
    get: getDisableControls,
    set: setDisableControls
  },
  disableYouTubeControls: {
    get: getDisableYouTubeControls,
    set: setDisableYouTubeControls
  },
  disablePictureInPicture: {
    get: getDisablePictureInPicture,
    set: setDisablePictureInPicture
  },
  disableContinueWithoutQuestions: {
    get: getDisableContinueWithoutQuestions,
    set: setDisableContinueWithoutQuestions
  },
  mobileWebViewCanAutoPlay: {
    get: getMobileWebViewCanAutoPlay,
    set: setMobileWebViewCanAutoPlay
  },
  googleAnalyticsID: {
    get: getGoogleAnalyticsID,
    set: setGoogleAnalyticsID
  },
  googleAnalyticsPageViewTracking: {
    get: getGAPageViewTracking,
    set: setGAPageViewTracking
  },
  googleAnalyticsEventTracking: {
    get: getGAEventTracking,
    set: setGAEventTracking
  },
  altEventCategoryAsFilename: {
    get: getAltEventCategoryAsFilename,
    set: setAltEventCategoryAsFilename
  },
  altLoadTimeAsSeconds: {
    get: getAltLoadTimeAsSeconds,
    set: setAltLoadTimeAsSeconds
  },
  jumpToTime: {
    get: getJumpToTime,
    set: setJumpToTime
  },
  embedIFrameId: {
    get: getEmbedIFrameId,
    set: setEmbedIFrameId
  },
  useSlimAppSplashScreen: {
    get: getUseSlimAppSplashScreen,
    set: setUseSlimAppSplashScreen
  },
  disableContextMenuForVideo: {
    get: setDisableContextMenuForVideo,
    set: setDisableContextMenuForVideo
  },
  showYouTubeAnnotations: {
    get: getShowYouTubeAnnotations,
    set: setShowYouTubeAnnotations
  },
  preRollSrc: {
    get: getPreRollSrc,
    set: setPreRollSrc
  },
  contentBase: {
    get: getContentBase,
    set: setContentBase
  },
  contentType: {
    get: getContentType,
    set: setContentType
  },
  preload: {
    get: getPreload,
    set: setPreload
  },
  fullViewPort: {
    get: getFullViewPort,
    set: setFullViewPort
  },
  webConnector: {
    get: getWebConnector,
    set: setWebConnector
  },
  theme: {
    get: getTheme,
    set: setTheme$2
  },
  enableSingleClickControl: {
    get: getEnableSingleClickControl,
    set: setEnableSingleClickControl
  },
  enableDoubleClickControl: {
    get: getEnableDoubleClickControl,
    set: setEnableDoubleClickControl
  },
  pluginController: {
    get: getPluginController,
    set: setPluginController
  },
  useLargerProgressBar: {
    get: getUseLargerProgressBar,
    set: setUseLargerProgressBar
  },
  isScormLesson: {
    get: getIsScormLesson,
    set: setIsScormLesson
  },
  displayHotspotsShape: {
    get: getDisplayHotspotsShape,
    set: setDisplayHotspotsShape
  },
  audioDescriptionMediaSrc: {
    get: getAudioDescriptionMediaSrc,
    set: setAudioDescriptionMediaSrc
  },
  captionSrcList: {
    get: getCaptionSrcList
  },
  skipVideoControlsEnabled: {
    get: getSkipVideoControlsEnabled,
    set: setSkipVideoControlsEnabled
  },
  skipVideoDuration: {
    get: getSkipVideoDuration,
    set: setSkipVideoDuration
  },
  allowFastForward: {
    get: getAllowFastForward,
    set: setAllowFastForward
  },
  showADACompliantCaptions: {
    get: getShowADACompliantCaptions,
    set: setShowADACompliantCaptions
  },
  logScormApiCalls: {
    get: getLogScormApiCalls,
    set: setLogScormApiCalls
  },
  videoThumbnailsSrc: {
    get: getVideoThumbnailSrc,
    set: setVideoThumbnailSrc
  },
  videoThumbnailWidth: {
    get: getVideoThumbnailWidth,
    set: setVideoThumbnailWidth
  },
  videoThumbnailHeight: {
    get: getVideoThumbnailHeight,
    set: setVideoThumbnailHeight
  },
  videoThumbnailInterval: {
    get: getVideoThumbnailInterval,
    set: setVideoThumbnailInterval
  },
  videoThumbnailColumns: {
    get: getVideoThumbnailColumns,
    set: setVideoThumbnailColumns
  },
  tocModelFromDescription: {
    get: getTocModelFromDescription,
    set: setTocModelFromDescription
  },
  completeScormOnRequirementsComplete: {
    get: getCompleteScormOnRequirementsComplete,
    set: setCompleteScormOnRequirementsComplete
  },
  customFullScreenDomElement: {
    get: getCustomFullScreenDomElement,
    set: setCustomFullScreenDomElement
  },
  enableTheaterMode: {
    get: getEnableTheaterMode,
    set: setEnableTheaterMode
  },
  ga4EventCallback: {
    get: getGA4EventCallback,
    set: setGA4EventCallback
  },
  showAcknowledgementLink: {
    get: getShowAcknowledgementLink,
    set: setShowAcknowledgementLink
  }
});

/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(function (value) {
    // @ts-ignore
    return constructor.resolve(callback()).then(function () {
      return value;
    });
  }, function (reason) {
    // @ts-ignore
    return constructor.resolve(callback()).then(function () {
      // @ts-ignore
      return constructor.reject(reason);
    });
  });
}

function allSettled(arr) {
  var P = this;
  return new P(function (resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(new TypeError(_typeof$1(arr) + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (_typeof$1(val) === 'object' || typeof val === 'function')) {
        var then = val.then;
        if (typeof then === 'function') {
          then.call(val, function (val) {
            res(i, val);
          }, function (e) {
            args[i] = {
              status: 'rejected',
              reason: e
            };
            if (--remaining === 0) {
              resolve(args);
            }
          });
          return;
        }
      }
      args[i] = {
        status: 'fulfilled',
        value: val
      };
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
}

/**
 * @constructor
 */
function AggregateError(errors, message) {
  this.name = 'AggregateError', this.errors = errors;
  this.message = message || '';
}
AggregateError.prototype = Error.prototype;
function any(arr) {
  var P = this;
  return new P(function (resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(new TypeError('Promise.any accepts an array'));
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return reject();
    var rejectionReasons = [];
    for (var i = 0; i < args.length; i++) {
      try {
        P.resolve(args[i]).then(resolve)["catch"](function (error) {
          rejectionReasons.push(error);
          if (rejectionReasons.length === args.length) {
            reject(new AggregateError(rejectionReasons, 'All promises were rejected'));
          }
        });
      } catch (ex) {
        reject(ex);
      }
    }
  });
}

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;
function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}
function noop$1() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function () {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise$1(fn) {
  if (!(this instanceof Promise$1)) throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];
  doResolve(fn, this);
}
function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise$1._immediateFn(function () {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}
function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
    if (newValue && (_typeof$1(newValue) === 'object' || typeof newValue === 'function')) {
      var then = newValue.then;
      if (newValue instanceof Promise$1) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}
function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}
function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise$1._immediateFn(function () {
      if (!self._handled) {
        Promise$1._unhandledRejectionFn(self._value);
      }
    });
  }
  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(function (value) {
      if (done) return;
      done = true;
      resolve(self, value);
    }, function (reason) {
      if (done) return;
      done = true;
      reject(self, reason);
    });
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}
Promise$1.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise$1.prototype.then = function (onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop$1);
  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};
Promise$1.prototype['finally'] = finallyConstructor;
Promise$1.all = function (arr) {
  return new Promise$1(function (resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      try {
        if (val && (_typeof$1(val) === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(val, function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};
Promise$1.any = any;
Promise$1.allSettled = allSettled;
Promise$1.resolve = function (value) {
  if (value && _typeof$1(value) === 'object' && value.constructor === Promise$1) {
    return value;
  }
  return new Promise$1(function (resolve) {
    resolve(value);
  });
};
Promise$1.reject = function (value) {
  return new Promise$1(function (resolve, reject) {
    reject(value);
  });
};
Promise$1.race = function (arr) {
  return new Promise$1(function (resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }
    for (var i = 0, len = arr.length; i < len; i++) {
      Promise$1.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise$1._immediateFn =
// @ts-ignore
typeof setImmediate === 'function' && function (fn) {
  // @ts-ignore
  setImmediate(fn);
} || function (fn) {
  setTimeoutFunc(fn, 0);
};
Promise$1._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

var MEASURE_NOT_FOUND_VALUE = -1;
var _performanceApiSupported = window.performance && window.performance.mark && window.performance.measure && window.performance.getEntriesByType;
var getMeasureDuration = function getMeasureDuration(measureName) {
  if (!_performanceApiSupported) {
    return MEASURE_NOT_FOUND_VALUE;
  }
  try {
    var measureDuration = MEASURE_NOT_FOUND_VALUE;
    var measures = window.performance.getEntriesByType('measure');
    for (var i = 0; i < measures.length; i++) {
      if (measures[i].name === measureName) {
        measureDuration = measures[i].duration;
      }
    }
    return Math.round(measureDuration);
  } catch (e) {
    return MEASURE_NOT_FOUND_VALUE;
  }
};
var createMarker = function createMarker(markerName) {
  if (!_performanceApiSupported) {
    return;
  }
  try {
    window.performance.mark(markerName);
  } catch (e) {
    // ignore the error
  }
};
var createMeasure = function createMeasure(measureName, startMark, endMark) {
  if (!_performanceApiSupported) {
    return;
  }
  try {
    // IE11 and Edge throw a syntax error if undefined is passed in to performance.measure
    if (endMark) {
      window.performance.measure(measureName, startMark, endMark);
    } else {
      window.performance.measure(measureName, startMark);
    }
  } catch (e) {
    // ignore the error
  }
};
var getRumEventData = function getRumEventData(measureNames) {
  if (!_performanceApiSupported) {
    return [];
  }
  var rumData = [];
  measureNames.forEach(function (measureName) {
    var measureDuration = getMeasureDuration(measureName);
    if (measureDuration !== MEASURE_NOT_FOUND_VALUE) {
      rumData.push({
        name: measureName,
        time: measureDuration
      });
    }
  });
  return rumData;
};
var performanceWrapper = {
  createMarker: createMarker,
  createMeasure: createMeasure,
  getRumEventData: getRumEventData
};

var registeredEvents = {};
var listeningToWindowMessageEvent = false;
var onExternalMessage = function onExternalMessage(e) {
  // filter out non smart player events
  if (!e.data || typeof e.data.indexOf !== 'function' || e.data.indexOf('smartPlayerEventName') === -1) {
    return;
  }
  var message = window.JSON.parse(e.data);
  if (registeredEvents[message.smartPlayerEventName]) {
    registeredEvents[message.smartPlayerEventName].call(this, message.data);
  }
};
var addWindowMessageListener = function addWindowMessageListener() {
  if (listeningToWindowMessageEvent) {
    return;
  }
  if (window.addEventListener) {
    window.addEventListener('message', onExternalMessage, false);
  } else {
    window.attachEvent('onmessage', onExternalMessage);
  }
  listeningToWindowMessageEvent = true;
};
var removeWindowMessageListener = function removeWindowMessageListener() {
  if (!listeningToWindowMessageEvent) {
    return;
  }
  if (window.removeEventListener) {
    window.removeEventListener('message', onExternalMessage, false);
  } else {
    window.removeEvent('onmessage', onExternalMessage);
  }
  listeningToWindowMessageEvent = false;
};
var externalMessageController = {
  addCallback: function addCallback(eventName, callbackFunction) {
    addWindowMessageListener();
    registeredEvents[eventName] = callbackFunction;
  },
  removeCallback: function removeCallback(eventName) {
    if (registeredEvents[eventName]) {
      delete registeredEvents[eventName];
    }
    if (Object.keys(registeredEvents).length === 0) {
      removeWindowMessageListener();
    }
  },
  removeAllCallbacks: function removeAllCallbacks() {
    registeredEvents = {};
    removeWindowMessageListener();
  }
};

var postMessage = function postMessage(eventName, domain, data) {
  var message = {};
  message.smartPlayerEventName = eventName;
  if (playerConfiguration.getEmbedIFrameId()) {
    message.iFrameId = playerConfiguration.getEmbedIFrameId();
  }
  if (data) {
    message.data = data;
  }
  window.top.postMessage(window.JSON.stringify(message), domain);
};
var isInIframe = function isInIframe() {
  return window !== window.top;
};
var iFrameBridge = {
  postMessage: postMessage,
  isInIframe: isInIframe
};

var parsePlayerURLParams = function parsePlayerURLParams(queryString) {
  var playerUrlParams = queryString.slice(queryString.indexOf('?') + 1).split('&');
  if (playerUrlParams && playerUrlParams.length > 0) {
    playerConfiguration.saveConfigurationFromQueryString(playerUrlParams);
  }
};
var requestEmbeddedURLParams = function requestEmbeddedURLParams() {
  externalMessageController.addCallback('PARENT-URL-PARAMS', parseEmbeddedURLParams);
  iFrameBridge.postMessage('GET-EMBEDDED-URL-VARS', '*');
};
var parseEmbeddedURLParams = function parseEmbeddedURLParams(data) {
  externalMessageController.removeCallback('PARENT-URL-PARAMS');
  parsePlayerURLParams(data);
};
var queryParamsStripper = {
  strip: function strip() {
    parsePlayerURLParams(windowWrapper.getLocationHref());
    if (iFrameBridge.isInIframe()) {
      requestEmbeddedURLParams();
    }
  }
};

var mediaType = Object.freeze({
  WEBM: 'webm',
  MP4: 'mp4',
  OGG: 'ogg',
  YOUTUBE: 'youtube',
  JPG: 'jpg',
  PNG: 'png',
  GIF: 'gif',
  PLAYLIST: 'playlist',
  UNKNOWN: 'unknown',
  NOT_AVAILABLE: 'not available',
  MULTIPLE_TYPES: 'multiple types'
});

var Media = function Media(media, type, mimeType, uri) {
  var _media = media;
  var _type = type;
  var _mimeType = mimeType;
  var _uri = uri;
  return Object.defineProperties({}, {
    media: {
      get: function get() {
        return _media;
      }
    },
    type: {
      get: function get() {
        return _type;
      }
    },
    mimeType: {
      get: function get() {
        return _mimeType;
      }
    },
    uri: {
      get: function get() {
        return _uri;
      }
    }
  });
};
var Media$1 = {
  create: Media
};

var PLAYLIST_EXT = 'm3u';
var getFileExtension = function getFileExtension(fileName) {
  return fileName.split('#')[0].split('?')[0].split('.').pop().toLowerCase();
};
var findMediaMimeTypeByRequestHeader = function findMediaMimeTypeByRequestHeader(mediaSource) {
  return new Promise$1(function (resolve) {
    $.ajax({
      type: 'HEAD',
      url: mediaSource
    }).done(function (data, textStatus, jqXHR) {
      var contentType = jqXHR.getResponseHeader('content-type') || mediaMimeType.UNKNOWN;
      resolve(contentType);
    }).fail(function () {
      resolve(mediaMimeType.UNKNOWN);
    });
  });
};
var inferMimeTypeFromFileExtension = function inferMimeTypeFromFileExtension(ext) {
  switch (ext) {
    case PLAYLIST_EXT:
      return mediaMimeType.M3U;
    case 'mp4':
    case 'm4v':
    case 'mov':
      return mediaMimeType.MP4;
    case 'webm':
      return mediaMimeType.WEBM;
    case 'ogv':
      return mediaMimeType.OGV;
    case 'jpg':
    case 'jpeg':
      return mediaMimeType.JPEG;
    case 'png':
      return mediaMimeType.PNG;
    case 'gif':
      return mediaMimeType.GIF;
    default:
      return mediaMimeType.UNKNOWN;
  }
};
var mediaTypeFromMimeType = function mediaTypeFromMimeType(mimeType) {
  switch (mimeType) {
    case mediaMimeType.M3U:
      return mediaType.PLAYLIST;
    case mediaMimeType.MP4:
      return mediaType.MP4;
    case mediaMimeType.WEBM:
      return mediaType.WEBM;
    case mediaMimeType.OGV:
      return mediaType.OGG;
    case mediaMimeType.PNG:
      return mediaType.PNG;
    case mediaMimeType.GIF:
      return mediaType.GIF;
    case mediaMimeType.JPEG:
      return mediaType.JPG;
    default:
      return mediaType.UNKNOWN;
  }
};
var loadPlaylistFile = function loadPlaylistFile(playlistSrc) {
  return $.ajax({
    type: 'GET',
    url: playlistSrc,
    isLocal: true,
    dataType: 'text'
  });
};

/**
 * @memberof TSC
 * @class MediaListParser
 * @classdesc Parse media sources.
 * @param {Array} mediaSources - List of media source strings or objects.
 * @return new MediaListParser instance
 */
var MediaListParser = function MediaListParser(mediaSources) {
  var _mediaList = [];
  var _ready = null;
  var _mediaProcessedPromises = [];
  var parseM3UData = function parseM3UData(playlistData) {
    return new Promise$1(function (resolve, reject) {
      var playListMediaPromises = [];
      var playListMedia = [];
      var playlistMediaUrls = playlistData.split(/\r?\n/g).filter(function (value) {
        return value !== '';
      });
      playlistMediaUrls.forEach(function (mediaSrc, index) {
        playListMediaPromises.push(parseMediaUrl(mediaSrc, playListMedia, index));
      });
      Promise$1.all(playListMediaPromises).then(function () {
        resolve(playListMedia);
      })["catch"](function () {
        reject('Failed to create media objects for the playlist sources.');
      });
    });
  };
  var parseYouTubeMedia = function parseYouTubeMedia(youTubeMediaSource, index) {
    var media = Media$1.create(youTubeMediaSource, mediaType.YOUTUBE, mediaMimeType.UNKNOWN, youTubeMediaSource);
    _mediaList[index] = media;
    return Promise$1.resolve(media);
  };
  var parsePlaylistSource = function parsePlaylistSource(playlistMediaSource, index) {
    return new Promise$1(function (resolve, reject) {
      var jHxr = loadPlaylistFile(playlistMediaSource);
      jHxr.done(function (data) {
        parseM3UData(data).then(function (playlistMedia) {
          var media = Media$1.create(playlistMedia, mediaType.PLAYLIST, mediaMimeType.M3U, playlistMediaSource);
          _mediaList[index] = media;
          resolve(media);
        })["catch"](function () {
          reject();
        });
      });
      jHxr.fail(function () {
        reject('Failed to load the supplied playlist (' + playlistMediaSource + ')');
      });
    });
  };
  var parseMediaUrl = function parseMediaUrl(mediaSource, mediaList, index) {
    return new Promise$1(function (resolve, reject) {
      var media = null;
      if (playerConfiguration.getContentType()) {
        media = Media$1.create(mediaSource, mediaTypeFromMimeType(playerConfiguration.getContentType()), playerConfiguration.getContentType(), mediaSource);
        mediaList[index] = media;
        resolve(media);
      } else {
        var inferredMimeType = inferMimeTypeFromFileExtension(getFileExtension(mediaSource));
        if (inferredMimeType === mediaMimeType.UNKNOWN) {
          findMediaMimeTypeByRequestHeader(mediaSource).then(function (mimeType) {
            if (mimeType !== mediaMimeType.UNKNOWN) {
              media = Media$1.create(mediaSource, mediaTypeFromMimeType(mimeType), mimeType, mediaSource);
              mediaList[index] = media;
              resolve(media);
            } else {
              reject('Could not determine the content type of media (' + mediaSource + ')');
            }
          });
        } else {
          media = Media$1.create(mediaSource, mediaTypeFromMimeType(inferredMimeType), inferredMimeType, mediaSource);
          mediaList[index] = media;
          resolve(media);
        }
      }
    });
  };
  var parseMedia = function parseMedia(mediaSource, index) {
    var youtubeRegex = /youtu(?:\.be|be\.com)\//;
    if (youtubeRegex.test(mediaSource)) {
      return parseYouTubeMedia(mediaSource, index);
    }
    if (getFileExtension(mediaSource) === PLAYLIST_EXT) {
      return parsePlaylistSource(mediaSource, index);
    }
    return parseMediaUrl(mediaSource, _mediaList, index);
  };
  mediaSources.forEach(function (source, index) {
    _mediaProcessedPromises.push(parseMedia(source, index));
  });
  _ready = Promise$1.all(_mediaProcessedPromises);
  return Object.defineProperties({}, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaListParser
     *  @property {Array} ready - List of Media objects.
     */
    mediaList: {
      get: function get() {
        return [].concat(_mediaList);
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaListParser
     *  @property {Promise} ready - Promise that resolves when media sources has been parsed.
     */
    ready: {
      get: function get() {
        return _ready;
      }
    }
  });
};
var MediaListParser$1 = {
  /**
   *  Factory method that returns a new MediaListParser object.
   *  @function create
   *  @memberof TSC.MediaListParser
   *  @static
   *  @param {Array} mediaSources - List of media source strings or objects.
   *  @return new MediaListParser instance
   */
  create: MediaListParser
};

/**
 * @memberof TSC
 * @class MediaList
 * @classdesc List of media
 * @param {Array} mediaSources - List of media source strings or objects.
 * @return new MediaList instance
 */
var MediaList = function MediaList(mediaSources) {
  var _readyPromiseResolve;
  var _readyPromiseReject;
  var _readyPromise = new Promise$1(function (resolve, reject) {
    _readyPromiseResolve = resolve;
    _readyPromiseReject = reject;
  });
  var _mediaListParser;
  var _currentMediaIndex = 0;
  var _mediaList;
  _mediaListParser = MediaListParser$1.create(mediaSources);
  _mediaListParser.ready.then(function () {
    _mediaList = _mediaListParser.mediaList[0].type === mediaType.PLAYLIST ? _mediaListParser.mediaList[0].media : _mediaListParser.mediaList;
    _readyPromiseResolve();
  })["catch"](function () {
    _readyPromiseReject();
  });
  var getMediaIndexByUri = function getMediaIndexByUri(uri) {
    var mediaIndex = -1;
    _mediaList.some(function (media, index) {
      if (media.uri === uri) {
        mediaIndex = index;
      }
      return media.uri === uri;
    });
    return mediaIndex;
  };
  var isMediaTypeAvailable = function isMediaTypeAvailable(type) {
    return _mediaList.some(function (media) {
      return type === media.type;
    });
  };
  var setCurrentMediaIndex = function setCurrentMediaIndex(mediaPosition) {
    if (typeof mediaPosition === 'string') {
      if (mediaPosition === 'next') {
        if (_currentMediaIndex < _mediaList.length - 1) {
          _currentMediaIndex++;
        }
      } else if (mediaPosition === 'previous') {
        if (_currentMediaIndex > 0) {
          _currentMediaIndex--;
        }
      }
    } else if (typeof mediaPosition === 'number') {
      if (mediaPosition >= 0 && mediaPosition < _mediaList.length) {
        _currentMediaIndex = mediaPosition;
      }
    }
    return _currentMediaIndex;
  };
  return Object.defineProperties({
    /**
     *  Get the index of an uri in the media list.
     *  @function getMediaIndexByUri
     *  @memberof TSC.MediaList
     *  @param {String} uri - uri to search for.
     *  @return {Number} index of uri or -1 if not found.
     */
    getMediaIndexByUri: getMediaIndexByUri,
    /**
     *  Checks media list for supplied type and return true if found.
     *  @function isMediaTypeAvailable
     *  @memberof TSC.MediaList
     *  @param {String} type - media type.
     *  @return {Boolean} Is the type available.
     */
    isMediaTypeAvailable: isMediaTypeAvailable
  }, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {Promise} ready - Promise that resolves when media list has been parsed.
     */
    ready: {
      get: function get() {
        return _readyPromise;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {TSC.Media} currentMedia - Current Media object.
     */
    currentMedia: {
      get: function get() {
        return _mediaList[_currentMediaIndex];
      }
    },
    /**
     *  @public
     *  @memberof TSC.MediaList
     *  @property {Number} currentMediaIndex - Current index  in the media list.
     */
    currentMediaIndex: {
      get: function get() {
        return _currentMediaIndex;
      },
      set: setCurrentMediaIndex
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {Array} mediaList - List of media objects.
     */
    mediaList: {
      get: function get() {
        return _mediaList;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {String} currentMediaType - Current media object type.
     */
    currentMediaType: {
      get: function get() {
        return _mediaList[_currentMediaIndex].type;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {Boolean} onFirstMedia - Is the current index pointing to the first media element in the list.
     */
    onFirstMedia: {
      get: function get() {
        return _currentMediaIndex === 0;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {Boolean} onFirstMedia - Is the current index pointing to the last media element in the list.
     */
    onLastMedia: {
      get: function get() {
        return _currentMediaIndex + 1 === _mediaList.length;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {Boolean} hasImage - Is there an image in the media list.
     */
    hasImage: {
      get: function get() {
        return _mediaList[0].type === mediaType.JPG || _mediaList[0].type === mediaType.GIF || _mediaList[0].type === mediaType.PNG;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaList
     *  @property {Boolean} isPlaylist - Is the first media element a playlist.
     */
    isPlaylist: {
      get: function get() {
        return _mediaListParser.mediaList[0].type === mediaType.PLAYLIST;
      }
    }
  });
};
var MediaList$1 = {
  /**
   *  Factory method that returns a new MediaList object.
   *  @function create
   *  @memberof TSC.MediaList
   *  @static
   *  @param {Array} mediaSources - List of media source strings or objects.
   *  @return new MediaList instance
   */
  create: MediaList
};

var playerType = Object.freeze({
  HTML5_VIDEO: 'html5',
  YOUTUBE: 'youtube',
  IMAGE: 'image',
  NOT_SUPPORTED: 'not_supported'
});

var _currentPlayerType$1;
var MIN_IE_VERSION = 9;
var _getPlayerType = function getPlayerType(mediaList) {
  var haveImage = mediaList.hasImage;
  var haveWebMAndCanPlay = mediaList.isMediaTypeAvailable(mediaType.WEBM) && deviceInfo.canPlayWebM();
  var haveMP4AndCanPlay = mediaList.isMediaTypeAvailable(mediaType.MP4) && deviceInfo.canPlayMP4();
  var haveOGGAndCanPlay = mediaList.isMediaTypeAvailable(mediaType.OGG) && deviceInfo.canPlayOgg();
  var haveYoutubeEmbedUrl = mediaList.isMediaTypeAvailable(mediaType.YOUTUBE);
  if (deviceInfo.isIE() && deviceInfo.getIEVersion() !== null && deviceInfo.getIEVersion() <= MIN_IE_VERSION) {
    return playerType.NOT_SUPPORTED;
  }
  if (haveYoutubeEmbedUrl) {
    return playerType.YOUTUBE;
  }
  if (haveWebMAndCanPlay || haveMP4AndCanPlay || haveOGGAndCanPlay) {
    return playerType.HTML5_VIDEO;
  }
  if (haveImage) {
    return playerType.IMAGE;
  }
  return playerType.NOT_SUPPORTED;
};
var mediaPlayerController = {
  getPlayerType: function getPlayerType(mediaList) {
    return _currentPlayerType$1 || (_currentPlayerType$1 = _getPlayerType(mediaList));
  },
  clearPlayerType: function clearPlayerType() {
    _currentPlayerType$1 = undefined;
  }
};

var _smartPlayerNamespace = 'tsc-smartplayer';
var _videoWrapper = 'video-wrapper';
var _scormModule = 'scorm-module';
var _scormModuleNavigationContainer = 'scorm-module-navigation-container';
var _playerControlsVisible = 'player-controls-visible';
var _largerProgressBar = 'larger-progress-bar';
var _disabled = 'disabled-button';
var _hide = 'hide';
var _hideElement = 'hide-element';
var _volumeSliderHidden = 'volume-slider-hidden';
var _hideSecondaryControls = 'hide-secondary-controls';
var _fullscreenMode = 'fullscreen-mode';
var _volumeMutedButtonGlyph = 'volume-muted-button-glyph';
var _volumeLowButtonGlyph = 'volume-low-button-glyph';
var _volumeMediumButtonGlyph = 'volume-medium-button-glyph';
var _volumeHighButtonGlyph = 'volume-high-button-glyph';
var _playButtonGlyph = 'play-button-glyph';
var _pauseButtonGlyph = 'pause-button-glyph';
var _fullscreenButtonGlyph = 'fullscreen-button-glyph';
var _fullscreenButtonActiveGlyph = 'fullscreen-button-active-glyph';
var _fullFrameButtonGlyph = 'full-frame-button-glyph';
var _fullFrameButtonActiveGlyph = 'full-frame-button-active-glyph';
var _theaterModeButtonGlyph = 'theater-mode-button-glyph';
var _theaterModeButtonActiveGlyph = 'theater-mode-button-active-glyph';
var _expandButtonActiveGlyph = 'expand-button-glyph';
var _audioDescriptionButtonGlyph = 'audio-description-button-glyph';
var _audioDescriptionButtonActiveGlyph = 'audio-description-button-active-glyph';
var _closedCaptionButtonGlyph = 'closed-caption-glyph';
var _closedCaptionNonEnglishButtonGlyph = 'closed-caption-non-en-glyph';
var _closedCaptionButtonActiveGlyph = 'closed-caption-active-glyph';
var _closedCaptionNonEnglishButtonActiveGlyph = 'closed-caption-non-en-active-glyph';
var _tocButtonGlyph = 'toc-button-glyph';
var _tocButtonActiveGlyph = 'toc-button-active-glyph';
var _settingsButtonGlyph = 'settings-button-glyph';
var _settingsButtonActiveGlyph = 'settings-button-active-glyph';
var _tertiaryButton = 'tertiary-button';
var _tertiaryButtonActive = 'tertiary-button-active';
var _generatedPluginContainer = 'generated-plugin-container';
var _pluginNamedContainerPrefix = 'plugin-';
var _hotspotVisible = 'hotspot-visible';
var _screenReaderAlert = 'alert-only';
var _imageViewAnimateTransitions = 'animate-transitions';
var _safariPipIssueFix = 'patch-safari-pip-issue';
var _captionsUnderVideo = 'caption_under_video';
var _captionsVerticalAlignTop = 'captionVAlignTop';
var _captionsVerticalAlignBottom = 'captionVAlignBottom';
var _captionsHorizontalAlignLeft = 'captionHAlignLeft';
var _captionsHorizontalAlignCenter = 'captionHAlignCenter';
var _captionsHorizontalAlignRight = 'captionHAlignRight';
var _captionsCustomPosition = 'custom-caption-position';
var _captionsCaptionSelected = 'caption-selected';
var _captionsPreventCaptionDrag = 'prevent-caption-drag';
var _captionXmpView = 'xmp-caption';
var _captionAdaView = 'ada-caption';
var _progressBarTrackPreventSeeking = 'prevent-seeking';
var _hideBubbleArrow = 'hide-bubble-arrow';
var _hiddenVideoThumbnailVisible = 'hidden-video-thumbnail-visible';
var _scrubPreviewHasThumbnail = 'has-thumbnail';
var _focusableAnswerInput = 'focusable-answer-input';
var _constrainMediaHeight = 'constrain-media-height';
var _constrainMediaWidth = 'constrain-media-width';
var _mediaTypeYouTube = 'media-type-youtube';
var cssClasses = Object.defineProperties({}, {
  smartPlayerNamespace: {
    value: _smartPlayerNamespace
  },
  videoWrapper: {
    value: _videoWrapper
  },
  scormModule: {
    value: _scormModule
  },
  scormModuleNavigationContainer: {
    value: _scormModuleNavigationContainer
  },
  playerControlsVisible: {
    value: _playerControlsVisible
  },
  largerProgressBar: {
    value: _largerProgressBar
  },
  hide: {
    value: _hide
  },
  hideElement: {
    value: _hideElement
  },
  volumeSliderHidden: {
    value: _volumeSliderHidden
  },
  hideSecondaryControls: {
    value: _hideSecondaryControls
  },
  disabled: {
    value: _disabled
  },
  fullscreenMode: {
    value: _fullscreenMode
  },
  volumeMutedButtonGlyph: {
    value: _volumeMutedButtonGlyph
  },
  volumeLowButtonGlyph: {
    value: _volumeLowButtonGlyph
  },
  volumeMediumButtonGlyph: {
    value: _volumeMediumButtonGlyph
  },
  volumeHighButtonGlyph: {
    value: _volumeHighButtonGlyph
  },
  playButtonGlyph: {
    value: _playButtonGlyph
  },
  pauseButtonGlyph: {
    value: _pauseButtonGlyph
  },
  fullscreenButtonGlyph: {
    value: _fullscreenButtonGlyph
  },
  fullscreenButtonActiveGlyph: {
    value: _fullscreenButtonActiveGlyph
  },
  fullFrameButtonGlyph: {
    value: _fullFrameButtonGlyph
  },
  fullFrameButtonActiveGlyph: {
    value: _fullFrameButtonActiveGlyph
  },
  expandButtonGlyph: {
    value: _expandButtonActiveGlyph
  },
  audioDescriptionButtonGlyph: {
    value: _audioDescriptionButtonGlyph
  },
  audioDescriptionButtonActiveGlyph: {
    value: _audioDescriptionButtonActiveGlyph
  },
  closedCaptionButtonGlyph: {
    value: _closedCaptionButtonGlyph
  },
  closedCaptionNonEnglishButtonGlyph: {
    value: _closedCaptionNonEnglishButtonGlyph
  },
  closedCaptionButtonActiveGlyph: {
    value: _closedCaptionButtonActiveGlyph
  },
  closedCaptionNonEnglishButtonActiveGlyph: {
    value: _closedCaptionNonEnglishButtonActiveGlyph
  },
  tocButtonGlyph: {
    value: _tocButtonGlyph
  },
  tocButtonActiveGlyph: {
    value: _tocButtonActiveGlyph
  },
  settingsButtonGlyph: {
    value: _settingsButtonGlyph
  },
  settingsButtonActiveGlyph: {
    value: _settingsButtonActiveGlyph
  },
  tertiaryButton: {
    value: _tertiaryButton
  },
  tertiaryButtonActive: {
    value: _tertiaryButtonActive
  },
  generatedPluginContainer: {
    value: _generatedPluginContainer
  },
  pluginNamedContainerPrefix: {
    value: _pluginNamedContainerPrefix
  },
  hotspotVisible: {
    value: _hotspotVisible
  },
  screenReaderAlert: {
    value: _screenReaderAlert
  },
  imageViewAnimateTransitions: {
    value: _imageViewAnimateTransitions
  },
  safariPipIssueFix: {
    value: _safariPipIssueFix
  },
  captionsUnderVideo: {
    value: _captionsUnderVideo
  },
  captionsVerticalAlignTop: {
    value: _captionsVerticalAlignTop
  },
  captionsVerticalAlignBottom: {
    value: _captionsVerticalAlignBottom
  },
  captionsHorizontalAlignLeft: {
    value: _captionsHorizontalAlignLeft
  },
  captionsHorizontalAlignCenter: {
    value: _captionsHorizontalAlignCenter
  },
  captionsHorizontalAlignRight: {
    value: _captionsHorizontalAlignRight
  },
  captionsCustomPosition: {
    value: _captionsCustomPosition
  },
  captionsCaptionSelected: {
    value: _captionsCaptionSelected
  },
  captionsPreventCaptionDrag: {
    value: _captionsPreventCaptionDrag
  },
  captionXmpView: {
    value: _captionXmpView
  },
  captionAdaView: {
    value: _captionAdaView
  },
  progressBarTrackPreventSeeking: {
    value: _progressBarTrackPreventSeeking
  },
  hideBubbleArrow: {
    value: _hideBubbleArrow
  },
  hiddenVideoThumbnailVisible: {
    value: _hiddenVideoThumbnailVisible
  },
  scrubPreviewHasThumbnail: {
    value: _scrubPreviewHasThumbnail
  },
  focusableAnswerInput: {
    value: _focusableAnswerInput
  },
  constrainMediaHeight: {
    value: _constrainMediaHeight
  },
  constrainMediaWidth: {
    value: _constrainMediaWidth
  },
  mediaTypeYouTube: {
    value: _mediaTypeYouTube
  },
  theaterModeButtonGlyph: {
    value: _theaterModeButtonGlyph
  },
  theaterModeButtonActiveGlyph: {
    value: _theaterModeButtonActiveGlyph
  }
});

var cssVariables = Object.defineProperties({}, {
  playerWidth: {
    value: '--player-width'
  },
  playerHeight: {
    value: '--player-height'
  },
  mediaIntrinsicWidth: {
    value: '--media-intrinsic-width'
  },
  mediaIntrinsicHeight: {
    value: '--media-intrinsic-height'
  },
  mediaIntrinsicAspectRatio: {
    value: '--media-intrinsic-aspect-ratio'
  },
  mediaIntrinsicAspectRatioNumber: {
    value: '--media-intrinsic-aspect-ratio-number'
  },
  mediaViewPortWidth: {
    value: '--media-viewport-width'
  },
  mediaViewPortHeight: {
    value: '--media-viewport-height'
  },
  mediaViewPortAspectRatio: {
    value: '--media-viewport-aspect-ratio'
  },
  mediaViewPortAspectRatioNumber: {
    value: '--media-viewport-aspect-ratio-number'
  },
  reservedSizeScorm: {
    value: '--reserved-size-scorm-controls'
  },
  reservedSizeCaptions: {
    value: '--reserved-size-captions'
  },
  reservedSizeControls: {
    value: '--reserved-size-controls'
  },
  tocTopOffset: {
    value: '--toc-top-offset'
  }
});

/**
 * @memberof TSC
 * @class responsiveController
 * @classdesc Control responsive classes and css variables on player container and media container
 * @param {jQuery} $rootContainer - Smart Player main container jquery element
 *
 */
var ResponsiveController = function ResponsiveController($rootContainer) {
  var _$rootContainer = $rootContainer;
  var _$mediaViewPortContainer = null;
  var _$mediaSizingContainer = null;
  var _currentViewPortWidth = 0;
  var _currentViewPortHeight = 0;
  var _currentViewPortAspectRatio = 1.0;
  var _intrinsicWidth = 0;
  var _intrinsicHeight = 0;
  var _intrinsicAspectRatio = 1.0;
  var _rootContainerResizeObserver = null;
  var _viewPortContainerResizeObserver = null;
  var _initialCheck = true;
  var isApproximatelySameSize = function isApproximatelySameSize(newDimensionDouble, existingCssVarName) {
    // not pretty, but... at least chrome will trigger size change on partial pixel calculation changes, even if it lands in the same pixel, due to
    // compounding javascript rounding errors that happen in continued calculations of aspect-ratio, this can cause a subtle, slow run-away down/up-sizing
    // so, we compare the existing value from CSS var, parseInt to clip off the 'px' and get to number, and do an === compare from there.  if the whole numbers
    // really haven't changed, we just return early exit where this func is used to prevent run-away size changes
    return Math.round(newDimensionDouble) === Math.round(parseFloat(_$rootContainer[0].style.getPropertyValue(existingCssVarName), 10));
  };
  _rootContainerResizeObserver = new ResizeObserver(function () {
    if (!_initialCheck && isApproximatelySameSize(_$rootContainer.width(), cssVariables.playerWidth) && isApproximatelySameSize(_$rootContainer.height(), cssVariables.playerHeight)) {
      return;
    }
    _initialCheck = false;
    manageResponsiveClasses();
    _$rootContainer[0].style.setProperty(cssVariables.playerWidth, "".concat(_$rootContainer.width(), "px"));
    _$rootContainer[0].style.setProperty(cssVariables.playerHeight, "".concat(_$rootContainer.height(), "px"));
    _$rootContainer.trigger(events.Controls.PlayerResize);
  });
  _viewPortContainerResizeObserver = new ResizeObserver(function () {
    calculateMediaViewPortDimensions();
    setCssVariables(_$rootContainer[0]);
    _$rootContainer.trigger(events.Controls.MediaResize);
  });
  var _responsiveBreakpoints = Object.freeze({
    'small-mobile': {
      width: 1,
      height: 1
    },
    'medium-mobile': {
      width: 250,
      height: 250
    },
    'small-desktop': {
      width: 400,
      height: 400
    },
    'medium-desktop': {
      width: 510,
      height: 510
    }
  });
  var initializeIntrinsicSizing = function initializeIntrinsicSizing(intrinsicWidth, intrinsicHeight) {
    if (_intrinsicWidth === 0 && _intrinsicHeight === 0) {
      _intrinsicWidth = intrinsicWidth;
      _intrinsicHeight = intrinsicHeight;
      _intrinsicAspectRatio = intrinsicWidth / intrinsicHeight;
    }
    calculateMediaViewPortDimensions();
    setCssVariables($rootContainer[0]);
  };
  var monitorContainerSize = function monitorContainerSize() {
    _rootContainerResizeObserver.observe(_$rootContainer[0]);
  };
  var calculateMediaViewPortDimensions = function calculateMediaViewPortDimensions() {
    if (!_$mediaViewPortContainer || _intrinsicWidth === 0 || _intrinsicHeight === 0) {
      return;
    }
    var viewPortWidth = _$mediaViewPortContainer.width();
    var viewPortHeight = _$mediaViewPortContainer.height();
    if (viewPortWidth === 0 || viewPortHeight === 0) {
      return;
    }
    if (isApproximatelySameSize(viewPortWidth, cssVariables.mediaViewPortWidth) && isApproximatelySameSize(viewPortHeight, cssVariables.mediaViewPortHeight)) {
      return;
    }
    _currentViewPortWidth = viewPortWidth;
    _currentViewPortHeight = viewPortHeight;
    _currentViewPortAspectRatio = _currentViewPortWidth / _currentViewPortHeight;

    // note: i _hate_ that we have to resort to this, i fought for many days trying to get our browser support vector
    // to use just plain css to do these things:
    // 1) expand the 'media-container' to the max width/height available based on the native media and viewport size
    // 2) reduce the 'media-container' to the necessary width/height available based on the native media and viewport size
    // 3) preserve aspect-ratio of the native media (ideally by just using the intrinsic dimensions of the video tag itself)
    // 4) put a container around that native media that shrinks height _AND_ width to the size of the auto-sized media
    //    - this container can then contain the hotspots, plugins, other to allow them to autosize to 100%/100% absolute
    // even with several layers of divs, i could not achieve this and am reduced to managing aspect-ratio-driven calculations
    // this final solution manages some responsive classes and allows CSS and css-variables to do the calculations
    // but ideally we could use flex and/or grid to just allow media to flex shrink/grow, preserve aspect ratio, and contain a
    // wrapping container that shrinks to the size of the media auto-sized media. (JMD: 2022-07)
    if (_currentViewPortAspectRatio < _intrinsicAspectRatio) {
      // width == 100%, add constrain-height
      _$mediaSizingContainer.addClass(cssClasses.constrainMediaHeight);
      _$mediaSizingContainer.removeClass(cssClasses.constrainMediaWidth);
    } else {
      // height == 100%, add constrain-width
      _$mediaSizingContainer.addClass(cssClasses.constrainMediaWidth);
      _$mediaSizingContainer.removeClass(cssClasses.constrainMediaHeight);
    }
  };
  var setCssVariables = function setCssVariables(domContainer) {
    domContainer.style.setProperty(cssVariables.mediaIntrinsicWidth, "".concat(_intrinsicWidth, "px"));
    domContainer.style.setProperty(cssVariables.mediaIntrinsicHeight, "".concat(_intrinsicHeight, "px"));
    domContainer.style.setProperty(cssVariables.mediaIntrinsicAspectRatio, "".concat(_intrinsicWidth, " / ").concat(_intrinsicHeight)); // we dont round this because intrinsic media data should always come in as whole number dimensions
    domContainer.style.setProperty(cssVariables.mediaIntrinsicAspectRatioNumber, "".concat(_intrinsicAspectRatio));
    if (_currentViewPortWidth !== 0 && _currentViewPortHeight !== 0) {
      domContainer.style.setProperty(cssVariables.mediaViewPortWidth, "".concat(_currentViewPortWidth, "px"));
      domContainer.style.setProperty(cssVariables.mediaViewPortHeight, "".concat(_currentViewPortHeight, "px"));
      domContainer.style.setProperty(cssVariables.mediaViewPortAspectRatio, "".concat(Math.round(_currentViewPortWidth), " / ").concat(Math.round(_currentViewPortHeight))); // round this, because it can come in as partial-pixel, the valid aspect-ratio for css are whole numbers
      domContainer.style.setProperty(cssVariables.mediaViewPortAspectRatioNumber, "".concat(_currentViewPortAspectRatio));
    }
  };
  var monitorMediaViewPortSize = function monitorMediaViewPortSize($mediaViewPortContainer, $mediaSizingContainer, intrinsicWidth, intrinsicHeight) {
    _$mediaViewPortContainer = $mediaViewPortContainer;
    _$mediaSizingContainer = $mediaSizingContainer;
    if (intrinsicWidth > 0 && intrinsicHeight > 0) {
      _intrinsicWidth = intrinsicWidth;
      _intrinsicHeight = intrinsicHeight;
      _intrinsicAspectRatio = intrinsicHeight ? intrinsicWidth / intrinsicHeight : 1; // guard for div0 even though it really shouldnt happen
    }
    calculateMediaViewPortDimensions();
    setCssVariables(_$rootContainer[0]);
    _viewPortContainerResizeObserver.observe(_$mediaViewPortContainer[0]);
  };
  var manageResponsiveClasses = function manageResponsiveClasses() {
    if (!_$rootContainer) {
      return;
    }
    var containerWidth = _$rootContainer.width();
    var containerHeight = _$rootContainer.height();
    $.each(_responsiveBreakpoints, function (key, breakpoint) {
      var widthClassName = [key, 'width'].join('-');
      var heightClassName = [key, 'height'].join('-');
      if (breakpoint.width && containerWidth > breakpoint.width) {
        _$rootContainer.addClass(widthClassName);
      } else {
        _$rootContainer.removeClass(widthClassName);
      }
      if (breakpoint.height && containerHeight > breakpoint.height) {
        _$rootContainer.addClass(heightClassName);
      } else {
        _$rootContainer.removeClass(heightClassName);
      }
    });
  };
  var clearContainerMonitors = function clearContainerMonitors() {
    _rootContainerResizeObserver.disconnect();
    _viewPortContainerResizeObserver.disconnect();

    // not resetting the $_rootContainer, _$mediaViewPortContainer or _$mediaSizingContainer because afaik, they persist for
    // the lifetime of the player?  if monitorMediaViewPortSize is called again, they will be re-established anyway
    _currentViewPortWidth = 0;
    _currentViewPortHeight = 0;
    _currentViewPortAspectRatio = 1.0;
    _intrinsicWidth = 0;
    _intrinsicHeight = 0;
    _intrinsicAspectRatio = 1.0;
  };
  return Object.defineProperties({
    /**
     *  Monitor the root player element for a change in size
     *  @function monitorContainerSize
     *  @memberof TSC.ResponsiveController
     *  @static
     */
    monitorContainerSize: monitorContainerSize,
    /**
     *  Monitor the viewport element for a change in size
     *  @function monitorMediaViewPortSize
     *  @param {JQuery} $mediaViewPortContainer - jquery element to monitor that is the media viewport
     *  @param {JQuery} $mediaSizingContainer - jquery element to resize based on aspect-ratio of media vs size of current viewport
     *  @param {number} intrinsicWidth - the current media intrinsic width.
     *  @param {number} intrinsicHeight - the current media intrinsic height.
     *  @memberof TSC.ResponsiveController
     *  @static
     */
    monitorMediaViewPortSize: monitorMediaViewPortSize,
    /**
     *  Configure some intrinsic media sizing hints for the media from data or configuration before media has been loaded.
     *  @function initializeIntrinsicSizing
     *  @param {number} intrinsicWidth - the current media intrinsic width.
     *  @param {number} intrinsicHeight - the current media intrinsic height.
     *  @memberof TSC.ResponsiveController
     *  @static
     */
    initializeIntrinsicSizing: initializeIntrinsicSizing,
    /**
     *  Stop monitoring the root player element for a change in size
     *  @function clearContainerMonitors
     *  @memberof TSC.ResponsiveController
     *  @static
     */
    clearContainerMonitors: clearContainerMonitors
  }, {
    responsiveBreakpoints: {
      get: function get() {
        return _responsiveBreakpoints;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} currentMediaWidth - the current width of the media
     */
    currentMediaWidth: {
      get: function get() {
        return _$mediaSizingContainer.width();
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} currentMediaHeight - the current height of the media
     */
    currentMediaHeight: {
      get: function get() {
        return _$mediaSizingContainer.height();
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} intrinsicMediaWidth - the intrinsic (native) width of the media
     */
    intrinsicMediaWidth: {
      get: function get() {
        return _intrinsicWidth;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} intrinsicMediaHeight - the intrinsic (native) height of the media
     */
    intrinsicMediaHeight: {
      get: function get() {
        return _intrinsicHeight;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} intrinsicMediaAspectRatio - the intrinsic (native) aspect-ratio of the media
     */
    intrinsicMediaAspectRatio: {
      get: function get() {
        return _intrinsicAspectRatio;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} currentViewPortWidth - the current width of the viewport
     */
    currentViewPortWidth: {
      get: function get() {
        return _currentViewPortWidth;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} currentViewPortHeight - the current height of the viewport
     */
    currentViewPortHeight: {
      get: function get() {
        return _currentViewPortHeight;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ResponsiveController
     *  @property {number} currentViewPortAspectRatio - the current aspect-ratio of the viewport
     */
    currentViewPortAspectRatio: {
      get: function get() {
        return _currentViewPortAspectRatio;
      }
    }
  });
};
var ResponsiveController$1 = {
  /**
   *  Factory method that returns a new ResponsiveController.
   *  @function create
   *  @memberof TSC.ResponsiveController
   *  @static
   *  @param {jQuery} $rootContainer - Smart Player main container jquery element
   *  @return new ResponsiveController instance
   */
  create: ResponsiveController
};

/* eslint-disable no-console */
var _noneType = 'NONE';
var _scormType = 'SCORM';
var _apiAndScormType = 'APIANDSCORM';
var _api = 'API';
var reportType = Object.freeze({
  NONE: _noneType,
  SCORM: _scormType,
  DEPRECATED_APIANDSCORM: _apiAndScormType,
  DEPRECATED_API: _api,
  isValid: function isValid(type) {
    return type === _noneType || type === _scormType;
  },
  convertDeprecatedAPIType: function convertDeprecatedAPIType(type) {
    if (type === _apiAndScormType) {
      return _scormType;
    }
    if (type === _api) {
      return _noneType;
    }
    return type;
  }
});

var MARKER_BEGIN_OFFSET = 250; // 250 milliseconds
var MARKER_END_OFFSET = 100; // 100 milliseconds

/**
 * @memberof TSC
 * @class QuestionSetMarker
 * @classdesc Question Set Marker
 * @params {Number} questionSetIndex - Question Set index
 * @params {TSC.QuestionSet} questionSet - Question set object for this marker.
 */
var QuestionSetMarker = function QuestionSetMarker(questionSetIndex, questionSet) {
  var _questionSetIndex = questionSetIndex;
  var _startTime = questionSet.startTime;
  var _rangeStart = questionSet.startTime - MARKER_BEGIN_OFFSET;
  var _rangeEnd = questionSet.startTime + MARKER_END_OFFSET;
  var _canSeekPast = false;
  return Object.defineProperties({}, {
    questionSetIndex: {
      get: function get() {
        return _questionSetIndex;
      },
      set: function set(questionSetId) {
        _questionSetIndex = questionSetId;
      }
    },
    rangeStart: {
      get: function get() {
        return _rangeStart;
      },
      set: function set(rangeStart) {
        _rangeStart = rangeStart;
      }
    },
    rangeEnd: {
      get: function get() {
        return _rangeEnd;
      },
      set: function set(rangeEnd) {
        _rangeEnd = rangeEnd;
      }
    },
    startTime: {
      get: function get() {
        return _startTime;
      },
      set: function set(time) {
        _startTime = time;
      }
    },
    completed: {
      get: function get() {
        return questionSet.completed;
      }
    },
    canSeekPast: {
      get: function get() {
        return questionSet.completed || _canSeekPast;
      },
      set: function set(canSeekPast) {
        _canSeekPast = canSeekPast;
      }
    }
  });
};
var QuestionSetMarker$1 = {
  /**
   *  Factory method that returns a new QuestionSetMarker object.
   *  @function create
   *  @memberof TSC.QuestionSetMarker
   *  @params {Number} questionSetIndex - Question Set index
   *  @params {Number} startTime - Time of question marker relative to media.
   *  @static
   *  @return new QuestionSetMarker instance
   */
  create: QuestionSetMarker
};

var questionType = Object.freeze({
  FILL_IN: 'FITB',
  CHOICE: 'MC',
  SHORT: 'SHORT'
});

var SHORT_ANSWER_SNAPSHOT_TEXT = 'n/a';

/**
 * @memberof TSC
 * @class Question
 * @param {tscme.Question} tscmeQuestionModel - Question model from Media-Extensions-js
 * @classdesc Question model
 */
var Question = function Question(tscmeQuestionModel) {
  var _isGraded = false;
  var _userResponse;
  var _isResponseCorrect;
  var _attemptDuration = 0;
  var _correctAnswer;
  var _responseLocked = false;
  var _feedbackActionExecuted = false;
  var getIsGraded = function getIsGraded(type, correctAnswer, answers) {
    return type === questionType.CHOICE && correctAnswer && correctAnswer > 0 || type === questionType.FILL_IN && answers.length > 0;
  };
  _isGraded = getIsGraded(tscmeQuestionModel.type, tscmeQuestionModel.correctAnswer, tscmeQuestionModel.answers);
  _correctAnswer = tscmeQuestionModel.correctAnswer;
  var toJSON = function toJSON() {
    return {
      id: tscmeQuestionModel.id,
      type: tscmeQuestionModel.type,
      questionText: tscmeQuestionModel.text,
      choices: tscmeQuestionModel.answers.map(function (answer) {
        return answer.text;
      }),
      correctAnswer: _correctAnswer
    };
  };
  var getSnapShot = function getSnapShot() {
    // due to character limitations with SCORM data we will not include short answer user response
    var snapshotUserResponse = _userResponse;
    if (tscmeQuestionModel.type === questionType.SHORT && _userResponse) {
      snapshotUserResponse = SHORT_ANSWER_SNAPSHOT_TEXT;
    }
    return {
      id: tscmeQuestionModel.id,
      rl: _responseLocked,
      ad: _attemptDuration,
      ur: snapshotUserResponse,
      irc: _isResponseCorrect
    };
  };
  var populateQuestion = function populateQuestion(questionSnapShot) {
    if (questionSnapShot.id === tscmeQuestionModel.id) {
      _responseLocked = questionSnapShot.rl;
      _attemptDuration = questionSnapShot.ad;
      _userResponse = questionSnapShot.ur;
      _isResponseCorrect = questionSnapShot.irc;
    }
  };
  var getQuizServiceData = function getQuizServiceData(percentOfVideoSegmentWatched) {
    var questionData = {
      type: tscmeQuestionModel.type,
      id: tscmeQuestionModel.id,
      duration: _attemptDuration,
      response: _userResponse,
      correct: _isResponseCorrect,
      segmentWatched: percentOfVideoSegmentWatched
    };

    // no correct answer for MC question, don't include correct var
    if (tscmeQuestionModel.type === questionType.CHOICE && _correctAnswer === 0) {
      delete questionData.correct;
    }
    return questionData;
  };
  var getFeedbackForReason = function getFeedbackForReason(reason) {
    var feedback = null;
    tscmeQuestionModel.feedback.forEach(function (feedbackItem) {
      if (feedbackItem.reason === reason) {
        feedback = feedbackItem;
      }
    });
    return feedback;
  };
  return Object.defineProperties({
    toJSON: toJSON,
    getSnapShot: getSnapShot,
    populateQuestion: populateQuestion,
    getQuizServiceData: getQuizServiceData,
    getFeedbackForReason: getFeedbackForReason
  }, {
    id: {
      get: function get() {
        return tscmeQuestionModel.id;
      }
    },
    type: {
      get: function get() {
        return tscmeQuestionModel.type;
      }
    },
    text: {
      get: function get() {
        return tscmeQuestionModel.text;
      }
    },
    correctAnswer: {
      get: function get() {
        return _correctAnswer;
      },
      set: function set(correctAnswer) {
        _correctAnswer = correctAnswer;
      }
    },
    answers: {
      get: function get() {
        return tscmeQuestionModel.answers;
      }
    },
    feedback: {
      get: function get() {
        return tscmeQuestionModel.feedback;
      }
    },
    isGraded: {
      get: function get() {
        return _isGraded;
      },
      set: function set(isGraded) {
        _isGraded = isGraded;
      }
    },
    userResponse: {
      get: function get() {
        return _userResponse;
      },
      set: function set(userResponse) {
        if (_responseLocked) {
          return;
        }
        _userResponse = userResponse;
      }
    },
    isResponseCorrect: {
      get: function get() {
        return _isResponseCorrect;
      },
      set: function set(isResponseCorrect) {
        _isResponseCorrect = isResponseCorrect;
      }
    },
    attemptDuration: {
      get: function get() {
        return _attemptDuration;
      },
      set: function set(attemptDuration) {
        if (_responseLocked) {
          return;
        }
        _attemptDuration = attemptDuration;
      }
    },
    responseLocked: {
      get: function get() {
        return _responseLocked;
      },
      set: function set(responseLocked) {
        _responseLocked = responseLocked;
      }
    },
    feedbackActionExecuted: {
      get: function get() {
        return _feedbackActionExecuted;
      },
      set: function set(feedbackActionExecuted) {
        _feedbackActionExecuted = feedbackActionExecuted;
      }
    }
  });
};
var Question$1 = {
  /**
   *  Factory method that returns a new Question object.
   *  @function create
   *  @memberof TSC.Question
   *  @param {tscme.Question} tscmeQuestionModel - Question model from Media-Extensions-js
   *  @static
   *  @return new Question instance
   */
  create: Question
};

/**
 * @memberof TSC
 * @class QuestionSet
 * @classdesc Question Set Model
 * @param {tscme.QuestionSet} tscmeQuestionSetModel - Question set model from Media-Extensions-js
 * @param {Number} orderId - Order id of the question set.  Should be a number above 0.
 */
var QuestionSet = function QuestionSet(tscmeQuestionSetModel, orderId) {
  var _questions = [];
  var _orderId = orderId;
  var _percentOfVideoSegmentWatched = 0;
  var _numberGradedQuestions = 0;
  var _numberUngradedQuestions = 0;
  var createQuestionModels = function createQuestionModels() {
    tscmeQuestionSetModel.questions.forEach(function (tscmeQuestion) {
      _questions.push(Question$1.create(tscmeQuestion));
    });
  };
  var cacheQuestionDetails = function cacheQuestionDetails() {
    _numberGradedQuestions = 0;
    _numberUngradedQuestions = 0;
    _questions.forEach(function (question) {
      if (question.isGraded) {
        _numberGradedQuestions++;
      } else {
        _numberUngradedQuestions++;
      }
    });
  };
  var toJSON = function toJSON() {
    return {
      name: tscmeQuestionSetModel.name,
      mediaTimePosition: tscmeQuestionSetModel.startTime,
      order: _orderId,
      questions: _questions.map(function (question) {
        return question.toJSON();
      })
    };
  };
  var getSnapShot = function getSnapShot() {
    return {
      n: tscmeQuestionSetModel.name,
      vsw: _percentOfVideoSegmentWatched,
      q: _questions.map(function (question) {
        return question.getSnapShot();
      })
    };
  };
  var populateQuestionSet = function populateQuestionSet(questionSetSnapShot) {
    if (tscmeQuestionSetModel.name === questionSetSnapShot.n) {
      _percentOfVideoSegmentWatched = questionSetSnapShot.vsw;
      questionSetSnapShot.q.forEach(function (questionSnapShot) {
        for (var i = 0; i < _questions.length; i++) {
          if (_questions[i].id === questionSnapShot.id) {
            _questions[i].populateQuestion(questionSnapShot);
          }
        }
      });
    }
  };
  var getQuizServiceData = function getQuizServiceData(quizId) {
    var questionSetData = {};
    questionSetData.quizId = quizId;
    questionSetData.order = _orderId;
    questionSetData.questions = _questions.filter(function (question) {
      return question.responseLocked;
    }).map(function (question) {
      return question.getQuizServiceData(_percentOfVideoSegmentWatched);
    });
    return JSON.stringify(questionSetData);
  };
  createQuestionModels();
  cacheQuestionDetails();
  return Object.defineProperties({
    toJSON: toJSON,
    getSnapShot: getSnapShot,
    populateQuestionSet: populateQuestionSet,
    getQuizServiceData: getQuizServiceData,
    cacheQuestionDetails: cacheQuestionDetails
  }, {
    name: {
      get: function get() {
        return tscmeQuestionSetModel.name;
      }
    },
    displayFeedback: {
      get: function get() {
        return tscmeQuestionSetModel.feedback;
      }
    },
    startTime: {
      get: function get() {
        return tscmeQuestionSetModel.startTime;
      }
    },
    questions: {
      get: function get() {
        return _questions;
      }
    },
    inProgress: {
      get: function get() {
        return _questions.some(function (question) {
          return question.responseLocked;
        });
      }
    },
    completed: {
      get: function get() {
        return _questions.every(function (question) {
          return question.responseLocked;
        });
      }
    },
    percentOfVideoSegmentWatched: {
      get: function get() {
        return _percentOfVideoSegmentWatched;
      },
      set: function set(percentOfVideoSegmentWatched) {
        _percentOfVideoSegmentWatched = percentOfVideoSegmentWatched;
      }
    },
    numberGradedQuestions: {
      get: function get() {
        return _numberGradedQuestions;
      }
    },
    numberUngradedQuestions: {
      get: function get() {
        return _numberUngradedQuestions;
      }
    },
    numberCorrectQuestions: {
      get: function get() {
        var correctQuestions = _questions.filter(function (question) {
          return question.isGraded && question.isResponseCorrect;
        });
        return correctQuestions.length;
      }
    },
    usesRationale: {
      get: function get() {
        return _questions.some(function (question) {
          return question.feedback.length > 0;
        });
      }
    }
  });
};
var QuestionSet$1 = {
  /**
   *  Factory method that returns a new QuestionSet object.
   *  @function create
   *  @memberof TSC.QuestionSet
   *  @param {tscme.QuestionSet} tscmeQuestionSetModel - Question set model from Media-Extensions-js
   *  @param {Number} orderId - Order id of the question set.  Should be a number above 0.
   *  @static
   *  @return new QuestionSet instance
   */
  create: QuestionSet
};

var MIN_MARKER_TIME_DIFF = 2000;

/**
 * @memberof TSC
 * @class Quiz
 * @classdesc Quiz Model
 * @param {TSC.Xmp} xmpModel - Xmp Model
 */
var Quiz = function Quiz(xmpModel) {
  var _productionName;
  var _originId;
  var _projectName;
  var _quizTitle;
  var _quizId;
  var _quizInstanceId;
  var _authoredEmail;
  var _clientId;
  var _quizHash;
  var _reportMethod = reportType.NONE;
  var _hideReplay = false;
  var _questionSets = [];
  var _questionSetMarkers = [];
  var _mediaDuration = 0;
  var _locale = '';
  var _allowSkipQuiz = true;
  var createQuizDefinition = function createQuizDefinition() {
    var quizDef = {};
    quizDef.quizId = _quizId;
    quizDef.lang = _locale;
    quizDef.projectName = _projectName;
    quizDef.productionName = _productionName;
    quizDef.originId = _originId;
    quizDef.mediaDuration = _mediaDuration;
    quizDef.reportRecipients = [_authoredEmail];
    quizDef.questionSets = [];
    _questionSets.forEach(function (questionSet) {
      quizDef.questionSets.push(questionSet.toJSON());
    });
    return window.JSON.stringify(quizDef);
  };
  var setAllowSkipQuiz = function setAllowSkipQuiz(allowSkipQuiz) {
    _allowSkipQuiz = !(allowSkipQuiz === '0' || allowSkipQuiz === false);
  };
  var setReportMethod = function setReportMethod(method) {
    var convertedMethod = reportType.convertDeprecatedAPIType(method);
    if (reportType.isValid(convertedMethod)) {
      _reportMethod = convertedMethod;
    }
  };
  var getApiDataForQuestionSet = function getApiDataForQuestionSet(questionSetIndex) {
    if (questionSetIndex < 0 || questionSetIndex >= _questionSets.length) {
      return;
    }
    return _questionSets[questionSetIndex].getQuizServiceData(_quizId);
  };
  var createQuestionSetMarkers = function createQuestionSetMarkers() {
    _questionSetMarkers = [];
    _questionSets.forEach(function (questionSet, index) {
      _questionSetMarkers.push(QuestionSetMarker$1.create(index, questionSet));
    });
  };
  var processXmp = function processXmp() {
    _productionName = xmpModel.title;
    _originId = xmpModel.originId;
    _projectName = xmpModel.project;
    _locale = xmpModel.quizLocale;
    _quizTitle = xmpModel.title;
    _quizId = xmpModel.quizGuid;
    _hideReplay = xmpModel.quizHideReplay;
    _authoredEmail = xmpModel.quizAuthoredEmail;
    _clientId = xmpModel.quizClientId;
    _quizHash = xmpModel.quizHash;
    _mediaDuration = xmpModel.mediaDuration;
    setReportMethod(xmpModel.quizReportMethod);
    setAllowSkipQuiz(xmpModel.quizAllowSkipQuiz);
    xmpModel.quizQuestionSetArray.forEach(function (tscmeQuestionSet, index) {
      _questionSets.push(QuestionSet$1.create(tscmeQuestionSet, index + 1));
    });
  };
  var getScormScore = function getScormScore() {
    var scormScore = 0;
    var totalGradableQuestions = 0;
    var totalCorrectQuestions = 0;
    _questionSets.forEach(function (questionSet) {
      totalGradableQuestions += questionSet.numberGradedQuestions;
      totalCorrectQuestions += questionSet.numberCorrectQuestions;
    });
    if (totalGradableQuestions !== 0) {
      scormScore = totalCorrectQuestions / totalGradableQuestions * 100;
    }
    return scormScore;
  };
  var isLastQuestionComplete = function isLastQuestionComplete(considerQuestionSetCompleteId) {
    if (considerQuestionSetCompleteId === undefined) {
      considerQuestionSetCompleteId = -1;
    }
    return _questionSets.every(function (questionSet, index) {
      return questionSet.numberGradedQuestions === 0 || questionSet.completed || index === considerQuestionSetCompleteId;
    });
  };
  var getPreviousMarkerTimeForMarker = function getPreviousMarkerTimeForMarker(questionSetIndex) {
    var markerTime = 0;
    var timeDiff;
    if (questionSetIndex > 0) {
      if (questionSetIndex >= _questionSets.length) {
        markerTime = _questionSets[_questionSets.length - 1].startTime;
      } else {
        for (var i = questionSetIndex - 1; i >= 0; i--) {
          if (!_questionSets[i].completed) {
            continue;
          }
          timeDiff = _questionSets[questionSetIndex].startTime - _questionSets[i].startTime;
          if (timeDiff >= MIN_MARKER_TIME_DIFF) {
            markerTime = _questionSets[i].startTime;
            break;
          }
        }
      }
    }
    return markerTime;
  };
  var getSnapShot = function getSnapShot() {
    return {
      qs: _questionSets.map(function (questionSet) {
        return questionSet.getSnapShot();
      })
    };
  };
  var populateQuiz = function populateQuiz(quizModelSnapshot) {
    quizModelSnapshot.qs.forEach(function (questionSetSnapshot) {
      for (var i = 0; i < _questionSets.length; i++) {
        if (_questionSets[i].name === questionSetSnapshot.n) {
          _questionSets[i].populateQuestionSet(questionSetSnapshot);
        }
      }
    });
  };
  processXmp();
  createQuestionSetMarkers();
  return Object.defineProperties({
    getApiDataForQuestionSet: getApiDataForQuestionSet,
    getScormScore: getScormScore,
    isLastQuestionComplete: isLastQuestionComplete,
    getPreviousMarkerTimeForMarker: getPreviousMarkerTimeForMarker,
    getSnapShot: getSnapShot,
    populateQuiz: populateQuiz
  }, {
    quizDefinition: {
      get: function get() {
        return createQuizDefinition();
      }
    },
    useQuizApi: {
      get: function get() {
        return false;
      }
    },
    useScorm: {
      get: function get() {
        return reportType.convertDeprecatedAPIType(_reportMethod) === reportType.SCORM;
      }
    },
    quizTitle: {
      get: function get() {
        return _quizTitle;
      }
    },
    quizID: {
      get: function get() {
        return _quizId;
      }
    },
    quizInstanceID: {
      set: function set(quizInstanceId) {
        _quizInstanceId = quizInstanceId;
      },
      get: function get() {
        return _quizInstanceId;
      }
    },
    authoredEmail: {
      get: function get() {
        return _authoredEmail;
      }
    },
    clientId: {
      get: function get() {
        return _clientId;
      }
    },
    quizHash: {
      get: function get() {
        return _quizHash;
      }
    },
    mediaDuration: {
      get: function get() {
        return _mediaDuration;
      }
    },
    reportMethod: {
      set: setReportMethod,
      get: function get() {
        return _reportMethod;
      }
    },
    requireUserId: {
      get: function get() {
        return false;
      }
    },
    hideReplay: {
      get: function get() {
        return _hideReplay;
      }
    },
    allowSkipQuiz: {
      get: function get() {
        return _allowSkipQuiz;
      }
    },
    locale: {
      get: function get() {
        return _locale;
      }
    },
    questionSetMarkerTimes: {
      get: function get() {
        return _questionSetMarkers;
      }
    },
    numberQuestionSets: {
      get: function get() {
        return _questionSets.length;
      }
    },
    questionSets: {
      get: function get() {
        return _questionSets;
      }
    },
    minMarkerTimeDiff: {
      get: function get() {
        return MIN_MARKER_TIME_DIFF;
      }
    },
    totalNumberOfGradedQuestionSets: {
      get: function get() {
        var totalGradableQuestionSets = 0;
        _questionSets.forEach(function (questionSet) {
          if (questionSet.numberGradedQuestions > 0) {
            totalGradableQuestionSets++;
          }
        });
        return totalGradableQuestionSets;
      }
    }
  });
};
var Quiz$1 = {
  /**
   *  Factory method that returns a new Quiz object.
   *  @function create
   *  @memberof TSC.Quiz
   *  @param {TSC.Xmp} xmpModel - Xmp Model
   *  @static
   *  @return new Quiz instance
   */
  create: Quiz
};

/**
 * @memberof TSC
 * @class urlService
 * @classdesc Url opening service.
 */
var ensureUrlHasValidScheme = function ensureUrlHasValidScheme(url) {
  if (typeof url === 'string' && url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
    url = 'http://' + url;
  }
  return url;
};
var openUrl = function openUrl(url, features) {
  url = ensureUrlHasValidScheme(url);
  if (features) {
    windowWrapper.open(url, features);
  } else {
    windowWrapper.open(url);
  }
};
var isUrlAbsolute = function isUrlAbsolute(url) {
  return url.indexOf('http://') === 0 || url.indexOf('https://') === 0;
};
var generateQueryStringWithExtraParam = function generateQueryStringWithExtraParam(key, value) {
  key = encodeURI(key);
  value = encodeURI(value);
  var windowLocation = windowWrapper.getLocation();
  var kvp = windowLocation.search.substr(1).split('&');
  var i = kvp.length;
  var x;
  while (i--) {
    x = kvp[i].split('=');
    if (x[0] === key) {
      x[1] = value;
      kvp[i] = x.join('=');
      break;
    }
  }
  if (i < 0) {
    kvp[kvp.length] = [key, value].join('=');
  }
  var query = kvp.join('&');
  if (query.indexOf('&') === 0) {
    query = query.substr(1);
  }
  return '?' + query;
};
var generateCurrentUrlWithExtraQueryParam = function generateCurrentUrlWithExtraQueryParam(paramName, paramValue) {
  var search = generateQueryStringWithExtraParam(paramName, paramValue);
  var windowLocation = windowWrapper.getLocation();
  var port = windowLocation.port ? ':' + windowLocation.port : '';
  return windowLocation.protocol + '//' + windowLocation.hostname + port + windowLocation.pathname + search + windowLocation.hash;
};
var convertUrlTime = function convertUrlTime(val) {
  if (isNaN(val)) {
    var hrs = 0;
    var min = 0;
    var sec = 0;
    var strTime = val.toLowerCase();
    // Regex patterns ----------------------------------------------------
    var hrsPattern = new RegExp('(\\d+[\h])', 'g'); //( 999h )
    var minPattern = new RegExp('(\\d+[\m])', 'g'); //( 999m )
    var secPattern = new RegExp('(\\d+[\s])', 'g'); //( 999s )
    var numPattern = new RegExp('\\d+', 'g'); // * numerals
    // Match regex Tests -------------------------------------------------
    var hrsTest = strTime.match(hrsPattern);
    var minTest = strTime.match(minPattern);
    var secTest = strTime.match(secPattern);
    var numTest = strTime.match(numPattern);
    if (secTest || minTest || hrsTest) {
      // assumes we want the 1st pattern encountered in each array is
      // the time we want to use.

      if (hrsTest) {
        // 3600 seconds in 1 hour
        hrs = Number(hrsTest[0].split('h').join('')) * 60 * 60;
      }
      if (minTest) {
        // 60 seconds in 1 minute
        min = Number(minTest[0].split('m').join('')) * 60;
      }
      if (secTest) {
        // 1 seconds = 1 second
        sec = Number(secTest[0].split('s').join(''));
      }
      // return the Time in seconds
      return Number(hrs + min + sec);
    } else if (numTest) {
      sec = Number(numTest[0]);
      // return the Time assuming seconds
      return sec;
    }
    // not valid time or all non-numeric characters
    return 0;
  }
  if (val < 0) {
    val = 0;
  }
  return val;
};
var urlService = {
  openUrl: openUrl,
  isUrlAbsolute: isUrlAbsolute,
  generateCurrentUrlWithExtraQueryParam: generateCurrentUrlWithExtraQueryParam,
  convertUrlTime: convertUrlTime
};

// This file is autogenerated. It's used to publish ESM to npm.
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {};

  // If input is already a tinycolor, return itself
  if (color instanceof tinycolor) {
    return color;
  }
  // If we are called as a function, call using new instead
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }
  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType;

  // Don't let the range of [0,255] come back in [0,1].
  // Potentially lose a little bit of precision here, but will fix issues where
  // .5 gets interpreted as half of the total, instead of half of 1
  // If it was supposed to be 128, this was already taken care of by `inputToRgb`
  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    //http://www.w3.org/TR/AERT#color-contrast
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  },
  getLuminance: function getLuminance() {
    //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360),
      s = Math.round(hsv.s * 100),
      v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360),
      s = Math.round(hsl.s * 100),
      l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
    if (needsAlphaFormat) {
      // Special case for "transparent", all other non-alpha formats
      // will return rgba when there is transparency.
      if (format === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function (color, opts) {
  if (_typeof(color) == "object") {
    var newColor = {};
    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }
    color = newColor;
  }
  return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;
  if (typeof color == "string") {
    color = stringInputToObject(color);
  }
  if (_typeof(color) == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }
    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
}

// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    l: l
  };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;
  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    v: v
  };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h),
    f = h - i,
    p = v * (1 - s),
    q = v * (1 - f * s),
    t = v * (1 - (1 - f) * s),
    mod = i % 6,
    r = [v, q, p, p, t, v][mod],
    g = [t, v, v, q, p, p][mod],
    b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

  // Return a 3 character hex if possible
  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

  // Return a 4 character hex if possible
  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function () {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};

// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}
function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}
function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}
function polyad(color, number) {
  if (isNaN(number) || number <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number;
  for (var i = 1; i < number; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }
  return result;
}
function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}
function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];
  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }
  return ret;
}
function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h,
    s = hsv.s,
    v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h: h,
      s: s,
      v: v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function (color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
};

// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function (color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function (color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function (baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level: level,
    size: size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};

// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);

// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n)));

  // Automatically convert percentage into number
  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }

  // Handle floating point rounding errors
  if (Math.abs(n - max) < 0.000001) {
    return 1;
  }

  // Convert into [0, 1] range if it isn't already
  return n % max / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
  return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = function () {
  // <http://www.w3.org/TR/css3-values/#integers>
  var CSS_INTEGER = "[-\\+]?\\d+%?";

  // <http://www.w3.org/TR/css3-values/#number-value>
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

  // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

  // Actual matching.
  // Parentheses and commas are optional, but not required.
  // Whitespace can take the place of commas or opening paren
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }

  // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.
  var match;
  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  // return valid WCAG2 parms for isReadable.
  // If input parms are invalid, return {"level":"AA", "size":"small"}
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level: level,
    size: size
  };
}

var BASE_FONT_SIZE_FOR_1080P_VIDEO = 48;
var BASE_VIDEO_WIDTH = 1920;
var BASE_VIDEO_HEIGHT = 1080;
var ROUNDING_MODIFIER = 0.5;
var _defaultTextColorObject = Object.freeze(tinycolor({
  r: 255,
  g: 255,
  b: 255,
  a: 1.0
}));
var _defaultBgColorObject = Object.freeze(tinycolor({
  r: 0,
  g: 0,
  b: 0,
  a: 0.9
}));
var _defaults = Object.freeze({
  captionFontFamily: 'Arial, Helvetica, sans-serif;',
  captionFontSize: 24,
  captionFontSizeMin: 12,
  captionFontSizeMax: 144,
  captionTextColor: _defaultTextColorObject,
  captionBgColor: _defaultBgColorObject,
  captionPosition: 'overlay',
  captionBarHeight: 0
});

/**
 * @memberof TSC
 * @class CaptionService
 * @classdesc The caption service
 */
var CaptionService = function CaptionService() {
  var _position = _defaults.captionPosition;
  var _barHeight = _defaults.captionBarHeight;
  var _font = _defaults.captionFontFamily;
  var _fontSize = _defaults.captionFontSize;
  var _fontSizeForPlayerDimensions = _defaults.captionFontSize;
  var _fontSizeMin = _defaults.captionFontSizeMin;
  var _fontSizeMax = _defaults.captionFontSizeMax;
  var _textColor = _defaults.captionTextColor.clone();
  var _backgroundColor = _defaults.captionBgColor.clone();
  var _captionController = CaptionController$1$1.create();
  var _eventHandlers = {};
  var setupSupportedEvents = function setupSupportedEvents() {
    _eventHandlers[events.CaptionService.NewCaptionTrack] = [];
  };
  var setFontSize = function setFontSize(value) {
    _fontSize = Math.min(Math.max(value, _fontSizeMin), _fontSizeMax);
  };
  var initFromXmp = function initFromXmp(xmp) {
    _position = xmp.captionPosition;
    _barHeight = xmp.captionBarHeight;
    _font = xmp.captionFontFamily;
    _fontSize = xmp.captionFontSize;
    _fontSizeMin = xmp.minCaptionFontSize;
    _fontSizeMax = xmp.maxCaptionFontSize;
    _textColor = tinycolor(xmp.captionTextColor);
    _backgroundColor = tinycolor(xmp.captionBg);
    _captionController = xmp.captionController;
  };
  var initDefaults = function initDefaults() {
    _position = _defaults.captionPosition;
    _barHeight = _defaults.captionBarHeight;
    _font = _defaults.captionFontFamily;
    _fontSize = _defaults.captionFontSize;
    _fontSizeForPlayerDimensions = _defaults.captionFontSize;
    _fontSizeMin = _defaults.captionFontSizeMin;
    _fontSizeMax = _defaults.captionFontSizeMax;
    _textColor = _defaults.captionTextColor.clone();
    _backgroundColor = _defaults.captionBgColor.clone();
  };
  var setFontSizeForPlayerDimensions = function setFontSizeForPlayerDimensions(playerWidth, playerHeight) {
    var scaleX = playerWidth / BASE_VIDEO_WIDTH;
    var scaleY = playerHeight / BASE_VIDEO_HEIGHT;
    _fontSizeForPlayerDimensions = Math.floor(BASE_FONT_SIZE_FOR_1080P_VIDEO * Math.min(scaleX, scaleY) + ROUNDING_MODIFIER);
  };
  var dispatchEvent = function dispatchEvent(eventName) {
    if (_eventHandlers[eventName]) {
      _eventHandlers[eventName].forEach(function (eventCallback) {
        eventCallback();
      });
    }
  };
  var addEventListener = function addEventListener(eventName, eventHandler) {
    if (!_eventHandlers[eventName]) {
      return;
    }
    _eventHandlers[eventName].push(eventHandler);
  };
  var removeEventListener = function removeEventListener(eventName, eventHandler) {
    if (!_eventHandlers[eventName]) {
      return;
    }
    var eventEntry = _eventHandlers[eventName];
    for (var i = 0; i < eventEntry.length; i++) {
      if (eventEntry[i] === eventHandler) {
        eventEntry.splice(i, 1);
        break;
      }
    }
  };
  var setCaptionTrack = function setCaptionTrack(newCaptionTrack) {
    _captionController.addCaptionTrack(newCaptionTrack);
    _backgroundColor = tinycolor({
      r: _captionController.activeCaptionTrack.bgColor.r,
      g: _captionController.activeCaptionTrack.bgColor.g,
      b: _captionController.activeCaptionTrack.bgColor.b,
      a: _captionController.activeCaptionTrack.bgOpacity
    });
    _textColor = tinycolor({
      r: _captionController.activeCaptionTrack.fgColor.r,
      g: _captionController.activeCaptionTrack.fgColor.g,
      b: _captionController.activeCaptionTrack.fgColor.b
    });
    setFontSize(_captionController.activeCaptionTrack.fontSize);
    _font = _captionController.activeCaptionTrack.fontFamily;
    _barHeight = _captionController.activeCaptionTrack.barHeight;
    _position = _captionController.activeCaptionTrack.position;
    dispatchEvent(events.CaptionService.NewCaptionTrack);
  };
  setupSupportedEvents();
  return Object.defineProperties({
    initFromXmp: initFromXmp,
    initDefaults: initDefaults,
    setFontSizeForPlayerDimensions: setFontSizeForPlayerDimensions,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener
  }, {
    position: {
      get: function get() {
        return _position;
      }
    },
    height: {
      get: function get() {
        return _barHeight;
      }
    },
    font: {
      get: function get() {
        return _font;
      },
      set: function set(value) {
        _font = value;
      }
    },
    fontEnclosedWithQuotes: {
      get: function get() {
        var fontFamilies = _font.split(',');
        var quotedFontFamilies = fontFamilies.map(function (fontFamily) {
          return '\'' + fontFamily.trim() + '\'';
        });
        return quotedFontFamilies.join(',');
      }
    },
    fontSize: {
      get: function get() {
        return _fontSize;
      },
      set: setFontSize
    },
    fontSizeForPlayerDimensions: {
      get: function get() {
        return _fontSizeForPlayerDimensions;
      }
    },
    fontSizeMin: {
      get: function get() {
        return _fontSizeMin;
      }
    },
    fontSizeMax: {
      get: function get() {
        return _fontSizeMax;
      }
    },
    textColor: {
      get: function get() {
        return _textColor;
      },
      set: function set(value) {
        _textColor = tinycolor(value);
      }
    },
    backgroundColor: {
      get: function get() {
        return _backgroundColor;
      },
      set: function set(value) {
        _backgroundColor = tinycolor(value);
      }
    },
    backgroundOpacity: {
      get: function get() {
        return _backgroundColor.getAlpha();
      },
      set: function set(value) {
        _backgroundColor.setAlpha(value);
      }
    },
    captionController: {
      get: function get() {
        return _captionController;
      }
    },
    captionTrack: {
      get: function get() {
        return _captionController.activeCaptionTrack;
      },
      set: setCaptionTrack
    },
    hasCaptions: {
      get: function get() {
        return _captionController.containsCaptions;
      }
    }
  });
};
var CaptionService$1 = {
  /**
   *  Factory method that returns a new CaptionService object.
   *  @function create
   *  @memberof TSC.CaptionService
   *  @static
   *  @return new CaptionService instance
   */
  create: function create() {
    return CaptionService();
  },
  defaults: function defaults() {
    return _defaults;
  }
};

/**
 * @memberof TSC
 * @class XmpModel
 * @classdesc Xmp model
 */
var XmpModel = function XmpModel() {
  var _readyPromiseResolve;
  var _readyPromiseReject;
  var _readyPromise = new Promise$1(function (resolve, reject) {
    _readyPromiseResolve = resolve;
    _readyPromiseReject = reject;
  });
  var _xmpModel = xmp.create('');
  var _maxAttemptTime = 5000;
  var _retryLimit = 2;
  var _timeBetweenRetries = 0;
  var _groupedScreenTextItems = null;
  var _captionDefaults = CaptionService$1.defaults();
  var _xmpAjaxPromise = null;
  var _captionFileAjaxPromiseList = [];
  var loadXmpWithRetry = function loadXmpWithRetry(xmpSrc, retrylimit, crossDomainRequest) {
    _xmpAjaxPromise = $.ajax({
      type: 'GET',
      url: xmpSrc,
      crossDomain: crossDomainRequest,
      dataType: 'text',
      timeout: _maxAttemptTime
    }).done(function (data) {
      if (retrylimit < _retryLimit) {
        log.logMessage('xmp: loadXMP() succeeded after ' + (_retryLimit - retrylimit) + ' failed attempts.');
      }
      _xmpAjaxPromise = null;
      parseXmp(data);
    }).fail(function () {
      _xmpAjaxPromise = null;
      if (retrylimit > 0) {
        setTimeout(function () {
          loadXmpWithRetry(xmpSrc, --retrylimit);
        }, _timeBetweenRetries, crossDomainRequest);
      } else {
        _readyPromiseReject('xmp: loadXMP() failed after ' + _retryLimit + ' retries.');
      }
    });
  };
  var loadXmp = function loadXmp(xmpSrc, crossDomainRequest) {
    loadXmpWithRetry(xmpSrc, _retryLimit, crossDomainRequest);
  };
  var parseXmp = function parseXmp(xmpXml) {
    try {
      _xmpModel = xmp.create(xmpXml);
      _readyPromiseResolve();
    } catch (err) {
      console.warn('Smart Player XMP parsing error - ', err);
      _readyPromiseReject('xmp - failed to parse XMP string');
    }
  };
  var groupScreenTextByStartTime = function groupScreenTextByStartTime() {
    var itemStartTime = null;
    var groupIndex = -1;
    _groupedScreenTextItems = [];
    _xmpModel.screenTextTrack.markers.forEach(function (item) {
      if (item.startTime !== itemStartTime) {
        groupIndex++;
        itemStartTime = item.startTime;
        _groupedScreenTextItems[groupIndex] = {
          startTime: item.startTime,
          file: item.file,
          image: item.image,
          imageRectangle: item.imageRectangle,
          items: []
        };
      }
      _groupedScreenTextItems[groupIndex].items.push(item);
    });
    _groupedScreenTextItems.forEach(function (groupedItem) {
      groupedItem.text = groupedItem.items.map(function (item) {
        return item.name;
      }).reduce(function (previousItemName, currentItemName) {
        return previousItemName + ' ' + currentItemName;
      });
    });
  };
  var loadCaptionFile = function loadCaptionFile(src) {
    var captionAjaxPromise;
    return new Promise$1(function (resolve) {
      captionAjaxPromise = $.ajax({
        type: 'GET',
        url: src,
        dataType: 'text',
        timeout: _maxAttemptTime
      }).done(function (captionData) {
        captionAjaxPromise = null;
        resolve(captionData);
      }).fail(function () {
        console.warn('Failed to load captions file [' + src + ']');
        captionAjaxPromise = null;
        resolve();
      });
      _captionFileAjaxPromiseList.push(captionAjaxPromise);
    });
  };
  var importCaptionsFromFile = function importCaptionsFromFile(captionsSrcList) {
    var loadedCaptionData = {};
    return Promise$1.all(captionsSrcList.map(function (captionSrcItem) {
      return loadCaptionFile(captionSrcItem.src).then(function (captionData) {
        loadedCaptionData[captionSrcItem.languageIdentifier] = captionData;
      });
    })).then(function () {
      _xmpModel.captionController.clearCaptions();

      // import the caption data in the same order as configured
      captionsSrcList.forEach(function (captionSrcItem) {
        if (loadedCaptionData[captionSrcItem.languageIdentifier]) {
          _xmpModel.importCaptionsFromFile(captionSrcItem.src, loadedCaptionData[captionSrcItem.languageIdentifier], captionSrcItem.languageIdentifier);
        }
      });
    });
  };
  var abortPendingRequests = function abortPendingRequests() {
    _xmpAjaxPromise && _xmpAjaxPromise.abort();
    _captionFileAjaxPromiseList.forEach(function (captionAjaxPromise) {
      captionAjaxPromise && captionAjaxPromise.abort();
    });
  };
  var imageExistsForTocFromDescription = function imageExistsForTocFromDescription() {
    return playerConfiguration.tocModelFromDescription && playerConfiguration.tocModelFromDescription.items.length && playerConfiguration.tocModelFromDescription.items[0].image;
  };
  return Object.defineProperties({
    load: loadXmp,
    parse: parseXmp,
    importCaptionsFromFile: importCaptionsFromFile,
    abortPendingRequests: abortPendingRequests
  }, {
    ready: {
      get: function get() {
        return _readyPromise;
      }
    },
    hasAdvancedFeatures: {
      get: function get() {
        return playerConfiguration.tocModelFromDescription || _xmpModel.containsToc || _xmpModel.containsCaptions || _xmpModel.containsHotspots || _xmpModel.containsQuiz;
      }
    },
    hasTocItems: {
      get: function get() {
        return playerConfiguration.tocModelFromDescription || _xmpModel.containsToc;
      }
    },
    hasCaptionItems: {
      get: function get() {
        return _xmpModel.containsCaptions;
      }
    },
    hasHotspotItems: {
      get: function get() {
        return _xmpModel.containsHotspots;
      }
    },
    hasQuiz: {
      get: function get() {
        return _xmpModel.containsQuiz;
      }
    },
    hasScreenTextItems: {
      get: function get() {
        return _xmpModel.containsScreenText;
      }
    },
    hasSpeechTextItems: {
      get: function get() {
        return _xmpModel.containsSpeechText;
      }
    },
    hasSearchableItems: {
      get: function get() {
        var hasAnySearchableItems = _xmpModel.containsCaptions || _xmpModel.containsScreenText || _xmpModel.containsSpeechText;
        return playerConfiguration.tocModelFromDescription || _xmpModel.containsToc || hasAnySearchableItems && playerConfiguration.getIsSearchable();
      }
    },
    project: {
      get: function get() {
        return _xmpModel.project;
      }
    },
    originId: {
      get: function get() {
        return _xmpModel.originId;
      }
    },
    mediaDuration: {
      get: function get() {
        return _xmpModel.duration.value;
      }
    },
    title: {
      get: function get() {
        return _xmpModel.title;
      }
    },
    controllerParameters: {
      get: function get() {
        return _xmpModel.controller && _xmpModel.controller.parameters ? _xmpModel.controller.parameters : [];
      }
    },
    tocImageSrc: {
      get: function get() {
        return _xmpModel.containsToc ? _xmpModel.tableOfContentsTrack.image : null;
      }
    },
    tocCellLayoutType: {
      get: function get() {
        return _xmpModel.containsToc ? _xmpModel.tableOfContentsTrack.cellLayout : null;
      }
    },
    tocItemArray: {
      get: function get() {
        if (playerConfiguration.tocModelFromDescription) {
          return playerConfiguration.tocModelFromDescription.items;
        } else if (_xmpModel.containsToc) {
          return _xmpModel.tableOfContentsTrack.items;
        }
        return [];
      }
    },
    speechTextItemArray: {
      get: function get() {
        return _xmpModel.containsSpeechText ? _xmpModel.speechTrack.markers : [];
      }
    },
    screenTextItemArray: {
      get: function get() {
        if (_xmpModel.containsScreenText && _groupedScreenTextItems === null) {
          groupScreenTextByStartTime();
        }
        return _xmpModel.containsScreenText ? _groupedScreenTextItems : [];
      }
    },
    hotspotItemArray: {
      get: function get() {
        return _xmpModel.containsHotspots ? _xmpModel.hotspotTrack.hotspots : [];
      }
    },
    quizGuid: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.quizGuid : null;
      }
    },
    quizAuthoredEmail: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.authoredEmail : null;
      }
    },
    quizRequireUserId: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.requireUserId : null;
      }
    },
    quizLocale: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.locale : null;
      }
    },
    quizReportMethod: {
      get: function get() {
        if (!_xmpModel.containsQuiz) {
          return null;
        }
        var convertedReportMethod = reportType.convertDeprecatedAPIType(_xmpModel.quizTrack.reportMethod);
        return reportType.isValid(convertedReportMethod) ? convertedReportMethod : reportType.NONE;
      }
    },
    quizClientId: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.clientId : null;
      }
    },
    quizHash: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.quizHash : null;
      }
    },
    quizHideReplay: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.hideReplay : null;
      }
    },
    quizAllowSkipQuiz: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.allowSkipQuiz : null;
      }
    },
    quizParameters: {
      get: function get() {
        return _xmpModel.containsQuiz && _xmpModel.quizTrack.parameters ? _xmpModel.quizTrack.parameters : [];
      }
    },
    quizQuestionSetArray: {
      get: function get() {
        return _xmpModel.containsQuiz ? _xmpModel.quizTrack.questionSets : [];
      }
    },
    captionController: {
      get: function get() {
        return _xmpModel.captionController;
      }
    },
    captionsHasMultipleLanguages: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.getAvailableLanguages().length > 1;
      }
    },
    captionItems: {
      get: function get() {
        return _xmpModel.containsCaptions ? _xmpModel.captionController.activeCaptionTrack.captionCollection.captions : [];
      }
    },
    captionFontFamily: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.fontFamily !== undefined ? _xmpModel.captionController.activeCaptionTrack.fontFamily : _captionDefaults.captionFontFamily;
      }
    },
    captionFontSize: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.fontSize !== undefined ? _xmpModel.captionController.activeCaptionTrack.fontSize : _captionDefaults.captionFontSize;
      }
    },
    minCaptionFontSize: {
      get: function get() {
        return _captionDefaults.captionFontSizeMin;
      }
    },
    maxCaptionFontSize: {
      get: function get() {
        return _captionDefaults.captionFontSizeMax;
      }
    },
    captionBgOpacity: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.bgOpacity !== undefined ? _xmpModel.captionController.activeCaptionTrack.bgOpacity : _captionDefaults.captionBgColor.getAlpha();
      }
    },
    captionTextColor: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.fgHexColor !== undefined ? _xmpModel.captionController.activeCaptionTrack.fgHexColor : _captionDefaults.captionTextColor.toHexString();
      }
    },
    captionBgColor: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.bgColor !== undefined ? _xmpModel.captionController.activeCaptionTrack.bgColor : _captionDefaults.captionBgColor.toHexString();
      }
    },
    captionBg: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.bgRGBACssColor ? _xmpModel.captionController.activeCaptionTrack.bgRGBACssColor : _captionDefaults.captionBgColor.toRgbString();
      }
    },
    captionPosition: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.position !== undefined ? _xmpModel.captionController.activeCaptionTrack.position : _captionDefaults.captionPosition;
      }
    },
    captionBarHeight: {
      get: function get() {
        return _xmpModel.containsCaptions && _xmpModel.captionController.activeCaptionTrack.barHeight !== undefined ? _xmpModel.captionController.activeCaptionTrack.barHeight : _captionDefaults.captionBarHeight;
      }
    },
    tocContainsThumbs: {
      get: function get() {
        return imageExistsForTocFromDescription() || _xmpModel.containsTocThumbnails;
      }
    },
    tocThumbImageSrc: {
      get: function get() {
        if (imageExistsForTocFromDescription()) {
          return playerConfiguration.tocModelFromDescription.items[0].image;
        } else if (playerConfiguration.getTOCSpriteSrc()) {
          return playerConfiguration.getTOCSpriteSrc();
        } else if (!urlService.isUrlAbsolute(_xmpModel.tocThumbnailImageSrc)) {
          return playerConfiguration.getContentBase() + playerConfiguration.getUnicodeSafeString(_xmpModel.tocThumbnailImageSrc);
        }
        return playerConfiguration.getUnicodeSafeString(_xmpModel.tocThumbnailImageSrc);
      }
    }
  });
};
var Xmp = {
  /**
   *  Factory method that returns a new XmpModel object.
   *  @function create
   *  @memberof TSC.XmpModel
   *  @static
   *  @return new XmpModel instance
   */
  create: XmpModel
};

var NullSmartPlayerView = function NullSmartPlayerView() {
  var noOp = function noOp() {}; // eslint-disable-line

  return Object.defineProperties({
    loadMedia: noOp,
    destroy: noOp,
    play: noOp,
    pause: noOp,
    isInFullScreenMode: noOp,
    addEventListener: noOp,
    removeEventListener: noOp,
    addMediaEventListener: noOp,
    removeMediaEventListener: noOp,
    getCaptionsVisible: noOp,
    setCaptionsVisible: noOp,
    getScrubbing: noOp,
    setScrubbing: noOp,
    triggerVideoStartEventCallbacks: noOp,
    getSafeSeekTime: noOp
  }, {
    initializedPromise: {
      get: function get() {
        return Promise.resolve();
      }
    },
    currentSrc: {
      get: function get() {
        return undefined;
      }
    },
    currentTime: {
      get: function get() {
        return 0;
      },
      set: noOp
    },
    duration: {
      get: function get() {
        return 0;
      }
    },
    paused: {
      get: function get() {
        return false;
      }
    },
    volume: {
      get: function get() {
        return 1;
      },
      set: noOp
    },
    muted: {
      get: function get() {
        return false;
      },
      set: noOp
    },
    playbackRate: {
      get: function get() {
        return 1;
      },
      set: noOp
    },
    ended: {
      get: function get() {
        return false;
      }
    },
    seeking: {
      get: function get() {
        return false;
      }
    },
    buffered: {
      get: function get() {
        return [];
      }
    },
    played: {
      get: function get() {
        return [];
      }
    },
    seekable: {
      get: function get() {
        return [];
      }
    }
  });
};
var NullSmartPlayerView$1 = {
  create: NullSmartPlayerView
};

var uuidGenerator = function uuidGenerator() {
  // src: http://slavik.meltser.info/the-efficient-way-to-create-guid-uuid-in-javascript-with-explanation/
  var _p8 = function _p8(s) {
    var p = (Math.random().toString(16) + '000000000').substr(2, 8);
    return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
  };
  return _p8() + _p8(true) + _p8(true) + _p8();
};
var uuidGenerator$1 = {
  getUUID: uuidGenerator
};

var _analyticsCategory = null;
var getCategory = function getCategory() {
  return _analyticsCategory;
};
var setCategory = function setCategory(analyticsCategory) {
  _analyticsCategory = analyticsCategory;
};
var initGoogleAnalytics = function initGoogleAnalytics() {
  log.logMessage('Built in Google Analytics has been removed');
};
var sendEvent = function sendEvent(action, label, value) {
  if (_analyticsCategory === null) {
    log.logMessage('AnalyticsService :: Could not send analytics event, no category was set');
    return;
  }
  var customEventCallback = playerConfiguration.getCustomEventCallback();
  if (playerConfiguration.getCustomEventTracking() && typeof customEventCallback === 'function') {
    var eventCategory = playerConfiguration.getAltEventCategoryAsFilename() ? playerConfiguration.getMediaFileName() : _analyticsCategory;
    customEventCallback({
      category: eventCategory,
      action: action,
      label: label,
      value: value
    });
  }
};
var sendGA4Event = function sendGA4Event(eventName, eventParams) {
  if (playerConfiguration.ga4EventCallback && typeof playerConfiguration.ga4EventCallback === 'function') {
    playerConfiguration.ga4EventCallback({
      eventName: eventName,
      eventParams: eventParams
    });
  }
};
var analyticsService = {
  getCategory: getCategory,
  setCategory: setCategory,
  initGoogleAnalytics: initGoogleAnalytics,
  sendEvent: sendEvent,
  sendGA4Event: sendGA4Event
};

var haveEnoughDataTimeoutInMilliseconds = 20000;
var EVENT_DELAY_TIME_MILLISECONDS = 100;
var EVENT_TIME_DIFF_TO_REMOVE_FROM_QUEUE = 200;
var readyStates = {
  HAVE_NOTHING: 0,
  // No information is available about the media resource.
  HAVE_METADATA: 1,
  // Enough of the media resource has been retrieved that the metadata attributes are initialized. Seeking will no longer raise an exception.
  HAVE_CURRENT_DATA: 2,
  // Data is available for the current playback position, but not enough to actually play more than one frame.
  HAVE_FUTURE_DATA: 3,
  // Data for the current playback position as well as for at least a little bit of time into the future is available (in other words, at least two frames of video, for example).
  HAVE_ENOUGH_DATA: 4 // Enough data is available—and the download rate is high enough—that the media can be played through to the end without interruption.
};

/**
 *  @memberof TSC
 *  @class VideoPlaybackQualityMetrics
 *  @classdesc Utility to monitor and report on how video is streaming
 *  @param {TSC.VideoElementView} videoElementView - Video element view
 *  @param {Function} triggerRumDataEventCallback - callback function for rum timing events
 *  @param {Function} eventLabelSuffixRetriever - function for retrieving event label suffix (optional)
 *  @param {TSC.playerState} playerState - player state
 */
var VideoPlaybackQualityMetrics = function VideoPlaybackQualityMetrics(videoElementView, triggerRumDataEventCallback, eventLabelSuffixRetriever, playerState) {
  var _readyStateHasAtLeastEnoughDataOnce = false;
  var _readyStateHasEnoughDataAfterSeeked = false;
  var _timeToReachFirstHaveEnoughData = -1;
  var _videoLoadStartTimeInMilliseconds = -1;
  var _uniqueID = uuidGenerator$1.getUUID();
  var _mediaLocation = windowWrapper.getLocation();
  var _eventListeners = {};
  var _currentReadyState = null;
  var _isSeeking = false;
  var _playingEventShouldFireAfterStalled = false; // workaround for Safari annoyance
  var _mediaElement = videoElementView.mediaElement;
  var _eventLabel = null;
  var _queuedEvents = [];
  var _sendEventsDelayID = -1;
  eventLabelSuffixRetriever = eventLabelSuffixRetriever || function () {
    return '';
  };
  var setEventLabel = function setEventLabel(eventLabel) {
    _eventLabel = eventLabel;
  };
  var getEventLabel = function getEventLabel() {
    var id = _eventLabel ? _eventLabel : 'UUID_' + _uniqueID;
    return id + '__' + _mediaLocation;
  };
  var triggerShowVideoBufferingViewEvent = function triggerShowVideoBufferingViewEvent() {
    _playingEventShouldFireAfterStalled = true;
    if (_eventListeners[events.Controls.ShowVideoBufferingView]) {
      _eventListeners[events.Controls.ShowVideoBufferingView]();
    }
  };
  var triggerHideVideoBufferingView = function triggerHideVideoBufferingView() {
    _playingEventShouldFireAfterStalled = false;
    if (_eventListeners[events.Controls.HideVideoBufferingView]) {
      _eventListeners[events.Controls.HideVideoBufferingView]();
    }
  };
  var sendQueuedEvents = function sendQueuedEvents() {
    _queuedEvents.forEach(function (queuedEvent) {
      analyticsService.sendEvent(queuedEvent.event.type, queuedEvent.event.label, queuedEvent.event.value);
      analyticsService.sendGA4Event(queuedEvent.ga4Event.eventName, queuedEvent.ga4Event.eventParams);
    });
    _queuedEvents = [];
  };
  var checkVideoReadyState = function checkVideoReadyState(currentReadyState) {
    // workaround for Safari not dispatching 'playing' event as expected
    if (_playingEventShouldFireAfterStalled && !_mediaElement.paused && !_isSeeking && currentReadyState >= readyStates.HAVE_ENOUGH_DATA) {
      triggerHideVideoBufferingView();
    }
    if (currentReadyState === _currentReadyState) {
      return;
    }
    var previousReadyState = _currentReadyState;
    _currentReadyState = currentReadyState;
    if (previousReadyState === readyStates.HAVE_ENOUGH_DATA && _currentReadyState < readyStates.HAVE_FUTURE_DATA && !_mediaElement.ended && _readyStateHasEnoughDataAfterSeeked && !playerState.pausedForQuiz) {
      var eventLabel = getEventLabel();
      eventLabel += eventLabelSuffixRetriever();
      var eventTime = performance.now();
      _queuedEvents.push({
        time: eventTime,
        event: {
          type: events.Analytics.PlaybackWasStoppedToBuffer,
          label: eventLabel,
          value: 1
        },
        ga4Event: {
          eventName: events.GA4.PlaybackWasStoppedToBuffer,
          eventParams: {
            video_session_id: eventLabel // eslint-disable-line
          }
        }
      });
      triggerShowVideoBufferingViewEvent();
    }
    if (_currentReadyState === readyStates.HAVE_ENOUGH_DATA) {
      if (_timeToReachFirstHaveEnoughData === -1) {
        performanceWrapper.createMeasure(events.Timing.VideoHasEnoughData, events.Timing.VideoHasEnoughData);
        triggerRumDataEventCallback([events.Timing.VideoHasEnoughData]);
        _timeToReachFirstHaveEnoughData = window.performance.now() - _videoLoadStartTimeInMilliseconds;
      }
      _readyStateHasAtLeastEnoughDataOnce = true;
      _readyStateHasEnoughDataAfterSeeked = true;
    }
    if (_sendEventsDelayID !== -1) {
      clearTimeout(_sendEventsDelayID);
    }
    _sendEventsDelayID = setTimeout(sendQueuedEvents, EVENT_DELAY_TIME_MILLISECONDS);
  };
  var onStalledEventHandler = function onStalledEventHandler(e) {
    if (e.target && e.target.readyState !== undefined) {
      checkVideoReadyState(e.target.readyState);
    }
  };
  var onProgressEventHandler = function onProgressEventHandler(e) {
    if (e.target && e.target.readyState !== undefined) {
      checkVideoReadyState(e.target.readyState);
    }
  };
  var removeStoppedToBufferEventIfNeeded = function removeStoppedToBufferEventIfNeeded() {
    var time = performance.now();
    for (var i = _queuedEvents.length - 1; i >= 0; i--) {
      if (time - _queuedEvents[i].time <= EVENT_TIME_DIFF_TO_REMOVE_FROM_QUEUE) {
        _queuedEvents.splice(i, 1);
      }
    }
  };
  var onVideoSeekingHandler = function onVideoSeekingHandler(e) {
    removeStoppedToBufferEventIfNeeded();
    if (!_isSeeking) {
      _isSeeking = true;
      _readyStateHasEnoughDataAfterSeeked = false;
      triggerShowVideoBufferingViewEvent();
      if (e.target && e.target.readyState !== undefined) {
        checkVideoReadyState(e.target.readyState);
      }
    }
  };
  var onVideoSeekedHandler = function onVideoSeekedHandler(e) {
    if (e.target && e.target.readyState !== undefined) {
      checkVideoReadyState(e.target.readyState);
    }
    triggerHideVideoBufferingView();
    _isSeeking = false;
  };
  var onVideoWaitingHandler = function onVideoWaitingHandler(e) {
    if (e.target && e.target.readyState !== undefined) {
      checkVideoReadyState(e.target.readyState);
    }
  };
  var onVideoTimeUpdateHandler = function onVideoTimeUpdateHandler(e) {
    if (e.target && e.target.readyState !== undefined) {
      checkVideoReadyState(e.target.readyState);
    }
  };
  var onVideoLoadStartHandler = function onVideoLoadStartHandler() {
    performanceWrapper.createMarker(events.Timing.VideoMetadataLoaded);
    performanceWrapper.createMarker(events.Timing.VideoLoadedData);
    performanceWrapper.createMarker(events.Timing.VideoCanPlay);
    performanceWrapper.createMarker(events.Timing.VideoHasEnoughData);
    _videoLoadStartTimeInMilliseconds = window.performance.now();
    window.setTimeout(function () {
      if (!_readyStateHasAtLeastEnoughDataOnce) {
        analyticsService.sendEvent(events.Analytics.CouldNotPlaySmoothlyIn20Secs, getEventLabel());
        analyticsService.sendGA4Event(events.GA4.CouldNotPlaySmoothlyIn20Secs, {
          video_session_id: getEventLabel() // eslint-disable-line
        });
      }
    }, haveEnoughDataTimeoutInMilliseconds);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoLoadStart, onVideoLoadStartHandler);
  };
  var onVideoMetadataLoadedHandler = function onVideoMetadataLoadedHandler() {
    _mediaElement.removeEventListener(events.ExternalVideo.VideoLoadedMetadata, onVideoMetadataLoadedHandler);
    performanceWrapper.createMeasure(events.Timing.VideoMetadataLoaded, events.Timing.VideoMetadataLoaded);
    triggerRumDataEventCallback([events.Timing.VideoMetadataLoaded]);
  };
  var onVideoLoadedDataHandler = function onVideoLoadedDataHandler() {
    _mediaElement.removeEventListener(events.ExternalVideo.VideoLoadedData, onVideoLoadedDataHandler);
    performanceWrapper.createMeasure(events.Timing.VideoLoadedData, events.Timing.VideoLoadedData);
    triggerRumDataEventCallback([events.Timing.VideoLoadedData]);
  };
  var onVideoCanPlayHandler = function onVideoCanPlayHandler() {
    _mediaElement.removeEventListener(events.ExternalVideo.VideoCanPlay, onVideoCanPlayHandler);
    performanceWrapper.createMeasure(events.Timing.VideoCanPlay, events.Timing.VideoCanPlay);
    triggerRumDataEventCallback([events.Timing.VideoCanPlay]);
  };
  var onVideoDurationChange = function onVideoDurationChange() {
    removeStoppedToBufferEventIfNeeded();
    _currentReadyState = null;
    _readyStateHasAtLeastEnoughDataOnce = false;
    _readyStateHasEnoughDataAfterSeeked = false;
  };
  var onMediaPlayingEventHandler = function onMediaPlayingEventHandler() {
    if (_isSeeking) {
      return;
    }
    triggerHideVideoBufferingView();
  };
  var addMediaEvents = function addMediaEvents() {
    videoElementView.addEventListener(events.Controls.ShowVideoBufferingView, triggerShowVideoBufferingViewEvent);
    videoElementView.addEventListener(events.Controls.HideVideoBufferingView, triggerHideVideoBufferingView);
    _mediaElement.addEventListener(events.ExternalVideo.VideoLoadStart, onVideoLoadStartHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoLoadedMetadata, onVideoMetadataLoadedHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoLoadedData, onVideoLoadedDataHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoCanPlay, onVideoCanPlayHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoSeeking, onVideoSeekingHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoSeeked, onVideoSeekedHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoWaiting, onVideoWaitingHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoTimeUpdate, onVideoTimeUpdateHandler);
    _mediaElement.addEventListener(events.ExternalVideo.VideoDurationChange, onVideoDurationChange);
    _mediaElement.addEventListener(events.Media.Progress, onProgressEventHandler);
    _mediaElement.addEventListener(events.Media.Stalled, onStalledEventHandler);
    _mediaElement.addEventListener(events.Media.Playing, onMediaPlayingEventHandler);
  };
  var addEventListener = function addEventListener(eventName, eventHandler) {
    _eventListeners[eventName] = eventHandler;
  };
  var removeEventListener = function removeEventListener(eventName) {
    _eventListeners[eventName] = undefined;
  };
  var destroy = function destroy() {
    videoElementView.removeEventListener(events.Controls.ShowVideoBufferingView);
    videoElementView.removeEventListener(events.Controls.HideVideoBufferingView);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoLoadStart, onVideoLoadStartHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoLoadedMetadata, onVideoMetadataLoadedHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoLoadedData, onVideoLoadedDataHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoCanPlay, onVideoCanPlayHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoSeeking, onVideoSeekingHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoSeeked, onVideoSeekedHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoWaiting, onVideoWaitingHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoTimeUpdate, onVideoTimeUpdateHandler);
    _mediaElement.removeEventListener(events.ExternalVideo.VideoDurationChange, onVideoDurationChange);
    _mediaElement.removeEventListener(events.Media.Progress, onProgressEventHandler);
    _mediaElement.removeEventListener(events.Media.Stalled, onStalledEventHandler);
    _mediaElement.removeEventListener(events.Media.Playing, onMediaPlayingEventHandler);
  };
  addMediaEvents();
  return Object.defineProperties({
    addEventListener: addEventListener,
    removeEventListener: removeEventListener,
    setEventLabel: setEventLabel,
    destroy: destroy
  }, {});
};

/**
 *  Factory method that returns a new VideoPlaybackQualityMetrics object.
 *  @memberof TSC.VideoPlaybackQualityMetrics
 *  @function create
 *  @static
 *  @param {TSC.VideoElementView} videoElementView - Video element view
 *  @param {Function} triggerRumDataEventCallback - callback function for rum timing events
 *  @param {Function} eventLabelSuffixRetriever - function for retrieving event label suffix (optional)
 *  @param {TSC.playerState} playerState - player state
 *  @return new VideoPlaybackQualityMetrics instance
 */
var VideoPlaybackQualityMetrics$1 = {
  create: VideoPlaybackQualityMetrics
};

var tabIndex = Object.freeze({
  Disabled: -1,
  DomOrder: 0
});

// pulled from https://gist.github.com/WebReflection/df05641bd04954f6d366
var escape = function escape(s) {
  if (typeof s !== 'string') {
    return s;
  }
  var escaped = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
  };
  return s.replace(/[&<>'"]/g, function (m) {
    return escaped[m];
  });
};

var audioDescriptionButtonTemplate = function audioDescriptionButtonTemplate(_ref) {
  var accessBtnAudioDescription = _ref.accessBtnAudioDescription,
    audioDescriptionIndex = _ref.audioDescriptionIndex;
  return "<button class=\"audio-description-button ui control-button tertiary-button\" name=\"AudioDescriptionButton\" type=\"button\" title=\"".concat(accessBtnAudioDescription, "\" tabindex=\"").concat(audioDescriptionIndex, "\" aria-pressed=\"false\">\n   <span class=\"ui audio-description-button-glyph\"></span>\n</button>");
};

var audioDescriptionTrackTemplate = function audioDescriptionTrackTemplate(_ref) {
  var audioDescriptionTrackSrc = _ref.audioDescriptionTrackSrc;
  return "<audio class=\"audio-description-track\" muted src=\"".concat(audioDescriptionTrackSrc, "\" preload=\"auto\"></audio>");
};

var beforeAfterPlayControlsTemplate = function beforeAfterPlayControlsTemplate(_ref) {
  var playButtonIndex = _ref.playButtonIndex,
    playIndex = _ref.playIndex,
    accessBtnClickToPlay = _ref.accessBtnClickToPlay,
    replayButtonIndex = _ref.replayButtonIndex,
    replayIndex = _ref.replayIndex,
    accessBtnClickToReplay = _ref.accessBtnClickToReplay;
  return "<div class=\"video-click-to-play-link\" tabindex=\"".concat(playButtonIndex, "\">\n    <button type=\"button\" class=\"video-click-to-play ui play-button-overlay-glyph\" tabindex=\"").concat(playIndex, "\" aria-label=\"").concat(accessBtnClickToPlay, "\" data-cy=\"video-click-to-play\"></button>\n</div>\n<div class=\"video-click-to-replay-link\" tabindex=\"").concat(replayButtonIndex, "\">\n    <button type=\"button\" class=\"video-click-to-replay ui replay-button-overlay-glyph\" tabindex=\"").concat(replayIndex, "\" aria-label=\"").concat(accessBtnClickToReplay, "\"></button>\n</div>\n<div class=\"before-after-plugin-container\"></div>");
};

var captionsButtonTemplate = function captionsButtonTemplate(_ref) {
  var accessBtnClosedCaption = _ref.accessBtnClosedCaption,
    closedCaptionIndex = _ref.closedCaptionIndex;
  return "<button class=\"closed-caption-button ui control-button tertiary-button\" name=\"ClosedCaption\" type=\"button\" title=\"".concat(accessBtnClosedCaption, "\" tabindex=\"").concat(closedCaptionIndex, "\">\n   <span class=\"ui closed-caption-button-glyph\"></span>\n</button>");
};

var choiceAnswerTemplate = function choiceAnswerTemplate(_ref) {
  var questionText = _ref.questionText,
    answers = _ref.answers,
    placeHolderImg = _ref.placeHolderImg,
    focusableAnswerInput = _ref.focusableAnswerInput;
  return "<form onsubmit=\"return false;\">\n   <fieldset>\n     <legend class=\"sr-only\">".concat(questionText, "</legend>\n     ").concat(answers.map(function (_ref2) {
    var answer = _ref2.answer,
      answerIndex = _ref2.answerIndex,
      isChecked = _ref2.isChecked;
    return "<label class=\"multiple-choice active-question-item\">\n        <img src='".concat(placeHolderImg, "' class='image-feedback feedback-placeholder' alt='' />\n        <input type=\"radio\" ").concat(answerIndex === 0 ? "class=\"".concat(focusableAnswerInput, "\"") : '', " name=\"multiple-choice\" value=\"").concat(answerIndex, "\" ").concat(isChecked ? 'checked' : '', " />\n        <span class=\"multiple-choice-answer-text\">").concat(answer, "</span>\n     </label>");
  }).join(''), "\n   </fieldset>\n </form>");
};

var fillAnswerTemplate = function fillAnswerTemplate(_ref) {
  var questionText = _ref.questionText,
    inputId = _ref.inputId,
    inputLabel = _ref.inputLabel,
    placeHolderImg = _ref.placeHolderImg,
    inputName = _ref.inputName,
    userResponse = _ref.userResponse,
    useAutofocus = _ref.useAutofocus,
    focusableAnswerInput = _ref.focusableAnswerInput;
  return "<form onsubmit=\"return false;\">\n   <fieldset>\n      <legend class=\"sr-only\">".concat(questionText, "</legend>\n      <label for=\"").concat(inputId, "\" class=\"sr-only float-element-left\">").concat(inputLabel, "</label>\n      <div class=\"fill-in-and-short-answer-answer-container\">\n         <img src='").concat(placeHolderImg, "' class='image-feedback feedback-placeholder' aria-hidden=\"true\" alt=\"\" />\n         <input type=\"text\" id=\"").concat(inputId, "\" class=\"fill-in-the-blank-input ").concat(focusableAnswerInput, "\" maxlength=\"140\" name=\"").concat(inputName, "\" value=\"").concat(userResponse ? userResponse : '', "\" autocomplete=\"off\" ").concat(useAutofocus ? 'autofocus' : '', " />\n      </div>\n   </fieldset>\n</form>");
};

var fullscreenControlTemplate = function fullscreenControlTemplate(_ref) {
  var accessBtnFullScreen = _ref.accessBtnFullScreen,
    fullscreenIndex = _ref.fullscreenIndex;
  return "<button name=\"FullScreen\" type=\"button\" aria-pressed=\"false\" class=\"ui control-button tertiary-button fullscreen-button\" title=\"".concat(accessBtnFullScreen, "\" tabindex=\"").concat(fullscreenIndex, "\">\n   <span class=\"ui fullscreen-button-glyph\"></span>\n</button>");
};

var screenReaderAlertTemplate = function screenReaderAlertTemplate(_ref) {
  var screenReaderAlertText = _ref.screenReaderAlertText;
  return "<div class=\"sr-only alert-only\" role=\"alert\">".concat(screenReaderAlertText, "</div>')");
};

var hotspotViewTemplate = function hotspotViewTemplate(_ref) {
  var hotspotContainerWidth = _ref.hotspotContainerWidth,
    hotspotContainerHeight = _ref.hotspotContainerHeight,
    hotspotIndex = _ref.hotspotIndex,
    displayHotspotsShape = _ref.displayHotspotsShape,
    hotspotDescriptionId = _ref.hotspotDescriptionId,
    hotspotDescription = _ref.hotspotDescription,
    hotspotLinkClassName = _ref.hotspotLinkClassName,
    hotspotCoordinatesSeparationBySpace = _ref.hotspotCoordinatesSeparationBySpace;
  return "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n     width=\"100%\" height=\"100%\"\n     viewBox=\"0 0 ".concat(hotspotContainerWidth, " ").concat(hotspotContainerHeight, "\"\n     version=\"1.1\"\n     data-hotspot-index=\"").concat(hotspotIndex, "\"\n     focusable=\"false\"\n     tabindex=\"-1\"\n     ").concat(displayHotspotsShape ? 'class="display-hotspots-shape"' : '', "\n   <desc id=\"").concat(hotspotDescriptionId, "\">").concat(hotspotDescription, "</desc>\n   <a xlink:href=\"#\" class=\"").concat(hotspotLinkClassName, "\" role=\"link\" tabindex=\"0\" focusable=\"true\" aria-labelledby=\"").concat(hotspotDescriptionId, "\" data-hotspot-index=\"").concat(hotspotIndex, "\">\n      <polygon points=\"").concat(hotspotCoordinatesSeparationBySpace, "\" data-hotspot-index=\"").concat(hotspotIndex, "\"></polygon>\n   </a>\n</svg>");
};

var hotspotsTemplate = function hotspotsTemplate(_ref) {
  var hotspotsContainerId = _ref.hotspotsContainerId;
  return "<div id=\"".concat(hotspotsContainerId, "\" class=\"hotspots\"></div>");
};

var videoViewTemplate = function videoViewTemplate(_ref) {
  var videoTagUniqueId = _ref.videoTagUniqueId;
  return "\n   <div class=\"audio-description-track-wrapper\"></div>\n   <div class=\"media-container\">\n      <div id=\"".concat(videoTagUniqueId, "\" class=\"video-div\"></div>\n      <div class=\"youtube-pointer-event-workaround hide\"></div>\n      <div class=\"hotspots-container\"></div>\n      <div class=\"media-plugin-container\"></div>\n      <div class=\"play-pause-state\">\n         <div class=\"play-state-indicator-container\">\n            <div class=\"ui play-pause-state-indicator\"></div>\n         </div>\n      </div>\n   </div>\n   <div class=\"caption hide\">\n      <p class=\"hide\"></p>\n   </div>\n");
};

var imageViewTemplate = function imageViewTemplate(_ref) {
  var mediaTagUniqueId = _ref.mediaTagUniqueId;
  return "\n<div id=\"".concat(mediaTagUniqueId, "\" class=\"media-container image-container\" aria-hidden=\"true\">\n   <div class=\"image-div\">\n      <img class=\"smart-player-image-media\" />\n   </div>\n   <div class=\"media-plugin-container\"></div>\n</div>");
};

var ioOverlayViewTemplate = function ioOverlayViewTemplate(_ref) {
  var loaderImg = _ref.loaderImg,
    loaderAltText = _ref.loaderAltText;
  return "<div style=\"display:none\" class=\"tsc-io-container\">\n    <div class=\"tsc-io-message\">\n        <span role=\"status\" aria-live=\"polite\"></span>\n        <img src=\"".concat(loaderImg, "\" alt=\"").concat(loaderAltText, "\" aria-hidden=\"true\"/>\n    </div>\n</div>");
};

var messageBarViewTemplate = function messageBarViewTemplate(_ref) {
  var messageText = _ref.messageText,
    primaryActionButtonText = _ref.primaryActionButtonText;
  return "<div role=\"alert\" class=\"message-bar-view-container\">\n   <div class=\"message-bar-view-content-container\">\n      <span class=\"message-bar-text-container\">".concat(messageText, "</span>\n      ").concat(primaryActionButtonText ? "<button class=\"button button-cta message-bar-action-button\">".concat(primaryActionButtonText, "</button>") : '', "\n   </div>\n</div>");
};

var openExternalLinkTemplate = function openExternalLinkTemplate(_ref) {
  var screenReaderAlertText = _ref.screenReaderAlertText,
    headerText = _ref.headerText,
    link = _ref.link,
    subHeaderText = _ref.subHeaderText,
    replayText = _ref.replayText,
    openButtonScreenReaderText = _ref.openButtonScreenReaderText,
    visitSiteText = _ref.visitSiteText;
  return "<div class=\"open-external-link-content\">\n   <span class=\"sr-only\" role=\"status\" aria-live=\"polite\">".concat(screenReaderAlertText, "</span>\n   <div class=\"open-external-link-text\">").concat(headerText, "</div>\n   <div class=\"open-external-link-text link-text\" title=").concat(link, ">").concat(link, "</div>\n   ").concat(subHeaderText ? "<div class=\"open-external-link-text\">".concat(subHeaderText, "</div>") : '', "\n   <div class=\"open-external-link-actions\">\n      <div class=\"button-and-text-container\">\n         <div class=\"open-external-link-button-container\">\n            <button role=\"button\" aria-label=\"").concat(replayText, "\" class=\"open-external-link-replay ui open-external-link-replay-glyph\"></button>\n         </div>\n         <div class=\"open-external-link-text\">").concat(replayText, "</div>\n      </div>\n      <div class=\"button-and-text-container\">\n         <div class=\"open-external-link-button-container\">\n            <button role=\"button\" class=\"open-external-link-open ui open-external-link-open-glyph\" aria-label=\"").concat(openButtonScreenReaderText, "\" title=\"").concat(link, "\"></button>\n         </div>\n         <div class=\"open-external-link-text\">").concat(visitSiteText, "</div>\n      </div>\n   </div>\n</div>");
};

var pipControlTemplate = function pipControlTemplate(_ref) {
  var accessBtnPip = _ref.accessBtnPip,
    pipButtonIndex = _ref.pipButtonIndex;
  return "<button name=\"PIP\" type=\"button\" role=\"button\" aria-pressed=\"false\" class=\"ui control-button tertiary-button pip-button\" title=\"".concat(accessBtnPip, "\" tabindex=\"").concat(pipButtonIndex, "\">\n   <span class=\"ui pip-button-glyph\"></span>\n</button>");
};

var playRewindControlsTemplate = function playRewindControlsTemplate(_ref) {
  var accessBtnPlay = _ref.accessBtnPlay,
    playIndex = _ref.playIndex,
    accessBtnRewind = _ref.accessBtnRewind,
    rewindIndex = _ref.rewindIndex,
    accessBtnForward = _ref.accessBtnForward,
    forwardIndex = _ref.forwardIndex;
  return "<button type=\"button\" name=\"Play\" aria-pressed=\"false\" class=\"ui control-button tertiary-button play-control\" title=\"".concat(accessBtnPlay, "\" tabindex=\"").concat(playIndex, "\">\n    <span class=\"ui play-button-glyph\"></span>\n    <span class=\"ui pause-button-glyph\"></span>\n</button>\n<button type=\"button\" name=\"Rewind\" class=\"ui control-button tertiary-button rewind-control\" title=\"").concat(accessBtnRewind, "\" tabindex=\"").concat(rewindIndex, "\">\n   <span class=\"ui rewind-button-glyph\"></span>\n</button>\n<button type=\"button\" name=\"Forward\" class=\"ui control-button tertiary-button forward-control\" title=\"").concat(accessBtnForward, "\" tabindex=\"").concat(forwardIndex, "\">\n   <span class=\"ui forward-button-glyph\"></span>\n</button>");
};

var preRollContainerTemplate = function preRollContainerTemplate(_ref) {
  var preRollSizeClass = _ref.preRollSizeClass,
    preRollSrc = _ref.preRollSrc;
  return "<iframe id=\"pre_roll_container\" class=\"preRoll preRollHidden ".concat(preRollSizeClass, "\" src=\"").concat(preRollSrc, "\" scrolling=\"no\"  frameborder=\"0\"></iframe>");
};

var prevNextControlsTemplate = function prevNextControlsTemplate(_ref) {
  var accessBtnPrevious = _ref.accessBtnPrevious,
    previousIndex = _ref.previousIndex,
    accessBtnNext = _ref.accessBtnNext,
    nextIndex = _ref.nextIndex;
  return "<button type=\"button\" name=\"Previous\" class=\"ui disabled-button control-button tertiary-button previous-control\" aria-disabled=\"false\" title=\"".concat(accessBtnPrevious, "\" tabindex=\"").concat(previousIndex, "\">\n   <span class=\"ui previous-button-glyph\"></span>\n</button>\n<button type=\"button\" name=\"Next\" class=\"ui control-button tertiary-button next-control\" aria-disabled=\"false\" title=\"").concat(accessBtnNext, "\" tabindex=\"").concat(nextIndex, "\">\n   <span class=\"ui next-button-glyph\"></span>\n</button>");
};

var progressBarControlTemplate = function progressBarControlTemplate(_ref) {
  var progressIndex = _ref.progressIndex,
    accessBtnProgressBar = _ref.accessBtnProgressBar;
  return "<div class=\"plugin-container\"></div>\n<div class=\"progress-scrubbar-track\" role=\"slider\" tabindex=\"".concat(progressIndex, "\" aria-label=\"").concat(accessBtnProgressBar, "\">\n   <div class=\"ui scrubbar-track\"></div>\n   <div class=\"markers\"></div>\n   <div class=\"scrub-preview\">\n      <div class=\"scrub-details\">\n         <canvas class=\"video-thumbnail\"></canvas>\n         <div class=\"hidden-video-thumbnail\">\n            <div class=\"hidden-glyph\"></div>\n         </div>\n         <span class=\"chapter-name\"></span>\n         <span class=\"video-time\"></span>\n      </div>\n   </div>\n</div>");
};

var progressBarChapterSegmentTemplate = function progressBarChapterSegmentTemplate(_ref) {
  var chapterIndex = _ref.chapterIndex;
  return "<div class=\"progress-bar-chapter\" data-chapter-index=\"".concat(chapterIndex, "\">\n   <div class=\"ui scrubbar-background-track\"></div>\n   <div class=\"ui scrubbar-loaded-track load-progress\"></div>\n   <div class=\"ui scrubbar-seek-hint-track seek-hint-progress\"></div>\n   <div class=\"ui scrubbar-played-track play-progress\"></div>\n</div>");
};

var questionCountTemplate = function questionCountTemplate(_ref) {
  var questionCountText = _ref.questionCountText;
  return "<p>".concat(questionCountText, "</p>");
};

var questionSetConfirmationTemplate = function questionSetConfirmationTemplate(_ref) {
  var title = _ref.title,
    alertText = _ref.alertText,
    reviewText = _ref.reviewText,
    confirmationText = _ref.confirmationText;
  return "<div class=\"start-question-set-confirmation-container\" role=\"alertdialog\" aria-label=\"".concat(title, "\" aria-describedby=\"questionSetConfirmationAlert\">\n   <p id=\"questionSetConfirmationAlert\" class=\"sr-only alert-only\">").concat(alertText, "</p>\n   <button type=\"button\" class=\"review-button button button-secondary fill-parent top-button-element button-taller\" data-cy=\"review-quiz-button\">").concat(reviewText, "</button>\n   <button type=\"button\" class=\"confirm-button button button-primary fill-parent button-taller\" data-cy=\"confirm-quiz-button\">").concat(confirmationText, "</button>\n   <div class=\"chat-bubble-arrow\"></div>\n</div>");
};

var questionSetReviewConfirmationTemplate = function questionSetReviewConfirmationTemplate(_ref) {
  var title = _ref.title,
    alertText = _ref.alertText,
    numberCorrect = _ref.numberCorrect,
    percentCorrect = _ref.percentCorrect,
    numberInCorrect = _ref.numberInCorrect,
    percentInCorrect = _ref.percentInCorrect,
    reviewAnswerText = _ref.reviewAnswerText,
    continueText = _ref.continueText;
  return "<div class=\"review-confirmation-container\" role=\"alertdialog\" aria-label=\"".concat(title, "\" aria-describedby=\"questionSetReviewConfirmationAlert\">\n   ").concat(alertText ? " <p id=\"questionSetReviewConfirmationAlert\" class=\"sr-only alert-only\">".concat(alertText, "</p>") : '', "\n   ").concat(numberCorrect ? "<div class=\"results-summary\">\n           <div class=\"results-container correct-result\"><span class=\"result-label\">".concat(numberCorrect, "</span> <span class=\"calculated-percentage\">").concat(percentCorrect, "</span></div>\n           <div class=\"results-container incorrect-result\"><span class=\"result-label\">").concat(numberInCorrect, "</span> <span class=\"calculated-percentage\">").concat(percentInCorrect, "</span></div>\n       </div>") : '', "\n    <div class=\"controls-container\">\n        <button type=\"button\" class=\"review-answers-button button button-secondary fill-parent top-button-element\">").concat(reviewAnswerText, "</button>\n        <button type=\"button\" class=\"continue-video-button button button-primary fill-parent\">").concat(continueText, "</button>\n    </div>\n    <div class=\"chat-bubble-arrow\"></div>\n</div>");
};

var questionSetReviewStatusTemplate = function questionSetReviewStatusTemplate(_ref) {
  var questionSetResultsTabIndex = _ref.questionSetResultsTabIndex,
    txtAnswersSubmitted = _ref.txtAnswersSubmitted,
    gradeableDetails = _ref.gradeableDetails,
    unGradeableDetails = _ref.unGradeableDetails,
    txtViewAnswers = _ref.txtViewAnswers,
    txtHideAnswers = _ref.txtHideAnswers;
  return "<div class=\"question-set-container\">\n   <div class=\"question-set-results\" tabindex=\"".concat(questionSetResultsTabIndex, "\">\n      <div class=\"results-title\">").concat(txtAnswersSubmitted, "</div>\n      <div class=\"gradeable-details\">").concat(gradeableDetails, "</div>\n      <div class=\"ungradeable-details\">").concat(unGradeableDetails, "</div>\n      <button type=\"button\" class=\"view-answers-button button button-primary\">").concat(txtViewAnswers, "</button>\n      <button type=\"button\" class=\"hide-answers-button button button-secondary\">").concat(txtHideAnswers, "</button>\n   </div>\n   <div class=\"chat-bubble-arrow\"></div>\n</div>");
};

var questionSetTemplate = function questionSetTemplate(_ref) {
  var submittingImg = _ref.submittingImg,
    submittingImgAltText = _ref.submittingImgAltText,
    previousQuestionButtonA11yText = _ref.previousQuestionButtonA11yText,
    previousButtonName = _ref.previousButtonName,
    nextQuestionButtonA11yText = _ref.nextQuestionButtonA11yText,
    nextButtonName = _ref.nextButtonName,
    submitButtonName = _ref.submitButtonName,
    continueButtonName = _ref.continueButtonName,
    hideQuizA11yText = _ref.hideQuizA11yText,
    hideQuizText = _ref.hideQuizText,
    showQuizText = _ref.showQuizText,
    quizTime = _ref.quizTime,
    quizAtTimeHeading = _ref.quizAtTimeHeading,
    videoId = _ref.videoId;
  return "<div class=\"question-set-container\">\n    <div class=\"submitting-response-container\">\n        <span class=\"submitting-text\">Submitting...</span>\n        <img class=\"loading-image\" src=\"".concat(submittingImg, "\" alt=\"").concat(submittingImgAltText, "\"/>\n    </div>\n    <section class=\"question-set-content\" aria-labelledby=\"").concat(videoId, "-quiz-header\">\n        <h1 id=\"").concat(videoId, "-quiz-header\" class=\"sr-only\">").concat(quizAtTimeHeading, " ").concat(quizTime, "</h1>\n        <div class=\"question-content-container\" aria-live=\"assertive\" aria-atomic=\"true\">\n           <div class=\"question-header\">\n             <div class=\"question-status-container\">\n                <div class=\"question-count\"></div>\n             </div>\n             <div class=\"question-text\"></div>\n          </div>\n          <div class=\"question-feedback hide-element\"></div>\n       </div>\n       <div class=\"question-answers\"></div>\n       <div class=\"question-set-controls\">\n          <button type=\"button\" class=\"previous-button button button-secondary\" aria-label=\"").concat(previousQuestionButtonA11yText, "\" disabled=\"disabled\">").concat(previousButtonName, "</button>\n          <button type=\"button\" class=\"next-button button button-secondary\" aria-label=\"").concat(nextQuestionButtonA11yText, "\" disabled=\"disabled\">").concat(nextButtonName, "</button>\n          <button type=\"button\" class=\"submit-button button button-primary\" disabled=\"disabled\">").concat(submitButtonName, "</button>\n          <button type=\"button\" class=\"continue-button button button-primary\" disabled=\"disabled\">").concat(continueButtonName, "</button>\n       </div>\n       <div class=\"question-badge-container\">\n          <div class=\"question-graded-status\"></div>\n          <button type=\"button\" aria-label=\"").concat(hideQuizA11yText, "\" class=\"hide-quiz-button button button-secondary\">").concat(hideQuizText, "</button>\n       </div>\n    </section>\n   <div class=\"minimized-question-set-container hide-element\">\n      <button class=\"show-quiz-button button button-primary\">").concat(showQuizText, "</button>\n   </div>\n</div>");
};

var questionTextTemplate = function questionTextTemplate(_ref) {
  var questionText = _ref.questionText,
    correctAnswerText = _ref.correctAnswerText;
  return "<div>\n   <p>".concat(questionText, "</p>\n   ").concat(correctAnswerText ? "<span class=\"sr-only\">".concat(correctAnswerText, "</span>") : '', "\n</div>");
};

var questionFeedbackContextTextTemplate = function questionFeedbackContextTextTemplate(_ref) {
  var questionFeedbackContextText = _ref.questionFeedbackContextText;
  return "<span class=\"sr-only\">".concat(questionFeedbackContextText, "</span>");
};

var questionGradedStatusTemplate = function questionGradedStatusTemplate(_ref) {
  var correctTextString = _ref.correctTextString,
    incorrectTextString = _ref.incorrectTextString;
  return "<div class=\"question-grade-status-text question-correct-text hide-element\">".concat(correctTextString, "</div>\n<div class=\"question-grade-status-text question-incorrect-text hide-element\">").concat(incorrectTextString, "</div>\n");
};

var settingsViewTemplate = function settingsViewTemplate(_ref) {
  var accessBtnSettings = _ref.accessBtnSettings,
    settingsIndex = _ref.settingsIndex,
    playerRateText = _ref.playerRateText,
    speedSettingIndex = _ref.speedSettingIndex,
    playbackRates = _ref.playbackRates,
    hasMultipleLanguages = _ref.hasMultipleLanguages,
    ccLanguageText = _ref.ccLanguageText,
    ccLanguageSettingIndex = _ref.ccLanguageSettingIndex,
    ccLanguages = _ref.ccLanguages,
    accessBtnAudioDescription = _ref.accessBtnAudioDescription,
    audioDescriptionMediaSrc = _ref.audioDescriptionMediaSrc,
    captionsExist = _ref.captionsExist,
    accessPlayerSettingsClose = _ref.accessPlayerSettingsClose,
    acknowledgementLinkName = _ref.acknowledgementLinkName,
    acknowledgmentUrl = _ref.acknowledgmentUrl;
  return "<button name=\"Settings\" type=\"button\" class=\"settings-button ui control-button tertiary-button\" title=\"".concat(accessBtnSettings, "\" tabindex=\"").concat(settingsIndex, "\" aria-expanded=\"false\">\n   <span class=\"ui settings-button-glyph\"></span>\n</button>\n<div class=\"player-settings-container ui\">\n   <div class=\"acknowledgment-container-modal\">\n      <a href=\"").concat(acknowledgmentUrl, "\" class=\"settings-acknowledgementlink\" target=\"_blank\" referrerpolicy=\"no-referrer\">").concat(acknowledgementLinkName, "</a>\n   </div>\n   <div class=\"setting-header-container\">\n      <span class=\"setting-text-large\">").concat(accessBtnSettings, "</span>\n      <button class=\"settings-close-button\" aria-label=\"").concat(accessPlayerSettingsClose, "\">\n         <span class=\"ui close-button-glyph\"></span>\n      </button>\n   </div>\n   ").concat(audioDescriptionMediaSrc ? " <div class=\"setting-container toggle-container audio-description-setting\">\n      <span class=\"setting-text\">".concat(accessBtnAudioDescription, "</span>\n      <label class=\"settings-select toggle\">\n         <input type=\"checkbox\" class=\"ad-toggle\" aria-label=\"").concat(accessBtnAudioDescription, "\">\n         <span class=\"slider round\"></span>\n      </label>\n   </div>") : '', "\n   ").concat(hasMultipleLanguages ? "<div class=\"setting-container\">\n      <span class=\"setting-text\">".concat(ccLanguageText, "</span>\n      <select tabindex=\"").concat(ccLanguageSettingIndex, "\" aria-label=\"").concat(ccLanguageText, "\" class=\"settings-select cc-language-select\">\n         ").concat(ccLanguages.map(function (_ref2) {
    var selected = _ref2.selected,
      languageValue = _ref2.languageValue,
      languageLabel = _ref2.languageLabel;
    return "<option class=\"cc-language-option\" ".concat(selected ? 'selected' : '', " value=\"").concat(languageValue, "\" tabindex=\"-1\">").concat(languageLabel, "</option>");
  }).join(''), "\n      </select>\n   </div>") : '', "\n   <div class=\"setting-container toggle-container closed-caption-setting ").concat(!captionsExist ? 'hide' : '', "\">\n      <span class=\"setting-text\">").concat(ccLanguageText, "</span>\n      <label class=\"settings-select toggle\">\n         <input type=\"checkbox\" class=\"cc-toggle\" aria-label=\"").concat(ccLanguageText, "\">\n         <span class=\"slider round\"></span>\n      </label>\n   </div>\n   <div class=\"setting-container\">\n      <span class=\"setting-text\">").concat(playerRateText, "</span>\n      <select tabindex=\"").concat(speedSettingIndex, "\" aria-label=\"").concat(playerRateText, "\" class=\"settings-select player-speed-select\">\n         ").concat(playbackRates.map(function (_ref3) {
    var selected = _ref3.selected,
      rateValue = _ref3.rateValue,
      rateLabel = _ref3.rateLabel;
    return "<option class=\"player-speed-option\" ".concat(selected ? 'selected' : '', " value=\"").concat(rateValue, "\" tabindex=\"-1\">").concat(rateLabel, "</option>");
  }).join(''), "\n      </select>\n   </div>\n   <div class=\"acknowledgment-container-panel\">\n      <a href=\"").concat(acknowledgmentUrl, "\" class=\"settings-acknowledgementlink\" target=\"_blank\" referrerpolicy=\"no-referrer\">").concat(acknowledgementLinkName, "</a>\n   </div>\n</div>");
};

var shortAnswerTemplate = function shortAnswerTemplate(_ref) {
  var questionText = _ref.questionText,
    inputId = _ref.inputId,
    inputLabel = _ref.inputLabel,
    inputName = _ref.inputName,
    useAutofocus = _ref.useAutofocus,
    userResponse = _ref.userResponse,
    focusableAnswerInput = _ref.focusableAnswerInput;
  return "<form onsubmit=\"return false;\">\n   <fieldset>\n      <legend class=\"sr-only\">".concat(questionText, "</legend>\n      <label for=\"").concat(inputId, "\" class=\"sr-only\">").concat(inputLabel, "</label>\n      <div class=\"fill-in-and-short-answer-answer-container\">\n         <textarea name=\"").concat(inputName, "\" id=\"").concat(inputId, "\" class=\"short-answer-input ").concat(focusableAnswerInput, "\" maxlength=\"2000\" rows=\"5\" ").concat(useAutofocus ? 'autofocus' : '', ">").concat(userResponse ? userResponse : '', "</textarea>\n      </div>\n   </fieldset>\n</form>");
};

var tocButtonTemplate = function tocButtonTemplate(_ref) {
  var accessBtnTableOfContents = _ref.accessBtnTableOfContents,
    tocIndex = _ref.tocIndex;
  return "<button class=\"toc-button ui control-button tertiary-button\" name=\"TableOfContents\" type=\"button\" title=\"".concat(accessBtnTableOfContents, "\" tabindex=\"").concat(tocIndex, "\" data-cy=\"toc-toggle-button\">\n   <span class=\"ui toc-button-glyph\"></span>\n</button>");
};

var tocItemTemplate = function tocItemTemplate(_ref) {
  var showText = _ref.showText,
    centerContent = _ref.centerContent,
    dataTocTime = _ref.dataTocTime,
    dataFileText = _ref.dataFileText,
    tocItemRawText = _ref.tocItemRawText,
    tocItemIndex = _ref.tocItemIndex,
    showThumbnail = _ref.showThumbnail,
    tocItemText = _ref.tocItemText;
  return "<li class=\"toc-list-item\" role=\"listitem\">\n   <button class=\"toc-item ".concat(showText ? 'limit-max-toc-item-height' : '', " ").concat(centerContent ? 'center-flex-content' : '', "\" ").concat(dataTocTime, " ").concat(dataFileText, " aria-label=\"").concat(tocItemRawText, "\" tabindex=\"").concat(tocItemIndex, "\">\n      ").concat(showThumbnail ? '<canvas class="thumbnail-placeholder"></canvas>' : '', "\n      ").concat(showText ? "<span class=\"toc-item-text\">\n            ".concat(tocItemText, "\n         </span>") : '', "\n   </button>\n</li>");
};

var tocTemplate = function tocTemplate(_ref) {
  var searchLabel = _ref.searchLabel,
    msgSearch = _ref.msgSearch,
    tocSearchIndex = _ref.tocSearchIndex,
    searchOrJumpTo = _ref.searchOrJumpTo,
    accessBtnClearSearch = _ref.accessBtnClearSearch,
    tocEraseIndex = _ref.tocEraseIndex,
    msgSearchIsDisabledInFS = _ref.msgSearchIsDisabledInFS;
  return "<div class=\"toc-head-container\">\n     <div class=\"toc-pip-image-container\"></div>\n     <h2 class=\"toc-media-title\"></h2>\n     <div class=\"toc-search-container\">\n         <div class=\"ui toc-search-glyph\"></div>\n         <label class=\"toc-search-input-label\">".concat(searchLabel, "\n             <input type=\"text\" class=\"toc-search-input\" placeholder=\"").concat(msgSearch, "\" tabindex=\"").concat(tocSearchIndex, "\" aria-label=\"").concat(searchOrJumpTo, "\"/>\n         </label>\n         <button class=\"ui clear-search-button\" name=\"ClearSearch\" type=\"button\" title=\"").concat(accessBtnClearSearch, "\" tabindex=\"").concat(tocEraseIndex, "\"></button>\n     </div>\n     <div class=\"toc-full-screen-search-alert\">\n         <p>").concat(msgSearchIsDisabledInFS, "</p>\n     </div>\n </div>\n <div class=\"toc-content-scroll-container\">\n     <h3 class=\"sr-only\" id=\"tocContentScreenReaderLabel\"></h3>\n     <ol class=\"toc-content-container\" role=\"directory\" aria-labelledby=\"tocContentScreenReaderLabel\"></ol>\n </div>");
};

var volumeControlTemplate = function volumeControlTemplate(_ref) {
  var accessBtnVolume = _ref.accessBtnVolume,
    volumeIndex = _ref.volumeIndex,
    accessVolumeSlider = _ref.accessVolumeSlider;
  return "<button type=\"button\" title=\"".concat(accessBtnVolume, "\" class=\"volume ui volume-button-high-glyph control-button tertiary-button\" tabindex=\"").concat(volumeIndex, "\"></button>\n<div class=\"volume-slider-container volume-slider-hidden\">\n   <div class=\"volume-slider-track\"></div>\n   <div class=\"button volume-slider\" role=\"slider\" aria-label=\"").concat(accessVolumeSlider, "\"></div>\n</div>");
};

var alertModalViewTemplate = function alertModalViewTemplate(_ref) {
  var screenReaderAlertText = _ref.screenReaderAlertText,
    modalTitle = _ref.modalTitle,
    closeModalButtonTitle = _ref.closeModalButtonTitle,
    modalContent = _ref.modalContent,
    dismissButtonText = _ref.dismissButtonText,
    confirmButtonText = _ref.confirmButtonText;
  return "<div class=\"alert-modal-view\">\n    <div class=\"modal-overlay\"></div>\n    <span class=\"sr-only\" role=\"status\" aria-live=\"polite\">".concat(screenReaderAlertText, "</span>\n    <div class=\"alert-modal-container\">\n        <div class=\"modal-header\"><h2>").concat(modalTitle, "</h2>\n           ").concat(closeModalButtonTitle ? "<button class=\"close-model-button button button-icon\" title=\"".concat(closeModalButtonTitle, "\" type=\"button\">\n                   <span class=\"sr-only\">").concat(closeModalButtonTitle, "</span>\n                   <span class=\"glyph\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" tabindex=\"-1\">\n                        <path d=\"M10.12 8l4.24-4.24a1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 0L8 5.88 3.76 1.64a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L5.88 8l-4.24 4.24a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 1.41 0L8 10.12l4.24 4.24a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41z\"></path>\n                    </svg>\n                </span>\n               </button>") : '', "\n        </div>\n        <div class=\"modal-body\">").concat(modalContent, "</div>\n        <div class=\"modal-footer\">\n            <div class=\"modal-button-group\">\n                <button class=\"dismiss-alert-button button button-tertiary\" aria-label=\"{{dismissButtonScreenReaderText}}\" type=\"button\"><span>").concat(dismissButtonText, "</span></button>\n                <button class=\"confirm-alert-button button button-secondary\" aria-label=\"{{confirmButtonScreenReaderText}}\" type=\"button\"><span>").concat(confirmButtonText, "</span></button>\n            </div>\n        </div>\n    </div>\n</div>");
};

var scormNavigationBarTemplate = function scormNavigationBarTemplate(_ref) {
  var isPrimaryButton = _ref.isPrimaryButton,
    completeSessionButtonLabel = _ref.completeSessionButtonLabel;
  return "<div class=\"scorm-navigation-bar\">\n   <h1 class=\"scorm-module-title\"></h1>\n   <button class=\"button ".concat(isPrimaryButton ? 'button-primary' : 'button-secondary', " complete-scorm-session-button\">").concat(completeSessionButtonLabel, "</button>\n</div>");
};

var scormConfirmCompleteModalTemplate = function scormConfirmCompleteModalTemplate(_ref) {
  var screenReaderAlertText = _ref.screenReaderAlertText,
    confirmText = _ref.confirmText,
    dismissButtonScreenReaderText = _ref.dismissButtonScreenReaderText,
    dismissButtonText = _ref.dismissButtonText,
    isDestructiveButton = _ref.isDestructiveButton,
    confirmButtonScreenReaderText = _ref.confirmButtonScreenReaderText,
    confirmButtonText = _ref.confirmButtonText;
  return "<div class=\"scorm-confirm-complete-modal-view\">\n   <div class=\"modal-overlay\"></div>\n   <span class=\"sr-only\" role=\"status\" aria-live=\"polite\">".concat(screenReaderAlertText, "</span>\n   <div class=\"scorm-confirm-complete-modal-container\">\n      <div class=\"modal-body\">").concat(confirmText, "</div>\n      <div class=\"modal-button-group\">\n         <button class=\"dismiss-complete-button button button-secondary\" aria-label=\"").concat(dismissButtonScreenReaderText, "\" type=\"button\"><span>").concat(dismissButtonText, "</span></button>\n         <button class=\"confirm-complete-button button ").concat(isDestructiveButton ? 'button-destructive' : 'button-primary', "\" aria-label=\"").concat(confirmButtonScreenReaderText, "\" type=\"button\"><span>").concat(confirmButtonText, "</span></button>\n      </div>\n   </div>\n</div>");
};

var scormSessionEndedTemplate = function scormSessionEndedTemplate(_ref) {
  var screenReaderAlertText = _ref.screenReaderAlertText,
    scormSessionEndedText = _ref.scormSessionEndedText;
  return "<div class=\"scorm-session-complete-container\">\n   <span class=\"sr-only\" role=\"status\" aria-live=\"polite\">".concat(screenReaderAlertText, "</span>\n   <span>").concat(scormSessionEndedText, "</span>\n</div>");
};

var videoSeekingSpinnerViewTemplate = function videoSeekingSpinnerViewTemplate() {
  return "<div style=\"display:none\" class=\"video-seeking-spinner-container\">\n   <div class=\"video-seeking-spinner\">\n      <svg class=\"spinner-svg\" viewBox=\"0 0 80 80\" xmlns=\"http://www.w3.org/2000/svg\" >\n         <circle class=\"spinner-circle\" cx=\"40\" cy=\"40\" r=\"35\"/>\n      </svg>\n   </div>\n</div>";
};

var playerLayoutTemplate = function playerLayoutTemplate(_ref) {
  var videoWrapperIndex = _ref.videoWrapperIndex;
  return "\n<div class=\"scorm-module-navigation-container\"></div>\n<div class=\"media-wrapper video-wrapper click-controls hide\" tabindex=\"".concat(videoWrapperIndex, "\"></div>\n<div class=\"ui control-backdrop video-controls-container hide\">\n   <div class=\"progress-bar-control\"></div>\n   <div class=\"player-controls\">\n      <div class=\"bottom-controls primary-controls\">\n         <div class=\"play-rewind-controls\"></div>\n         <div class=\"prev-next-controls\"></div>\n         <div class=\"volume-wrapper\"></div>\n         <div class=\"play-time\" aria-hidden=\"true\">0:00 / 0:00</div>\n      </div>\n      <div class=\"bottom-controls secondary-controls\">\n         <div class=\"audio-description-control-wrapper\"></div>\n         <div class=\"caption-wrapper\"></div>\n         <div class=\"toc-button-wrapper\"></div>\n         <div class=\"toc-container\"></div>\n         <div class=\"player-settings-wrapper\"></div>\n         <div class=\"pip-wrapper\"></div>\n         <div class=\"theater-mode-wrapper\"></div>\n         <div class=\"fullscreen-wrapper\"></div>\n      </div>\n   </div>\n</div>\n<div class=\"before-after-play-controls\"></div>\n<div class=\"scorm-confirm-complete-modal-wrapper\"></div>\n<div class=\"scorm-session-ended-wrapper\"></div>\n<div class=\"open-external-link\"></div>\n<div class=\"player-plugin-container\"></div>\n");
};

var theaterModeButtonTemplate = function theaterModeButtonTemplate(_ref) {
  var accessBtnTheaterMode = _ref.accessBtnTheaterMode,
    theaterModeIndex = _ref.theaterModeIndex;
  return "<button class=\"theater-mode-button ui control-button tertiary-button\" name=\"TheaterMode\" type=\"button\" title=\"".concat(accessBtnTheaterMode, "\" tabindex=\"").concat(theaterModeIndex, "\">\n   <span class=\"ui theater-mode-button-glyph\"></span>\n</button>");
};

var timecodeDelimiter = ':';
var maxSupportTimecodePlaces = 3;
var secondsMultiplier = 60;
var millisecondsMultiplier = 1000;
var padIfNecessary = function padIfNecessary(num) {
  return num >= 10 ? num : "0".concat(num);
};
var getHourMinuteSecondsFromTimeInSeconds = function getHourMinuteSecondsFromTimeInSeconds(timeInSeconds) {
  timeInSeconds = Math.round(timeInSeconds);
  var hours = Math.floor(timeInSeconds / 3600);
  var secondsWithoutHours = timeInSeconds % 3600;
  var minutes = Math.floor(secondsWithoutHours / 60);
  var seconds = secondsWithoutHours % 60;
  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};
var formatTime = function formatTime(timeInSeconds) {
  var timeComponents = getHourMinuteSecondsFromTimeInSeconds(timeInSeconds);
  if (timeComponents.hours > 0) {
    return "".concat(timeComponents.hours, ":").concat(padIfNecessary(timeComponents.minutes), ":").concat(padIfNecessary(timeComponents.seconds));
  } else if (timeComponents.minutes > 0) {
    return "".concat(timeComponents.minutes, ":").concat(padIfNecessary(timeComponents.seconds));
  }
  return "0:".concat(padIfNecessary(timeComponents.seconds));
};
var formatTimeForReadability = function formatTimeForReadability(timeInSeconds) {
  var timeComponents = getHourMinuteSecondsFromTimeInSeconds(timeInSeconds);
  return localizationStrings.getReadableTimeByLocale(timeComponents.hours, timeComponents.minutes, timeComponents.seconds);
};
var formatTimeForCmiTimespan = function formatTimeForCmiTimespan(timeInSeconds) {
  var timeComponents = getHourMinuteSecondsFromTimeInSeconds(timeInSeconds);
  return "".concat(padIfNecessary(timeComponents.hours), ":").concat(padIfNecessary(timeComponents.minutes), ":").concat(padIfNecessary(timeComponents.seconds));
};
var formatTimeAsTimeInterval = function formatTimeAsTimeInterval(timeInSeconds) {
  var timeComponents = getHourMinuteSecondsFromTimeInSeconds(timeInSeconds);
  var timeInterval = 'PT';
  if (timeComponents.hours > 0) {
    timeInterval += timeComponents.hours + 'H';
  }
  if (timeComponents.minutes > 0) {
    timeInterval += timeComponents.minutes + 'M';
  }
  timeInterval += timeComponents.seconds + 'S';
  return timeInterval;
};
var convertTimecodeToMilliseconds = function convertTimecodeToMilliseconds(timecode) {
  if (!timecode || typeof timecode !== 'string') {
    return 0;
  }
  var timeInSeconds = 0;
  var multiplier = 1;
  var timecodeParts = timecode.split(timecodeDelimiter);
  var lowTimeBounds = timecodeParts.length > maxSupportTimecodePlaces ? timecodeParts.length - maxSupportTimecodePlaces : 0;
  for (var i = timecodeParts.length - 1; i >= lowTimeBounds; i--) {
    var timePartAsNumber = parseInt(timecodeParts[i], 10);
    if (!isNaN(timePartAsNumber)) {
      timeInSeconds += timePartAsNumber * multiplier;
    }
    multiplier *= secondsMultiplier;
  }
  return timeInSeconds * millisecondsMultiplier;
};
var timeFormatter = {
  /**
   *  Utility function for formatting a number seconds into a user-readable duration
   *  @function formatTime
   *  @memberof TSC.timeFormatter
   *  @static
   *  @param {Number} totalSeconds - numbers of seconds to format
   *  @returns {String} time formatted as string (ex: 132 would return '02:12')
   */
  formatTime: formatTime,
  /**
   *  Utility function for formatting a number seconds into a human readable string
   *  @function formatTimeForReadability
   *  @memberof TSC.timeFormatter
   *  @static
   *  @param {Number} totalSeconds - numbers of seconds to format
   *  @returns {String} seconds formatted as string (ex: 132 would return '2 minutes and 12 seconds')
   */
  formatTimeForReadability: formatTimeForReadability,
  /**
   *  Utility function for formatting number of seconds into CMI timespan format used for SCORM 1.2 reporting
   *  @function formatTimeForCmiTimespan
   *  @memberof TSC.timeFormatter
   *  @static
   *  @param {Number} totalSeconds - numbers of seconds to format
   *  @returns {String} time formatted as CMI Timespan (ex: 132 would return '00:02:12')
   */
  formatTimeForCmiTimespan: formatTimeForCmiTimespan,
  /**
   *  Utility function for formatting number of seconds into Time Interval format used for SCORM 2004 reporting
   *  @function formatTimeAsTimeInterval
   *  @memberof TSC.timeFormatter
   *  @static
   *  @param {Number} totalSeconds - numbers of seconds to format
   *  @returns {String} time formatted as Time Interval (Ex: 132 would return 'PT2M12S')
   */
  formatTimeAsTimeInterval: formatTimeAsTimeInterval,
  /**
   *  Utility function will take a timecode string and return the time in milliseconds.
   *  @function convertTimecodeToMilliseconds
   *  @memberof TSC.timeFormatter
   *  @static
   *  @param {String} timecode - String timecode HH:MM:SS (ex: 01:12:33)
   *  @returns {Number} time in milliseconds
   */
  convertTimecodeToMilliseconds: convertTimecodeToMilliseconds
};

var LOADER_IMG = 'data:image/gif;base64,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';
var PLACEHOLDER_GLYPH_DATA_URL = 'data:image/png;base64,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';
var SUBMITTING_GLYPH_DATA_URL = 'data:image/gif;base64,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';
var _videoId;
var generateAudioDescriptionButtonMarkup = function generateAudioDescriptionButtonMarkup() {
  return audioDescriptionButtonTemplate({
    accessBtnAudioDescription: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnAudioDescription)),
    fullscreenIndex: tabIndex.DomOrder
  });
};
var generateAudioDescriptionTrackMarkup = function generateAudioDescriptionTrackMarkup(audioDescriptionMediaSrc) {
  return audioDescriptionTrackTemplate({
    audioDescriptionTrackSrc: escape(audioDescriptionMediaSrc)
  });
};
var generateBeforeAfterPlayControlsMarkup = function generateBeforeAfterPlayControlsMarkup() {
  var templateContext = {
    playIndex: tabIndex.DomOrder,
    replayIndex: tabIndex.DomOrder,
    playButtonIndex: tabIndex.DomOrder,
    replayButtonIndex: tabIndex.DomOrder,
    accessBtnClickToPlay: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPlay)),
    accessBtnClickToReplay: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnClickToReplayLink))
  };
  return beforeAfterPlayControlsTemplate(templateContext);
};
var generateCaptionsButtonMarkup = function generateCaptionsButtonMarkup() {
  return captionsButtonTemplate({
    accessBtnClosedCaption: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnClosedCaption)),
    closedCaptionIndex: tabIndex.DomOrder
  });
};
var generateChoiceAnswersMarkup = function generateChoiceAnswersMarkup(questionText, questionAnswers, userResponse) {
  var templateContext = {};
  templateContext.questionText = escape(questionText);
  templateContext.answers = [];
  templateContext.placeHolderImg = PLACEHOLDER_GLYPH_DATA_URL;
  templateContext.focusableAnswerInput = cssClasses.focusableAnswerInput;
  questionAnswers.forEach(function (answer, index) {
    if (userResponse && index === parseInt(userResponse, 10)) {
      templateContext.answers.push({
        answerIndex: index,
        answer: escape(answer.text),
        isChecked: true
      });
    } else {
      templateContext.answers.push({
        answerIndex: index,
        answer: escape(answer.text)
      });
    }
  });
  return choiceAnswerTemplate(templateContext);
};
var generateFillInTheBlankAnswerMarkup = function generateFillInTheBlankAnswerMarkup(questionText, userResponse, autoFocus) {
  var templateContext = {};
  templateContext.questionText = escape(questionText);
  templateContext.inputLabel = 'Fill in question answer';
  templateContext.inputId = 'fill-in-the-blank-input';
  templateContext.inputName = 'fill-in-the-blank-input';
  templateContext.placeHolderImg = PLACEHOLDER_GLYPH_DATA_URL;
  templateContext.userResponse = escape(userResponse);
  templateContext.focusableAnswerInput = cssClasses.focusableAnswerInput;
  if (autoFocus) {
    templateContext.useAutofocus = 'true';
  }
  return fillAnswerTemplate(templateContext);
};
var generateFullscreenControlMarkup = function generateFullscreenControlMarkup(buttonTitle) {
  return fullscreenControlTemplate({
    accessBtnFullScreen: escape(buttonTitle),
    fullscreenIndex: tabIndex.DomOrder
  });
};
var generateHotspotMarkup = function generateHotspotMarkup(hotspotContainerWidth, hotspotContainerHeight, hotspotIndex, descriptionId, hotspotDescription, hotspotShape, hotspotCoordinatesSeparationBySpace, hotspotLinkClassName) {
  return hotspotViewTemplate({
    hotspotContainerWidth: hotspotContainerWidth,
    hotspotContainerHeight: hotspotContainerHeight,
    hotspotIndex: hotspotIndex,
    hotspotDescriptionId: escape(descriptionId),
    hotspotDescription: escape(hotspotDescription),
    displayHotspotsShape: hotspotShape,
    hotspotCoordinatesSeparationBySpace: hotspotCoordinatesSeparationBySpace,
    hotspotLinkClassName: escape(hotspotLinkClassName)
  });
};
var generateScreenReaderAlertMarkup = function generateScreenReaderAlertMarkup(screenReaderAlertText) {
  return screenReaderAlertTemplate({
    screenReaderAlertText: escape(screenReaderAlertText)
  });
};
var generateHotspotsMarkup = function generateHotspotsMarkup(hotspotsContainerId) {
  return hotspotsTemplate({
    hotspotsContainerId: escape(hotspotsContainerId),
    hotspotsAltText: escape(localizationStrings.getPlayerString(playerStringNames.txtHotspot))
  });
};
var generateVideoViewMarkup = function generateVideoViewMarkup(videoTagUniqueId) {
  _videoId = videoTagUniqueId;
  return videoViewTemplate({
    videoTagUniqueId: escape(videoTagUniqueId)
  });
};
var generateImageMarkup = function generateImageMarkup(mediaTagUniqueId) {
  return imageViewTemplate({
    mediaTagUniqueId: escape(mediaTagUniqueId)
  });
};
var generateIoOverlayMarkup = function generateIoOverlayMarkup() {
  return ioOverlayViewTemplate({
    loaderImg: LOADER_IMG,
    loaderAltText: escape(localizationStrings.getPlayerString(playerStringNames.videoLoading))
  });
};
var generateMessageBarMarkup = function generateMessageBarMarkup(messageText, primaryActionButtonText) {
  return messageBarViewTemplate({
    messageText: messageText,
    primaryActionButtonText: escape(primaryActionButtonText)
  });
};
var generateOpenExternalLinkMarkup = function generateOpenExternalLinkMarkup(link) {
  return openExternalLinkTemplate({
    link: escape(link),
    replayText: escape(localizationStrings.getPlayerString(playerStringNames.txtReplayVideo)),
    visitSiteText: escape(localizationStrings.getPlayerString(playerStringNames.txtVisitSite)),
    headerText: escape(localizationStrings.getPlayerString(playerStringNames.txtOpenLinkHeader)),
    subHeaderText: escape(localizationStrings.getPlayerString(playerStringNames.txtOpenLinkSubHeader)),
    screenReaderAlertText: escape(localizationStrings.getPlayerString(playerStringNames.confirmOpenUrlModalScreenReaderAlertText).replace('URL_TOKEN', link)),
    openButtonScreenReaderText: escape(localizationStrings.getPlayerString(playerStringNames.confirmOpenUrlConfirmButtonScreenReaderText))
  });
};
var generatePipControlMarkup = function generatePipControlMarkup(buttonTitle) {
  return pipControlTemplate({
    accessBtnPip: escape(buttonTitle),
    pipButtonIndex: tabIndex.DomOrder
  });
};
var generatePlayRewindControlsMarkup = function generatePlayRewindControlsMarkup(skipDuration) {
  return playRewindControlsTemplate({
    accessBtnRewind: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnRewind).replace('{{duration}}', skipDuration)),
    accessBtnForward: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnForward).replace('{{duration}}', skipDuration)),
    accessBtnPlay: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPlay)),
    rewindIndex: tabIndex.DomOrder,
    playIndex: tabIndex.DomOrder,
    forwardIndex: tabIndex.DomOrder
  });
};
var generatePlayerLayoutMarkup = function generatePlayerLayoutMarkup() {
  return playerLayoutTemplate({
    videoWrapperIndex: tabIndex.Disabled
  });
};
var generatePreRollMarkup = function generatePreRollMarkup(preRollSrc) {
  return preRollContainerTemplate({
    preRollSizeClass: 'preRoll-fullPage',
    preRollSrc: escape(preRollSrc)
  });
};
var generatePrevNextControlsMarkup = function generatePrevNextControlsMarkup() {
  return prevNextControlsTemplate({
    accessBtnPrevious: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPrevious)),
    accessBtnNext: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnNext)),
    previousIndex: tabIndex.DomOrder,
    nextIndex: tabIndex.DomOrder
  });
};
var generateProgressBarMarkup = function generateProgressBarMarkup() {
  return progressBarControlTemplate({
    progressIndex: tabIndex.DomOrder,
    accessBtnProgressBar: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnProgressBar))
  });
};
var generateProgressBarChapterSegmentMarkup = function generateProgressBarChapterSegmentMarkup(chapterIndex) {
  return progressBarChapterSegmentTemplate({
    chapterIndex: chapterIndex
  });
};
var generateQuestionTextMarkup = function generateQuestionTextMarkup(questionText, correctAnswerText) {
  var questionTextContext = {
    questionText: escape(questionText),
    correctAnswerText: escape(correctAnswerText)
  };
  return questionTextTemplate(questionTextContext);
};
var generateQuestionFeedbackContextMarkup = function generateQuestionFeedbackContextMarkup(questionFeedbackContextText) {
  var questionFeedbackContextContext = {
    questionFeedbackContextText: escape(questionFeedbackContextText)
  };
  return questionFeedbackContextTextTemplate(questionFeedbackContextContext);
};
var generateQuestionGradedStatusMarkup = function generateQuestionGradedStatusMarkup() {
  var questionGradedStatusContext = {
    correctTextString: escape(localizationStrings.getPlayerString(playerStringNames.txtCorrectString)),
    incorrectTextString: escape(localizationStrings.getPlayerString(playerStringNames.txtIncorrectString))
  };
  return questionGradedStatusTemplate(questionGradedStatusContext);
};
var generateQuestionSetMarkup = function generateQuestionSetMarkup(quizTime) {
  var context = {
    previousButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtPrev)),
    previousQuestionButtonA11yText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnPreviousQuestion)),
    nextButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtNext)),
    nextQuestionButtonA11yText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnNextQuestion)),
    submitButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtSubmit)),
    continueButtonName: escape(localizationStrings.getPlayerString(playerStringNames.txtContinue)),
    hideQuizText: escape(localizationStrings.getPlayerString(playerStringNames.txtHideQuiz)),
    hideQuizA11yText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnHideQuiz)),
    showQuizText: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnShowQuiz)),
    submittingImg: SUBMITTING_GLYPH_DATA_URL,
    submittingImgAltText: escape(localizationStrings.getPlayerString(playerStringNames.txtSubmittingAnswers)),
    quizTime: timeFormatter.formatTimeForReadability(quizTime),
    quizAtTimeHeading: escape(localizationStrings.getPlayerString(playerStringNames.quizAtTimeHeading)),
    videoId: _videoId
  };
  return questionSetTemplate(context);
};
var generateQuestionSetConfirmationMarkup = function generateQuestionSetConfirmationMarkup(reviewText, confirmationText) {
  var context = {
    reviewText: escape(reviewText),
    confirmationText: escape(confirmationText),
    title: escape(localizationStrings.getPlayerString(playerStringNames.accessQuestionSetConfirmationTitle)),
    alertText: escape(localizationStrings.getPlayerString(playerStringNames.accessVideoPausedForQuiz))
  };
  return questionSetConfirmationTemplate(context);
};
var generateQuestionSetQuestionCountMarkup = function generateQuestionSetQuestionCountMarkup(currentQuestionNumber, totalQuestions) {
  var questionCountContext = {
    questionCountText: localizationStrings.getQuestionCountString(currentQuestionNumber, totalQuestions)
  };
  return questionCountTemplate(questionCountContext);
};
var generateQuestionSetReviewConfirmationMarkup = function generateQuestionSetReviewConfirmationMarkup(numberCorrectText, percentCorrectText, numberInCorrectText, percentInCorrectText, continueText, reviewText) {
  var context = {
    title: localizationStrings.getPlayerString(playerStringNames.accessQuizResults),
    alertText: numberCorrectText ? escape("".concat(numberCorrectText, " ").concat(percentCorrectText, ". ").concat(numberInCorrectText, " ").concat(percentInCorrectText)) : null,
    numberCorrect: escape(numberCorrectText),
    percentCorrect: escape(percentCorrectText),
    numberInCorrect: numberInCorrectText,
    percentInCorrect: percentInCorrectText,
    continueText: escape(continueText),
    reviewAnswerText: escape(reviewText)
  };
  return questionSetReviewConfirmationTemplate(context);
};
var generateQuestionSetReviewStatusMarkup = function generateQuestionSetReviewStatusMarkup(gradableDetails, unGradeableDetails) {
  var context = {
    gradeableDetails: escape(gradableDetails),
    unGradeableDetails: escape(unGradeableDetails),
    txtAnswersSubmitted: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnAnswersSubmitted)),
    txtViewAnswers: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnShowAnswer)),
    txtHideAnswers: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnHideAnswer)),
    questionSetResultsTabIndex: tabIndex.DomOrder
  };
  return questionSetReviewStatusTemplate(context);
};
var generateSettingsMarkup = function generateSettingsMarkup(hasMultipleLanguages, playbackRatesList, ccLanguageList, captionsExist, audioDescriptionMediaSrc) {
  var acknowledgmentUrl = 'https://www.techsmith.com/redirect.asp?target=SmartPlayerAcknowledgementLink&ver=1.0.0&lang=enu&os=na&product=smartplayer';
  var context = {
    accessBtnSettings: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnSettings)),
    settingsIndex: tabIndex.DomOrder,
    playerRateText: escape(localizationStrings.getPlayerString(playerStringNames.playerRateText)),
    speedSettingIndex: tabIndex.DomOrder,
    playbackRates: playbackRatesList,
    hasMultipleLanguages: hasMultipleLanguages,
    ccLanguageText: escape(localizationStrings.getPlayerString(playerStringNames.ccLanguageText)),
    ccLanguageSettingIndex: tabIndex.DomOrder,
    ccLanguages: ccLanguageList,
    accessBtnAudioDescription: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnAudioDescription)),
    audioDescriptionMediaSrc: audioDescriptionMediaSrc,
    captionsExist: captionsExist,
    accessPlayerSettingsClose: escape(localizationStrings.getPlayerString(playerStringNames.accessPlayerSettingsClose)),
    acknowledgementLinkName: localizationStrings.getPlayerString(playerStringNames.acknowledgementLinkName),
    acknowledgmentUrl: acknowledgmentUrl
  };
  return settingsViewTemplate(context);
};
var generateShortAnswerMarkup = function generateShortAnswerMarkup(questionText, userResponse, autoFocus) {
  var templateContext = {};
  templateContext.questionText = escape(questionText);
  templateContext.inputLabel = 'Supply your response';
  templateContext.inputId = 'short-answer-input';
  templateContext.inputName = 'short-answer-input';
  templateContext.userResponse = escape(userResponse);
  templateContext.focusableAnswerInput = cssClasses.focusableAnswerInput;
  if (autoFocus) {
    templateContext.useAutofocus = 'true';
  }
  return shortAnswerTemplate(templateContext);
};
var generateTocMarkup = function generateTocMarkup() {
  return tocTemplate({
    searchLabel: escape(localizationStrings.getPlayerString(playerStringNames.search)),
    msgSearch: escape(localizationStrings.getPlayerString(playerStringNames.searchPlaceholder)),
    msgSearchIsDisabledInFS: escape(localizationStrings.getPlayerString(playerStringNames.searchDisabledFullScreen)),
    accessBtnClearSearch: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnClearSearch)),
    searchOrJumpTo: escape(localizationStrings.getPlayerString(playerStringNames.searchOrJumpTo)),
    tocSearchIndex: tabIndex.DomOrder,
    tocEraseIndex: tabIndex.DomOrder
  });
};
var generateTocButtonMarkup = function generateTocButtonMarkup() {
  return tocButtonTemplate({
    accessBtnTableOfContents: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnTableOfContents)),
    tocIndex: tabIndex.DomOrder
  });
};
var generateTocItemMarkup = function generateTocItemMarkup(dataTocTime, dataFileText, showThumbnail, centerContent, showText, tocText, tocRawText) {
  return tocItemTemplate({
    dataTocTime: dataTocTime,
    dataFileText: dataFileText,
    showThumbnail: showThumbnail,
    centerContent: centerContent,
    showText: showText,
    tocItemText: tocText,
    tocItemRawText: escape(tocRawText),
    tocItemIndex: tabIndex.DomOrder
  });
};
var generateVolumeControlMarkup = function generateVolumeControlMarkup(cachedVolume) {
  var VOLUME_SLIDER_MIN = 0;
  var VOLUME_SLIDER_MAX = 100;
  return volumeControlTemplate({
    accessBtnVolume: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnVolume)),
    volumeIndex: tabIndex.DomOrder,
    minVolume: VOLUME_SLIDER_MIN,
    maxVolume: VOLUME_SLIDER_MAX,
    currentVolume: cachedVolume,
    accessVolumeSlider: escape(localizationStrings.getPlayerString(playerStringNames.accessTxtVolume))
  });
};
var generateAlertModalMarkup = function generateAlertModalMarkup(screenReaderAlertText, closeModalButtonTitle, modalTitle, modalContent, dismissButtonText, dismissButtonScreenReaderText, confirmButtonText, confirmButtonScreenReaderText) {
  return alertModalViewTemplate({
    screenReaderAlertText: escape(screenReaderAlertText),
    closeModalButtonTitle: escape(closeModalButtonTitle),
    modalTitle: escape(modalTitle),
    modalContent: modalContent,
    dismissButtonText: escape(dismissButtonText),
    dismissButtonScreenReaderText: escape(dismissButtonScreenReaderText),
    confirmButtonText: escape(confirmButtonText),
    confirmButtonScreenReaderText: escape(confirmButtonScreenReaderText)
  });
};
var generateScormNavigationBarMarkup = function generateScormNavigationBarMarkup(buttonLabel, isPrimaryButton) {
  return scormNavigationBarTemplate({
    completeSessionButtonLabel: escape(buttonLabel),
    isPrimaryButton: isPrimaryButton
  });
};
var generateScormConfirmCompleteModalMarkup = function generateScormConfirmCompleteModalMarkup(screenReaderAlertText, confirmText, dismissButtonText, dismissButtonScreenReaderText, confirmButtonText, confirmButtonScreenReaderText, isDestructiveButton) {
  return scormConfirmCompleteModalTemplate({
    screenReaderAlertText: escape(screenReaderAlertText),
    confirmText: confirmText,
    dismissButtonText: escape(dismissButtonText),
    dismissButtonScreenReaderText: escape(dismissButtonScreenReaderText),
    confirmButtonText: escape(confirmButtonText),
    confirmButtonScreenReaderText: escape(confirmButtonScreenReaderText),
    isDestructiveButton: escape(isDestructiveButton)
  });
};
var generateScormSessionEndedMarkup = function generateScormSessionEndedMarkup(sessionEndedText) {
  return scormSessionEndedTemplate({
    screenReaderAlertText: escape(sessionEndedText),
    scormSessionEndedText: escape(sessionEndedText)
  });
};
var generateVideoSeekingSpinnerViewTemplateMarkup = function generateVideoSeekingSpinnerViewTemplateMarkup() {
  return videoSeekingSpinnerViewTemplate();
};
var generateTheaterModeButtonMarkup = function generateTheaterModeButtonMarkup() {
  return theaterModeButtonTemplate({
    accessBtnTheaterMode: escape(localizationStrings.getPlayerString(playerStringNames.accessBtnTheaterMode)),
    theaterModeIndex: tabIndex.DomOrder
  });
};
var templateGenerator = {
  generateAudioDescriptionButtonMarkup: generateAudioDescriptionButtonMarkup,
  generateAudioDescriptionTrackMarkup: generateAudioDescriptionTrackMarkup,
  generateBeforeAfterPlayControlsMarkup: generateBeforeAfterPlayControlsMarkup,
  generateCaptionsButtonMarkup: generateCaptionsButtonMarkup,
  generateChoiceAnswersMarkup: generateChoiceAnswersMarkup,
  generateFillInTheBlankAnswerMarkup: generateFillInTheBlankAnswerMarkup,
  generateFullscreenControlMarkup: generateFullscreenControlMarkup,
  generateHotspotMarkup: generateHotspotMarkup,
  generateScreenReaderAlertMarkup: generateScreenReaderAlertMarkup,
  generateHotspotsMarkup: generateHotspotsMarkup,
  generateVideoViewMarkup: generateVideoViewMarkup,
  generateImageMarkup: generateImageMarkup,
  generateIoOverlayMarkup: generateIoOverlayMarkup,
  generateMessageBarMarkup: generateMessageBarMarkup,
  generateOpenExternalLinkMarkup: generateOpenExternalLinkMarkup,
  generatePipControlMarkup: generatePipControlMarkup,
  generatePlayRewindControlsMarkup: generatePlayRewindControlsMarkup,
  generatePlayerLayoutMarkup: generatePlayerLayoutMarkup,
  generatePreRollMarkup: generatePreRollMarkup,
  generatePrevNextControlsMarkup: generatePrevNextControlsMarkup,
  generateProgressBarMarkup: generateProgressBarMarkup,
  generateProgressBarChapterSegmentMarkup: generateProgressBarChapterSegmentMarkup,
  generateQuestionTextMarkup: generateQuestionTextMarkup,
  generateQuestionFeedbackContextMarkup: generateQuestionFeedbackContextMarkup,
  generateQuestionGradedStatusMarkup: generateQuestionGradedStatusMarkup,
  generateQuestionSetConfirmationMarkup: generateQuestionSetConfirmationMarkup,
  generateQuestionSetQuestionCountMarkup: generateQuestionSetQuestionCountMarkup,
  generateQuestionSetMarkup: generateQuestionSetMarkup,
  generateQuestionSetReviewConfirmationMarkup: generateQuestionSetReviewConfirmationMarkup,
  generateQuestionSetReviewStatusMarkup: generateQuestionSetReviewStatusMarkup,
  generateSettingsMarkup: generateSettingsMarkup,
  generateShortAnswerMarkup: generateShortAnswerMarkup,
  generateTocButtonMarkup: generateTocButtonMarkup,
  generateTocItemMarkup: generateTocItemMarkup,
  generateTocMarkup: generateTocMarkup,
  generateVolumeControlMarkup: generateVolumeControlMarkup,
  generateAlertModalMarkup: generateAlertModalMarkup,
  generateScormNavigationBarMarkup: generateScormNavigationBarMarkup,
  generateScormConfirmCompleteModalMarkup: generateScormConfirmCompleteModalMarkup,
  generateScormSessionEndedMarkup: generateScormSessionEndedMarkup,
  generateVideoSeekingSpinnerViewTemplateMarkup: generateVideoSeekingSpinnerViewTemplateMarkup,
  generateTheaterModeButtonMarkup: generateTheaterModeButtonMarkup
};

var DISPLAY_DELAY_MILLISECONDS = 500;

/**
 *  @memberof TSC
 *  @class VideoSeekingSpinnerView
 *  @classdesc IoOverlay View
 *  @param {jQuery} $container - Top level DOM element wrapped in jQuery.
 */
var VideoSeekingSpinnerView = function VideoSeekingSpinnerView($container) {
  var _viewOpen = false;
  var _displayTimeoutId = -1;
  var markup = templateGenerator.generateVideoSeekingSpinnerViewTemplateMarkup();
  $container.append(markup);
  var _$seekingSpinnerContainer = $container.find('.video-seeking-spinner-container');
  var showViewAfterDelay = function showViewAfterDelay() {
    _displayTimeoutId = -1;
    _viewOpen = true;
    _$seekingSpinnerContainer.show();
  };
  var showView = function showView() {
    if (_viewOpen || _displayTimeoutId !== -1) {
      return;
    }
    _displayTimeoutId = window.setTimeout(showViewAfterDelay, DISPLAY_DELAY_MILLISECONDS);
  };
  var hideView = function hideView() {
    if (_displayTimeoutId !== -1) {
      window.clearTimeout(_displayTimeoutId);
      _displayTimeoutId = -1;
    }
    if (_viewOpen) {
      _viewOpen = false;
      _$seekingSpinnerContainer.hide();
    }
  };
  return Object.defineProperties({
    hideView: hideView,
    showView: showView
  }, {});
};
var VideoSeekingSpinnerView$1 = {
  /**
   *  Factory method that returns a new VideoSeekingSpinnerView object.
   *  @memberof TSC.VideoSeekingSpinnerView
   *  @function create
   *  @static
   *  @param {jQuery} $container - Top level DOM element wrapped in jQuery.
   *  @return new VideoSeekingSpinnerView instance
   */
  create: VideoSeekingSpinnerView
};

var NUMBER_MILLISECONDS_IN_SECOND = 1000;
var WEB_COMPATIBLE_CAPTION_FILE_EXT = 'vtt';
var quizController = null;
var setQuizController = function setQuizController(newQuizController) {
  quizController = newQuizController;
};
var getSafeSeekTime$1 = function getSafeSeekTime(mediaElement, timeInSeconds) {
  var timeInMilliseconds = timeInSeconds * NUMBER_MILLISECONDS_IN_SECOND;
  var questionSetMarker;
  var shouldRespectQuizMarkers = quizController && quizController.quizModel && quizController.quizEnabled && !playerConfiguration.ignoreQuizQuestions;
  if (shouldRespectQuizMarkers) {
    for (var i = 0; i < quizController.quizModel.questionSetMarkerTimes.length; i++) {
      questionSetMarker = quizController.quizModel.questionSetMarkerTimes[i];
      if (!questionSetMarker.canSeekPast && questionSetMarker.startTime < timeInMilliseconds) {
        return questionSetMarker.startTime / NUMBER_MILLISECONDS_IN_SECOND;
      }
    }
  }

  // video time bounds
  if (timeInSeconds < 0) {
    return 0;
  }
  if (timeInSeconds > mediaElement.duration) {
    return mediaElement.duration;
  }
  return timeInSeconds;
};
var calculateCanvasScale = function calculateCanvasScale(mediaView, wrapperWidth, wrapperHeight) {
  var scale = 1;
  if (mediaView.mediaWidth > 0 && wrapperWidth > 0 && wrapperHeight > 0 && mediaView.mediaHeight > 0) {
    var ratioOfWidth = wrapperWidth / mediaView.mediaWidth;
    var ratioOfHeight = wrapperHeight / mediaView.mediaHeight;
    scale = Math.min(ratioOfWidth, ratioOfHeight);
  }
  return scale;
};
var captionSrcIsWebCompatible = function captionSrcIsWebCompatible(captionSrc) {
  return captionSrc && captionSrc.toLowerCase().split('.').pop() === WEB_COMPATIBLE_CAPTION_FILE_EXT;
};
var videoApiUtils = {
  getSafeSeekTime: getSafeSeekTime$1,
  setQuizController: setQuizController,
  calculateCanvasScale: calculateCanvasScale,
  captionSrcIsWebCompatible: captionSrcIsWebCompatible
};

var AnalyticsVideoEventCategory = 'HTML5-Video';
var AnalyticsYouTubeEventCategory = 'YouTube-Video';
var AnalyticsImageEventCategory = 'Image';
var AnalyticsRumVideoCategorySuffix = '';

var playerControlsType = Object.freeze({
  none: 'none',
  video: 'video',
  videoPlaylist: 'videoPlaylist'
});

var mediaViewType = Object.freeze({
  video: 'video',
  youtube: 'youtube',
  playlist: 'playlist',
  image: 'image'
});

var CAPTION_TRACK_SHOWING = 'showing';
var CAPTION_TRACK_HIDDEN = 'hidden';
var SAFARI_VERSION_WITH_PIP_ISSUE = 13;

/**
 *  @memberof TSC
 *  @implement MediaView
 *  @class VideoElementView
 *  @classdesc HTML 5 Video element view
 *  @param {jQuery} $rootContainer - Smart Player main container jquery element
 *  @param {jQuery} $mediaContainer - Smart Player media container jquery element
 *  @param {Array} mediaSources - html5 media DOM element (or wrapper presenting same interface)
 *  @param {Boolean} includeControls - Include the built in controls for the video element
 *  @param {Function} triggerRumDataEvent - Callback function to use when triggering rum data event
 *  @param {Function} firstPlayCallback - callback function called on the first play click
 *  @param {Boolean} [includePosterIfAvailable=false] - Include the poster image if available
 */
var VideoElementView = function VideoElementView($rootContainer, $mediaContainer, mediaSources, includeControls, triggerRumDataEvent, firstPlayCallback, includePosterIfAvailable) {
  var _containsWebTrackCaptions = false;
  var _view;
  var _mediaWrapper;
  var _mediaElement;
  var _videoSeekingSpinnerView;
  var _videoPlaybackQualityMetrics;
  var _videoFirstPlayTriggered = false;
  var _$videoAndVideoSources = null;
  var _captionTrackElements = {};
  if (!includePosterIfAvailable) {
    includePosterIfAvailable = false;
  }
  var createView = function createView() {
    var videoElementMarkup = '<video';
    if (includePosterIfAvailable && playerConfiguration.getPosterImageSrc()) {
      videoElementMarkup += ' poster="' + playerConfiguration.getPosterImageSrc() + '"';
    }
    if (includeControls) {
      videoElementMarkup += ' controls';
    }
    if (deviceInfo.isIOS()) {
      videoElementMarkup += ' webkit-playsinline playsinline';
    }
    videoElementMarkup += '>';
    if (playerConfiguration.captionSrcList.length > 0) {
      playerConfiguration.captionSrcList.forEach(function (captionSrc) {
        if (videoApiUtils.captionSrcIsWebCompatible(captionSrc.src)) {
          _containsWebTrackCaptions = true;
          var languageIdentifier = LanguageIdentifier$1.create(captionSrc.languageIdentifier);
          var languageDisplayName = languageIdentifiers.identifiers[languageIdentifier.language].displayName;
          videoElementMarkup += '<track label="' + languageDisplayName + '" kind="subtitles" srclang="' + languageIdentifier.language + '" src="' + captionSrc.src + '">';
        }
      });
    }
    videoElementMarkup += playerConfiguration.getUnableToDisplayContentString() + '</video>';
    var $videoElementContainer = $mediaContainer.find('.video-div');
    $videoElementContainer.html(videoElementMarkup);
    if (deviceInfo.isSafari() && +deviceInfo.getSafariMajorVersion() >= SAFARI_VERSION_WITH_PIP_ISSUE) {
      $videoElementContainer.addClass(cssClasses.safariPipIssueFix);
    }
    _mediaWrapper = $mediaContainer.find('video');
    if (_mediaWrapper.length > 0) {
      _mediaElement = _mediaWrapper[0];
    }
    _videoSeekingSpinnerView = VideoSeekingSpinnerView$1.create($mediaContainer);
  };
  var setVideoSources = function setVideoSources() {
    var numberMediaSource = mediaSources.length;
    for (var i = 0; i < numberMediaSource; i++) {
      var source = playerConfiguration.getUnicodeSafeString(mediaSources[i].media);
      _mediaWrapper.append('<source src="' + source + '" type="' + mediaSources[i].mimeType + '" />');
    }
    bindVideoSourceEvents();
  };
  var showVideoBufferingView = function showVideoBufferingView() {
    _videoSeekingSpinnerView.showView();
  };
  var hideVideoBufferingView = function hideVideoBufferingView() {
    _videoSeekingSpinnerView.hideView();
  };
  var createPlaybackQualityMetrics = function createPlaybackQualityMetrics(view) {
    _videoPlaybackQualityMetrics = VideoPlaybackQualityMetrics$1.create(view, function (timingMeasureList) {
      triggerRumDataEvent(timingMeasureList, AnalyticsRumVideoCategorySuffix);
    }, null, $rootContainer.playerState);
    _videoPlaybackQualityMetrics.addEventListener(events.Controls.ShowVideoBufferingView, showVideoBufferingView);
    _videoPlaybackQualityMetrics.addEventListener(events.Controls.HideVideoBufferingView, hideVideoBufferingView);
  };
  var cacheCaptionTrackElements = function cacheCaptionTrackElements() {
    if (_containsWebTrackCaptions) {
      var captionTrackElements = _mediaElement.textTracks;
      for (var i = 0, numberTracks = captionTrackElements.length; i < numberTracks; i++) {
        var captionLanguage = captionTrackElements[i].language;
        _captionTrackElements[captionLanguage] = captionTrackElements[i];
      }
    }
  };
  var showCaptionTrack = function showCaptionTrack(languageIdentifier) {
    if (_captionTrackElements[languageIdentifier.language]) {
      _captionTrackElements[languageIdentifier.language].mode = CAPTION_TRACK_SHOWING;
    }
  };
  var hideCaptionTrack = function hideCaptionTrack(languageIdentifier) {
    if (_captionTrackElements[languageIdentifier.language]) {
      _captionTrackElements[languageIdentifier.language].mode = CAPTION_TRACK_HIDDEN;
    }
  };
  var onVideoErrorHandler = function onVideoErrorHandler() {
    $rootContainer.trigger(events.Media.Error, {
      errorString: localizationStrings.getPlayerString(playerStringNames.mediaNotFound)
    });
  };
  var onFirstPlayHandler = function onFirstPlayHandler() {
    if (!_videoFirstPlayTriggered) {
      firstPlayCallback();
      _videoFirstPlayTriggered = true;
      unbindVideoEvents();
    }
  };
  var unbindVideoEvents = function unbindVideoEvents() {
    _mediaElement && _mediaElement.removeEventListener(events.ExternalVideo.VideoPlay, onFirstPlayHandler);
    _mediaElement && _mediaElement.removeEventListener(events.ExternalVideo.VideoSeeking, onFirstPlayHandler);
  };
  var bindVideoEvents = function bindVideoEvents() {
    _mediaElement && _mediaElement.addEventListener(events.ExternalVideo.VideoPlay, onFirstPlayHandler);
    _mediaElement && _mediaElement.addEventListener(events.ExternalVideo.VideoSeeking, onFirstPlayHandler);
  };
  var bindVideoSourceEvents = function bindVideoSourceEvents() {
    // Selecting video and sources because ie throws errors to video and everyone to sources
    _$videoAndVideoSources = $mediaContainer.find('video, video source');
    _$videoAndVideoSources.on(events.ExternalVideo.VideoError, onVideoErrorHandler);
  };
  var processVideoEnd = function processVideoEnd() {
    return true;
  };
  var reshowVideoAfterClickToReplay = function reshowVideoAfterClickToReplay() {
    // do nothing
  };
  var destroy = function destroy() {
    unbindVideoEvents();
    _$videoAndVideoSources && _$videoAndVideoSources.off();
    _videoPlaybackQualityMetrics.destroy();
  };
  var addEventListener = function addEventListener(eventName, onEventHandler) {
  };
  var removeEventListener = function removeEventListener(eventName) {
  };
  var hotfixViewAndControlsCSS = function hotfixViewAndControlsCSS($controlsView) {}; // eslint-disable-line

  createView();
  bindVideoEvents();
  cacheCaptionTrackElements();
  _view = Object.defineProperties({
    hotfixViewAndControlsCSS: hotfixViewAndControlsCSS,
    showCaptionTrack: showCaptionTrack,
    hideCaptionTrack: hideCaptionTrack,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener,
    reshowVideoAfterClickToReplay: reshowVideoAfterClickToReplay,
    processVideoEnd: processVideoEnd,
    loadMedia: setVideoSources,
    destroy: destroy
  }, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {jQuery} mediaWrapper - jQuery wrapper of the video element.
     */
    mediaWrapper: {
      get: function get() {
        return _mediaWrapper;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {HTMLVideoElement} mediaElement - HTML video element
     */
    mediaElement: {
      get: function get() {
        return _mediaElement;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Boolean} containsWebTrackCaptions - Does the video contain web track captions?
     */
    containsWebTrackCaptions: {
      get: function get() {
        return _containsWebTrackCaptions;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Number} mediaWidth - video width
     */
    mediaWidth: {
      get: function get() {
        return _mediaElement.videoWidth;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Number} mediaHeight - video height
     */
    mediaHeight: {
      get: function get() {
        return _mediaElement.videoHeight;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {int} currentTimeInMilliseconds - The current time of the media, in milliseconds
     */
    currentTimeInMilliseconds: {
      get: function get() {
        var mediaElement = this.mediaElement;
        var currentTimeInSeconds = mediaElement.currentTime > mediaElement.duration ? mediaElement.duration : mediaElement.currentTime;
        return currentTimeInSeconds ? currentTimeInSeconds * 1000 : 0;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Boolean}  - allows dragging extension content
     */
    canDragContentOnVideo: {
      get: function get() {
        return true;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {string} playerControlType - Type of player controls to use
     */
    playerControlType: {
      get: function get() {
        return playerControlsType.video;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {string} type - Media view type
     */
    type: {
      get: function get() {
        return mediaViewType.video;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {boolean} supportsClickToPlayControls - Does view support click to play controls over media
     */
    supportsClickToPlayControls: {
      get: function get() {
        return true;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {boolean} supportsSCORM - Does view support SCORM
     */
    supportsSCORM: {
      get: function get() {
        return true;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {TSC.VideoPlaybackQualityMetrics} playbackQualityMetrics - the playback quality metrics set up for this view (may be null)
     */
    playbackQualityMetrics: {
      get: function get() {
        return _videoPlaybackQualityMetrics;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {string} currentSrc - The current source path of the media
     */
    currentSrc: {
      get: function get() {
        return _mediaElement.currentSrc;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Number} currentTime - The current time for the media
     */
    currentTime: {
      get: function get() {
        return _mediaElement.currentTime;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Number} duration - The duration of the media
     */
    duration: {
      get: function get() {
        return _mediaElement.duration;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Boolean} ended - Has the media ended
     */
    ended: {
      get: function get() {
        return _mediaElement.ended;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Boolean} paused - Is the media paused
     */
    paused: {
      get: function get() {
        return _mediaElement.paused;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Boolean} seeking - Is the media seeking
     */
    seeking: {
      get: function get() {
        return _mediaElement.seeking;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Number} volume - The volume of the media
     */
    volume: {
      get: function get() {
        return _mediaElement.volume;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Boolean} muted - Is the media muted
     */
    muted: {
      get: function get() {
        return _mediaElement.muted;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Number} playbackRate - Playback rate of the media
     */
    playbackRate: {
      get: function get() {
        return _mediaElement.playbackRate;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Array} buffered - THe array of buffered segments
     */
    buffered: {
      get: function get() {
        return _mediaElement.buffered;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Array} played - THe array of media segments that have been played
     */
    played: {
      get: function get() {
        return _mediaElement.played;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoElementView
     *  @property {Array} seekable - THe array of media segments that are seekable
     */
    seekable: {
      get: function get() {
        return _mediaElement.seekable;
      }
    }
  });
  createPlaybackQualityMetrics(_view);
  return _view;
};
var VideoElementView$1 = {
  create: VideoElementView
};

var messageBarType = Object.freeze({
  info: 'info',
  warning: 'warning'
});

var animationTimeMilliseconds = 300;

/**
 *  @memberof TSC
 *  @class MessageBarView
 *  @classdesc View to display player messages
 *  @param {jQuery} $container - jQuery element to append message bar view to.
 *  @param {String} type - Type of message bar to display
 *  @param {String} messageText - Text to display in message bar.
 *  @param {String} [primaryActionButtonText] - Text to display in action button
 *  @param {Function} [customActionButtonHandler] - Optional function to call when action button is clicked.
 */
var MessageBarView = function MessageBarView($container, type, messageText, primaryActionButtonText, customActionButtonHandler) {
  var _$messageBarContainer;
  var _$actionButton;
  var onActionClick = function onActionClick() {
    remove();
    if (customActionButtonHandler) {
      customActionButtonHandler();
    }
  };
  var showView = function showView() {
    _$messageBarContainer.stop().css('opacity', 0).show().animate({
      opacity: 1
    }, animationTimeMilliseconds);
  };
  var remove = function remove() {
    if (_$actionButton.length > 0) {
      _$actionButton.off('click');
    }
    _$messageBarContainer.remove();
  };
  var init = function init() {
    var markup = templateGenerator.generateMessageBarMarkup(messageText, primaryActionButtonText);
    $container.append(markup);
    _$messageBarContainer = $container.find('.message-bar-view-container');
    _$actionButton = _$messageBarContainer.find('.message-bar-action-button');
    if (type === messageBarType.warning) {
      _$messageBarContainer.addClass('warning');
    }
  };
  var bindEvents = function bindEvents() {
    if (_$actionButton.length > 0) {
      _$actionButton.on('click', onActionClick);
    }
  };
  init();
  bindEvents();
  showView();
  return {
    remove: remove
  };
};
var MessageBarView$1 = {
  /**
   *  Factory method that returns a new MessageBarView object.
   *  @function create
   *  @memberof TSC.MessageBarView
   *  @static
   *  @param {jQuery} $container - jQuery element to append message bar view to.
   *  @param {String} type - Type of message bar to display
   *  @param {String} messageText - Text to display in message bar.
   *  @param {String} [primaryActionButtonText] - Text to display in action button
   *  @param {Function} [customActionButtonHandler] - Optional function to call when action button is clicked.
   *  @return new MessageBarView instance
   */
  create: MessageBarView
};

var playedTracker = function playedTracker(video) {
  var mergeToleranceInSeconds = 0.5;
  // if two time updates are farther apart than this,
  // assume something like seek or replay happened, and we need a new segment
  var timeDifferenceToForceNewSegment = 5;
  var tracker = function tracker() {
    var internalPlayed = [];
    var currentMediaSegmentIndex = 0;
    var that = this;
    var seeking = false;
    var lastTimeUpdate = 0;
    this.start = function (segmentIndex) {
      if (segmentIndex < 0 || segmentIndex > internalPlayed.length - 1) {
        throw new Error('INDEX_SIZE_ERR');
      }
      return internalPlayed[segmentIndex].start;
    };
    this.end = function (segmentIndex) {
      if (segmentIndex < 0 || segmentIndex > internalPlayed.length - 1) {
        throw new Error('INDEX_SIZE_ERR');
      }
      return internalPlayed[segmentIndex].end;
    };
    Object.defineProperty(this, 'length', {
      get: function get() {
        return internalPlayed.length;
      }
    });
    var createNewPlayedMediaSegment = function createNewPlayedMediaSegment(time) {
      var newIndex = 0;
      var numberPlayedSegments = internalPlayed.length;
      for (var i = 0; i < numberPlayedSegments; i++) {
        if (time > internalPlayed[i].end) {
          newIndex++;
        }
      }
      internalPlayed.splice(newIndex, 0, new PlayedMediaSegment());
      currentMediaSegmentIndex = newIndex;
    };
    var onTimeChange = function onTimeChange(event) {
      if (video.paused) {
        seeking = true;
        return;
      }
      var timeChangeSinceLastUpdate = Math.abs(event.data - lastTimeUpdate);
      lastTimeUpdate = event.data;
      if (seeking || timeChangeSinceLastUpdate > timeDifferenceToForceNewSegment) {
        seeking = false;
        onMediaSeekEnd(event);
      }
      if (that.length === 0) {
        createNewPlayedMediaSegment(event.data);
        internalPlayed[0].recordTime(0);
      }
      internalPlayed[currentMediaSegmentIndex].recordTime(event.data);
      if (internalPlayed.length > 1) {
        mergeOverlappingMediaSegments();
      }
    };
    var onMediaSeekEnd = function onMediaSeekEnd(event) {
      var mediaSegmentIndexForTime = getPlayedMediaSegmentIndexByTime(event.data);
      if (mediaSegmentIndexForTime === -1) {
        createNewPlayedMediaSegment(event.data);
      } else {
        currentMediaSegmentIndex = mediaSegmentIndexForTime;
      }
    };
    var mergeOverlappingMediaSegments = function mergeOverlappingMediaSegments() {
      var numberSegments = internalPlayed.length;
      for (var i = 0; i < numberSegments; i++) {
        if (currentMediaSegmentIndex !== i && that.areMediaSegmentsOverlapping(internalPlayed[currentMediaSegmentIndex], internalPlayed[i])) {
          mergeMediaSegments(currentMediaSegmentIndex, i);
          break;
        }
      }
    };
    var mergeMediaSegments = function mergeMediaSegments(segmentOneIndex, segmentTwoIndex) {
      var mergedIndex = Math.min(segmentOneIndex, segmentTwoIndex);
      var notMergedIndex = Math.max(segmentOneIndex, segmentTwoIndex);
      internalPlayed[mergedIndex].start = Math.min(internalPlayed[segmentOneIndex].start, internalPlayed[segmentTwoIndex].start);
      internalPlayed[mergedIndex].end = Math.max(internalPlayed[segmentOneIndex].end, internalPlayed[segmentTwoIndex].end);
      internalPlayed.splice(notMergedIndex, 1);
      currentMediaSegmentIndex = mergedIndex;
    };
    var getPlayedMediaSegmentIndexByTime = function getPlayedMediaSegmentIndexByTime(time) {
      var segmentIndex = -1;
      var numberPlayedSegments = internalPlayed.length;
      for (var i = 0; i < numberPlayedSegments; i++) {
        if (time >= internalPlayed[i].start && time <= internalPlayed[i].end) {
          segmentIndex = i;
          break;
        }
      }
      return segmentIndex;
    };
    video.addEventListener('timeupdate', onTimeChange);
  };
  tracker.prototype.areMediaSegmentsOverlapping = function (segment1, segment2) {
    var startInOuterSegment = segment2.start >= segment1.start - mergeToleranceInSeconds && segment2.start <= segment1.end + mergeToleranceInSeconds;
    var endInOuterSegment = segment2.end >= segment1.start - mergeToleranceInSeconds && segment2.end <= segment1.end + mergeToleranceInSeconds;
    return startInOuterSegment || endInOuterSegment;
  };
  return new tracker();
};
var PlayedMediaSegment = function PlayedMediaSegment() {
  var startTime = -1;
  var endTime = -1;
  var segment = {};
  Object.defineProperty(segment, 'start', {
    get: function get() {
      return startTime;
    },
    set: function set(value) {
      startTime = +value;
    }
  });
  Object.defineProperty(segment, 'end', {
    get: function get() {
      return endTime;
    },
    set: function set(value) {
      endTime = +value;
    }
  });
  segment.recordTime = function (time) {
    if (startTime === -1 || time < startTime) {
      startTime = time;
    }
    if (time > endTime) {
      endTime = time;
    }
  };
  return segment;
};

var getIdFromUrl = function getIdFromUrl(videoUrl) {
  var videoIdRegex = /(youtu\.be\/|v=)(.{11})/i;
  var videoIdMatch = videoIdRegex.exec(videoUrl);
  return videoIdMatch && videoIdMatch[2] ? videoIdMatch[2] : '*';
};
var youtubeIdParser = {
  getIdFromUrl: getIdFromUrl
};

var addYouTubeApiReadyHandler = function addYouTubeApiReadyHandler() {
  if (!window.onYouTubeIframeAPIReady) {
    window.onYouTubeIframeAPIReady = function () {
      window.onYouTubeIframeAPIReady.ready = true;
      if (Array.isArray(window.onYouTubeIframeAPIReady.queued)) {
        for (var i = 0; i < window.onYouTubeIframeAPIReady.queued.length; i++) {
          if (typeof window.onYouTubeIframeAPIReady.queued[i] === 'function') {
            window.onYouTubeIframeAPIReady.queued[i]();
          } else {
            console.warn('window.onYouTubeIframeAPIReady.queued[' + i + '] is not a function');
          }
        }
      } else {
        console.warn('window.onYouTubeIframeAPIReady.queued is not an array');
      }
    };
    window.onYouTubeIframeAPIReady.queued = [];
  }
};
var youTubeApiUri = 'https://www.youtube.com/iframe_api';
var _playbackReadyPromiseResolve;
var _playbackReadyPromise = new Promise$1(function (resolve) {
  _playbackReadyPromiseResolve = resolve;
});
var YouTubePlayer = function YouTubePlayer(videoUrl, iFrameId, onFirstPlay, onError, playerWidth, playerHeight, startTimeInSeconds, disableFullScreen) {
  var that = this;
  //Keep local variables to minimize cross-iframe communication
  var events = {};
  var currentTime = 0;
  var duration = 0;
  var loadedPercent = 0;
  var playbackRate = 1;
  var playerState = -1;
  var supportPlaybackRate = false;
  var volume = 0.5;
  var muted = false;
  var availableRateSettings = [];
  var ended = false;
  var displayAnnotations = 3; //3 indicates that annotations should be hidden
  var videoId = youtubeIdParser.getIdFromUrl(videoUrl);
  var heartbeatIntervalId = null;
  if (typeof startTimeInSeconds !== 'number') {
    startTimeInSeconds = 0;
  }
  that.playbackReadyPromise = _playbackReadyPromise;
  this.addEventListener = function (eventName, handler) {
    events[eventName] = events[eventName] || [];
    events[eventName].push(handler);
  };
  this.removeEventListener = function (eventName, handler) {
    if (!events[eventName] || events[eventName].length === 0) {
      return;
    }
    var handlerIndex = events[eventName].indexOf(handler);
    if (handlerIndex !== -1) {
      events[eventName].splice(handlerIndex, 1);
    }
  };
  this.bind = function (arg1, arg2) {
    if (typeof arg1 === 'string') {
      this.addEventListener(arg1, arg2);
    } else if (_typeof$1(arg1) === 'object') {
      var keys = Object.keys(arg1);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        that.addEventListener(key, arg1[key]);
      }
    }
  };
  this.on = this.bind;
  this.unbind = function (eventName, handler) {
    if (typeof handler !== 'undefined') {
      this.removeEventListener(eventName, handler);
    } else {
      events[eventName] = [];
    }
  };
  this.off = this.unbind;
  var errorHandler = function errorHandler(event) {
    switch (event.data) {
      case 2:
        //The watch URL is probably wrong - missing/too many characters, or invalid characters
        dispatchEvent('error', 'Invalid video url.'); //
        break;
      case 5:
        //The internal HTML5_VIDEO player cannot play the content
        dispatchEvent('error', 'The video cannot be played.');
        break;
      case 100:
        //Video has been removed or marked private
        dispatchEvent('error', 'This video has been removed from YouTube and is no longer available for playback.');
        break;
      case 101:
      case 150:
        //The video has embedding disabled
        dispatchEvent('error', 'This video is unavailable.  Its YouTube owner either disabled embedding or marked it private.');
        break;
      //Unknown video error?
    }
  };
  if (onError) {
    this.addEventListener('error', onError);
  }
  var firstPlay = function firstPlay() {
    duration = player.getDuration();
    dispatchEvent('durationchange');
    if (onFirstPlay) {
      onFirstPlay();
    }
    dispatchEvent('loadedmetadata');
    dispatchEvent('loadeddata');
    dispatchEvent('canplay');
    //Ensure these events get fired in the proper order the first time, especially for mobile case
    that.removeEventListener('playing', firstPlay);
    dispatchEvent('playing');
    dispatchEvent('play');
  };
  var onStateChange = function onStateChange(event) {
    playerState = event.data;
    switch (event.data) {
      case window.YT.PlayerState.PAUSED:
        dispatchEvent('pause');
        break;
      case window.YT.PlayerState.ENDED:
        ended = true;
        dispatchEvent('ended');
        break;
      case window.YT.PlayerState.PLAYING:
        dispatchEvent('playing');
        dispatchEvent('play');
        break;
      case window.YT.PlayerState.BUFFERING:
        dispatchEvent('waiting');
        break;
    }
  };
  var onPlaybackRateChange = function onPlaybackRateChange(event) {
    playbackRate = event.data;
    dispatchEvent('ratechange', playbackRate);
  };
  var removeFullScreenAttributes = function removeFullScreenAttributes() {
    var playerIFrame = $('#' + iFrameId);
    var fullScreenAttributes = ['allowfullscreen', 'webkitAllowFullScreen', 'mozallowfullscreen'];
    fullScreenAttributes.forEach(function (attr) {
      playerIFrame.removeAttr(attr);
    });
  };
  var readyHandler = function readyHandler() {
    dispatchEvent('loadstart');
    if (disableFullScreen) {
      removeFullScreenAttributes();
    }
    availableRateSettings = player.getAvailablePlaybackRates();
    if (availableRateSettings.length > 1) {
      supportPlaybackRate = true;
    }
    that.addEventListener('playing', firstPlay);
    _playbackReadyPromiseResolve();
  };
  if (playerConfiguration.getShowYouTubeAnnotations()) {
    displayAnnotations = 1;
  }

  /* eslint camelcase:'off' */
  var player = new window.YT.Player(iFrameId, {
    width: playerWidth,
    height: playerHeight,
    playerVars: {
      wmode: 'opaque',
      //Fix for overlays when iframe is hosting flash content
      loop: 0,
      autoplay: 0,
      controls: playerConfiguration.getDisableYouTubeControls() ? 0 : 1,
      disablekb: playerConfiguration.getDisableYouTubeControls() ? 1 : 0,
      rel: 0,
      showsearch: 0,
      showinfo: 0,
      iv_load_policy: displayAnnotations,
      playsinline: 1,
      fs: disableFullScreen ? 0 : 1,
      modestbranding: 1
    },
    events: {
      onReady: readyHandler,
      onStateChange: onStateChange,
      onPlaybackRateChange: onPlaybackRateChange,
      onError: errorHandler
    }
  });
  var dispatchEvent = function dispatchEvent(eventName, arg) {
    var event = {
      type: eventName,
      target: that,
      data: arg
    };
    if (events.hasOwnProperty(eventName)) {
      var eventHandlers = events[eventName].slice(0);
      for (var i = 0; i < eventHandlers.length; i++) {
        eventHandlers[i](event);
      }
    }
  };
  var _playedTracker = new playedTracker(this);

  //As the name suggests, this is mocking the behavior of the html5 spec 'loaded' parameter
  var loadedMock = function loadedMock() {
    return {
      start: function start() {
        return 0;
      },
      end: function end() {
        return duration * loadedPercent;
      },
      length: 1
    };
  };
  Object.defineProperty(this, 'buffered', {
    get: loadedMock
  });
  Object.defineProperty(this, 'currentSrc', {
    get: function get() {
      return videoUrl;
    }
  });
  Object.defineProperty(this, 'currentTime', {
    get: function get() {
      return player.getCurrentTime();
    },
    set: function set(value) {
      dispatchEvent('seeking');
      if (+value > that.buffered.end()) {
        player.seekTo(+value, true);
      } else {
        player.seekTo(+value);
      }
      dispatchEvent('seeked');
    }
  });
  Object.defineProperty(this, 'duration', {
    get: function get() {
      return duration;
    }
  });
  Object.defineProperty(this, 'paused', {
    get: function get() {
      return playerState === window.YT.PlayerState.PAUSED;
    }
  });
  Object.defineProperty(this, 'playbackRate', {
    get: function get() {
      return playbackRate;
    },
    set: function set(value) {
      if (player.setPlaybackRate) {
        player.setPlaybackRate(+value);
      }
      //Don't set internal value here - let the emitted event update it
    }
  });
  Object.defineProperty(this, 'played', {
    get: function get() {
      return _playedTracker;
    }
  });
  Object.defineProperty(this, 'ended', {
    get: function get() {
      return ended;
    }
  });
  Object.defineProperty(this, 'seekable', {
    get: function get() {
      return {
        start: function start() {
          return 0;
        },
        end: function end() {
          return duration;
        },
        length: 1
      };
    }
  });
  Object.defineProperty(this, 'supportPlaybackRate', {
    get: function get() {
      return supportPlaybackRate;
    }
  });
  Object.defineProperty(this, 'validRateSettings', {
    get: function get() {
      return availableRateSettings;
    }
  });
  Object.defineProperty(this, 'volume', {
    get: function get() {
      return volume;
    },
    set: function set(value) {
      //Youtube player decided to let volume be 1-100 instead of html5 spec 0-1
      var scaledValue = value * 100;
      player.setVolume && player.setVolume(scaledValue);
      volume = value;
      dispatchEvent('volumechange', null);
    }
  });
  Object.defineProperty(this, 'muted', {
    get: function get() {
      return muted;
    },
    set: function set(value) {
      if (muted !== value) {
        muted = value;
        dispatchEvent('volumechange', null);
      }
      if (value) {
        player.mute && player.mute();
      } else {
        player.unMute && player.unMute();
      }
    }
  });
  Object.defineProperty(this, 'height', {
    get: function get() {
      return playerHeight;
    }
  });
  Object.defineProperty(this, 'width', {
    get: function get() {
      return playerWidth;
    }
  });
  Object.defineProperty(this, 'playbackReadyPromise', {
    get: function get() {
      return _playbackReadyPromise;
    }
  });
  this.play = function () {
    player.playVideo();
  };
  this.pause = function () {
    player.pauseVideo();
  };
  this.attr = function (property, value) {
    var domPlayer = document.getElementById(iFrameId);
    domPlayer.setAttribute(property, value);
  };
  this.load = function () {
    _playbackReadyPromise.then(function () {
      player.cueVideoById(videoId, startTimeInSeconds);
    });
  };
  this.destroy = function () {
    if (player) {
      player.destroy();
      window.onYouTubeIframeAPIReady = null;
    }
    if (heartbeatIntervalId) {
      clearInterval(heartbeatIntervalId);
    }
  };
  var heartbeat = function heartbeat() {
    if (typeof player.getCurrentTime === 'undefined') {
      return;
    }
    playerState = player.getPlayerState();
    var time = player.getCurrentTime();
    if (currentTime !== time) {
      currentTime = time;
      dispatchEvent('timeupdate', time);
    }
    var videoLoadedFraction = player.getVideoLoadedFraction;
    if (typeof videoLoadedFraction === 'undefined' || videoLoadedFraction === null) {
      return;
    }
    var percentLoaded = player.getVideoLoadedFraction();
    if (loadedPercent !== percentLoaded) {
      loadedPercent = percentLoaded;
      dispatchEvent('progress');
      // not really sure on this, but if it's at 99%, should be able to play through...
      if (loadedPercent > 0.99) {
        dispatchEvent('canplaythrough');
      }
    }
  };
  heartbeatIntervalId = setInterval(heartbeat, 100);
};
var addApi = function addApi() {
  addYouTubeApiReadyHandler();
  var youTubeApiFound = $("script[src='" + youTubeApiUri + "']").length;
  if (!youTubeApiFound) {
    $.getScript(youTubeApiUri);
  }
  return !youTubeApiFound;
};
var youTube = {
  create: YouTubePlayer,
  addApi: addApi
};

/**
 *  @memberof TSC
 *  @implement MediaView
 *  @class YoutubeElementView
 *  @classdesc Youtube Video element view
 *  @param {jQuery} $rootContainer - Smart Player top container jquery element
 *  @param {jQuery} $mediaContainer - Smart Player media container jquery element
 *  @param {string} containerElementUniqueId - Smart Player main container id
 *  @param {Array} mediaSources - html5 media DOM element (or wrapper presenting same interface)
 *  @param {Function} firstPlayCallback - callback function called on the first play click
 */
var YoutubeElementView = function YoutubeElementView($rootContainer, $mediaContainer, containerElementUniqueId, mediaSources, firstPlayCallback) {
  var _youtubePlayer;
  var _errorMessageBarView;
  var _$youtubePointerEventWorkaround = $mediaContainer.find('.youtube-pointer-event-workaround');
  var addHideBubbleClass = function addHideBubbleClass() {
    $rootContainer.addClass(cssClasses.hideBubbleArrow);
  };
  var removeHideBubbleClass = function removeHideBubbleClass() {
    $rootContainer.removeClass(cssClasses.hideBubbleArrow);
  };

  // need to first MediaControlsReady event when using YouTube controls
  var internalFirstPlayCallback = function internalFirstPlayCallback() {
    firstPlayCallback && firstPlayCallback();
  };
  var onControlsHidden = function onControlsHidden() {
    if (playerConfiguration.getDisableYouTubeControls()) {
      _$youtubePointerEventWorkaround.removeClass(cssClasses.hide);
    }
  };
  var onControlsVisible = function onControlsVisible() {
    _$youtubePointerEventWorkaround.addClass(cssClasses.hide);
  };
  var processVideoEnd = function processVideoEnd() {
    return true;
  };
  var reshowVideoAfterClickToReplay = function reshowVideoAfterClickToReplay() {
    // do nothing
  };
  var bindToEvents = function bindToEvents() {
    $rootContainer.on(events.Controls.VideoControlsVisible, onControlsVisible);
    $rootContainer.on(events.Controls.VideoControlsHidden, onControlsHidden);
  };
  var unbindToEvents = function unbindToEvents() {
    $rootContainer.off(events.Controls.VideoControlsVisible, onControlsVisible);
    $rootContainer.off(events.Controls.VideoControlsHidden, onControlsHidden);
  };
  var destroy = function destroy() {
    if (_youtubePlayer) {
      _youtubePlayer.destroy();
    }
    removeHideBubbleClass();
    _errorMessageBarView && _errorMessageBarView.remove();
    unbindToEvents();
  };
  var showCaptionTrack = function showCaptionTrack() {
    // our captions are not shown over youtube videos
  };
  var hideCaptionTrack = function hideCaptionTrack() {
    // our captions are not shown over youtube videos
  };
  var addEventListener = function addEventListener(eventName, handler) {
    _youtubePlayer.addEventListener(eventName, handler);
  };
  var removeEventListener = function removeEventListener(eventName, handler) {
    _youtubePlayer.removeEventListener(eventName, handler);
  };
  var onError = function onError(event) {
    _errorMessageBarView = MessageBarView$1.create($rootContainer, messageBarType.info, event.data);
  };
  var hotfixViewAndControlsCSS = function hotfixViewAndControlsCSS($controlsView) {
    if (playerConfiguration.getDisableControls() || playerConfiguration.getDisableInteractions()) {
      // Quiz location logic needs the controls to have reasonable width and height.
      // But in the case when we are using YouTube controls we want the controls hidden
      // so they can't be interacted with. By pushing it behind the player with z-index
      // it accomplishes "hiding" the controls but still allowing the controls to take
      // up the correct width and height for the quiz marker location logic. Using
      // _$controls.hide() does not accomplish the same affect and that is why it is
      // avoided here.
      $controlsView.css('z-index', '-1');
    } else {
      _youtubePlayer.css('height', 'calc(100% - ' + $controlsView.height() + 'px)');
    }
  };
  addHideBubbleClass();
  var startTime = playerConfiguration.getJumpToTime();
  if (startTime !== undefined) {
    startTime = urlService.convertUrlTime(startTime);
  } else {
    startTime = 0;
  }
  var youtubeElementViewObject = Object.defineProperties({
    hotfixViewAndControlsCSS: hotfixViewAndControlsCSS,
    showCaptionTrack: showCaptionTrack,
    hideCaptionTrack: hideCaptionTrack,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener,
    reshowVideoAfterClickToReplay: reshowVideoAfterClickToReplay,
    processVideoEnd: processVideoEnd,
    loadMedia: function loadMedia() {
      _youtubePlayer.load();
    },
    destroy: destroy
  }, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {jQuery} mediaWrapper - jQuery wrapper of the video element.
     */
    mediaWrapper: {
      get: function get() {
        return _youtubePlayer;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {HTMLVideoElement} mediaElement - HTML video element
     */
    mediaElement: {
      get: function get() {
        return _youtubePlayer;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Boolean} containsWebTrackCaptions - Does the video contain web track captions?
     */
    containsWebTrackCaptions: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {int} currentTimeInMilliseconds - The current time of the media, in milliseconds
     */
    currentTimeInMilliseconds: {
      get: function get() {
        var mediaElement = this.mediaElement;
        var currentTimeInSeconds = mediaElement.currentTime > mediaElement.duration ? mediaElement.duration : mediaElement.currentTime;
        return currentTimeInSeconds ? currentTimeInSeconds * 1000 : 0;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Number} mediaWidth - video width
     */
    mediaWidth: {
      get: function get() {
        return _youtubePlayer.width;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Number} mediaHeight - video height
     */
    mediaHeight: {
      get: function get() {
        return _youtubePlayer.height;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Boolean}  - allows dragging extension content
     */
    canDragContentOnVideo: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {string} playerControlType - Type of player controls to use
     */
    playerControlType: {
      get: function get() {
        return playerControlsType.video;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {string} type - Media view type
     */
    type: {
      get: function get() {
        return mediaViewType.youtube;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {boolean} supportsClickToPlayControls - Does view support click to play controls over media
     */
    supportsClickToPlayControls: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {boolean} supportsSCORM - Does view support SCORM
     */
    supportsSCORM: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {TSC.VideoPlaybackQualityMetrics} playbackQualityMetrics - the playback quality metrics set up for this view (may be null)
     */
    playbackQualityMetrics: {
      get: function get() {
        return null;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {string} currentSrc - The current source path of the media
     */
    currentSrc: {
      get: function get() {
        return _youtubePlayer.currentSrc;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Number} currentTime - The current time for the media
     */
    currentTime: {
      get: function get() {
        return _youtubePlayer.currentTime;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Number} duration - The duration of the media
     */
    duration: {
      get: function get() {
        return _youtubePlayer.duration;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Boolean} ended - Has the media ended
     */
    ended: {
      get: function get() {
        return _youtubePlayer.ended;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Boolean} paused - Is the media paused
     */
    paused: {
      get: function get() {
        return _youtubePlayer.paused;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Boolean} seeking - Is the media seeking
     */
    seeking: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Number} volume - The volume of the media
     */
    volume: {
      get: function get() {
        return _youtubePlayer.volume;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Boolean} muted - Is the media muted
     */
    muted: {
      get: function get() {
        return _youtubePlayer.muted;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Number} playbackRate - Playback rate of the media
     */
    playbackRate: {
      get: function get() {
        return _youtubePlayer.playbackRate;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Array} buffered - THe array of buffered segments
     */
    buffered: {
      get: function get() {
        return _youtubePlayer.buffered;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Array} played - THe array of media segments that have been played
     */
    played: {
      get: function get() {
        return _youtubePlayer.played;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.YoutubeElementView
     *  @property {Array} seekable - THe array of media segments that are seekable
     */
    seekable: {
      get: function get() {
        return _youtubePlayer.seekable;
      }
    }
  });
  youTube.addApi();
  return new Promise$1(function (resolve, reject) {
    try {
      var disableFullScreen = $rootContainer.playerState.mediaHasQuizQuestions;
      if (window.onYouTubeIframeAPIReady.ready) {
        _youtubePlayer = new youTube.create(mediaSources[0].uri, containerElementUniqueId, internalFirstPlayCallback, onError, $mediaContainer.width(), $mediaContainer.height(), startTime, disableFullScreen);
        bindToEvents();
        $rootContainer.trigger(events.Controls.HideIOOverlay);
        resolve(youtubeElementViewObject);
      } else {
        window.onYouTubeIframeAPIReady.queued.push(function () {
          _youtubePlayer = new youTube.create(mediaSources[0].uri, containerElementUniqueId, internalFirstPlayCallback, onError, $mediaContainer.width(), $mediaContainer.height(), startTime, disableFullScreen);
          bindToEvents();
          $rootContainer.trigger(events.Controls.HideIOOverlay);
          resolve(youtubeElementViewObject);
        });
      }
    } catch (_) {
      reject(new Error('unhandled error creating youtube element view'));
    }
  });
};
var YoutubeElementView$1 = {
  create: YoutubeElementView
};

var DEFAULT_SEGMENT_LENGTH = 30000;
var SEGMENT_CHOICES = [{
  duration: 300000,
  segmentLength: 2000
}, {
  duration: 1800000,
  segmentLength: 5000
}];
var _videoLoadStartTime;
var _videoLoadEndTime;
var _videoDuration = 0;
var _segmentLength = DEFAULT_SEGMENT_LENGTH;
var _numberSegments = 0;
var _videoSegments = [];
var _numberVideoSegmentWatched = 0;
var _currentPlayTime = 0;
var _enabled = false;
var videoAnalytics = {
  setVideoLoadStartTime: function setVideoLoadStartTime(time) {
    _videoLoadStartTime = time;
  },
  setVideoLoadEndTime: function setVideoLoadEndTime(time) {
    _videoLoadEndTime = time;
  },
  getVideoLoadTime: function getVideoLoadTime() {
    var loadTime = 0;
    if (_videoLoadStartTime && _videoLoadEndTime) {
      loadTime = _videoLoadEndTime - _videoLoadStartTime;
    }
    return loadTime;
  },
  getNumberSegments: function getNumberSegments() {
    return _numberSegments;
  },
  setCurrentPlayTime: function setCurrentPlayTime(time) {
    _currentPlayTime = time;
  },
  getCurrentPlayTime: function getCurrentPlayTime() {
    return _currentPlayTime;
  },
  getNumberWatchedSegments: function getNumberWatchedSegments() {
    return _numberVideoSegmentWatched;
  },
  isPercentWatchedInitialized: function isPercentWatchedInitialized() {
    return _videoDuration > 0;
  },
  clearPercentWatched: function clearPercentWatched() {
    _numberSegments = 0;
    _videoSegments = [];
    _numberVideoSegmentWatched = 0;
    _currentPlayTime = 0;
    _videoDuration = 0;
  },
  initPercentWatched: function initPercentWatched(videoDurationInMilliseconds) {
    if (videoDurationInMilliseconds <= 0) {
      return;
    }
    _videoDuration = videoDurationInMilliseconds;

    // determine video segment length
    _segmentLength = DEFAULT_SEGMENT_LENGTH;
    for (var i = 0; i < SEGMENT_CHOICES.length; i++) {
      if (videoDurationInMilliseconds <= SEGMENT_CHOICES[i].duration) {
        _segmentLength = SEGMENT_CHOICES[i].segmentLength;
        break;
      }
    }

    // create array to store percentage watched
    _videoSegments = [];
    _numberSegments = Math.ceil(videoDurationInMilliseconds / _segmentLength);
    for (var j = 0; j < _numberSegments; j++) {
      _videoSegments.push(false);
    }
    _numberVideoSegmentWatched = 0;
  },
  markTimeWatched: function markTimeWatched(videoTimeInMilliseconds) {
    videoTimeInMilliseconds = Math.min(videoTimeInMilliseconds, _videoDuration);
    _currentPlayTime = videoTimeInMilliseconds / 1000;
    var index = Math.floor(videoTimeInMilliseconds / _segmentLength);
    if (index < 0 || index >= _numberSegments) {
      return;
    }
    if (!_videoSegments[index]) {
      _numberVideoSegmentWatched++;
      _videoSegments[index] = true;
    }
  },
  getPercentageWatched: function getPercentageWatched() {
    if (_numberSegments && _numberSegments > 0) {
      return _numberVideoSegmentWatched / _numberSegments;
    }
    return 0;
  },
  getPercentageWatchedForVideoSegment: function getPercentageWatchedForVideoSegment(startTimeInMilliseconds, endTimeInMilliseconds) {
    var percentageWatched = 0;
    if (_videoDuration > 0 && startTimeInMilliseconds <= endTimeInMilliseconds) {
      var startSegmentIndex = Math.floor(startTimeInMilliseconds / _segmentLength);
      var endSegmentIndex = Math.floor(endTimeInMilliseconds / _segmentLength);
      var numberSegmentsWatched = 0;
      var totalSegmentsInRange = endSegmentIndex - startSegmentIndex + 1;
      for (var i = startSegmentIndex; i <= endSegmentIndex; i++) {
        if (_videoSegments[i]) {
          numberSegmentsWatched++;
        }
      }
      percentageWatched = numberSegmentsWatched / totalSegmentsInRange;
    }
    return percentageWatched;
  },
  setEnabled: function setEnabled(enabled) {
    _enabled = enabled;
  },
  isEnabled: function isEnabled() {
    return _enabled;
  },
  getVideoSegmentSnapShot: function getVideoSegmentSnapShot() {
    return _videoSegments.map(function (segmentValue) {
      return segmentValue === true ? '1' : '0';
    }).join(',');
  },
  populateVideoSegmentsWatch: function populateVideoSegmentsWatch(videoSegmentSnapshot) {
    var videoSegmentSnapshotList = videoSegmentSnapshot.split(',');
    if (_videoSegments.length !== videoSegmentSnapshotList.length) {
      return;
    }
    videoSegmentSnapshotList.forEach(function (segmentValue, index) {
      if (segmentValue === '1') {
        _numberVideoSegmentWatched++;
        _videoSegments[index] = true;
      }
    });
  }
};

/**
 *  @memberof TSC
 *  @implement MediaView
 *  @class PlaylistElementView
 *  @classdesc HTML 5 Video element view
 *  @param {jQuery} $rootContainer - Smart Player main container jquery element
 *  @param {jQuery} $mediaContainer - Smart Player media container jquery element
 *  @param {MediaList} mediaList - the media sources to use when creating the view
 *  @param {Boolean} includeControls - Include the built in controls for the video element
 *  @param {Function} triggerRumDataEvent - Callback function to use when triggering rum data event
 *  @param {Function} firstPlayCallback - callback function called on the first play click
 *  @param {Boolean} [includePosterIfAvailable=false] - Include the poster image if available
 */
var PlaylistElementView = function PlaylistElementView($rootContainer, $mediaContainer, mediaList, includeControls, triggerRumDataEvent, firstPlayCallback, includePosterIfAvailable) {
  var _videoElementView = VideoElementView$1.create($rootContainer, $mediaContainer, mediaList.mediaList, includeControls, triggerRumDataEvent, firstPlayCallback, includePosterIfAvailable);
  var initCurrentMedia = function initCurrentMedia() {
    _videoElementView.mediaElement.src = mediaList.currentMedia.media;
    if (videoAnalytics.isEnabled()) {
      videoAnalytics.clearPercentWatched();
    }
    $mediaContainer.trigger(events.Media.InitializeCurrent, {
      enablePreviousButton: !mediaList.onFirstMedia,
      enableNextButton: !mediaList.onLastMedia
    });
  };
  var clickPrevHandler = function clickPrevHandler() {
    if (!mediaList.onFirstMedia) {
      mediaList.currentMediaIndex = 'previous';
      initCurrentMedia();
    }
  };
  var clickNextHandler = function clickNextHandler() {
    if (!mediaList.onLastMedia) {
      mediaList.currentMediaIndex = 'next';
      initCurrentMedia();
    }
  };
  var processVideoEnd = function processVideoEnd() {
    var wasPlaylistLastMediaItem = mediaList.onLastMedia;
    if (!wasPlaylistLastMediaItem) {
      mediaList.currentMediaIndex = 'next';
      initCurrentMedia();
    }
    return wasPlaylistLastMediaItem;
  };
  var restartPlaybackAtBeginning = function restartPlaybackAtBeginning() {
    mediaList.currentMediaIndex = 0;
    initCurrentMedia();
  };
  var destroy = function destroy() {
    $rootContainer.off(events.Controls.ClickPrev, clickPrevHandler);
    $rootContainer.off(events.Controls.ClickNext, clickNextHandler);
    $rootContainer.off(events.Media.SourceChanged, initCurrentMedia);
    _videoElementView.destroy();
  };
  var hotfixViewAndControlsCSS = function hotfixViewAndControlsCSS($controlsView) {}; // eslint-disable-line

  $rootContainer.on(events.Controls.ClickNext, clickNextHandler);
  $rootContainer.on(events.Controls.ClickPrev, clickPrevHandler);
  $rootContainer.on(events.Media.SourceChanged, initCurrentMedia);
  return Object.defineProperties({
    hotfixViewAndControlsCSS: hotfixViewAndControlsCSS,
    showCaptionTrack: _videoElementView.showCaptionTrack,
    hideCaptionTrack: _videoElementView.hideCaptionTrack,
    addEventListener: _videoElementView.addEventListener,
    removeEventListener: _videoElementView.removeEventListener,
    reshowVideoAfterClickToReplay: restartPlaybackAtBeginning,
    processVideoEnd: processVideoEnd,
    loadMedia: _videoElementView.loadMedia,
    destroy: destroy
  }, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {jQuery} mediaWrapper - jQuery wrapper of the video element.
     */
    mediaWrapper: {
      get: function get() {
        return _videoElementView.mediaWrapper;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {HTMLVideoElement} mediaElement - HTML video element
     */
    mediaElement: {
      get: function get() {
        return _videoElementView.mediaElement;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Boolean} containsWebTrackCaptions - Does the video contain web track captions?
     */
    containsWebTrackCaptions: {
      get: function get() {
        return _videoElementView.containsWebTrackCaptions;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {int} currentTimeInMilliseconds - The current time of the media, in milliseconds
     */
    currentTimeInMilliseconds: {
      get: function get() {
        return _videoElementView.currentTimeInMilliseconds;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Number} mediaWidth - video width
     */
    mediaWidth: {
      get: function get() {
        return _videoElementView.mediaWidth;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Number} mediaHeight - video height
     */
    mediaHeight: {
      get: function get() {
        return _videoElementView.mediaHeight;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Boolean}  - allows dragging extension content
     */
    canDragContentOnVideo: {
      get: function get() {
        return true;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {string} playerControlType - Type of player controls to use
     */
    playerControlType: {
      get: function get() {
        return playerControlsType.videoPlaylist;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {string} type - Media view type
     */
    type: {
      get: function get() {
        return mediaViewType.playlist;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {boolean} supportsClickToPlayControls - Does view support click to play controls over media
     */
    supportsClickToPlayControls: {
      get: function get() {
        return true;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {boolean} supportsSCORM - Does view support SCORM
     */
    supportsSCORM: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {TSC.VideoPlaybackQualityMetrics} playbackQualityMetrics - the playback quality metrics set up for this view (may be null)
     */
    playbackQualityMetrics: {
      get: function get() {
        return _videoElementView.playbackQualityMetrics;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {string} currentSrc - The current source path of the media
     */
    currentSrc: {
      get: function get() {
        return _videoElementView.currentSrc;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Number} currentTime - The current time for the media
     */
    currentTime: {
      get: function get() {
        return _videoElementView.currentTime;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Number} duration - The duration of the media
     */
    duration: {
      get: function get() {
        return _videoElementView.duration;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Boolean} ended - Has the media ended
     */
    ended: {
      get: function get() {
        return _videoElementView.ended;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Boolean} paused - Is the media paused
     */
    paused: {
      get: function get() {
        return _videoElementView.paused;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Boolean} seeking - Is the media seeking
     */
    seeking: {
      get: function get() {
        return _videoElementView.seeking;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Number} volume - The volume of the media
     */
    volume: {
      get: function get() {
        return _videoElementView.volume;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Boolean} muted - Is the media muted
     */
    muted: {
      get: function get() {
        return _videoElementView.muted;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Number} playbackRate - Playback rate of the media
     */
    playbackRate: {
      get: function get() {
        return _videoElementView.playbackRate;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Array} buffered - THe array of buffered segments
     */
    buffered: {
      get: function get() {
        return _videoElementView.buffered;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Array} played - THe array of media segments that have been played
     */
    played: {
      get: function get() {
        return _videoElementView.played;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {Array} seekable - THe array of media segments that are seekable
     */
    seekable: {
      get: function get() {
        return _videoElementView.seekable;
      }
    }
  });
};
var PlaylistElementView$1 = {
  create: PlaylistElementView
};

var switchToFullScreenMode = function switchToFullScreenMode(elementToFullScreen) {
  if (elementToFullScreen.requestFullscreen) {
    elementToFullScreen.requestFullscreen();
  } else if (elementToFullScreen.webkitRequestFullscreen) {
    elementToFullScreen.webkitRequestFullscreen();
  } else if (elementToFullScreen.webkitEnterFullscreen) {
    // legacy iOS full screen api
    elementToFullScreen.webkitEnterFullscreen();
  }
};
var exitFullscreenMode = function exitFullscreenMode(fullScreenElement) {
  if (window.document.exitFullscreen) {
    window.document.exitFullscreen();
  } else if (window.document.webkitExitFullscreen) {
    window.document.webkitExitFullscreen();
  } else if (fullScreenElement && fullScreenElement.webkitExitFullscreen) {
    // legacy iOS full screen api
    fullScreenElement.webkitExitFullscreen();
  }
};
var fullscreenHelper = {
  switchToFullscreenMode: switchToFullScreenMode,
  exitFullscreenMode: exitFullscreenMode
};

/**
 *  @memberof TSC
 *  @implement MediaView
 *  @class ImageView
 *  @classdesc Image View @param {jQuery} $rootContainer - Smart Player main container jquery element
 *  @param {jQuery} $rootContainer - Smart Player main container jquery element
 *  @param {jQuery} $mediaContainer - Smart Player media container jquery element
 *  @param {string} containerElementUniqueId - ID for container element
 *  @param {string} imageSrc - Image source
*/
var ImageView = function ImageView($rootContainer, $mediaContainer, containerElementUniqueId, imageSrc) {
  var _$imageEl;
  var _imageTapActive = true; // default to active
  var _$document = windowWrapper.getDocument(true);
  var onImageError = function onImageError(e) {
    e.preventDefault();
    $mediaContainer.trigger(events.Media.Error, {
      errorString: localizationStrings.getPlayerString(playerStringNames.mediaNotFound)
    });
    _$imageEl.hide();
  };
  var setBackgroundImage = function setBackgroundImage() {
    _$imageEl.attr('src', imageSrc);
  };
  var switchToFullscreenMode = function switchToFullscreenMode() {
    fullscreenHelper.switchToFullscreenMode($rootContainer[0]);
  };
  var exitFullscreenMode = function exitFullscreenMode() {
    fullscreenHelper.exitFullscreenMode();
  };
  var onFullscreenChange = function onFullscreenChange() {
    if (_$document[0].fullscreenElement) {
      $rootContainer.addClass('fullscreen-mode');
    } else {
      $rootContainer.removeClass('fullscreen-mode');
    }
  };
  var initDom = function initDom() {
    var imageViewMarkup = templateGenerator.generateImageMarkup(containerElementUniqueId);
    $mediaContainer.html(imageViewMarkup);
    _$imageEl = $mediaContainer.find('.smart-player-image-media');
  };
  var createView = function createView() {
    initDom();
  };
  var loadImage = function loadImage() {
    setBackgroundImage();

    // simulate the loadedmetadata html5 video events, must be dispatchEvent as jQuery events dont propagate to addEventListener
    _$imageEl[0].dispatchEvent(new Event(events.ExternalVideo.VideoLoadedMetadata));
    _$imageEl[0].dispatchEvent(new Event(events.ExternalVideo.VideoLoadedData));
  };
  var destroy = function destroy() {
    _$imageEl.off('pointerup', onImageTouchToggle);
    _$imageEl.off('click', switchToFullscreenMode);
    _$imageEl.off('error', onImageError);
    _$document.off('fullscreenchange', onFullscreenChange);
    $rootContainer.off(events.External.SwitchToFullscreen, switchToFullscreenMode);
    $rootContainer.off(events.External.ExitFullscreen, exitFullscreenMode);
  };
  var onImageTouchToggle = function onImageTouchToggle() {
    _imageTapActive = !_imageTapActive;
    if (_imageTapActive) {
      $rootContainer.trigger(events.Images.PointerOver);
    } else {
      $rootContainer.trigger(events.Images.PointerLeave);
    }
  };
  var initializeHandlers = function initializeHandlers() {
    if (deviceInfo.isTouchInterface()) {
      _$imageEl.on('pointerup', onImageTouchToggle);
    }
    _$imageEl.on('click', switchToFullscreenMode);
    _$imageEl.on('error', onImageError);
    _$document.on('fullscreenchange', onFullscreenChange);
    $rootContainer.on(events.External.SwitchToFullscreen, switchToFullscreenMode);
    $rootContainer.on(events.External.ExitFullscreen, exitFullscreenMode);
  };
  createView();
  initializeHandlers();
  var noOp = function noOp() {}; // eslint-disable-line
  var hotfixViewAndControlsCSS = function hotfixViewAndControlsCSS($controlsView) {}; // eslint-disable-line

  return Object.defineProperties({
    hotfixViewAndControlsCSS: hotfixViewAndControlsCSS,
    // these are only defined on the image view
    exitFullscreenMode: exitFullscreenMode,
    switchToFullscreenMode: switchToFullscreenMode,
    // the rest of these are standard media element view
    showCaptionTrack: noOp,
    hideCaptionTrack: noOp,
    addEventListener: noOp,
    removeEventListener: noOp,
    reshowVideoAfterClickToReplay: noOp,
    processVideoEnd: noOp,
    loadMedia: loadImage,
    destroy: destroy
  }, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {jQuery} mediaWrapper - jQuery wrapper of the imagre element.
     */
    mediaWrapper: {
      get: function get() {
        return _$imageEl;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {HTMLImageElement} mediaElement - HTML image element
     */
    mediaElement: {
      get: function get() {
        return _$imageEl[0];
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Boolean} containsWebTrackCaptions - Does the view contain web track captions?
     */
    containsWebTrackCaptions: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.PlaylistElementView
     *  @property {int} currentTimeInMilliseconds - The current time of the media, in milliseconds
     */
    currentTimeInMilliseconds: {
      get: function get() {
        return 0;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Number} mediaWidth - image width
     */
    mediaWidth: {
      get: function get() {
        return this.mediaElement.naturalWidth;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Number} mediaHeight - image height
     */
    mediaHeight: {
      get: function get() {
        return this.mediaElement.naturalHeight;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Boolean}  - allows dragging extension content
     */
    canDragContentOnVideo: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {string} playerControlType - Type of player controls to use
     */
    playerControlType: {
      get: function get() {
        return playerControlsType.none;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {string} type - Media view type
     */
    type: {
      get: function get() {
        return mediaViewType.image;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {boolean} supportsClickToPlayControls - Does view support click to play controls over media
     */
    supportsClickToPlayControls: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {boolean} supportsSCORM - Does view support SCORM
     */
    supportsSCORM: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {TSC.VideoPlaybackQualityMetrics} playbackQualityMetrics - the playback quality metrics set up for this view (may be null)
     */
    playbackQualityMetrics: {
      get: function get() {
        return null;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {string} currentSrc - The current source path of the media
     */
    currentSrc: {
      get: function get() {
        return imageSrc;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Number} currentTime - The current time for the media
     */
    currentTime: {
      get: function get() {
        return 0;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Number} duration - The duration of the media
     */
    duration: {
      get: function get() {
        return 0;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Boolean} ended - Has the media ended
     */
    ended: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Boolean} paused - Is the media paused
     */
    paused: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Boolean} seeking - Is the media seeking
     */
    seeking: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Number} volume - The volume of the media
     */
    volume: {
      get: function get() {
        return 1;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Boolean} muted - Is the media muted
     */
    muted: {
      get: function get() {
        return false;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Number} playbackRate - Playback rate of the media
     */
    playbackRate: {
      get: function get() {
        return 1;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Array} buffered - THe array of buffered segments
     */
    buffered: {
      get: function get() {
        return [];
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Array} played - THe array of media segments that have been played
     */
    played: {
      get: function get() {
        return [];
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.ImageView
     *  @property {Array} seekable - THe array of media segments that are seekable
     */
    seekable: {
      get: function get() {
        return [];
      }
    }
  });
};
var ImageView$1 = {
  /**
   *  Factory method that returns a new ImageView object.
   *  @function create
   *  @memberof TSC.ImageView
   *  @static
   *  @param {jQuery} $rootContainer - Smart Player main container jquery element
   *  @param {jQuery} $mediaContainer - Smart Player media container jquery element
   *  @param {string} containerElementUniqueId - ID for container element
   *  @param {string} imageSrc - Image source
   *  @return new ImageView instance
   */
  create: ImageView
};

/**
 * Interface for a media view
 *
 * @interface MediaView
 *
 * @property {jQuery} mediaWrapper - jQuery wrapper around media element
 * @property {HTMLImageElement|HTMLVideoElement} mediaElement - reference to the media element.
 * @property {Boolean} containsWebTrackCaptions - Does the view contain web track captions
 * @property {Number} mediaWidth - Width of the media
 * @property {Number} mediaHeight - Height of the media
 * @property {string} playerControlType - Type of controls to use with view.
 * @property {String} type - The view type
 * @property {Boolean} supportsClickToPlayControls - View supports click to play controls
 * @property {Boolean} supportsSCORM - Does the media view support SCORM.
 * @property {TSC.VideoPlaybackQualityMetrics} playbackQualityMetrics - Video playback quality metrics instance for view
 * @property {String} currentSrc - Current source string
 * @property {Number} currentTime - Current time of the media
 * @property {Number} duration - The duration of the media
 * @property {Boolean} ended - Has the media ended
 * @property {Boolean} paused - Is the media paused
 * @property {Boolean} seeking - Is the media seeking
 * @property {Number} volume - Volume of the media
 * @property {Boolean} muted - Is media muted
 * @property {Number} playbackRate - Playback rate of the media
 * @property {Array} buffered - The array of segments the media has buffered
 * @property {Array} played - The array of media segments that have been played
 * @property {Array} seekable - The array of media segments that are seekable
 */

/**
 * @memberof TSC
 * @class MediaViewFactory
 * @classdesc Media View Factory
 *  @param {JQuery} $rootContainer - Smart Player top-level container
 *  @param {JQuery} $mediaContainer - Smart Player container of media viewport
 *  @param {string} containerElementUniqueId - Smart Player main container id
 *  @param {TSC.MediaList} mediaList - the media sources to use when creating the view
 *  @param {Function} firstPlayCallback - callback function called on the first play click
 *  @param {Function} triggerRumDataEvent - Callback function to use when triggering rum data event
 *
 */
var MediaViewFactory = function MediaViewFactory($rootContainer, $mediaContainer, containerElementUniqueId, mediaList, firstPlayCallback, triggerRumDataEvent) {
  var includeControls = false;
  var haveYoutubeEmbedUrl = mediaList.isMediaTypeAvailable(mediaType.YOUTUBE);
  var createBaseVideoViewMarkup = function createBaseVideoViewMarkup() {
    var playerMarkup = templateGenerator.generateVideoViewMarkup(containerElementUniqueId);
    $mediaContainer.html(playerMarkup);
  };
  if (!mediaList.hasImage) {
    createBaseVideoViewMarkup();
  }
  if (haveYoutubeEmbedUrl) {
    $mediaContainer.addClass(cssClasses.mediaTypeYouTube);
    return YoutubeElementView$1.create($rootContainer, $mediaContainer, containerElementUniqueId, mediaList.mediaList, firstPlayCallback);
  }
  if (mediaList.isPlaylist) {
    return Promise$1.resolve(PlaylistElementView$1.create($rootContainer, $mediaContainer, mediaList, includeControls, triggerRumDataEvent, firstPlayCallback));
  }
  if (mediaList.hasImage) {
    return Promise$1.resolve(ImageView$1.create($rootContainer, $mediaContainer, containerElementUniqueId, mediaList.currentMedia.media));
  }
  return Promise$1.resolve(VideoElementView$1.create($rootContainer, $mediaContainer, mediaList.mediaList, includeControls, triggerRumDataEvent, firstPlayCallback));
};
var MediaViewFactory$1 = {
  /**
   *  Factory method that returns a new MediaViewFactory.
   *  @function create
   *  @memberof TSC.MediaViewFactory
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {string} videoTagUniqueId - Smart Player main container id
   *  @param {MediaList} mediaList - the media sources to use when creating the view
   *  @param {Function} firstPlayCallback - callback function called on the first play click
   *  @param {Function} triggerRumDataEvent - Callback function to use when triggering rum data event
   *  @return new Promise that resolves a MediaViewFactory instance
   */
  createView: MediaViewFactory
};

var highlightProperty = 'outline-style';
var disableHighlights = function disableHighlights($element) {
  $element.css(highlightProperty, 'none').on('blur', function () {
    $element.off('blur').css(highlightProperty, '');
  });
};
var disableHighlightsOnMouseClick = function disableHighlightsOnMouseClick($element, e) {
  if (e.screenX || e.screenY) {
    disableHighlights($element);
  }
};
var checkIfElementIsHighlighted = function checkIfElementIsHighlighted($element) {
  var highlightState = $element.css(highlightProperty);
  return highlightState !== 'none' && highlightState !== '';
};
var highlightDisabler = {
  disableHighlights: disableHighlights,
  disableHighlightsOnMouseClick: disableHighlightsOnMouseClick,
  checkIfElementIsHighlighted: checkIfElementIsHighlighted
};

var _keyTypes = Object.freeze({
  escape: 1,
  space: 2,
  leftArrow: 3,
  upArrow: 4,
  rightArrow: 5,
  downArrow: 6,
  tab: 7,
  enter: 8,
  tableOfContents: 9
});
var isKeyPassedOfSameType = function isKeyPassedOfSameType(key, type) {
  switch (key.toLowerCase()) {
    case 'esc': // IE11 and Edge
    case 'escape':
      return type === _keyTypes.escape;
    case 'spacebar': // IE11
    case ' ':
      return type === _keyTypes.space;
    case 'left': // IE11 and Edge
    case 'arrowleft':
      return type === _keyTypes.leftArrow;
    case 'up': // IE11 and Edge
    case 'arrowup':
      return type === _keyTypes.upArrow;
    case 'right': // IE11 and Edge
    case 'arrowright':
      return type === _keyTypes.rightArrow;
    case 'down': // IE11 and Edge
    case 'arrowdown':
      return type === _keyTypes.downArrow;
    case 'tab':
      return type === _keyTypes.tab;
    case 'enter':
      return type === _keyTypes.enter;
    default:
      return isKeyOfLanguageSpecificType(key.toLowerCase(), type);
  }
};
var isKeyOfLanguageSpecificType = function isKeyOfLanguageSpecificType(key, type) {
  switch (localizationStrings.getLanguage()) {
    case languageCodes.ENGLISH:
      return isKeyOfEnglishSpecificType(key, type);
    case languageCodes.GERMAN:
      return isKeyOfGermanSpecificType(key, type);
    case languageCodes.JAPANESE:
      return isKeyOfJapaneseSpecificType(key, type);
    default:
      return false;
  }
};
var isKeyOfEnglishSpecificType = function isKeyOfEnglishSpecificType(key, type) {
  switch (key) {
    case 't':
      return type === _keyTypes.tableOfContents;
    default:
      return false;
  }
};
var isKeyOfGermanSpecificType = function isKeyOfGermanSpecificType(key, type) {
  switch (key) {
    case 'i':
      return type === _keyTypes.tableOfContents;
    default:
      return false;
  }
};
var isKeyOfJapaneseSpecificType = function isKeyOfJapaneseSpecificType(key, type) {
  switch (key) {
    case 't':
      return type === _keyTypes.tableOfContents;
    default:
      return false;
  }
};
var isKeyOfType = function isKeyOfType(key) {
  for (var i = 1; i < arguments.length; ++i) {
    if (isKeyPassedOfSameType(key, arguments[i])) {
      return true;
    }
  }
  return false;
};
var keys = Object.defineProperties({
  isKeyOfType: isKeyOfType
}, {
  keyTypes: {
    get: function get() {
      return _keyTypes;
    }
  }
});

var _previousActiveElement;
var _previousActiveElementWasHighlighted;
var _$focusTrapElement = null;
var _firstFocusableEl = null;
var _lastFocusableEl = null;
var _$window = $(window);
var scrollActiveElementIntoView = function scrollActiveElementIntoView() {
  try {
    var activeElement = document.activeElement;
    if (activeElement) {
      scrollIntoView(activeElement);
    }
  } catch (e) {
    /* eslint  no-empty:'off' */
  }
};
var scrollIntoView = function scrollIntoView(e) {
  setTimeout(function () {
    var element = e.currentTarget ? e.currentTarget : e;
    var container = $(element).scrollParent();
    if (!element || !container || !element.scrollIntoViewIfNeeded) {
      return;
    }

    // Android uses container innerHeight while ios uses window innerHeight
    var elementFitsInsideContainer = element.offsetHeight <= container.innerHeight() && element.offsetHeight < window.innerHeight;
    element.scrollIntoViewIfNeeded(elementFitsInsideContainer);
  }, 200);
};
var saveActiveElement = function saveActiveElement() {
  try {
    _previousActiveElement = document.activeElement;
    _previousActiveElementWasHighlighted = highlightDisabler.checkIfElementIsHighlighted($(document.activeElement));
  } catch (e) {
    /* eslint  no-empty:'off' */
  }
};
var disableHighlightsOnPreviousActiveElement = function disableHighlightsOnPreviousActiveElement() {
  if (_previousActiveElement) {
    var $previousActiveElement = $(_previousActiveElement);
    if (!_previousActiveElementWasHighlighted) {
      highlightDisabler.disableHighlights($previousActiveElement);
    }
  }
};
var focusPreviousElement = function focusPreviousElement() {
  if (_previousActiveElement) {
    var $previousActiveElement = $(_previousActiveElement);
    $previousActiveElement.focus();
    disableHighlightsOnPreviousActiveElement();
  }
};
var elementOrChildHasFocus = function elementOrChildHasFocus($element) {
  try {
    return $element.is(':focus') || $element.has(document.activeElement).length > 0;
  } catch (e) {
    return false;
  }
};
var getActiveElement = function getActiveElement(document) {
  document = document || window.document;
  if (document.body === document.activeElement || document.activeElement.tagName.toLowerCase() === 'iframe') {
    var iframes = document.getElementsByTagName('iframe');
    for (var i = 0; i < iframes.length; i++) {
      var focused = getActiveElement(iframes[i].contentWindow.document);
      if (focused !== false) {
        return focused;
      }
    }
  } else {
    return document.activeElement;
  }
  return false;
};
var onFocusTrapTab = function onFocusTrapTab(e) {
  var isTabPressed = keys.isKeyOfType(e.key, keys.keyTypes.tab);
  if (!isTabPressed) {
    return;
  }
  if (e.shiftKey && document.activeElement === _firstFocusableEl) {
    _lastFocusableEl.focus();
    e.preventDefault();
  } else if (!e.shiftKey && document.activeElement === _lastFocusableEl) {
    _firstFocusableEl.focus();
    e.preventDefault();
  }
};
var removeFocusTrap = function removeFocusTrap() {
  if (!_$focusTrapElement) {
    return;
  }
  _$focusTrapElement.off('keydown', onFocusTrapTab);
  _firstFocusableEl = null;
  _lastFocusableEl = null;
};
var trapFocus = function trapFocus($element) {
  if (_$focusTrapElement) {
    removeFocusTrap();
  }
  _$focusTrapElement = $element;
  var focusableEls = $element.find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="email"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
  _firstFocusableEl = focusableEls[0];
  _lastFocusableEl = focusableEls[focusableEls.length - 1];
  _$focusTrapElement.on('keydown', onFocusTrapTab);
};
var init$1 = function init() {
  _$window.blur(saveActiveElement).focus(disableHighlightsOnPreviousActiveElement);
};
init$1();
var viewHelper = {
  trapFocus: trapFocus,
  removeFocusTrap: removeFocusTrap,
  scrollActiveElementIntoView: scrollActiveElementIntoView,
  scrollIntoView: scrollIntoView,
  saveActiveElement: saveActiveElement,
  focusPreviousElement: focusPreviousElement,
  elementOrChildHasFocus: elementOrChildHasFocus,
  getActiveElement: getActiveElement
};

var rightParenRegex = /\)/gi;
var leftParenRegex = /\(/gi;
var playReplayControlStates = Object.freeze({
  none: 'none',
  playVideoDisplayed: 'playVideo',
  replayVideoDisplayed: 'replayVideo'
});

/**
 * @memberof TSC
 * @class BeforeAfterPlayControlsView
 * @param {jQuery} $container - Smart Player root dom element
 * @param {Object} playerConfiguration - Player configuration object
 * @classdesc View containing the large play video and replay video buttons at the beginning and end of videos
 */
var BeforeAfterPlayControlsView = function BeforeAfterPlayControlsView($container, playerConfiguration) {
  var _markup;
  var _$videoClickToPlayLink;
  var _$videoClickToReplayLink;
  var _$videoClickToPlayGraphic;
  var _$videoClickToReplayGraphic;
  var _$pluginContainer;
  var _viewState = playReplayControlStates.none;
  var onPlayHandler = function onPlayHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    if (playerConfiguration.disableInteractions) {
      return;
    }
    hideVideoClickToPlayLink();
    $container.trigger(events.Controls.HeroPlayControlClicked);
  };
  var showVideoClickToPlayLink = function showVideoClickToPlayLink() {
    _viewState = playReplayControlStates.playVideoDisplayed;
    _$videoClickToPlayLink.show();
    $container.trigger(events.Controls.HeroPlayControlVisible);
  };
  var hideVideoClickToPlayLink = function hideVideoClickToPlayLink() {
    _viewState = playReplayControlStates.none;
    _$videoClickToPlayLink.hide();
    $container.trigger(events.Controls.HeroPlayControlHidden);
  };
  var setVideoClickToPlayErrorState = function setVideoClickToPlayErrorState(state) {
    if (state) {
      _$videoClickToPlayLink.addClass('video-click-to-play-error');
    } else {
      _$videoClickToPlayLink.removeClass('video-click-to-play-error');
    }
  };
  var hideVideoClickToReplayLink = function hideVideoClickToReplayLink() {
    if (_viewState === playReplayControlStates.replayVideoDisplayed) {
      _viewState = playReplayControlStates.none;
      _$videoClickToReplayLink.hide();
      $container.trigger(events.Controls.ReplayControlHidden);
    }
  };
  var showVideoClickToReplayLink = function showVideoClickToReplayLink() {
    _viewState = playReplayControlStates.replayVideoDisplayed;
    _$videoClickToReplayLink.show();
    $container.trigger(events.Controls.ReplayControlVisible);
    if (viewHelper.elementOrChildHasFocus($container)) {
      _$videoClickToReplayGraphic.focus();
      highlightDisabler.disableHighlights(_$videoClickToReplayGraphic);
    }
  };
  var addVideoClickToPlayBackground = function addVideoClickToPlayBackground(posterSrc) {
    posterSrc = posterSrc.replace(rightParenRegex, '\\\)');
    posterSrc = posterSrc.replace(leftParenRegex, '\\\(');
    var url = 'url(' + posterSrc + ')';
    _$videoClickToPlayLink.css('background-image', url);
    _$videoClickToReplayLink.css('background-image', url);
  };
  var replayHandler = function replayHandler(e) {
    e.stopPropagation();
    hideVideoClickToReplayLink();
    $container.trigger(events.Media.Replay);
  };
  var disableControls = function disableControls() {
    _$videoClickToReplayGraphic && _$videoClickToReplayGraphic.attr('tabindex', tabIndex.Disabled);
  };
  var enableControls = function enableControls() {
    _$videoClickToReplayGraphic && _$videoClickToReplayGraphic.attr('tabindex', tabIndex.DomOrder);
  };
  var toggleFullscreen = function toggleFullscreen() {
    $container.trigger(events.Controls.ToggleFullScreen);
  };
  var createView = function createView() {
    _markup = templateGenerator.generateBeforeAfterPlayControlsMarkup();
    $container.find('.before-after-play-controls').html(_markup);
    _$videoClickToPlayLink = $container.find('.video-click-to-play-link');
    _$videoClickToReplayLink = $container.find('.video-click-to-replay-link');
    _$videoClickToPlayGraphic = $container.find('.video-click-to-play');
    _$videoClickToReplayGraphic = $container.find('.video-click-to-replay');
    _$pluginContainer = $container.find('.before-after-plugin-container');
    _$videoClickToReplayLink.hide();
    if (viewHelper.elementOrChildHasFocus($container)) {
      _$videoClickToPlayGraphic.focus();
      highlightDisabler.disableHighlights(_$videoClickToPlayGraphic);
    }
  };
  var initPlugins = function initPlugins(event, data) {
    var pluginController = playerConfiguration.getPluginController();
    if (pluginController && data.viewElementType === supportedPluginViewElements.BEFORE_AFTER_PLAY_CONTROLS) {
      pluginController.initializePluginsForViewElement(supportedPluginViewElements.BEFORE_AFTER_PLAY_CONTROLS, _$pluginContainer);
    }
  };
  var bindEvents = function bindEvents() {
    $container.on(events.Media.TryToAutoPlay, hideVideoClickToPlayLink);
    $container.on(events.Modals.Open, disableControls);
    $container.on(events.Modals.Closed, enableControls);
    $container.on(events.Plugin.Added, initPlugins);
    _$videoClickToReplayLink.on('dblclick', toggleFullscreen);
    _$videoClickToReplayGraphic.on('click', replayHandler);
    _$videoClickToPlayLink.on('click', onPlayHandler);
  };
  var disableClickToPlayEvents = function disableClickToPlayEvents() {
    _$videoClickToPlayLink.addClass('noClickToPlayEvents');
  };
  var destroy = function destroy() {
    $container.off(events.Media.TryToAutoPlay, hideVideoClickToPlayLink);
    $container.off(events.Modals.Open, disableControls);
    $container.off(events.Modals.Closed, enableControls);
    $container.off(events.Plugin.Added, initPlugins);
    _$videoClickToReplayLink.off('dblclick', toggleFullscreen);
    _$videoClickToReplayGraphic.off('click', replayHandler);
    _$videoClickToPlayLink.off('click', onPlayHandler);
  };
  createView();
  bindEvents();
  return Object.defineProperties({
    showVideoClickToPlayLink: showVideoClickToPlayLink,
    hideVideoClickToPlayLink: hideVideoClickToPlayLink,
    setVideoClickToPlayErrorState: setVideoClickToPlayErrorState,
    hideVideoClickToReplayLink: hideVideoClickToReplayLink,
    showVideoClickToReplayLink: showVideoClickToReplayLink,
    addVideoClickToPlayBackground: addVideoClickToPlayBackground,
    disableClickToPlayEvents: disableClickToPlayEvents,
    destroy: destroy
  }, {
    viewState: {
      get: function get() {
        return _viewState;
      }
    }
  });
};
var BeforeAfterPlayControlsView$1 = {
  /**
   *  Factory method that returns a new BeforeAfterPlayControlsView object.
   *  @function create
   *  @memberof TSC.BeforeAfterPlayControlsView
   *  @static
   *  @param {jQuery} $container - Smart Player root dom element
   *  @param {Object} playerConfiguration - Player configuration object
   *  @return new BeforeAfterPlayControlsView instance
   */
  create: BeforeAfterPlayControlsView
};

var mouseButtons = Object.freeze({
  mainButton: 0,
  auxiliaryButton: 1,
  secondaryButton: 2
});

/**
 * @memberof TSC
 * @class ProgressChapterModel
 * @classdesc Progress Chapter View Model
 * @param {Number} index - Index of the chapter
 * @param {String} name - Chapter name
 * @param {Number} startTime - Start time of the video for the chapter (in seconds)
 * @param {Number} startAsPercent - Percentage of the video when the chapter starts
 * @param {Number} endAsPercent - Percentage of the video when the chapter ends
 * @param {Number} durationAsPercent - Duration of the chapter as a percentage of the video duration
 * @param {jQuery} $chapterElement - jQuery wrapper of the chapter element
 */
var ProgressChapterModel = function ProgressChapterModel(index, name, startTime, startAsPercent, endAsPercent, durationAsPercent, $chapterElement) {
  var _index = index;
  var _name = name;
  var _startTime = startTime;
  var _startAsPercent = startAsPercent;
  var _endAsPercent = endAsPercent;
  var _durationAsPercent = durationAsPercent;
  var _$chapterElement = $chapterElement;
  var _$loadProgressElement = $chapterElement.find('.load-progress');
  var _$seekHintProgressElement = $chapterElement.find('.seek-hint-progress');
  var _$playProgressElement = $chapterElement.find('.play-progress');
  return Object.defineProperties({}, {
    index: {
      get: function get() {
        return _index;
      }
    },
    name: {
      get: function get() {
        return _name;
      }
    },
    startTime: {
      get: function get() {
        return _startTime;
      }
    },
    startAsPercent: {
      get: function get() {
        return _startAsPercent;
      }
    },
    endAsPercent: {
      get: function get() {
        return _endAsPercent;
      }
    },
    durationAsPercent: {
      get: function get() {
        return _durationAsPercent;
      }
    },
    $element: {
      get: function get() {
        return _$chapterElement;
      }
    },
    $loadProgressElement: {
      get: function get() {
        return _$loadProgressElement;
      }
    },
    $seekHintProgressElement: {
      get: function get() {
        return _$seekHintProgressElement;
      }
    },
    $playProgressElement: {
      get: function get() {
        return _$playProgressElement;
      }
    }
  });
};
var ProgressChapterModel$1 = {
  /**
   *  Factory method that returns a new ProgressChapterModel object.
   *  @function create
   *  @memberof TSC.ProgressChapterModel
   *  @static
   *  @param {Number} index - Index of the chapter
   *  @param {String} name - Chapter name
   *  @param {Number} startTime - Start time of the video for the chapter (in seconds)
   *  @param {Number} startAsPercent - Percentage of the video when the chapter starts
   *  @param {Number} endAsPercent - Percentage of the video when the chapter ends
   *  @param {Number} durationAsPercent - Duration of the chapter as a percentage of the video duration
   *  @param {jQuery} $chapterElement - jQuery wrapper of the chapter element
   *  @return new ProgressChapterModel instance
   */
  create: ProgressChapterModel
};

/**
 *  Utility function that find the rectangle for the video frame in the video thumbnails sprite sheet.
 *  @function getThumbnailRectangleByTime
 *  @param {Number} timeInSeconds - Time in seconds to locate the video thumbnail
 *  @param {Number} videoThumbnailInterval - The interval in time between generated thumbnails in sprite sheet.
 *  @param {Number} videoThumbnailColumns - The max number of columns in the sprite sheet.
 *  @param {Number} videoThumbnailWidth - The width of a video frame thumbnail.
 *  @param {Number} videoThumbnailHeight - The height of a video frame thumbnail.
 *  @returns {Object} An object that contains the x, y, width, height of the video thumbnail frame.
 */
var getThumbnailRectangleByTime = function getThumbnailRectangleByTime(timeInSeconds, videoThumbnailInterval, videoThumbnailColumns, videoThumbnailWidth, videoThumbnailHeight) {
  var timeIndex = Math.floor(timeInSeconds / videoThumbnailInterval);
  var row = Math.floor(timeIndex / videoThumbnailColumns);
  var column = timeIndex - videoThumbnailColumns * row;
  return {
    x: column * videoThumbnailWidth,
    y: row * videoThumbnailHeight,
    width: videoThumbnailWidth,
    height: videoThumbnailHeight
  };
};

var SHIFT_KEY_SKIP_DURATION_MODIFIER = 4;
var SCRUB_PREVIEW_OFFSET = 10;
var SCRUB_PREVIEW_BOX_PADDING = 8;
var MAX_NUMBER_CHAPTERS_CAN_RENDER = 100;
var MAX_LOAD_VALUE = 100;
var CHECK_VIDEO_LOAD_PROGRESS_INTERVAL = 1000;
var HIDE_SCRUB_PREVIEW_DELAY = 200;

/**
 * @memberof TSC
 * @class ProgressBarControlView
 * @classdesc Video progress bar view
 * @param {jQuery} $container - Smart Player root dom element
 * @param {HTMLVideoElement} mediaElement
 * @param {TSC.Quiz} quizModel
 */
var ProgressBarControlView = function ProgressBarControlView($container, mediaElement, quizModel) {
  var markup = templateGenerator.generateProgressBarMarkup();
  $container.find('.progress-bar-control').html(markup);
  var _$document = windowWrapper.getDocument(true);
  var _documentRef = _$document[0];
  var _windowRef = windowWrapper.getWindow();
  var _requestAnimationId = null;
  var _scrubbing = false;
  var _lastScrubTime = 0;
  var _wasPlayingBeforeSeek = false;
  var _playStatusAfterSeek = false;
  var _quizModel = quizModel;
  var _$playTimeDisplay = $container.find('.play-time');
  var _$scrubBar = $container.find('.progress-scrubbar-track');
  var _$scrubbarTrack = $container.find('.scrubbar-track');
  var _$quizMarkers = $container.find('.markers');
  var _$scrubPreview = $container.find('.scrub-preview');
  var _videoThumbnailImage;
  var _$scrubVideoThumbnail = _$scrubPreview.find('.video-thumbnail');
  var _$hiddenVideoThumbnail = _$scrubPreview.find('.hidden-video-thumbnail');
  var _scrubVideoThumbnailCanvasCtx = null;
  var _$scrubPreviewChapterName = _$scrubPreview.find('.chapter-name');
  var _$scrubPreviewVideoTime = _$scrubPreview.find('.video-time');
  var _$pluginContainer = $container.find('.plugin-container');
  var _markers = [];
  var _keysEnabled = true;
  var _durationDisplayInitialized = false;
  var _markersCreated = false;
  var _formattedDuration;
  var _readableDuration;
  var _lastUpdatedFormattedMediaTime = -1;
  var _lastUpdatedScrubTime = -1;
  var _showSeekPreview = false;
  var _lastSeekHintVideoPercent = -1;
  var _lastSeekPreviewDetails = {
    hideThumbnail: false,
    videoTimeInSeconds: 0,
    displayAtVideoPercent: -1,
    chapterName: null,
    formattedVideoTime: null
  };
  var _chaptersCache = [];
  var _shouldRespectQuizMarkers = false;
  var _updateBufferedTimeout = -1;
  var _hideSeekPreviewTimeoutId = -1;
  var _currentProgressBarWidth = 0;
  var setShouldRespectQuizMarkers = function setShouldRespectQuizMarkers(newShouldRespectQuizMarkers) {
    _shouldRespectQuizMarkers = newShouldRespectQuizMarkers;
  };
  var shouldRespectQuizMarkers = function shouldRespectQuizMarkers() {
    return _shouldRespectQuizMarkers;
  };
  var getClickX = function getClickX(event) {
    if (event.targetTouches && event.targetTouches[0] && event.targetTouches[0].pageX) {
      return event.targetTouches[0].pageX;
    }
    return event.pageX;
  };
  var getClosestRequiredQuizMarkerTimeBeforeVideoTime = function getClosestRequiredQuizMarkerTimeBeforeVideoTime(timeInSeconds) {
    if (!shouldRespectQuizMarkers()) {
      return null;
    }
    var timeInMilliseconds = timeInSeconds * 1000;
    for (var i = 0; i < _quizModel.questionSetMarkerTimes.length; i++) {
      if (_quizModel.questionSetMarkerTimes[i].startTime <= timeInMilliseconds && !_quizModel.questionSetMarkerTimes[i].canSeekPast) {
        return _quizModel.questionSetMarkerTimes[i].startTime / 1000;
      }
    }
    return null;
  };
  var allowSkipQuestionSetMarkersBeforeTime = function allowSkipQuestionSetMarkersBeforeTime(timeInSeconds) {
    if (!shouldRespectQuizMarkers()) {
      return;
    }
    var timeInMilliseconds = timeInSeconds * 1000;
    _quizModel.questionSetMarkerTimes.forEach(function (questionSetMarker) {
      questionSetMarker.canSeekPast = questionSetMarker.startTime < timeInMilliseconds;
    });
  };
  var resetSeekPastFlagForQuizMarkersPastTime = function resetSeekPastFlagForQuizMarkersPastTime(timeInSeconds) {
    if (!shouldRespectQuizMarkers()) {
      return;
    }
    var timeInMilliseconds = timeInSeconds * 1000;
    _quizModel.questionSetMarkerTimes.forEach(function (questionSetMarker) {
      if (timeInMilliseconds <= questionSetMarker.startTime) {
        questionSetMarker.canSeekPast = false;
      }
    });
  };
  var getChapterNameAtVideoTime = function getChapterNameAtVideoTime(videoTimeInMilliseconds) {
    for (var i = _chaptersCache.length - 1; i >= 0; i--) {
      if (videoTimeInMilliseconds >= _chaptersCache[i].startTime) {
        return _chaptersCache[i].name;
      }
    }
    return null;
  };
  var getChapterPercentageFromTotalPercentage = function getChapterPercentageFromTotalPercentage(totalPercent, chapter) {
    if (totalPercent >= chapter.startAsPercent && totalPercent <= chapter.endAsPercent) {
      return (totalPercent - chapter.startAsPercent) / chapter.durationAsPercent * 100;
    } else if (totalPercent > chapter.endAsPercent) {
      return 100;
    }
    return 0;
  };
  var getVideoTimeFromXPosition = function getVideoTimeFromXPosition(xPos) {
    var closestRequiredQuizMarker;
    var relativeXPos = xPos - _$scrubBar.offset().left;
    var scrubBarWidth = _$scrubBar.width();
    var amountPlayedPercentage = Math.max(Math.min(relativeXPos / scrubBarWidth, 1), 0);
    var pendingVideoTime = mediaElement.duration * amountPlayedPercentage;
    closestRequiredQuizMarker = getClosestRequiredQuizMarkerTimeBeforeVideoTime(pendingVideoTime);
    return {
      videoTime: pendingVideoTime,
      closestRequiredQuizMarker: closestRequiredQuizMarker
    };
  };
  var updateLoadProgress = function updateLoadProgress(progress) {
    _chaptersCache.forEach(function (chapter) {
      chapter.$loadProgressElement.css({
        width: getChapterPercentageFromTotalPercentage(progress, chapter) + '%'
      });
    });
  };
  var onDownSeek = function onDownSeek(e) {
    e.preventDefault();
    if (_scrubbing) {
      return;
    }
    _$document.on('pointermove touchmove', onMoveSeek);
    // Safari needs mouseup, Safari reports wrong event.buttons code after user
    // right clicks on player.  This causes pepjs to report pointerup event as pointermove event
    _$document.on('pointerup mouseup touchend mouseleave', onUpSeek);
    if (!mediaElement.paused) {
      _wasPlayingBeforeSeek = true;
      mediaElement.pause();
    } else {
      _wasPlayingBeforeSeek = false;
    }
    _playStatusAfterSeek = _wasPlayingBeforeSeek;
    setScrubbing(true);
    _lastUpdatedScrubTime = -1;
    setPlayProgress(getClickX(e.originalEvent));
  };
  var moveScrubPreview = function moveScrubPreview(videoPercent) {
    var scrubBarWidth = _$scrubBar.width();
    var previewLeftPos = scrubBarWidth * videoPercent;
    var scrubPreviewWidth = _$scrubPreview.width();
    previewLeftPos -= scrubPreviewWidth / 2;
    if (previewLeftPos < SCRUB_PREVIEW_OFFSET) {
      previewLeftPos = SCRUB_PREVIEW_OFFSET;
    } else if (previewLeftPos + scrubPreviewWidth > scrubBarWidth - SCRUB_PREVIEW_OFFSET) {
      previewLeftPos = scrubBarWidth - (SCRUB_PREVIEW_OFFSET + scrubPreviewWidth);
    }
    _$scrubPreview.css('left', previewLeftPos + 'px');
  };
  var drawSeekHint = function drawSeekHint(videoPercent) {
    var videoPercentNormalized = videoPercent * 100;
    _chaptersCache.forEach(function (chapter) {
      chapter.$seekHintProgressElement.css({
        width: getChapterPercentageFromTotalPercentage(videoPercentNormalized, chapter) + '%'
      });
    });
  };
  var updateScrubPreviewText = function updateScrubPreviewText(chapterName, formattedVideoTime) {
    var previewDisplayText = '';
    if (_lastSeekPreviewDetails.hideThumbnail) {
      previewDisplayText = localizationStrings.getPlayerString(playerStringNames.hideThumbnailDueToQuiz);
    } else if (chapterName) {
      previewDisplayText = chapterName;
    }
    _$scrubPreviewChapterName.text(previewDisplayText);
    _$scrubPreviewVideoTime.text(formattedVideoTime);
  };
  var setScrubPreviewDetailsAtTime = function setScrubPreviewDetailsAtTime(videoSeekTimes) {
    var unrestrictedVideoPercent = videoSeekTimes.videoTime / mediaElement.duration;
    var restrictedVideoPercent = videoSeekTimes.closestRequiredQuizMarker !== null ? videoSeekTimes.closestRequiredQuizMarker / mediaElement.duration : unrestrictedVideoPercent;
    _lastSeekPreviewDetails.videoTimeInSeconds = videoSeekTimes.videoTime;
    _lastSeekPreviewDetails.hideThumbnail = unrestrictedVideoPercent !== restrictedVideoPercent;
    _lastSeekPreviewDetails.chapterName = getChapterNameAtVideoTime(videoSeekTimes.videoTime * 1000);
    _lastSeekPreviewDetails.formattedVideoTime = timeFormatter.formatTime(videoSeekTimes.videoTime);
    _lastSeekPreviewDetails.displayAtVideoPercent = unrestrictedVideoPercent;
    _lastSeekHintVideoPercent = restrictedVideoPercent;
  };
  var onMouseMoveToPreview = function onMouseMoveToPreview(e) {
    var videoSeekTimes = getVideoTimeFromXPosition(getClickX(e.originalEvent));
    setScrubPreviewDetailsAtTime(videoSeekTimes);
  };
  var clearHideScrubPreviewDelay = function clearHideScrubPreviewDelay() {
    _hideSeekPreviewTimeoutId !== -1 && clearTimeout(_hideSeekPreviewTimeoutId);
    _hideSeekPreviewTimeoutId = -1;
  };
  var showScrubPreview = function showScrubPreview(e) {
    clearHideScrubPreviewDelay();
    _showSeekPreview = true;
    onMouseMoveToPreview(e);
    updateSeekHint();
    _$scrubPreview.show();
    _$document.on('pointermove touchmove', onMouseMoveToPreview);
  };
  var hideScrubPreview = function hideScrubPreview() {
    _hideSeekPreviewTimeoutId = -1;
    _showSeekPreview = false;
    _$scrubPreview.hide();
    _chaptersCache.forEach(function (chapter) {
      chapter.$seekHintProgressElement.css({
        width: '0'
      });
    });
    _$document.off('pointermove touchmove', onMouseMoveToPreview);
  };
  var onScrubBarMouseOut = function onScrubBarMouseOut() {
    clearHideScrubPreviewDelay();
    _hideSeekPreviewTimeoutId = setTimeout(hideScrubPreview, HIDE_SCRUB_PREVIEW_DELAY);
  };
  var onMoveSeek = function onMoveSeek(e) {
    if (!_scrubbing) {
      return;
    }
    if (!mediaElement.paused) {
      mediaElement.pause();
    }
    setPlayProgress(getClickX(e.originalEvent));
  };
  var onUpSeek = function onUpSeek() {
    if (!_scrubbing) {
      return;
    }
    _$document.off('pointermove touchmove', onMoveSeek);
    _$document.off('pointerup mouseup touchend mouseleave', onUpSeek);
    var atVideoEndTime = Number(mediaElement.currentTime.toFixed(2)) >= Number(mediaElement.duration.toFixed(2));
    if (_playStatusAfterSeek && !atVideoEndTime) {
      mediaElement.play();
    }
    setScrubbing(false);
  };
  var setPlayProgress = function setPlayProgress(xPos) {
    var videoTimes = getVideoTimeFromXPosition(xPos);
    if (videoTimes.closestRequiredQuizMarker) {
      _playStatusAfterSeek = false;
    } else {
      _playStatusAfterSeek = _wasPlayingBeforeSeek;
    }
    _lastScrubTime = videoTimes.closestRequiredQuizMarker || videoTimes.videoTime;
  };
  var updatePlayProgress = function updatePlayProgress() {
    if (mediaElement.duration === 0) {
      return;
    }
    if (_scrubbing) {
      if (_lastScrubTime === _lastUpdatedScrubTime || _lastScrubTime < 0) {
        return;
      }
      _lastUpdatedScrubTime = _lastScrubTime;
      if (mediaElement.ended) {
        $container.trigger(events.Media.Replay, {
          time: _lastScrubTime,
          playAfterSeek: false
        });
      } else {
        $container.trigger(events.Media.SeekToTime, {
          time: _lastScrubTime
        });
      }
      updateUi(_lastScrubTime);
    } else {
      if (mediaElement.seeking) {
        return;
      }
      updateUi(mediaElement.currentTime);
    }
  };
  var updateVideoThumbnail = function updateVideoThumbnail() {
    if (!_scrubVideoThumbnailCanvasCtx) {
      return;
    }
    if (_lastSeekPreviewDetails.hideThumbnail) {
      _$hiddenVideoThumbnail.addClass(cssClasses.hiddenVideoThumbnailVisible);
      _$scrubVideoThumbnail.hide();
    } else {
      _$hiddenVideoThumbnail.removeClass(cssClasses.hiddenVideoThumbnailVisible);
      _$scrubVideoThumbnail.show();
      var thumbnailRect = getThumbnailRectangleByTime(_lastSeekPreviewDetails.videoTimeInSeconds, playerConfiguration.videoThumbnailInterval, playerConfiguration.videoThumbnailColumns, playerConfiguration.videoThumbnailWidth, playerConfiguration.videoThumbnailHeight);
      _scrubVideoThumbnailCanvasCtx.drawImage(_videoThumbnailImage, thumbnailRect.x, thumbnailRect.y, thumbnailRect.width, thumbnailRect.height, 0, 0, playerConfiguration.videoThumbnailWidth, playerConfiguration.videoThumbnailHeight);
    }
  };
  var updateSeekHint = function updateSeekHint() {
    if (!_showSeekPreview) {
      return;
    }
    updateVideoThumbnail();
    updateScrubPreviewText(_lastSeekPreviewDetails.chapterName, _lastSeekPreviewDetails.formattedVideoTime);
    moveScrubPreview(_lastSeekPreviewDetails.displayAtVideoPercent);
    drawSeekHint(_lastSeekHintVideoPercent);
  };
  var updateUi = function updateUi(currentTime) {
    var percentPlayed = currentTime / mediaElement.duration * 100;
    _chaptersCache.forEach(function (chapter) {
      chapter.$playProgressElement.css({
        width: getChapterPercentageFromTotalPercentage(percentPlayed, chapter) + '%'
      });
    });
    updateTimeDisplay(currentTime);
  };
  var updateTimeDisplay = function updateTimeDisplay(currentTime) {
    var formattedCurrentTime = timeFormatter.formatTime(currentTime);
    if (formattedCurrentTime === _lastUpdatedFormattedMediaTime && _durationDisplayInitialized) {
      return;
    }
    _lastUpdatedFormattedMediaTime = formattedCurrentTime;
    var progressDisplayText = formattedCurrentTime;
    if (!_durationDisplayInitialized && mediaElement.duration) {
      _durationDisplayInitialized = true;
      _formattedDuration = timeFormatter.formatTime(mediaElement.duration);
      _readableDuration = timeFormatter.formatTimeForReadability(mediaElement.duration);
      _$scrubBar.attr('aria-valuemax', mediaElement.duration);
    }
    if (_durationDisplayInitialized) {
      progressDisplayText += ' / ' + _formattedDuration;
      _$playTimeDisplay.html(progressDisplayText);
      var ariaValueText = timeFormatter.formatTimeForReadability(currentTime) + localizationStrings.getPlayerString(playerStringNames.accessProgressBarTimeConjunction) + _readableDuration;
      _$scrubBar.attr('aria-valuenow', currentTime);
      _$scrubBar.attr('aria-valuetext', ariaValueText);
    }
  };
  var setMarkersXPos = function setMarkersXPos() {
    var markerSize = 4;
    var mediaDurationInMilliseconds = mediaElement.duration * 1000;
    var xPos = 0;
    var timePercent = 0;
    var quizMarkerContainerWidth = _$quizMarkers.width();
    _quizModel.questionSetMarkerTimes.forEach(function (questionSetMarker, i) {
      timePercent = questionSetMarker.startTime / mediaDurationInMilliseconds;
      xPos = Math.round(quizMarkerContainerWidth * timePercent - markerSize / 2);
      var marker = _markers[i];
      marker && marker.css('left', xPos + 'px');
    });
  };
  var cacheProgressBarWidth = function cacheProgressBarWidth() {
    _currentProgressBarWidth = _$scrubBar.width();
  };
  var onPlayerResize = function onPlayerResize() {
    updateQuizMarkers();
    cacheProgressBarWidth();
  };
  var updateQuizMarkers = function updateQuizMarkers() {
    if (!shouldRespectQuizMarkers()) {
      return;
    }
    if (!_markersCreated) {
      createQuizMarkers();
    }
    updateMarkerVisibility();
  };
  var updateMarkerVisibility = function updateMarkerVisibility() {
    _quizModel.questionSetMarkerTimes.forEach(function (questionSetMarker, i) {
      if (questionSetMarker.completed) {
        var marker = _markers[i];
        marker && marker.hide();
      }
    });
    setMarkersXPos();
  };
  var createQuizMarkers = function createQuizMarkers() {
    if (!shouldRespectQuizMarkers()) {
      return;
    }
    _markersCreated = true;
    _quizModel.questionSetMarkerTimes.forEach(function () {
      _markers.push($('<div></div>').addClass('quiz-marker'));
    });
    _$quizMarkers.append(_markers);
  };
  var blockTextSelection = function blockTextSelection() {
    _documentRef.body.focus();
    _documentRef.onselectstart = function () {
      return false;
    };
  };
  var unblockTextSelection = function unblockTextSelection() {
    _documentRef.onselectstart = function () {
      return true;
    };
  };
  var setScrubbing = function setScrubbing(value) {
    _scrubbing = value;
    if (_scrubbing) {
      blockTextSelection();
      $container.trigger(events.Scrubbing.Started);
    } else {
      unblockTextSelection();
      $container.trigger(events.Scrubbing.Ended);
    }
  };
  var alertScreenReaderFastForwardIsDisabled = function alertScreenReaderFastForwardIsDisabled() {
    var fastForwardDisabledText = localizationStrings.getPlayerString(playerStringNames.fastForwardDisabledScreenReaderText);
    var screenReaderAlertMarkup = templateGenerator.generateScreenReaderAlertMarkup(fastForwardDisabledText);
    var $screenReaderAlert = $(screenReaderAlertMarkup);
    $container.append($screenReaderAlert);
  };
  var keyPressed = function keyPressed(e) {
    if (!_keysEnabled) {
      return;
    }
    var timeToSkip = e.shiftKey ? SHIFT_KEY_SKIP_DURATION_MODIFIER * playerConfiguration.skipVideoDuration : playerConfiguration.skipVideoDuration;
    if (keys.isKeyOfType(e.key, keys.keyTypes.rightArrow)) {
      if (playerConfiguration.allowFastForward) {
        mediaElement.currentTime = videoApiUtils.getSafeSeekTime(mediaElement, mediaElement.currentTime + timeToSkip);
      } else {
        alertScreenReaderFastForwardIsDisabled();
      }
    } else if (keys.isKeyOfType(e.key, keys.keyTypes.leftArrow)) {
      mediaElement.currentTime = videoApiUtils.getSafeSeekTime(mediaElement, mediaElement.currentTime - timeToSkip);
    } else if (keys.isKeyOfType(e.key, keys.keyTypes.space) && _documentRef.activeElement === _$scrubBar[0]) {
      e.preventDefault();
      if (mediaElement.paused) {
        mediaElement.play();
      } else {
        mediaElement.pause();
      }
    }
  };
  var onMousedown = function onMousedown(e) {
    if (e.button === mouseButtons.mainButton) {
      onDownSeek(e);
    } else {
      highlightDisabler.disableHighlights($(this));
    }
  };
  var disableKeyListeners = function disableKeyListeners() {
    _$scrubBar.attr('tabindex', tabIndex.Disabled);
    _keysEnabled = false;
  };
  var enableKeyListeners = function enableKeyListeners() {
    _$scrubBar.attr('tabindex', tabIndex.DomOrder);
    _keysEnabled = true;
  };
  var getXPositionForQuestionSetMarker = function getXPositionForQuestionSetMarker(questionSetMarkerId) {
    if (!shouldRespectQuizMarkers()) {
      return;
    }
    var questionSetMarker = null;
    var mediaDurationInMilliseconds = mediaElement.duration * 1000;
    var measuredContainerWidth = $container.width();
    var measuredQuizMarkerWidth = _$quizMarkers.width();
    // use the max width, when control is hidden width measurement is not correct.
    var usedElementWidth = Math.max(measuredContainerWidth, measuredQuizMarkerWidth);
    var scrubBarLeftOffset = _$scrubBar.offset().left;
    for (var i = 0; i < _quizModel.questionSetMarkerTimes.length; i++) {
      questionSetMarker = quizModel.questionSetMarkerTimes[i];
      if (questionSetMarker.questionSetIndex === questionSetMarkerId) {
        var timePercent = questionSetMarker.startTime / mediaDurationInMilliseconds;
        return Math.round(usedElementWidth * timePercent) + scrubBarLeftOffset;
      }
    }
  };
  var onQuizzingCompleteHandler = function onQuizzingCompleteHandler() {
    allowSkipQuestionSetMarkersBeforeTime(mediaElement.currentTime);
  };
  var onMediaSeekedEvent = function onMediaSeekedEvent() {
    resetSeekPastFlagForQuizMarkersPastTime(mediaElement.currentTime);
  };
  var onLoadedMetadata = function onLoadedMetadata() {
    _$scrubBar.show();
    updateQuizMarkers();
    cacheProgressBarWidth();
  };
  var createDefaultChapter = function createDefaultChapter() {
    var progressBarChapterSegmentMarkup = templateGenerator.generateProgressBarChapterSegmentMarkup(0);
    var $chapterElement = $(progressBarChapterSegmentMarkup);
    $chapterElement.css('width', '100%');
    _$scrubbarTrack.append($chapterElement);
    _chaptersCache = [ProgressChapterModel$1.create(0, null, 0, 0, 100, 100, $chapterElement)];
  };
  var onVideoThumbnailLoaded = function onVideoThumbnailLoaded() {
    _scrubVideoThumbnailCanvasCtx = _$scrubVideoThumbnail[0].getContext('2d');
    _videoThumbnailImage.onload = undefined;
    _videoThumbnailImage.onerror = undefined;
  };
  var loadVideoThumbnailsImage = function loadVideoThumbnailsImage() {
    _videoThumbnailImage = new Image();
    _videoThumbnailImage.onload = onVideoThumbnailLoaded;
    _videoThumbnailImage.onerror = function () {
      _videoThumbnailImage.onload = undefined;
      _videoThumbnailImage.onerror = undefined;
      _videoThumbnailImage = null;
    };
    _videoThumbnailImage.src = playerConfiguration.videoThumbnailsSrc;
  };
  var initPlugins = function initPlugins() {
    var pluginController = playerConfiguration.getPluginController();
    if (!pluginController) {
      return;
    }
    pluginController.initializePluginsForViewElement(supportedPluginViewElements.PROGRESS_BAR, _$pluginContainer);
  };
  var onAddPlugin = function onAddPlugin() {
    initPlugins();
  };
  var setup = function setup() {
    _$scrubBar.attr('aria-valuemin', 0);
    if (playerConfiguration.allowFastForward) {
      _$scrubBar.on('touchstart', onDownSeek);
      _$scrubBar.on('mousedown', onMousedown);
      _$scrubBar.on('mouseover touchstart', showScrubPreview);
      _$scrubBar.on('mouseout touchend', onScrubBarMouseOut);
    } else {
      _$scrubBar.addClass(cssClasses.progressBarTrackPreventSeeking);
    }
    $container.on('keydown', keyPressed);
    $container.on(events.Modals.Open, disableKeyListeners);
    $container.on(events.Modals.Closed, enableKeyListeners);
    $container.on(events.Controls.Disable, disableKeyListeners);
    $container.on(events.Controls.Enable, enableKeyListeners);
    $container.on(events.Quizzing.Complete, onQuizzingCompleteHandler);
    $container.on(events.Controls.PlayerResize, onPlayerResize);
    $container.on(events.Plugin.Added, onAddPlugin);
    mediaElement.addEventListener(events.ExternalVideo.VideoSeeked, onMediaSeekedEvent);
    mediaElement.addEventListener(events.ExternalVideo.VideoLoadedMetadata, onLoadedMetadata);
    mediaElement.addEventListener(events.ExternalVideo.VideoDurationChange, onVideoDurationChange);
    mediaElement.addEventListener(events.ExternalVideo.VideoProgress, onVideoProgress);
    var onRequestAnimationFrame = function onRequestAnimationFrame() {
      updatePlayProgress();
      updateSeekHint();
      _requestAnimationId = _windowRef.requestAnimationFrame(onRequestAnimationFrame);
    };
    _requestAnimationId = _windowRef.requestAnimationFrame(onRequestAnimationFrame);

    // will be re-shown when metadata loads
    cacheProgressBarWidth();
    _$scrubBar.hide();
    if (!playerConfiguration.videoThumbnailsSrc) {
      _$scrubVideoThumbnail.hide();
    } else {
      _$scrubPreview.addClass(cssClasses.scrubPreviewHasThumbnail);
      _$scrubPreview.css({
        width: "".concat(playerConfiguration.videoThumbnailWidth + SCRUB_PREVIEW_BOX_PADDING, "px")
      });
      _$hiddenVideoThumbnail.css({
        width: "".concat(playerConfiguration.videoThumbnailWidth, "px"),
        height: "".concat(playerConfiguration.videoThumbnailHeight, "px")
      });
      _$scrubVideoThumbnail.attr('width', "".concat(playerConfiguration.videoThumbnailWidth, "px"));
      _$scrubVideoThumbnail.attr('height', "".concat(playerConfiguration.videoThumbnailHeight, "px"));
      loadVideoThumbnailsImage();
    }
    createDefaultChapter();
    initPlugins();
  };
  var createTocChapters = function createTocChapters(xmpTocItems) {
    if (!mediaElement.duration) {
      return;
    }
    // limit number chapters the player will render, protect from kayak man projects :)
    if (xmpTocItems.length > MAX_NUMBER_CHAPTERS_CAN_RENDER) {
      console.info('The Table of contents contains too many items to render in the progress bar.'); // eslint-disable-line
      return;
    }
    _$scrubbarTrack.empty();
    _chaptersCache = [];
    var mediaDurationInMilliseconds = mediaElement.duration * 1000;
    var lastStartTime = 0;
    var lastChapterDuration = 0;
    for (var i = 0; i < xmpTocItems.length; i++) {
      if (xmpTocItems[i].startTime >= mediaDurationInMilliseconds) {
        continue;
      }
      var nextChapterTimeOrDuration = i < xmpTocItems.length - 1 ? xmpTocItems[i + 1].startTime : mediaDurationInMilliseconds;
      var chapterDurationInMilliseconds = nextChapterTimeOrDuration - lastStartTime;
      var chapterPercentage = chapterDurationInMilliseconds / mediaDurationInMilliseconds * 100;
      var progressBarChapterSegmentMarkup = templateGenerator.generateProgressBarChapterSegmentMarkup(i);
      var $chapterElement = $(progressBarChapterSegmentMarkup);
      $chapterElement.css('width', chapterPercentage + '%');
      _$scrubbarTrack.append($chapterElement);
      _chaptersCache.push(ProgressChapterModel$1.create(i, xmpTocItems[i].name, xmpTocItems[i].startTime, lastChapterDuration, lastChapterDuration + chapterPercentage, chapterPercentage, $chapterElement));
      lastChapterDuration += chapterPercentage;
      lastStartTime = nextChapterTimeOrDuration;
    }
  };
  var onVideoProgress = function onVideoProgress() {
    var downloadedPercent = 0;
    if (mediaElement) {
      if (mediaElement.buffered && mediaElement.buffered.length) {
        downloadedPercent = Math.min(MAX_LOAD_VALUE, Math.ceil(mediaElement.buffered.end(mediaElement.buffered.length - 1) * MAX_LOAD_VALUE / mediaElement.duration));
      }
      updateLoadProgress(downloadedPercent);
      if (downloadedPercent === MAX_LOAD_VALUE && _updateBufferedTimeout !== -1) {
        _windowRef.clearInterval(_updateBufferedTimeout);
      }
    }
  };
  var onVideoDurationChange = function onVideoDurationChange() {
    // this is a workaround because the ipad/iphone do not support the
    // progress event so we must check the buffering every second
    onVideoProgress();
    if (_updateBufferedTimeout !== -1) {
      _windowRef.clearInterval(_updateBufferedTimeout);
    }
    updateQuizMarkers();
    _updateBufferedTimeout = _windowRef.setInterval(onVideoProgress, CHECK_VIDEO_LOAD_PROGRESS_INTERVAL);
  };
  var destroy = function destroy() {
    if (_updateBufferedTimeout !== -1) {
      _windowRef.clearInterval(_updateBufferedTimeout);
    }
    _$scrubBar.off('touchstart', onDownSeek);
    _$scrubBar.off('mousedown', onMousedown);
    _$scrubBar.off('mouseover touchstart', showScrubPreview);
    _$scrubBar.off('mouseout touchend', onScrubBarMouseOut);
    $container.off('keydown', keyPressed);
    $container.off(events.Modals.Open, disableKeyListeners);
    $container.off(events.Modals.Closed, enableKeyListeners);
    $container.off(events.Controls.Disable, disableKeyListeners);
    $container.off(events.Controls.Enable, enableKeyListeners);
    $container.off(events.Quizzing.Complete, onQuizzingCompleteHandler);
    $container.off(events.Controls.PlayerResize, onPlayerResize);
    $container.off(events.Plugin.Added, onAddPlugin);
    mediaElement.removeEventListener(events.ExternalVideo.VideoSeeked, onMediaSeekedEvent);
    mediaElement.removeEventListener(events.ExternalVideo.VideoDurationChange, onVideoDurationChange);
    mediaElement.removeEventListener(events.ExternalVideo.VideoProgress, onVideoProgress);
    if (_requestAnimationId !== null) {
      _windowRef.cancelAnimationFrame(_requestAnimationId);
    }
  };
  var durationHasChanged = function durationHasChanged() {
    _durationDisplayInitialized = false;
  };
  setup();
  return Object.defineProperties({
    getXPositionForQuestionSetMarker: getXPositionForQuestionSetMarker,
    updateQuizMarkers: updateQuizMarkers,
    updateLoadProgress: updateLoadProgress,
    allowSkipQuestionSetMarkersBeforeTime: allowSkipQuestionSetMarkersBeforeTime,
    durationHasChanged: durationHasChanged,
    createTocChapters: createTocChapters,
    destroy: destroy,
    setShouldRespectQuizMarkers: setShouldRespectQuizMarkers
  }, {
    scrubbing: {
      get: function get() {
        return _scrubbing;
      },
      set: setScrubbing
    },
    lastScrubTime: {
      get: function get() {
        return _lastScrubTime;
      }
    },
    controlElement: {
      get: function get() {
        return _$scrubBar;
      }
    },
    displayWidth: {
      get: function get() {
        return _currentProgressBarWidth;
      }
    }
  });
};
var ProgressBarControlView$1 = {
  /**
   *  Factory method that returns a new ProgressBarControlView object
   *  @function create
   *  @memberof TSC.ProgressBarControlView
   *  @param {jQuery} $container - Smart Player root dom element
   *  @param {HTMLVideoElement} mediaElement
   *  @param {TSC.Quiz} quizModel
   *  @static
   *  @return new ProgressBarControlView instance
   */
  create: ProgressBarControlView
};

var PlayRewindControlsView = function PlayRewindControlsView($container, mediaElement) {
  var skipDuration = playerConfiguration.skipVideoDuration;
  var _markup = templateGenerator.generatePlayRewindControlsMarkup(skipDuration);
  $container.find('.play-rewind-controls').html(_markup);
  var _disabled = false;
  var _$playControl = $container.find('.play-control');
  var _$rewindControl = $container.find('.rewind-control');
  var _$forwardControl = $container.find('.forward-control');
  var _$playButtonGlyph = _$playControl.find('.play-button-glyph');
  var _$pauseButtonGlyph = _$playControl.find('.pause-button-glyph');
  var disableKeyListeners = function disableKeyListeners() {
    _$playControl.attr('tabindex', tabIndex.Disabled);
    _$rewindControl.attr('tabindex', tabIndex.Disabled);
    _$forwardControl.attr('tabindex', tabIndex.Disabled);
    _disabled = true;
  };
  var enableKeyListeners = function enableKeyListeners() {
    _$playControl.attr('tabindex', tabIndex.DomOrder);
    _$rewindControl.attr('tabindex', tabIndex.DomOrder);
    _$forwardControl.attr('tabindex', tabIndex.DomOrder);
    _disabled = false;
  };
  var pauseMedia = function pauseMedia() {
    mediaElement.pause();
  };
  $container.on(events.Controls.Disable, disableKeyListeners);
  $container.on(events.Controls.Enable, enableKeyListeners);
  $container.on(events.SCORM.ExitSession, pauseMedia);
  mediaElement.addEventListener(events.Media.Play, function () {
    _$playButtonGlyph.hide();
    _$pauseButtonGlyph.show();
    _$playControl.attr('aria-pressed', true);
  });
  mediaElement.addEventListener(events.Media.Pause, function () {
    _$pauseButtonGlyph.hide();
    _$playButtonGlyph.show();
    _$playControl.attr('aria-pressed', false);
  });
  var onPlayHandler = function onPlayHandler(e) {
    e.preventDefault();
    togglePlay();
  };
  var togglePlay = function togglePlay() {
    if (_disabled) {
      return;
    }
    if (mediaElement.paused) {
      if (mediaElement.ended) {
        $container.trigger(events.Media.Replay);
      } else {
        mediaElement.play();
      }
    } else {
      pauseMedia();
    }
  };
  var seekVideo = function seekVideo(timeInSeconds) {
    $container.trigger(events.Media.SeekToTime, {
      time: videoApiUtils.getSafeSeekTime(mediaElement, timeInSeconds)
    });
  };
  var rewindVideo = function rewindVideo(e) {
    e.preventDefault();
    seekVideo(mediaElement.currentTime - playerConfiguration.skipVideoDuration);
  };
  var skipVideoForward = function skipVideoForward(e) {
    e.preventDefault();
    seekVideo(mediaElement.currentTime + playerConfiguration.skipVideoDuration);
  };
  var setInitialFocus = function setInitialFocus() {
    if (viewHelper.elementOrChildHasFocus($container)) {
      _$playControl.focus();
      highlightDisabler.disableHighlights(_$playControl);
    }
  };
  var destroy = function destroy() {
    _$playControl.off('click', onPlayHandler);
    _$rewindControl.off('click', rewindVideo);
    _$forwardControl.off('click', skipVideoForward);
  };
  if (playerConfiguration.skipVideoControlsEnabled) {
    _$rewindControl.on('click', rewindVideo);
    if (playerConfiguration.allowFastForward) {
      _$forwardControl.on('click', skipVideoForward);
    } else {
      _$forwardControl.addClass(cssClasses.hide);
    }
  } else {
    _$rewindControl.addClass(cssClasses.hide);
    _$forwardControl.addClass(cssClasses.hide);
  }
  _$playControl.on('click', onPlayHandler);
  _$pauseButtonGlyph.hide();
  return Object.defineProperties({
    togglePlay: togglePlay,
    setInitialFocus: setInitialFocus,
    destroy: destroy
  }, {});
};
var PlayRewindControlsView$1 = {
  create: PlayRewindControlsView
};

var PrevNextControlsView = function PrevNextControlsView($container) {
  var _markup = templateGenerator.generatePrevNextControlsMarkup();
  $container.find('.prev-next-controls').html(_markup);
  var _$previousControl = $container.find('.previous-control');
  var _$nextControl = $container.find('.next-control');
  var disableKeyListeners = function disableKeyListeners() {
    _$previousControl.attr('tabindex', tabIndex.Disabled);
    _$nextControl.attr('tabindex', tabIndex.Disabled);
  };
  var enableKeyListeners = function enableKeyListeners() {
    _$previousControl.attr('tabindex', tabIndex.DomOrder);
    _$nextControl.attr('tabindex', tabIndex.DomOrder);
  };
  $container.on(events.Controls.Disable, disableKeyListeners);
  $container.on(events.Controls.Enable, enableKeyListeners);
  _$previousControl.click(function () {
    $container.trigger(events.Controls.ClickPrev);
  });
  _$nextControl.click(function () {
    $container.trigger(events.Controls.ClickNext);
  });
  var hide = function hide() {
    _$previousControl.addClass(cssClasses.hide);
    _$nextControl.addClass(cssClasses.hide);
  };
  var show = function show() {
    _$previousControl.removeClass(cssClasses.hide);
    _$nextControl.removeClass(cssClasses.hide);
  };
  var disablePreviousButton = function disablePreviousButton() {
    _$previousControl.addClass(cssClasses.disabled).attr('aria-disabled', true);
  };
  var enablePreviousButton = function enablePreviousButton() {
    _$previousControl.removeClass(cssClasses.disabled).attr('aria-disabled', false);
  };
  var disableNextButton = function disableNextButton() {
    _$nextControl.addClass(cssClasses.disabled).attr('aria-disabled', true);
  };
  var enableNextButton = function enableNextButton() {
    _$nextControl.removeClass(cssClasses.disabled).attr('aria-disabled', false);
  };
  var destroy = function destroy() {
    $container.off(events.Controls.Disable, disableKeyListeners);
    $container.off(events.Controls.Enable, enableKeyListeners);
    $container.find('.prev-next-controls').html('');
  };
  return {
    show: show,
    hide: hide,
    disablePreviousButton: disablePreviousButton,
    enablePreviousButton: enablePreviousButton,
    disableNextButton: disableNextButton,
    enableNextButton: enableNextButton,
    destroy: destroy
  };
};
var PrevNextControlsView$1 = {
  create: PrevNextControlsView
};

var setItem = function setItem(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    //oh well
  }
};
var getItem = function getItem(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};
var localStorageWrapper = {
  /**
   *  Wraps native local storage setItem with a try/catch.
   *  @function setItem
   *  @memberof TSC.localStorageWrapper
   *  @static
   *  @param {String} key - the key of the value to set in local storage
   *  @param {String} value - the value to set in local storage
   */
  setItem: setItem,
  /**
   *  Wraps native local storage getItem.
   *  @function getItem
   *  @memberof TSC.localStorageWrapper
   *  @static
   *  @param {String} key - the key of the value to retrieve in local storage
   *  @returns {String} value from local storage (could be null or undefined)
   */
  getItem: getItem
};

var VOLUME_CACHE_KEY = 'volume';
var MUTED_CACHE_KEY = 'muted';
var DEFAULT_VOLUME_VALUE = 1;
var VOLUME_SLIDER_MIN = 0;
var VOLUME_SLIDER_MAX = 100;
var MIN_VOLUME_POSITION_PERCENT = 0;
var MAX_VOLUME_POSITION_PERCENT = 1;
var MOUSEOUT_HIDE_SLIDER_TIMEOUT = 1000;
var FOCUSOUT_HIDE_SLIDER_TIMEOUT = 200;
var VOLUME_STRING = localizationStrings.getPlayerString(playerStringNames.accessTxtVolume);
var VOLUME_TRACK_WIDTH = 67;
var VOLUME_SLIDER_HALF_WIDTH = 6;
var KEYBOARD_VOLUME_MODIFIER = .1;
var MIN_VOLUME_PERCENT_HIGH_VOLUME_GLYPH = .7;
var MIN_VOLUME_PERCENT_MEDIUM_VOLUME_GLYPH = .3;
var getCachedVolumeValueAsValidNumber = function getCachedVolumeValueAsValidNumber() {
  var cachedVolumeValue = localStorageWrapper.getItem(VOLUME_CACHE_KEY);
  if (cachedVolumeValue === undefined || cachedVolumeValue === null || +cachedVolumeValue > MAX_VOLUME_POSITION_PERCENT) {
    return DEFAULT_VOLUME_VALUE;
  }
  return +cachedVolumeValue;
};

/**
 * @memberof TSC
 * @class VolumeControlView
 * @classdesc VolumeControl View
 */
var VolumeControlView = function VolumeControlView($container, mediaElement) {
  var _showVolumeSlider = false;
  var _secondaryControlsHidden = false;
  var _cachedVolume = getCachedVolumeValueAsValidNumber();
  var _cachedMuted = localStorageWrapper.getItem(MUTED_CACHE_KEY);
  var _sliderShowTimeoutId = -1;
  var _markup = templateGenerator.generateVolumeControlMarkup(_cachedVolume);
  var _$controlsContainer = $container.find('.player-controls');
  var _$primaryControlsContainer = $container.find('.primary-controls');
  var _$secondaryControlsContainer = $container.find('.secondary-controls');
  var _$volumeContainer = $container.find('.volume-wrapper');
  _$volumeContainer.html(_markup);
  var _$volumeSliderContainer = _$volumeContainer.find('.volume-slider-container');
  var _$volumeSlider = _$volumeContainer.find('.volume-slider');
  var _$volumeSliderTrack = _$volumeContainer.find('.volume-slider-track');
  var _$volumeControl = _$volumeContainer.find('.volume');
  var _initialVolume = _cachedVolume;
  var _initialMuted = _cachedMuted === 'true';
  var _sliderVolumeValue = _initialVolume;
  var _sliderActive = false;
  if (deviceInfo.isIOS() || deviceInfo.isAndroid()) {
    _$volumeControl.remove();
    _$volumeSliderContainer.remove();
  }
  var onKeyDownHandler = function onKeyDownHandler(e) {
    if (keys.isKeyOfType(e.key, keys.keyTypes.upArrow) || keys.isKeyOfType(e.key, keys.keyTypes.downArrow)) {
      e.preventDefault();
    }
  };
  var onKeyHandler = function onKeyHandler(e) {
    e.preventDefault();
    if (keys.isKeyOfType(e.key, keys.keyTypes.upArrow)) {
      setSliderValue(_sliderVolumeValue + KEYBOARD_VOLUME_MODIFIER);
      updateVolumeSliderPositionByVolume(_sliderVolumeValue);
      setVolume(_sliderVolumeValue);
    } else if (keys.isKeyOfType(e.key, keys.keyTypes.downArrow)) {
      setSliderValue(_sliderVolumeValue - KEYBOARD_VOLUME_MODIFIER);
      updateVolumeSliderPositionByVolume(_sliderVolumeValue);
      setVolume(_sliderVolumeValue);
    }
  };
  var clampVolumePercentage = function clampVolumePercentage(volumeAsPercent) {
    volumeAsPercent = volumeAsPercent < MIN_VOLUME_POSITION_PERCENT ? MIN_VOLUME_POSITION_PERCENT : volumeAsPercent;
    volumeAsPercent = volumeAsPercent > MAX_VOLUME_POSITION_PERCENT ? MAX_VOLUME_POSITION_PERCENT : volumeAsPercent;
    return volumeAsPercent;
  };
  var setSliderValue = function setSliderValue(volumePercentageValue) {
    volumePercentageValue = clampVolumePercentage(volumePercentageValue);

    // do not store min volume, the volume will be muted then
    if (volumePercentageValue > MIN_VOLUME_POSITION_PERCENT) {
      _sliderVolumeValue = volumePercentageValue;
    }
  };
  var onSliderMouseDownHandler = function onSliderMouseDownHandler(e) {
    e.preventDefault();
    highlightDisabler.disableHighlights(_$volumeSliderContainer);
    var volumeSliderLeftOffset = _$volumeSliderTrack.offset().left;
    var pendingVolumeValue = _sliderVolumeValue;
    var updateSliderOnAnimationFrame = function updateSliderOnAnimationFrame() {
      updateVolumeSliderPositionByVolume(pendingVolumeValue);
      setVolume(pendingVolumeValue);
      if (_sliderActive) {
        window.requestAnimationFrame(updateSliderOnAnimationFrame);
      }
    };
    var updateSliderValue = function updateSliderValue(pageX) {
      var currentDelta = pageX - volumeSliderLeftOffset;
      pendingVolumeValue = clampVolumePercentage(currentDelta / VOLUME_TRACK_WIDTH);
    };
    var onMouseMove = function onMouseMove(evt) {
      evt.preventDefault();
      updateSliderValue(evt.pageX);
    };
    var onMouseUp = function onMouseUp(evt) {
      evt.preventDefault();
      _sliderActive = false;
      setSliderValue(pendingVolumeValue);
      window.document.removeEventListener('mousemove', onMouseMove, true);
      window.document.removeEventListener('mouseup', onMouseUp, true);
    };
    window.document.addEventListener('mousemove', onMouseMove, true);
    window.document.addEventListener('mouseup', onMouseUp, true);
    updateSliderValue(e.pageX);
    _sliderActive = true;
    window.requestAnimationFrame(updateSliderOnAnimationFrame);
  };
  var updateVolumeSliderPositionByVolume = function updateVolumeSliderPositionByVolume(volumeFromMedia) {
    var volumeConverted = volumeFromMedia * VOLUME_SLIDER_MAX;
    var volumeSliderLeftCssValue = 'calc(' + volumeConverted + '% - ' + VOLUME_SLIDER_HALF_WIDTH + 'px)';
    var volumeTrackWidthCssValue = volumeConverted + '%';
    _$volumeSlider.css('left', volumeSliderLeftCssValue);
    _$volumeSliderTrack.css('width', volumeTrackWidthCssValue);
  };
  var showVolumeSlider = function showVolumeSlider() {
    _$volumeSliderContainer.removeClass(cssClasses.volumeSliderHidden);
    _showVolumeSlider = true;
    handleSecondaryControls();
  };
  var handleSecondaryControls = function handleSecondaryControls() {
    var controlsWidth = _$primaryControlsContainer.width() + _$secondaryControlsContainer.width();
    var volumeSliderExpandedWidth = _$volumeSliderContainer.width() === 0 ? VOLUME_TRACK_WIDTH : 0;
    var shouldHideSecondaryControls = controlsWidth + volumeSliderExpandedWidth >= _$controlsContainer.width();
    if (_secondaryControlsHidden && !shouldHideSecondaryControls) {
      setSecondaryControlsVisibility(false);
    } else if (!_secondaryControlsHidden && shouldHideSecondaryControls) {
      setSecondaryControlsVisibility(true);
    }
  };
  var setSecondaryControlsVisibility = function setSecondaryControlsVisibility(isHidden) {
    if (isHidden) {
      _$secondaryControlsContainer.addClass(cssClasses.hideSecondaryControls);
      _secondaryControlsHidden = true;
    } else {
      _$secondaryControlsContainer.removeClass(cssClasses.hideSecondaryControls);
      _secondaryControlsHidden = false;
    }
  };
  var hideControls = function hideControls() {
    if (_sliderShowTimeoutId !== -1) {
      hideVolumeSlider();
    }
  };
  var hideVolumeSlider = function hideVolumeSlider() {
    _showVolumeSlider = false;
    if (_sliderShowTimeoutId !== -1) {
      clearTimeout(_sliderShowTimeoutId);
      _sliderShowTimeoutId = -1;
    }
    setSecondaryControlsVisibility(false);
    _$volumeSliderContainer.addClass(cssClasses.volumeSliderHidden);
  };
  var updateUI = function updateUI() {
    var volumeValue = mediaElement.muted ? 0 : Math.round(mediaElement.volume * VOLUME_SLIDER_MAX);
    _$volumeSlider.attr('aria-valuenow', volumeValue);
    _$volumeSlider.attr('aria-valuetext', volumeValue + '% ' + VOLUME_STRING);
    _$volumeControl.attr('aria-pressed', !!mediaElement.muted);
    _$volumeSlider.attr({
      value: volumeValue
    });
    _$volumeControl.removeClass(cssClasses.volumeHighButtonGlyph);
    _$volumeControl.removeClass(cssClasses.volumeMediumButtonGlyph);
    _$volumeControl.removeClass(cssClasses.volumeLowButtonGlyph);
    _$volumeControl.removeClass(cssClasses.volumeMutedButtonGlyph);
    if (volumeValue === MIN_VOLUME_POSITION_PERCENT) {
      _$volumeControl.addClass(cssClasses.volumeMutedButtonGlyph);
    } else if (mediaElement.volume > MIN_VOLUME_PERCENT_HIGH_VOLUME_GLYPH) {
      _$volumeControl.addClass(cssClasses.volumeHighButtonGlyph);
    } else if (mediaElement.volume > MIN_VOLUME_PERCENT_MEDIUM_VOLUME_GLYPH) {
      _$volumeControl.addClass(cssClasses.volumeMediumButtonGlyph);
    } else {
      _$volumeControl.addClass(cssClasses.volumeLowButtonGlyph);
    }
  };
  var setMuted = function setMuted(muted) {
    mediaElement.muted = muted;
    localStorageWrapper.setItem(MUTED_CACHE_KEY, muted);
  };
  var setVolume = function setVolume(newVolumeAsPercent) {
    newVolumeAsPercent = clampVolumePercentage(newVolumeAsPercent);
    if (newVolumeAsPercent === MIN_VOLUME_POSITION_PERCENT) {
      setMuted(true);
    } else {
      setMuted(false);
      localStorageWrapper.setItem(VOLUME_CACHE_KEY, newVolumeAsPercent);
      mediaElement.volume = newVolumeAsPercent;
    }
  };
  var startHideSliderTimeout = function startHideSliderTimeout(timeout) {
    if (_sliderShowTimeoutId !== -1) {
      clearTimeout(_sliderShowTimeoutId);
    }
    _sliderShowTimeoutId = setTimeout(function () {
      hideVolumeSlider();
      _sliderShowTimeoutId = -1;
    }, timeout);
  };
  var onContainerMouseOver = function onContainerMouseOver() {
    if (_sliderShowTimeoutId !== -1) {
      clearTimeout(_sliderShowTimeoutId);
      _sliderShowTimeoutId = -1;
    }
    showVolumeSlider();
  };
  var onContainerMouseLeave = function onContainerMouseLeave(e) {
    if (e.buttons !== 1) {
      startHideSliderTimeout(MOUSEOUT_HIDE_SLIDER_TIMEOUT);
    }
  };
  var hideVolumeSliderOnFocusOut = function hideVolumeSliderOnFocusOut() {
    startHideSliderTimeout(FOCUSOUT_HIDE_SLIDER_TIMEOUT);
  };
  var onVolumeButtonClick = function onVolumeButtonClick() {
    setMuted(!mediaElement.muted);
    if (mediaElement.muted) {
      updateVolumeSliderPositionByVolume(0);
    } else {
      updateVolumeSliderPositionByVolume(_sliderVolumeValue);
      setVolume(_sliderVolumeValue);
    }
  };
  var disableControls = function disableControls() {
    _$volumeControl.attr('tabindex', tabIndex.Disabled);
    _$volumeSlider.attr('tabindex', tabIndex.Disabled);
  };
  var enableControls = function enableControls() {
    _$volumeControl.attr('tabindex', tabIndex.DomOrder);
    _$volumeSlider.attr('tabindex', tabIndex.DomOrder);
  };
  var initVolumeControls = function initVolumeControls() {
    setVolume(_initialVolume);
    setMuted(_initialMuted);
    updateUI();
    updateVolumeSliderPositionByVolume(mediaElement.muted ? MIN_VOLUME_POSITION_PERCENT : _initialVolume);
  };
  var onResize = function onResize() {
    if (_showVolumeSlider) {
      handleSecondaryControls();
    }
  };
  var onMediaVolumeChange = function onMediaVolumeChange() {
    if (!_sliderActive) {
      setSliderValue(mediaElement.volume);
      if (mediaElement.volume === VOLUME_SLIDER_MIN && !mediaElement.muted) {
        setMuted(true);
      }
    }
    updateUI();
  };
  var initializeHandlers = function initializeHandlers() {
    _$volumeContainer.on('mousemove', onContainerMouseOver);
    _$volumeContainer.on('mouseout', onContainerMouseLeave);
    _$volumeSliderContainer.on('mousedown', onSliderMouseDownHandler);
    _$volumeControl.on('click', onVolumeButtonClick);
    _$volumeSlider.on('focus', showVolumeSlider);
    _$volumeSlider.on('focusout', hideVolumeSliderOnFocusOut);
    _$volumeSlider.on('keydown', onKeyDownHandler);
    _$volumeSlider.on('keyup', onKeyHandler);
    _$volumeSlider.attr('tabindex', tabIndex.DomOrder);
    _$volumeSlider.attr('aria-valuemin', VOLUME_SLIDER_MIN);
    _$volumeSlider.attr('aria-valuemax', VOLUME_SLIDER_MAX);
    _$volumeSlider.attr('role', 'slider');
    mediaElement.addEventListener('volumechange', onMediaVolumeChange);
    $container.on(events.Controls.Disable, disableControls);
    $container.on(events.Controls.Enable, enableControls);
    $container.on(events.Controls.PlayerResize, onResize);
  };
  var destroy = function destroy() {
    _$volumeContainer.off('mousemove', onContainerMouseOver);
    _$volumeContainer.off('mouseout', onContainerMouseLeave);
    _$volumeSliderContainer.off('mousedown', onSliderMouseDownHandler);
    _$volumeControl.off('click', onVolumeButtonClick);
    _$volumeSlider.off('focus', showVolumeSlider);
    _$volumeSlider.off('focusout', hideVolumeSliderOnFocusOut);
    _$volumeSlider.off('keydown', onKeyDownHandler);
    _$volumeSlider.off('keyup', onKeyHandler);
    mediaElement.removeEventListener('volumechange', onMediaVolumeChange);
    $container.off(events.Controls.Disable, disableControls);
    $container.off(events.Controls.Enable, enableControls);
  };
  initializeHandlers();
  initVolumeControls();
  return Object.defineProperties({
    hideControls: hideControls,
    destroy: destroy
  }, {
    volume: {
      get: function get() {
        return mediaElement.volume;
      },
      set: setVolume
    },
    muted: {
      get: function get() {
        return mediaElement.muted;
      },
      set: setMuted
    }
  });
};
var VolumeControlView$1 = {
  /**
   *  Factory method that returns a new VolumeControlView object.
   *  @function create
   *  @memberof TSC.VolumeControlView
   *  @static
   *  @param {Object} $container - jQuery element that contains a .volume-wrapper element where the volume controls will be injected
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @return new VolumeControlView instance
   */
  create: VolumeControlView
};

/**
 * @memberof TSC
 * @class AudioDescriptionControlView
 * @classdesc Audio Description Control View
 * @param {Object} $container - jQuery element that contains a .audio-description-control-wrapper element where the control will be injected
 */
var AudioDescriptionControlView = function AudioDescriptionControlView($container) {
  var _audioDescriptionEnabled = false;
  var _$audioDescriptionButton;
  var _$audioDescriptionGlyph;
  var createView = function createView() {
    var _markup = templateGenerator.generateAudioDescriptionButtonMarkup();
    $container.find('.audio-description-control-wrapper').html(_markup);
    _$audioDescriptionButton = $container.find('.audio-description-button');
    _$audioDescriptionGlyph = $container.find('.audio-description-button-glyph');
  };
  var setAudioDescriptionState = function setAudioDescriptionState(audioDescriptionEnabled) {
    _audioDescriptionEnabled = audioDescriptionEnabled;
    if (_audioDescriptionEnabled) {
      _$audioDescriptionButton.attr('aria-pressed', true);
      _$audioDescriptionGlyph.removeClass(cssClasses.audioDescriptionButtonGlyph).addClass(cssClasses.audioDescriptionButtonActiveGlyph);
      _$audioDescriptionButton.removeClass(cssClasses.tertiaryButton).addClass(cssClasses.tertiaryButtonActive);
    } else {
      _$audioDescriptionButton.attr('aria-pressed', false);
      _$audioDescriptionGlyph.removeClass(cssClasses.audioDescriptionButtonActiveGlyph).addClass(cssClasses.audioDescriptionButtonGlyph);
      _$audioDescriptionButton.removeClass(cssClasses.tertiaryButtonActive).addClass(cssClasses.tertiaryButton);
    }
  };
  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    $container.trigger(events.AudioDescription.Changed, {
      audioDescriptionEnabled: !_audioDescriptionEnabled
    });
  };
  var onAudioDescriptionChange = function onAudioDescriptionChange(e, eventData) {
    setAudioDescriptionState(eventData.audioDescriptionEnabled);
  };
  var audioDescriptionFailedToPlay = function audioDescriptionFailedToPlay() {
    _$audioDescriptionButton.attr('disabled', true);
  };
  var disableControl = function disableControl() {
    _$audioDescriptionButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControl = function enableControl() {
    _$audioDescriptionButton.attr('tabindex', tabIndex.DomOrder);
  };
  var initializeHandlers = function initializeHandlers() {
    _$audioDescriptionButton.on('click', onButtonClick);
    $container.on(events.AudioDescription.Failed, audioDescriptionFailedToPlay);
    $container.on(events.Controls.Disable, disableControl);
    $container.on(events.Controls.Enable, enableControl);
    $container.on(events.AudioDescription.Changed, onAudioDescriptionChange);
  };
  var destroy = function destroy() {
    $container.off(events.AudioDescription.Failed, audioDescriptionFailedToPlay);
    $container.off(events.Controls.Disable, disableControl);
    $container.off(events.Controls.Enable, enableControl);
    $container.off(events.AudioDescription.Changed, onAudioDescriptionChange);
    _$audioDescriptionButton.off('click', onButtonClick);
  };
  createView();
  initializeHandlers();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var AudioDescriptionControlView$1 = {
  /**
   *  Factory method that returns a new AudioDescriptionControlView object.
   *  @function create
   *  @memberof TSC.AudioDescriptionControlView
   *  @static
   *  @param {Object} $container - jQuery element that contains a .audio-description-control-wrapper element where the control will be injected
   *  @return new AudioDescriptionControlView instance
   */
  create: AudioDescriptionControlView
};

/**
 * @memberof TSC
 * @class CaptionsControlView
 * @classdesc Captions Control View in player controls
 * @param {Object} $container - jQuery element that contains a ??? element where the control will be injected
 */
var CaptionsControlView = function CaptionsControlView($container) {
  var _captionsEnabled = false;
  var _$closedCaptionButton;
  var _$closedCaptionGlyph;
  var _normalButtonClass = cssClasses.closedCaptionButtonGlyph;
  var _activeButtonClass = cssClasses.closedCaptionButtonActiveGlyph;
  if (localizationStrings.getLanguage() !== languageCodes.ENGLISH) {
    _normalButtonClass = cssClasses.closedCaptionNonEnglishButtonGlyph;
    _activeButtonClass = cssClasses.closedCaptionNonEnglishButtonActiveGlyph;
  }
  var createView = function createView() {
    var _markup = templateGenerator.generateCaptionsButtonMarkup();
    $container.find('.caption-wrapper').html(_markup);
    _$closedCaptionButton = $container.find('.closed-caption-button');
    _$closedCaptionGlyph = $container.find('.closed-caption-button-glyph');
  };
  var setCaptionState = function setCaptionState(captionsEnabled) {
    _captionsEnabled = captionsEnabled;
    if (_captionsEnabled) {
      _$closedCaptionButton.attr('aria-pressed', true);
      _$closedCaptionGlyph.removeClass(_normalButtonClass).addClass(_activeButtonClass);
      _$closedCaptionButton.removeClass(cssClasses.tertiaryButton).addClass(cssClasses.tertiaryButtonActive);
    } else {
      _$closedCaptionButton.attr('aria-pressed', false);
      _$closedCaptionGlyph.removeClass(_activeButtonClass).addClass(_normalButtonClass);
      _$closedCaptionButton.removeClass(cssClasses.tertiaryButtonActive).addClass(cssClasses.tertiaryButton);
    }
  };
  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    $container.trigger(events.Captions.Toggled, {
      captionsEnabled: !_captionsEnabled,
      savePreference: true
    });
  };
  var onCaptionsToggle = function onCaptionsToggle(e, eventData) {
    setCaptionState(eventData.captionsEnabled);
  };
  var disableControl = function disableControl() {
    _$closedCaptionButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControl = function enableControl() {
    _$closedCaptionButton.attr('tabindex', tabIndex.DomOrder);
  };
  var savedStateLoaded = function savedStateLoaded(e, eventData) {
    $container.trigger(events.Captions.Toggled, {
      captionsEnabled: eventData.captionsEnabled,
      savePreference: false
    });
  };
  var initializeHandlers = function initializeHandlers() {
    _$closedCaptionButton.on('click', onButtonClick);
    $container.on(events.Controls.Disable, disableControl);
    $container.on(events.Controls.Enable, enableControl);
    $container.on(events.Captions.StateLoaded, savedStateLoaded);
    $container.on(events.Captions.Toggled, onCaptionsToggle);
  };
  var setCaptionButtonVisible = function setCaptionButtonVisible(captionButtonVisible) {
    if (captionButtonVisible) {
      _$closedCaptionButton.removeClass(cssClasses.hide);
    } else {
      _$closedCaptionButton.addClass(cssClasses.hide);
    }
  };
  var destroy = function destroy() {
    $container.off(events.Controls.Disable, disableControl);
    $container.off(events.Controls.Enable, enableControl);
    $container.off(events.Captions.StateLoaded, savedStateLoaded);
    _$closedCaptionButton.off('click', onButtonClick);
    $container.off(events.Captions.Toggled, onCaptionsToggle);
  };
  createView();
  initializeHandlers();
  return Object.defineProperties({
    setCaptionButtonVisible: setCaptionButtonVisible,
    destroy: destroy
  }, {});
};
var CaptionsControlView$1 = {
  /**
   *  Factory method that returns a new AudioDescriptionControlView object.
   *  @function create
   *  @memberof TSC.CaptionsControlView
   *  @static
   *  @param {Object} $container - jQuery element that contains a ??? element where the control will be injected
   *  @return new CaptionsControlView instance
   */
  create: CaptionsControlView
};

var _hotkeysEnabled = true;
var areHotkeysEnabled = function areHotkeysEnabled() {
  return _hotkeysEnabled;
};
var disableHotkeys = function disableHotkeys() {
  _hotkeysEnabled = false;
};
var enableHotkeys = function enableHotkeys() {
  _hotkeysEnabled = true;
};
var hotkeyService = {
  areHotkeysEnabled: areHotkeysEnabled,
  disableHotkeys: disableHotkeys,
  enableHotkeys: enableHotkeys
};

var REMOVE_SCREEN_READER_ALERT_TIME = 1000;

/**
 * @memberof TSC
 * @class TocControlView
 * @classdesc TOC Control View in player controls
 * @param {Object} $container - Smart Player root jquery element.
 * @param {TSC.playerConfiguration} playerConfiguration - Player configuration
 */
var TocControlView = function TocControlView($container, playerConfiguration) {
  var _tocDisplayed = false;
  var _$tocButton;
  var _$tocGlyph;
  var _windowRef = windowWrapper.getWindow();
  var createView = function createView() {
    var tocButtonMarkup = templateGenerator.generateTocButtonMarkup();
    $container.find('.toc-button-wrapper').html(tocButtonMarkup);
    _$tocButton = $container.find('.toc-button');
    _$tocGlyph = $container.find('.toc-button-glyph');
  };
  var alertScreenReader = function alertScreenReader(alertText) {
    var screenReaderAlertMarkup = templateGenerator.generateScreenReaderAlertMarkup(alertText);
    var $screenReaderAlert = $(screenReaderAlertMarkup);
    $container.append($screenReaderAlert);
    _windowRef.setTimeout(function () {
      $screenReaderAlert.remove();
    }, REMOVE_SCREEN_READER_ALERT_TIME);
  };
  var setTocDisplayState = function setTocDisplayState(displayToc) {
    _tocDisplayed = displayToc;
    if (_tocDisplayed) {
      _$tocButton.attr('aria-expanded', true);
      _$tocButton.removeClass(cssClasses.tertiaryButton).addClass(cssClasses.tertiaryButtonActive);
      // bug in IE11 that does not display SVG glyph when toggling SVG when enabling TOC on player load
      if (!(deviceInfo.isIE() && playerConfiguration.getSidebarEnabled())) {
        _$tocGlyph.addClass(cssClasses.tocButtonActiveGlyph);
      }
    } else {
      _$tocGlyph.removeClass(cssClasses.tocButtonActiveGlyph);
      _$tocButton.attr('aria-expanded', false);
      _$tocButton.removeClass(cssClasses.tertiaryButtonActive).addClass(cssClasses.tertiaryButton);
    }
    $container.trigger(events.Controls.TocDisplayToggled, {
      displayToc: _tocDisplayed
    });
  };
  var setInitialState = function setInitialState() {
    setTocDisplayState(_tocDisplayed);
  };
  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    setTocDisplayState(!_tocDisplayed);
  };
  var onKeyDownHandler = function onKeyDownHandler(e) {
    if (!hotkeyService.areHotkeysEnabled()) {
      return;
    }
    var isTypingInSearchBox = e.target && e.target.classList && e.target.classList.contains('toc-search-input');
    if (isTypingInSearchBox) {
      return;
    }
    if (keys.isKeyOfType(e.key, keys.keyTypes.tableOfContents)) {
      if (_$tocButton.attr('tabindex') !== tabIndex.Disabled) {
        if (_$tocButton.is(':focus')) {
          alertScreenReader(_tocDisplayed ? localizationStrings.getPlayerString(playerStringNames.tableOfContentsHidden) : localizationStrings.getPlayerString(playerStringNames.tableOfContentsDisplayed));
        } else {
          _$tocButton.focus();
        }
        setTocDisplayState(!_tocDisplayed);
      }
    }
  };
  var disableControl = function disableControl() {
    _$tocButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControl = function enableControl() {
    _$tocButton.attr('tabindex', tabIndex.DomOrder);
  };
  var onHideToc = function onHideToc() {
    setTocDisplayState(false);
  };
  var onShowToc = function onShowToc() {
    setTocDisplayState(true);
  };
  var focusTocButton = function focusTocButton() {
    _$tocButton.focus();
  };
  var initializeHandlers = function initializeHandlers() {
    _$tocButton.on('click', onButtonClick);
    $container.on('keydown', onKeyDownHandler);
    $container.on(events.Controls.Disable, disableControl);
    $container.on(events.Controls.Enable, enableControl);
    $container.on(events.Controls.FocusTocButton, focusTocButton);
    $container.on(events.Controls.HideToc, onHideToc);
    $container.on(events.Controls.ShowToc, onShowToc);
  };
  var destroy = function destroy() {
    _$tocButton.off('click', onButtonClick);
    $container.off('keydown', onKeyDownHandler);
    $container.off(events.Controls.Disable, disableControl);
    $container.off(events.Controls.Enable, enableControl);
    $container.off(events.Controls.FocusTocButton, focusTocButton);
    $container.off(events.Controls.HideToc, onHideToc);
    $container.off(events.Controls.ShowToc, onShowToc);
  };
  createView();
  initializeHandlers();
  setInitialState();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var TocControlView$1 = {
  /**
   *  Factory method that returns a new TocControlView object.
   *  @function create
   *  @memberof TSC.TocControlView
   *  @static
   *  @param {Object} $container - Smart Player root jquery element.
   *  @param {TSC.playerConfiguration} playerConfiguration - Player configuration
   *  @return new TocControlView instance
   */
  create: TocControlView
};

var LOCAL_STORAGE_PLAYBACK_SPEED_KEY = 'tscSmartPlayerPlaybackSpeed';
var _defaultPlaybackRate = 1.0;
var _defaultAvailablePlaybackRates = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
var hideButton = function hideButton($container) {
  $container.find('.settings-button').hide();
};

/**
 * @memberof TSC
 * @class PlayerSettingsView
 * @classdesc PlayerSettings View
 */
var PlayerSettingsView = function PlayerSettingsView($container, mediaElement, xmp, playbackRates, audioDescriptionMediaSrc) {
  var _isOpen = false;
  var _currentPlaybackRate = _defaultPlaybackRate;
  var _availablePlaybackRates = playbackRates || _defaultAvailablePlaybackRates;
  var _minPlaybackRate = _availablePlaybackRates[0];
  var _maxPlaybackRate = _availablePlaybackRates[_availablePlaybackRates.length - 1];
  mediaElement.playbackRate = _currentPlaybackRate;
  mediaElement.defaultPlaybackRate = _currentPlaybackRate;
  var getPlaybackRates = function getPlaybackRates() {
    var playerRateOptionsLocalizedStrings = localizationStrings.getPlayerString(playerStringNames.playerRateOptionsText);
    var playbackRatesList = [];
    for (var j = _availablePlaybackRates.length - 1; j >= 0; j--) {
      var rate = _availablePlaybackRates[j];
      playbackRatesList.push({
        rateValue: rate,
        rateLabel: playerRateOptionsLocalizedStrings[rate],
        selected: rate === _defaultPlaybackRate
      });
    }
    return playbackRatesList;
  };
  var getClosedCaptionLanguages = function getClosedCaptionLanguages() {
    var ccLanguageList = [];
    var selectedLanguageIdentifier = xmp.captionController.getActiveLanguageIdentifier();
    if (selectedLanguageIdentifier.identifier === languageIdentifiers.identifiers["default"]) {
      selectedLanguageIdentifier = LanguageIdentifier$1.create(localizationStrings.getLanguage());
    }
    var foundSelectedLanguageInAvailableList = false;
    xmp.captionController.getAvailableLanguages().forEach(function (languageIdentifierString) {
      var languageIdentifier = LanguageIdentifier$1.create(languageIdentifierString);
      var languageLabel = localizationStrings.getLanguageNameFromIdentifierString(languageIdentifierString);
      var languageShouldBeSelected = languageIdentifier.language === selectedLanguageIdentifier.language;
      if (languageShouldBeSelected) {
        foundSelectedLanguageInAvailableList = true;
      }
      ccLanguageList.push({
        languageValue: languageIdentifierString,
        languageLabel: languageLabel,
        selected: languageShouldBeSelected
      });
    });
    if (foundSelectedLanguageInAvailableList) {
      xmp.captionController.setActiveLanguageIdentifier(selectedLanguageIdentifier.identifier);
    } else {
      xmp.captionController.setActiveLanguageIdentifier(languageIdentifiers.identifiers["default"]);
    }
    return ccLanguageList;
  };
  var playerSettingsViewMarkup = templateGenerator.generateSettingsMarkup(xmp ? xmp.captionsHasMultipleLanguages : false, getPlaybackRates(), xmp ? getClosedCaptionLanguages() : [], xmp && xmp.hasCaptionItems, audioDescriptionMediaSrc);
  var _$playerSettingsWrapper = $container.find('.player-settings-wrapper');
  _$playerSettingsWrapper.html(playerSettingsViewMarkup);
  var _$playerSettingsViewEl = $container.find('.player-settings-container');
  var _$playbackRateSelectEl = _$playerSettingsViewEl.find('.player-speed-select');
  var _$ccLanguageSelectEl = _$playerSettingsViewEl.find('.cc-language-select');
  var _$playerSettingsButton = $container.find('.settings-button');
  var _$playerSettingsButtonGlyph = $container.find('.settings-button-glyph');
  var _$closedCaptionToggleContainer = $container.find('.closed-caption-setting');
  var _$closedCaptionToggle = _$playerSettingsViewEl.find('.cc-toggle');
  var _$closedCaptionToggleElement = _$closedCaptionToggle[0];
  var _$audioDescriptionToggle = _$playerSettingsViewEl.find('.ad-toggle');
  var _$audioDescriptionToggleElement = _$audioDescriptionToggle[0];
  var _$settingsCloseButton = _$playerSettingsViewEl.find('.settings-close-button');
  var _$settingsHeaderContainer = _$playerSettingsViewEl.find('.setting-header-container');
  if (!playerConfiguration.showAcknowledgementLink) {
    _$playerSettingsWrapper.find('.settings-acknowledgementlink').hide();
  }
  var hideView = function hideView() {
    _isOpen = false;
    $container.trigger(events.Controls.PlayerSettingsClose);
    _$playerSettingsViewEl.hide();
    _$playerSettingsButton.attr('aria-expanded', false);
    _$playerSettingsButton.removeClass(cssClasses.tertiaryButtonActive).addClass(cssClasses.tertiaryButton);
    _$playerSettingsButtonGlyph.removeClass(cssClasses.settingsButtonActiveGlyph).addClass(cssClasses.settingsButtonGlyph);
    removeClickHandler();
    viewHelper.removeFocusTrap();
  };
  var showView = function showView() {
    _isOpen = true;
    $container.trigger(events.Controls.PlayerSettingsOpen);
    _$playerSettingsViewEl.show();
    _$playerSettingsButton.attr('aria-expanded', true);
    _$playerSettingsButton.removeClass(cssClasses.tertiaryButton).addClass(cssClasses.tertiaryButtonActive);
    _$playerSettingsButtonGlyph.removeClass(cssClasses.settingsButtonGlyph).addClass(cssClasses.settingsButtonActiveGlyph);
    addClickHandler();
    trapFocusInModalView();
  };
  var isModalView = function isModalView() {
    return _$settingsHeaderContainer.css('display') !== 'none';
  };
  var trapFocusInModalView = function trapFocusInModalView() {
    if (isModalView()) {
      viewHelper.trapFocus(_$playerSettingsViewEl);
    }
  };
  var addClickHandler = function addClickHandler() {
    $container.mouseup(hideSettingsViewOnClickOutside);
  };
  var removeClickHandler = function removeClickHandler() {
    $container.off('mouseup', hideSettingsViewOnClickOutside);
  };
  var hideSettingsViewOnClickOutside = function hideSettingsViewOnClickOutside(e) {
    if (!_isOpen) {
      return;
    }
    if (!_$playerSettingsViewEl.is(e.target) && _$playerSettingsViewEl.has(e.target).length === 0) {
      //This timeout is so that the click handler for the settings view button sees the right state
      setTimeout(function () {
        hideView();
      }, 50);
    }
  };
  var syncPlaybackRateControlsWithPlaybackRateValue = function syncPlaybackRateControlsWithPlaybackRateValue() {
    var realPlaybackRate = mediaElement.playbackRate;
    if (realPlaybackRate !== Number(_$playbackRateSelectEl.find(':selected').val())) {
      if (realPlaybackRate > _maxPlaybackRate) {
        setPlaybackRate(_maxPlaybackRate);
      } else if (realPlaybackRate < _minPlaybackRate) {
        setPlaybackRate(_minPlaybackRate);
      } else {
        _$playbackRateSelectEl.find('.player-speed-option[value="' + mediaElement.playbackRate + '"]').prop('selected', true);
      }
    }
  };
  var setPlaybackRate = function setPlaybackRate(playbackSpeed) {
    if (!playbackSpeed) {
      playbackSpeed = _defaultPlaybackRate;
    } else if (playbackSpeed < _minPlaybackRate) {
      playbackSpeed = _minPlaybackRate;
    } else if (playbackSpeed > _maxPlaybackRate) {
      playbackSpeed = _maxPlaybackRate;
    }
    _currentPlaybackRate = playbackSpeed;
    mediaElement.playbackRate = playbackSpeed;
    mediaElement.defaultPlaybackRate = playbackSpeed;
    localStorageWrapper.setItem(LOCAL_STORAGE_PLAYBACK_SPEED_KEY, playbackSpeed.toString());

    // workaround to get iOS to apply the playback rate change right away
    if (deviceInfo.isIOS() && !mediaElement.paused) {
      mediaElement.pause();
      mediaElement.play();
    }
  };
  var onPlaybackRateControlChange = function onPlaybackRateControlChange() {
    var playbackSpeed = Number(_$playbackRateSelectEl.find(':selected').val());
    setPlaybackRate(playbackSpeed);
  };
  var onCCLanguageControlChange = function onCCLanguageControlChange() {
    var ccLanguageCode = _$ccLanguageSelectEl.find(':selected').val();
    xmp.captionController.setActiveLanguageIdentifier(ccLanguageCode);
    $container.trigger(events.Captions.LanguageChanged);
  };
  var onAudioDescriptionToggleChange = function onAudioDescriptionToggleChange() {
    var checked = _$audioDescriptionToggleElement.checked;
    $container.trigger(events.AudioDescription.Changed, {
      audioDescriptionEnabled: checked
    });
  };
  var onAudioDescriptionChange = function onAudioDescriptionChange(e, eventData) {
    if (eventData.audioDescriptionEnabled) {
      _$audioDescriptionToggleElement.checked = true;
    } else {
      _$audioDescriptionToggleElement.checked = false;
    }
  };
  var onClosedCaptionToggleChange = function onClosedCaptionToggleChange() {
    var checked = _$closedCaptionToggleElement.checked;
    $container.trigger(events.Captions.Toggled, {
      captionsEnabled: checked,
      savePreference: true
    });
  };
  var onCaptionsToggled = function onCaptionsToggled(e, eventData) {
    if (_$closedCaptionToggleElement) {
      if (eventData.captionsEnabled) {
        _$closedCaptionToggleElement.checked = true;
      } else {
        _$closedCaptionToggleElement.checked = false;
      }
    }
  };
  var onPlaybackRateValueChange = function onPlaybackRateValueChange() {
    syncPlaybackRateControlsWithPlaybackRateValue();
  };
  var incrementPlaybackRate = function incrementPlaybackRate() {
    var indexOfCurrentRate = _availablePlaybackRates.indexOf(_currentPlaybackRate);
    if (indexOfCurrentRate === -1) {
      return;
    }
    if (indexOfCurrentRate + 1 < _availablePlaybackRates.length) {
      setPlaybackRate(_availablePlaybackRates[indexOfCurrentRate + 1]);
    }
  };
  var decrementPlaybackRate = function decrementPlaybackRate() {
    var indexOfCurrentRate = _availablePlaybackRates.indexOf(_currentPlaybackRate);
    if (indexOfCurrentRate === -1) {
      return;
    }
    if (indexOfCurrentRate > 0) {
      setPlaybackRate(_availablePlaybackRates[indexOfCurrentRate - 1]);
    }
  };
  var onKeyboardShortCut = function onKeyboardShortCut(e) {
    if (!hotkeyService.areHotkeysEnabled()) {
      return;
    }
    if (keys.isKeyOfType(e.key, keys.keyTypes.upArrow) && e.shiftKey) {
      e.preventDefault();
      incrementPlaybackRate();
    } else if (keys.isKeyOfType(e.key, keys.keyTypes.downArrow) && e.shiftKey) {
      e.preventDefault();
      decrementPlaybackRate();
    } else if (keys.isKeyOfType(e.key, keys.keyTypes.escape)) {
      if (_isOpen) {
        if (_$playbackRateSelectEl.is(':focus') || _$ccLanguageSelectEl.is(':focus')) {
          _$playerSettingsButton.focus();
        }
        hideView();
      }
    }
  };
  var stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
  };
  var disableControl = function disableControl() {
    _$playerSettingsButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControl = function enableControl() {
    _$playerSettingsButton.attr('tabindex', tabIndex.DomOrder);
  };
  var onPlayerSettingsButtonClick = function onPlayerSettingsButtonClick(e) {
    e.preventDefault();
    if (_isOpen) {
      hideView();
    } else {
      showView();
      highlightDisabler.disableHighlightsOnMouseClick(_$playbackRateSelectEl, e);
    }
  };
  var onDisplayCaptionControl = function onDisplayCaptionControl(e, eventData) {
    if (eventData.displayCaptionControl) {
      _$closedCaptionToggleContainer.removeClass(cssClasses.hide);
    } else {
      _$closedCaptionToggleContainer.addClass(cssClasses.hide);
    }
  };
  var loadSavedSettings = function loadSavedSettings() {
    var savedPlayBackSpeedFromLocalStorage = localStorageWrapper.getItem(LOCAL_STORAGE_PLAYBACK_SPEED_KEY);
    if (savedPlayBackSpeedFromLocalStorage) {
      setPlaybackRate(+savedPlayBackSpeedFromLocalStorage);
    }
  };
  var initializeHandlers = function initializeHandlers() {
    _$playbackRateSelectEl.on('click', stopPropagation);
    _$playbackRateSelectEl.on('mouseup', stopPropagation);
    _$playbackRateSelectEl.on('change', onPlaybackRateControlChange);
    _$ccLanguageSelectEl.on('click', stopPropagation);
    _$ccLanguageSelectEl.on('mouseup', stopPropagation);
    _$ccLanguageSelectEl.on('change', onCCLanguageControlChange);
    _$playerSettingsButton.on('click', onPlayerSettingsButtonClick);
    _$settingsCloseButton.on('click', close);
    _$audioDescriptionToggle.on('change', onAudioDescriptionToggleChange);
    _$closedCaptionToggle.on('change', onClosedCaptionToggleChange);
    if (mediaElement.addEventListener) {
      mediaElement.addEventListener('ratechange', onPlaybackRateValueChange, false);
    } else if (mediaElement.on) {
      mediaElement.on('ratechange', onPlaybackRateValueChange);
    }
    $container.on(events.Controls.Disable, disableControl);
    $container.on(events.Controls.Enable, enableControl);
    $container.on('keydown', onKeyboardShortCut);
    $container.on(events.AudioDescription.Changed, onAudioDescriptionChange);
    $container.on(events.Captions.Toggled, onCaptionsToggled);
    $container.on(events.Controls.DisplayCaptionControl, onDisplayCaptionControl);
  };
  var destroy = function destroy() {
    _$playbackRateSelectEl.off('click', stopPropagation);
    _$playbackRateSelectEl.off('mouseup', stopPropagation);
    _$playbackRateSelectEl.off('change', onPlaybackRateControlChange);
    _$ccLanguageSelectEl.off('click', stopPropagation);
    _$ccLanguageSelectEl.off('mouseup', stopPropagation);
    _$ccLanguageSelectEl.off('change', onCCLanguageControlChange);
    _$playerSettingsButton.off('click', onPlayerSettingsButtonClick);
    _$settingsCloseButton.off('click', close);
    _$audioDescriptionToggle.off('change', onAudioDescriptionToggleChange);
    _$closedCaptionToggle.off('change', onClosedCaptionToggleChange);
    if (mediaElement.removeEventListener) {
      mediaElement.removeEventListener('ratechange', onPlaybackRateValueChange);
    } else if (mediaElement.off) {
      mediaElement.off('ratechange', onPlaybackRateValueChange);
    }
    $container.off(events.Controls.Disable, disableControl);
    $container.off(events.Controls.Enable, enableControl);
    $container.off('keydown', onKeyboardShortCut);
    $container.off(events.AudioDescription.Changed, onAudioDescriptionChange);
    $container.off(events.Captions.Toggled, onCaptionsToggled);
    $container.off(events.Controls.DisplayCaptionControl, onDisplayCaptionControl);
  };
  var open = function open() {
    if (!_isOpen) {
      showView();
    }
  };
  var close = function close() {
    if (_isOpen) {
      hideView();
    }
  };
  loadSavedSettings();
  initializeHandlers();
  hideView();
  return Object.defineProperties({
    open: open,
    close: close,
    destroy: destroy
  }, {
    isOpen: {
      get: function get() {
        return _isOpen;
      }
    },
    playbackRate: {
      get: function get() {
        return _currentPlaybackRate;
      },
      set: setPlaybackRate
    }
  });
};
var PlayerSettingsView$1 = {
  /**
   *  Factory method that returns a new PlayerSettingsView object.
   *  @function create
   *  @memberof TSC.PlayerSettingsView
   *  @static
   *  @param {Object} $container - jQuery element that contains a .settings-button element and a .player-settings-wrapper element where the player settings controls will be injected
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @param {Array} playbackRates - optional - a list of available playback rates
   *  @param {TSC.xmp} xmp - optional - xmp data model
   *  @param {string} audioDescriptionMediaSrc - optional - string containing media source to determine if Audio Description button is needed
   *  @return new PlayerSettingsView instance
   */
  create: PlayerSettingsView,
  /**
   *  Method that hides the settings button within a container.
   *  @function hideButton
   *  @memberof TSC.PlayerSettingsView
   *  @static
   *  @param {Object} $container - jQuery element that contains a .settings-button element to be hidden
   */
  hideButton: hideButton
};

/**
 * @memberof TSC
 * @class nullPipController
 * @classdesc Null controller when PIP feature is not available
 */
var noop = function noop() {}; // eslint-disable-line

var nullPipController = Object.defineProperties({
  enter: noop,
  exit: noop,
  bindChangeEvent: noop,
  unbindChangeEvent: noop
}, {
  inPip: {
    get: function get() {
      return false;
    }
  },
  isSupported: {
    get: function get() {
      return false;
    }
  }
});

var ENTER_PIP_EVENT = 'enterpictureinpicture';
var LEAVE_PIP_EVENT = 'leavepictureinpicture';

/**
 * @memberof TSC
 * @class StandardsPipController
 * @classdesc Controller to interface with standards PIP api.
 * @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
 */
var StandardsPipController = function StandardsPipController(mediaElement) {
  var documentRef = documentWrapper.getDocument();
  var enter = function enter() {
    mediaElement.requestPictureInPicture();
  };
  var exit = function exit() {
    documentRef.exitPictureInPicture();
  };
  var bindChangeEvent = function bindChangeEvent(onChangeHandler) {
    mediaElement.addEventListener(ENTER_PIP_EVENT, onChangeHandler);
    mediaElement.addEventListener(LEAVE_PIP_EVENT, onChangeHandler);
  };
  var unbindChangeEvent = function unbindChangeEvent(onChangeHandler) {
    mediaElement.removeEventListener(ENTER_PIP_EVENT, onChangeHandler);
    mediaElement.removeEventListener(LEAVE_PIP_EVENT, onChangeHandler);
  };
  return Object.defineProperties({
    enter: enter,
    exit: exit,
    bindChangeEvent: bindChangeEvent,
    unbindChangeEvent: unbindChangeEvent
  }, {
    inPip: {
      get: function get() {
        return mediaElement === documentRef.pictureInPictureElement;
      }
    },
    isSupported: {
      get: function get() {
        return true;
      }
    }
  });
};
var isControllerSupported$1 = function isControllerSupported() {
  var documentRef = documentWrapper.getDocument();
  return 'pictureInPictureEnabled' in documentRef && documentRef.pictureInPictureEnabled;
};
var StandardsPipController$1 = {
  /**
   *  Factory method that returns a new StandardsPipController object
   *  @function create
   *  @memberof TSC.StandardsPipController
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @static
   *  @return new StandardsPipController instance
   */
  create: StandardsPipController,
  /**
   *  Check to see if StandardsPipController is supported for platform being run on
   *  @function isControllerSupported
   *  @memberof TSC.StandardsPipController
   *  @static
   *  @return {Boolean} is controller supported on platform
   */
  isControllerSupported: isControllerSupported$1
};

var CHANGED_PIP_MODE_SAFARI_EVENT = 'webkitpresentationmodechanged';
var SAFARI_INLINE_MODE = 'inline';
var SAFARI_PIP_MODE = 'picture-in-picture';

/**
 * @memberof TSC
 * @class LegacySafariPipController
 * @classdesc Controller to interface with Safari PIP api.  This API is supported before Safari 14.
 *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
 */
var LegacySafariPipController = function LegacySafariPipController(mediaElement) {
  var enter = function enter() {
    mediaElement.webkitSetPresentationMode(SAFARI_PIP_MODE);
  };
  var exit = function exit() {
    mediaElement.webkitSetPresentationMode(SAFARI_INLINE_MODE);
  };
  var bindChangeEvent = function bindChangeEvent(onChangeHandler) {
    mediaElement.addEventListener(CHANGED_PIP_MODE_SAFARI_EVENT, onChangeHandler);
  };
  var unbindChangeEvent = function unbindChangeEvent(onChangeHandler) {
    mediaElement.removeEventListener(CHANGED_PIP_MODE_SAFARI_EVENT, onChangeHandler);
  };
  return Object.defineProperties({
    enter: enter,
    exit: exit,
    bindChangeEvent: bindChangeEvent,
    unbindChangeEvent: unbindChangeEvent
  }, {
    inPip: {
      get: function get() {
        return mediaElement.webkitPresentationMode === SAFARI_PIP_MODE;
      }
    },
    isSupported: {
      get: function get() {
        return true;
      }
    }
  });
};
var isControllerSupported = function isControllerSupported(mediaElement) {
  return mediaElement && typeof mediaElement.webkitSetPresentationMode === 'function' && typeof mediaElement.webkitSupportsPresentationMode === 'function' && mediaElement.webkitSupportsPresentationMode(SAFARI_PIP_MODE);
};
var LegacySafariPipController$1 = {
  /**
   *  Factory method that returns a new LegacySafariPipController object
   *  @function create
   *  @memberof TSC.LegacySafariPipController
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @static
   *  @return new LegacySafariPipController instance
   */
  create: LegacySafariPipController,
  /**
   *  Check to see if LegacySafariPipController is supported for platform being run on
   *  @function isControllerSupported
   *  @memberof TSC.LegacySafariPipController
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @static
   *  @return {Boolean} is controller supported on platform
   */
  isControllerSupported: isControllerSupported
};

var getPipController = function getPipController(mediaElement) {
  if (!playerConfiguration.disablePictureInPicture && StandardsPipController$1.isControllerSupported()) {
    return StandardsPipController$1.create(mediaElement);
  } else if (!playerConfiguration.disablePictureInPicture && LegacySafariPipController$1.isControllerSupported(mediaElement)) {
    return LegacySafariPipController$1.create(mediaElement);
  }
  return nullPipController;
};
var pipControllerFactory = {
  getPipController: getPipController
};

/**
 * @memberof TSC
 * @class PipControlView
 * @classdesc PIP View Control
 *  @param {Object} $container - jQuery element that contains a .settings-button element and a .player-settings-wrapper element where the player settings controls will be injected
 *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
 */
var PipControlView = function PipControlView($container, mediaElement) {
  var _$pipButton = null;
  var _pipApiController = null;
  var onPresentationModeChange = function onPresentationModeChange() {
    $container.trigger(events.Controls.PipChanged, {
      pipViewActive: _pipApiController.inPip
    });
  };
  var onPipControlClick = function onPipControlClick(e) {
    e.preventDefault();
    _pipApiController.enter();
  };
  var handleSmartPlayerActionEvents = function handleSmartPlayerActionEvents() {
    if (_pipApiController && _pipApiController.inPip) {
      _pipApiController.exit();
    }
  };
  var disableControl = function disableControl() {
    _$pipButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControl = function enableControl() {
    _$pipButton.attr('tabindex', tabIndex.DomOrder);
  };
  var createView = function createView() {
    var buttonTitle = localizationStrings.getPlayerString(playerStringNames.accessBtnPip);
    var _markup = templateGenerator.generatePipControlMarkup(buttonTitle);
    $container.find('.pip-wrapper').html(_markup);
    _$pipButton = $container.find('.pip-button');
  };
  var initializeHandlers = function initializeHandlers() {
    _pipApiController.bindChangeEvent(onPresentationModeChange);
    _$pipButton.on('click', onPipControlClick);
    $container.on(events.Hotspots.Paused, handleSmartPlayerActionEvents);
    $container.on(events.Quizzing.Paused, handleSmartPlayerActionEvents);
    $container.on(events.Media.End, handleSmartPlayerActionEvents);
    $container.on(events.Controls.Disable, disableControl);
    $container.on(events.Controls.Enable, enableControl);
  };
  var initialize = function initialize() {
    _pipApiController = pipControllerFactory.getPipController(mediaElement);
    if (_pipApiController.isSupported) {
      createView();
      initializeHandlers();
    }
  };
  var destroy = function destroy() {
    if (_pipApiController && _pipApiController.isSupported) {
      _pipApiController.unbindChangeEvent(onPresentationModeChange);
      _$pipButton.off('click', onPipControlClick);
      $container.off(events.Hotspots.Paused, handleSmartPlayerActionEvents);
      $container.off(events.Quizzing.Paused, handleSmartPlayerActionEvents);
      $container.off(events.Media.End, handleSmartPlayerActionEvents);
      $container.off(events.Controls.Disable, disableControl);
      $container.off(events.Controls.Enable, enableControl);
    }
  };
  return Object.defineProperties({
    initialize: initialize,
    destroy: destroy
  }, {});
};
var PipControlView$1 = {
  /**
   *  Factory method that returns a new PipControlView object.
   *  @function create
   *  @memberof TSC.PipControlView
   *  @param {Object} $container - jQuery element that contains a .settings-button element and a .player-settings-wrapper element where the player settings controls will be injected
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @static
   *  @return new PipControlView instance
   */
  create: PipControlView
};

var DisplayModes = {
  Normal: 'normal',
  Theater: 'theater',
  Fullscreen: 'fullscreen',
  PictureInPicture: 'picture-in-picture'
};

var LOCAL_STORAGE_DISPLAY_MODE_KEY = 'tscSmartPlayerDisplayMode';

/**
 * @memberof TSC
 * @class TheaterModeControlView
 * @classdesc Theater Mode View Control
 * @param {Object} $container - jQuery element that contains a wrapper element where the theater mode control will be injected
 */
var TheaterModeControlView = function TheaterModeControlView($container) {
  var _theaterModeEnabled = false;
  var _$theaterModeButton;
  var _$theaterModeGlyph;
  var disableControl = function disableControl() {
    _$theaterModeButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControl = function enableControl() {
    _$theaterModeButton.attr('tabindex', tabIndex.DomOrder);
  };
  var sendTheaterModeChangedEvent = function sendTheaterModeChangedEvent() {
    $container.trigger(events.Controls.TheaterModeChanged, {
      displayMode: _theaterModeEnabled ? DisplayModes.Theater : DisplayModes.Normal
    });
  };
  var setDisplayMode = function setDisplayMode(enabled) {
    _theaterModeEnabled = enabled;
    $container.playerState.displayMode = _theaterModeEnabled ? DisplayModes.Theater : DisplayModes.Normal;
    localStorageWrapper.setItem(LOCAL_STORAGE_DISPLAY_MODE_KEY, $container.playerState.displayMode);
    if (_theaterModeEnabled) {
      _$theaterModeButton.attr('title', localizationStrings.getPlayerString(playerStringNames.accessBtnExitTheaterMode));
      _$theaterModeButton.attr('aria-pressed', true);
      _$theaterModeGlyph.removeClass(cssClasses.theaterModeButtonGlyph).addClass(cssClasses.theaterModeButtonActiveGlyph);
      _$theaterModeButton.removeClass(cssClasses.tertiaryButton).addClass(cssClasses.tertiaryButtonActive);
    } else {
      _$theaterModeButton.attr('title', localizationStrings.getPlayerString(playerStringNames.accessBtnTheaterMode));
      _$theaterModeButton.attr('aria-pressed', false);
      _$theaterModeGlyph.removeClass(cssClasses.theaterModeButtonActiveGlyph).addClass(cssClasses.theaterModeButtonGlyph);
      _$theaterModeButton.removeClass(cssClasses.tertiaryButtonActive).addClass(cssClasses.tertiaryButton);
    }
  };
  var loadSavedSettings = function loadSavedSettings() {
    var savedDisplayStateStorage = localStorageWrapper.getItem(LOCAL_STORAGE_DISPLAY_MODE_KEY);
    if (savedDisplayStateStorage) {
      setDisplayMode(savedDisplayStateStorage === DisplayModes.Theater);
      sendTheaterModeChangedEvent();
    } else {
      setDisplayMode(_theaterModeEnabled);
    }
  };
  var onFullscreenChange = function onFullscreenChange(e, eventData) {
    if (eventData.inFullScreen) {
      _$theaterModeButton.hide();
    } else {
      _$theaterModeButton.show();
    }
  };
  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    setDisplayMode(!_theaterModeEnabled);
    sendTheaterModeChangedEvent();
  };
  var createView = function createView() {
    var markup = templateGenerator.generateTheaterModeButtonMarkup();
    $container.find('.theater-mode-wrapper').html(markup);
    _$theaterModeButton = $container.find('.theater-mode-button');
    _$theaterModeGlyph = $container.find('.theater-mode-button-glyph');
  };
  var initializeHandlers = function initializeHandlers() {
    _$theaterModeButton.on('click', onButtonClick);
    $container.on(events.Controls.PlayerInitialized, loadSavedSettings);
    $container.on(events.Controls.FullScreenChange, onFullscreenChange);
    $container.on(events.Controls.Disable, disableControl);
    $container.on(events.Controls.Enable, enableControl);
  };
  var destroy = function destroy() {
    _$theaterModeButton.off('click', onButtonClick);
    $container.off(events.Controls.PlayerInitialized, loadSavedSettings);
    $container.off(events.Controls.FullScreenChange, onFullscreenChange);
    $container.off(events.Controls.Disable, disableControl);
    $container.off(events.Controls.Enable, enableControl);
  };
  createView();
  initializeHandlers();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var TheaterModeControlView$1 = {
  create: TheaterModeControlView
};

var FULL_SCREEN_BUTTON_MODE = 'fullScreenMode';
var FULL_FRAME_BUTTON_MODE = 'fullFrameMode';
var EXPAND_BUTTON_MODE = 'expandMode';
var HIDDEN_BUTTON_MODE = 'hiddenMode';

/**
 * @memberof TSC
 * @class FullscreenControlView
 * @classdesc Full Screen Control View
 * @param {jQuery} $container - top level Smart Player container
 * @param {HTMLVideoElement} videoElement
 */
var FullscreenControlView = function FullscreenControlView($container, videoElement) {
  var _inFullScreen = false;
  var _inFullFrame = false;
  var _$document = $(window.document);
  var _$fullScreenButton;
  var _$fullScreenGlyph;
  var _fullScreenDomElement = playerConfiguration.customFullScreenDomElement ? playerConfiguration.customFullScreenDomElement : $container.get(0);
  var _elementToFullscreen;
  var _buttonMode = null;
  var _legacyIOSFullScreenMode = false;
  var findButtonMode = function findButtonMode(canSupportExpandVideoMode) {
    if (deviceInfo.supportsFullScreen()) {
      _legacyIOSFullScreenMode = false;
      _elementToFullscreen = _fullScreenDomElement;
      _buttonMode = FULL_SCREEN_BUTTON_MODE;
    } else if (deviceInfo.supportsLegacyIOSFullScreen(videoElement)) {
      _legacyIOSFullScreenMode = true;
      _elementToFullscreen = videoElement;
      _buttonMode = FULL_SCREEN_BUTTON_MODE;
    } else if (iFrameBridge.isInIframe() && canSupportExpandVideoMode) {
      _buttonMode = playerConfiguration.getDisableFullframeMode() ? EXPAND_BUTTON_MODE : FULL_FRAME_BUTTON_MODE;
    } else {
      _buttonMode = HIDDEN_BUTTON_MODE;
    }
  };
  var updateButtonTitle = function updateButtonTitle() {
    var buttonTitle = localizationStrings.getPlayerString(playerStringNames.accessBtnFullScreen);
    if (_buttonMode === EXPAND_BUTTON_MODE) {
      buttonTitle = localizationStrings.getPlayerString(playerStringNames.accessBtnFullScreenExpand);
    }
    _$fullScreenButton.attr('title', buttonTitle);
  };
  var setButtonDisplay = function setButtonDisplay() {
    if (_buttonMode === HIDDEN_BUTTON_MODE) {
      _$fullScreenButton.hide();
    } else {
      _$fullScreenButton.show();
    }
  };
  var createView = function createView() {
    var buttonTitle = localizationStrings.getPlayerString(playerStringNames.accessBtnFullScreen);
    if (_buttonMode === EXPAND_BUTTON_MODE) {
      buttonTitle = localizationStrings.getPlayerString(playerStringNames.accessBtnFullScreenExpand);
    }
    var _markup = templateGenerator.generateFullscreenControlMarkup(buttonTitle);
    $container.find('.fullscreen-wrapper').html(_markup);
    _$fullScreenButton = $container.find('.fullscreen-button');
    _$fullScreenGlyph = $container.find('.fullscreen-button-glyph');
  };
  var onFullScreenChange = function onFullScreenChange() {
    _inFullScreen = !_inFullScreen;
    if (_inFullScreen) {
      _$fullScreenGlyph.removeClass(cssClasses.fullscreenButtonGlyph);
      _$fullScreenGlyph.addClass(cssClasses.fullscreenButtonActiveGlyph);
      _$fullScreenButton.attr('aria-pressed', true);
      _$fullScreenButton.focus();
      $container.addClass(cssClasses.fullscreenMode);
    } else {
      _$fullScreenGlyph.removeClass(cssClasses.fullscreenButtonActiveGlyph);
      _$fullScreenGlyph.addClass(cssClasses.fullscreenButtonGlyph);
      _$fullScreenButton.attr('aria-pressed', false);
      $container.removeClass(cssClasses.fullscreenMode);
    }
    $container.trigger(events.Controls.FullScreenChange, {
      inFullScreen: _inFullScreen
    });
  };
  var initializeFullScreenSupport = function initializeFullScreenSupport(canSupportExpandVideoMode) {
    findButtonMode(canSupportExpandVideoMode);
    updateButtonTitle();
    setButtonDisplay();
    initializeHandlers();
  };
  var cancelFullScreen = function cancelFullScreen() {
    _$fullScreenButton.attr('aria-pressed', false);
    fullscreenHelper.exitFullscreenMode(videoElement);
  };
  var switchToFullScreenMode = function switchToFullScreenMode() {
    _$fullScreenButton.attr('aria-pressed', true);
    fullscreenHelper.switchToFullscreenMode(_elementToFullscreen);
  };
  var switchFromFullScreenMode = function switchFromFullScreenMode() {
    cancelFullScreen();
  };
  var toggleFullScreenMode = function toggleFullScreenMode() {
    if (!_inFullScreen) {
      switchToFullScreenMode();
    } else {
      switchFromFullScreenMode();
    }
  };
  var toggleFullFrameMode = function toggleFullFrameMode() {
    _inFullFrame = !_inFullFrame;
    if (_inFullFrame) {
      _$fullScreenGlyph.removeClass(cssClasses.fullFrameButtonGlyph);
      _$fullScreenGlyph.addClass(cssClasses.fullFrameButtonActiveGlyph);
      _$fullScreenButton.attr('aria-pressed', true);
      iFrameBridge.postMessage(events.IFrame.EnterFullFrame, '*');
    } else {
      _$fullScreenGlyph.removeClass(cssClasses.fullFrameButtonActiveGlyph);
      _$fullScreenGlyph.addClass(cssClasses.fullFrameButtonGlyph);
      iFrameBridge.postMessage(events.IFrame.ExitFullFrame, '*');
      _$fullScreenButton.attr('aria-pressed', false);
    }
  };
  var expandVideo = function expandVideo() {
    $container.trigger(events.Controls.ExpandVideo);
    urlService.openUrl(urlService.generateCurrentUrlWithExtraQueryParam('theme', playerConfiguration.getTheme()), '_blank');
  };
  var onFullScreenClick = function onFullScreenClick() {
    switch (_buttonMode) {
      case FULL_SCREEN_BUTTON_MODE:
        toggleFullScreenMode();
        break;
      case FULL_FRAME_BUTTON_MODE:
        toggleFullFrameMode();
        break;
      case EXPAND_BUTTON_MODE:
        expandVideo();
        break;
    }
  };
  var onDoubleClick = function onDoubleClick() {
    switch (_buttonMode) {
      case FULL_SCREEN_BUTTON_MODE:
        toggleFullScreenMode();
        break;
      case FULL_FRAME_BUTTON_MODE:
        toggleFullFrameMode();
        break;
    }
  };
  var disableControl = function disableControl() {
    _$fullScreenButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControl = function enableControl() {
    _$fullScreenButton.attr('tabindex', tabIndex.DomOrder);
  };
  var checkToExitFullScreen = function checkToExitFullScreen() {
    if (_legacyIOSFullScreenMode) {
      switchFromFullScreenMode();
    }
  };
  var onFullButtonClick = function onFullButtonClick(e) {
    onFullScreenClick();
    e.preventDefault();
  };
  var initializeHandlers = function initializeHandlers() {
    _$fullScreenButton.on('click', onFullButtonClick);
    $container.on(events.Controls.Disable, disableControl);
    $container.on(events.Controls.Enable, enableControl);
    $container.on(events.Quizzing.Paused, checkToExitFullScreen);
    $container.on(events.Hotspots.Paused, checkToExitFullScreen);
    $container.on(events.Media.End, checkToExitFullScreen);
    $container.on(events.Controls.ToggleFullScreen, toggleFullScreenMode);
    switch (_buttonMode) {
      case FULL_SCREEN_BUTTON_MODE:
        if (_legacyIOSFullScreenMode) {
          videoElement.addEventListener('webkitbeginfullscreen', onFullScreenChange);
          videoElement.addEventListener('webkitendfullscreen', onFullScreenChange);
        } else {
          var fullScreenEventNames = deviceInfo.getFullScreenChangeEventNames();
          _$document.off(fullScreenEventNames, onFullScreenChange);
          _$document.on(fullScreenEventNames, onFullScreenChange);
        }
        break;
      case FULL_FRAME_BUTTON_MODE:
        _$fullScreenGlyph.removeClass(cssClasses.fullscreenButtonGlyph);
        _$fullScreenGlyph.addClass(cssClasses.fullFrameButtonGlyph);
        break;
      case EXPAND_BUTTON_MODE:
        _$fullScreenGlyph.removeClass(cssClasses.fullscreenButtonGlyph);
        _$fullScreenGlyph.addClass(cssClasses.expandButtonGlyph);
        break;
    }
  };
  var onVideoEnd = function onVideoEnd() {
    // must kick them out of full screen to get the replay button to show
    if (_inFullScreen) {
      cancelFullScreen();
    }
  };
  var destroy = function destroy() {
    _$fullScreenButton.off('click', onFullButtonClick);
    videoElement.removeEventListener('webkitbeginfullscreen', onFullScreenChange);
    videoElement.removeEventListener('webkitendfullscreen', onFullScreenChange);
    $container.off(events.Controls.Disable, disableControl);
    $container.off(events.Controls.Enable, enableControl);
    $container.off(events.Quizzing.Paused, checkToExitFullScreen);
    $container.off(events.Hotspots.Paused, checkToExitFullScreen);
    $container.off(events.Media.End, checkToExitFullScreen);
    $container.off(events.Controls.ToggleFullScreen, toggleFullScreenMode);
  };
  findButtonMode(false);
  createView();
  setButtonDisplay();
  return Object.defineProperties({
    initializeFullScreenSupport: initializeFullScreenSupport,
    onVideoEnd: onVideoEnd,
    onDoubleClick: onDoubleClick,
    destroy: destroy
  }, {
    isFullScreen: {
      get: function get() {
        return _inFullScreen;
      }
    },
    isFullFrame: {
      get: function get() {
        return _inFullFrame;
      }
    },
    controlElement: {
      get: function get() {
        return _$fullScreenButton;
      }
    }
  });
};
var FullscreenControlView$1 = {
  /**
   *  Factory method that returns a new FullscreenControlView object.
   *  @function create
   *  @memberof TSC.FullscreenControlView
   *  @static
   *  @param {Object} $container - jQuery element that contains a .fullscreen-wrapper element where the fullscreen controls will be injected
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @return new FullscreenControlView instance
   */
  create: FullscreenControlView
};

var DEFAULT_DOUBLE_CLICK_DELAY = 300;
var SINGLE_CLICK_COUNT = 1;
var DOUBLE_CLICK_COUNT = 2;

/**
 * @memberof TSC
 * @class ClickControlsView
 * @classdesc Control that allows uer to click on video area to toggle play / pause and full screen mode.
 * @param {jQuery} $container - root Smart Player dom element
 * @param {HTMLVideoElement} mediaElement
 * @param {TSC.FullscreenControlView} fullscreenControlView
 * @param {TSC.ProgressBarControlView} progressBarControlView
 * @param {TSC.playerConfiguration} playerConfiguration
 * @param {Number} [doubleClickDelay] - time delay to track double clicks
 */
var ClickControlsView = function ClickControlsView($container, mediaElement, fullscreenControlView, progressBarControlView, playerConfiguration, doubleClickDelay) {
  var _$clickControls = $container.find('.click-controls');
  var _$playPauseStateContainer = $container.find('.play-pause-state');
  var _$playPauseStateIndicator = $container.find('.play-pause-state-indicator');
  var _clicks = 0;
  var _doubleClickTimer = null;
  var _enabled = true;
  var _draggingCaption = false;
  var _mediaPluginInteractionActive = false;
  var _doubleClickDelay = doubleClickDelay || DEFAULT_DOUBLE_CLICK_DELAY;
  var onClickPlay = function onClickPlay() {
    if (mediaElement.ended) {
      $container.trigger(events.Media.Replay);
    } else {
      mediaElement.play();
    }
    _$playPauseStateIndicator.removeClass('pause-button-background-glyph').addClass('play-button-background-glyph');
    _$playPauseStateContainer.show().fadeOut('slow');
  };
  var onClickPause = function onClickPause() {
    if (mediaElement.currentTime !== mediaElement.duration) {
      mediaElement.pause();
      _$playPauseStateIndicator.removeClass('play-button-background-glyph').addClass('pause-button-background-glyph');
      _$playPauseStateContainer.show().fadeOut('slow');
    }
  };
  var processHotspotActiveChange = function processHotspotActiveChange(e, eventData) {
    if (e.type === events.Hotspots.Paused && eventData && eventData.hasTimeChangeAction) {
      disable();
    } else if (e.type === events.Hotspots.Resume) {
      enable();
    }
  };
  var onControlClick = function onControlClick(e) {
    if (_mediaPluginInteractionActive || !_enabled || _draggingCaption || e.button !== mouseButtons.mainButton) {
      _mediaPluginInteractionActive = false;
      return;
    }
    _clicks++;
    clearTimeout(_doubleClickTimer);
    if (_clicks === SINGLE_CLICK_COUNT) {
      var mediaPaused = mediaElement.paused;
      _doubleClickTimer = setTimeout(function () {
        _clicks = 0;
        if (!playerConfiguration.getEnableSingleClickControl()) {
          return;
        }
        if (mediaElement.paused === mediaPaused && !progressBarControlView.scrubbing) {
          mediaElement.paused ? onClickPlay() : onClickPause();
        }
      }, _doubleClickDelay);
    } else if (_clicks === DOUBLE_CLICK_COUNT) {
      _clicks = 0;
      if (!playerConfiguration.getEnableDoubleClickControl()) {
        return;
      }
      fullscreenControlView.onDoubleClick();
    }
  };
  var onCaptionDragStart = function onCaptionDragStart() {
    _draggingCaption = true;
  };
  var onCaptionDragEnd = function onCaptionDragEnd() {
    _draggingCaption = false;
  };
  var processMediaAreaPluginInteractiveHandler = function processMediaAreaPluginInteractiveHandler() {
    _mediaPluginInteractionActive = true;
  };
  var bindEvents = function bindEvents() {
    $container.on(events.Captions.DragStart, onCaptionDragStart);
    $container.on(events.Captions.DragEnd, onCaptionDragEnd);
    $container.on(events.Hotspots.Paused, processHotspotActiveChange);
    $container.on(events.Hotspots.Resume, processHotspotActiveChange);
    $container.on(events.Plugin.MediaAreaPluginMouseDown, processMediaAreaPluginInteractiveHandler);
    $container.on(events.Plugin.MediaAreaPluginKeyDown, processMediaAreaPluginInteractiveHandler);
    _$clickControls.on('click', onControlClick);
  };
  var enable = function enable() {
    _enabled = true;
  };
  var disable = function disable() {
    _enabled = false;
  };
  var destroy = function destroy() {
    $container.off(events.Captions.DragStart, onCaptionDragStart);
    $container.off(events.Captions.DragEnd, onCaptionDragEnd);
    $container.off(events.Hotspots.Paused, processHotspotActiveChange);
    $container.off(events.Hotspots.Resume, processHotspotActiveChange);
    $container.off(events.Plugin.MediaAreaPluginMouseDown, processMediaAreaPluginInteractiveHandler);
    $container.off(events.Plugin.MediaAreaPluginKeyDown, processMediaAreaPluginInteractiveHandler);
    _$clickControls.off('click', onControlClick);
  };
  bindEvents();
  return Object.defineProperties({
    enable: enable,
    disable: disable,
    destroy: destroy
  }, {});
};
var ClickControlsView$1 = {
  /**
   *  Factory method that returns a new ClickControlsView object
   *  @function create
   *  @memberof TSC.ClickControlsView
   *  @param {jQuery} $container - root Smart Player dom element
   *  @param {HTMLVideoElement} mediaElement
   *  @param {TSC.FullscreenControlView} fullscreenControlView
   *  @param {TSC.ProgressBarControlView} progressBarControlView
   *  @param {TSC.playerConfiguration} playerConfiguration
   *  @param {Number} [doubleClickDelay] - time delay to track double clicks
   *  @static
   *  @return new ClickControlsView instance
   */
  create: ClickControlsView
};

var ANIMATION_SPEED = 300;
var AUTO_HIDE_TIME_OUT_IN_MILLISECONDS = 5000;
var MOUSE_MOVE_TOLERANCE = 5;
var SURFACE_CLICK_LEAVE_DELAY = 100;

/**
 * @memberof TSC
 * @class VideoControlsController
 * @classdesc Video controls controller - binds all the controls used for a video in Smart Player
 * @param {jQuery} $rootSmartPlayerElement
 * @param {MediaView} mediaView
 * @param {TSC.XmpModel} xmpModel
 * @param {TSC.Quiz} quizModel
 * @param {TSC.playerConfiguration} playerConfiguration
 */
var VideoControlsController = function VideoControlsController($rootSmartPlayerElement, mediaView, xmpModel, quizModel, playerConfiguration) {
  // eslint-disable-line
  var _windowRef = windowWrapper.getWindow();
  var _displayStartScreenOnPlaybackError = false;
  var _$videoControlsContainer;
  var _beforeAfterPlayControlsView;
  var _progressBarControlView;
  var _playRewindControlsView;
  var _prevNextControlsView;
  var _volumeControlView;
  var _audioDescriptionControlView;
  var _captionsControlView;
  var _tocControlView;
  var _playerSettingsView;
  var _pipControlView;
  var _theaterModeControlView;
  var _fullScreenControlView;
  var _clickControlsView;
  var _mediaIsSeeking = false;
  var _timeToSeekAfterCurrentSeekOperation = -1;
  var _displayMode = mediaInterfaceConstants.controls.autohide;
  var _playbackInitialized = false;
  var _userNeedToClickHeroPlayControl = false;
  var _lastClickTime;
  var _controlsHidden = true;
  var _autoHideControlsTimeoutId = -1;
  var _lastMouseMoveCoords = {
    x: 0,
    y: 0
  };
  var onPlayPromiseError = function onPlayPromiseError() {
    // safari fires an abort error when playback is started and document is hidden
    // in this case we do not want to assume user interaction is needed to play
    if (window.document.hidden || !_displayStartScreenOnPlaybackError) {
      return;
    }
    // Assume user interaction is needed to play
    _playbackInitialized = false;
    _displayStartScreenOnPlaybackError = false;
    setControlsDisplayMode(mediaInterfaceConstants.controls["false"]);
    _beforeAfterPlayControlsView.showVideoClickToPlayLink();
  };
  var isScrubbingVideo = function isScrubbingVideo() {
    return _progressBarControlView ? _progressBarControlView.scrubbing : false;
  };
  var hideControls = function hideControls(forceHide, hideElementAfterFadeOut) {
    if (_displayMode === mediaInterfaceConstants.controls["true"]) {
      return;
    }
    var controlsAreBusy = isScrubbingVideo() || _playerSettingsView && _playerSettingsView.isOpen;
    if (!forceHide && controlsAreBusy) {
      return;
    }
    _controlsHidden = true;
    _$videoControlsContainer.stop(true, true);
    _$videoControlsContainer.fadeTo(ANIMATION_SPEED, 0, function () {
      if (hideElementAfterFadeOut) {
        _$videoControlsContainer.hide();
      }
    });
    _volumeControlView.hideControls();
    $rootSmartPlayerElement.removeClass(cssClasses.playerControlsVisible);
    $rootSmartPlayerElement.trigger(events.Controls.VideoControlsHidden);
  };
  var hideControlsOnTimeout = function hideControlsOnTimeout(forceHide) {
    hideControls(forceHide, false);
    if (_controlsHidden) {
      _clickControlsView && _clickControlsView.disable();
    }
  };
  var clearHideControlsTimeout = function clearHideControlsTimeout() {
    _windowRef.clearTimeout(_autoHideControlsTimeoutId);
  };
  var resetHideControlsTimeout = function resetHideControlsTimeout() {
    clearHideControlsTimeout();
    if (playerConfiguration.getAutoHideControls()) {
      _autoHideControlsTimeoutId = _windowRef.setTimeout(hideControlsOnTimeout, AUTO_HIDE_TIME_OUT_IN_MILLISECONDS);
    }
  };
  var enableClickControlsIfNotPausedForHotspot = function enableClickControlsIfNotPausedForHotspot() {
    if (!$rootSmartPlayerElement.playerState.oneOrMoreHotspotsWithTimeActionArePaused && _clickControlsView) {
      if (deviceInfo.isTouchInterface()) {
        setTimeout(_clickControlsView.enable, ANIMATION_SPEED);
      } else {
        _clickControlsView.enable();
      }
    }
  };
  var showControls = function showControls(autoHideControls) {
    if (_controlsHidden) {
      _controlsHidden = false;
      _$videoControlsContainer.removeClass(cssClasses.hide);
      _$videoControlsContainer.stop(true, true);
      _$videoControlsContainer.show();
      _$videoControlsContainer.fadeTo(ANIMATION_SPEED, 1);
      enableClickControlsIfNotPausedForHotspot();
      $rootSmartPlayerElement.addClass(cssClasses.playerControlsVisible);
      $rootSmartPlayerElement.trigger(events.Controls.VideoControlsVisible);
    }
    if (autoHideControls) {
      resetHideControlsTimeout();
    }
  };
  var showControlsWithAutoHide = function showControlsWithAutoHide() {
    showControls(true);
  };
  var onContainerClick = function onContainerClick() {
    _lastClickTime = new Date().getTime();
    showControlsWithAutoHide();
  };
  var onContainerLeave = function onContainerLeave() {
    //Older Win touch devices emulate clicks with Enter -> Click -> Leave, so we need hax for them
    if (!_lastClickTime || new Date().getTime() - _lastClickTime > SURFACE_CLICK_LEAVE_DELAY) {
      hideControlsOnTimeout();
    }
  };
  var onContainerMousemove = function onContainerMousemove(e) {
    var x = e.pageX;
    var y = e.pageY;
    if (!x && x !== 0 || !y && y !== 0) {
      //Just in case values aren't assigned for some reason
      showControlsWithAutoHide();
      return;
    }
    var deltaX = Math.abs(x - _lastMouseMoveCoords.x);
    var deltaY = Math.abs(y - _lastMouseMoveCoords.y);
    if (deltaX + deltaY > MOUSE_MOVE_TOLERANCE) {
      _lastMouseMoveCoords.x = x;
      _lastMouseMoveCoords.y = y;
      showControlsWithAutoHide();
    }
  };
  var enableAutoHideControls = function enableAutoHideControls() {
    $rootSmartPlayerElement.on('mousemove', onContainerMousemove);
    $rootSmartPlayerElement.on('keydown', showControlsWithAutoHide);
    $rootSmartPlayerElement.on('click', onContainerClick);
    $rootSmartPlayerElement.on('mouseleave', onContainerLeave);
    resetHideControlsTimeout();
  };
  var disableAutoHideControls = function disableAutoHideControls() {
    clearHideControlsTimeout();
    $rootSmartPlayerElement.off('mousemove', onContainerMousemove);
    $rootSmartPlayerElement.off('keydown', showControlsWithAutoHide);
    $rootSmartPlayerElement.off('click', onContainerClick);
    $rootSmartPlayerElement.off('mouseleave', onContainerLeave);
  };
  var seekVideo = function seekVideo(timeInSeconds) {
    if (!mediaView.mediaElement || isNaN(mediaView.mediaElement.currentTime) || mediaView.mediaElement.currentTime === null || isNaN(timeInSeconds) || timeInSeconds === null) {
      return;
    }
    if (_mediaIsSeeking) {
      _timeToSeekAfterCurrentSeekOperation = timeInSeconds;
      return;
    }
    _timeToSeekAfterCurrentSeekOperation = -1;
    if (mediaView.mediaElement.currentTime.toFixed(4) === timeInSeconds.toFixed(4)) {
      return;
    }
    mediaView.mediaElement.currentTime = timeInSeconds;
  };
  var initCurrentMedia = function initCurrentMedia(e, eventData) {
    if (eventData.enablePreviousButton) {
      _prevNextControlsView.enablePreviousButton();
    } else {
      _prevNextControlsView.disablePreviousButton();
    }
    if (eventData.enableNextButton) {
      _prevNextControlsView.enableNextButton();
    } else {
      _prevNextControlsView.disableNextButton();
    }
    if (_progressBarControlView) {
      _progressBarControlView.durationHasChanged();
    }
    _displayStartScreenOnPlaybackError = true;

    // ensure current time starts at 0 for FireFox to record correct played time range
    if (deviceInfo.isFirefox()) {
      mediaView.mediaElement.currentTime = 0;
    }
    mediaView.mediaElement && play();

    // OSX Safari on some machines fast forwards videos when we call play with a quiz at frame 0.
    // Resetting the current time resolves this behavior. Ref https://github.com/TechSmith/SmartPlayer/issues/387
    if (deviceInfo.isSafari() && !deviceInfo.isIOS() && mediaView.mediaElement.readyState === 0) {
      mediaView.mediaElement.addEventListener('canplay', function resetTime() {
        mediaView.mediaElement.currentTime = 0;
        mediaView.mediaElement.removeEventListener('canplay', resetTime);
      });
    }
  };
  var onPlaybackInitialized = function onPlaybackInitialized() {
    if (!_playbackInitialized) {
      _playbackInitialized = true;
      $rootSmartPlayerElement.trigger(events.Controls.StartedPlayback);
    }
  };
  var play = function play() {
    var playPromise = mediaView.mediaElement.play();
    if (playPromise !== undefined) {
      playPromise.then(function () {
        onPlaybackInitialized();
      })["catch"](function (error) {
        onPlayPromiseError();
      });
    }
  };
  var onSeekToTime = function onSeekToTime(e, eventData) {
    var time = eventData.time;
    seekVideo(time);
    setControlsDisplayMode(_displayMode);
    if (eventData.playAfterSeek) {
      mediaView.mediaElement && play();
    }
  };
  var onSetVolume = function onSetVolume(e, data) {
    if (_volumeControlView) {
      _volumeControlView.volume = data.volumeValue;
    }
  };
  var onSetMuted = function onSetMuted(e, data) {
    if (_volumeControlView) {
      _volumeControlView.muted = data.isMuted;
    }
  };
  var onSetPlaybackRate = function onSetPlaybackRate(e, data) {
    if (_playerSettingsView) {
      _playerSettingsView.playbackRate = data.playbackRate;
    }
  };
  var onVideoSeeking = function onVideoSeeking() {
    _mediaIsSeeking = true;
  };
  var onVideoSeeked = function onVideoSeeked() {
    _mediaIsSeeking = false;
    if (_timeToSeekAfterCurrentSeekOperation >= 0) {
      seekVideo(_timeToSeekAfterCurrentSeekOperation);
    }
  };
  var onVideoMetadataLoaded = function onVideoMetadataLoaded() {
    mediaView.mediaElement.removeEventListener(events.ExternalVideo.VideoLoadedMetadata, onVideoMetadataLoaded);
    var canSupportExpandVideoMode = !playerConfiguration.isScormLesson;
    _fullScreenControlView.initializeFullScreenSupport(canSupportExpandVideoMode);
    _pipControlView && _pipControlView.initialize();
    $rootSmartPlayerElement.trigger(events.Controls.HideLoadingMessage);
    seekToInitialTimeIfSet();
  };
  var teardownHideShowControls = function teardownHideShowControls() {
    if (_displayMode === mediaInterfaceConstants.controls.autohide) {
      disableAutoHideControls();
    }
  };
  var setControlsDisplayMode = function setControlsDisplayMode(displayMode) {
    teardownHideShowControls();
    _displayMode = displayMode;
    if (_displayMode === mediaInterfaceConstants.controls["false"]) {
      disableAutoHideControls();
      hideControls(true, true);
    } else if (_displayMode === mediaInterfaceConstants.controls.autohide) {
      enableAutoHideControls();
      showControls(true);
    } else {
      showControls(false);
    }
  };
  var onDisplayCaptionControl = function onDisplayCaptionControl(e, eventData) {
    if (eventData.displayCaptionControl) {
      _captionsControlView = CaptionsControlView$1.create($rootSmartPlayerElement);
    }
    if (_captionsControlView) {
      _captionsControlView.setCaptionButtonVisible(eventData.displayCaptionControl);
    }
  };
  var onDisplayTocControl = function onDisplayTocControl() {
    _tocControlView = TocControlView$1.create($rootSmartPlayerElement, playerConfiguration);
  };
  var onTocScroll = function onTocScroll() {
    resetHideControlsTimeout();
  };
  var seekToInitialTimeIfSet = function seekToInitialTimeIfSet() {
    if (!playerConfiguration.isScormLesson && playerConfiguration.jumpToTime) {
      var timeToSeek = urlService.convertUrlTime(playerConfiguration.jumpToTime);
      if (timeToSeek < mediaView.duration) {
        seekVideo(timeToSeek);
      }
    }
  };
  var initializePlayback = function initializePlayback(playVideo) {
    if (playVideo) {
      play();
    } else {
      onPlaybackInitialized();
    }
  };
  var onFirstPlay = function onFirstPlay() {
    if (!_playbackInitialized) {
      initializePlayback(false);
    }
  };
  var onHeroPlayControlClick = function onHeroPlayControlClick() {
    $rootSmartPlayerElement.off(events.Controls.HeroPlayControlClicked, onHeroPlayControlClick);
    $rootSmartPlayerElement.trigger(events.Player.MediaControlsReady);
    initializePlayback(true);
  };
  var onMediaError = function onMediaError() {
    _beforeAfterPlayControlsView.hideVideoClickToPlayLink();
    _beforeAfterPlayControlsView.setVideoClickToPlayErrorState(true);
    hideControls(true, true);
  };
  var onHotspotInactive = function onHotspotInactive() {
    enableClickControlsIfNotPausedForHotspot();
  };
  var onTryToAutoPlay = function onTryToAutoPlay() {
    _displayStartScreenOnPlaybackError = true;
    initializePlayback(true);
  };
  var setupControls = function setupControls() {
    _$videoControlsContainer = $rootSmartPlayerElement.find('.video-controls-container');
    mediaView.hotfixViewAndControlsCSS(_$videoControlsContainer);
    _beforeAfterPlayControlsView = BeforeAfterPlayControlsView$1.create($rootSmartPlayerElement, playerConfiguration);
    if (!mediaView.supportsClickToPlayControls) {
      _beforeAfterPlayControlsView.hideVideoClickToPlayLink();
    }
    _progressBarControlView = ProgressBarControlView$1.create($rootSmartPlayerElement, mediaView.mediaElement, quizModel);
    _playRewindControlsView = PlayRewindControlsView$1.create($rootSmartPlayerElement, mediaView.mediaElement);
    if (mediaView.playerControlType === playerControlsType.videoPlaylist) {
      _prevNextControlsView = PrevNextControlsView$1.create($rootSmartPlayerElement);
    }
    _volumeControlView = VolumeControlView$1.create($rootSmartPlayerElement, mediaView.mediaElement);
    if (playerConfiguration.audioDescriptionMediaSrc) {
      _audioDescriptionControlView = AudioDescriptionControlView$1.create($rootSmartPlayerElement);
    }
    _playerSettingsView = PlayerSettingsView$1.create($rootSmartPlayerElement, mediaView.mediaElement, xmpModel, null, playerConfiguration.audioDescriptionMediaSrc);
    if (mediaView.playerControlType !== playerControlsType.videoPlaylist) {
      _pipControlView = PipControlView$1.create($rootSmartPlayerElement, mediaView.mediaElement);
    }
    if (playerConfiguration.getEnableTheaterMode()) {
      _theaterModeControlView = TheaterModeControlView$1.create($rootSmartPlayerElement);
    }
    _fullScreenControlView = FullscreenControlView$1.create($rootSmartPlayerElement, mediaView.mediaElement);
    if (mediaView.supportsClickToPlayControls) {
      _clickControlsView = ClickControlsView$1.create($rootSmartPlayerElement, mediaView.mediaElement, _fullScreenControlView, _progressBarControlView, playerConfiguration);
    }
  };
  var initControls = function initControls() {
    if (playerConfiguration.getPreload() !== preloadOptions.metadata && mediaView.type !== mediaViewType.youtube) {
      _userNeedToClickHeroPlayControl = true;
      if (playerConfiguration.getPosterImageSrc()) {
        _beforeAfterPlayControlsView.addVideoClickToPlayBackground(playerConfiguration.getPosterImageSrc());
      }
      $rootSmartPlayerElement.on(events.Controls.HeroPlayControlClicked, onHeroPlayControlClick);
    } else {
      _beforeAfterPlayControlsView.hideVideoClickToPlayLink();
      _beforeAfterPlayControlsView.hideVideoClickToReplayLink();
      _userNeedToClickHeroPlayControl = false;
    }
  };
  var bindEvents = function bindEvents() {
    $rootSmartPlayerElement.on(events.Controls.DisplayCaptionControl, onDisplayCaptionControl);
    $rootSmartPlayerElement.on(events.Controls.DisplayTocControl, onDisplayTocControl);
    $rootSmartPlayerElement.on(events.Controls.TocScroll, onTocScroll);
    $rootSmartPlayerElement.on(events.Media.SeekToTime, onSeekToTime);
    $rootSmartPlayerElement.on(events.Media.SetVolume, onSetVolume);
    $rootSmartPlayerElement.on(events.Media.SetMutedState, onSetMuted);
    $rootSmartPlayerElement.on(events.Media.SetPlaybackRate, onSetPlaybackRate);
    $rootSmartPlayerElement.on(events.Media.InitializeCurrent, initCurrentMedia);
    $rootSmartPlayerElement.on(events.Media.TryToAutoPlay, onTryToAutoPlay);
    $rootSmartPlayerElement.on(events.Media.FirstPlay, onFirstPlay);
    $rootSmartPlayerElement.on(events.Media.Error, onMediaError);
    $rootSmartPlayerElement.on(events.Hotspots.AreaInactive, onHotspotInactive);
    mediaView.mediaElement.addEventListener(events.ExternalVideo.VideoLoadedMetadata, onVideoMetadataLoaded);
    mediaView.mediaElement.addEventListener(events.ExternalVideo.VideoSeeking, onVideoSeeking);
    mediaView.mediaElement.addEventListener(events.ExternalVideo.VideoSeeked, onVideoSeeked);
  };
  var destroy = function destroy() {
    teardownHideShowControls();
    mediaView.mediaElement.removeEventListener(events.ExternalVideo.VideoLoadedMetadata, onVideoMetadataLoaded);
    mediaView.mediaElement.removeEventListener(events.ExternalVideo.VideoSeeking, onVideoSeeking);
    mediaView.mediaElement.removeEventListener(events.ExternalVideo.VideoSeeked, onVideoSeeked);
    $rootSmartPlayerElement.off(events.Controls.DisplayCaptionControl, onDisplayCaptionControl);
    $rootSmartPlayerElement.off(events.Controls.DisplayTocControl, onDisplayTocControl);
    $rootSmartPlayerElement.off(events.Controls.TocScroll, onTocScroll);
    $rootSmartPlayerElement.off(events.Media.SeekToTime, onSeekToTime);
    $rootSmartPlayerElement.off(events.Media.SetVolume, onSetVolume);
    $rootSmartPlayerElement.off(events.Media.SetMutedState, onSetMuted);
    $rootSmartPlayerElement.off(events.Media.SetPlaybackRate, onSetPlaybackRate);
    $rootSmartPlayerElement.off(events.Controls.ShowToc, disableAutoHideControls);
    $rootSmartPlayerElement.off(events.Controls.HideToc, enableAutoHideControls);
    $rootSmartPlayerElement.off(events.Media.InitializeCurrent, initCurrentMedia);
    $rootSmartPlayerElement.off(events.Media.TryToAutoPlay, onTryToAutoPlay);
    $rootSmartPlayerElement.off(events.Media.FirstPlay, onFirstPlay);
    $rootSmartPlayerElement.off(events.Media.Error, onMediaError);
    $rootSmartPlayerElement.off(events.Hotspots.AreaInactive, onHotspotInactive);
    _beforeAfterPlayControlsView && _beforeAfterPlayControlsView.destroy();
    _progressBarControlView && _progressBarControlView.destroy();
    _playRewindControlsView && _playRewindControlsView.destroy();
    _prevNextControlsView && _prevNextControlsView.destroy();
    _volumeControlView && _volumeControlView.destroy();
    _audioDescriptionControlView && _audioDescriptionControlView.destroy();
    _captionsControlView && _captionsControlView.destroy();
    _tocControlView && _tocControlView.destroy();
    _playerSettingsView && _playerSettingsView.destroy();
    _pipControlView && _pipControlView.destroy();
    _theaterModeControlView && _theaterModeControlView.destroy();
    _fullScreenControlView && _fullScreenControlView.destroy();
    _clickControlsView && _clickControlsView.destroy();
  };
  setupControls();
  bindEvents();
  initControls();
  return Object.defineProperties({
    /**
     *  Sets the display mode for the video controls
     *  @memberof TSC.VideoControlsController
     *  @function setControlsDisplayMode
     *  @param displayMode - Mode the video controls should be displayed with
     */
    setDisplayMode: setControlsDisplayMode,
    /**
     *  Tear downs the instance of video controls controller
     *  @memberof TSC.VideoControlsController
     *  @function destroy
     */
    destroy: destroy
  }, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoControlsController
     *  @property {boolean} userNeedToClickHeroPlayControl - User needs to click hero play control to start playback
     */
    userNeedToClickHeroPlayControl: {
      get: function get() {
        return _userNeedToClickHeroPlayControl;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoControlsController
     *  @property {boolean} playbackInitialized - Playback has been initialized
     */
    playbackInitialized: {
      get: function get() {
        return _playbackInitialized;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoControlsController
     *  @property {TSC.ProgressBarControlView} progressBarControlView - progress bar view
     */
    progressBarControlView: {
      get: function get() {
        return _progressBarControlView;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoControlsController
     *  @property {TSC.FullscreenControlView} fullscreenControlView - full screen control view
     */
    fullscreenControlView: {
      get: function get() {
        return _fullScreenControlView;
      }
    },
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.VideoControlsController
     *  @property {TSC.BeforeAfterPlayControlsView} beforeAfterPlayControlsView - before after play controls view
     */
    beforeAfterPlayControlsView: {
      get: function get() {
        return _beforeAfterPlayControlsView;
      }
    }
  });
};
var VideoControlsController$1 = {
  /**
   *  Factory method that returns a new VideoControlsController object
   *  @function create
   *  @memberof TSC.VideoControlsController
   *  @param {jQuery} $rootSmartPlayerElement
   *  @param {MediaView} mediaView
   *  @param {TSC.XmpModel} xmpModel
   *  @param {TSC.Quiz} quizModel
   *  @param {TSC.playerConfiguration} playerConfiguration
   *  @static
   *  @return new VideoControlsController instance
   */
  create: VideoControlsController
};

var CAPTION_POSITION = {
  under: 'under'
};
var CAPTION_ALIGNMENT = {
  top: 'top',
  left: 'left',
  right: 'right'
};

/**
 * @memberof TSC
 * @class VideoControlsDisplayModeController
 * @classdesc Video controls controller - binds all the controls used for a video in Smart Player
 * @param {jQuery} $rootSmartPlayerElement - jQuery wrapper of Top level dom element for Smart Player
 * @param {TSC.VideoControlsController} videoControlsController - Video Controls Controller
 * @param {TSC.playerConfiguration} playerConfiguration -  Player configuration
 */
var VideoControlsDisplayModeController = function VideoControlsDisplayModeController($rootSmartPlayerElement, videoControlsController, playerConfiguration) {
  var _quizUIVisible = false;
  var _quizUIMinimized = false;
  var _pipViewActive = false;
  var _captionViewPosition = null;
  var _searchIsFocused = false;
  var _isScrubbing = false;
  var _externalLinkViewOpen = false;
  var _mediaError = false;
  var getDisplayMode = function getDisplayMode() {
    if (!videoControlsController.playbackInitialized && playerConfiguration.getPreload() !== preloadOptions.metadata) {
      return mediaInterfaceConstants.controls["false"];
    } else if (_mediaError) {
      return mediaInterfaceConstants.controls["false"];
    } else if (_externalLinkViewOpen) {
      return mediaInterfaceConstants.controls["false"];
    } else if (_pipViewActive) {
      return mediaInterfaceConstants.controls["false"];
    } else if (_quizUIVisible) {
      return _quizUIMinimized ? mediaInterfaceConstants.controls["false"] : mediaInterfaceConstants.controls["true"];
    } else if (videoControlsController.beforeAfterPlayControlsView.viewState !== playReplayControlStates.none || playerConfiguration.getDisableControls() || playerConfiguration.getDisableInteractions()) {
      return mediaInterfaceConstants.controls["false"];
    } else if (_isScrubbing || _searchIsFocused || !playerConfiguration.getAutoHideControls() || _captionViewPosition === CAPTION_POSITION.under) {
      return mediaInterfaceConstants.controls["true"];
    }
    return mediaInterfaceConstants.controls.autohide;
  };
  var updateVideoControlsDisplayMode = function updateVideoControlsDisplayMode() {
    videoControlsController.setDisplayMode(getDisplayMode());
  };
  var onDisplayCaptionControl = function onDisplayCaptionControl(e, eventData) {
    _captionViewPosition = eventData && eventData.captionViewPosition || null;
    updateVideoControlsDisplayMode();
  };
  var onPipChanged = function onPipChanged(e, eventData) {
    _pipViewActive = eventData.pipViewActive;
    updateVideoControlsDisplayMode();
  };
  var onQuizUIVisible = function onQuizUIVisible() {
    _quizUIVisible = true;
    updateVideoControlsDisplayMode();
  };
  var onQuizUIHidden = function onQuizUIHidden() {
    _quizUIVisible = false;
    updateVideoControlsDisplayMode();
  };
  var onMinimizeQuizUI = function onMinimizeQuizUI() {
    _quizUIMinimized = true;
    updateVideoControlsDisplayMode();
  };
  var onMaximizeQuizUI = function onMaximizeQuizUI() {
    _quizUIMinimized = false;
    updateVideoControlsDisplayMode();
  };
  var handleControlsUpdated = function handleControlsUpdated() {
    videoControlsController.setDisplayMode(getDisplayMode());
  };
  var onSearchFocusChange = function onSearchFocusChange(e, eventData) {
    _searchIsFocused = eventData.searchIsFocused;
    updateVideoControlsDisplayMode();
  };
  var onScrubbingStarted = function onScrubbingStarted() {
    _isScrubbing = true;
    updateVideoControlsDisplayMode();
  };
  var onScrubbingEnded = function onScrubbingEnded() {
    _isScrubbing = false;
    updateVideoControlsDisplayMode();
  };
  var onExternalLinkViewOpen = function onExternalLinkViewOpen() {
    _externalLinkViewOpen = true;
    updateVideoControlsDisplayMode();
  };
  var onExternalLinkViewClosed = function onExternalLinkViewClosed() {
    _externalLinkViewOpen = false;
    updateVideoControlsDisplayMode();
  };
  var onMediaError = function onMediaError() {
    _mediaError = true;
    updateVideoControlsDisplayMode();
  };
  var bindEvents = function bindEvents() {
    $rootSmartPlayerElement.on(events.Controls.StartedPlayback, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.on(events.Controls.HeroPlayControlVisible, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.on(events.Controls.HeroPlayControlHidden, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.on(events.Controls.ReplayControlVisible, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.on(events.Controls.ReplayControlHidden, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.on(events.Controls.DisplayCaptionControl, onDisplayCaptionControl);
    $rootSmartPlayerElement.on(events.Controls.PipChanged, onPipChanged);
    $rootSmartPlayerElement.on(events.Quizzing.UIVisible, onQuizUIVisible);
    $rootSmartPlayerElement.on(events.Quizzing.UIHidden, onQuizUIHidden);
    $rootSmartPlayerElement.on(events.Quizzing.MinimizeUI, onMinimizeQuizUI);
    $rootSmartPlayerElement.on(events.Quizzing.MaximizeUI, onMaximizeQuizUI);
    $rootSmartPlayerElement.on(events.Controls.Updated, handleControlsUpdated);
    $rootSmartPlayerElement.on(events.Controls.SearchFocusChange, onSearchFocusChange);
    $rootSmartPlayerElement.on(events.Scrubbing.Started, onScrubbingStarted);
    $rootSmartPlayerElement.on(events.Scrubbing.Ended, onScrubbingEnded);
    $rootSmartPlayerElement.on(events.ExternalLinkView.Open, onExternalLinkViewOpen);
    $rootSmartPlayerElement.on(events.ExternalLinkView.Closed, onExternalLinkViewClosed);
    $rootSmartPlayerElement.on(events.Media.Error, onMediaError);
  };
  var destroy = function destroy() {
    $rootSmartPlayerElement.off(events.Controls.StartedPlayback, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.off(events.Controls.HeroPlayControlVisible, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.off(events.Controls.HeroPlayControlHidden, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.off(events.Controls.ReplayControlVisible, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.off(events.Controls.ReplayControlHidden, updateVideoControlsDisplayMode);
    $rootSmartPlayerElement.off(events.Controls.DisplayCaptionControl, onDisplayCaptionControl);
    $rootSmartPlayerElement.off(events.Controls.PipChanged, onPipChanged);
    $rootSmartPlayerElement.off(events.Quizzing.UIVisible, onQuizUIVisible);
    $rootSmartPlayerElement.off(events.Quizzing.UIHidden, onQuizUIHidden);
    $rootSmartPlayerElement.off(events.Quizzing.MinimizeUI, onMinimizeQuizUI);
    $rootSmartPlayerElement.off(events.Quizzing.MaximizeUI, onMaximizeQuizUI);
    $rootSmartPlayerElement.off(events.Controls.Updated, handleControlsUpdated);
    $rootSmartPlayerElement.off(events.Controls.SearchFocusChange, onSearchFocusChange);
    $rootSmartPlayerElement.off(events.Scrubbing.Started, onScrubbingStarted);
    $rootSmartPlayerElement.off(events.Scrubbing.Ended, onScrubbingEnded);
    $rootSmartPlayerElement.off(events.ExternalLinkView.Open, onExternalLinkViewOpen);
    $rootSmartPlayerElement.off(events.ExternalLinkView.Closed, onExternalLinkViewClosed);
    $rootSmartPlayerElement.off(events.Media.Error, onMediaError);
  };
  bindEvents();
  updateVideoControlsDisplayMode();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var VideoControlsDisplayModeController$1 = {
  /**
   *  Factory method that returns a new VideoControlsDisplayModeController object
   *  @function create
   *  @memberof TSC.VideoControlsDisplayModeController
   *  @param {jQuery} $rootSmartPlayerElement - jQuery wrapper of Top level dom element for Smart Player
   *  @param {TSC.VideoControlsController} videoControlsController - Video Controls Controller
   *  @param {TSC.playerConfiguration} playerConfiguration -  Player configuration
   *  @static
   *  @return new VideoControlsDisplayModeController instance
   */
  create: VideoControlsDisplayModeController
};

var hotspotViewState = Object.freeze({
  hidden: 'hidden',
  firstVisible: 'firstVisible',
  visible: 'visible'
});

// time buffer value used to check if a media time is at the end of the hotspot
var endingTimeBufferSizeInMilliseconds = 1000;
var createHotspotDescription = function createHotspotDescription(hotspotXmpModel) {
  var hotspotText = localizationStrings.getPlayerString(playerStringNames.txtHotspot);
  var jumpMediaText = localizationStrings.getPlayerString(playerStringNames.txtJumpToMedia);
  var jumpTimeText = localizationStrings.getPlayerString(playerStringNames.txtJumpToTime);
  var openLinkText = localizationStrings.getPlayerString(playerStringNames.txtOpenLink);
  var playText = localizationStrings.getPlayerString(playerStringNames.accessBtnPlay);
  if (hotspotXmpModel.jumpFile !== undefined) {
    return hotspotText + ': ' + jumpMediaText + ': ' + hotspotXmpModel.jumpFile;
  } else if (hotspotXmpModel.jumpTime !== undefined && hotspotXmpModel.jumpTime !== '') {
    return hotspotText + ': ' + jumpTimeText + ': ' + timeFormatter.formatTimeForReadability(Number(hotspotXmpModel.jumpTime) / 1000);
  } else if (hotspotXmpModel.location !== undefined && hotspotXmpModel.location !== '') {
    return hotspotText + ': ' + openLinkText + ': ' + hotspotXmpModel.location;
  }
  return hotspotText + ': ' + playText;
};
var getHotspotViewPoints = function getHotspotViewPoints(hotspotXmpModel, videoNativeWidth, videoNativeHeight) {
  var viewPoints = [];
  hotspotXmpModel.boundingPoly.coordinates.forEach(function (coordinate) {
    var hsViewData = {
      xOrig: Math.round(coordinate.x),
      yOrig: Math.round(coordinate.y),
      xScale: Math.round(coordinate.x) / videoNativeWidth,
      yScale: Math.round(coordinate.y) / videoNativeHeight
    };
    viewPoints.push(hsViewData);
  });
  return viewPoints;
};

/**
 * @memberof TSC
 * @class HotspotViewModel
 * @classdesc HotSpot View Model
 * @param {Object} hotspotXmpModel - Hotspot XMP model
 * @param {Number} index - index of hotspot within all hotspots
 * @param {Number} videoNativeWidth - original width of video
 * @param {Number} videoNativeHeight - original height of video
 */
var HotspotViewModel = function HotspotViewModel(hotspotXmpModel, index, videoNativeWidth, videoNativeHeight) {
  var _hotspotXmpModel = hotspotXmpModel;
  var _hotspotIndex = index;
  var _isActive = false;
  var _hasPausedAtEnd = false;
  var _viewPoints = getHotspotViewPoints(hotspotXmpModel, videoNativeWidth, videoNativeHeight);
  var _description = createHotspotDescription(hotspotXmpModel);
  var getCoordinates = function getCoordinates(hotspotViewWidth, hotspotViewHeight) {
    var coordinates = [];
    _viewPoints.forEach(function (viewPoint) {
      coordinates.push(viewPoint.xOrig >= 0 ? Math.round(viewPoint.xScale * hotspotViewWidth) : 0);
      coordinates.push(viewPoint.yOrig >= 0 ? Math.round(viewPoint.yScale * hotspotViewHeight) : 0);
    });
    return coordinates.join(',');
  };
  var isWithinTime = function isWithinTime(timeInMilliseconds) {
    return _hotspotXmpModel.startTime < timeInMilliseconds && timeInMilliseconds <= _hotspotXmpModel.endTime;
  };
  var isTimeNearEndOfHotspot = function isTimeNearEndOfHotspot(timeInMilliseconds) {
    return getTimeLeftUntilEnd(timeInMilliseconds) <= endingTimeBufferSizeInMilliseconds;
  };
  var shouldPauseAtTheEnd = function shouldPauseAtTheEnd(timeInMilliseconds) {
    return _hotspotXmpModel.pause === true && !_hasPausedAtEnd && isTimeNearEndOfHotspot(timeInMilliseconds);
  };
  var getTimeLeftUntilEnd = function getTimeLeftUntilEnd(timeInMilliseconds) {
    return _hotspotXmpModel.endTime - timeInMilliseconds;
  };
  return Object.defineProperties({
    getCoordinates: getCoordinates,
    isHotspotWithinTime: isWithinTime,
    isTimeNearEndOfHotspot: isTimeNearEndOfHotspot,
    shouldPauseAtTheEnd: shouldPauseAtTheEnd,
    getTimeLeftUntilEnd: getTimeLeftUntilEnd
  }, {
    index: {
      get: function get() {
        return _hotspotIndex;
      }
    },
    description: {
      get: function get() {
        return _description;
      }
    },
    isActive: {
      get: function get() {
        return _isActive;
      },
      set: function set(isActive) {
        _isActive = isActive;
      }
    },
    hasPausedAtEnd: {
      get: function get() {
        return _hasPausedAtEnd;
      },
      set: function set(hasPausedAtEnd) {
        _hasPausedAtEnd = hasPausedAtEnd;
      }
    },
    xmpModel: {
      get: function get() {
        return _hotspotXmpModel;
      }
    }
  });
};
var HotspotViewModel$1 = {
  /**
   *  Factory method that returns a new HotspotViewModel object.
   *  @function create
   *  @memberof TSC.HotspotViewModel
   *  @static
   *  @param {Object} hotspotXmpModel - Hotspot XMP model
   *  @param {Number} index - index of hotspot within all hotspots
   *  @param {Number} videoNativeWidth - original width of video
   *  @param {Number} videoNativeHeight - original height of video
   *  @return new HotspotViewModel instance
   */
  create: HotspotViewModel
};

/**
 * @memberof TSC
 * @class HotspotView
 * @classdesc Hotspot View
 * @param {Object} spContainer
 * @param {HTMLVideoElement} mediaElement
 * @param {jquery} $hotspotsContainerElement
 * @param {TSC.HotspotViewModel} hotspotViewModel
 * @param {Number} hotspotContainerWidth
 * @param {Number} hotspotContainerHeight
 */
var HotspotView = function HotspotView(spContainer, mediaElement, $hotspotsContainerElement, hotspotViewModel, hotspotContainerWidth, hotspotContainerHeight) {
  var _$hotspotSvgElement;
  var _$hotspotLinkElement;
  var _timerId;
  var enableTabbing = function enableTabbing() {
    _$hotspotLinkElement.attr('tabindex', tabIndex.DomOrder);
    _$hotspotLinkElement.attr('focusable', true);
  };
  var disableTabbing = function disableTabbing() {
    _$hotspotLinkElement.attr('tabindex', tabIndex.Disabled);
    _$hotspotLinkElement.attr('focusable', false);
  };
  var onQuizEventHandler = function onQuizEventHandler(e) {
    switch (e.type) {
      case events.Quizzing.Complete:
      case events.Quizzing.Review:
        enableTabbing();
        break;
      case events.Quizzing.Paused:
        disableTabbing();
        break;
    }
  };
  var onControlsUpdatedHandler = function onControlsUpdatedHandler() {
    if (playerConfiguration.disableInteractions) {
      hideHotspot();
    } else if (hotspotViewModel.isHotspotWithinTime(getCurrentTimeInMilliseconds())) {
      displayHotspot();
    }
  };
  var getCurrentTimeInMilliseconds = function getCurrentTimeInMilliseconds() {
    return mediaElement.currentTime > mediaElement.duration ? mediaElement.duration : mediaElement.currentTime * 1000;
  };
  var getSvgElementWithLowerIndex = function getSvgElementWithLowerIndex(hotspotIndex) {
    var $svgElementWithLowerIndex = null;
    var svgElements = $hotspotsContainerElement.find('svg');
    svgElements.each(function (index, element) {
      var $svg = $(element);
      if (hotspotIndex > Number($svg.attr('data-hotspot-index'))) {
        $svgElementWithLowerIndex = $svg;
      }
    });
    return $svgElementWithLowerIndex;
  };
  var addHotspotViewToDom = function addHotspotViewToDom($svgView) {
    var $svgElementWithLowerIndex = getSvgElementWithLowerIndex(hotspotViewModel.index);
    if ($svgElementWithLowerIndex !== null) {
      $svgElementWithLowerIndex.after($svgView);
    } else {
      $hotspotsContainerElement.prepend($svgView);
    }
    _$hotspotSvgElement = $hotspotsContainerElement.find('svg[data-hotspot-index="' + hotspotViewModel.index + '"]');
    _$hotspotLinkElement = _$hotspotSvgElement.find('a');
  };
  var createView = function createView() {
    var hotspotCoordinates = hotspotViewModel.getCoordinates(hotspotContainerWidth, hotspotContainerHeight);
    var hotspotCoordinatesSeparationBySpace = hotspotCoordinates.replace(/,/g, ' ');
    var descriptionId = 'hotspot-description-' + hotspotViewModel.index;
    var hotspotLinkClassName = 'hotspot-link-' + hotspotViewModel.index;
    var svgViewMarkup = templateGenerator.generateHotspotMarkup(hotspotContainerWidth, hotspotContainerHeight, hotspotViewModel.index, descriptionId, hotspotViewModel.description, playerConfiguration.displayHotspotsShape, hotspotCoordinatesSeparationBySpace, hotspotLinkClassName);
    var $svgView = $(svgViewMarkup);
    addHotspotViewToDom($svgView);
  };
  var bindEvents = function bindEvents() {
    spContainer.on(events.Quizzing.Complete, onQuizEventHandler);
    spContainer.on(events.Quizzing.Review, onQuizEventHandler);
    spContainer.on(events.Quizzing.Paused, onQuizEventHandler);
    spContainer.on(events.Controls.Updated, onControlsUpdatedHandler);
  };
  var displayHotspot = function displayHotspot() {
    if (playerConfiguration.disableInteractions) {
      return;
    }
    _$hotspotSvgElement.addClass(cssClasses.hotspotVisible);
    enableTabbing();
  };
  var hideHotspot = function hideHotspot() {
    _$hotspotSvgElement.removeClass(cssClasses.hotspotVisible);
    disableTabbing();
  };
  var getTimeToHotspotEnd = function getTimeToHotspotEnd(timeInMilliseconds, mediaPlaybackRate) {
    var frameBuffer = 10 / (mediaPlaybackRate * 30) * 1000;
    return hotspotViewModel.getTimeLeftUntilEnd(timeInMilliseconds) / mediaPlaybackRate - frameBuffer;
  };
  var pauseOnHotspot = function pauseOnHotspot() {
    _timerId = null;
    hotspotViewModel.hasPausedAtEnd = true;
    mediaElement.pause();
    var eventData = {
      hasTimeChangeAction: !hotspotViewModel.xmpModel.location
    };
    spContainer.trigger(events.Hotspots.Paused, eventData);
  };
  var initPauseOnHotspot = function initPauseOnHotspot(timeInMilliseconds) {
    window.clearTimeout(_timerId);
    if (window.document.hidden) {
      //Can't use setTimeout if document is hidden
      pauseOnHotspot();
    } else {
      _timerId = setTimeout(pauseOnHotspot, getTimeToHotspotEnd(timeInMilliseconds, mediaElement.playbackRate));
    }
  };
  var update = function update(timeInMilliseconds) {
    var hotspotState = hotspotViewState.hidden;
    if (hotspotViewModel.isHotspotWithinTime(timeInMilliseconds)) {
      if (!hotspotViewModel.isActive) {
        hotspotState = hotspotViewState.firstVisible;
        hotspotViewModel.isActive = true;
        displayHotspot();
      } else {
        hotspotState = hotspotViewState.visible;
      }
      if (hotspotViewModel.shouldPauseAtTheEnd(timeInMilliseconds) && !mediaElement.paused) {
        initPauseOnHotspot(timeInMilliseconds);
      }
    } else if (hotspotViewModel.isActive) {
      hotspotViewModel.isActive = false;
      hideHotspot();
      if (!_timerId && !mediaElement.paused) {
        resetHasPaused();
      }
    }
    return hotspotState;
  };
  var resetHasPaused = function resetHasPaused() {
    hotspotViewModel.hasPausedAtEnd = false;
  };
  createView();
  bindEvents();
  hideHotspot();
  return Object.defineProperties({
    update: update,
    resetHasPaused: resetHasPaused
  }, {
    hotspotViewModel: {
      get: function get() {
        return hotspotViewModel;
      }
    },
    controlElement: {
      get: function get() {
        return _$hotspotLinkElement;
      }
    }
  });
};
var HotspotView$1 = {
  create: HotspotView
};

/**
 *  @memberof TSC
 *  @class HotspotsView
 *  @classdesc Hotspots View
 *  @param {Object} spContainer - jQuery element that is the smartplayer top-level container
 *  @param {TSC.Xmp} xmp - XMP model
 *  @param {HTMLVideoElement} mediaElement - html5 media DOM element (or wrapper presenting same interface)
 *  @param {TSC.TabController} tabController - Tab controller instance
 */
var HotspotsView = function HotspotsView(spContainer, xmp, mediaElement, tabController) {
  var _xmp = xmp;
  var _eventContainer = spContainer;
  var _spContainerId = spContainer.attr('id');
  var _hotspotsContainerId = [_spContainerId, 'hotspots'].join('-');
  var _hotspotXmpModels = [];
  var _hotspotViews = [];
  var _$hotspots;
  var _mediaNativeWidth = null;
  var _mediaNativeHeight = null;
  var _oneOrMoreHotspotActive = false;
  var _currentFile;
  var createView = function createView() {
    var hotspotsMarkup = templateGenerator.generateHotspotsMarkup(_hotspotsContainerId);
    _$hotspots = $($.parseHTML(hotspotsMarkup));
  };
  var preventEvent = function preventEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  var bindEvents = function bindEvents() {
    _$hotspots.on('click', 'svg', onHotspotClick);
    _$hotspots.on('mousedown', preventEvent);
    _$hotspots.on('touchend', 'svg', onHotspotClick);
    _$hotspots.on('keydown', 'svg', function (e) {
      if (keys.isKeyOfType(e.key, keys.keyTypes.space)) {
        onHotspotClick(e);
      }
    });
  };
  var init = function init(videoNativeWidth, videoNativeHeight, currentFile) {
    _currentFile = currentFile;
    _mediaNativeWidth = videoNativeWidth;
    _mediaNativeHeight = videoNativeHeight;
    _oneOrMoreHotspotActive = false;

    // remove all current hotspots in the case we are loading consecutive video in a playlist
    _$hotspots.empty();
    _hotspotViews = [];
    _hotspotXmpModels = [];
    _xmp.hotspotItemArray.filter(function (hotspotXmpModel) {
      // only init hotspots for this video
      var isHotspotForADifferentFile = hotspotXmpModel.file !== undefined && hotspotXmpModel.file !== _currentFile;
      return !isHotspotForADifferentFile;
    }).forEach(function (hotspotXmpModel, index) {
      var hotspotViewModel = HotspotViewModel$1.create(hotspotXmpModel, index, _mediaNativeWidth, _mediaNativeHeight);
      var hotspotView = HotspotView$1.create(spContainer, mediaElement, _$hotspots, hotspotViewModel, _mediaNativeWidth, _mediaNativeHeight);
      _hotspotViews.push(hotspotView);
      _hotspotXmpModels.push(hotspotXmpModel);
    });
  };
  var removeScreenReaderAlert = function removeScreenReaderAlert() {
    _$hotspots.find('.' + cssClasses.screenReaderAlert).remove();
  };
  var addScreenReaderAlert = function addScreenReaderAlert(numberHotspotsJustDisplayed) {
    var hotspotAlertStringToken = '{{numberOfHotspots}}';
    var hotspotAlertText = localizationStrings.getPlayerString(playerStringNames.txtHotspotScreenReaderAlert);
    if (numberHotspotsJustDisplayed > 1) {
      hotspotAlertText = localizationStrings.getPlayerString(playerStringNames.txtHotspotScreenReaderAlertPlural);
    }
    hotspotAlertText = hotspotAlertText.replace(hotspotAlertStringToken, numberHotspotsJustDisplayed);
    var screenReaderAlertMarkup = templateGenerator.generateScreenReaderAlertMarkup(hotspotAlertText);
    var $screenReaderAlert = $(screenReaderAlertMarkup);
    _$hotspots.append($screenReaderAlert);
  };
  var getLastActiveHotspotView = function getLastActiveHotspotView() {
    for (var i = _hotspotViews.length - 1; i >= 0; i--) {
      if (_hotspotViews[i].hotspotViewModel.isActive) {
        return _hotspotViews[i];
      }
    }
    return null;
  };
  var onHotspotActiveChange = function onHotspotActiveChange(oneOrMoreHotspotActive, numberHotspotsJustDisplayed) {
    spContainer.playerState.oneOrMoreHotspotsWithTimeActionArePaused = isHotspotWithTimeActionPaused();
    if (_oneOrMoreHotspotActive !== oneOrMoreHotspotActive) {
      _oneOrMoreHotspotActive = oneOrMoreHotspotActive;
      var eventName = _oneOrMoreHotspotActive ? events.Hotspots.AreaActive : events.Hotspots.AreaInactive;
      _eventContainer.trigger(eventName);
    }
    if (_oneOrMoreHotspotActive) {
      var lastActiveHotspotView = getLastActiveHotspotView();
      if (lastActiveHotspotView) {
        tabController.lastTabEnabledElement = lastActiveHotspotView.controlElement;
      }
      if (numberHotspotsJustDisplayed > 0) {
        addScreenReaderAlert(numberHotspotsJustDisplayed);
      }
    } else {
      tabController.lastTabEnabledElement = null;
      removeScreenReaderAlert();
    }
  };
  var update = function update(currentMediaTimeInMilliseconds) {
    var oneOrMoreHotspotActive = false;
    var numberHotspotsJustDisplayed = 0;
    _hotspotViews.forEach(function (hotspotView) {
      var hotspotState = hotspotView.update(currentMediaTimeInMilliseconds);
      if (hotspotState === hotspotViewState.firstVisible) {
        numberHotspotsJustDisplayed++;
      }
      if (hotspotState === hotspotViewState.firstVisible || hotspotState === hotspotViewState.visible) {
        oneOrMoreHotspotActive = true;
      }
    });
    onHotspotActiveChange(oneOrMoreHotspotActive, numberHotspotsJustDisplayed);
  };
  var onHotspotClick = function onHotspotClick(event) {
    event.preventDefault();
    event.stopPropagation();
    var hotspotIndex = Number($(event.target).attr('data-hotspot-index'));
    var targetHotspotXmpModel = _hotspotXmpModels[hotspotIndex];
    var targetHotspotViewModel = _hotspotViews[hotspotIndex].hotspotViewModel;
    var eventData = {
      jumpFile: targetHotspotXmpModel.jumpFile,
      jumpTime: targetHotspotXmpModel.jumpTime,
      location: targetHotspotXmpModel.location,
      newWindow: targetHotspotXmpModel.newWindow
    };
    if (!eventData.location && targetHotspotViewModel.hasPausedAtEnd) {
      _eventContainer.trigger(events.Hotspots.Resume);
    }
    _eventContainer.trigger(events.Controls.HotspotClicked, eventData);
  };
  var resetHasPaused = function resetHasPaused() {
    _hotspotViews.forEach(function (hotspotView) {
      hotspotView.resetHasPaused();
    });
  };
  var isHotspotWithTimeActionPaused = function isHotspotWithTimeActionPaused() {
    for (var i = 0; i < _hotspotViews.length; i++) {
      if (_hotspotViews[i].hotspotViewModel.hasPausedAtEnd && !_hotspotViews[i].hotspotViewModel.xmpModel.location) {
        return true;
      }
    }
    return false;
  };
  createView();
  bindEvents();
  return Object.defineProperties({
    init: init,
    update: update,
    resetHasPaused: resetHasPaused
  }, {
    $hotspots: {
      get: function get() {
        return _$hotspots;
      }
    },
    oneOrMoreHotspotActive: {
      get: function get() {
        return _oneOrMoreHotspotActive;
      }
    },
    oneOrMoreHotspotsWithTimeActionArePaused: {
      get: isHotspotWithTimeActionPaused
    }
  });
};
var HotspotsView$1 = {
  create: HotspotsView
};

/**
 * @memberof TSC
 * @class HotspotController
 * @classdesc Controller for managing XMP features
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.XmpModel} xmpModel
 * @param {TSC.MediaList} mediaList
 * @param {TSC.TabController} tabController
 *
 */
var HotspotController = function HotspotController($container, mediaView, xmpModel, mediaList, tabController) {
  var _hotspotsView;
  var _$hotspotsContainer = $container.find('.hotspots-container');
  var setupXmpFeatures = function setupXmpFeatures() {
    _hotspotsView = HotspotsView$1.create($container, xmpModel, mediaView.mediaElement, tabController);
    _$hotspotsContainer.replaceWith(_hotspotsView.$hotspots);
  };
  var onLoadedMetadata = function onLoadedMetadata() {
    var currentFile = mediaList.isPlaylist ? mediaList.currentMedia.media : undefined;
    _hotspotsView.init(mediaView.mediaWidth, mediaView.mediaHeight, currentFile);
  };
  var onVideoTimeUpdate = function onVideoTimeUpdate() {
    _hotspotsView.update(mediaView.currentTimeInMilliseconds);
  };
  var updateHotSpotsViewTime = function updateHotSpotsViewTime() {
    _hotspotsView.update(mediaView.currentTimeInMilliseconds);
  };
  var processHotspotClick = function processHotspotClick(e, eventData) {
    if (eventData.jumpFile !== undefined) {
      mediaList.currentMediaIndex = mediaList.getMediaIndexByUri(eventData.jumpFile);
      $container.trigger(events.Media.SourceChanged);
    } else if (eventData.jumpTime !== undefined && eventData.jumpTime !== '') {
      var timeInSeconds = Number(eventData.jumpTime) / 1000;
      $container.trigger(events.Media.SeekToTime, {
        time: videoApiUtils.getSafeSeekTime(mediaView.mediaElement, timeInSeconds),
        playAfterSeek: true
      });
    } else if (eventData.location !== undefined && eventData.location !== '') {
      if (playerConfiguration.getTrackEvents()) {
        analyticsService.sendEvent(events.Analytics.HotspotAction, eventData.location);
        analyticsService.sendGA4Event(events.GA4.HotspotAction, {
          opened_url: eventData.location
        }); // eslint-disable-line
      }
      var targetWindow = '_parent';
      if (eventData.newWindow !== undefined && eventData.newWindow === true) {
        targetWindow = '_blank';
      }
      mediaView.mediaElement.pause();
      urlService.openUrl(eventData.location, targetWindow);
    } else {
      mediaView.mediaElement.play();
    }
  };
  var onSeeked = function onSeeked() {
    _hotspotsView.resetHasPaused();
    _hotspotsView.update(mediaView.currentTimeInMilliseconds);
  };
  var bindToEvents = function bindToEvents() {
    $container.on(events.Controls.HotspotClicked, processHotspotClick);
    mediaView.mediaWrapper.on('ratechange', updateHotSpotsViewTime, false);
    mediaView.mediaWrapper.on('play', updateHotSpotsViewTime, false);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      timeupdate: onVideoTimeUpdate,
      seeked: onSeeked
    };
    mediaView.mediaWrapper.on(eventsToBind);
  };
  var unbindToEvents = function unbindToEvents() {
    $container.off(events.Controls.HotspotClicked, processHotspotClick);
    mediaView.mediaWrapper.off('ratechange', updateHotSpotsViewTime, false);
    mediaView.mediaWrapper.off('play', updateHotSpotsViewTime, false);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      timeupdate: onVideoTimeUpdate,
      seeked: onSeeked
    };
    mediaView.mediaWrapper.off(eventsToBind);
  };
  var destroy = function destroy() {
    unbindToEvents();
  };
  var hasHotspots = xmpModel && xmpModel.hasHotspotItems;
  if (!hasHotspots) {
    throw new Error('Attempted to create hotspot controller with no hotspots in xmp');
  }
  setupXmpFeatures();
  bindToEvents();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var HotspotController$1 = {
  /**
   *  Factory method that returns a new HotspotController.
   *  @function create
   *  @memberof TSC.HotspotController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.XmpModel} xmpModel
   *  @param {TSC.MediaList} mediaList
   *  @param {TSC.TabController} tabController
   *  @return new HotspotController instance
   */
  create: HotspotController
};

var CAPTION_VIDEO_WIDTH_PERCENTAGE$1 = .75;
var LINE_HEIGHT_PADDING_UNDER_VIDEO$1 = 24;
var MAX_DISPLAYED_LINES$1 = 3;
var _scaledFontSize$1 = 16;
var _currentCaptionWidth$1 = 0;
var setStyle$1 = function setStyle(captionsService, $positionContainer, $textContainer) {
  $textContainer.css({
    'font-family': captionsService.fontEnclosedWithQuotes,
    color: captionsService.textColor.toString()
  });
  $textContainer.find('span').css({
    background: captionsService.backgroundColor.toString()
  });
  $textContainer.addClass(cssClasses.captionXmpView);
  if (captionsService.position === CAPTION_POSITION.under) {
    // toHexString masks the alpha component so we get a non-transparent full bg
    $positionContainer.css('background', captionsService.backgroundColor.toHexString());
    $positionContainer.addClass(cssClasses.captionsUnderVideo);
    $positionContainer.removeClass(cssClasses.hide);
  }
};
var setWidth$1 = function setWidth(scaledVideoWidth, $textContainer, captionPositionUnderVideo) {
  if (captionPositionUnderVideo) {
    $textContainer.css('width', "".concat(scaledVideoWidth, "px"));
  } else {
    _currentCaptionWidth$1 = Math.ceil(scaledVideoWidth * CAPTION_VIDEO_WIDTH_PERCENTAGE$1);
    $textContainer.css('width', _currentCaptionWidth$1 + 'px');
  }
};
var setScale$1 = function setScale(captionsService, canvasScale, $positionContainer) {
  var fontSize = Math.round(captionsService.fontSize * canvasScale);
  fontSize = Math.min(Math.max(captionsService.fontSizeMin, fontSize), captionsService.fontSizeMax);
  _scaledFontSize$1 = fontSize;
  if (captionsService.position === CAPTION_POSITION.under) {
    var maxRequiredHeight = Math.ceil(_scaledFontSize$1 * MAX_DISPLAYED_LINES$1 + LINE_HEIGHT_PADDING_UNDER_VIDEO$1);
    $positionContainer.css('height', "".concat(maxRequiredHeight, "px"));
  }
  $positionContainer.css('font-size', "".concat(_scaledFontSize$1, "px"));
};
var setText$1 = function setText(caption, $textContainer) {
  $textContainer.html('<span>' + caption.markupText.replace('&para', '&amp;para') + '</span>');
};
var xmpCaptionView = Object.defineProperties({
  setStyle: setStyle$1,
  setWidth: setWidth$1,
  setScale: setScale$1,
  setText: setText$1
}, {
  scaledFontSize: {
    get: function get() {
      return _scaledFontSize$1;
    }
  },
  captionWidth: {
    get: function get() {
      return _currentCaptionWidth$1;
    }
  }
});

var CAPTION_VIDEO_WIDTH_PERCENTAGE = .7;
var LINE_HEIGHT_PADDING_UNDER_VIDEO = 24;
var MAX_DISPLAYED_LINES = 3;
var _scaledFontSize = 16;
var _currentCaptionWidth = 0;
var setStyle = function setStyle(captionsService, $positionContainer, $textContainer) {
  $textContainer.css({
    'font-family': CaptionService$1.defaults().captionFontFamily,
    color: CaptionService$1.defaults().captionTextColor
  });
  $textContainer.find('span').css({
    background: CaptionService$1.defaults().captionBgColor
  });
  $textContainer.addClass(cssClasses.captionAdaView);
  if (captionsService.position === CAPTION_POSITION.under) {
    // toHexString masks the alpha component so we get a non-transparent full bg
    $positionContainer.css('background', CaptionService$1.defaults().captionBgColor.toHexString());
    $positionContainer.addClass(cssClasses.captionsUnderVideo);
    $positionContainer.removeClass(cssClasses.hide);
  }
};
var setWidth = function setWidth(scaledVideoWidth, $textContainer, captionPositionUnderVideo) {
  if (captionPositionUnderVideo) {
    $textContainer.css('width', "".concat(scaledVideoWidth, "px"));
  } else {
    _currentCaptionWidth = Math.ceil(scaledVideoWidth * CAPTION_VIDEO_WIDTH_PERCENTAGE);
    $textContainer.css('width', _currentCaptionWidth + 'px');
  }
};
var setScale = function setScale(captionsService, canvasScale, $positionContainer) {
  _scaledFontSize = captionsService.fontSizeForPlayerDimensions;
  if (captionsService.position === CAPTION_POSITION.under) {
    var maxRequiredHeight = Math.ceil(_scaledFontSize * MAX_DISPLAYED_LINES + LINE_HEIGHT_PADDING_UNDER_VIDEO);
    $positionContainer.css('height', "".concat(maxRequiredHeight, "px"));
  }
  $positionContainer.css('font-size', "".concat(_scaledFontSize, "px"));
};
var setText = function setText(caption, $textContainer) {
  $textContainer.html('<span>' + caption.markupText + '</span>');
};
var adaCaptionView = Object.defineProperties({
  setStyle: setStyle,
  setWidth: setWidth,
  setScale: setScale,
  setText: setText
}, {
  scaledFontSize: {
    get: function get() {
      return _scaledFontSize;
    }
  },
  captionWidth: {
    get: function get() {
      return _currentCaptionWidth;
    }
  }
});

var getCaptionView = function getCaptionView() {
  if (playerConfiguration.showADACompliantCaptions) {
    return adaCaptionView;
  }
  return xmpCaptionView;
};
var captionViewFactory = {
  getCaptionView: getCaptionView
};

var MAX_TOP_CAPTION_PERCENTAGE = 95;
var PERCENTAGE_MULTIPLICATION_DENOMINATOR = 100;
var DRAG_END_EVENT_TRIGGER_DELAY = 100;

/**
 * @memberof TSC
 * @class CaptionsView
 * @classdesc Captions View
 *
 * @param {jQuery} $container - Root Smart Player dom element
 * @param {CaptionService} captionsService - Caption service instance
 * @param {TSC.VideoElementView} videoElementView - Video element view for MP4 video, this is null for YouTube video.
 * @param {boolean} canDragCaptions - Captions can be dragged to a new location by the user.
 */
var CaptionsView = function CaptionsView($container, captionsService, videoElementView, canDragCaptions) {
  var _window = windowWrapper.getWindow();
  var _$document = $(_window.document);
  var _$positionContainer = $container.find('.caption');
  var _$textContainer = $container.find('.caption > p');
  var _canvasScale = 1.0;
  // if position is 'under' captions start as visible and the user cannot hide, else it is from config option
  var _visible = captionsService.position === CAPTION_POSITION.under ? true : playerConfiguration.getCaptionsEnabled();
  var _currentCaptionIndex = -1;
  var _lastUpdateCurrentTime = 0;
  var _lastUpdateCurrentFile;
  var _draggingCaption = false;
  var _initDragClientPosition = {
    x: 0,
    y: 0
  };
  var _onStartDragCaptionContainerSize = {
    width: 0,
    height: 0
  };
  var _initCaptionTextPosition = {
    top: 0,
    left: 0
  };
  var _customCaptionPosition = {
    top: 0,
    left: 0
  };
  var onCaptionLanguageChanged = function onCaptionLanguageChanged() {
    _currentCaptionIndex = -1;
    updateCaption(_lastUpdateCurrentTime, _lastUpdateCurrentFile);
  };
  var onDragAnimationFrame = function onDragAnimationFrame() {
    _$textContainer.css({
      top: _customCaptionPosition.top + '%',
      left: _customCaptionPosition.left + '%'
    });
    if (_draggingCaption) {
      _window.requestAnimationFrame(onDragAnimationFrame);
    }
  };
  var getInteractionPointFromEvent = function getInteractionPointFromEvent(event) {
    if (event.targetTouches && event.targetTouches.length === 1) {
      return {
        x: event.targetTouches[0].pageX,
        y: event.targetTouches[0].pageY
      };
    }
    return {
      x: event.clientX,
      y: event.clientY
    };
  };
  var onCaptionDragEnd = function onCaptionDragEnd(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    _draggingCaption = false;
    _$textContainer.removeClass(cssClasses.captionsCaptionSelected);
    _$document.off('pointermove touchmove', onCaptionDrag);
    _$document.off('pointerup mouseup touchend mouseleave', onCaptionDragEnd);
    setTimeout(function () {
      $container.trigger(events.Captions.DragEnd);
    }, DRAG_END_EVENT_TRIGGER_DELAY);
  };
  var onCaptionDrag = function onCaptionDrag(e) {
    e.preventDefault();
    var point = getInteractionPointFromEvent(e.originalEvent);
    var dragXOffset = point.x - _initDragClientPosition.x;
    var dragYOffset = point.y - _initDragClientPosition.y;
    var offsetXPercent = dragXOffset / _onStartDragCaptionContainerSize.width * PERCENTAGE_MULTIPLICATION_DENOMINATOR;
    var offsetYPercent = dragYOffset / _onStartDragCaptionContainerSize.height * PERCENTAGE_MULTIPLICATION_DENOMINATOR;
    _customCaptionPosition.top = _initCaptionTextPosition.top + offsetYPercent;
    _customCaptionPosition.left = _initCaptionTextPosition.left + offsetXPercent;
    var maxWidthPercentOffset = captionViewFactory.getCaptionView().captionWidth / _onStartDragCaptionContainerSize.width * PERCENTAGE_MULTIPLICATION_DENOMINATOR;
    var maxWidthPercentage = PERCENTAGE_MULTIPLICATION_DENOMINATOR - maxWidthPercentOffset;
    _customCaptionPosition.top = _customCaptionPosition.top < 0 ? 0 : _customCaptionPosition.top;
    _customCaptionPosition.top = _customCaptionPosition.top > MAX_TOP_CAPTION_PERCENTAGE ? MAX_TOP_CAPTION_PERCENTAGE : _customCaptionPosition.top;
    _customCaptionPosition.left = _customCaptionPosition.left < 0 ? 0 : _customCaptionPosition.left;
    _customCaptionPosition.left = _customCaptionPosition.left > maxWidthPercentage ? maxWidthPercentage : _customCaptionPosition.left;
  };
  var onCaptionDragStart = function onCaptionDragStart(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $container.trigger(events.Captions.DragStart);
    _$textContainer.addClass(cssClasses.captionsCaptionSelected);
    _$positionContainer.addClass(cssClasses.captionsCustomPosition);
    var currentCaptionWidth = _$positionContainer.innerWidth();
    var currentCaptionHeight = _$positionContainer.innerHeight();
    var currentCaptionOffset = _$positionContainer.offset();
    var currentTextOffset = _$textContainer.offset();
    var point = getInteractionPointFromEvent(e.originalEvent);
    _initDragClientPosition.x = point.x;
    _initDragClientPosition.y = point.y;
    _onStartDragCaptionContainerSize.width = currentCaptionWidth;
    _onStartDragCaptionContainerSize.height = currentCaptionHeight;
    var topPercent = (currentTextOffset.top - currentCaptionOffset.top) / currentCaptionHeight * PERCENTAGE_MULTIPLICATION_DENOMINATOR;
    var leftPercent = (currentTextOffset.left - currentCaptionOffset.left) / currentCaptionWidth * PERCENTAGE_MULTIPLICATION_DENOMINATOR;
    _initCaptionTextPosition.top = topPercent;
    _initCaptionTextPosition.left = leftPercent;
    _customCaptionPosition.top = topPercent;
    _customCaptionPosition.left = leftPercent;
    _$document.on('pointermove touchmove', onCaptionDrag);
    // Safari needs mouseup, Safari reports wrong event.buttons code after user
    // right clicks on player.  This causes pepjs to report pointerup event as pointermove event
    _$document.on('pointerup mouseup touchend mouseleave', onCaptionDragEnd);
    _draggingCaption = true;
    onDragAnimationFrame();
  };
  var onCaptionsToggle = function onCaptionsToggle(e, eventData) {
    e.preventDefault();
    setVisible(eventData.captionsEnabled);
    handleDisplayCaptions();
  };
  var resizeCaptionsContainer = function resizeCaptionsContainer() {
    // it's possible we can tie this function into sequential logic for internal sizeChange management, but this was moved to this file at
    // end of large refactor work where it was known to work when triggered off the Captions.Resized logic as it is done here.  so, that  event-driven
    // trigger was just left in place for now
    if (captionsService.position === CAPTION_POSITION.under) {
      $container[0].style.setProperty(cssVariables.reservedSizeCaptions, "".concat(Math.round(_$positionContainer.height()), "px"));
    }
  };
  var setupDomStructure = function setupDomStructure() {
    if (captionsService.position === CAPTION_POSITION.under) {
      var mediaWrapper = $container.find('.media-wrapper').first();
      _$positionContainer.insertAfter(mediaWrapper);
    }
  };
  var setupEvents = function setupEvents() {
    $container.on(events.Captions.Toggled, onCaptionsToggle);
    $container.on(events.Captions.LanguageChanged, onCaptionLanguageChanged);
    $container.on(events.Captions.Resized, resizeCaptionsContainer);
    if (canDragCaptions && captionsService.position !== CAPTION_POSITION.under) {
      _$textContainer.on('mousedown touchstart', onCaptionDragStart);
    }
  };
  var destroy = function destroy() {
    $container.off(events.Captions.Toggled, onCaptionsToggle);
    $container.off(events.Captions.LanguageChanged, onCaptionLanguageChanged);
    $container.off(events.Captions.Resized, resizeCaptionsContainer);
    _$textContainer.off();
  };
  var removeCustomCaptionPosition = function removeCustomCaptionPosition() {
    _initDragClientPosition.x = _initDragClientPosition.y = 0;
    _onStartDragCaptionContainerSize.width = _onStartDragCaptionContainerSize.height = 0;
    _initCaptionTextPosition.top = _initCaptionTextPosition.left = 0;
    _customCaptionPosition.top = _customCaptionPosition.left = 0;
    _$positionContainer.removeClass(cssClasses.captionsCustomPosition);
    _$textContainer.css({
      top: '',
      left: ''
    });
  };
  var setVisible = function setVisible(value) {
    if (value === true && captionsService.hasCaptions) {
      updateView();
      removeCustomCaptionPosition();
      _$positionContainer.removeClass(cssClasses.hide);
    } else {
      _$positionContainer.addClass(cssClasses.hide);
    }
    _visible = value;
  };
  var getVerticalAlignmentClass = function getVerticalAlignmentClass(verticalAlignment) {
    return verticalAlignment === CAPTION_ALIGNMENT.top ? cssClasses.captionsVerticalAlignTop : cssClasses.captionsVerticalAlignBottom;
  };
  var getHorizontalAlignmentClass = function getHorizontalAlignmentClass(horizontalAlignment) {
    switch (horizontalAlignment) {
      case CAPTION_ALIGNMENT.left:
        return cssClasses.captionsHorizontalAlignLeft;
      case CAPTION_ALIGNMENT.right:
        return cssClasses.captionsHorizontalAlignRight;
      default:
        return cssClasses.captionsHorizontalAlignCenter;
    }
  };
  var handleDisplayCaptions = function handleDisplayCaptions(captionStylesHaveChanged) {
    if (captionsService.hasCaptions) {
      if (captionStylesHaveChanged === true) {
        updateView();
      }
      // deal with setting up captions 'under' video, causes us to restructure DOM elements a little =(
      if (captionsService.position === CAPTION_POSITION.under) {
        _$textContainer.off();
      }
    }
  };
  var updateView = function updateView() {
    _$textContainer.removeClass([cssClasses.captionXmpView, cssClasses.captionAdaView]);
    captionViewFactory.getCaptionView().setStyle(captionsService, _$positionContainer, _$textContainer);
  };
  var onSizeChange = function onSizeChange() {
    if (videoElementView === null) {
      return;
    }
    captionViewFactory.getCaptionView().setScale(captionsService, _canvasScale, _$positionContainer);
    captionViewFactory.getCaptionView().setWidth(videoElementView.mediaWidth * _canvasScale, _$textContainer, captionsService.position === CAPTION_POSITION.under);
    $container.trigger(events.Captions.Resized);
  };
  var updateCaption = function updateCaption(currentTime, currentFile, forceActiveCaptionUpdate) {
    if (!captionsService.hasCaptions) {
      _$textContainer.html('');
      return;
    }
    _lastUpdateCurrentTime = currentTime;
    _lastUpdateCurrentFile = currentFile;
    var newCaptionIndex = -1;
    $.each(captionsService.captionController.activeCaptionTrack.captionCollection.captions, function (i, caption) {
      // this check is for playlist config, single media player use doesn't match here
      if (caption.file !== undefined && caption.file !== currentFile) {
        return;
      }
      if (caption.startTime <= currentTime && currentTime <= caption.endTime) {
        newCaptionIndex = i;
      }
    });
    if (newCaptionIndex === -1) {
      _$textContainer.addClass(cssClasses.hide);
      _$textContainer.html('');
      _currentCaptionIndex = -1;
      return;
    }
    if (forceActiveCaptionUpdate || newCaptionIndex !== _currentCaptionIndex) {
      _currentCaptionIndex = newCaptionIndex;
      var newCaption = captionsService.captionController.activeCaptionTrack.captionCollection.captions[newCaptionIndex];
      if (!(newCaption && newCaption.markupText)) {
        _$textContainer.addClass(cssClasses.hide);
        _$textContainer.html('');
        return;
      }
      _$textContainer.removeClass(cssClasses.hide);
      _$positionContainer.removeClass(cssClasses.captionsHorizontalAlignLeft + ' ' + cssClasses.captionsHorizontalAlignCenter + ' ' + cssClasses.captionsHorizontalAlignRight);
      _$positionContainer.addClass(getHorizontalAlignmentClass(newCaption.horizontalAlignment));
      if (captionsService.position !== CAPTION_POSITION.under) {
        _$positionContainer.removeClass(cssClasses.captionsVerticalAlignTop + ' ' + cssClasses.captionsVerticalAlignBottom);
        _$positionContainer.addClass(getVerticalAlignmentClass(newCaption.verticalAlignment));
      }
      captionViewFactory.getCaptionView().setText(newCaption, _$textContainer);
      updateView();
      onSizeChange();
      $container.trigger(events.Captions.Changed, newCaption);
    }
  };
  var showVideoTrackCaptions = function showVideoTrackCaptions() {
    if (videoElementView === null) {
      return;
    }
    if (videoElementView.containsWebTrackCaptions) {
      _$positionContainer.addClass(cssClasses.hide);
      videoElementView.showCaptionTrack(captionsService.captionController.getActiveLanguageIdentifier());
    }
  };
  var hideVideoTrackCaptions = function hideVideoTrackCaptions() {
    if (videoElementView === null) {
      return;
    }
    if (videoElementView.containsWebTrackCaptions) {
      _$positionContainer.removeClass(cssClasses.hide);
      videoElementView.hideCaptionTrack(captionsService.captionController.getActiveLanguageIdentifier());
    }
  };
  setupDomStructure();
  setupEvents();
  updateView();
  if (!canDragCaptions) {
    _$positionContainer.addClass(cssClasses.captionsPreventCaptionDrag);
  }
  return Object.defineProperties({
    updateCaption: updateCaption,
    handleDisplayCaptions: handleDisplayCaptions,
    showVideoTrackCaptions: showVideoTrackCaptions,
    hideVideoTrackCaptions: hideVideoTrackCaptions,
    destroy: destroy
  }, {
    visible: {
      get: function get() {
        return _visible;
      },
      set: setVisible
    },
    scale: {
      get: function get() {
        return _canvasScale;
      },
      set: function set(canvasScale) {
        _canvasScale = canvasScale;
        onSizeChange();
      }
    }
  });
};
var CaptionsView$1 = {
  /**
   *  Factory method that returns a new CaptionsView object.
   *  @function create
   *  @memberof TSC.CaptionsView
   *  @static
   *  @param {jQuery} $container - Root Smart Player dom element
   *  @param {CaptionService} captionsService - Caption service instance
   *  @param {TSC.VideoElementView} videoElementView - Video element view for MP4 video, this is null for YouTube video.
   *  @param {boolean} canDragCaptions - Captions can be dragged to a new location by the user.
   *  @return new CaptionView instance
   */
  create: CaptionsView
};

var DEFAULT_CAPTION_STATE = false;

/**
 * @memberof TSC
 * @class CaptionController
 * @classdesc Controller for managing XMP features
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.XmpModel} xmpModel
 * @param {TSC.MediaList} mediaList
 * @param {TSC.CaptionService} captionService
 *
 */
var CaptionController = function CaptionController($container, mediaView, xmpModel, mediaList, captionService) {
  var hasCaptions = xmpModel && xmpModel.hasCaptionItems || captionService.captionTrack;
  if (!hasCaptions) {
    throw new Error('Attempted to create caption controller with no captions in xmp');
  }
  var LOCAL_STORAGE_CAPTIONS_STATE_KEY = 'captionEnabled';
  var _captionsView;
  var _$controls = $container.find('.video-controls-container');
  var setupCaptionView = function setupCaptionView(captionPosition) {
    _captionsView = CaptionsView$1.create($container, captionService, mediaView, mediaView.canDragContentOnVideo);
    _captionsView.handleDisplayCaptions(true);
    if (captionPosition === CAPTION_POSITION.under) {
      _$controls.addClass(cssClasses.captionsUnderVideo);
    }
    $container.trigger(events.Controls.DisplayCaptionControl, {
      displayCaptionControl: captionPosition !== CAPTION_POSITION.under,
      captionViewPosition: captionPosition
    });
  };
  var setupNonXmpFeatures = function setupNonXmpFeatures() {
    captionService.initDefaults();
    setupCaptionView(captionService.position);
  };
  var setupXmpFeatures = function setupXmpFeatures() {
    captionService.initFromXmp(xmpModel);
    setupCaptionView(xmpModel.captionPosition);
  };
  var isNotNullOrUndefined = function isNotNullOrUndefined(input) {
    return input !== null && input !== undefined;
  };
  var loadInitialState = function loadInitialState() {
    var savedCaptionsStateFromLocalStorage = localStorageWrapper.getItem(LOCAL_STORAGE_CAPTIONS_STATE_KEY);
    savedCaptionsStateFromLocalStorage = savedCaptionsStateFromLocalStorage ? savedCaptionsStateFromLocalStorage === 'true' : undefined;
    var videoCaptionsSetting = playerConfiguration.getCaptionsEnabled();
    var initialState;
    if (playerConfiguration.getIgnoreStoredCaptionVisibleSetting()) {
      initialState = isNotNullOrUndefined(videoCaptionsSetting) ? videoCaptionsSetting : DEFAULT_CAPTION_STATE;
    } else if (isNotNullOrUndefined(savedCaptionsStateFromLocalStorage)) {
      initialState = savedCaptionsStateFromLocalStorage;
    } else if (isNotNullOrUndefined(videoCaptionsSetting)) {
      initialState = videoCaptionsSetting;
    } else {
      initialState = DEFAULT_CAPTION_STATE;
    }
    $container.trigger(events.Captions.StateLoaded, {
      captionsEnabled: initialState
    });
  };
  var onCaptionsToggle = function onCaptionsToggle(e, eventData) {
    e.preventDefault();
    eventData.savePreference && localStorageWrapper.setItem(LOCAL_STORAGE_CAPTIONS_STATE_KEY, eventData.captionsEnabled);
  };
  var resizeCaptions = function resizeCaptions() {
    if (!mediaView || mediaView.mediaWrapper === undefined || mediaView.mediaHeight <= 0) {
      return;
    }
    captionService.setFontSizeForPlayerDimensions($container.width(), $container.height());
    if (_captionsView) {
      // if caption-position under we use the top-level container for scaling
      var scaleContainer = captionService.captionPosition === CAPTION_POSITION.under ? $container : mediaView.mediaWrapper;
      _captionsView.scale = videoApiUtils.calculateCanvasScale(mediaView, scaleContainer.width(), scaleContainer.height());
    }
  };
  var updateCaptions = function updateCaptions(currentTimeInMilliseconds, forceActiveCaptionUpdate) {
    var currentFile = mediaList.isPlaylist ? mediaList.currentMedia.media : null;
    _captionsView.updateCaption(currentTimeInMilliseconds, currentFile, forceActiveCaptionUpdate);
  };
  var onPlayerResize = function onPlayerResize() {
    resizeCaptions();
  };
  var onFullScreenChange = function onFullScreenChange() {
    resizeCaptions();
  };
  var onLoadedMetadata = function onLoadedMetadata() {
    resizeCaptions();
  };
  var onVideoTimeUpdate = function onVideoTimeUpdate() {
    updateCaptions(mediaView.currentTimeInMilliseconds, false);
  };
  var onSeeked = function onSeeked() {
    updateCaptions(mediaView.currentTimeInMilliseconds, false);
  };
  var onPipChanged = function onPipChanged(event, eventData) {
    if (_captionsView && _captionsView.visible) {
      if (eventData.pipViewActive) {
        _captionsView.showVideoTrackCaptions();
      } else {
        _captionsView.hideVideoTrackCaptions();
      }
    }
  };
  var onNewCaptionTrack = function onNewCaptionTrack() {
    if (_captionsView) {
      _captionsView.handleDisplayCaptions();
    }
  };
  var bindToEvents = function bindToEvents() {
    captionService.addEventListener(events.CaptionService.NewCaptionTrack, onNewCaptionTrack);
    $container.on(events.Controls.FullScreenChange, onFullScreenChange);
    $container.on(events.Controls.MediaResize, onPlayerResize);
    $container.on(events.Controls.PipChanged, onPipChanged);
    $container.on(events.Captions.Toggled, onCaptionsToggle);
    mediaView.mediaWrapper.on('ratechange', onVideoTimeUpdate, false);
    mediaView.mediaWrapper.on('play', onVideoTimeUpdate, false);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      timeupdate: onVideoTimeUpdate,
      seeked: onSeeked
    };
    mediaView.mediaWrapper.on(eventsToBind);
  };
  var unbindToEvents = function unbindToEvents() {
    captionService.removeEventListener(events.CaptionService.NewCaptionTrack, onNewCaptionTrack);
    $container.off(events.Controls.FullScreenChange, onFullScreenChange);
    $container.off(events.Controls.MediaResize, onPlayerResize);
    $container.off(events.Controls.PipChanged, onPipChanged);
    $container.off(events.Captions.Toggled, onCaptionsToggle);
    mediaView.mediaWrapper.off('ratechange', onVideoTimeUpdate, false);
    mediaView.mediaWrapper.off('play', onVideoTimeUpdate, false);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      timeupdate: onVideoTimeUpdate,
      seeked: onSeeked
    };
    mediaView.mediaWrapper.off(eventsToBind);
  };
  var getCaptionCollection = function getCaptionCollection() {
    return captionService.captionTrack.captionCollection;
  };
  var getCaptionTrack = function getCaptionTrack() {
    return captionService.captionTrack;
  };
  var setCaptionTrack = function setCaptionTrack(value) {
    captionService.captionTrack = value;
    if (_captionsView) {
      _captionsView.handleDisplayCaptions();
    }
  };
  var getCaptionsVisible = function getCaptionsVisible() {
    return _captionsView ? _captionsView.visible : playerConfiguration.getCaptionsEnabled();
  };
  var setCaptionsVisible = function setCaptionsVisible(value) {
    if (_captionsView) {
      _captionsView.visible = value;
      _captionsView.handleDisplayCaptions();
      updateCaptions(mediaView.currentTimeInMilliseconds, true);
    } else {
      playerConfiguration.setCaptionsEnabled(value);
    }
    var showCaptionControls = value && captionService.hasCaptions;
    $container.trigger(events.Controls.DisplayCaptionControl, {
      displayCaptionControl: showCaptionControls && captionService.captionPosition !== CAPTION_POSITION.under,
      captionViewPosition: captionService.captionPosition
    });
    $container.trigger(events.Captions.StateLoaded, {
      captionsEnabled: showCaptionControls
    });
  };
  var destroy = function destroy() {
    unbindToEvents();
    _captionsView && _captionsView.destroy();
  };
  if (xmpModel) {
    setupXmpFeatures();
  } else {
    setupNonXmpFeatures();
  }
  bindToEvents();
  loadInitialState();
  return Object.defineProperties({
    destroy: destroy,
    getCaptionCollection: getCaptionCollection,
    getCaptionTrack: getCaptionTrack,
    setCaptionTrack: setCaptionTrack,
    getCaptionsVisible: getCaptionsVisible,
    setCaptionsVisible: setCaptionsVisible
  }, {});
};
var CaptionController$1 = {
  /**
   *  Factory method that returns a new CaptionController.
   *  @function create
   *  @memberof TSC.CaptionController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.XmpModel} xmpModel
   *  @param {TSC.MediaList} mediaList
   *  @param {TSC.CaptionService} captionService
   *  @return new CaptionController instance
   */
  create: CaptionController
};

var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var htmlEncode = function htmlEncode(text) {
  if (typeof text === 'string') {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
  }
  return text;
};
var isValidEmail = function isValidEmail(email) {
  return EMAIL_REGEX.test(email);
};
var textSanitizer = {
  htmlEncode: htmlEncode,
  isValidEmail: isValidEmail
};

var TIME_SALT = new Date().getMilliseconds();
var UNIQUE_TOKEN_1 = 'MJB_!_1_@__#_' + TIME_SALT;
var UNIQUE_TOKEN_2 = 'MJB_!_2_@__#_' + TIME_SALT;
var REGEX_REPLACEMENT_STRING = UNIQUE_TOKEN_1 + '$1' + UNIQUE_TOKEN_2;
var TOKEN_1_REGEX = new RegExp(UNIQUE_TOKEN_1, 'g');
var TOKEN_2_REGEX = new RegExp(UNIQUE_TOKEN_2, 'g');
var REGEX_ESCAPE = /[.*+?^${}()|[\]\\]/g;
var createHighlightedText = function createHighlightedText(text, searchRegex) {
  var textWithSearchMatchPlaceholders = text.replace(searchRegex, REGEX_REPLACEMENT_STRING);
  var sanitizedText = textSanitizer.htmlEncode(textWithSearchMatchPlaceholders);
  return sanitizedText.replace(TOKEN_1_REGEX, '<span class="found-search-text">').replace(TOKEN_2_REGEX, '</span>');
};
var simpleSearch = function simpleSearch(items, searchString) {
  var matches = [];
  if (!searchString) {
    return matches;
  }
  var searchRegex = new RegExp('(' + searchString.replace(REGEX_ESCAPE, '\\$&') + ')', 'gi');
  items.forEach(function (item) {
    var itemText = item.plainText || item.text || item.name || '';
    if (itemText.toLowerCase().indexOf(searchString) !== -1) {
      matches.push({
        rawText: itemText,
        text: createHighlightedText(itemText, searchRegex),
        startTime: item.startTime,
        file: item.file,
        imageRef: item.image,
        imageRect: item.imageRectangle
      });
    }
  });
  return matches;
};
var searchXmpForString = function searchXmpForString(xmp, searchString) {
  searchString = searchString.toLowerCase();
  var itemsToSearch = xmp.tocItemArray.concat(xmp.captionItems).concat(xmp.screenTextItemArray);

  // captions are speech to text converted
  if (xmp.captionItems.length < 1 && xmp.speechTextItemArray.length > 0) {
    itemsToSearch = itemsToSearch.concat(xmp.speechTextItemArray);
  }
  return simpleSearch(itemsToSearch, searchString);
};
var searchTool = {
  searchXmpForString: searchXmpForString
};

var TOC_WIDTH = 250;
var TOC_MAX_HEIGHT = 80;
var POINTER_MOVE_DETECTED_PIXEL_DELTA = 2;

/**
 * @memberof TSC
 * @class TocView
 * @classdesc Table of Contents View
 * @param {JQuery}} $container - jQuery top-level smartplayer container
 * @param {TSC.Xmp} xmpModel - Xmp Model
 */
var TocView = function TocView($container, xmpModel) {
  var _viewVisible = false;
  var _viewIsOpen = false;
  var _searchFocus = false;
  var _scrolledToc = false;
  var _eventHandlers = {};
  var _keysEnabled = true;
  var _inputSearchClassName = '.toc-search-input';
  var _$tocHeadContainer = null;
  var _$searchContainer = null;
  var _$searchInput = null;
  var _$titleHeader = null;
  var _$clearSearchButton = null;
  var _$tocPipImageContainer = null;
  var _$searchInputDisabled = null;
  var _$tocContentScrollContainer = null;
  var _$tocContent = null;
  var _$tocContentScreenReaderLabel = null;
  var _$tocItemDomList = null;
  var _$tocContainer = null;
  var _$noSearchResultsAlert = null;
  var _xmp = xmpModel;
  var _tocThumbsImage = null;
  var _tocPipImage = null;
  var _pointerDownClientPoint = {
    x: 0,
    y: 0
  };
  var createView = function createView() {
    _$tocContainer = $container.find('.toc-container');
    var tocMarkup = templateGenerator.generateTocMarkup();
    _$tocContainer.html(tocMarkup);
    _$tocHeadContainer = _$tocContainer.find('.toc-head-container');
    _$searchInput = _$tocContainer.find(_inputSearchClassName);
    _$titleHeader = _$tocContainer.find('.toc-media-title');
    _$searchContainer = _$tocContainer.find('.toc-search-container');
    _$clearSearchButton = _$tocContainer.find('.clear-search-button');
    _$tocPipImageContainer = _$tocContainer.find('.toc-pip-image-container');
    _$searchInputDisabled = _$tocContainer.find('.toc-full-screen-search-alert');
    _$tocContentScrollContainer = _$tocContainer.find('.toc-content-scroll-container');
    _$tocContent = _$tocContainer.find('.toc-content-container');
    _$tocContentScreenReaderLabel = _$tocContainer.find('#tocContentScreenReaderLabel');
    _$noSearchResultsAlert = $('<div class="sr-only alert-only" role="alert">' + localizationStrings.getPlayerString(playerStringNames.accessListNoSearchResults) + '</div>');
  };
  var tocContainsActiveElement = function tocContainsActiveElement() {
    var activeElement = viewHelper.getActiveElement();
    return activeElement && (_$tocContainer[0] === activeElement || $.contains(_$tocContainer[0], activeElement));
  };
  var showView = function showView(animationSpeed) {
    if (animationSpeed) {
      _$tocContainer.stop(true, true).fadeIn(animationSpeed);
    } else {
      _$tocContainer.show();
    }
    _viewVisible = true;
  };
  var hideView = function hideView(animationSpeed) {
    if (animationSpeed) {
      _$tocContainer.stop(true, true).fadeOut(animationSpeed);
    } else {
      _$tocContainer.hide();
    }
    _viewVisible = false;
  };
  var openView = function openView() {
    _viewIsOpen = true;
    showView();
    resizeView();
  };
  var closeView = function closeView() {
    _viewIsOpen = false;
    hideView();
  };
  var blurSearchInput = function blurSearchInput() {
    _$searchInput.blur();
  };
  var resizeView = function resizeView() {
    var headerHeight = _$tocHeadContainer.height();
    var containerHeight = $container.height();
    var playerControlHeight = $container.find('.video-controls-container').height();
    var tocTopPosition = containerHeight - playerControlHeight;
    $container[0].style.setProperty(cssVariables.tocTopOffset, "-".concat(Math.round(tocTopPosition), "px"));
    _$tocContentScrollContainer.css('top', headerHeight + 'px');
  };
  var addEventListener = function addEventListener(eventName, eventCallback) {
    if (typeof eventCallback !== 'function') {
      throw Error('Toc View : addEventListener expects eventCallback to be a function.');
    }
    _eventHandlers[eventName] = eventCallback;
  };
  var removeEventListener = function removeEventListener(eventName) {
    delete _eventHandlers[eventName];
  };
  var loadTocPipImage = function loadTocPipImage() {
    return new Promise$1(function (resolve, reject) {
      _tocPipImage = new Image();
      _tocPipImage.onerror = function () {
        reject();
      };
      _tocPipImage.onload = function () {
        resolve();
      };
      _tocPipImage.src = _xmp.tocImageSrc;
    });
  };
  var displayTocPipImage = function displayTocPipImage() {
    var imageWidth = _tocPipImage.width;
    var imageHeight = _tocPipImage.height;
    var scale = 1;
    var targetWidth;
    var targetHeight;
    var scaledReduction = .60;
    var padding = 20;
    if (imageHeight <= imageWidth) {
      if (imageWidth > TOC_WIDTH - padding) {
        scale = (TOC_WIDTH - padding) / imageWidth;
        targetWidth = TOC_WIDTH - padding;
        targetHeight = imageHeight * scale;
      } else {
        targetWidth = imageWidth;
        targetHeight = imageHeight;
      }
    } else if (imageHeight > TOC_WIDTH - padding) {
      scale = (imageWidth * scaledReduction - padding) / imageHeight;
      targetHeight = TOC_WIDTH * scaledReduction - padding;
      targetWidth = imageWidth * scale;
    } else {
      targetHeight = imageHeight;
      targetWidth = imageWidth;
    }
    var pipImageBackgroundStyle = 'background: url(' + _xmp.tocImageSrc + ') no-repeat;' + 'width: ' + targetWidth + 'px;' + 'height: ' + targetHeight + 'px;' + 'margin-left: ' + (TOC_WIDTH - targetWidth) / 2 + 'px;' + 'margin-right:' + (TOC_WIDTH - targetWidth) / 2 + 'px;';
    var pipImageBackground = $('<div />', {
      "class": 'toc-pip-image-background',
      style: pipImageBackgroundStyle
    });
    _$tocPipImageContainer.append(pipImageBackground);
    _$tocPipImageContainer.show();
  };
  var loadTocThumbnailImage = function loadTocThumbnailImage(tocThumbnailImageSrc) {
    return new Promise$1(function (resolve) {
      if (_xmp.tocContainsThumbs) {
        _tocThumbsImage = new Image();
        _tocThumbsImage.onload = function () {
          resolve();
        };
        _tocThumbsImage.onerror = function () {
          _tocThumbsImage.onload = undefined;
          _tocThumbsImage.onerror = undefined;
          _tocThumbsImage = null;
          resolve();
        };
        _tocThumbsImage.src = tocThumbnailImageSrc;
      } else {
        resolve();
      }
    });
  };
  var setupTocPosition = function setupTocPosition() {
    _$tocContainer.toggleClass('right', playerConfiguration.getSidebarLocation() === 'right');
  };
  var setupSearch = function setupSearch() {
    if (!playerConfiguration.getIsSearchable()) {
      _$searchContainer.hide();
    }
  };
  var setupTocHeader = function setupTocHeader() {
    if (_xmp.tocImageSrc) {
      loadTocPipImage().then(displayTocPipImage)["catch"](function () {
        console.warn('Failed to load toc pip image ', _xmp.tocImageSrc);
      });
    }
    _$titleHeader.text(playerConfiguration.tocTitle || localizationStrings.getPlayerString(playerStringNames.accessListTableOfContents));
  };
  var clearTocContent = function clearTocContent() {
    _$tocContent.empty();
  };
  var generateTocItemThumbnail = function generateTocItemThumbnail(tocItemThumbnailCanvasEl, imageThumbRect) {
    var defaultBgColor = '#000';
    var tocCellPadding = 20;
    var xPos = Number(imageThumbRect.x);
    var yPos = Number(imageThumbRect.y);
    var imageWidth = Number(imageThumbRect.width);
    var imageHeight = Number(imageThumbRect.height);
    var thumbScale = 1;
    if (imageWidth > TOC_WIDTH / 2 - tocCellPadding) {
      thumbScale = (TOC_WIDTH / 2 - tocCellPadding) / imageWidth;
      imageWidth = TOC_WIDTH / 2 - tocCellPadding;
    }
    if (imageHeight > TOC_MAX_HEIGHT - tocCellPadding) {
      var verticalThumbScale = (TOC_MAX_HEIGHT - tocCellPadding) / imageHeight;
      thumbScale = Math.min(thumbScale, verticalThumbScale);
    }
    var ctx = tocItemThumbnailCanvasEl.getContext('2d');
    tocItemThumbnailCanvasEl.width = imageWidth * thumbScale;
    tocItemThumbnailCanvasEl.height = imageHeight * thumbScale;
    ctx.scale(thumbScale, thumbScale);
    if (_tocThumbsImage) {
      ctx.drawImage(_tocThumbsImage, xPos, yPos, imageWidth, imageHeight, 0, 0, imageWidth, imageHeight);
    } else {
      ctx.fillStyle = defaultBgColor;
      ctx.fillRect(0, 0, imageWidth, imageHeight);
    }
  };
  var createTocItem = function createTocItem(tocText, tocRawText, tocTime, tocFile, tocItemThumbnailCanvasEl, imageThumbRect, showText, showThumbnail) {
    var dataTocTime = 'data-time=' + tocTime;
    var dataFileText = tocFile ? 'data-file=' + tocFile : '';
    var centerContent = !showText;
    var tocItemMarkup = templateGenerator.generateTocItemMarkup(dataTocTime, dataFileText, showThumbnail, centerContent, showText, tocText, tocRawText);
    var $tocItem = $($.parseHTML(tocItemMarkup));
    if (showThumbnail) {
      generateTocItemThumbnail(tocItemThumbnailCanvasEl, imageThumbRect);
      tocItemThumbnailCanvasEl.classList.add('toc-item-thumbnail');
      $tocItem.find('.thumbnail-placeholder').replaceWith(tocItemThumbnailCanvasEl);
    }
    return $tocItem;
  };
  var createTocItems = function createTocItems() {
    _$tocItemDomList = [];
    var tocItems = _xmp.tocItemArray;
    tocItems.forEach(function (tocItem) {
      var thumbnailCanvasEl = tocItem.imageRectangle ? document.createElement('canvas') : undefined;
      var showThumbnail = !!thumbnailCanvasEl;
      var showText = _xmp.tocCellLayoutType !== 'imageOnly' || !showThumbnail;
      _$tocItemDomList.push(createTocItem(textSanitizer.htmlEncode(tocItem.name), tocItem.name, tocItem.startTime, tocItem.file, thumbnailCanvasEl, tocItem.imageRectangle, showText, showThumbnail));
    });
  };
  var displayTocItems = function displayTocItems() {
    clearTocContent();
    if (_$tocItemDomList === null) {
      createTocItems();
    }
    _$tocContentScreenReaderLabel.html(localizationStrings.getPlayerString(playerStringNames.accessListTableOfContents));
    _$tocContent.append(_$tocItemDomList);
  };
  var setupView = function setupView() {
    setupTocPosition();
    setupSearch();
    setupTocHeader();
    loadTocThumbnailImage(_xmp.tocThumbImageSrc).then(displayTocItems);
    if (playerConfiguration.getSidebarEnabled()) {
      openView();
    }
    _$tocContainer.click(function (e) {
      e.stopPropagation();
    });
  };
  var tocItemClickHandler = function tocItemClickHandler(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    if (deviceInfo.isTouchInterface() && _scrolledToc) {
      return;
    }
    seekToTocItem(e.currentTarget);
  };
  var seekToTocItem = function seekToTocItem(target) {
    if (_eventHandlers.clickTocItem) {
      var $currentTarget = $(target);
      var timeToSeekTo = Number($currentTarget.attr('data-time')) / 1000;
      var fileToSeekTo = $currentTarget.attr('data-file');
      _eventHandlers.clickTocItem(timeToSeekTo, fileToSeekTo);
    }
  };
  var onTocItemPointerDown = function onTocItemPointerDown(e) {
    _pointerDownClientPoint.x = e.originalEvent.clientX;
    _pointerDownClientPoint.y = e.originalEvent.clientY;
    _scrolledToc = false;
  };
  var onTocItemPointerMove = function onTocItemPointerMove(e) {
    // this event fires a lot when the browser natively implements pointer-events.  We need to actual check for movement between events.
    if (Math.abs(e.originalEvent.clientX - _pointerDownClientPoint.x) <= POINTER_MOVE_DETECTED_PIXEL_DELTA && Math.abs(e.originalEvent.clientY - _pointerDownClientPoint.y) <= POINTER_MOVE_DETECTED_PIXEL_DELTA) {
      return;
    }
    if (!deviceInfo.isTouchIEInterface()) {
      _scrolledToc = true;
    }
  };
  var onSearchTextInput = function onSearchTextInput(e) {
    updateSearchResults();
    if (keys.isKeyOfType(e.key, keys.keyTypes.enter)) {
      var $tocButtons = _$tocContent.find('button');
      if ($tocButtons.length > 0) {
        $tocButtons.first().focus();
      } else {
        _$tocContent.after(_$noSearchResultsAlert);
      }
    }
  };
  var updateSearchResults = function updateSearchResults() {
    if (_$searchInput.val() !== '') {
      clearTocContent();
      var searchResults = searchTool.searchXmpForString(_xmp, _$searchInput.val());
      var searchResultsTocItems = [];
      searchResults.forEach(function (result) {
        var thumbnailCanvasEl = result.imageRect ? document.createElement('canvas') : undefined;
        var showThumbnail = !!thumbnailCanvasEl;
        var showText = true;
        searchResultsTocItems.push(createTocItem(result.text, result.rawText, result.startTime, result.file, thumbnailCanvasEl, result.imageRect, showText, showThumbnail));
      });
      _$tocContentScreenReaderLabel.html(localizationStrings.getPlayerString(playerStringNames.accessListSearchResults));
      _$tocContent.append(searchResultsTocItems);
      var updateSearchAlertStringToken = '{{number}}';
      var updatedSearchAlertText = localizationStrings.getPlayerString(playerStringNames.searchResultsUpdated);
      updatedSearchAlertText = updatedSearchAlertText.replace(updateSearchAlertStringToken, searchResultsTocItems.length);
      alertScreenReader(updatedSearchAlertText);
    } else {
      _$noSearchResultsAlert.remove();
      displayTocItems();
    }
  };
  var alertScreenReader = function alertScreenReader(alertText) {
    var screenReaderAlertMarkup = templateGenerator.generateScreenReaderAlertMarkup(alertText);
    var $screenReaderAlert = $(screenReaderAlertMarkup);
    $container.append($screenReaderAlert);
    setTimeout(function () {
      $screenReaderAlert.remove();
    }, 1000);
  };
  var clearSearch = function clearSearch() {
    _$searchInput.val('');
    _$noSearchResultsAlert.remove();
    displayTocItems();
    var clearSearchAlertText = localizationStrings.getPlayerString(playerStringNames.searchTextCleared);
    alertScreenReader(clearSearchAlertText);
  };
  var disableSearch = function disableSearch() {
    _$searchContainer.hide();
    _$searchInputDisabled.show();
  };
  var enableSearch = function enableSearch() {
    if (playerConfiguration.getIsSearchable()) {
      _$searchContainer.show();
      _$searchInputDisabled.hide();
    }
  };
  var onSearchInputFocus = function onSearchInputFocus() {
    _searchFocus = true;
    $container.trigger(events.Controls.Disable);
    $container.trigger(events.Controls.SearchFocusChange, {
      searchIsFocused: true
    });
  };
  var onSearchInputBlur = function onSearchInputBlur() {
    _searchFocus = false;
    $container.trigger(events.Controls.Enable);
    $container.trigger(events.Controls.SearchFocusChange, {
      searchIsFocused: false
    });
  };
  var onTocItemKeyUp = function onTocItemKeyUp(e) {
    if (!_keysEnabled) {
      return;
    }
    if (keys.isKeyOfType(e.key, keys.keyTypes.space, keys.keyTypes.enter)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      seekToTocItem(e.currentTarget);
    }
  };
  var onTocItemKeyDown = function onTocItemKeyDown(e) {
    if (!_keysEnabled) {
      return;
    }
    if (keys.isKeyOfType(e.key, keys.keyTypes.space)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  };
  var onTocContentScrollHandler = function onTocContentScrollHandler() {
    $container.trigger(events.Controls.TocScroll);
  };
  var onKeyDownHandler = function onKeyDownHandler(e) {
    if (!hotkeyService.areHotkeysEnabled()) {
      return;
    }
    if (keys.isKeyOfType(e.key, keys.keyTypes.escape)) {
      if (_viewIsOpen) {
        if (_$tocContainer.is(':focus') || _$tocContainer.has(e.target).length > 0) {
          $container.trigger(events.Controls.FocusTocButton);
        }
        alertScreenReader(localizationStrings.getPlayerString(playerStringNames.tableOfContentsHidden));
        $container.trigger(events.Controls.HideToc);
      }
    }
  };
  var disableKeyListeners = function disableKeyListeners() {
    _$tocContainer.attr('tabindex', tabIndex.Disabled);
    _keysEnabled = false;
  };
  var enableKeyListeners = function enableKeyListeners() {
    _$tocContainer.attr('tabindex', tabIndex.DomOrder);
    _keysEnabled = true;
  };
  var bindEvents = function bindEvents() {
    _$tocContent.on('pointerup', '.toc-item', tocItemClickHandler);
    _$tocContent.on('keyup', '.toc-item', onTocItemKeyUp);
    _$tocContent.on('keydown', '.toc-item', onTocItemKeyDown);
    _$tocContent.on('pointerdown', '.toc-item', onTocItemPointerDown);
    _$tocContent.on('pointermove', '.toc-item', onTocItemPointerMove);
    _$tocContentScrollContainer.on('scroll', onTocContentScrollHandler);
    $container.on('keydown', onKeyDownHandler);
    $container.on(events.Controls.Disable, disableKeyListeners);
    $container.on(events.Controls.Enable, enableKeyListeners);
    if (playerConfiguration.getIsSearchable()) {
      _$searchInput.on('keyup', onSearchTextInput);
      _$searchInput.on('focus', onSearchInputFocus);
      _$clearSearchButton.on('click', clearSearch);
      $container.on('blur', _inputSearchClassName, onSearchInputBlur); // need to use delegate for blur to consistently fire
      $container.on(events.Captions.LanguageChanged, updateSearchResults);
    }
  };
  var destroy = function destroy() {
    _$tocContent.off('pointerup', '.toc-item', tocItemClickHandler);
    _$tocContent.off('keyup', '.toc-item', onTocItemKeyUp);
    _$tocContent.off('keydown', '.toc-item', onTocItemKeyDown);
    _$tocContent.off('pointerdown', '.toc-item', onTocItemPointerDown);
    _$tocContent.off('pointermove', '.toc-item', onTocItemPointerMove);
    _$tocContentScrollContainer.off('scroll', onTocContentScrollHandler);
    $container.off('keydown', onKeyDownHandler);
    $container.off(events.Controls.Disable, disableKeyListeners);
    $container.off(events.Controls.Enable, enableKeyListeners);
    if (playerConfiguration.getIsSearchable()) {
      _$searchInput.off('keyup', onSearchTextInput);
      _$searchInput.off('focus', onSearchInputFocus);
      $container.off('blur', _inputSearchClassName, onSearchInputBlur);
      _$clearSearchButton.off('click', clearSearch);
      $container.off(events.Captions.LanguageChanged, updateSearchResults);
    }
  };
  createView();
  setupView();
  bindEvents();
  return Object.defineProperties({
    open: openView,
    close: closeView,
    show: showView,
    hide: hideView,
    blurSearchInput: blurSearchInput,
    disableSearch: disableSearch,
    enableSearch: enableSearch,
    resize: resizeView,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener,
    destroy: destroy
  }, {
    isOpen: {
      get: function get() {
        return _viewIsOpen;
      }
    },
    visible: {
      get: function get() {
        return _viewVisible;
      }
    },
    searchIsFocused: {
      get: function get() {
        return _searchFocus;
      }
    },
    tocContainsActiveElement: {
      get: tocContainsActiveElement
    }
  });
};
var TocView$1 = {
  /**
   *  Factory method that returns a new TocView object.
   *  @function create
   *  @memberof TSC.TocView
   *  @static
   *  @param {Object} $container - jQuery element that contains a .toc-container element where ToC view will be injected
   *  @param {TSC.Xmp} xmpModel - Xmp Model
   *  @return new TocView instance
   */
  create: TocView
};

/**
 * @memberof TSC
 * @class TableOfContentsController
 * @classdesc Controller for managing XMP features
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.XmpModel} xmpModel
 * @param {TSC.MediaList} mediaList
 * @param {TSC.ProgressBarControlView} progressBarControlView
 * @param {TSC.playerConfiguration} playerConfiguration
 *
 */
var TableOfContentsController = function TableOfContentsController($container, mediaView, xmpModel, mediaList, progressBarControlView, playerConfiguration) {
  var hasTableOfContents = xmpModel && xmpModel.hasSearchableItems;
  if (!hasTableOfContents) {
    throw new Error('Attempted to create table of contents controller with no table of contents or searchable items in xmp');
  }
  var _animationSpeed = 300;
  var _tocView;
  var _inFullScreen;
  var _controlsHidden;
  var setupXmpFeatures = function setupXmpFeatures() {
    _tocView = TocView$1.create($container, xmpModel);
    $container.trigger(events.Controls.DisplayTocControl);
  };
  var resizeTableOfContents = function resizeTableOfContents() {
    if (_tocView.isOpen) {
      _tocView.resize();
    }
  };
  var onPlayerResize = function onPlayerResize() {
    resizeTableOfContents();
  };
  var onFullScreenChange = function onFullScreenChange(e, eventData) {
    _inFullScreen = eventData.inFullScreen;
    resizeTableOfContents();
  };
  var onLoadedMetadata = function onLoadedMetadata() {
    mediaView.mediaWrapper.off('loadedmetadata', onLoadedMetadata);
    if (xmpModel.hasTocItems && mediaView.type !== mediaViewType.playlist) {
      progressBarControlView.createTocChapters(xmpModel.tocItemArray);
    }
    resizeTableOfContents();
    if (_tocView.isOpen) {
      $container.trigger(events.Controls.ShowToc);
    }
  };
  var onTocItemClicked = function onTocItemClicked(timeToSeekTo, fileToSeekTo) {
    if (fileToSeekTo !== undefined) {
      var videoIndex = mediaList.getMediaIndexByUri(fileToSeekTo);
      if (videoIndex === mediaList.currentMediaIndex) {
        $container.trigger(events.Media.SeekToTime, {
          time: timeToSeekTo
        });
      } else {
        mediaList.currentMediaIndex = videoIndex;
        $container.trigger(events.Media.SourceChanged);
      }
    } else if (playerConfiguration.allowFastForward || timeToSeekTo < mediaView.currentTime) {
      $container.trigger(events.Media.SeekToTime, {
        time: timeToSeekTo
      });
    }
  };
  var displayToc = function displayToc() {
    _tocView.open();
  };
  var hideToc = function hideToc() {
    _tocView.close();
  };
  var mobileOrientationChange = function mobileOrientationChange() {
    if (_inFullScreen) {
      // when keyboard is up on ipad, the size of screen
      // is reported wrong until we get rid of it
      if (_tocView.searchIsFocused) {
        _tocView.blurSearchInput();
        setTimeout(resizeTableOfContents, 500);
      } else {
        resizeTableOfContents();
      }
    }
  };
  var hideControls = function hideControls() {
    if (_tocView.tocContainsActiveElement) {
      return;
    }
    _controlsHidden = true;
    if (_tocView.isOpen) {
      _tocView.hide(_animationSpeed);
    }
  };
  var showControls = function showControls() {
    if (_controlsHidden) {
      _controlsHidden = false;
      if (_tocView.isOpen) {
        _tocView.show(_animationSpeed);
      }
    }
  };
  var onQuizMinimizeUI = function onQuizMinimizeUI() {
    if (_tocView.isOpen) {
      _tocView.close();
    }
    hideControls();
  };
  var onQuizMaximizeUI = function onQuizMaximizeUI() {
    showControls();
  };
  var onQuizReview = function onQuizReview() {
    if (_tocView.isOpen) {
      _tocView.show(_animationSpeed);
    }
  };
  var onQuizPaused = function onQuizPaused() {
    if (_tocView.isOpen) {
      _tocView.hide(_animationSpeed);
    }
  };
  var onTocDisplayToggled = function onTocDisplayToggled(e, data) {
    if (data.displayToc) {
      displayToc();
    } else {
      hideToc();
    }
  };
  var bindToEvents = function bindToEvents() {
    _tocView.addEventListener('clickTocItem', onTocItemClicked);
    $container.on(events.Controls.ShowToc, displayToc);
    $container.on(events.Controls.HideToc, hideToc);
    $container.on(events.Controls.TocDisplayToggled, onTocDisplayToggled);
    if (deviceInfo.isIOS() || deviceInfo.isAndroid()) {
      window.addEventListener('orientationchange', mobileOrientationChange);
    }
    $container.on(events.Quizzing.MinimizeUI, onQuizMinimizeUI);
    $container.on(events.Quizzing.MaximizeUI, onQuizMaximizeUI);
    $container.on(events.Quizzing.Review, onQuizReview);
    $container.on(events.Quizzing.Paused, onQuizPaused);
    $container.on(events.Controls.FullScreenChange, onFullScreenChange);
    $container.on(events.Controls.PlayerResize, onPlayerResize);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata
    };
    mediaView.mediaWrapper.on(eventsToBind);
  };
  var unbindToEvents = function unbindToEvents() {
    _tocView.removeEventListener('clickTocItem', onTocItemClicked);
    $container.off(events.Controls.ShowToc, displayToc);
    $container.off(events.Controls.HideToc, hideToc);
    $container.off(events.Controls.TocDisplayToggled, onTocDisplayToggled);
    if (deviceInfo.isIOS() || deviceInfo.isAndroid()) {
      window.removeEventListener('orientationchange', mobileOrientationChange);
    }
    $container.off(events.Quizzing.MinimizeUI, onQuizMinimizeUI);
    $container.off(events.Quizzing.MaximizeUI, onQuizMaximizeUI);
    $container.off(events.Quizzing.Review, onQuizReview);
    $container.on(events.Quizzing.Paused, onQuizPaused);
    $container.off(events.Controls.FullScreenChange, onFullScreenChange);
    $container.off(events.Controls.PlayerResize, onPlayerResize);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata
    };
    mediaView.mediaWrapper.off(eventsToBind);
  };
  var destroy = function destroy() {
    unbindToEvents();
    _tocView && _tocView.destroy();
  };
  setupXmpFeatures();
  bindToEvents();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var TableOfContentsController$1 = {
  /**
   *  Factory method that returns a new TableOfContentsController.
   *  @function create
   *  @memberof TSC.TableOfContentsController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.XmpModel} xmpModel
   *  @param {TSC.MediaList} mediaList
   *  @param {TSC.ProgressBarControlView} progressBarControlView
   *  @param {TSC.playerConfiguration} playerConfiguration
   *  @return new TableOfContentsController instance
   */
  create: TableOfContentsController
};

var SYNC_TOLERANCE_TIME_IN_SECONDS = .5;
var BUFFER_TIME_OFFSET_IN_SECONDS = 1;

/**
 * @memberof TSC
 * @class AudioDescriptionTrackView
 * @classdesc Audio Description Track
 *  @param {Object} $container - jQuery element to add audio description track audio dom.
 *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
 *  @param {String} audioDescriptionMediaSrc - Audio source string
 */
var AudioDescriptionTrackView = function AudioDescriptionTrackView($container, mediaElement, audioDescriptionMediaSrc) {
  var _audioDescriptionAudioEl = null;
  var _audioTrackEnabled = false;
  var _videoIsSeeking = false;
  var _videoIsBuffering = false;
  var _lastBufferedVideoTime = 0;
  var onAudioError = function onAudioError() {
    destroy();
    $container.trigger(events.AudioDescription.Failed);
  };
  var createView = function createView() {
    var _markup = templateGenerator.generateAudioDescriptionTrackMarkup(audioDescriptionMediaSrc);
    $container.find('.audio-description-track-wrapper').html(_markup);
    _audioDescriptionAudioEl = $container.find('.audio-description-track')[0];
  };
  var syncAudioTimeWithVideoTime = function syncAudioTimeWithVideoTime() {
    if (!isNaN(_audioDescriptionAudioEl.duration)) {
      _audioDescriptionAudioEl.currentTime = mediaElement.currentTime;
    }
  };
  var syncAudioVolumeWithVideoVolume = function syncAudioVolumeWithVideoVolume() {
    _audioDescriptionAudioEl.volume = mediaElement.muted ? 0 : mediaElement.volume;
  };
  var syncAudioPlaybackRateWithVideoPlaybackRate = function syncAudioPlaybackRateWithVideoPlaybackRate() {
    _audioDescriptionAudioEl.playbackRate = mediaElement.playbackRate;
    _audioDescriptionAudioEl.defaultPlaybackRate = mediaElement.playbackRate;
  };
  var pauseAudioDescription = function pauseAudioDescription() {
    _audioDescriptionAudioEl.pause();
  };
  var onVideoPlaying = function onVideoPlaying() {
    syncAudioTimeWithVideoTime();
  };
  var onVideoStartSeeking = function onVideoStartSeeking() {
    _videoIsSeeking = true;

    // some browsers do not fire 'waiting' event when seeking and no data is buffered
    // manually fire this to make sure player pauses audio and checks for video buffering
    onWaiting();
    _audioDescriptionAudioEl.volume = 0;
    pauseAudioDescription();
  };
  var onVideoSeeked = function onVideoSeeked() {
    _videoIsSeeking = false;
    syncAudioTimeWithVideoTime();
  };
  var playAudioDescriptionIfVideoIsPlaying = function playAudioDescriptionIfVideoIsPlaying() {
    if (mediaElement.paused || _videoIsBuffering) {
      return;
    }
    var promise = _audioDescriptionAudioEl.play();
    if (promise !== undefined) {
      promise["catch"](function () {}); // eslint-disable-line
    }
  };
  var onRateChange = function onRateChange() {
    syncAudioPlaybackRateWithVideoPlaybackRate();
    syncAudioTimeWithVideoTime();
  };
  var onAudioTrackSeeked = function onAudioTrackSeeked() {
    if (_videoIsSeeking) {
      return;
    }
    var mediaTimeDelta = Math.abs(mediaElement.currentTime - _audioDescriptionAudioEl.currentTime);
    if (mediaTimeDelta >= SYNC_TOLERANCE_TIME_IN_SECONDS) {
      syncAudioTimeWithVideoTime();
    } else {
      syncAudioVolumeWithVideoVolume();
      playAudioDescriptionIfVideoIsPlaying();
    }
  };
  var onAudioDescriptionControlChange = function onAudioDescriptionControlChange(e, eventData) {
    e.preventDefault();
    _audioTrackEnabled = eventData.audioDescriptionEnabled;
    _audioDescriptionAudioEl.muted = !_audioTrackEnabled;
    syncAudioTimeWithVideoTime();
    playAudioDescriptionIfVideoIsPlaying();
  };
  var onWaiting = function onWaiting() {
    _videoIsBuffering = true;
    if (!_audioDescriptionAudioEl.paused) {
      pauseAudioDescription();
    }
  };
  var onTimeUpdate = function onTimeUpdate() {
    if (_videoIsBuffering) {
      var timeDiff = Math.abs(mediaElement.currentTime - _lastBufferedVideoTime);
      if (timeDiff > BUFFER_TIME_OFFSET_IN_SECONDS) {
        _videoIsBuffering = false;
        syncAudioTimeWithVideoTime();
      }
    } else {
      _lastBufferedVideoTime = mediaElement.currentTime;
    }
  };
  var initializeHandlers = function initializeHandlers() {
    _audioDescriptionAudioEl.addEventListener('error', onAudioError);
    _audioDescriptionAudioEl.addEventListener('seeked', onAudioTrackSeeked);
    _audioDescriptionAudioEl.addEventListener('pause', syncAudioTimeWithVideoTime);
    $container.on(events.AudioDescription.Changed, onAudioDescriptionControlChange);
    mediaElement.addEventListener('playing', onVideoPlaying);
    mediaElement.addEventListener('seeking', onVideoStartSeeking);
    mediaElement.addEventListener('seeked', onVideoSeeked);
    mediaElement.addEventListener('pause', pauseAudioDescription);
    mediaElement.addEventListener('volumechange', syncAudioVolumeWithVideoVolume);
    mediaElement.addEventListener('ratechange', onRateChange);
    mediaElement.addEventListener('ended', pauseAudioDescription);
    mediaElement.addEventListener('waiting', onWaiting);
    mediaElement.addEventListener('timeupdate', onTimeUpdate);
  };
  var destroy = function destroy() {
    _audioDescriptionAudioEl.removeEventListener('error', onAudioError);
    _audioDescriptionAudioEl.removeEventListener('seeked', onAudioTrackSeeked);
    _audioDescriptionAudioEl.removeEventListener('pause', syncAudioTimeWithVideoTime);
    $container.off(events.AudioDescription.Changed, onAudioDescriptionControlChange);
    mediaElement.removeEventListener('playing', onVideoPlaying);
    mediaElement.removeEventListener('seeking', onVideoStartSeeking);
    mediaElement.removeEventListener('seeked', syncAudioTimeWithVideoTime);
    mediaElement.removeEventListener('pause', pauseAudioDescription);
    mediaElement.removeEventListener('volumechange', syncAudioVolumeWithVideoVolume);
    mediaElement.removeEventListener('ratechange', onRateChange);
    mediaElement.removeEventListener('ended', pauseAudioDescription);
    mediaElement.removeEventListener('waiting', onWaiting);
    mediaElement.removeEventListener('timeupdate', onTimeUpdate);
  };
  createView();
  initializeHandlers();
  syncAudioVolumeWithVideoVolume();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var AudioDescriptionTrackView$1 = {
  /**
   *  Factory method that returns a new AudioDescriptionTrackView object.
   *  @function create
   *  @memberof TSC.AudioDescriptionTrackView
   *  @param {Object} $container - jQuery element to add audio description track audio dom.
   *  @param {Object} mediaElement - html5 media DOM element (or wrapper presenting same interface)
   *  @param {String} audioDescriptionMediaSrc - Audio source string
   *  @static
   *  @return new AudioDescriptionTrackView instance
   */
  create: AudioDescriptionTrackView
};

/**
 * @memberof TSC
 * @class AudioDescriptionController
 * @classdesc Controller for managing XMP features
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {string} audioDescriptionMediaSrc - The source url for the audio description track
 *
 */
var AudioDescriptionController = function AudioDescriptionController($container, mediaView, audioDescriptionMediaSrc) {
  var hasAudioDescription = !!audioDescriptionMediaSrc;
  if (!hasAudioDescription) {
    throw new Error('Attempted to create audio description controller with no audio description');
  }
  var _audioDescriptionControlView;
  var _audioDescriptionTrackView;
  var setupFeatures = function setupFeatures() {
    _audioDescriptionControlView = AudioDescriptionControlView$1.create($container);
    _audioDescriptionTrackView = AudioDescriptionTrackView$1.create($container, mediaView.mediaElement, audioDescriptionMediaSrc);
  };
  var destroy = function destroy() {
    _audioDescriptionControlView && _audioDescriptionControlView.destroy();
    _audioDescriptionTrackView && _audioDescriptionTrackView.destroy();
  };
  setupFeatures();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var AudioDescriptionController$1 = {
  /**
   *  Factory method that returns a new AudioDescriptionController.
   *  @function create
   *  @memberof TSC.AudioDescriptionController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {string} audioDescriptionMediaSrc - The source url for the audio description track
   *  @return new AudioDescriptionController instance
   */
  create: AudioDescriptionController
};

var ConfirmOpenUrlView = function ConfirmOpenUrlView($container, url, newWindow) {
  var _$view;
  var _$externalLinkReplayButton;
  var _$externalLinkVisitButton;
  var onConfirmHandler = function onConfirmHandler() {
    $container.trigger(events.ExternalLinkView.Clicked);
    var windowTarget = newWindow === true ? '_blank' : '_top';
    windowWrapper.open(url, windowTarget);
  };
  var onReplay = function onReplay() {
    $container.trigger(events.ExternalLinkView.Closed);
    $container.trigger(events.Modals.Closed);
    $container.trigger(events.Media.Replay);
    destroy();
  };
  var createView = function createView() {
    _$view = $container.find('.open-external-link');
    _$view.html(templateGenerator.generateOpenExternalLinkMarkup(url));
    _$externalLinkReplayButton = _$view.find('.open-external-link-replay');
    _$externalLinkVisitButton = _$view.find('.open-external-link-open');
    bindEvents();
    $container.trigger(events.Modals.Open);
    $container.trigger(events.ExternalLinkView.Open);
    _$view.show();
  };
  var bindEvents = function bindEvents() {
    _$externalLinkReplayButton.on('click', onReplay);
    _$externalLinkVisitButton.on('click', onConfirmHandler);
  };
  var destroy = function destroy() {
    _$externalLinkReplayButton.off('click', onReplay);
    _$externalLinkVisitButton.off('click', onConfirmHandler);
    _$view.empty();
    _$view.hide();
  };
  createView();
};

/**
 *  Factory method that returns a new ConfirmOpenUrlView object.
 *  @function create
 *  @memberof TSC.ConfirmOpenUrlView
 *  @static
 *  @param {Object} $container - jQuery element that contains a .open-external-link where the view will be injected
 *  @param {String} url - URL to open if confirmed
 *  @param {Boolean} newWindow - Open URL in new window
 *  @return new ConfirmOpenUrlView instance
 */
var ConfirmOpenUrlView$1 = {
  create: ConfirmOpenUrlView
};

var endActionType = Object.freeze({
  notAvailable: 'notAvailable',
  loop: 'loop',
  jumpToTimeAndPlay: 'jumpToTime',
  jumpToTImeAndStop: 'jumpToTimeAndStop',
  showReplayControls: 'showReplayControls',
  hideReplayControls: 'hideReplayControls',
  openUrl: 'openUrl',
  openUrlInNewWindow: 'openUrlInNewWindow'
});

/**
 * @memberof TSC
 * @class EndActionsController
 * @classdesc Controller for managing XMP features
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.ProgressBarControlView} progressBarControlView
 * @param {TSC.BeforeAfterPlayControlsView} beforeAfterPlayControlsView
 *
 */
var EndActionsController = function EndActionsController($container, mediaView, progressBarControlView, beforeAfterPlayControlsView) {
  var _processingEndOfVideo = false;
  var getScrubbing = function getScrubbing() {
    return progressBarControlView ? progressBarControlView.scrubbing : false;
  };
  var pause = function pause() {
    mediaView.mediaElement && mediaView.mediaElement.pause();
  };
  var replayVideo = function replayVideo(time, playAfterSeek) {
    if (mediaView.type === mediaViewType.playlist) {
      mediaView.reshowVideoAfterClickToReplay();
    } else {
      $container.trigger(events.Media.SeekToTime, {
        time: time,
        playAfterSeek: playAfterSeek
      });
    }
  };
  var showClickToReplay = function showClickToReplay() {
    beforeAfterPlayControlsView.showVideoClickToReplayLink();
  };
  var onVideoReplayHandler = function onVideoReplayHandler(e, eventData) {
    var replayTime = eventData && eventData.time || 0;
    var playAfterSeek = eventData && eventData.playAfterSeek !== undefined ? eventData.playAfterSeek : true;
    replayVideo(replayTime, playAfterSeek);
  };
  var onVideoEnd = function onVideoEnd() {
    var isPlaybackEnded = !mediaView || mediaView.processVideoEnd();
    $container.trigger(events.Media.End, {
      isPlaybackEnded: isPlaybackEnded
    });
    if (isPlaybackEnded) {
      pause();
      executeEndAction($container, replayVideo, showClickToReplay);
    }
  };
  var processEndOfMedia = function processEndOfMedia() {
    _processingEndOfVideo = true;
    progressBarControlView.updateQuizMarkers();
    pause();
    onVideoEnd();
    _processingEndOfVideo = false;
  };
  var onVideoTimeUpdate = function onVideoTimeUpdate() {
    // check for duration equal zero to fix issue seen on some Android devices
    if (mediaView.mediaElement.duration === 0) {
      return;
    }
    var atVideoEndTime = Number(mediaView.mediaElement.currentTime.toFixed(2)) >= Number(mediaView.mediaElement.duration.toFixed(2));
    if (!getScrubbing() && atVideoEndTime && !_processingEndOfVideo) {
      processEndOfMedia();
    }
  };
  var bindToEvents = function bindToEvents() {
    $container.on(events.Scrubbing.Ended, onVideoTimeUpdate);
    $container.on(events.Media.Replay, onVideoReplayHandler);
    var eventsToBind = {
      timeupdate: onVideoTimeUpdate
    };
    mediaView.mediaWrapper.on(eventsToBind);
  };
  var unbindToEvents = function unbindToEvents() {
    $container.off(events.Scrubbing.Ended, onVideoTimeUpdate);
    $container.off(events.Media.Replay, onVideoReplayHandler);
    var eventsToBind = {
      timeupdate: onVideoTimeUpdate
    };
    mediaView.mediaWrapper.off(eventsToBind);
  };
  var destroy = function destroy() {
    unbindToEvents();
  };
  bindToEvents();
  onVideoTimeUpdate();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var getEndActionType = function getEndActionType() {
  var xmpEndActionType = playerConfiguration.getEndActionType();
  if (xmpEndActionType !== undefined) {
    var xmpEndActionTypeLowerCase = xmpEndActionType.toLowerCase();
    var endActionParam = playerConfiguration.getEndActionParam();
    switch (xmpEndActionTypeLowerCase) {
      case 'loop':
        {
          return endActionType.loop;
        }
      case 'stop':
        {
          if (endActionParam === 'false' || endActionParam === '0') {
            return endActionType.hideReplayControls;
          }
          return endActionType.showReplayControls;
        }
      case 'jumptotime':
        {
          return endActionType.jumpToTimeAndPlay;
        }
      case 'jumptotimeandstop':
        {
          return endActionType.jumpToTImeAndStop;
        }
      case 'jumptourl':
        {
          return endActionType.openUrl;
        }
      case 'jumptourlnew':
        {
          return endActionType.openUrlInNewWindow;
        }
      default:
        {
          return endActionType.notAvailable;
        }
    }
  }
  return endActionType.notAvailable;
};
var executeSeekAction = function executeSeekAction(onReplayHandler, playAfterSeek) {
  var seekTime = parseFloat(playerConfiguration.getEndActionParam());
  var seekTimeInSeconds = !seekTime ? 0 : seekTime / 1000;
  onReplayHandler(seekTimeInSeconds, playAfterSeek);
};
var displayConfirmOpenUrlView = function displayConfirmOpenUrlView($localContainer, inNewWindow) {
  var urlString = '' + playerConfiguration.getEndActionParam();
  ConfirmOpenUrlView$1.create($localContainer, urlString, inNewWindow);
};
var executeEndAction = function executeEndAction($localContainer, replayVideoHandler, showReplayControlsHandler) {
  var type = getEndActionType();
  if (type === endActionType.notAvailable) {
    return;
  }
  switch (type) {
    case endActionType.loop:
      {
        executeSeekAction(replayVideoHandler, true);
        break;
      }
    case endActionType.jumpToTimeAndPlay:
      {
        executeSeekAction(replayVideoHandler, true);
        break;
      }
    case endActionType.jumpToTImeAndStop:
      {
        executeSeekAction(replayVideoHandler, false);
        break;
      }
    case endActionType.showReplayControls:
      {
        showReplayControlsHandler();
        break;
      }
    case endActionType.openUrl:
      {
        displayConfirmOpenUrlView($localContainer, false);
        break;
      }
    case endActionType.openUrlInNewWindow:
      {
        displayConfirmOpenUrlView($localContainer, true);
        break;
      }
  }
};
var EndActionsController$1 = {
  /**
   *  Factory method that returns a new EndActionsController.
   *  @function create
   *  @memberof TSC.EndActionsController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.ProgressBarControlView} progressBarControlView
   *  @param {TSC.BeforeAfterPlayControlsView} beforeAfterPlayControlsView
   *  @return new EndActionsController instance
   */
  create: EndActionsController,
  getEndActionType: getEndActionType,
  executeEndAction: executeEndAction
};

var OVERLAY_TRANSPARENCY = 0.7;

/**
 * @memberof TSC
 * @class BubbleView
 * @classdesc Bubble View
 * @param {String} containerId - id for container element
 */
var BubbleView = function BubbleView(containerId) {
  var _viewIsMinimized = false;
  var _windowPadding = 2;
  var _viewBottom = 48;
  var _minArrowDistanceFromEdge = 9;
  var _ignoreBreakpoints = false;
  var _containerId = containerId;
  var _overlayId = '.tsc_overlay';
  var _arrowBubbleClass = '.chat-bubble-arrow';
  var _overlayMarkup = '<div class="tsc_overlay"></div>';
  var _topContainer = null;
  var _$container = null;
  var _$overlay = null;
  var _$arrowBubble = null;
  var clickCapture = function clickCapture(event) {
    event.stopPropagation();
  };
  var isDesktopBreakpoint = function isDesktopBreakpoint() {
    return _topContainer.hasClass('small-desktop-width') && _topContainer.hasClass('small-desktop-height');
  };
  var cacheElements = function cacheElements() {
    _topContainer = _topContainer || $(_containerId).parents('.' + cssClasses.smartPlayerNamespace);
    _$container = _$container || $(_containerId);
    _$overlay = _$overlay || $(_overlayId);
    _$arrowBubble = _$arrowBubble || $(_arrowBubbleClass);
  };
  var minimizeView = function minimizeView() {
    _viewIsMinimized = true;
    _$overlay.css('opacity', 0.0);
  };
  var maximizeView = function maximizeView() {
    _viewIsMinimized = false;
    _$overlay.css('opacity', OVERLAY_TRANSPARENCY);
  };
  var showView = function showView(ignoreBreakpoints) {
    _ignoreBreakpoints = ignoreBreakpoints === undefined ? false : ignoreBreakpoints;
    cacheElements();
    _$container.css('opacity', 1);
    _$overlay.css('opacity', OVERLAY_TRANSPARENCY);
    _$container.on('click', clickCapture);
  };
  var hideView = function hideView() {
    _$container.css('opacity', 0);
    _$overlay.css('opacity', 0);
    _$container.off('click', clickCapture);
  };
  var updateViewPosition = function updateViewPosition() {
    cacheElements();
    if (_ignoreBreakpoints || isDesktopBreakpoint()) {
      _$container.css('bottom', _viewBottom + 'px');
    } else {
      _$container.css('bottom', '0px');
    }
  };
  var removeView = function removeView(destroyOverlay) {
    if (destroyOverlay) {
      _$overlay.remove();
    }
    _$container.remove();
    _topContainer = null;
    _$container = null;
    _$overlay = null;
    _$arrowBubble = null;
  };
  var getOverlayMarkup = function getOverlayMarkup() {
    return _overlayMarkup;
  };
  var setBottomOffset = function setBottomOffset(bottom) {
    _viewBottom = bottom;
  };
  var pointAt = function pointAt(xPos) {
    if (_$container === null) {
      return;
    }
    var playerWidth = _topContainer.outerWidth(true);
    var viewWidth = _$container.outerWidth(true);
    var halfViewWidth = viewWidth / 2;
    var borderWidth = _$arrowBubble.css('border-left-width').replace(/px/, '');
    var arrowWidth = borderWidth * 2;
    var quizXPos;
    var arrowPos;

    // left bounds
    if (!_ignoreBreakpoints && !isDesktopBreakpoint()) {
      quizXPos = 0;
      arrowPos = 0;
    } else if (xPos - (halfViewWidth + _windowPadding) < 0) {
      quizXPos = _windowPadding;
      arrowPos = xPos - _windowPadding - borderWidth;
      // right bounds
    } else if (xPos + halfViewWidth + _windowPadding > playerWidth) {
      quizXPos = playerWidth - (viewWidth + _windowPadding);
      arrowPos = xPos - quizXPos - borderWidth;
      // center on point
    } else {
      quizXPos = xPos - halfViewWidth;
      arrowPos = halfViewWidth - borderWidth;
    }
    _$container.css('left', quizXPos);
    _$arrowBubble.css('left', arrowPos);
    if (arrowPos < _minArrowDistanceFromEdge || viewWidth - arrowPos - arrowWidth < _minArrowDistanceFromEdge) {
      _$arrowBubble.hide();
    } else {
      _$arrowBubble.show();
    }
  };
  return Object.defineProperties({
    showView: showView,
    hideView: hideView,
    maximizeView: maximizeView,
    minimizeView: minimizeView,
    updateViewPosition: updateViewPosition,
    removeView: removeView,
    getOverlayMarkup: getOverlayMarkup,
    setBottomOffset: setBottomOffset,
    pointAt: pointAt
  }, {
    viewIsMinimized: {
      get: function get() {
        return _viewIsMinimized;
      }
    }
  });
};
var BubbleView$1 = {
  /**
   *  Factory method that returns a new BubbleView object.
   *  @function create
   *  @memberof TSC.BubbleView
   *  @param {String} containerId - id for container element
   *  @static
   *  @return new BubbleView instance
   */
  create: BubbleView
};

/**
 * @memberof TSC
 * @class rationaleActionType
 * @classdesc Rationale Action Types
 */
var rationaleActionType = Object.defineProperties({}, {
  /**
   *  @public
   *  @readonly
   *  @static
   *  @memberof TSC.rationaleActionType
   *  @property {String} CONTINUE - continue type
   */
  CONTINUE: {
    value: 'continue'
  },
  /**
   *  @public
   *  @readonly
   *  @static
   *  @memberof TSC.rationaleActionType
   *  @property {String} LOCATION - location type
   */
  LOCATION: {
    value: 'location'
  },
  /**
   *  @public
   *  @readonly
   *  @static
   *  @memberof TSC.rationaleActionType
   *  @property {String} JUMP_TO_TIME - jump to time type
   */
  JUMP_TO_TIME: {
    value: 'jumpToTIme'
  }
});

var CHECK_SVG = '<svg id="Correct" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42"><style>.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#97C93D;} .st1{fill:#82AD40;} .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><path class="st0" d="M21 39c-9.9 0-18-8.1-18-18S11.1 3 21 3s18 8.1 18 18-8.1 18-18 18z"/><path class="st1" d="M21 5c8.8 0 16 7.2 16 16s-7.2 16-16 16S5 29.8 5 21 12.2 5 21 5m0-4C10 1 1 10 1 21s9 20 20 20 20-9 20-20S32 1 21 1z"/><path class="st2" d="M30 16.6l-11.2 12c-.8.8-1.8.3-2.3-.2l-4.8-5.9c-.5-.7-.4-1.6.3-2.2.7-.5 1.6-.4 2.1.3l3.7 4.5 10-10.8c.6-.6 1.5-.6 2.1 0 .7.7.7 1.7.1 2.3z"/></svg>';
var INCORRECT_SVG = '<svg id="Wrong" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42"><style>.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EF4546;} .st1{fill:#B93130;} .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><path class="st0" d="M21 39c-9.9 0-18-8.1-18-18S11.1 3 21 3s18 8.1 18 18-8.1 18-18 18z"/><path class="st1" d="M21 5c8.8 0 16 7.2 16 16s-7.2 16-16 16S5 29.8 5 21 12.2 5 21 5m0-4C10 1 1 10 1 21s9 20 20 20 20-9 20-20S32 1 21 1z"/><path class="st2" d="M24.2 21l4.1 4.1c.9.9.9 2.4 0 3.3-.9.9-2.4.9-3.3 0l-4-4.2-4 4c-.9.9-2.3.9-3.2 0s-.9-2.3 0-3.2l4-4-4.1-4.1c-.9-.9-.9-2.4 0-3.3.9-.9 2.4-.9 3.3 0l4.1 4.1 4-4c.9-.9 2.3-.9 3.2 0 .9.9.9 2.3 0 3.2L24.2 21z"/></svg>';
var CORRECT_GLYPH_DATA_URL = 'data:image/svg+xml,' + window.encodeURIComponent(CHECK_SVG);
var INCORRECT_GLYPH_DATA_URL = 'data:image/svg+xml,' + window.encodeURIComponent(INCORRECT_SVG);
var ACTIVE_QUESTION_CLASS = 'active-question-item';
var ACTIVE_FEEDBACK_CLASS = 'active-feedback-item';
var CORRECT_ANSWER_TEXT = localizationStrings.getPlayerString(playerStringNames.txtCorrectAnswer);
var YOUR_ANSWER_TEXT = localizationStrings.getPlayerString(playerStringNames.txtYourAnswer);

/**
 * @memberof TSC
 * @class AnswersView
 * @classdesc Answers View
 */
var AnswersView = function AnswersView($container, question, showResults) {
  var _$window = $(window);
  var _$textInput = null;
  var getUserResponse = function getUserResponse() {
    switch (question.type) {
      case questionType.CHOICE:
        return $container.find('input[name=multiple-choice]:checked').val();
      case questionType.FILL_IN:
        return $container.find('input').val();
      case questionType.SHORT:
        return $container.find('textarea').val().replace(/^[ \t]+|[ \t]+$/, '');
    }
  };
  var displayResponseFillInResults = function displayResponseFillInResults() {
    if (!question.isGraded) {
      return;
    }
    var $correctImage = $('<img src=\'' + CORRECT_GLYPH_DATA_URL + '\' class=\'image-fill-in-the-blank-feedback\' alt=\'' + localizationStrings.getPlayerString(playerStringNames.txtCorrectString) + '\' />');
    var $incorrectImage = $('<img src=\'' + INCORRECT_GLYPH_DATA_URL + '\' class=\'image-fill-in-the-blank-feedback\' alt=\'' + localizationStrings.getPlayerString(playerStringNames.txtIncorrectString) + '\' />');
    if (question.isResponseCorrect) {
      $container.find('img.feedback-placeholder').replaceWith($correctImage);
    } else {
      $container.find('img.feedback-placeholder').replaceWith($incorrectImage);
    }
  };
  var getCorrectAnswerIndex = function getCorrectAnswerIndex() {
    var numberAnswers = question.answers.length;
    var correctAnswerBitshifted = question.correctAnswer;
    for (var i = 0; i < numberAnswers; i++) {
      /*eslint no-bitwise: "off"*/
      if (1 << i === Number(correctAnswerBitshifted)) {
        return i;
      }
    }
    return -1;
  };
  var displayChoiceResults = function displayChoiceResults() {
    var correctAnswerIndex;
    var $placeHolderImgEls;
    var $userResponseInputImageEl;
    var $correctResponseInputImageEl;
    var $correctImage;
    var $incorrectImage;
    var answerIndex = question.userResponse;
    var $labelEls = $container.find('label');
    $labelEls.removeClass(ACTIVE_QUESTION_CLASS);
    $labelEls.addClass(ACTIVE_FEEDBACK_CLASS);
    if (showResults && question.isGraded) {
      correctAnswerIndex = getCorrectAnswerIndex();
      $placeHolderImgEls = $container.find('label img');
      $userResponseInputImageEl = $container.find('label:eq(' + answerIndex + ') img');
      $correctResponseInputImageEl = $container.find('label:eq(' + correctAnswerIndex + ') img');
      $correctImage = $('<img src=\'' + CORRECT_GLYPH_DATA_URL + '\' class=\'image-feedback\' alt=\'' + localizationStrings.getPlayerString(playerStringNames.txtCorrectString) + '\' />');
      $incorrectImage = $('<img src=\'' + INCORRECT_GLYPH_DATA_URL + '\' class=\'image-feedback\' alt=\'' + localizationStrings.getPlayerString(playerStringNames.txtIncorrectString) + '\' />');
      $placeHolderImgEls.removeClass('feedback-placeholder');
      if (answerIndex === correctAnswerIndex) {
        $userResponseInputImageEl.replaceWith($correctImage);
        $correctImage.css('opacity', 0);
        $correctImage.animate({
          opacity: 1
        }, 200);
      } else {
        $correctResponseInputImageEl.replaceWith($correctImage);
        $correctImage.css('opacity', 0);
        $correctImage.animate({
          opacity: 1
        }, 200);
        $userResponseInputImageEl.replaceWith($incorrectImage);
        $incorrectImage.css('opacity', 0);
        $incorrectImage.animate({
          opacity: 1
        }, 200);
      }
    }
    $container.find('input').hide();
    if (answerIndex !== undefined) {
      $container.find('label:eq(' + answerIndex + ')').addClass('picked-quiz-item');
    }
  };
  var disableInput = function disableInput() {
    var $inputEls = null;
    switch (question.type) {
      case questionType.CHOICE:
      case questionType.FILL_IN:
        $inputEls = $container.find('input');
        break;
      case questionType.SHORT:
        $inputEls = $container.find('textarea');
        break;
    }
    if ($inputEls) {
      $inputEls.attr('disabled', true);
    }
  };
  var focusFirstInput = function focusFirstInput() {
    $container.find(".".concat(cssClasses.focusableAnswerInput)).focus();
  };
  var displayResults = function displayResults() {
    switch (question.type) {
      case questionType.CHOICE:
        displayChoiceResults();
        break;
      case questionType.FILL_IN:
        displayResponseFillInResults();
        break;
    }
    disableInput();
  };
  var getAnswersMarkup = function getAnswersMarkup(autoFocus) {
    if (deviceInfo.isIOS() || deviceInfo.isAndroid()) {
      autoFocus = false;
    }
    switch (question.type) {
      case questionType.CHOICE:
        return templateGenerator.generateChoiceAnswersMarkup(question.text, question.answers, question.userResponse);
      case questionType.FILL_IN:
        return templateGenerator.generateFillInTheBlankAnswerMarkup(question.text, question.userResponse, autoFocus);
      case questionType.SHORT:
        return templateGenerator.generateShortAnswerMarkup(question.text, question.userResponse, autoFocus);
      default:
        log.logException('Answers-view: unsupported question type (' + question.type + ')');
    }
  };
  var destroy = function destroy() {
    if (!showResults && deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
      _$window.off('resize', viewHelper.scrollActiveElementIntoView);
    }
    if (_$textInput && (question.type === questionType.FILL_IN || question.type === questionType.SHORT) && (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid())) {
      _$textInput.off('focus keydown', viewHelper.scrollIntoView);
    }
  };
  var getTextResponseSuffix = function getTextResponseSuffix(userAnsweredQuestion) {
    if (question.isGraded) {
      if (!userAnsweredQuestion) {
        return localizationStrings.getPlayerString(playerStringNames.accessResultsLabelNoResponseGradedSuffix);
      } else if (question.isResponseCorrect) {
        return localizationStrings.getPlayerString(playerStringNames.accessResultsLabelCorrectSuffix);
      }
      return localizationStrings.getPlayerString(playerStringNames.accessResultsLabelIncorrectSuffix);
    } else if (!userAnsweredQuestion) {
      return localizationStrings.getPlayerString(playerStringNames.accessResultsLabelNoResponseSuffix);
    }
    return '';
  };
  var getUsersAnswer = function getUsersAnswer(userAnsweredQuestion) {
    if (question.type === questionType.CHOICE) {
      return userAnsweredQuestion && question.answers[question.userResponse].text;
    }
    return question.userResponse;
  };
  var getCorrectAnswerOrEmptyString = function getCorrectAnswerOrEmptyString() {
    if (question.isGraded && question.type === questionType.CHOICE) {
      return question.answers[getCorrectAnswerIndex()].text;
    }
    return '';
  };
  var getCorrectAnswerText = function getCorrectAnswerText() {
    var userAnsweredQuestion = !(question.userResponse === null || typeof question.userResponse === 'undefined');
    var responseSuffix = getTextResponseSuffix(userAnsweredQuestion);
    var usersAnswer = getUsersAnswer(userAnsweredQuestion);
    var correctAnswer = getCorrectAnswerOrEmptyString();
    var fullAnswerText = '';
    if (correctAnswer) {
      fullAnswerText = CORRECT_ANSWER_TEXT + correctAnswer;
    }
    if (userAnsweredQuestion) {
      fullAnswerText += correctAnswer ? ' - ' : '';
      fullAnswerText += YOUR_ANSWER_TEXT + usersAnswer;
    }
    fullAnswerText += fullAnswerText && responseSuffix ? ' - ' : '';
    fullAnswerText += responseSuffix;
    return fullAnswerText;
  };
  var setupAnswers = function setupAnswers() {
    if (showResults) {
      displayResults();
    } else {
      if (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
        _$window.on('resize', viewHelper.scrollActiveElementIntoView);
      }

      // remove hover css when device is touch screen
      if (question.type === questionType.CHOICE && deviceInfo.isTouchInterface()) {
        $container.find('.multiple-choice').removeClass(ACTIVE_QUESTION_CLASS);
      }
      _$textInput = $container.find('input[type=text], textarea');
      if (_$textInput && (question.type === questionType.FILL_IN || question.type === questionType.SHORT)) {
        if (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
          _$textInput.on('focus keydown', viewHelper.scrollIntoView);
        }
      }
    }
  };
  var isTextInputOrAreaFocused = function isTextInputOrAreaFocused() {
    return _$textInput && _$textInput.length > 0 && _$textInput.is(':focus');
  };
  var createView = function createView() {
    var answersMarkup = getAnswersMarkup();
    if (answersMarkup) {
      $container.html(answersMarkup);
    }
    $container.find('.multiple-choice > input').focus(function () {
      $(this).parent().addClass('highlight-background');
    }).blur(function () {
      $(this).parent().removeClass('highlight-background');
    });
  };
  createView();
  setupAnswers();
  focusFirstInput();
  return {
    getUserResponse: getUserResponse,
    destroy: destroy,
    getCorrectAnswerText: getCorrectAnswerText,
    isTextInputOrAreaFocused: isTextInputOrAreaFocused
  };
};
var AnswersView$1 = {
  /**
   *  Factory method that returns a new QuestionView object.
   *  @function create
   *  @memberof TSC.AnswersView
   *  @static
   *  @return new AnswersView instance
   */
  create: AnswersView
};

var QUESTION_CORRECT_TEXT_CLASS = '.question-correct-text';
var QUESTION_INCORRECT_TEXT_CLASS = '.question-incorrect-text';

/**
 * @memberof TSC
 * @class QuestionView
 * @classdesc Question View
 * @params {Object} $questionTextContainer - jquery wrapper for question text container element
 * @params {Object} $questionGradedStatusContainer - jquery wrapper for question graded status container element
 * @params {Object} $feedbackContainer - jquery wrapper for feedback text container element
 * @params {Object} $answersContainer - jquery wrapper for answers container element
 * @params {TSC.Question} question - Question model for this view.
 * @params {Boolean} showResults - show results for question.
 */
var QuestionView = function QuestionView($questionTextContainer, $questionGradedStatusContainer, $feedbackContainer, $answersContainer, question, showResults) {
  var _answersView;
  var _feedbackContextMarkup = templateGenerator.generateQuestionFeedbackContextMarkup(localizationStrings.getPlayerString(playerStringNames.accessQuestionFeedbackContext));
  var createView = function createView() {
    _answersView = AnswersView$1.create($answersContainer, question, showResults);
    $feedbackContainer.addClass('hide-element');
    var correctAnswerText = showResults ? _answersView.getCorrectAnswerText() : '';
    var questionTextMarkup = templateGenerator.generateQuestionTextMarkup(question.text, correctAnswerText);
    $questionTextContainer.html(questionTextMarkup);
    var questionGradedStatusMarkup = templateGenerator.generateQuestionGradedStatusMarkup();
    $questionGradedStatusContainer.html(questionGradedStatusMarkup);
  };
  var showFeedbackTextIfAvailable = function showFeedbackTextIfAvailable() {
    var feedbackMarkup = null;
    question.feedback.forEach(function (feedback) {
      if (question.isResponseCorrect && feedback.reason === 'correct') {
        feedbackMarkup = feedback.markupText;
      } else if (!question.isResponseCorrect && feedback.reason === 'incorrect') {
        feedbackMarkup = feedback.markupText;
      }
    });
    if (feedbackMarkup) {
      $feedbackContainer.html(_feedbackContextMarkup + feedbackMarkup);
      $feedbackContainer.removeClass('hide-element');
    }
  };
  var setupView = function setupView() {
    if (showResults && question.isGraded) {
      showFeedbackTextIfAvailable();
      if (question.isResponseCorrect) {
        $questionGradedStatusContainer.find(QUESTION_CORRECT_TEXT_CLASS).removeClass('hide-element');
      } else {
        $questionGradedStatusContainer.find(QUESTION_INCORRECT_TEXT_CLASS).removeClass('hide-element');
      }
    }
  };
  createView();
  setupView();
  return {
    isTextInputOrAreaFocused: _answersView.isTextInputOrAreaFocused,
    destroy: _answersView.destroy,
    getUserResponse: _answersView.getUserResponse
  };
};
var QuestionView$1 = {
  /**
   *  Factory method that returns a new QuestionView object.
   *  @function create
   *  @memberof TSC.QuestionView
   *  @static
   *  @return new QuestionView instance
   */
  create: QuestionView
};

var SCREEN_READER_ALERT_REMOVAL_TIMEOUT = 1000;
var INIT_QUESTION_SET_TIMEOUT = 10;
var PEEK_AT_VIDEO_SHORT_CUT_KEYCODE = 72; // h key
var CONTAINER_CLASS = '.question-set-container';
var QUESTION_SET_CONTENT_CLASS = '.question-set-content';
var HIDE_CONTROL_CLASS = '.hide-quiz-button';
var SHOW_CONTROL_CLASS = '.show-quiz-button';
var PREV_CONTROL_CLASS = '.previous-button';
var NEXT_CONTROL_CLASS = '.next-button';
var SUBMIT_CONTROL_CLASS = '.submit-button';
var CONTINUE_CONTROL_CLASS = '.continue-button';
var QUESTION_COUNT_CLASS = '.question-count';
var QUESTION_GRADED_STATUS_CLASS = '.question-graded-status';
var QUESTION_CLASS = '.question-text';
var ANSWERS_CLASS = '.question-answers';
var FEEDBACK_CLASS = '.question-feedback';
var MINIMIZED_VIEW_CLASS = '.minimized-question-set-container';

/**
 * @memberof TSC
 * @class QuestionSetView
 * @param {Object} $container -- Container to add question set view.
 * @param {TSC.QuestionSet} questionSet -- Question Set model for view.
 * @param {Boolean} displayOverlay -- Display overlay.
 * @param {Boolean} mediaIsImage -- Media is an image.
 * @param {Boolean} showQuestionSetResults -- Show user results for question set.
 * @classdesc View for Question sets.
 */
var QuestionSetView = function QuestionSetView($container, questionSet, displayOverlay, mediaIsImage, showQuestionSetResults, quizTime) {
  var _$document = windowWrapper.getDocument(true);
  var _currentQuestionIndex = 0;
  var _$container = $container;
  var _startTimeForQuestion = 0;
  var _endTimeForQuestion = 0;
  var _currentQuestionView = null;
  var _initTimeoutId = null;
  var _alertScreenReaderTimeoutId = null;
  var _$questionSetContainer = null;
  var _$questionSetContent = null;
  var _$questionTextContainer = null;
  var _$answersContainer = null;
  var _$feedbackContainer = null;
  var _$questionCountContainer = null;
  var _$questionGradedStatusContainer = null;
  var _$hideControl = null;
  var _$showControl = null;
  var _$prevControl = null;
  var _$nextControl = null;
  var _$continueControl = null;
  var _$submitControl = null;
  var _$minimizedContainer = null;
  var _minimizedByKeyboardShortcut = false;
  var _superView = BubbleView$1.create(CONTAINER_CLASS);
  var _resolveInitPromise;
  var initPromise = new Promise$1(function (resolve) {
    _resolveInitPromise = resolve;
  });
  var alertScreenReader = function alertScreenReader(message) {
    var screenReaderAlertMarkup = templateGenerator.generateScreenReaderAlertMarkup(message);
    var $screenReaderAlert = $(screenReaderAlertMarkup);
    _$container.append($screenReaderAlert);
    _alertScreenReaderTimeoutId = setTimeout(function () {
      $screenReaderAlert.remove();
    }, SCREEN_READER_ALERT_REMOVAL_TIMEOUT);
  };
  var onHideQuizClick = function onHideQuizClick() {
    minimizeView();
  };
  var onShowQuizHandler = function onShowQuizHandler() {
    maximizeView();
  };
  var onKeyDownHandler = function onKeyDownHandler(e) {
    if (e && e.keyCode === PEEK_AT_VIDEO_SHORT_CUT_KEYCODE && !_currentQuestionView.isTextInputOrAreaFocused() && !_superView.viewIsMinimized) {
      _minimizedByKeyboardShortcut = true;
      _$document.on('keyup', onKeyUpHandler);
      minimizeView();
    }
  };
  var onKeyUpHandler = function onKeyUpHandler() {
    _minimizedByKeyboardShortcut = false;
    _$document.off('keyup', onKeyUpHandler);
    maximizeView();
  };
  var minimizeView = function minimizeView() {
    if (!_superView.viewIsMinimized) {
      $container.trigger(events.Quizzing.MinimizeUI);
      _$questionSetContent.addClass(cssClasses.hideElement);
      if (!_minimizedByKeyboardShortcut) {
        _$minimizedContainer.removeClass(cssClasses.hideElement);
      }
      viewHelper.removeFocusTrap();
      alertScreenReader(localizationStrings.getPlayerString(playerStringNames.accessQuizHidden));
      _superView.minimizeView();
    }
  };
  var maximizeView = function maximizeView() {
    if (_superView.viewIsMinimized) {
      $container.trigger(events.Quizzing.MaximizeUI);
      _$questionSetContent.removeClass(cssClasses.hideElement);
      _$minimizedContainer.addClass(cssClasses.hideElement);
      _superView.maximizeView();
      alertScreenReader(localizationStrings.getPlayerString(playerStringNames.accessQuizShown));
      $container.focus();
      viewHelper.trapFocus(_$questionSetContent);
    }
  };
  var isOnFirstQuestion = function isOnFirstQuestion() {
    return _currentQuestionIndex === 0;
  };
  var isOnLastQuestion = function isOnLastQuestion() {
    return _currentQuestionIndex === questionSet.questions.length - 1;
  };
  var showView = function showView() {
    _$questionSetContainer.removeClass('minimized');
    _superView.showView();
  };
  var hideView = function hideView() {
    _$questionSetContainer.addClass('minimized');
    _superView.hideView();
  };
  var startTrackingQuestionTime = function startTrackingQuestionTime() {
    _startTimeForQuestion = new Date().getTime();
  };
  var recordDurationOnQuestion = function recordDurationOnQuestion() {
    _endTimeForQuestion = new Date().getTime();
    var timeBetween = _endTimeForQuestion - _startTimeForQuestion;
    questionSet.questions[_currentQuestionIndex].attemptDuration += timeBetween;
  };
  var storeUserResponse = function storeUserResponse() {
    var userResponse = _currentQuestionView.getUserResponse();
    if (userResponse !== undefined && userResponse !== '') {
      questionSet.questions[_currentQuestionIndex].userResponse = userResponse;
    }
  };
  var saveQuestionUserInput = function saveQuestionUserInput() {
    if (showQuestionSetResults) {
      return;
    }
    storeUserResponse();
    recordDurationOnQuestion();
  };
  var lockResponses = function lockResponses() {
    if (questionSet.usesRationale) {
      questionSet.questions[_currentQuestionIndex].responseLocked = true;
    } else {
      questionSet.questions.forEach(function (question) {
        question.responseLocked = true;
      });
    }
  };
  var getFeedbackInfoForCurrentQuestion = function getFeedbackInfoForCurrentQuestion() {
    var actionType = rationaleActionType.CONTINUE;
    var feedback;
    if (questionSet.questions[_currentQuestionIndex].isGraded) {
      var feedbackReason = questionSet.questions[_currentQuestionIndex].isResponseCorrect ? 'correct' : 'incorrect';
      feedback = questionSet.questions[_currentQuestionIndex].getFeedbackForReason(feedbackReason);
      if (feedback !== null) {
        if (feedback.location !== undefined) {
          actionType = rationaleActionType.LOCATION;
        } else if (feedback.jumpToTime !== undefined) {
          actionType = rationaleActionType.JUMP_TO_TIME;
        }
      }
    }
    return {
      feedback: feedback,
      actionType: actionType
    };
  };
  var executeContinueAction = function executeContinueAction() {
    if (isOnLastQuestion()) {
      $container.trigger(events.Quizzing.CloseQuestionSetView);
    } else {
      displayNextQuestion();
    }
  };
  var executeRationaleAction = function executeRationaleAction() {
    var feedbackInfo;
    if (questionSet.questions[_currentQuestionIndex].feedbackActionExecuted) {
      feedbackInfo = {
        actionType: rationaleActionType.CONTINUE
      };
    } else {
      feedbackInfo = getFeedbackInfoForCurrentQuestion();
      questionSet.questions[_currentQuestionIndex].feedbackActionExecuted = true;
    }
    switch (feedbackInfo.actionType) {
      case rationaleActionType.CONTINUE:
        executeContinueAction();
        break;
      case rationaleActionType.LOCATION:
        $container.trigger(events.Quizzing.RationaleActionLocation, {
          location: feedbackInfo.feedback.location
        });
        executeContinueAction();
        break;
      case rationaleActionType.JUMP_TO_TIME:
        if (questionSet.startTime !== feedbackInfo.feedback.jumpToTime) {
          $container.trigger(events.Quizzing.RationaleActionJumpToTime, {
            jumpToTime: feedbackInfo.feedback.jumpToTime
          });
        } else {
          executeContinueAction();
        }
        break;
    }
  };
  var displayNextQuestion = function displayNextQuestion() {
    saveQuestionUserInput();
    _currentQuestionIndex++;
    displayQuestion();
  };
  var onPreviousQuestion = function onPreviousQuestion(e) {
    e.preventDefault();
    saveQuestionUserInput();
    _currentQuestionIndex--;
    displayQuestion();
  };
  var onNextQuestion = function onNextQuestion(e) {
    e.preventDefault();
    displayNextQuestion();
  };
  var onContinue = function onContinue(e) {
    e.preventDefault();
    if (questionSet.usesRationale && !showQuestionSetResults) {
      executeRationaleAction();
    } else {
      $container.trigger(events.Quizzing.CloseQuestionSetView);
    }
  };
  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    _$submitControl.attr('disabled', 'disabled');
    saveQuestionUserInput();
    lockResponses();
    $container.trigger(events.Quizzing.SubmitQuestionSet);
  };

  //This is a fix for iPhones whipping users back to the top of the page if there is a focused input.
  var onIphoneTouchstart = function onIphoneTouchstart() {
    _$questionSetContainer.find('.fill-in-the-blank-input').blur();
  };
  var getControlsConfig = function getControlsConfig() {
    var currentQuestion = questionSet.questions[_currentQuestionIndex];
    var onFirstQuestion = isOnFirstQuestion();
    var onLastQuestion = isOnLastQuestion();
    var hasOneQuestion = onFirstQuestion && onLastQuestion;
    var controlsConfig = {
      showSubmitNav: false,
      showContinueNav: false,
      showPrevNav: false,
      showNextNav: false,
      prevDisabled: false,
      nextDisabled: false
    };
    if (questionSet.usesRationale && !showQuestionSetResults) {
      if (currentQuestion.responseLocked) {
        if (currentQuestion.feedbackActionExecuted && !onLastQuestion) {
          controlsConfig.showNextNav = true;
        } else {
          controlsConfig.showContinueNav = true;
        }
      } else {
        controlsConfig.showSubmitNav = true;
      }
      controlsConfig.showPrevNav = !hasOneQuestion && !onFirstQuestion;
    } else {
      controlsConfig.showSubmitNav = !showQuestionSetResults && onLastQuestion;
      controlsConfig.showContinueNav = showQuestionSetResults && onLastQuestion && !mediaIsImage;
      controlsConfig.showPrevNav = !hasOneQuestion;
      controlsConfig.showNextNav = !hasOneQuestion && !controlsConfig.showSubmitNav && !controlsConfig.showContinueNav;
      controlsConfig.prevDisabled = _currentQuestionIndex === 0;
      controlsConfig.nextDisabled = onLastQuestion;
    }
    return controlsConfig;
  };
  var updateControls = function updateControls() {
    var controlsConfig = getControlsConfig();
    _$prevControl.css('display', 'none');
    _$nextControl.css('display', 'none');
    _$submitControl.css('display', 'none');
    _$continueControl.css('display', 'none');
    if (controlsConfig.showPrevNav) {
      _$prevControl.css('display', 'inline');
      if (controlsConfig.prevDisabled) {
        _$prevControl.attr('disabled', 'disabled');
      } else {
        _$prevControl.removeAttr('disabled');
      }
    }
    if (controlsConfig.showNextNav) {
      _$nextControl.css('display', 'inline');
      if (controlsConfig.nextDisabled) {
        _$nextControl.attr('disabled', 'disabled');
      } else {
        _$nextControl.removeAttr('disabled');
      }
    }
    if (controlsConfig.showSubmitNav) {
      _$submitControl.removeAttr('disabled');
      _$submitControl.css('display', 'inline');
    }
    if (controlsConfig.showContinueNav) {
      _$continueControl.removeAttr('disabled');
      _$continueControl.css('display', 'inline');
    }
  };
  var displayQuestion = function displayQuestion() {
    var showResults = showQuestionSetResults;
    if (questionSet.usesRationale && questionSet.questions[_currentQuestionIndex].responseLocked) {
      showResults = true;
    }
    if (_currentQuestionView !== null) {
      _currentQuestionView.destroy();
    }
    _currentQuestionView = QuestionView$1.create(_$questionTextContainer, _$questionGradedStatusContainer, _$feedbackContainer, _$answersContainer, questionSet.questions[_currentQuestionIndex], showResults);
    updateQuestionCount();
    updateControls();
    startTrackingQuestionTime();
    viewHelper.trapFocus(_$questionSetContent);
  };
  var updateQuestionCount = function updateQuestionCount() {
    var questionCountMarkup = templateGenerator.generateQuestionSetQuestionCountMarkup(_currentQuestionIndex + 1, questionSet.questions.length);
    _$questionCountContainer.html(questionCountMarkup);
  };
  var showFeedbackForCurrentQuestion = function showFeedbackForCurrentQuestion() {
    displayQuestion();
    updateControls();
  };
  var createView = function createView() {
    var questionSetViewMarkup = templateGenerator.generateQuestionSetMarkup(quizTime);
    if (displayOverlay) {
      questionSetViewMarkup += _superView.getOverlayMarkup();
    }
    _$container.append(questionSetViewMarkup);
    _$questionSetContainer = _$container.find(CONTAINER_CLASS);
    _$questionSetContent = _$container.find(QUESTION_SET_CONTENT_CLASS);
    _$questionTextContainer = _$container.find(QUESTION_CLASS);
    _$answersContainer = _$container.find(ANSWERS_CLASS);
    _$feedbackContainer = _$container.find(FEEDBACK_CLASS);
    _$questionCountContainer = _$container.find(QUESTION_COUNT_CLASS);
    _$questionGradedStatusContainer = _$container.find(QUESTION_GRADED_STATUS_CLASS);
    _$hideControl = _$container.find(HIDE_CONTROL_CLASS);
    _$showControl = _$container.find(SHOW_CONTROL_CLASS);
    _$prevControl = _$container.find(PREV_CONTROL_CLASS);
    _$nextControl = _$container.find(NEXT_CONTROL_CLASS);
    _$continueControl = _$container.find(CONTINUE_CONTROL_CLASS);
    _$submitControl = _$container.find(SUBMIT_CONTROL_CLASS);
    _$minimizedContainer = _$container.find(MINIMIZED_VIEW_CLASS);
  };
  var removeEvents = function removeEvents() {
    _$hideControl.off('click', onHideQuizClick);
    _$showControl.off('click', onShowQuizHandler);
    _$prevControl.off('click', onPreviousQuestion);
    _$nextControl.off('click', onNextQuestion);
    _$submitControl.off('click', onSubmit);
    _$continueControl.off('click', onContinue);
    $container.off('keydown', onKeyDownHandler);
    viewHelper.removeFocusTrap();
    if (deviceInfo.isIPhoneOrIPod()) {
      _$questionSetContainer.off('touchstart', onIphoneTouchstart);
    }
  };
  var setupEvents = function setupEvents() {
    _$hideControl.on('click', onHideQuizClick);
    _$showControl.on('click', onShowQuizHandler);
    _$prevControl.on('click', onPreviousQuestion);
    _$nextControl.on('click', onNextQuestion);
    _$submitControl.on('click', onSubmit);
    _$continueControl.on('click', onContinue);
    $container.on('keydown', onKeyDownHandler);
    if (deviceInfo.isIPhoneOrIPod()) {
      _$questionSetContainer.on('touchstart', onIphoneTouchstart);
    }
  };
  var checkQuestionSetProgress = function checkQuestionSetProgress() {
    if (showQuestionSetResults) {
      return;
    }
    for (var i = 0; i < questionSet.questions.length; i++) {
      if (!questionSet.questions[i].responseLocked) {
        _currentQuestionIndex = i;
        break;
      }
    }
  };
  var removeView = function removeView(completeCallback, destroyOverlay) {
    _initTimeoutId && clearTimeout(_initTimeoutId);
    _alertScreenReaderTimeoutId && clearTimeout(_alertScreenReaderTimeoutId);
    removeEvents();
    _currentQuestionView.destroy();
    _superView.removeView(completeCallback, destroyOverlay);
  };
  createView();
  checkQuestionSetProgress();
  setupEvents();

  // need to delay displaying first question for NVDA screen reader to pick up text.
  _initTimeoutId = setTimeout(function () {
    displayQuestion();
    _resolveInitPromise();
  }, INIT_QUESTION_SET_TIMEOUT);
  return Object.defineProperties({
    showView: showView,
    hideView: hideView,
    removeView: removeView,
    showFeedbackForCurrentQuestion: showFeedbackForCurrentQuestion
  }, {
    viewInitializedPromise: {
      get: function get() {
        return initPromise;
      }
    }
  });
};
var QuestionSetView$1 = {
  create: QuestionSetView
};

var _containerId$2 = '.start-question-set-confirmation-container';
var _superView$2 = BubbleView$1.create(_containerId$2);
var _reviewControlId = '.review-button';
var _confirmControlId = '.confirm-button';
var questionSetConfirmationView = {
  getViewMarkup: function getViewMarkup(reviewText, confirmationText) {
    return templateGenerator.generateQuestionSetConfirmationMarkup(reviewText, confirmationText) + _superView$2.getOverlayMarkup();
  },
  getReviewControlRef: function getReviewControlRef() {
    return _reviewControlId;
  },
  getConfirmControlRef: function getConfirmControlRef() {
    return _confirmControlId;
  },
  hideView: function hideView() {
    _superView$2.hideView();
  },
  showView: function showView() {
    _superView$2.showView(true);
    var $confirmControl = $(_containerId$2).find(_confirmControlId);
    $confirmControl.focus();
    highlightDisabler.disableHighlights($confirmControl);
  },
  removeView: _superView$2.removeView,
  updateViewPosition: _superView$2.updateViewPosition,
  setBottomOffset: _superView$2.setBottomOffset,
  pointAt: _superView$2.pointAt
};

var _superView$1 = BubbleView$1.create('.review-confirmation-container');
var _containerId$1 = '.controls-container';
var _continueControlId = '.continue-video-button';
var _reviewAnswersControlId = '.review-answers-button';
var reviewAnswersConfirmationView = {
  getViewMarkup: function getViewMarkup(numberCorrectText, percentCorrectText, numberInCorrectText, percentInCorrectText, continueText, reviewText) {
    return templateGenerator.generateQuestionSetReviewConfirmationMarkup(numberCorrectText, percentCorrectText, numberInCorrectText, percentInCorrectText, continueText, reviewText);
  },
  getContinueControlRef: function getContinueControlRef() {
    return _continueControlId;
  },
  getReviewControlRef: function getReviewControlRef() {
    return _reviewAnswersControlId;
  },
  hideView: function hideView() {
    _superView$1.hideView();
  },
  showView: function showView() {
    _superView$1.showView(true);
    var $reviewControl = $(_containerId$1).find(_reviewAnswersControlId);
    $reviewControl.focus();
    highlightDisabler.disableHighlights($reviewControl);
  },
  removeView: _superView$1.removeView,
  updateViewPosition: _superView$1.updateViewPosition,
  setBottomOffset: _superView$1.setBottomOffset,
  pointAt: _superView$1.pointAt
};

var questionGrader = Object.freeze({
  XMP: 'XMP'
});

var scormConstants = Object.freeze({
  fn: {
    initialize: 'initialize',
    terminate: 'terminate',
    getValue: 'getValue',
    setValue: 'setValue',
    commit: 'commit'
  },
  dataModelID: {
    cmiExit: 'cmiExit',
    cmiLocation: 'cmiLocation',
    cmiSuspendData: 'cmiSuspendData',
    cmiProgressMeasure: 'cmiProgressMeasure',
    cmiScaledPassingScore: 'cmiScaledPassingScore',
    cmiScoreMin: 'cmiScoreMin',
    cmiScoreMax: 'cmiScoreMax',
    cmiScoreRaw: 'cmiScoreRaw',
    cmiScoreScaled: 'cmiScoreScaled',
    cmiSuccessStatus: 'cmiSuccessStatus',
    cmiCompletionStatus: 'cmiCompletionStatus',
    cmiObjectives0Id: 'cmiObjectives0Id',
    cmiObjectives0ScoreScaled: 'cmiObjectives0ScoreScaled',
    cmiObjectives0ScoreRaw: 'cmiObjectives0ScoreRaw',
    cmiObjectives0ScoreMin: 'cmiObjectives0ScoreMin',
    cmiObjectives0ScoreMax: 'cmiObjectives0ScoreMax',
    cmiObjectives0SuccessStatus: 'cmiObjectives0SuccessStatus',
    cmiObjectives0CompletionStatus: 'cmiObjectives0CompletionStatus',
    cmiSessionTime: 'cmiSessionTime',
    adlNavRequest: 'adlNavRequest'
  },
  scorm1Dot2DataModel: {
    cmiExit: 'cmi.core.exit',
    cmiLocation: 'cmi.core.lesson_location',
    cmiSuspendData: 'cmi.suspend_data',
    cmiProgressMeasure: null,
    cmiScaledPassingScore: 'cmi.student_data.mastery_score',
    cmiScoreMin: 'cmi.core.score.min',
    cmiScoreMax: 'cmi.core.score.max',
    cmiScoreRaw: 'cmi.core.score.raw',
    cmiScoreScaled: null,
    cmiSuccessStatus: null,
    cmiCompletionStatus: 'cmi.core.lesson_status',
    cmiObjectives0Id: 'cmi.objectives.0.id',
    cmiObjectives0ScoreScaled: null,
    cmiObjectives0ScoreRaw: 'cmi.objectives.0.score.raw',
    cmiObjectives0ScoreMin: 'cmi.objectives.0.score.min',
    cmiObjectives0ScoreMax: 'cmi.objectives.0.score.max',
    cmiObjectives0SuccessStatus: 'cmi.objectives.0.status',
    cmiObjectives0CompletionStatus: null,
    cmiSessionTime: 'cmi.core.session_time',
    adlNavRequest: null
  },
  scorm2004DataModel: {
    cmiExit: 'cmi.exit',
    cmiLocation: 'cmi.location',
    cmiSuspendData: 'cmi.suspend_data',
    cmiProgressMeasure: 'cmi.progress_measure',
    cmiScaledPassingScore: 'cmi.scaled_passing_score',
    cmiScoreMin: 'cmi.score.min',
    cmiScoreMax: 'cmi.score.max',
    cmiScoreRaw: 'cmi.score.raw',
    cmiScoreScaled: 'cmi.score.scaled',
    cmiSuccessStatus: 'cmi.success_status',
    cmiCompletionStatus: 'cmi.completion_status',
    cmiObjectives0Id: 'cmi.objectives.0.id',
    cmiObjectives0ScoreScaled: 'cmi.objectives.0.score.scaled',
    cmiObjectives0ScoreRaw: 'cmi.objectives.0.score.raw',
    cmiObjectives0ScoreMin: 'cmi.objectives.0.score.min',
    cmiObjectives0ScoreMax: 'cmi.objectives.0.score.max',
    cmiObjectives0SuccessStatus: 'cmi.objectives.0.success_status',
    cmiObjectives0CompletionStatus: 'cmi.objectives.0.completion_status',
    cmiSessionTime: 'cmi.session_time',
    adlNavRequest: 'adl.nav.request'
  },
  status: {
    completed: 'completed',
    incomplete: 'incomplete',
    notAttempted: 'not attempted',
    unknown: 'unknown',
    passed: 'passed',
    failed: 'failed',
    browsed: 'browsed'
  },
  exitStates: {
    suspend: 'suspend',
    logout: 'logout',
    complete: ''
  },
  navRequestStates: {
    exitAll: 'exitAll',
    suspendAll: 'suspendAll'
  },
  versions: {
    NOT_DETECTED: -1,
    SCORM_1_2: 0,
    SCORM_2004: 1
  },
  assessment: {
    minScore: 0,
    maxScore: 100,
    scoreNormalizationDivider: 100
  },
  interactionTypes: {
    choice: 'choice',
    fillIn: 'fill-in',
    longFillIn: 'long-fill-in'
  },
  interactionResults: {
    correct: 'correct',
    incorrect: 'incorrect',
    wrong: 'wrong',
    neutral: 'neutral'
  },
  objectiveId: 'TechSmithCamtasia'
});

var V1_SUSPENDED_DATA_KEY = 'tscsp1';
var V2_SUSPENDED_DATA_KEY = 'tscsp2';

/**
 * @memberof TSC
 * @class ScormDataModel
 * @classdesc Data modal for smart player suspended scorm data
 */
var ScormDataModel = function ScormDataModel() {
  var _percentageComplete = 0;
  var _quizPercentageCorrect = 0;
  var _quizCompletionStatus = scormConstants.status.unknown;
  var _quizModelSnapshot = '';
  var _videoAnalyticsSnapshot = '';
  var _videoTimeInSecondsSnapshot = 0;
  var _videoTimeInSeconds = 0;
  var _completionStatus = scormConstants.status.notAttempted;
  var _passingStatus = scormConstants.status.unknown;

  /**
   * @methodOf TSC.ScormDataModel
   * @method parseSuspendedDataString
   * @param {String} suspendedDataString - string containing suspended scorm data
   */
  var parseSuspendedDataString = function parseSuspendedDataString(suspendedDataString) {
    if (!suspendedDataString) {
      return;
    }
    try {
      var suspendedData = window.JSON.parse(suspendedDataString);
      if (suspendedData[V1_SUSPENDED_DATA_KEY]) {
        _percentageComplete = parseFloat(suspendedData[V1_SUSPENDED_DATA_KEY].pc);
        _videoAnalyticsSnapshot = suspendedData[V1_SUSPENDED_DATA_KEY].vas;
        _videoTimeInSecondsSnapshot = parseFloat(suspendedData[V1_SUSPENDED_DATA_KEY].cvt);
      } else if (suspendedData[V2_SUSPENDED_DATA_KEY]) {
        _percentageComplete = parseFloat(suspendedData[V2_SUSPENDED_DATA_KEY].pc);
        _videoAnalyticsSnapshot = suspendedData[V2_SUSPENDED_DATA_KEY].vas;
        _videoTimeInSecondsSnapshot = parseFloat(suspendedData[V2_SUSPENDED_DATA_KEY].cvt);
        _quizModelSnapshot = suspendedData[V2_SUSPENDED_DATA_KEY].qs;
      }
    } catch (e) {} // eslint-disable-line
  };

  /**
   * @methodOf TSC.ScormDataModel
   * @method getSuspendedDataString
   * Return string of suspended data
   * @returns {String} string containing suspended scorm data
   */
  var getSuspendedDataString = function getSuspendedDataString() {
    var suspendedData = {};
    suspendedData[V2_SUSPENDED_DATA_KEY] = {
      pc: _percentageComplete,
      vas: _videoAnalyticsSnapshot,
      cvt: _videoTimeInSeconds,
      qs: _quizModelSnapshot
    };
    return window.JSON.stringify(suspendedData);
  };
  return Object.defineProperties({
    parseSuspendedDataString: parseSuspendedDataString,
    getSuspendedDataString: getSuspendedDataString
  }, {
    percentageComplete: {
      get: function get() {
        return _percentageComplete;
      },
      set: function set(percentageComplete) {
        _percentageComplete = percentageComplete;
      }
    },
    quizPercentageCorrect: {
      get: function get() {
        return _quizPercentageCorrect;
      },
      set: function set(quizPercentageCorrect) {
        _quizPercentageCorrect = quizPercentageCorrect;
      }
    },
    quizPercentageCorrectAsString: {
      get: function get() {
        return _quizPercentageCorrect.toString();
      }
    },
    quizCompletionStatus: {
      get: function get() {
        return _quizCompletionStatus;
      },
      set: function set(quizCompletionStatus) {
        _quizCompletionStatus = quizCompletionStatus;
      }
    },
    quizModelSnapshot: {
      get: function get() {
        return _quizModelSnapshot;
      },
      set: function set(quizModelSnapshot) {
        _quizModelSnapshot = quizModelSnapshot;
      }
    },
    videoAnalyticsSnapshot: {
      get: function get() {
        return _videoAnalyticsSnapshot;
      },
      set: function set(snapshot) {
        _videoAnalyticsSnapshot = snapshot;
      }
    },
    videoTimeInSecondsSnapshot: {
      get: function get() {
        return _videoTimeInSecondsSnapshot;
      }
    },
    videoTimeInSeconds: {
      get: function get() {
        return _videoTimeInSeconds;
      },
      set: function set(timeInSeconds) {
        _videoTimeInSeconds = timeInSeconds;
      }
    },
    completionStatus: {
      get: function get() {
        return _completionStatus;
      },
      set: function set(completionStatus) {
        _completionStatus = completionStatus;
      }
    },
    passingStatus: {
      get: function get() {
        return _passingStatus;
      },
      set: function set(passingStatus) {
        _passingStatus = passingStatus;
      }
    }
  });
};
var ScormDataModel$1 = {
  create: ScormDataModel
};

var DEFAULT_TITLE_TEXT = '';
var MAX_PARENTS_TO_SEARCH = 500;
var SCORM_MANIFEST_FILE_NAME = 'imsmanifest.xml';
var CAMTASIA_SCORM_1_2_MANIFEST_STRING = '<metadatascheme>ADL SCORM 1.2</metadatascheme>';

/**
 * @memberof TSC
 * @class ScormApiWrapper
 * @classdesc Wrapper around Scorm API that handles Scorm 1.2 and 2004
 */
var ScormApiWrapper = function ScormApiWrapper() {
  var scormApi = null;
  var noAPIFound = false;
  var apiVersion = scormConstants.versions.NOT_DETECTED;
  var scormManifestDocString = null;

  /**
   * Get last error message
   * @function getLastError
   * @return {String} - An error string that contains error number, string and diagnostic information.
   */
  var getLastError = function getLastError() {
    var errorNumber;
    var errorString;
    var diagnostic;
    if (!scormApi) {
      return 'SCORM API not found';
    }
    if (apiVersion >= scormConstants.versions.SCORM_2004) {
      errorNumber = scormApi.GetLastError();
      errorString = scormApi.GetErrorString(errorNumber);
      diagnostic = scormApi.GetDiagnostic(errorNumber);
    } else {
      errorNumber = scormApi.LMSGetLastError();
      errorString = scormApi.LMSGetErrorString(errorNumber);
      diagnostic = scormApi.LMSGetDiagnostic(errorNumber);
    }
    return 'Number: ' + errorNumber + '\nDescription: ' + errorString + '\nDiagnostic: ' + diagnostic;
  };

  /**
   * This function is used to communicate with the API, if it is found.
   * @memberof TSC.ScormApiWrapper
   * @function apiCall
   * @param {string} scormFunctionName - Name of the api function to call
   * @param {string} [dataModalID] - Name of the data model id defined in scorm constants object.
   * @param [dmeValue] - Value to write to data model
   * @return {string} - Value returned from the api call.
   */
  var apiCall = function apiCall(scormFunctionName, dataModalID, dmeValue) {
    var dataModel;
    var result;
    if (scormApi) {
      switch (scormFunctionName) {
        case scormConstants.fn.initialize:
          var initializedResult;
          if (apiVersion >= scormConstants.versions.SCORM_2004) {
            initializedResult = scormApi.Initialize('');
          } else {
            initializedResult = scormApi.LMSInitialize('');
          }
          if (initializedResult === 'true') {
            if (apiVersion >= scormConstants.versions.SCORM_2004) {
              result = scormApi.GetValue(scormConstants.scorm2004DataModel.cmiCompletionStatus);
            } else {
              result = scormApi.LMSGetValue(scormConstants.scorm1Dot2DataModel.cmiCompletionStatus);
            }
          }
          break;
        case scormConstants.fn.terminate:
          if (apiVersion >= scormConstants.versions.SCORM_2004) {
            result = scormApi.Terminate('');
          } else {
            result = scormApi.LMSFinish('');
          }
          break;
        case scormConstants.fn.getValue:
          if (apiVersion >= scormConstants.versions.SCORM_2004) {
            dataModel = scormConstants.scorm2004DataModel[dataModalID];
            if (dataModel) {
              result = scormApi.GetValue(dataModel);
            }
          } else {
            dataModel = scormConstants.scorm1Dot2DataModel[dataModalID];
            if (dataModel) {
              result = scormApi.LMSGetValue(dataModel);
            }
          }
          break;
        case scormConstants.fn.setValue:
          if (apiVersion >= scormConstants.versions.SCORM_2004) {
            dataModel = scormConstants.scorm2004DataModel[dataModalID];
            if (dataModel) {
              result = scormApi.SetValue(dataModel, dmeValue);
            }
          } else {
            // In 1.2, lesson_status hold both complete/incomplete and pass/fail.
            // So if we've already used it for pass/fail, we don't want to
            // overwrite with 'completed'
            dataModel = scormConstants.scorm1Dot2DataModel[dataModalID];
            var canSetValue = !!dataModel;
            if (dataModalID === scormConstants.dataModelID.cmiCompletionStatus) {
              var lessonStatus = scormApi.LMSGetValue(scormConstants.scorm1Dot2DataModel.cmiCompletionStatus);
              if (dmeValue !== scormConstants.status.passed && dmeValue !== scormConstants.status.failed) {
                canSetValue = lessonStatus !== scormConstants.status.failed && lessonStatus !== scormConstants.status.passed;
              }
            }
            if (canSetValue) {
              result = scormApi.LMSSetValue(dataModel, dmeValue);
            }
          }
          break;
        case scormConstants.fn.commit:
          if (apiVersion >= scormConstants.versions.SCORM_2004) {
            result = scormApi.Commit('');
          } else {
            result = scormApi.LMSCommit('');
          }
          break;
      }
      if (playerConfiguration.logScormApiCalls) {
        console.info('SCORM apiCall - ', scormFunctionName, dataModalID, dmeValue, ' returned ', result); // eslint-disable-line
      }
      return result;
    }
  };
  var isFalsyButAllowZero = function isFalsyButAllowZero(value) {
    return value === 0 ? false : !value;
  };

  /**
   * Send a quiz interaction to the SCORM API.
   * @memberof TSC.ScormApiWrapper
   * @function submitInteraction
   * @param {number} interactionIndex
   * @param {string} interactionType
   * @param {(string|number|undefined)} userResponse
   * @param {(Array.<string>|string|number|null)} correctResponse
   * @param {(string|null)} result
   */
  var submitInteraction = function submitInteraction(interactionIndex, interactionType, userResponse, correctResponse, result) {
    var interactionId = "Question_".concat(interactionIndex + 1);
    if (apiVersion >= scormConstants.versions.SCORM_2004) {
      scormApi.SetValue("cmi.interactions.".concat(interactionIndex, ".id"), interactionId);
      scormApi.SetValue("cmi.interactions.".concat(interactionIndex, ".type"), interactionType);
      if (!isFalsyButAllowZero(userResponse)) {
        scormApi.SetValue("cmi.interactions.".concat(interactionIndex, ".learner_response"), userResponse.toString());
      }
      if (correctResponse !== null) {
        if (Array.isArray(correctResponse)) {
          correctResponse.forEach(function (response, index) {
            scormApi.SetValue("cmi.interactions.".concat(interactionIndex, ".correct_responses.").concat(index, ".pattern"), response.toString());
          });
        } else {
          scormApi.SetValue("cmi.interactions.".concat(interactionIndex, ".correct_responses.0.pattern"), correctResponse.toString());
        }
      }
      if (result !== null) {
        scormApi.SetValue("cmi.interactions.".concat(interactionIndex, ".result"), result);
      }
    } else {
      if (interactionType === scormConstants.interactionTypes.longFillIn) {
        // In SCORM 1.2, long-fill-in interactions are not supported, so we use 'fill-in' type
        interactionType = scormConstants.interactionTypes.fillIn;
      }

      // In SCORM 1.2, 'incorrect' is not a valid result value, so we convert it to 'wrong'
      if (result === scormConstants.interactionResults.incorrect) {
        result = scormConstants.interactionResults.wrong;
      }
      scormApi.LMSSetValue("cmi.interactions.".concat(interactionIndex, ".id"), interactionId);
      scormApi.LMSSetValue("cmi.interactions.".concat(interactionIndex, ".type"), interactionType);
      if (!isFalsyButAllowZero(userResponse)) {
        scormApi.LMSSetValue("cmi.interactions.".concat(interactionIndex, ".student_response"), userResponse.toString());
      }
      if (correctResponse !== null) {
        if (Array.isArray(correctResponse)) {
          correctResponse.forEach(function (response, index) {
            scormApi.LMSSetValue("cmi.interactions.".concat(interactionIndex, ".correct_responses.").concat(index, ".pattern"), response.toString());
          });
        } else {
          scormApi.LMSSetValue("cmi.interactions.".concat(interactionIndex, ".correct_responses.0.pattern"), correctResponse.toString());
        }
      }
      if (result !== null) {
        scormApi.LMSSetValue("cmi.interactions.".concat(interactionIndex, ".result"), result);
      }
    }
    if (playerConfiguration.logScormApiCalls) {
      console.info('SCORM submitInteraction - ', interactionIndex, interactionId, interactionType, userResponse, correctResponse, result); // eslint-disable-line
    }
  };
  var loadScormManifest = function loadScormManifest() {
    return $.ajax({
      type: 'GET',
      url: SCORM_MANIFEST_FILE_NAME,
      dataType: 'text'
    });
  };
  var getScormManifestDoc = function getScormManifestDoc() {
    if (scormManifestDocString === null) {
      return new Promise$1(function (resolve, reject) {
        loadScormManifest().done(function (data) {
          scormManifestDocString = data;
          resolve(scormManifestDocString);
        }).fail(function () {
          reject();
        });
      });
    }
    return Promise$1.resolve(scormManifestDocString);
  };
  var getScormVersionFromManifestDoc = function getScormVersionFromManifestDoc() {
    return getScormManifestDoc().then(function (manifestDocAsString) {
      // manifest doc will contain a specific string only with SCORM version 1.2 produced with Camtasia
      if (manifestDocAsString.indexOf(CAMTASIA_SCORM_1_2_MANIFEST_STRING) !== -1) {
        return scormConstants.versions.SCORM_1_2;
      }
      return scormConstants.versions.SCORM_2004;
    });
  };
  var getScormApiOnWindow = function getScormApiOnWindow(windowRef) {
    // scorm 1.2 and 2004 api are defined on window
    if (windowRef.API && windowRef.API_1484_11) {
      return getScormVersionFromManifestDoc().then(function (scormApiVersion) {
        apiVersion = scormApiVersion;
        if (scormApiVersion === scormConstants.versions.SCORM_1_2) {
          return windowRef.API;
        }
        return windowRef.API_1484_11;
      });
      // look for scorm 1.2 api
    } else if (windowRef.API) {
      apiVersion = scormConstants.versions.SCORM_1_2;
      return Promise$1.resolve(windowRef.API);
      // look for scorm 2004 api
    } else if (windowRef.API_1484_11) {
      apiVersion = scormConstants.versions.SCORM_2004;
      return Promise$1.resolve(windowRef.API_1484_11);
    }
    return Promise$1.reject();
  };

  /**
   * Searches all the parents of a given window until it finds an object named "API_1484_11" or "API".
   * If an object of that name is found, a reference to it is returned. Otherwise, this function returns null.
   * @function findAPI
   * @param {window} win - Window object
   * @return {object} - If the API object is found, it's returned, otherwise null is returned
   */
  var findAPI = function findAPI(win) {
    var findAPITries = 0;

    // Search each parent window until we find the API, encounter a window with no parent / the
    // same as the current window, or have reached our MAX_PARENTS_TO_SEARCH to search threshold
    while (!win.API && !win.API_1484_11 && win.parent !== win && findAPITries <= MAX_PARENTS_TO_SEARCH) {
      findAPITries++;
      win = win.parent;
    }
    return getScormApiOnWindow(win);
  };
  var lookForApiOnParentWindow = function lookForApiOnParentWindow() {
    try {
      if (window.parent !== window) {
        return findAPI(window.parent);
      }
      return Promise$1.reject();
    } catch (e) {
      return Promise$1.reject(e);
    }
  };
  var lookForApiOnWindowTopOpener = function lookForApiOnWindowTopOpener() {
    if (window.top.opener !== null) {
      return findAPI(window.top.opener);
    }
    return Promise$1.reject();
  };

  /**
   * This function looks for an object named API, first in the current window's
   * frame hierarchy and then, if necessary, in the current window's opener window
   * hierarchy (if there is an opener window).
   * @function getAPI
   * @return {Promise} - A Promise that will resolve with API object if found or promise is rejected.
   */
  var getAPI = function getAPI() {
    return lookForApiOnParentWindow()["catch"](lookForApiOnWindowTopOpener);
  };

  /**
   * Returns the handle to API object if it was previously set, otherwise it returns null
   * @function getAPIHandle
   * @return {Promise} - A Promise that will resolve with the available SCORM api.
   */
  var getAPIHandle = function getAPIHandle() {
    if (noAPIFound) {
      return Promise$1.reject();
    }
    if (!scormApi) {
      return getAPI();
    }
    return Promise$1.resolve(scormApi);
  };
  var getTitleFromManifestDoc = function getTitleFromManifestDoc() {
    try {
      var manifestXml = $.parseXML(scormManifestDocString);
      var $manifestXml = $(manifestXml);
      var $item = $manifestXml.find('item');
      var $title = $item.find('title');
      return $title.text();
    } catch (e) {
      return DEFAULT_TITLE_TEXT;
    }
  };

  /**
   * Get title for SCORM module
   * @function getTitle
   * @return {Promise} - A Promise that will resolve with the title found in the SCORM manifest file or empty string.
   */
  var getTitle = function getTitle() {
    if (!scormManifestDocString) {
      return getScormManifestDoc().then(getTitleFromManifestDoc)["catch"](function () {
        return DEFAULT_TITLE_TEXT;
      });
    }
    return Promise$1.resolve(getTitleFromManifestDoc());
  };

  /**
   * Initialize SCORM module
   * @function init
   * @return {Promise} - A Promise that will resolve with the state of initialize.
   */
  var init = function init() {
    return getAPIHandle().then(function (api) {
      scormApi = api;
      if (playerConfiguration.logScormApiCalls) {
        console.info('SCORM initialized with version: ', apiVersion); // eslint-disable-line
      }
      return apiCall(scormConstants.fn.initialize);
    })["catch"](function () {
      noAPIFound = true;
      return 'false';
    });
  };
  return Object.defineProperties({
    init: init,
    apiCall: apiCall,
    submitInteraction: submitInteraction,
    getTitle: getTitle,
    getLastError: getLastError
  }, {
    apiVersion: {
      get: function get() {
        return apiVersion;
      }
    }
  });
};

/**
 *  Factory method that returns a new Scorm Api Wrapper object.
 *  @function create
 *  @memberof TSC.ScormApiWrapper
 *  @static
 *  @return new ScormApiWrapper instance
 */
var ScormApiWrapper$1 = {
  create: ScormApiWrapper
};

var ScormNavigationBarView = function ScormNavigationBarView($container) {
  var _$scormNavigationBarContainer = $container.find('.scorm-module-navigation-container');
  var _$scormHeaderElement = null;
  var _$scormCompleteSessionButton = null;
  var _scoObjectiveHasBeenCompleted = false;
  var onCompleteSessionHandler = function onCompleteSessionHandler(e) {
    e.preventDefault();
    $container.trigger(events.SCORM.ExitSession);
  };
  var getButtonLabel = function getButtonLabel() {
    if (_scoObjectiveHasBeenCompleted) {
      return playerConfiguration.completeScormOnRequirementsComplete ? localizationStrings.getPlayerString(playerStringNames.scormExitVideo) : localizationStrings.getPlayerString(playerStringNames.scormCompleteVideo);
    }
    return localizationStrings.getPlayerString(playerStringNames.scormCompleteVideoLater);
  };
  var createView = function createView() {
    var buttonLabel = getButtonLabel();
    var isPrimaryButton = _scoObjectiveHasBeenCompleted;
    var scormNavigationBarMarkup = templateGenerator.generateScormNavigationBarMarkup(buttonLabel, isPrimaryButton);
    _$scormNavigationBarContainer.html(scormNavigationBarMarkup);
    _$scormHeaderElement = _$scormNavigationBarContainer.find('.scorm-module-title');
    _$scormCompleteSessionButton = _$scormNavigationBarContainer.find('.complete-scorm-session-button');
  };
  var disableControls = function disableControls() {
    _$scormCompleteSessionButton && _$scormCompleteSessionButton.attr('tabindex', tabIndex.Disabled);
  };
  var enableControls = function enableControls() {
    _$scormCompleteSessionButton && _$scormCompleteSessionButton.attr('tabindex', tabIndex.DomOrder);
  };
  var setupEvents = function setupEvents() {
    $container.on(events.Modals.Open, disableControls);
    $container.on(events.Modals.Closed, enableControls);
    _$scormCompleteSessionButton.on('click', onCompleteSessionHandler);
  };
  var setTitle = function setTitle(scormTitle) {
    if (_$scormHeaderElement) {
      _$scormHeaderElement.html(scormTitle);
    }
  };
  var destroy = function destroy() {
    if (_$scormCompleteSessionButton) {
      _$scormCompleteSessionButton.off();
    }
    $container.off(events.Modals.Open, disableControls);
    $container.off(events.Modals.Closed, enableControls);
  };
  var init = function init() {
    createView();
    setupEvents();
  };
  var updateView = function updateView(scoObjectiveHasBeenCompleted) {
    _scoObjectiveHasBeenCompleted = scoObjectiveHasBeenCompleted;
    destroy();
    init();
  };
  return Object.defineProperties({
    setTitle: setTitle,
    updateView: updateView
  }, {});
};
var ScormNavigationBarView$1 = {
  create: ScormNavigationBarView
};

/**
 * Options for the ScormConfirmCompleteModal
 * @typedef {Object} ScormModalOptions
 * @property {boolean} canResumeVideo - Can the SCORM module be resumed
 * @property {boolean} failedToSaveSuspendedData - Indicates whether the player could not save the current state to the suspended data api.
 */

/**
 * @memberof TSC
 * @class ScormConfirmCompleteModalView
 * @classdesc Confirmation modal used with SCORM operations
 * @param {jQuery} $container - jQuery wrapped element to add modal to.
 * @param {ScormModalOptions} options - Options to use when displaying modal.
 */
var ScormConfirmCompleteModalView = function ScormConfirmCompleteModalView($container, options) {
  var _$scormConfirmCompleteModalWrapper = $container.find('.scorm-confirm-complete-modal-wrapper');
  var _$confirmButton;
  var _$dismissButton;
  var createView = function createView() {
    var finalConfirmText;
    if (options.failedToSaveSuspendedData) {
      finalConfirmText = localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalFailedToSaveProgressText);
    } else {
      var confirmText = localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalText);
      var confirmWarningText = options.canResumeVideo ? localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalResumeVideoText) : localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalRestartVideoText);
      finalConfirmText = confirmText + ' ' + confirmWarningText;
    }
    var screenReaderAlertText = finalConfirmText;
    var dismissButtonText = localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalDismissButtonText);
    var dismissButtonScreenReaderText = localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalDismissButtonScreenReaderText);
    var confirmButtonText = localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalConfirmButtonText);
    var confirmButtonScreenReaderText = localizationStrings.getPlayerString(playerStringNames.scormConfirmCompleteModalConfirmButtonScreenReaderText);
    var scormConfirmCompleteModalMarkup = templateGenerator.generateScormConfirmCompleteModalMarkup(screenReaderAlertText, finalConfirmText, dismissButtonText, dismissButtonScreenReaderText, confirmButtonText, confirmButtonScreenReaderText, options.failedToSaveSuspendedData);
    _$scormConfirmCompleteModalWrapper.html(scormConfirmCompleteModalMarkup);
    _$dismissButton = _$scormConfirmCompleteModalWrapper.find('.dismiss-complete-button');
    _$confirmButton = _$scormConfirmCompleteModalWrapper.find('.confirm-complete-button');
  };
  var onDismissClickHandler = function onDismissClickHandler(e) {
    e.preventDefault();
    destroy();
  };
  var onCompleteClickHandler = function onCompleteClickHandler(e) {
    e.preventDefault();
    if (options.failedToSaveSuspendedData) {
      $container.trigger(events.SCORM.ExitSessionWithOutProgressConfirmed);
    } else {
      $container.trigger(events.SCORM.ExitSessionConfirmed);
    }
  };
  var setupEvents = function setupEvents() {
    _$confirmButton.on('click', onCompleteClickHandler);
    _$dismissButton.on('click', onDismissClickHandler);
  };
  var destroy = function destroy() {
    $container.trigger(events.Modals.Closed);
    _$confirmButton && _$confirmButton.off();
    _$dismissButton && _$dismissButton.off();
    _$scormConfirmCompleteModalWrapper.html('');
  };
  createView();
  setupEvents();
  $container.trigger(events.Modals.Open);
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var ScormConfirmCompleteModalView$1 = {
  create: ScormConfirmCompleteModalView
};

var ScormSessionEndedView = function ScormSessionEndedView($container) {
  var _$scormSessionEndedWrapper = $container.find('.scorm-session-ended-wrapper');
  var scormSessionEndedMarkup = templateGenerator.generateScormSessionEndedMarkup(localizationStrings.getPlayerString(playerStringNames.scormSessionEndedText));
  _$scormSessionEndedWrapper.html(scormSessionEndedMarkup);
  $container.trigger(events.Modals.Open);
};
var ScormSessionEndedView$1 = {
  create: ScormSessionEndedView
};

var DEFAULT_PASSING_SCORE = 80;
var DEFAULT_VIDEO_WATCH_PERCENT_FOR_COMPLETE = 1;
var SCORM_NAV_CONTAINER_HEIGHT = '44px'; // note this should match the LESS var @scorm-ui-bar-height

/**
 * @memberof TSC
 * @class scormController
 * @static
 * @classdesc Scorm Controller
 */
var scormController = function scormController() {
  var _$container = null;
  var _scormNavigationBarView = null;
  var _scormConfirmCompleteModalView = null;
  var _minimumScoreToPass = DEFAULT_PASSING_SCORE;
  var _minimumViewPercentageToCompleteLesson = DEFAULT_VIDEO_WATCH_PERCENT_FOR_COMPLETE;
  var _scormApiWrapper;
  var _isDisposed;
  var _initialized;
  var _scormModel;
  var _quizModel = null;
  var _sessionStartTimeInMilliseconds = 0;
  var _preventWindowClose = true;
  var _ignoreFailedToSuspendError = false;
  var _pendingScoExitValue = null;
  var _scoSessionHasEnded = false;
  var initializeInternalState = function initializeInternalState() {
    _$container = null;
    _scormNavigationBarView = null;
    _scormConfirmCompleteModalView = null;
    _scormApiWrapper = ScormApiWrapper$1.create();
    _isDisposed = false;
    _initialized = false;
    _scormModel = ScormDataModel$1.create();
    _sessionStartTimeInMilliseconds = 0;
    _preventWindowClose = true;
    _ignoreFailedToSuspendError = false;
    _pendingScoExitValue = null;
    _scoSessionHasEnded = false;
  };
  var scoHasQuiz = function scoHasQuiz() {
    return _quizModel !== null;
  };
  var scormSessionHasUnfinishedQuiz = function scormSessionHasUnfinishedQuiz() {
    return scoHasQuiz() && _scormModel.passingStatus === scormConstants.status.unknown;
  };
  var canSuspendScormSession = function canSuspendScormSession() {
    return !scoHasQuiz() || _quizModel.reportMethod === reportType.NONE || _quizModel.reportMethod === reportType.SCORM;
  };
  var submitMinMaxScoreValuesToScormApi = function submitMinMaxScoreValuesToScormApi() {
    if (_scormApiWrapper.apiVersion === scormConstants.versions.SCORM_1_2) {
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiScoreMin, scormConstants.assessment.minScore.toString());
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0ScoreMin, scormConstants.assessment.minScore.toString());
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiScoreMax, scormConstants.assessment.maxScore.toString());
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0ScoreMax, scormConstants.assessment.maxScore.toString());
    } else {
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiScoreMin, scormConstants.assessment.minScore);
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0ScoreMin, scormConstants.assessment.minScore);
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiScoreMax, scormConstants.assessment.maxScore);
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0ScoreMax, scormConstants.assessment.maxScore);
    }
    _scormApiWrapper.apiCall(scormConstants.fn.commit);
  };
  var submitScoreToScormApi = function submitScoreToScormApi() {
    if (_scormApiWrapper.apiVersion === scormConstants.versions.SCORM_1_2) {
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiScoreRaw, _scormModel.quizPercentageCorrectAsString);
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0ScoreRaw, _scormModel.quizPercentageCorrectAsString);
    } else {
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiScoreRaw, _scormModel.quizPercentageCorrect);
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0ScoreRaw, _scormModel.quizPercentageCorrect);
    }
    _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiScoreScaled, _scormModel.quizPercentageCorrect / scormConstants.assessment.scoreNormalizationDivider);
    _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0ScoreScaled, _scormModel.quizPercentageCorrect / scormConstants.assessment.scoreNormalizationDivider);
    _scormApiWrapper.apiCall(scormConstants.fn.commit);
  };
  var getSuspendedDataFromAPI = function getSuspendedDataFromAPI() {
    var suspendedData = _scormApiWrapper.apiCall(scormConstants.fn.getValue, scormConstants.dataModelID.cmiSuspendData);
    _scormModel.parseSuspendedDataString(suspendedData);
  };
  var getSuspendData = function getSuspendData() {
    if (_quizModel) {
      _scormModel.quizModelSnapshot = _quizModel.getSnapShot();
    }
    _scormModel.videoAnalyticsSnapshot = videoAnalytics.getVideoSegmentSnapShot();
    return _scormModel.getSuspendedDataString();
  };
  var getSessionTimeValueByApiVersion = function getSessionTimeValueByApiVersion() {
    var sessionTimeInMilliseconds = window.performance.now() - _sessionStartTimeInMilliseconds;
    var sessionTimeInSeconds = Math.round(sessionTimeInMilliseconds / 1000);
    if (_scormApiWrapper.apiVersion === scormConstants.versions.SCORM_1_2) {
      return timeFormatter.formatTimeForCmiTimespan(sessionTimeInSeconds);
    }
    return timeFormatter.formatTimeAsTimeInterval(sessionTimeInSeconds);
  };
  var scoObjectiveHasBeenCompleted = function scoObjectiveHasBeenCompleted() {
    return _scormModel.percentageComplete >= _minimumViewPercentageToCompleteLesson && !scormSessionHasUnfinishedQuiz();
  };
  var shouldSubmitQuizScoreToApi = function shouldSubmitQuizScoreToApi() {
    return _quizModel && _scormModel.completionStatus === scormConstants.status.completed && _scormModel.quizCompletionStatus === scormConstants.status.completed && _quizModel.totalNumberOfGradedQuestionSets > 0;
  };
  var endScormSession = function endScormSession() {
    if (!_scoSessionHasEnded) {
      // need to mark this ended upfront
      _scoSessionHasEnded = true;
      if (_scormModel.percentageComplete >= _minimumViewPercentageToCompleteLesson) {
        _scormModel.completionStatus = scormConstants.status.completed;
      }
      var timeInSecondsAsString = videoAnalytics.getCurrentPlayTime().toString();
      _pendingScoExitValue = scormConstants.exitStates.complete;
      var scoCompletionStatusValue = _scormModel.completionStatus;
      var scoSuccessStatusValue;

      // SCORM 1.2 when video has quiz and not answered all questions complete status will be 'incomplete'
      // This is because SCORM 1.2 does not have a separate api value for pass / fail success
      if (_scormApiWrapper.apiVersion === scormConstants.versions.SCORM_1_2 && scormSessionHasUnfinishedQuiz()) {
        scoCompletionStatusValue = scormConstants.status.incomplete;
      }

      // Suspend SCO (Enables bookmarking feature) when viewer has not watched all the required video or they have not answered all the quiz questions if they exist
      if (canSuspendScormSession() && (_scormModel.completionStatus !== scormConstants.status.completed || scormSessionHasUnfinishedQuiz())) {
        _pendingScoExitValue = scormConstants.exitStates.suspend;
      }

      // If SCO attempt is complete and there is a quiz make sure we write the score out regardless if viewer has finished quiz
      if (_pendingScoExitValue === scormConstants.exitStates.complete) {
        if (scoHasQuiz()) {
          submitScore(_scormModel.quizPercentageCorrect, true);
        } else {
          _scormModel.passingStatus = scormConstants.status.passed;
        }
      }

      // SCORM 1.2 completionStatus value can be 'incomplete', 'passed' or 'failed'
      // SCORM 1.2 does not have a key to store an independent success status.
      if (_scormApiWrapper.apiVersion === scormConstants.versions.SCORM_1_2 && scoHasQuiz() && _scormModel.passingStatus !== scormConstants.status.unknown && scoCompletionStatusValue === scormConstants.status.completed) {
        scoCompletionStatusValue = _scormModel.passingStatus;
        scoSuccessStatusValue = _scormModel.passingStatus;
      } else {
        scoSuccessStatusValue = _scormModel.passingStatus;
      }
      var suspendedData = _pendingScoExitValue === scormConstants.exitStates.suspend ? getSuspendData() : '';
      var suspendSuccess = _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiSuspendData, suspendedData);

      // SCORM spec says boolean is returned, but in testing it is a boolean as a string.  So testing for both in case a LMS returns a boolean.
      if (typeof suspendSuccess === 'string' && suspendSuccess.toLowerCase() === 'false' || suspendSuccess === false) {
        _pendingScoExitValue = scormConstants.exitStates.complete;
        if (!_ignoreFailedToSuspendError) {
          _scormConfirmCompleteModalView = ScormConfirmCompleteModalView$1.create(_$container, {
            canResumeVideo: true,
            failedToSaveSuspendedData: true
          });
          _scoSessionHasEnded = false;
          return false;
        }
      }
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiSessionTime, getSessionTimeValueByApiVersion());
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiProgressMeasure, _scormModel.percentageComplete);
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiLocation, timeInSecondsAsString);
      if (shouldSubmitQuizScoreToApi()) {
        submitScoreToScormApi();
      }
      if (_scormModel.passingStatus !== scormConstants.status.completed) {
        _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiSuccessStatus, scoSuccessStatusValue);
        _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0SuccessStatus, scoSuccessStatusValue);
      }
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiCompletionStatus, scoCompletionStatusValue);
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0CompletionStatus, scoCompletionStatusValue);
      _scormApiWrapper.apiCall(scormConstants.fn.commit);
    }
    return true;
  };
  var terminateScormSession = function terminateScormSession() {
    _initialized = false;
    _isDisposed = true;
    _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiExit, _pendingScoExitValue);
    _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.adlNavRequest, scormConstants.navRequestStates.exitAll);
    _scormApiWrapper.apiCall(scormConstants.fn.terminate);
    ScormSessionEndedView$1.create(_$container);
  };
  var createNavigationBarView = function createNavigationBarView() {
    _scormNavigationBarView = ScormNavigationBarView$1.create(_$container);
    _scormNavigationBarView.updateView(scoObjectiveHasBeenCompleted());
    _scormApiWrapper.getTitle().then(function (scormTitle) {
      _scormNavigationBarView.setTitle(scormTitle);
    });
    _$container[0].style.setProperty(cssVariables.reservedSizeScorm, SCORM_NAV_CONTAINER_HEIGHT);
  };
  var onExitSessionHandler = function onExitSessionHandler() {
    if (!scoObjectiveHasBeenCompleted()) {
      _scormConfirmCompleteModalView = ScormConfirmCompleteModalView$1.create(_$container, {
        canResumeVideo: canSuspendScormSession(),
        failedToSaveSuspendedData: false
      });
    } else {
      exitScormSession();
    }
  };
  var onExitSessionConfirmedHandler = function onExitSessionConfirmedHandler() {
    _scormConfirmCompleteModalView && _scormConfirmCompleteModalView.destroy();
    _scormConfirmCompleteModalView = null;
    exitScormSession();
  };
  var onExitSessionWithOutProgressConfirmed = function onExitSessionWithOutProgressConfirmed() {
    _ignoreFailedToSuspendError = true;
    onExitSessionConfirmedHandler();
  };
  var initView = function initView($container) {
    _$container = $container;
    if (_scormApiWrapper.apiVersion === scormConstants.versions.NOT_DETECTED) {
      _$container.trigger(events.SCORM.FailedToFindApi);
      return;
    }
    _$container.addClass(cssClasses.scormModule);
    _$container.on(events.SCORM.ExitSession, onExitSessionHandler);
    _$container.on(events.SCORM.ExitSessionConfirmed, onExitSessionConfirmedHandler);
    _$container.on(events.SCORM.ExitSessionWithOutProgressConfirmed, onExitSessionWithOutProgressConfirmed);
    createNavigationBarView();
  };
  var exitScormSession = function exitScormSession() {
    var endedSuccessStatus = endScormSession();
    if (endedSuccessStatus || _ignoreFailedToSuspendError) {
      terminateScormSession();
      _preventWindowClose = false;
    }
  };
  var preventPopUpWindowClose = function preventPopUpWindowClose() {
    try {
      if (window.top && window.top.opener) {
        window.top.onbeforeunload = function () {
          if (_preventWindowClose) {
            return '';
          }
        };
      }
    } catch (e) {
      // eslint-disable-line
    }
  };
  var initializeCompletionStatus = function initializeCompletionStatus() {
    var completionStatus = _scormApiWrapper.apiCall(scormConstants.fn.getValue, scormConstants.dataModelID.cmiCompletionStatus, true);
    if (completionStatus === scormConstants.status.unknown || completionStatus === scormConstants.status.notAttempted) {
      _scormModel.completionStatus = scormConstants.status.incomplete;
      _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiCompletionStatus, scormConstants.status.incomplete);
    } else {
      _scormModel.completionStatus = completionStatus;
    }
  };

  // as a backup, try and terminate the SCORM session if the user did not do it.
  // most likely this will not work with some browsers with some LMSs
  var tryAndTerminateSessionOnPageUnloadIfNeeded = function tryAndTerminateSessionOnPageUnloadIfNeeded() {
    if (!_isDisposed) {
      exitScormSession();
    }
  };
  var initializeObjectiveStatus = function initializeObjectiveStatus() {
    _scormApiWrapper.apiCall(scormConstants.fn.setValue, scormConstants.dataModelID.cmiObjectives0Id, scormConstants.objectiveId);
  };
  var init = function init() {
    initializeInternalState();
    _sessionStartTimeInMilliseconds = window.performance.now();
    return _scormApiWrapper.init().then(function (apiResult) {
      if (apiResult === 'false') {
        console.error(_scormApiWrapper.getLastError());
        return;
      }
      if (apiResult !== 'test') {
        preventPopUpWindowClose();
        getSuspendedDataFromAPI();
        initializeCompletionStatus();
        initializeObjectiveStatus();
        if (_quizModel !== null) {
          submitMinMaxScoreValuesToScormApi();
        }
        window.addEventListener('unload', tryAndTerminateSessionOnPageUnloadIfNeeded);
      }
      _initialized = true;
    });
  };

  /**
   * Submit percentage of video watched to SCORM api
   * @function submitVideoWatchedPercentage
   * @memberof TSC.scormController
   * @param {Number} percentageWatched - Percentage of video watched from 0 - 1
   * @param {Number} timeInSeconds - Current time of video in seconds
   */
  var submitVideoWatchedPercentage = function submitVideoWatchedPercentage(percentageWatched, timeInSeconds) {
    if (!_initialized) {
      return;
    }
    // Note: the percentage reported via value reports how much was actually watched
    //       and not the percentage of the timeline that the playhead is at.
    //       So, for example, if you started up a video and then immediately seeked to
    //       the 75% pt, the values reported here would still start from zero.
    _scormModel.percentageComplete = Math.max(0, Math.min(1, percentageWatched));
    _scormModel.videoTimeInSeconds = timeInSeconds;
    if (_scormModel.percentageComplete >= _minimumViewPercentageToCompleteLesson) {
      _scormModel.completionStatus = scormConstants.status.completed;
    }
    if (scoObjectiveHasBeenCompleted()) {
      if (_scormNavigationBarView) {
        _scormNavigationBarView.updateView(true);
      }
      if (playerConfiguration.completeScormOnRequirementsComplete) {
        endScormSession();
      }
    }
  };

  /**
   * Submit a score to the SCORM api
   * @memberof TSC.scormController
   * @function submitScore
   * @param {Number} currentScore - Score to report to Scorm
   * @param {Boolean} allQuestionsAnswered - Are all questions answered
   */
  var submitScore = function submitScore(currentScore, allQuestionsAnswered) {
    if (!_initialized) {
      return;
    }
    var scoreNeededToPass = _minimumScoreToPass;
    if (!isNaN(currentScore)) {
      var scoreNeededMultiplier = null;
      var maxPassingScoreValue = null;
      if (_scormApiWrapper.apiVersion === scormConstants.versions.SCORM_2004) {
        scoreNeededMultiplier = 100;
        maxPassingScoreValue = 1;
      } else if (_scormApiWrapper.apiVersion === scormConstants.versions.SCORM_1_2) {
        scoreNeededMultiplier = 1;
        maxPassingScoreValue = 100;
      }

      // lms defined mastery level will take precedence over sco defined mastery level
      var lmsPassingScore = _scormApiWrapper.apiCall(scormConstants.fn.getValue, scormConstants.dataModelID.cmiScaledPassingScore);
      if (lmsPassingScore !== null && lmsPassingScore !== '' && lmsPassingScore >= 0 && lmsPassingScore <= maxPassingScoreValue) {
        scoreNeededToPass = lmsPassingScore * scoreNeededMultiplier;
      }
      _scormModel.quizPercentageCorrect = currentScore;
      _scormModel.quizCompletionStatus = allQuestionsAnswered ? scormConstants.status.completed : scormConstants.status.incomplete;
      if (allQuestionsAnswered) {
        if (_quizModel.totalNumberOfGradedQuestionSets === 0) {
          _scormModel.passingStatus = scormConstants.status.completed;
        } else if (currentScore >= scoreNeededToPass) {
          _scormModel.passingStatus = scormConstants.status.passed;
        } else {
          _scormModel.passingStatus = scormConstants.status.failed;
        }
      } else {
        _scormModel.passingStatus = scormConstants.status.unknown;
      }
      if (scoObjectiveHasBeenCompleted()) {
        if (_scormNavigationBarView) {
          _scormNavigationBarView.updateView(true);
        }
        if (playerConfiguration.completeScormOnRequirementsComplete) {
          endScormSession();
        }
      }
    }
  };

  /**
   * Submit a quiz interaction to the SCORM API.
   * @memberof TSC.scormController
   * @function submitInteraction
   * @param {number} interactionIndex
   * @param {string} interactionType
   * @param {(string|number|undefined)} userResponse
   * @param {(Array.<string>|string|number|null)} correctResponse
   * @param {(string|null)} result
   */
  var submitInteraction = function submitInteraction(interactionIndex, interactionType, userResponse, correctResponse, result) {
    if (!_initialized) {
      return;
    }
    _scormApiWrapper.submitInteraction(interactionIndex, interactionType, userResponse, correctResponse, result);
  };
  return Object.defineProperties({
    init: init,
    initView: initView,
    submitVideoWatchedPercentage: submitVideoWatchedPercentage,
    submitScore: submitScore,
    submitInteraction: submitInteraction
  }, {
    initialized: {
      get: function get() {
        return _initialized;
      }
    },
    initialPercentageComplete: {
      get: function get() {
        return _scormModel.percentageComplete;
      }
    },
    initialVideoAnalyticsSnapshot: {
      get: function get() {
        return _scormModel.videoAnalyticsSnapshot;
      }
    },
    initialQuizModelSnapshot: {
      get: function get() {
        return _scormModel.quizModelSnapshot;
      }
    },
    initialVideoTimeInSeconds: {
      get: function get() {
        return _scormModel.videoTimeInSecondsSnapshot;
      }
    },
    minScoreToPassLesson: {
      get: function get() {
        return _minimumScoreToPass;
      },
      set: function set(minimumScoreToPass) {
        _minimumScoreToPass = minimumScoreToPass;
      }
    },
    minViewPercentageToCompleteLesson: {
      get: function get() {
        return _minimumViewPercentageToCompleteLesson;
      },
      set: function set(minimumViewPercentageToCompleteLesson) {
        _minimumViewPercentageToCompleteLesson = minimumViewPercentageToCompleteLesson;
      }
    },
    quizModel: {
      get: function get() {
        return _quizModel;
      },
      set: function set(quizModel) {
        _quizModel = quizModel;
        if (_quizModel !== null && _scormApiWrapper) {
          submitMinMaxScoreValuesToScormApi();
        }
      }
    },
    scoObjectiveHasBeenCompleted: {
      get: scoObjectiveHasBeenCompleted
    },
    supportsResumeSession: {
      get: canSuspendScormSession
    }
  });
};
var scormController$1 = scormController();

var getCorrectAnswerIndex = function getCorrectAnswerIndex(question) {
  for (var index = 0; index < question.answers.length; index++) {
    var bitShiftedIndex = 1 << index;
    if (bitShiftedIndex === question.correctAnswer) {
      return index;
    }
  }
  return -1;
};

/**
 * @memberof TSC
 * @class xmpGrader
 * @classdesc Xmp Grader question sets
 */
var gradeChoiceQuestion = function gradeChoiceQuestion(question, response) {
  var correctAnswer = question.correctAnswer;
  var isCorrect;
  var responseNumber = parseInt(response, 10);
  if (isNaN(responseNumber)) {
    isCorrect = false;
  } else {
    /*eslint no-bitwise: "off"*/
    isCorrect = 1 << responseNumber === correctAnswer;
  }
  question.isResponseCorrect = isCorrect;
  question.isGraded = correctAnswer !== undefined && correctAnswer > 0;
  if (scormController$1.initialized) {
    var scormResult = scormConstants.interactionResults.neutral;
    var scormUserResponseNumber = isNaN(responseNumber) ? '' : responseNumber + 1;
    var correctAnswerIndex = getCorrectAnswerIndex(question);
    var scormCorrectAnswerNumber = correctAnswerIndex === -1 ? null : correctAnswerIndex + 1;
    if (question.isGraded) {
      scormResult = question.isResponseCorrect ? scormConstants.interactionResults.correct : scormConstants.interactionResults.incorrect;
    }
    scormController$1.submitInteraction(question.id, scormConstants.interactionTypes.choice, scormUserResponseNumber, scormCorrectAnswerNumber, scormResult);
  }
};
var gradeFillInTheBlankQuestion = function gradeFillInTheBlankQuestion(question, response) {
  var responseLowerCase = response !== undefined ? response.toLowerCase() : '';
  var possibleAnswers = question.answers;
  var numberPossibleAnswers = possibleAnswers ? possibleAnswers.length : 0;
  question.isGraded = numberPossibleAnswers > 0;
  if (question.isGraded) {
    question.isResponseCorrect = false;
    for (var i = 0; i < numberPossibleAnswers; i++) {
      if (responseLowerCase === possibleAnswers[i].text.toLowerCase()) {
        question.isResponseCorrect = true;
        break;
      }
    }
  }
  if (scormController$1.initialized) {
    var scormPossibleAnswerList = null;
    var scormResult = scormConstants.interactionResults.neutral;
    if (question.isGraded) {
      scormPossibleAnswerList = possibleAnswers.map(function (answer) {
        return answer.text;
      });
      scormResult = question.isResponseCorrect ? scormConstants.interactionResults.correct : scormConstants.interactionResults.incorrect;
    }
    scormController$1.submitInteraction(question.id, scormConstants.interactionTypes.fillIn, response, scormPossibleAnswerList, scormResult);
  }
};
var gradeLongFillInTheBlankQuestion = function gradeLongFillInTheBlankQuestion(question, response) {
  if (scormController$1.initialized) {
    scormController$1.submitInteraction(question.id, scormConstants.interactionTypes.longFillIn, response, null, scormConstants.interactionResults.neutral);
  }
};
var gradeQuestion = function gradeQuestion(question) {
  if (question.type === questionType.CHOICE) {
    gradeChoiceQuestion(question, question.userResponse);
  } else if (question.type === questionType.FILL_IN) {
    gradeFillInTheBlankQuestion(question, question.userResponse);
  } else if (question.type === questionType.SHORT) {
    gradeLongFillInTheBlankQuestion(question, question.userResponse);
  }
};
var gradeQuestionSet = function gradeQuestionSet(questionSet) {
  questionSet.questions.forEach(function (question) {
    if (question.responseLocked) {
      gradeQuestion(question);
    }
  });
};
var xmpGrader = Object.defineProperties({
  gradeQuestionSet: gradeQuestionSet
}, {
  doesLocalGrading: {
    value: true
  }
});

var _containerId = '.question-set-container';
var _superView = BubbleView$1.create(_containerId);
var _showAnswersId = '.view-answers-button';
var _hideAnswersId = '.hide-answers-button';
var _gradeableDetails;
var _unGradeableDetails;
var _readingSelector = '.question-set-results';
var questionSetReviewStatusView = {
  setGradeableDetails: function setGradeableDetails(text) {
    _gradeableDetails = text;
  },
  setUngradeableDetails: function setUngradeableDetails(text) {
    _unGradeableDetails = text;
  },
  getViewMarkup: function getViewMarkup() {
    return templateGenerator.generateQuestionSetReviewStatusMarkup(_gradeableDetails, _unGradeableDetails) + _superView.getOverlayMarkup();
  },
  getHideAnswersControlRef: function getHideAnswersControlRef() {
    return _hideAnswersId;
  },
  getShowAnswersControlRef: function getShowAnswersControlRef() {
    return _showAnswersId;
  },
  showView: function showView() {
    var $container = $(_containerId);
    $container.removeClass('minimized');
    _superView.showView();
    var $readableElement = $container.find(_readingSelector);
    $readableElement.focus();
    highlightDisabler.disableHighlights($readableElement);
  },
  hideView: function hideView() {
    $(_containerId).addClass('minimized');
    _superView.hideView();
  },
  removeView: _superView.removeView,
  updateViewPosition: _superView.updateViewPosition,
  setBottomOffset: _superView.setBottomOffset,
  pointAt: _superView.pointAt
};

var CONTROL_BAR_HEIGHT = 48;
var BOTTOM_PADDING = 14;

/**
 * @memberof TSC
 * @class QuizController
 * @classdesc Quiz Controller manages questions state and views.
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.Quiz} quizModel
 * @param {TSC.BeforeAfterPlayControlsView} beforeAfterPlayControlsView
 * @param {boolean} enforceLinearAssessment
 *
 */
var QuizController = function QuizController($container, mediaView, quizModel, beforeAfterPlayControlsView, enforceLinearAssessment) {
  var hasQuiz = !!quizModel;
  if (!hasQuiz) {
    throw new Error('Attempted to create quiz controller with no quiz model');
  }
  var _currentView = null;
  var _quizModel = null;
  var _numberQuestionSets = 0;
  var _currentQuestionSetIndex = 0;
  var _bottomOffset = 0;
  var _pointAt = null;
  var _quizEnabled = true;
  var _quizReady = false;
  var _mediaIsImage = mediaView.type === mediaViewType.image;
  var _lastStatusMessage = '';
  var _questionGrader;
  var _quizSetupPromise;
  var _resolveQuizSetup;
  var submitScoreToScormController = function submitScoreToScormController() {
    if (_quizModel.useScorm) {
      // Built in Scorm support
      if (scormController$1.initialized) {
        scormController$1.submitScore(_quizModel.getScormScore(), _quizModel.isLastQuestionComplete());
        // Legacy Scorm support
      } else if (typeof window.userSubmitToLMS !== 'undefined') {
        window.userSubmitToLMS(_quizModel.getScormScore());
      }
    }
  };
  var completeQuestionSetEventDispatch = function completeQuestionSetEventDispatch() {
    $container.trigger(events.Quizzing.Complete);
    hotkeyService.enableHotkeys();
  };
  var questionSetCompleteHandler = function questionSetCompleteHandler() {
    _currentQuestionSetIndex = -1;
    _currentView.removeView(true);
    _currentView = null;
    completeQuestionSetEventDispatch();
  };
  var dispatchStatusEvent = function dispatchStatusEvent(ioMessage) {
    _lastStatusMessage = ioMessage;
    $container.trigger(events.Quizzing.Status, {
      message: ioMessage
    });
  };
  var onContinueHandler = function onContinueHandler() {
    $container.off(events.Quizzing.CloseQuestionSetView, onContinueHandler);
    questionSetCompleteHandler();
  };
  var createQuestionSetFeedbackView = function createQuestionSetFeedbackView(needOverlay) {
    var questionSetView = QuestionSetView$1.create($container, _quizModel.questionSets[_currentQuestionSetIndex], needOverlay, _mediaIsImage, true, mediaView.currentTime);
    $container.on(events.Quizzing.CloseQuestionSetView, onContinueHandler);
    _currentView = questionSetView;
    _currentView.showView();
  };
  var continueVideoHandler = function continueVideoHandler() {
    $(reviewAnswersConfirmationView.getContinueControlRef()).off('click', continueVideoHandler);
    $(reviewAnswersConfirmationView.getReviewControlRef()).off('click', initQuestionSetFeedback);
    reviewAnswersConfirmationView.removeView(true);
    _currentView = null;
    completeQuestionSetEventDispatch();
  };
  var initQuestionSetFeedback = function initQuestionSetFeedback() {
    $(reviewAnswersConfirmationView.getContinueControlRef()).off('click', continueVideoHandler);
    $(reviewAnswersConfirmationView.getReviewControlRef()).off('click', initQuestionSetFeedback);
    reviewAnswersConfirmationView.removeView(false);
    _currentView = null;
    createQuestionSetFeedbackView();
  };
  var createReviewAnswersConfirmationView = function createReviewAnswersConfirmationView() {
    var numberCorrectText = null;
    var percentCorrectText = null;
    var numberIncorrectText = null;
    var percentIncorrectText = null;
    var numberCorrect = 0;
    var numberIncorrect = 0;
    var numberUngradable = 0;
    var possibleCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberGradedQuestions;
    if (possibleCorrect > 0) {
      numberCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberCorrectQuestions;
      numberIncorrect = possibleCorrect - numberCorrect;
      numberUngradable = _quizModel.questionSets[_currentQuestionSetIndex].numberUngradedQuestions;
      numberCorrectText = localizationStrings.getPlayerString(playerStringNames.txtCorrect).replace('{{numberCorrect}}', numberCorrect);
      percentCorrectText = Math.round(100 * (numberCorrect / possibleCorrect)) + '%';
      numberIncorrectText = localizationStrings.getPlayerString(playerStringNames.txtIncorrect).replace('{{numberIncorrect}}', numberIncorrect);
      percentIncorrectText = Math.round(100 * (numberIncorrect / possibleCorrect)) + '%';
    }
    if (numberUngradable === 1) {
      questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.getPlayerString(playerStringNames.accessBtnWasNotGraded));
    } else {
      questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.getPlayerString(playerStringNames.accessBtnWereNotGraded));
    }
    var markup = reviewAnswersConfirmationView.getViewMarkup(numberCorrectText, percentCorrectText, numberIncorrectText, percentIncorrectText, localizationStrings.getPlayerString(playerStringNames.txtContinue), localizationStrings.getPlayerString(playerStringNames.txtReviewAnswer));

    // add view template
    $container.append(markup);
    _currentView = reviewAnswersConfirmationView;
    $(_currentView.getContinueControlRef()).on('click', continueVideoHandler);
    $(_currentView.getReviewControlRef()).on('click', initQuestionSetFeedback);

    // fade in view
    _currentView.showView();
    updateViewBottom();
    if (_pointAt !== null) {
      _currentView.pointAt(_pointAt);
    }
  };
  var createQuestionSetReviewStatusView = function createQuestionSetReviewStatusView() {
    var numberCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberCorrectQuestions;
    var possibleCorrect = _quizModel.questionSets[_currentQuestionSetIndex].numberGradedQuestions;
    var numberUngradable = _quizModel.questionSets[_currentQuestionSetIndex].numberUngradedQuestions;
    questionSetReviewStatusView.setGradeableDetails(numberCorrect + localizationStrings.getPlayerString(playerStringNames.accessBtnCorrectOutOf) + possibleCorrect + localizationStrings.getPlayerString(playerStringNames.accessBtnGradedQuestions));
    if (numberUngradable === 1) {
      questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.getPlayerString(playerStringNames.accessBtnWasNotGraded));
    } else {
      questionSetReviewStatusView.setUngradeableDetails(numberUngradable + localizationStrings.getPlayerString(playerStringNames.accessBtnWereNotGraded));
    }
    var markup = questionSetReviewStatusView.getViewMarkup();
    $container.append(markup);
    _currentView = questionSetReviewStatusView;
    $(questionSetReviewStatusView.getHideAnswersControlRef()).on('click', hideQuizStatus);
    $(questionSetReviewStatusView.getShowAnswersControlRef()).on('click', initFeedbackFromReviewStatusView);
    questionSetReviewStatusView.showView();
    _currentView.updateViewPosition();
  };
  var initFeedbackFromReviewStatusView = function initFeedbackFromReviewStatusView() {
    $(questionSetReviewStatusView.getHideAnswersControlRef()).off('click', hideQuizStatus);
    $(questionSetReviewStatusView.getShowAnswersControlRef()).off('click', initFeedbackFromReviewStatusView);
    questionSetReviewStatusView.removeView(false);
    _currentView = null;
    createQuestionSetFeedbackView();
  };
  var hideQuizStatus = function hideQuizStatus() {
    $container.trigger(events.Quizzing.HideQuiz);
    _currentView.hideView();
  };
  var onRationaleActionHandler = function onRationaleActionHandler(e, data) {
    if (e.type === events.Quizzing.RationaleActionLocation) {
      urlService.openUrl(data.location, '_blank');
    } else if (e.type === events.Quizzing.RationaleActionJumpToTime) {
      $container.off(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
      $container.off(events.Quizzing.SubmitQuestionSet, onSubmit);
      $container.off(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
      $container.off(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);
      questionSetCompleteHandler();
    }
  };
  var onCloseQuestionSetView = function onCloseQuestionSetView() {
    $container.off(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
    $container.off(events.Quizzing.SubmitQuestionSet, onSubmit);
    $container.off(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
    $container.off(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);
    $container.trigger(events.Quizzing.Submitted);
    if (_quizModel.questionSets[_currentQuestionSetIndex].displayFeedback) {
      if (_mediaIsImage) {
        $container.trigger(events.Quizzing.TransitionImageQuizToAnswers);
        _currentView.removeView(true);
        createQuestionSetReviewStatusView();
      } else {
        _currentView.removeView(false);
        createReviewAnswersConfirmationView();
      }
    } else {
      questionSetCompleteHandler();
    }
  };
  var submitResults = function submitResults() {
    dispatchStatusEvent(localizationStrings.getPlayerString(playerStringNames.txtSubmittingAnswers));
    return Promise$1.resolve();
  };
  var gradeResults = function gradeResults() {
    _questionGrader.gradeQuestionSet(_quizModel.questionSets[_currentQuestionSetIndex]);
    return Promise$1.resolve();
  };
  var onGradingComplete = function onGradingComplete() {
    if (_quizModel.useScorm) {
      submitScoreToScormController();
    }
    if (_quizModel.questionSets[_currentQuestionSetIndex].usesRationale) {
      $container.trigger(events.Quizzing.HideLoadingMessage);
      _currentView.showFeedbackForCurrentQuestion();
    } else {
      onCloseQuestionSetView();
    }
  };
  var onSubmit = function onSubmit() {
    submitResults().then(gradeResults).then(onGradingComplete);
  };
  var createQuestionSetView = function createQuestionSetView(needOverlay) {
    var questionSetView = QuestionSetView$1.create($container, _quizModel.questionSets[_currentQuestionSetIndex], needOverlay, _mediaIsImage, false, mediaView.currentTime);
    if (_quizModel.questionSets[_currentQuestionSetIndex].usesRationale) {
      $container.on(events.Quizzing.SubmitQuestionSet, onSubmit);
      $container.on(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
      $container.on(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
      $container.on(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);
    } else {
      $container.on(events.Quizzing.SubmitQuestionSet, onSubmit);
    }
    _currentView = questionSetView;
    _currentView.showView();
    $container.trigger(events.Quizzing.ShowQuestionSetView);
    return questionSetView;
  };
  var reviewHandler = function reviewHandler() {
    _currentView.removeView(true);
    _currentView = null;
    $container.trigger(events.Quizzing.Review);
    hotkeyService.enableHotkeys();
  };
  var onViewRemove = function onViewRemove() {
    if (_currentQuestionSetIndex < _numberQuestionSets) {
      createQuestionSetView(false);
    }
  };
  var confirmHandler = function confirmHandler() {
    _currentView.removeView();
    _currentView = null;
    onViewRemove();
  };
  var createConfirmView = function createConfirmView() {
    var reviewText;
    if (enforceLinearAssessment) {
      reviewText = localizationStrings.getPlayerString(playerStringNames.txtReview);
    } else {
      reviewText = localizationStrings.getPlayerString(playerStringNames.txtContinue);
    }
    var markup = questionSetConfirmationView.getViewMarkup(reviewText, localizationStrings.getPlayerString(playerStringNames.txtAnswerQuestion));
    $container.append(markup);
    _currentView = questionSetConfirmationView;
    updateViewBottom();
    if (_quizModel.hideReplay === true) {
      $(questionSetConfirmationView.getReviewControlRef()).hide();
    }
    $(questionSetConfirmationView.getReviewControlRef()).on('click', reviewHandler);
    $(questionSetConfirmationView.getConfirmControlRef()).on('click', confirmHandler);
    questionSetConfirmationView.showView();
    questionSetConfirmationView.updateViewPosition();
    $container.trigger(events.Quizzing.ShowStartQuizPrompt);
  };
  var updateViewBottom = function updateViewBottom() {
    if (_currentView && _currentView.setBottomOffset) {
      _currentView.setBottomOffset(_bottomOffset);
      _currentView.updateViewPosition();
    }
  };
  var getLastStatusMessage = function getLastStatusMessage() {
    return _lastStatusMessage;
  };
  var displayNextQuestionSet = function displayNextQuestionSet() {
    if (_currentQuestionSetIndex < _numberQuestionSets) {
      return createQuestionSetView(true);
    }
  };
  var hasMultipleQuestionSets = function hasMultipleQuestionSets() {
    return _numberQuestionSets > 1;
  };
  var hasQuizQuestions = function hasQuizQuestions() {
    return _numberQuestionSets > 0;
  };
  var findQuestionSet = function findQuestionSet(time) {
    var activeQuestionSetId = -1;
    var markerTime = -1;
    if (!playerConfiguration.ignoreQuizQuestions) {
      var markers = _quizModel.questionSetMarkerTimes;
      var numberMarkers = markers.length;
      for (var i = 0; i < numberMarkers; i++) {
        if (!markers[i].completed && (enforceLinearAssessment && markers[i].startTime <= time && !markers[i].canSeekPast || markers[i].rangeStart <= time && time <= markers[i].rangeEnd)) {
          activeQuestionSetId = markers[i].questionSetIndex;
          markerTime = markers[i].startTime;
          break;
        }
      }
    }
    return {
      id: activeQuestionSetId,
      markerTime: markerTime
    };
  };
  var findPrevMarkerTimeForMarker = function findPrevMarkerTimeForMarker(questionSetIndex) {
    return _quizModel.getPreviousMarkerTimeForMarker(questionSetIndex);
  };
  var updatePercentWatchedForQuestionSet = function updatePercentWatchedForQuestionSet(questionSetId, percentWatched) {
    _quizModel.questionSets[questionSetId].percentOfVideoSegmentWatched = percentWatched;
  };
  var displayConfirm = function displayConfirm(questionSetIndex) {
    if (!_currentView) {
      _currentQuestionSetIndex = questionSetIndex;
      hotkeyService.disableHotkeys();

      // no need to display confirm view if we are in the beginning of the video and force linear is on or if we are in the middle of a rationale quiz
      if (enforceLinearAssessment && _quizModel.questionSets[questionSetIndex].startTime <= _quizModel.minMarkerTimeDiff || _quizModel.questionSets[questionSetIndex].inProgress) {
        createQuestionSetView(true);
      } else {
        createConfirmView();
      }
    }
  };
  var showQuiz = function showQuiz() {
    if (_currentView === null) {
      createQuestionSetView(true);
    } else {
      _currentView.showView();
    }
  };
  var hideQuiz = function hideQuiz() {
    _currentView.hideView();
  };
  var pointViewAt = function pointViewAt(xPos) {
    _pointAt = xPos;
    if (_currentView) {
      if (_currentView.pointAt) {
        _currentView.pointAt(_pointAt);
      }
      updateViewBottom();
    }
  };
  var setViewControlBarOffset = function setViewControlBarOffset(bottom) {
    _bottomOffset = bottom + BOTTOM_PADDING;
    updateViewBottom();
  };
  var setQuestionGrader = function setQuestionGrader(grader) {
    switch (grader) {
      case questionGrader.XMP:
        {
          _questionGrader = xmpGrader;
          break;
        }
      default:
        throw new Error('Grader type not recognized');
    }
  };
  var onMediaFirstPlayerHandler = function onMediaFirstPlayerHandler() {
    init();
  };
  var onMediaControlsReady = function onMediaControlsReady() {
    // do not listen to another media controls ready event
    $container.off(events.Player.MediaControlsReady, onMediaControlsReady);
    setViewControlBarOffset(CONTROL_BAR_HEIGHT);
    _resolveQuizSetup();
  };
  var bindToEvents = function bindToEvents() {
    $container.on(events.Media.FirstPlay, onMediaFirstPlayerHandler);
    $container.on(events.Player.MediaControlsReady, onMediaControlsReady);
  };
  var destroy = function destroy() {
    if (_currentView) {
      _currentView.removeView(true);
      _currentView = null;
    }
    if ($container) {
      $container.off(events.Media.FirstPlay, onMediaFirstPlayerHandler);
      $container.off(events.Player.MediaControlsReady, onMediaControlsReady);
      $container.off(events.Quizzing.SubmitQuestionSet, onSubmit);
      $container.off(events.Quizzing.CloseQuestionSetView, onCloseQuestionSetView);
      $container.off(events.Quizzing.RationaleActionLocation, onRationaleActionHandler);
      $container.off(events.Quizzing.RationaleActionJumpToTime, onRationaleActionHandler);
    }
    _quizModel = null;
    _numberQuestionSets = 0;
    _currentQuestionSetIndex = 0;
    _bottomOffset = 0;
    _pointAt = null;
    _quizEnabled = true;
    _quizReady = false;
    _mediaIsImage = false;
    _lastStatusMessage = '';
    _questionGrader = null;
    _quizSetupPromise = null;
  };
  var init = function init() {
    $container.trigger(events.Quizzing.CreatedInstance);
    _quizReady = true;
  };
  var populateQuizModel = function populateQuizModel(suspendedQuizData) {
    _quizModel.populateQuiz(suspendedQuizData);
    submitScoreToScormController();
  };
  var setQuizModel = function setQuizModel(newQuizModel) {
    _quizModel = newQuizModel;
    _numberQuestionSets = _quizModel.numberQuestionSets;
    scormController$1.quizModel = _quizModel;
  };

  // begin initialization of quiz controller
  _quizSetupPromise = new Promise$1(function (resolveQuizSetup) {
    _resolveQuizSetup = resolveQuizSetup;
  });
  setQuizModel(quizModel);
  bindToEvents();
  setQuestionGrader(questionGrader.XMP);
  var fullControlsAreShownOnPageLoad = playerConfiguration.getPreload() === preloadOptions.metadata && mediaView.type !== mediaViewType.youtube;
  if (fullControlsAreShownOnPageLoad) {
    onMediaControlsReady();
  }
  return Object.defineProperties({
    destroy: destroy,
    hasMultipleQuestionSets: hasMultipleQuestionSets,
    getLastStatusMessage: getLastStatusMessage,
    displayNextQuestionSet: displayNextQuestionSet,
    findQuestionSet: findQuestionSet,
    findPrevMarkerTimeForMarker: findPrevMarkerTimeForMarker,
    updatePercentWatchedForQuestionSet: updatePercentWatchedForQuestionSet,
    displayConfirm: displayConfirm,
    showQuiz: showQuiz,
    hideQuiz: hideQuiz,
    pointViewAt: pointViewAt,
    populateQuizModel: populateQuizModel
  }, {
    quizIsSetupPromise: {
      get: function get() {
        return _quizSetupPromise;
      }
    },
    quizEnabled: {
      get: function get() {
        return _quizEnabled;
      },
      set: function set(value) {
        _quizEnabled = value;
      }
    },
    quizReady: {
      get: function get() {
        return _quizReady;
      }
    },
    hasQuiz: {
      get: function get() {
        return _quizModel && _quizModel.quizID;
      }
    },
    viewIsOpen: {
      get: function get() {
        return _currentView !== null;
      }
    },
    mediaIsImage: {
      set: function set(mediaIsImage) {
        _mediaIsImage = mediaIsImage;
      },
      get: function get() {
        return _mediaIsImage;
      }
    },
    quizModel: {
      get: function get() {
        return _quizModel;
      },
      set: setQuizModel
    },
    hasQuizQuestions: {
      get: hasQuizQuestions
    }
  });
};
var QuizController$1 = {
  /**
   *  Factory method that returns a new QuizController.
   *  @function create
   *  @memberof TSC.QuizController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.Quiz} quizModel
   *  @param {TSC.BeforeAfterPlayControlsView} beforeAfterPlayControlsView
   *  @param {boolean} enforceLinearAssessment
   *  @return new QuizController instance
   */
  create: QuizController
};

var SEEK_DELAY_IN_MILLISECONDS = 100;

/**
 * @memberof TSC
 * @class QuizEventController
 * @classdesc Controller for managing quiz events
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.QuizController} quizController
 * @param {TSC.ProgressBarControlView} progressBarControlView
 * @param {boolean} enforceLinearAssessment
 * @param {TSC.IoOverlayView} ioOverlayView - IO Overlay View used to show the user messages
 *
 */
var QuizEventController = function QuizEventController($container, mediaView, quizController, progressBarControlView, enforceLinearAssessment, ioOverlayView) {
  if (!quizController) {
    throw new Error('Attempted to create quiz event controller with no quiz controller');
  }
  var _lastQuestionSetId;
  var _lastQuestionSetMarkerTime;
  var _isScrubbing = false;
  var updateQuizPointAtPosition = function updateQuizPointAtPosition() {
    if (!progressBarControlView) {
      return;
    }
    var playerXOffset = $container.offset().left;
    var markerXPosition = progressBarControlView.getXPositionForQuestionSetMarker(_lastQuestionSetId);
    var pointAtXPosition = markerXPosition - playerXOffset;
    quizController.pointViewAt(pointAtXPosition);
  };
  var seekToTime = function seekToTime(seekTime, playAfterSeek) {
    var safeSeekTime = videoApiUtils.getSafeSeekTime(mediaView.mediaElement, seekTime);
    $container.trigger(events.Media.SeekToTime, {
      time: safeSeekTime,
      playAfterSeek: playAfterSeek
    });
  };
  var updateQuizzing = function updateQuizzing(currentTimeInMilliseconds) {
    if (!quizController.quizEnabled || _isScrubbing) {
      return;
    }
    var numberMillisecondsInSecond = 1000;
    var qs = quizController.findQuestionSet(currentTimeInMilliseconds);
    if (qs.id < 0) {
      _lastQuestionSetId = -1;
      return;
    }
    if (_lastQuestionSetId !== qs.id) {
      viewHelper.saveActiveElement();
      // make sure control bar is shown up and auto hide is disabled.
      $container.trigger(events.Controls.Disable);
      $container.trigger(events.Controls.HideToc);
      _lastQuestionSetId = qs.id;
      _lastQuestionSetMarkerTime = qs.markerTime / numberMillisecondsInSecond;
      $container.playerState.pausedForQuiz = true;
      mediaView.mediaElement.pause();
      $container.trigger(events.Quizzing.Paused);

      // Try pausing and seeking YouTube until player confirms the video is in the correct position
      // Fixes issues with YouTube video playing in the background
      if (mediaView.type === mediaViewType.youtube) {
        var intervalId = setInterval(function () {
          mediaView.mediaElement.pause();
          seekToTime(_lastQuestionSetMarkerTime, false);
          if (mediaView.mediaElement.currentTime.toFixed(4) === _lastQuestionSetMarkerTime.toFixed(4) && mediaView.mediaElement.paused) {
            clearInterval(intervalId);
          }
        }, SEEK_DELAY_IN_MILLISECONDS);
      } else {
        setTimeout(function () {
          seekToTime(_lastQuestionSetMarkerTime, false);
        }, SEEK_DELAY_IN_MILLISECONDS);
      }
      quizController.displayConfirm(qs.id);
      updateQuizPointAtPosition();
      if (videoAnalytics.isEnabled()) {
        if (!isNaN(qs.markerTime) && videoAnalytics.isPercentWatchedInitialized()) {
          videoAnalytics.markTimeWatched(qs.markerTime);
        } else {
          log.logMessage('Player-view: videoAnalytics percent watched not initialized, or Quiz Marker time is NaN (' + qs.markerTime + ')');
        }
        var percentWatched = videoAnalytics.getPercentageWatchedForVideoSegment(quizController.findPrevMarkerTimeForMarker(qs.id), qs.markerTime);
        quizController.updatePercentWatchedForQuestionSet(_lastQuestionSetId, percentWatched);
      }
    }
  };
  var quizEventHandler = function quizEventHandler(event, data) {
    switch (event.type) {
      case events.Quizzing.ShowStartQuizPrompt:
      case events.Quizzing.ShowQuestionSetView:
        $container.trigger(events.Quizzing.MaximizeUI);
        $container.trigger(events.Quizzing.UIVisible);
        break;
      case events.Quizzing.Complete:
      case events.Quizzing.Review:
        $container.trigger(events.Quizzing.UIHidden);
        $container.trigger(events.Controls.Enable);
        viewHelper.focusPreviousElement();
        progressBarControlView.updateQuizMarkers();
        $container.playerState.pausedForQuiz = false;
        if (event.type === events.Quizzing.Review && enforceLinearAssessment) {
          var prevMarkerTimeInSeconds = quizController.findPrevMarkerTimeForMarker(_lastQuestionSetId) / 1000;
          _lastQuestionSetId = -1;
          seekToTime(prevMarkerTimeInSeconds, true);
        } else {
          mediaView.mediaElement.play();
        }
        break;
      case events.Quizzing.Status:
        ioOverlayView.displayMessage(data.message);
        break;
      case events.Quizzing.HideLoadingMessage:
      case events.Quizzing.Submitted:
        ioOverlayView.hideView();
        break;
      case events.Quizzing.CreatedInstance:
        progressBarControlView && progressBarControlView.updateQuizMarkers();
        $container.trigger(events.Quizzing.UIHidden);
        break;
      case events.Quizzing.RationaleActionJumpToTime:
        var jumpToTimeInSeconds = data.jumpToTime / 1000;
        progressBarControlView.allowSkipQuestionSetMarkersBeforeTime(jumpToTimeInSeconds);
        seekToTime(jumpToTimeInSeconds);
        break;
    }
  };
  var onLoadedMetadata = function onLoadedMetadata() {
    // check to see if quiz exists and it is ready to rumble
    if (!quizController.hasQuiz || quizController.hasQuiz && (!quizController.quizEnabled || quizController.quizReady)) {
      ioOverlayView.hideView();
    } else {
      // update overlay with status of quiz code
      var lastStatusMessage = quizController.getLastStatusMessage();
      if (lastStatusMessage) {
        mediaView.mediaElement.pause();
        ioOverlayView.displayMessage(lastStatusMessage);
      }
    }
  };
  var onVideoTimeUpdate = function onVideoTimeUpdate() {
    updateQuizzing(mediaView.currentTimeInMilliseconds);
  };
  var onSeeked = function onSeeked() {
    updateQuizzing(mediaView.currentTimeInMilliseconds);
  };
  var onVideoControlsVisible = function onVideoControlsVisible() {
    progressBarControlView.updateQuizMarkers();
  };
  var onScrubbingStarted = function onScrubbingStarted() {
    _isScrubbing = true;
  };
  var onScrubbingEnded = function onScrubbingEnded() {
    _isScrubbing = false;
    onVideoTimeUpdate();
  };
  var bindToEvents = function bindToEvents() {
    mediaView.mediaWrapper.on('ratechange', onVideoTimeUpdate, false);
    mediaView.mediaWrapper.on('play', onVideoTimeUpdate, false);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      timeupdate: onVideoTimeUpdate,
      seeked: onSeeked
    };
    mediaView.mediaWrapper.on(eventsToBind);
    $container.on(events.Controls.VideoControlsVisible, onVideoControlsVisible);
    $container.on(events.Controls.PlayerResize, updateQuizPointAtPosition);
    $container.on(events.Quizzing.Complete, quizEventHandler);
    $container.on(events.Quizzing.Review, quizEventHandler);
    $container.on(events.Quizzing.Status, quizEventHandler);
    $container.on(events.Quizzing.Submitted, quizEventHandler);
    $container.on(events.Quizzing.CreatedInstance, quizEventHandler);
    $container.on(events.Quizzing.RationaleActionJumpToTime, quizEventHandler);
    $container.on(events.Quizzing.HideLoadingMessage, quizEventHandler);
    $container.on(events.Quizzing.ShowStartQuizPrompt, quizEventHandler);
    $container.on(events.Quizzing.ShowQuestionSetView, quizEventHandler);
    $container.on(events.Scrubbing.Started, onScrubbingStarted);
    $container.on(events.Scrubbing.Ended, onScrubbingEnded);
  };
  var unbindToEvents = function unbindToEvents() {
    mediaView.mediaWrapper.off('ratechange', onVideoTimeUpdate, false);
    mediaView.mediaWrapper.off('play', onVideoTimeUpdate, false);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      timeupdate: onVideoTimeUpdate,
      seeked: onSeeked
    };
    mediaView.mediaWrapper.off(eventsToBind);
    $container.off(events.Controls.VideoControlsVisible, onVideoControlsVisible);
    $container.off(events.Controls.PlayerResize, updateQuizPointAtPosition);
    $container.off(events.Quizzing.Complete, quizEventHandler);
    $container.off(events.Quizzing.Review, quizEventHandler);
    $container.off(events.Quizzing.Status, quizEventHandler);
    $container.off(events.Quizzing.Submitted, quizEventHandler);
    $container.off(events.Quizzing.CreatedInstance, quizEventHandler);
    $container.off(events.Quizzing.RationaleActionJumpToTime, quizEventHandler);
    $container.off(events.Quizzing.HideLoadingMessage, quizEventHandler);
    $container.off(events.Quizzing.ShowStartQuizPrompt, quizEventHandler);
    $container.off(events.Quizzing.ShowQuestionSetView, quizEventHandler);
    $container.off(events.Scrubbing.Started, onScrubbingStarted);
    $container.off(events.Scrubbing.Ended, onScrubbingEnded);
  };
  var destroy = function destroy() {
    unbindToEvents();
  };
  videoApiUtils.setQuizController(quizController);
  progressBarControlView && progressBarControlView.setShouldRespectQuizMarkers(quizController.quizModel && quizController.quizEnabled && !playerConfiguration.ignoreQuizQuestions);
  quizController.mediaIsImage = mediaView.type === mediaViewType.image;
  bindToEvents();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var QuizEventController$1 = {
  /**
   *  Factory method that returns a new QuizEventController.
   *  @function create
   *  @memberof TSC.QuizEventController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.QuizController} quizController
   *  @param {TSC.ProgressBarControlView} progressBarControlView
   *  @param {boolean} enforceLinearAssessment
   *  @param {TSC.IoOverlayView} ioOverlayView - IO Overlay View used to show the user messages
   *  @return new QuizEventController instance
   */
  create: QuizEventController
};

var EVENT_PERCENT_WATCH_INC = 10;
var MAX_PERCENT = 100;

/**
 * @memberof TSC
 * @class MediaAnalyticsController
 * @classdesc Controller for managing media analytics
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.MediaList} mediaList
 * @param {TSC.QuizController} quizController
 * @param {TSC.playerConfiguration} playerConfiguration
 */
var MediaAnalyticsController = function MediaAnalyticsController($container, mediaView, mediaList, quizController, playerConfiguration) {
  var _eventPlayTracking = true;
  var _eventLastPercentReported = 0;
  var doesSCORMModuleNeedToResumeLastTime = function doesSCORMModuleNeedToResumeLastTime() {
    return mediaView.supportsSCORM && playerConfiguration.isScormLesson && scormController$1.supportsResumeSession && scormController$1.initialVideoTimeInSeconds > 0;
  };
  var initVideoAnalytics = function initVideoAnalytics() {
    videoAnalytics.initPercentWatched(mediaView.mediaElement.duration * 1000);
    if (doesSCORMModuleNeedToResumeLastTime()) {
      resumeSCORMSession(scormController$1.initialVideoTimeInSeconds, scormController$1.initialVideoAnalyticsSnapshot);
      $container.trigger(events.Media.SeekToTime, {
        time: scormController$1.initialVideoTimeInSeconds,
        playAfterSeek: true
      });
    }
  };
  var updateAnalytics = function updateAnalytics(currentTimeInMilliseconds) {
    if (!mediaView.mediaElement.duration) {
      return;
    }
    if (!videoAnalytics.isEnabled()) {
      return;
    }
    if (!videoAnalytics.isPercentWatchedInitialized()) {
      initVideoAnalytics();
    }
    if (!isNaN(currentTimeInMilliseconds)) {
      videoAnalytics.markTimeWatched(currentTimeInMilliseconds);
    } else {
      log.logMessage('Player-view: currentTime is NaN (' + currentTimeInMilliseconds + ')');
    }
    var percentWatched = Math.round(videoAnalytics.getPercentageWatched() * 100);
    if (scormController$1.initialized) {
      scormController$1.submitVideoWatchedPercentage(0.01 * percentWatched, videoAnalytics.getCurrentPlayTime());
    }
    if (playerConfiguration.getTrackEvents()) {
      if (percentWatched >= _eventLastPercentReported + EVENT_PERCENT_WATCH_INC) {
        while (_eventLastPercentReported + EVENT_PERCENT_WATCH_INC <= percentWatched) {
          _eventLastPercentReported += EVENT_PERCENT_WATCH_INC;
          if (_eventLastPercentReported > MAX_PERCENT) {
            _eventLastPercentReported = MAX_PERCENT;
          }
          analyticsService.sendEvent(events.Analytics.VideoPercentViewed, 'Viewed: ' + _eventLastPercentReported + ' Percent');
          analyticsService.sendGA4Event(events.GA4.VideoPercentViewed, {
            percent_viewed: _eventLastPercentReported
          }); // eslint-disable-line
        }
      }
    }
  };
  var handleTimeUpdate = function handleTimeUpdate(currentTimeInMilliseconds) {
    if (videoAnalytics.isEnabled()) {
      updateAnalytics(currentTimeInMilliseconds);
    }
  };
  var onVideoTimeUpdate = function onVideoTimeUpdate() {
    handleTimeUpdate(mediaView.currentTimeInMilliseconds);
  };
  var onSeeked = function onSeeked() {
    handleTimeUpdate(mediaView.currentTimeInMilliseconds);
  };
  var onCanPlayVideo = function onCanPlayVideo() {
    if (videoAnalytics.isEnabled()) {
      videoAnalytics.setVideoLoadEndTime(new Date().getTime());
      if (playerConfiguration.getTrackEvents()) {
        var eventAction = playerConfiguration.getAltEventCategoryAsFilename() ? analyticsService.getCategory() : mediaList.currentMedia.uri;
        if (playerConfiguration.getAltLoadTimeAsSeconds()) {
          analyticsService.sendEvent(events.Analytics.VideoLoadingTimeInSeconds, eventAction, videoAnalytics.getVideoLoadTime() / 1000);
          analyticsService.sendGA4Event(events.GA4.VideoLoadingTimeInSeconds, {
            loading_duration: videoAnalytics.getVideoLoadTime() / 1000
          }); // eslint-disable-line
        } else {
          analyticsService.sendEvent(events.Analytics.VideoLoadingTime, eventAction, videoAnalytics.getVideoLoadTime());
          analyticsService.sendGA4Event(events.GA4.VideoLoadingTime, {
            loading_duration: videoAnalytics.getVideoLoadTime()
          }); // eslint-disable-line
        }
      }
    }
    mediaView.mediaWrapper.off('canplay', onCanPlayVideo);
  };
  var resetPlayStartAnalytics = function resetPlayStartAnalytics() {
    if (videoAnalytics.isEnabled()) {
      videoAnalytics.setVideoLoadStartTime(new Date().getTime());
    }
    if (playerConfiguration.getTrackEvents() && _eventPlayTracking) {
      _eventPlayTracking = false;
      var videoStartedEventAction = playerConfiguration.getAltEventCategoryAsFilename() ? analyticsService.getCategory() : mediaList.currentMedia.uri;
      analyticsService.sendEvent(events.Analytics.VideoStarted, videoStartedEventAction);
      analyticsService.sendEvent(events.Analytics.VideoPercentViewed, 'Viewed: 0 Percent');
      analyticsService.sendGA4Event(events.GA4.VideoStarted, null);
      analyticsService.sendGA4Event(events.GA4.VideoPercentViewed, {
        percent_viewed: 0
      }); // eslint-disable-line
    }
  };
  var onMediaEnd = function onMediaEnd(e, eventData) {
    if (eventData.isPlaybackEnded && playerConfiguration.getTrackEvents()) {
      analyticsService.sendEvent(events.Analytics.VideoFinishedAction, playerConfiguration.getEndActionParam());
      analyticsService.sendGA4Event(events.GA4.VideoFinishedAction, {
        finished_action: playerConfiguration.getEndActionParam()
      }); // eslint-disable-line
    }
  };
  var onVideoReplayHandler = function onVideoReplayHandler() {
    if (playerConfiguration.getTrackEvents()) {
      var eventAction = playerConfiguration.getAltEventCategoryAsFilename() ? analyticsService.getCategory() : mediaList.currentMedia.uri;
      analyticsService.sendEvent(events.Analytics.VideoReplay, eventAction);
      analyticsService.sendGA4Event(events.GA4.VideoReplay, null);
    }
  };
  var onMediaWrapperMediaEnd = function onMediaWrapperMediaEnd() {
    if (playerConfiguration.getTrackEvents()) {
      var eventAction = playerConfiguration.getAltEventCategoryAsFilename() ? analyticsService.getCategory() : mediaList.currentMedia.uri;
      analyticsService.sendEvent(events.Analytics.VideoFinished, eventAction);
      analyticsService.sendGA4Event(events.GA4.VideoFinished, null);
    }
  };
  var onOpenExternalLink = function onOpenExternalLink() {
    var eventAction = playerConfiguration.getAltEventCategoryAsFilename() ? analyticsService.getCategory() : mediaList.currentMedia.uri;
    analyticsService.sendEvent(events.Analytics.OpenExternalLinkView, eventAction);
    analyticsService.sendGA4Event(events.GA4.OpenExternalLinkView, null);
  };
  var onClickExternalLink = function onClickExternalLink() {
    var eventAction = playerConfiguration.getAltEventCategoryAsFilename() ? analyticsService.getCategory() : mediaList.currentMedia.uri;
    analyticsService.sendEvent(events.Analytics.OpenExternalLinkClick, eventAction);
    analyticsService.sendGA4Event(events.GA4.OpenExternalLinkClick, null);
  };
  var resumeSCORMSession = function resumeSCORMSession(initialVideoTimeInSeconds, initialVideoAnalyticsSnapshot) {
    videoAnalytics.populateVideoSegmentsWatch(initialVideoAnalyticsSnapshot);
    videoAnalytics.markTimeWatched(initialVideoTimeInSeconds * 1000);
  };
  var onStartedPlayback = function onStartedPlayback() {
    var quizRequiresAnalytics = quizController && quizController.hasQuiz && quizController.quizEnabled;
    var playerConfigurationRequiresAnalytics = playerConfiguration.getTrackEvents() || playerConfiguration.isScormLesson || playerConfiguration.getReportScormComplete() || quizRequiresAnalytics;
    var shouldTrackVideoAnalytics = !mediaList.isPlaylist && playerConfigurationRequiresAnalytics;
    if (shouldTrackVideoAnalytics) {
      videoAnalytics.setEnabled(true);
    }
  };
  var onPlayerInitialized = function onPlayerInitialized() {
    performanceWrapper.createMeasure(events.Timing.PlayerLoaded, events.Timing.PlayerLoaded);
    performanceWrapper.createMeasure(events.Timing.PlayerInitialized, events.Timing.PlayerInitialized);
    analyticsService.sendEvent(events.Analytics.ContentLoaded, mediaList.currentMedia.uri);
    analyticsService.sendGA4Event(events.GA4.PlayerInitialized, null);
  };
  var bindToEvents = function bindToEvents() {
    $container.on(events.Controls.StartedPlayback, onStartedPlayback);
    $container.on(events.Controls.PlayerInitialized, onPlayerInitialized);
    $container.on(events.Media.End, onMediaEnd);
    $container.on(events.Media.Replay, onVideoReplayHandler);
    $container.on(events.ExternalLinkView.Open, onOpenExternalLink);
    $container.on(events.ExternalLinkView.Clicked, onClickExternalLink);
    mediaView.mediaWrapper.on('ratechange', onVideoTimeUpdate, false);
    mediaView.mediaWrapper.on('play', onVideoTimeUpdate, false);
    var eventsToBind = {
      timeupdate: onVideoTimeUpdate,
      canplay: onCanPlayVideo,
      seeked: onSeeked,
      ended: onMediaWrapperMediaEnd
    };
    mediaView.mediaWrapper.on(eventsToBind);
    mediaView.mediaElement.addEventListener(events.Media.Play, resetPlayStartAnalytics);
  };
  var unbindToEvents = function unbindToEvents() {
    $container.off(events.Controls.StartedPlayback, onStartedPlayback);
    $container.off(events.Controls.PlayerInitialized, onPlayerInitialized);
    $container.off(events.Media.End, onMediaEnd);
    $container.on(events.Media.Replay, onVideoReplayHandler);
    $container.on(events.ExternalLinkView.Open, onOpenExternalLink);
    $container.on(events.ExternalLinkView.Clicked, onClickExternalLink);
    mediaView.mediaWrapper.off('ratechange', onVideoTimeUpdate, false);
    mediaView.mediaWrapper.off('play', onVideoTimeUpdate, false);
    var eventsToBind = {
      timeupdate: onVideoTimeUpdate,
      canplay: onCanPlayVideo,
      seeked: onSeeked,
      ended: onMediaWrapperMediaEnd
    };
    mediaView.mediaWrapper.off(eventsToBind);
    mediaView.mediaElement.removeEventListener(events.Media.Play, resetPlayStartAnalytics);
  };
  var destroy = function destroy() {
    unbindToEvents();
  };
  bindToEvents();
  if (mediaView.mediaWrapper.metadataReady) {
    mediaView.mediaWrapper.metadataReady.then(function () {
      return mediaView.mediaWrapper.canPlayReady.then(function () {
        onCanPlayVideo();
      });
    });
  }
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var MediaAnalyticsController$1 = {
  /**
   *  Factory method that returns a new MediaAnalyticsController.
   *  @function create
   *  @memberof TSC.MediaAnalyticsController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.MediaList} mediaList
   *  @param {TSC.QuizController} quizController
   *  @param {TSC.playerConfiguration} playerConfiguration
   *  @return new MediaAnalyticsController instance
   */
  create: MediaAnalyticsController
};

var enterKeyCode = 13;
var spacebarKeyCode = 32;

/**
 * @memberof TSC
 * @class PluginEventsController
 * @classdesc Controller for managing XMP features
 * @param {jQuery} $container - Smart Player main container jquery element
 *
 */
var PluginEventsController = function PluginEventsController($container) {
  var _$mediaPluginContainer = $container.find('.media-plugin-container');
  _$mediaPluginContainer.hide();
  var onMediaPluginContainerKeyHandler = function onMediaPluginContainerKeyHandler(e) {
    if (e.type === 'keydown' && (e.keyCode === enterKeyCode || e.keyCode === spacebarKeyCode)) {
      $container.trigger(events.Plugin.MediaAreaPluginKeyDown);
    } else if (e.type === 'keyup' && (e.keyCode === enterKeyCode || e.keyCode === spacebarKeyCode)) {
      $container.trigger(events.Plugin.MediaAreaPluginKeyUp);
    }
  };
  var onMediaPluginContainerMouseHandler = function onMediaPluginContainerMouseHandler(e) {
    if (e.type === 'mousedown') {
      $container.trigger(events.Plugin.MediaAreaPluginMouseDown);
    } else if (e.type === 'mouseup') {
      $container.trigger(events.Plugin.MediaAreaPluginMouseUp);
    }
  };
  var initMediaPlugins = function initMediaPlugins() {
    var pluginController = playerConfiguration.getPluginController();
    if (!pluginController) {
      return;
    }
    _$mediaPluginContainer.show();
    pluginController.initializePluginsForViewElement(supportedPluginViewElements.MEDIA, _$mediaPluginContainer);
  };
  var onPluginAdded = function onPluginAdded(eventName, data) {
    if (data.viewElementType === supportedPluginViewElements.MEDIA) {
      initMediaPlugins();
    }
  };
  var bindToEvents = function bindToEvents() {
    $container.on(events.Plugin.Added, onPluginAdded);
    _$mediaPluginContainer.on('mousedown', onMediaPluginContainerMouseHandler);
    _$mediaPluginContainer.on('mouseup', onMediaPluginContainerMouseHandler);
    _$mediaPluginContainer.on('keydown', onMediaPluginContainerKeyHandler);
    _$mediaPluginContainer.on('keyup', onMediaPluginContainerKeyHandler);
  };
  var unbindToEvents = function unbindToEvents() {
    $container.off(events.Plugin.Added, onPluginAdded);
    _$mediaPluginContainer.off('mousedown', onMediaPluginContainerMouseHandler);
    _$mediaPluginContainer.off('mouseup', onMediaPluginContainerMouseHandler);
    _$mediaPluginContainer.off('keydown', onMediaPluginContainerKeyHandler);
    _$mediaPluginContainer.off('keyup', onMediaPluginContainerKeyHandler);
  };
  var destroy = function destroy() {
    unbindToEvents();
  };
  bindToEvents();
  initMediaPlugins();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var PluginEventsController$1 = {
  /**
   *  Factory method that returns a new PluginEventsController.
   *  @function create
   *  @memberof TSC.PluginEventsController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @return new PluginEventsController instance
   */
  create: PluginEventsController
};

/**
 * @memberof TSC
 * @class MediaSessionController
 * @classdesc Media Session controller will interface media with system controls
 * @param {jQuery} $rootSmartPlayerElement
 * @param {HTMLVideoElement} mediaElement
 * @param {string} mediaTitle
 * @param {string} mediaPosterImageSrc
 */
var MediaSessionController = function MediaSessionController($rootSmartPlayerElement, mediaElement, mediaTitle, mediaPosterImageSrc) {
  var _windowRef = windowWrapper.getWindow();
  var _navigatorRef = windowWrapper.getNavigator();
  // This prevents unnecessary errors when Media Session API is not available.
  var _mediaSessionRef = _navigatorRef.mediaSession || {};
  _mediaSessionRef.setActionHandler = _navigatorRef.mediaSession.setActionHandler || function () {}; // eslint-disable-line
  _windowRef.MediaMetadata = _windowRef.MediaMetadata || function () {}; // eslint-disable-line

  var _metaDataSet = false;
  var setMetaData = function setMetaData() {
    _mediaSessionRef.metadata = new _windowRef.MediaMetadata({
      title: mediaTitle,
      artwork: [{
        src: mediaPosterImageSrc
      }]
    });
    _metaDataSet = true;
    updateMediaSessionState();
  };
  var updateMediaSessionState = function updateMediaSessionState() {
    if (!_metaDataSet) {
      return;
    }
    _mediaSessionRef.playbackState = mediaElement.paused ? 'paused' : 'playing';
    _mediaSessionRef.setPositionState({
      duration: mediaElement.duration,
      playbackRate: mediaElement.playbackRate,
      position: mediaElement.currentTime
    });
  };
  var onPlayAction = function onPlayAction() {
    if ($rootSmartPlayerElement.playerState.pausedForQuiz) {
      return;
    }
    mediaElement.play();
  };
  var onPauseAction = function onPauseAction() {
    if ($rootSmartPlayerElement.playerState.pausedForQuiz) {
      return;
    }
    mediaElement.pause();
  };
  var onSeekToAction = function onSeekToAction(details) {
    if ($rootSmartPlayerElement.playerState.pausedForQuiz) {
      return;
    }
    $rootSmartPlayerElement.trigger(events.Media.SeekToTime, {
      time: details.seekTime
    });
  };
  var bindEvents = function bindEvents() {
    mediaElement.addEventListener('loadedmetadata', setMetaData);
    mediaElement.addEventListener('playing', updateMediaSessionState);
    mediaElement.addEventListener('pause', updateMediaSessionState);
    mediaElement.addEventListener('durationchange', updateMediaSessionState);
    mediaElement.addEventListener('ratechange', updateMediaSessionState);
    mediaElement.addEventListener('timeupdate', updateMediaSessionState);
    _mediaSessionRef.setActionHandler('play', onPlayAction);
    _mediaSessionRef.setActionHandler('pause', onPauseAction);
    _mediaSessionRef.setActionHandler('seekto', onSeekToAction);
  };
  var destroy = function destroy() {
    mediaElement.removeEventListener('loadedmetadata', setMetaData);
    mediaElement.removeEventListener('playing', updateMediaSessionState);
    mediaElement.removeEventListener('pause', updateMediaSessionState);
    mediaElement.removeEventListener('durationchange', updateMediaSessionState);
    mediaElement.removeEventListener('ratechange', updateMediaSessionState);
    mediaElement.removeEventListener('timeupdate', updateMediaSessionState);
  };
  bindEvents();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var isSupported = function isSupported() {
  return !!windowWrapper.getNavigator().mediaSession;
};
var MediaSessionController$1 = {
  /**
   *  Factory method that returns a new MediaSessionController object
   *  @function create
   *  @memberof TSC.MediaSessionController
   *  @param {jQuery} $rootSmartPlayerElement
   *  @param {HTMLVideoElement} mediaElement
   *  @param {string} mediaTitle
   *  @param {string} mediaPosterImageSrc
   *  @static
   *  @return MediaSessionController instance
   */
  create: MediaSessionController,
  /**
   *  Is the Media Session api supported
   *  @function isSupported
   *  @memberof TSC.MediaSessionController
   *  @static
   *  @return {boolean} Is the api supported
   */
  isSupported: isSupported
};

/**
 * @memberof TSC
 * @class MediaExtensionsController
 * @classdesc Controller for managing XMP features
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.XmpModel} xmpModel
 * @param {TSC.Quiz} quizModel
 * @param {TSC.MediaList} mediaList
 * @param {TSC.CaptionService} captionService
 * @param {TSC.playerConfiguration} playerConfiguration
 * @param {TSC.ResponsiveController} responsiveController
 * @param {TSC.TabController} tabController
 * @param {TSC.ProgressBarControlView} progressBarControlView
 * @param {TSC.BeforeAfterPlayControlsView} beforeAfterPlayControlsView
 * @param {TSC.IoOverlayView} ioOverlayView
 *
 */
var MediaExtensionsController = function MediaExtensionsController($container, mediaView, xmpModel, quizModel, mediaList, captionService, playerConfiguration, responsiveController, tabController, progressBarControlView, beforeAfterPlayControlsView, ioOverlayView) {
  var _hotspotController;
  var _captionController;
  var _tableOfContentsController;
  var _audioDescriptionController;
  var _endActionsController;
  var _quizController;
  var _quizEventController;
  var _mediaAnalyticsController;
  var _pluginEventsController;
  var _mediaSessionController;
  var modifyPlayerConfigurationBasedOnDevice = function modifyPlayerConfigurationBasedOnDevice() {
    // ignore auto play if this is an iOS device that plays video inline or there is a quiz present
    // may want to move this out of the view at some point.
    var hasAnEnabledQuiz = _quizController && _quizController.hasQuiz && _quizController.quizEnabled;
    if ((deviceInfo.isIOS() || deviceInfo.isAndroid() || hasAnEnabledQuiz) && !playerConfiguration.getMobileWebViewCanAutoPlay()) {
      playerConfiguration.setAutoPlayMedia(false);
    }
  };
  var setupImageControllers = function setupImageControllers() {
    if (quizModel) {
      _quizController = QuizController$1.create($container, mediaView, quizModel, beforeAfterPlayControlsView, playerConfiguration.enforceLinearAssessment);
      _quizEventController = QuizEventController$1.create($container, mediaView, _quizController, progressBarControlView, playerConfiguration.enforceLinearAssessment, ioOverlayView);
    }
    _mediaAnalyticsController = MediaAnalyticsController$1.create($container, mediaView, mediaList, _quizController, playerConfiguration);
  };
  var getMediaTitle = function getMediaTitle() {
    if (playerConfiguration.mediaTitle) {
      return playerConfiguration.mediaTitle;
    } else if (playerConfiguration.tocTitle) {
      return playerConfiguration.tocTitle;
    } else if (xmpModel && xmpModel.title) {
      return xmpModel.title;
    }
    return localizationStrings.getPlayerString(playerStringNames.defaultMediaTitle);
  };
  var getMediaPosterSrc = function getMediaPosterSrc() {
    return playerConfiguration.getPosterImageSrc() || '';
  };
  var setupVideoControllers = function setupVideoControllers() {
    _endActionsController = EndActionsController$1.create($container, mediaView, progressBarControlView, beforeAfterPlayControlsView);
    if (playerConfiguration.audioDescriptionMediaSrc) {
      _audioDescriptionController = AudioDescriptionController$1.create($container, mediaView, playerConfiguration.audioDescriptionMediaSrc);
    }
    if (quizModel) {
      _quizController = QuizController$1.create($container, mediaView, quizModel, beforeAfterPlayControlsView, playerConfiguration.enforceLinearAssessment);
      _quizEventController = QuizEventController$1.create($container, mediaView, _quizController, progressBarControlView, playerConfiguration.enforceLinearAssessment, ioOverlayView);
    }
    _mediaAnalyticsController = MediaAnalyticsController$1.create($container, mediaView, mediaList, _quizController, playerConfiguration);
    if (MediaSessionController$1.isSupported()) {
      _mediaSessionController = MediaSessionController$1.create($container, mediaView.mediaElement, getMediaTitle(), getMediaPosterSrc());
    }
    if (mediaView.supportsSCORM && playerConfiguration.isScormLesson) {
      if (_quizController && _quizController.quizModel !== null && _quizController.quizModel.reportMethod === reportType.SCORM) {
        scormController$1.submitScore(0, false);
      }

      // restore quizzing model state and seek video if not using TechSmith Quiz Service (it can not resume a quiz)
      if (_quizController && _quizController.quizModel && _quizController.quizModel.reportMethod === reportType.SCORM && scormController$1.initialQuizModelSnapshot) {
        _quizController.populateQuizModel(scormController$1.initialQuizModelSnapshot);
        progressBarControlView.updateQuizMarkers();
      }
      scormController$1.initView($container);
    }
    var hasCaptionItems = xmpModel && xmpModel.hasCaptionItems || captionService.captionTrack;
    if (hasCaptionItems) {
      _captionController = CaptionController$1.create($container, mediaView, xmpModel, mediaList, captionService);
    }
    var hasHotspotItems = xmpModel && xmpModel.hasHotspotItems;
    if (hasHotspotItems) {
      _hotspotController = HotspotController$1.create($container, mediaView, xmpModel, mediaList, tabController);
    }
    var hasTableOfContents = xmpModel && xmpModel.hasSearchableItems;
    if (hasTableOfContents) {
      _tableOfContentsController = TableOfContentsController$1.create($container, mediaView, xmpModel, mediaList, progressBarControlView, playerConfiguration);
    }
  };
  var setupControllers = function setupControllers() {
    _pluginEventsController = PluginEventsController$1.create($container);
    if (mediaView.type === mediaViewType.image) {
      setupImageControllers();
    } else {
      setupVideoControllers();
    }
  };
  var preventEvent = function preventEvent(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  };
  var disableHighlightOnMouseDown = function disableHighlightOnMouseDown() {
    highlightDisabler.disableHighlights($(this));
  };
  var activateHighlightDisabler = function activateHighlightDisabler() {
    $container.on('mousedown', '*', disableHighlightOnMouseDown);
  };
  var applyCustomBackgroundColor = function applyCustomBackgroundColor() {
    $container.css('background-color', playerConfiguration.getBackgroundColor());
  };
  var disableContextMenuIfNeeded = function disableContextMenuIfNeeded() {
    if (playerConfiguration.getDisableContextMenuForVideo()) {
      $container.on('contextmenu', preventEvent);
    }
  };
  var configurePlayer = function configurePlayer() {
    modifyPlayerConfigurationBasedOnDevice();
    activateHighlightDisabler();
    applyCustomBackgroundColor();
    disableContextMenuIfNeeded();
    responsiveController.monitorContainerSize();
    if (!_quizController) {
      $container.trigger(events.Player.MediaExtensionsReady);
    } else {
      _quizController.quizIsSetupPromise.then(function () {
        $container.trigger(events.Player.MediaExtensionsReady);
      });
    }
  };
  var destroy = function destroy() {
    _hotspotController && _hotspotController.destroy();
    _captionController && _captionController.destroy();
    _tableOfContentsController && _tableOfContentsController.destroy();
    _audioDescriptionController && _audioDescriptionController.destroy();
    _endActionsController && _endActionsController.destroy();
    _quizController && _quizController.destroy();
    _quizEventController && _quizEventController.destroy();
    _mediaAnalyticsController && _mediaAnalyticsController.destroy();
    _pluginEventsController && _pluginEventsController.destroy();
    _mediaSessionController && _mediaSessionController.destroy();
    $container.off('mousedown', '*', disableHighlightOnMouseDown);
    $container.off('contextmenu', preventEvent);
    responsiveController.clearContainerMonitors();
  };
  setupControllers();
  configurePlayer();
  return Object.defineProperties({
    destroy: destroy
  }, {
    /**
     *  @public
     *  @readonly
     *  @memberof TSC.MediaExtensionsController
     *  @property {TSC.CaptionController} captionController - the caption controller
     */
    captionController: {
      get: function get() {
        return _captionController;
      }
    }
  });
};
var MediaExtensionsController$1 = {
  /**
   *  Factory method that returns a new MediaExtensionsController.
   *  @function create
   *  @memberof TSC.MediaExtensionsController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.XmpModel} xmpModel
   *  @param {TSC.Quiz} quizModel
   *  @param {TSC.MediaList} mediaList
   *  @param {TSC.CaptionService} captionService
   *  @param {TSC.playerConfiguration} playerConfiguration
   *  @param {TSC.TabController} tabController
   *  @param {TSC.ResponsiveController} responsiveController
   *  @param {TSC.ProgressBarControlView} progressBarControlView
   *  @param {TSC.BeforeAfterPlayControlsView} beforeAfterPlayControlsView
   *  @param {TSC.IoOverlayView} ioOverlayView
   *  @return new MediaExtensionsController instance
   */
  create: MediaExtensionsController
};

/**
 * @memberof TSC
 * @class TabController
 * @classdesc Controller for tabs
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {jQuery} $defaultFirstTabEnabledElement - The default first tab that should be enabled
 * @param {jQuery} $defaultLastTabEnabledElement - The default last tab that should be enabled
 *
 */
var TabController = function TabController($container, $defaultFirstTabEnabledElement, $defaultLastTabEnabledElement) {
  var _defaultFirstTabEnabledElement = $defaultFirstTabEnabledElement;
  var _defaultLastTabEnabledElement = $defaultLastTabEnabledElement;
  var _firstTabEnabledElement = null;
  var _lastTabEnabledElement = null;
  var _playerInFullScreenMode = false;
  var onFullScreenChange = function onFullScreenChange(event, eventData) {
    _playerInFullScreenMode = eventData.inFullScreen;
  };
  var unbindEventsToTabEnabledElement = function unbindEventsToTabEnabledElement(element) {
    if (element) {
      element.off('keydown');
    }
  };
  var setFirstTabEnabledElement = function setFirstTabEnabledElement(firstTabEnabledElement) {
    if (_firstTabEnabledElement) {
      unbindEventsToTabEnabledElement(_firstTabEnabledElement);
    }
    if (firstTabEnabledElement === null) {
      _firstTabEnabledElement = _defaultFirstTabEnabledElement;
    } else {
      _firstTabEnabledElement = firstTabEnabledElement;
    }
    _firstTabEnabledElement.on('keydown', function (e) {
      if (_playerInFullScreenMode && keys.isKeyOfType(e.key, keys.keyTypes.tab) && e.shiftKey === true) {
        e.preventDefault();
        _lastTabEnabledElement.focus();
      }
    });
  };
  var setLastTabEnabledElement = function setLastTabEnabledElement(lastTabEnabledElement) {
    if (_lastTabEnabledElement) {
      unbindEventsToTabEnabledElement(_lastTabEnabledElement);
    }
    if (lastTabEnabledElement === null) {
      _lastTabEnabledElement = _defaultLastTabEnabledElement;
    } else {
      _lastTabEnabledElement = lastTabEnabledElement;
    }
    _lastTabEnabledElement.on('keydown', function (e) {
      if (_playerInFullScreenMode && keys.isKeyOfType(e.key, keys.keyTypes.tab) && e.shiftKey === false) {
        e.preventDefault();
        _firstTabEnabledElement.focus();
      }
    });
  };
  var initController = function initController() {
    if (!_defaultFirstTabEnabledElement || !_defaultLastTabEnabledElement) {
      throw new Error('Tab controller is missing a default tab enabled element');
    }
    setFirstTabEnabledElement(_defaultFirstTabEnabledElement);
    setLastTabEnabledElement(_defaultLastTabEnabledElement);
    $container.on(events.Controls.FullScreenChange, onFullScreenChange);
  };
  var destroy = function destroy() {
    unbindEventsToTabEnabledElement(_firstTabEnabledElement);
    unbindEventsToTabEnabledElement(_lastTabEnabledElement);
    $container.off(events.Controls.FullScreenChange, onFullScreenChange);
  };
  initController();
  return Object.defineProperties({
    destroy: destroy
  }, {
    firstTabEnabledElement: {
      get: function get() {
        return _firstTabEnabledElement;
      },
      set: setFirstTabEnabledElement
    },
    lastTabEnabledElement: {
      get: function get() {
        return _lastTabEnabledElement;
      },
      set: setLastTabEnabledElement
    }
  });
};
var TabController$1 = {
  create: TabController
};

/**
 * @memberof TSC
 * @class ExternalEventsController
 * @classdesc Controller for managing external events
 * @param {jQuery} $container - Smart Player main container jquery element
 * @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
 * @param {TSC.MediaList} mediaList
 * @param {Object} playerViewEventCallbacks
 *
 */
var ExternalEventsController = function ExternalEventsController($container, mediaView, mediaList, playerViewEventCallbacks) {
  var onLoadedMetadata = function onLoadedMetadata() {
    playerViewEventCallbacks[events.External.MediaReady].forEach(function (callback) {
      callback();
    });
  };
  var onFullScreenChange = function onFullScreenChange() {
    playerViewEventCallbacks[events.External.PlayerFullScreenModeChanged].forEach(function (callback) {
      callback();
    });
  };
  var onTheaterModeChanged = function onTheaterModeChanged(e, eventData) {
    var newDisplayMode = eventData && eventData.displayMode;
    playerViewEventCallbacks[events.External.DisplayModeChanged].forEach(function (callback) {
      callback(newDisplayMode);
    });
  };
  var onCanPlayVideo = function onCanPlayVideo() {
    playerViewEventCallbacks[events.External.VideoStart].forEach(function (callback) {
      callback();
    });
    mediaView.mediaWrapper.off('canplay', onCanPlayVideo);
  };
  var onMediaEnd = function onMediaEnd(e, eventData) {
    if (eventData.isPlaybackEnded) {
      playerViewEventCallbacks[events.External.VideoEnd].forEach(function (callback) {
        callback();
      });
    }
  };
  var onVideoReplayHandler = function onVideoReplayHandler() {
    playerViewEventCallbacks[events.External.VideoReplay].forEach(function (callback) {
      callback();
    });
  };
  var onVideoError = function onVideoError() {
    playerViewEventCallbacks[events.External.MediaError].forEach(function (callback) {
      callback();
    });
  };
  var onPlayingEvent = function onPlayingEvent() {
    mediaView.mediaWrapper.off('playing', onPlayingEvent);

    // send a playing/streaming confirmation if applicable
    playerViewEventCallbacks[events.External.VideoPlay].forEach(function (callback) {
      callback();
    });
  };
  var onStartedPlaybackHandler = function onStartedPlaybackHandler() {
    playerViewEventCallbacks[events.External.VideoStartInitiated].forEach(function (callback) {
      callback();
    });
  };
  var triggerQuizVisible = function triggerQuizVisible() {
    playerViewEventCallbacks[events.External.QuizVisible].forEach(function (callback) {
      callback();
    });
  };
  var triggerQuizHidden = function triggerQuizHidden() {
    playerViewEventCallbacks[events.External.QuizHidden].forEach(function (callback) {
      callback();
    });
  };
  var processCaptionChanged = function processCaptionChanged(e, eventData) {
    if (eventData) {
      playerViewEventCallbacks[events.External.CaptionChange].forEach(function (callback) {
        callback(eventData.plainText);
      });
    }
  };
  var processCaptionToggled = function processCaptionToggled(e, eventData) {
    if (eventData) {
      var externalCaptionEvent = eventData.captionsEnabled ? events.External.CaptionsVisible : events.External.CaptionsHidden;
      playerViewEventCallbacks[externalCaptionEvent].forEach(function (callback) {
        callback();
      });
    }
  };
  var onCaptionsReadyHandler = function onCaptionsReadyHandler() {
    playerViewEventCallbacks[events.External.CaptionsReady].forEach(function (callback) {
      callback();
    });
  };
  var triggerPlayerSettingsOpen = function triggerPlayerSettingsOpen() {
    playerViewEventCallbacks[events.External.PlayerSettingsOpen].forEach(function (callback) {
      callback();
    });
  };
  var triggerPlayerSettingsClose = function triggerPlayerSettingsClose() {
    playerViewEventCallbacks[events.External.PlayerSettingsClose].forEach(function (callback) {
      callback();
    });
  };
  var triggerVideoControlsHidden = function triggerVideoControlsHidden() {
    playerViewEventCallbacks[events.External.PlayerControlsHidden].forEach(function (callback) {
      callback();
    });
  };
  var triggerVideoControlsVisible = function triggerVideoControlsVisible() {
    playerViewEventCallbacks[events.External.PlayerControlsVisible].forEach(function (callback) {
      callback();
    });
  };
  var triggerExternalPlayerResize = function triggerExternalPlayerResize() {
    playerViewEventCallbacks[events.External.PlayerResize].forEach(function (callback) {
      callback();
    });
  };
  var triggerHeroControlHidden = function triggerHeroControlHidden() {
    playerViewEventCallbacks[events.External.HeroControlHidden].forEach(function (callback) {
      callback();
    });
  };
  var triggerImagePointerOver = function triggerImagePointerOver() {
    playerViewEventCallbacks[events.External.ImagePointerOver].forEach(function (callback) {
      callback();
    });
  };
  var triggerImagePointerLeave = function triggerImagePointerLeave() {
    playerViewEventCallbacks[events.External.ImagePointerLeave].forEach(function (callback) {
      callback();
    });
  };
  var bindToEvents = function bindToEvents() {
    $container.on(events.Controls.StartedPlayback, onStartedPlaybackHandler);
    $container.on(events.Controls.FullScreenChange, onFullScreenChange);
    $container.on(events.Controls.TheaterModeChanged, onTheaterModeChanged);
    $container.on(events.Media.End, onMediaEnd);
    $container.on(events.Media.Replay, onVideoReplayHandler);
    $container.on(events.Media.Error, onVideoError);
    $container.on(events.Quizzing.ShowStartQuizPrompt, triggerQuizVisible);
    $container.on(events.Quizzing.Review, triggerQuizHidden);
    $container.on(events.Quizzing.ShowQuestionSetView, triggerQuizVisible);
    $container.on(events.Quizzing.Complete, triggerQuizHidden);
    $container.on(events.Captions.Changed, processCaptionChanged);
    $container.on(events.Captions.Toggled, processCaptionToggled);
    $container.on(events.Captions.StateLoaded, onCaptionsReadyHandler);
    $container.on(events.Controls.PlayerSettingsOpen, triggerPlayerSettingsOpen);
    $container.on(events.Controls.PlayerSettingsClose, triggerPlayerSettingsClose);
    $container.on(events.Controls.VideoControlsHidden, triggerVideoControlsHidden);
    $container.on(events.Controls.VideoControlsVisible, triggerVideoControlsVisible);
    $container.on(events.Controls.PlayerResize, triggerExternalPlayerResize);
    $container.on(events.Controls.HeroPlayControlClicked, triggerHeroControlHidden);
    $container.on(events.Images.PointerOver, triggerImagePointerOver);
    $container.on(events.Images.PointerLeave, triggerImagePointerLeave);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      canplay: onCanPlayVideo,
      playing: onPlayingEvent
    };
    mediaView.mediaWrapper.on(eventsToBind);
  };
  var unbindToEvents = function unbindToEvents() {
    $container.off(events.Controls.StartedPlayback, onStartedPlaybackHandler);
    $container.off(events.Controls.FullScreenChange, onFullScreenChange);
    $container.off(events.Controls.TheaterModeChanged, onTheaterModeChanged);
    $container.off(events.Media.End, onMediaEnd);
    $container.off(events.Media.Replay, onVideoReplayHandler);
    $container.off(events.Media.Error, onVideoError);
    $container.off(events.Quizzing.ShowStartQuizPrompt, triggerQuizVisible);
    $container.off(events.Quizzing.Review, triggerQuizHidden);
    $container.off(events.Quizzing.ShowQuestionSetView, triggerQuizVisible);
    $container.off(events.Quizzing.Complete, triggerQuizHidden);
    $container.off(events.Captions.Changed, processCaptionChanged);
    $container.off(events.Captions.Toggled, processCaptionToggled);
    $container.off(events.Captions.StateLoaded, onCaptionsReadyHandler);
    $container.off(events.Controls.PlayerSettingsOpen, triggerPlayerSettingsOpen);
    $container.off(events.Controls.PlayerSettingsClose, triggerPlayerSettingsClose);
    $container.off(events.Controls.VideoControlsHidden, triggerVideoControlsHidden);
    $container.off(events.Controls.VideoControlsVisible, triggerVideoControlsVisible);
    $container.off(events.Controls.PlayerResize, triggerExternalPlayerResize);
    $container.off(events.Controls.HeroPlayControlClicked, triggerHeroControlHidden);
    $container.off(events.Images.PointerOver, triggerImagePointerOver);
    $container.off(events.Images.PointerLeave, triggerImagePointerLeave);
    var eventsToBind = {
      loadedmetadata: onLoadedMetadata,
      canplay: onCanPlayVideo,
      playing: onPlayingEvent
    };
    mediaView.mediaWrapper.off(eventsToBind);
  };
  var destroy = function destroy() {
    unbindToEvents();
  };
  bindToEvents();
  return Object.defineProperties({
    destroy: destroy
  }, {});
};
var ExternalEventsController$1 = {
  /**
   *  Factory method that returns a new ExternalEventsController.
   *  @function create
   *  @memberof TSC.ExternalEventsController
   *  @static
   *  @param {jQuery} $container - Smart Player main container jquery element
   *  @param {MediaView} mediaView - Media view for current media. Created by MediaViewFactory.
   *  @param {TSC.MediaList} mediaList
   *  @param {Object} playerViewEventCallbacks
   *  @return new ExternalEventsController instance
   */
  create: ExternalEventsController
};

/**
 * @memberof TSC
 * @class PlayerState
 * @classdesc State object used for player instance player state.
 */
var PlayerState = function PlayerState() {
  var _oneOrMoreHotspotsWithTimeActionArePaused = false;
  var _videoHasQuizQuestions = false;
  var _pausedForQuiz = false;
  var _displayMode = DisplayModes.Normal;
  return Object.defineProperties({}, {
    oneOrMoreHotspotsWithTimeActionArePaused: {
      get: function get() {
        return _oneOrMoreHotspotsWithTimeActionArePaused;
      },
      set: function set(oneOrMoreHotspotsWithTimeActionArePaused) {
        _oneOrMoreHotspotsWithTimeActionArePaused = oneOrMoreHotspotsWithTimeActionArePaused;
      }
    },
    mediaHasQuizQuestions: {
      get: function get() {
        return _videoHasQuizQuestions;
      },
      set: function set(videoHasQuizQuestions) {
        _videoHasQuizQuestions = videoHasQuizQuestions;
      }
    },
    pausedForQuiz: {
      get: function get() {
        return _pausedForQuiz;
      },
      set: function set(pausedForQuiz) {
        _pausedForQuiz = pausedForQuiz;
      }
    },
    displayMode: {
      get: function get() {
        return _displayMode;
      },
      set: function set(displayMode) {
        _displayMode = displayMode;
      }
    }
  });
};
var PlayerState$1 = {
  /**
   *  Factory method that returns a new PlayerState object
   *  @function create
   *  @memberof TSC.PlayerState
   *  @static
   *  @return new PlayerState instance
   */
  create: PlayerState
};

/**
 *  @memberof TSC.IoOverlayView
 *  @class IoOverlayView
 *  @classdesc IoOverlay View
 */
var IoOverlayView = function IoOverlayView($container) {
  var _viewOpen = false;
  var markup = templateGenerator.generateIoOverlayMarkup();
  $container.append(markup);
  var _$ioContainer = $container.find('.tsc-io-container');
  var _$ioMessage = _$ioContainer.find('span');
  var _$ioImg = _$ioContainer.find('img');
  var setViewMessage = function setViewMessage(message) {
    _$ioMessage.html(message);
  };
  var hideLoadingGraphic = function hideLoadingGraphic() {
    _$ioImg.hide();
  };
  var showLoadingGraphic = function showLoadingGraphic() {
    _$ioImg.show();
  };
  var showView = function showView() {
    _$ioContainer.stop().css('opacity', 0).show().animate({
      opacity: 1
    }, 300);
    _viewOpen = true;
  };
  var hideView = function hideView(completeCallback) {
    if (_viewOpen) {
      _viewOpen = false;
      _$ioContainer.stop().animate({
        opacity: 0
      }, 200, function () {
        if (completeCallback) {
          completeCallback.call();
        }
        _$ioContainer.hide();
      });
    }
  };
  var displayMessage = function displayMessage(message, shouldHideLoadingGraphic) {
    setViewMessage(message);
    if (shouldHideLoadingGraphic) {
      hideLoadingGraphic();
    } else {
      showLoadingGraphic();
    }
    if (!_viewOpen) {
      showView();
    }
  };
  var destroy = function destroy() {
    $container.off(events.Controls.HideIOOverlay, hideView);
  };
  var bindEvents = function bindEvents() {
    $container.on(events.Controls.HideIOOverlay, hideView);
  };
  bindEvents();
  return Object.defineProperties({
    hideView: hideView,
    displayMessage: displayMessage,
    destroy: destroy
  }, {});
};
var IoOverlayView$1 = {
  /**
   *  Factory method that returns a new IoOverlayView object.
   *  @function create
   *  @memberof TSC.IoOverlayView
   *  @static
   *  @param {Object} $container - jQuery element that is the smartplayer top-level container
   *  @return new IoOverlayView instance
   */
  create: IoOverlayView
};

var VIDEO_TIME_COMPARE_PRECISION = 2;

/**
 * @memberof TSC
 * @class SmartPlayerView
 * @classdesc Smart Player view
 * @param {String} playerInstanceUUID
 * @param {JQuery} $rootContainer
 * @param {TSC.MediaList} mediaList
 * @param {TSC.XmpModel} xmpModel
 * @param {TSC.Quiz} quizModel
 * @param {TSC.CaptionService} captionService
 * @param {TSC.playerConfiguration} playerConfiguration
 * @param {TSC.ResponsiveController} responsiveController
 * @param {Boolean} xmpInErrorState
 */
var SmartPlayerView = function SmartPlayerView(playerInstanceUUID, $rootContainer, mediaList, xmpModel, quizModel, captionService, playerConfiguration, responsiveController, xmpInErrorState) {
  // eslint-disable-line
  var _mediaElementUniqueID = [$rootContainer.attr('id').replace(/^[#]/, ''), playerInstanceUUID].join('-');
  var _mediaViewReady;
  var _viewHasBeenInitialized;
  var _mediaExtensionsController;
  var _tabController;
  var _externalEventsController;
  var _scormErrorMessageBarView;
  var _$playerPluginContainer;
  var _viewInitializedPromise = new Promise$1(function (resolve, reject) {
    _viewHasBeenInitialized = resolve; // eslint-disable-line
  });
  var _playerViewEventCallbacks = {};
  var _queuedMediaBinds = {};
  var _mediaView = null;
  var _ioOverlayView = null;
  var _videoControlsController = null;
  var _videoControlsDisplayModeController = null;
  var _controlsReady = false;
  var _mediaExtensionsReady = false;
  var _mediaHasBeenLoaded = false;
  var _playerState = PlayerState$1.create();
  _playerState.mediaHasQuizQuestions = quizModel && quizModel.questionSets.length > 0;
  $rootContainer.playerState = _playerState;
  var _$mediaViewPortContainer = null;
  var _$mediaContainer = null;
  var _$playerLayoutControlsContainer = null;
  var displayXmpErrorMessage = function displayXmpErrorMessage() {
    if (deviceInfo.isLocal()) {
      MessageBarView$1.create($rootContainer, messageBarType.info, localizationStrings.getPlayerString(playerStringNames.xmpSecurity), localizationStrings.getPlayerString(playerStringNames.close));
    } else {
      MessageBarView$1.create($rootContainer, messageBarType.info, localizationStrings.getPlayerString(playerStringNames.xmpError));
    }
  };
  var onFirstPlayHandler = function onFirstPlayHandler() {
    $rootContainer.trigger(events.Media.FirstPlay);
  };
  var triggerRumDataEvent = function triggerRumDataEvent(timingMeasureList, eventCategorySuffix) {
    var eventData = {
      categorySuffix: eventCategorySuffix,
      rum: performanceWrapper.getRumEventData(timingMeasureList)
    };
    _playerViewEventCallbacks[events.External.PlayerRumData].forEach(function (callback) {
      callback(eventData);
    });
  };
  var externalEventIsSupported = function externalEventIsSupported(eventName) {
    return Object.keys(events.External).some(function (eventKey) {
      return events.External[eventKey] === eventName;
    });
  };
  var setupExternalEventCallbackHarness = function setupExternalEventCallbackHarness() {
    Object.keys(events.External).forEach(function (eventKey) {
      var eventName = events.External[eventKey];
      _playerViewEventCallbacks[eventName] = [];
    });
  };
  var getCaptionsVisible = function getCaptionsVisible() {
    return _mediaExtensionsController.captionController ? _mediaExtensionsController.captionController.getCaptionsVisible() : false;
  };
  var setCaptionsVisible = function setCaptionsVisible(value) {
    if (_mediaExtensionsController.captionController) {
      _mediaExtensionsController.captionController.setCaptionsVisible(value);
    }
  };
  var addEventListener = function addEventListener(type, listener) {
    if (externalEventIsSupported(type)) {
      _playerViewEventCallbacks[type].push(listener);
    }
  };
  var removeEventListener = function removeEventListener(type, listener) {
    if (externalEventIsSupported(type)) {
      // just in case the same listener pointer is bound more than once?
      while (_playerViewEventCallbacks[type].indexOf(listener) !== -1) {
        _playerViewEventCallbacks[type].splice(_playerViewEventCallbacks[type].indexOf(listener), 1);
      }
    }
  };
  var addMediaEventListener = function addMediaEventListener(event, handler) {
    if (_mediaView && _mediaView.mediaWrapper) {
      _mediaView.mediaWrapper.on(event, handler);
    } else {
      if (_typeof$1(_queuedMediaBinds[event]) !== 'object') {
        _queuedMediaBinds[event] = [];
      }
      _queuedMediaBinds[event].push(handler);
    }
  };
  var removeMediaEventListener = function removeMediaEventListener(event, handler) {
    if (_mediaView.mediaWrapper) {
      _mediaView.mediaWrapper.off(event, handler);
    } else {
      if (_typeof$1(_queuedMediaBinds[event]) !== 'object') {
        return;
      }
      // if the same handler is bound multiple times?
      while (_queuedMediaBinds[event].indexOf(handler) !== -1) {
        _queuedMediaBinds[event].splice(_queuedMediaBinds[event].indexOf(handler), 1);
      }
    }
  };
  var processQueuedMediaBinds = function processQueuedMediaBinds() {
    Object.keys(_queuedMediaBinds).forEach(function (event) {
      if (_typeof$1(_queuedMediaBinds[event]) === 'object') {
        _queuedMediaBinds[event].forEach(function (callback) {
          _mediaView.mediaWrapper.on(event, callback);
        });
      }
    });
    _queuedMediaBinds = {};
  };
  var triggerVideoStartEventCallbacks = function triggerVideoStartEventCallbacks() {
    // dispatch callback for media started event (note: after _mediaWrapper and _mediaElement are set)
    _playerViewEventCallbacks[events.External.VideoStart].forEach(function (callback) {
      callback();
    });
  };
  var createPlayerLayout = function createPlayerLayout() {
    $rootContainer.html(templateGenerator.generatePlayerLayoutMarkup());
    _$mediaViewPortContainer = $rootContainer.find('.media-wrapper').first();
    _$playerLayoutControlsContainer = $rootContainer.find('.video-controls-container').first();
    _$playerPluginContainer = $rootContainer.find('.player-plugin-container').first();
  };
  var createMediaView = function createMediaView() {
    return MediaViewFactory$1.createView($rootContainer, _$mediaViewPortContainer, _mediaElementUniqueID, mediaList, onFirstPlayHandler, triggerRumDataEvent);
  };
  var onMediaError = function onMediaError(e, data) {
    _ioOverlayView.hideView();
    _ioOverlayView.displayMessage(data.errorString, true);
  };
  var showVideoLoadingMessage = function showVideoLoadingMessage() {
    if (_mediaView.type !== mediaViewType.youtube && _mediaView.type !== mediaViewType.image) {
      _ioOverlayView.displayMessage(localizationStrings.getPlayerString(playerStringNames.videoLoading));
    }
  };
  var onHideLoadingMessage = function onHideLoadingMessage() {
    _ioOverlayView.hideView();
  };
  var loadMediaWhenComponentsAreReady = function loadMediaWhenComponentsAreReady() {
    if (_controlsReady && _mediaExtensionsReady && !_mediaHasBeenLoaded) {
      showVideoLoadingMessage();
      loadMedia();
    }
  };
  var onControlsVisible = function onControlsVisible() {
    if (_$playerLayoutControlsContainer.length > 0 && captionService.position === CAPTION_POSITION.under) {
      $rootContainer[0].style.setProperty(cssVariables.reservedSizeControls, "".concat(Math.round(_$playerLayoutControlsContainer.height()), "px"));
    }
  };
  var onControlsReady = function onControlsReady() {
    _controlsReady = true;
    loadMediaWhenComponentsAreReady();
  };
  var onMediaExtensionsReady = function onMediaExtensionsReady() {
    _mediaExtensionsReady = true;
    loadMediaWhenComponentsAreReady();
  };
  var onFailedToFindSCORMApi = function onFailedToFindSCORMApi() {
    _ioOverlayView.hideView();
    _scormErrorMessageBarView = MessageBarView$1.create($rootContainer, messageBarType.info, localizationStrings.getPlayerString(playerStringNames.scormApiNotFoundMessage), localizationStrings.getPlayerString(playerStringNames.close));
  };
  var startViewPortObserver = function startViewPortObserver() {
    _mediaView.mediaWrapper.off(events.ExternalVideo.VideoLoadedMetadata, startViewPortObserver);
    // at this point, these should have been initialized
    _$mediaContainer = $rootContainer.find('.media-container');
    responsiveController.monitorMediaViewPortSize(_$mediaViewPortContainer, _$mediaContainer, _mediaView.mediaWidth, _mediaView.mediaHeight);
  };
  var onImagePointerOver = function onImagePointerOver() {
    $rootContainer.trigger(events.Images.PointerOver);
  };
  var onImagePointerLeave = function onImagePointerLeave() {
    $rootContainer.trigger(events.Images.PointerLeave);
  };
  var onMediaViewInitialized = function onMediaViewInitialized(mediaView) {
    _mediaView = mediaView;
    _ioOverlayView = IoOverlayView$1.create($rootContainer);
    $rootContainer.on(events.Media.Error, onMediaError);
    $rootContainer.on(events.Player.MediaControlsReady, onControlsReady);
    $rootContainer.on(events.Controls.VideoControlsVisible, onControlsVisible);
    $rootContainer.on(events.Player.MediaExtensionsReady, onMediaExtensionsReady);
    $rootContainer.on(events.Controls.HideLoadingMessage, onHideLoadingMessage);
    $rootContainer.on(events.SCORM.FailedToFindApi, onFailedToFindSCORMApi);
    $rootContainer.on(events.Plugin.Added, initPlugins);
    _mediaView.mediaWrapper.on(events.ExternalVideo.VideoLoadedMetadata, startViewPortObserver);
    if (_mediaView.playerControlType === playerControlsType.video || _mediaView.playerControlType === playerControlsType.videoPlaylist) {
      _videoControlsController = VideoControlsController$1.create($rootContainer, _mediaView, xmpModel, quizModel, playerConfiguration);
      _videoControlsDisplayModeController = VideoControlsDisplayModeController$1.create($rootContainer, _videoControlsController, playerConfiguration);
      _tabController = TabController$1.create($rootContainer, _videoControlsController.progressBarControlView.controlElement, _videoControlsController.fullscreenControlView.controlElement);
    } else {
      // if not creating videoControls just yank the dom structure, perhaps this should be its own template
      $rootContainer.find('.video-controls-container').remove();
      if (_mediaView.type === mediaViewType.image && !deviceInfo.isTouchInterface()) {
        $rootContainer.on('pointerover', onImagePointerOver);
        $rootContainer.on('pointerleave', onImagePointerLeave);
      }
    }
    var progressBarControlView = _videoControlsController ? _videoControlsController.progressBarControlView : null;
    var beforeAfterPlayControlsView = _videoControlsController ? _videoControlsController.beforeAfterPlayControlsView : null;
    _externalEventsController = ExternalEventsController$1.create($rootContainer, mediaView, mediaList, _playerViewEventCallbacks);
    processQueuedMediaBinds();
    _mediaExtensionsController = MediaExtensionsController$1.create($rootContainer, mediaView, xmpModel, quizModel, mediaList, captionService, playerConfiguration, responsiveController, _tabController, progressBarControlView, beforeAfterPlayControlsView, _ioOverlayView);
    if (!_videoControlsController || !_videoControlsController.userNeedToClickHeroPlayControl) {
      $rootContainer.trigger(events.Player.MediaControlsReady);
    }
    $rootContainer.trigger(events.Controls.PlayerInitialized);
    triggerRumDataEvent([events.Timing.PlayerLoaded, events.Timing.PlayerInitialized], AnalyticsRumVideoCategorySuffix);
    _viewHasBeenInitialized();
  };
  var destroy = function destroy() {
    $rootContainer.off(events.Media.Error, onMediaError);
    $rootContainer.off(events.Player.MediaControlsReady, onControlsReady);
    $rootContainer.off(events.Controls.VideoControlsVisible, onControlsVisible);
    $rootContainer.off(events.Player.MediaExtensionsReady, onMediaExtensionsReady);
    $rootContainer.off(events.Controls.HideLoadingMessage, onHideLoadingMessage);
    $rootContainer.off(events.SCORM.FailedToFindApi, onFailedToFindSCORMApi);
    $rootContainer.off(events.Plugin.Added, initPlugins);
    $rootContainer.off('pointerover', onImagePointerOver);
    $rootContainer.off('pointerleave', onImagePointerLeave);
    _mediaView.mediaWrapper.off(events.ExternalVideo.VideoLoadedMetadata, startViewPortObserver);
    _videoControlsController && _videoControlsController.destroy();
    _videoControlsDisplayModeController && _videoControlsDisplayModeController.destroy();
    _mediaView && _mediaView.destroy();
    _ioOverlayView && _ioOverlayView.destroy();
    _mediaExtensionsController && _mediaExtensionsController.destroy();
    _tabController && _tabController.destroy();
    _externalEventsController && _externalEventsController.destroy();
    _scormErrorMessageBarView && _scormErrorMessageBarView.remove();
  };
  var playVideo = function playVideo() {
    if (_mediaView && _mediaView.mediaElement && _mediaView.type !== mediaViewType.image) {
      if (_mediaView.mediaElement.ended) {
        $rootContainer.trigger(events.Media.Replay);
      } else {
        _mediaView.mediaElement.play();
      }
    }
    return Promise$1.reject('Media Element not yet initialized');
  };
  var pauseVideo = function pauseVideo() {
    if (_mediaView && _mediaView.mediaElement && _mediaView.type !== mediaViewType.image) {
      _mediaView.mediaElement.pause();
    }
  };
  var isInFullScreenMode = function isInFullScreenMode() {
    if (_videoControlsController && _videoControlsController.fullscreenControlView) {
      return _videoControlsController.fullscreenControlView.isFullScreen;
    }
    return false;
  };
  var getIsScrubbing = function getIsScrubbing() {
    if (_videoControlsController && _videoControlsController.progressBarControlView) {
      return _videoControlsController.progressBarControlView.scrubbing;
    }
    return false;
  };
  var setIsScrubbing = function setIsScrubbing(isScrubbingVideo) {
    if (_videoControlsController && _videoControlsController.progressBarControlView) {
      _videoControlsController.progressBarControlView.scrubbing = isScrubbingVideo;
    }
  };
  var getSafeSeekTime = function getSafeSeekTime(time) {
    if (!_mediaView && _mediaView.type === mediaViewType.image && !_mediaView.mediaElement) {
      return 0;
    }
    return videoApiUtils.getSafeSeekTime(_mediaView.mediaElement, time);
  };
  var loadMedia = function loadMedia() {
    if (_mediaHasBeenLoaded) {
      return;
    }
    _mediaHasBeenLoaded = true;
    $rootContainer.find('.video-wrapper').removeClass(cssClasses.hide);
    _mediaView.loadMedia();
    if (playerConfiguration.getAutoPlayMedia() || playerConfiguration.getForceAutoPlayMedia()) {
      $rootContainer.trigger(events.Media.TryToAutoPlay);
    }
  };
  var setExternalCurrentTime = function setExternalCurrentTime(timeInSeconds) {
    var safeSeekTime = videoApiUtils.getSafeSeekTime(_mediaView.mediaElement, timeInSeconds);
    if (_videoControlsController && _mediaView.mediaElement.currentTime.toFixed(VIDEO_TIME_COMPARE_PRECISION) !== safeSeekTime.toFixed(VIDEO_TIME_COMPARE_PRECISION)) {
      _videoControlsController.beforeAfterPlayControlsView.hideVideoClickToReplayLink();
    }
    if (_mediaView.mediaElement.ended) {
      $rootContainer.trigger(events.Media.Replay, {
        time: safeSeekTime,
        playAfterSeek: false
      });
    } else {
      $rootContainer.trigger(events.Media.SeekToTime, {
        time: safeSeekTime
      });
    }
  };
  var initPlugins = function initPlugins(event, data) {
    var pluginController = playerConfiguration.getPluginController();
    if (pluginController && data.viewElementType === supportedPluginViewElements.PLAYER) {
      pluginController.initializePluginsForViewElement(supportedPluginViewElements.PLAYER, _$playerPluginContainer);
    }
  };
  setupExternalEventCallbackHarness();
  createPlayerLayout();
  if (xmpInErrorState) {
    displayXmpErrorMessage();
  }
  _mediaViewReady = createMediaView();
  _mediaViewReady.then(onMediaViewInitialized)["catch"](function (error) {
    log.logException(error);
  });
  return Object.defineProperties({
    loadMedia: loadMedia,
    destroy: destroy,
    play: playVideo,
    pause: pauseVideo,
    // custom view stuff
    isInFullScreenMode: isInFullScreenMode,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener,
    addMediaEventListener: addMediaEventListener,
    removeMediaEventListener: removeMediaEventListener,
    // controls state internal to smart-player-view
    getCaptionsVisible: getCaptionsVisible,
    setCaptionsVisible: setCaptionsVisible,
    getScrubbing: getIsScrubbing,
    setScrubbing: setIsScrubbing,
    // events
    triggerVideoStartEventCallbacks: triggerVideoStartEventCallbacks,
    // util methods
    getSafeSeekTime: getSafeSeekTime
  }, {
    initializedPromise: {
      get: function get() {
        return _viewInitializedPromise;
      }
    },
    currentSrc: {
      get: function get() {
        return _mediaView ? _mediaView.currentSrc : '';
      }
    },
    currentTime: {
      get: function get() {
        return _mediaView ? _mediaView.currentTime : 0;
      },
      set: setExternalCurrentTime
    },
    duration: {
      get: function get() {
        return _mediaView ? _mediaView.duration : 0;
      }
    },
    paused: {
      get: function get() {
        return _mediaView ? _mediaView.paused : false;
      }
    },
    ended: {
      get: function get() {
        return _mediaView ? _mediaView.ended : false;
      }
    },
    seeking: {
      get: function get() {
        return _mediaView ? _mediaView.seeking : false;
      }
    },
    buffered: {
      get: function get() {
        return _mediaView ? _mediaView.buffered : [];
      }
    },
    played: {
      get: function get() {
        return _mediaView ? _mediaView.played : [];
      }
    },
    seekable: {
      get: function get() {
        return _mediaView ? _mediaView.seekable : [];
      }
    },
    volume: {
      get: function get() {
        return _mediaView ? _mediaView.volume : 1;
      },
      set: function set(volumeValue) {
        $rootContainer.trigger(events.Media.SetVolume, {
          volumeValue: volumeValue
        });
      }
    },
    muted: {
      get: function get() {
        return _mediaView ? _mediaView.muted : false;
      },
      set: function set(isMuted) {
        $rootContainer.trigger(events.Media.SetMutedState, {
          isMuted: isMuted
        });
      }
    },
    playbackRate: {
      get: function get() {
        return _mediaView ? _mediaView.playbackRate : 1;
      },
      set: function set(playbackRate) {
        $rootContainer.trigger(events.Media.SetPlaybackRate, {
          playbackRate: playbackRate
        });
      }
    },
    progressBarDisplayWidth: {
      get: function get() {
        return _videoControlsController ? _videoControlsController.progressBarControlView.displayWidth : 0;
      }
    },
    currentDisplayMode: {
      get: function get() {
        return _playerState.displayMode;
      }
    }
  });
};
var SmartPlayerView$1 = {
  /**
   *  Factory method that returns a new SmartPlayerView object
   *  @function create
   *  @memberof TSC.SmartPlayerView
   *  @param {String} playerInstanceUUID
   *  @param {jQuery} $rootContainer
   *  @param {TSC.MediaList} mediaList
   *  @param {TSC.XmpModel} xmpModel
   *  @param {TSC.Quiz} quizModel
   *  @param {TSC.CaptionService} captionService
   *  @param {Object} playerConfiguration
   *  @static
   *  @return new SmartPlayerView instance
   */
  create: SmartPlayerView
};

var smartPlayerPreRollEventConstants = Object.freeze({
  PRE_ROLL_STARTED: 'preRollStarted',
  PRE_ROLL_FINISHED: 'preRollFinished',
  PRE_ROLL_FINISHED_ACTIONS: {
    REMOVE_NOW: 'removeNow'
  }
});

var preRollView = {
  render: function render(preRollSrc) {
    return templateGenerator.generatePreRollMarkup(preRollSrc);
  }
};

var _onPreRollStartedCallback;
var $preRollView;
var $window = $(window);
var preRollMessage = function preRollMessage(e) {
  e = e.originalEvent;
  // filter out non smart player events
  if (!e.data || typeof e.data.indexOf !== 'function' || e.data.indexOf('smartPlayerEventName') === -1) {
    return;
  }
  var message = window.JSON.parse(e.data);
  switch (message.smartPlayerEventName) {
    case smartPlayerPreRollEventConstants.PRE_ROLL_STARTED:
      {
        if (_onPreRollStartedCallback) {
          _onPreRollStartedCallback();
        }
        break;
      }
    case smartPlayerPreRollEventConstants.PRE_ROLL_FINISHED:
      {
        switch (message.data.action) {
          case smartPlayerPreRollEventConstants.PRE_ROLL_FINISHED_ACTIONS.REMOVE_NOW:
            {
              destroyView();
              break;
            }
        }
        break;
      }
  }
};
var onIFrameContentLoaded = function onIFrameContentLoaded() {
  $preRollView.removeClass('preRollHidden');
};
var destroyView = function destroyView() {
  if ($preRollView) {
    $window.off('message', preRollMessage);
    $preRollView.off('load', onIFrameContentLoaded);
    $preRollView.remove();
    $preRollView = undefined;
    _onPreRollStartedCallback = undefined;
  }
};
var preRollController = {
  createView: function createView(preRollSrc, onPreRollStartedCallback) {
    $preRollView = $(preRollView.render(preRollSrc)).appendTo('body');
    $preRollView.on('load', onIFrameContentLoaded);
    _onPreRollStartedCallback = onPreRollStartedCallback;
    $window.on('message', preRollMessage);
  },
  viewExists: function viewExists() {
    return $preRollView !== undefined;
  },
  destroyView: destroyView
};

var _$spElement = null;
var setTheme$1 = function setTheme(themeName) {
  playerConfiguration.setTheme(themeName);
  applyTheme();
};
var registerCallback = function registerCallback() {
  externalMessageController.addCallback('SET_THEME', setTheme$1);
};
var setSmartPlayerContainerElement = function setSmartPlayerContainerElement($element) {
  _$spElement = $element;
  applyTheme();
};
var getClassNameForTheme = function getClassNameForTheme(theme) {
  return 'smartplayer-' + theme + '-theme';
};
var applyTheme = function applyTheme() {
  if (_$spElement) {
    var themeClassNameAsString = Object.keys(themeNames).reduce(function (accumulator, currentValue) {
      return accumulator + getClassNameForTheme(themeNames[currentValue]) + ' ';
    }, '');
    var currentThemeClassName = getClassNameForTheme(playerConfiguration.getTheme());
    _$spElement.removeClass(themeClassNameAsString);
    _$spElement.addClass(currentThemeClassName);
  }
};
registerCallback();
var themeController = {
  setTheme: setTheme$1,
  setSmartPlayerContainerElement: setSmartPlayerContainerElement
};

var externalVideoEventIsSupported = function externalVideoEventIsSupported(eventName) {
  return Object.keys(events.ExternalVideo).some(function (eventKey) {
    return events.ExternalVideo[eventKey] === eventName;
  });
};

// major, minor, build
var PLAYER_VERSION = 'x.x.x';
var INIT_DEFAULT_WIDTH = 1920;
var INIT_DEFAULT_HEIGHT = 1080;
var _$rootSmartPlayerElement = null;
var _responsiveController = null;
var _currentPlayerType = null;
var _mediaList = null;
var _xmp = null;
var _quizModel = null;
var _captionService = null;
var _smartPlayerView = NullSmartPlayerView$1.create();
var _viewCreated = false;
var _viewInitialized = false;
var _queuedEvents = {};
var _queuedExternalConfiguration = {};
var _playerInstanceUUID = null;
var _xmpInErrorState = false;
var mediaListError = function mediaListError() {
  MessageBarView$1.create(_$rootSmartPlayerElement, messageBarType.warning, localizationStrings.getPlayerString(playerStringNames.mediaNotFound));
};
var onPreRollStart = function onPreRollStart() {
  continueInit();
};
var initPlayer = function initPlayer(currentInstanceUUID) {
  _captionService = CaptionService$1.create();
  deviceInfo.lookAtDevice();
  queryParamsStripper.strip();
  themeController.setSmartPlayerContainerElement(_$rootSmartPlayerElement);
  if (playerConfiguration.getPreRollSrc()) {
    preRollController.createView(playerConfiguration.getPreRollSrc(), onPreRollStart);
  } else {
    continueInit(currentInstanceUUID);
  }
};
var continueInit = function continueInit(currentInstanceUUID) {
  var mediaSources = playerConfiguration.getMediaSources();
  _mediaList = MediaList$1.create(mediaSources);
  _mediaList.ready.then(function () {
    if (_playerInstanceUUID === currentInstanceUUID) {
      mediaListReady(currentInstanceUUID);
    }
  }, mediaListError);
};
var playbackInitiatedHandler = function playbackInitiatedHandler() {
  _smartPlayerView.removeEventListener(events.External.VideoStartInitiated, playbackInitiatedHandler);
  if (preRollController && preRollController.viewExists()) {
    preRollController.destroyView();
  }
};
var mediaListReady = function mediaListReady(currentInstanceUUID) {
  _currentPlayerType = mediaPlayerController.getPlayerType(_mediaList);
  _responsiveController = ResponsiveController$1.create(_$rootSmartPlayerElement);
  switch (_currentPlayerType) {
    case playerType.YOUTUBE:
      {
        youTube.addApi();
        analyticsService.setCategory(AnalyticsYouTubeEventCategory);
        // we dont have any info on youtube media, so just default to 1080p, it tends to look right
        _responsiveController.initializeIntrinsicSizing(INIT_DEFAULT_WIDTH, INIT_DEFAULT_HEIGHT);
        processMediaAssets(currentInstanceUUID);
        break;
      }
    case playerType.HTML5_VIDEO:
      {
        analyticsService.setCategory(AnalyticsVideoEventCategory);
        if (playerConfiguration.getPosterImageSrc()) {
          // assumption that quick load of posterUrl will have sizing (or at least aspect ratio to match video)
          initIntrinsicSizingFromImageUrl(playerConfiguration.getPosterImageSrc());
        } else {
          _responsiveController.initializeIntrinsicSizing(INIT_DEFAULT_WIDTH, INIT_DEFAULT_HEIGHT);
        }
        processMediaAssets(currentInstanceUUID);
        break;
      }
    case playerType.IMAGE:
      {
        analyticsService.setCategory(AnalyticsImageEventCategory);
        initIntrinsicSizingFromImageUrl(_mediaList.currentMedia.uri);
        processMediaAssets(currentInstanceUUID);
        break;
      }
    case playerType.NOT_SUPPORTED:
      {
        if (_mediaList.currentMediaType === mediaType.WEBM) {
          MessageBarView$1.create(_$rootSmartPlayerElement, messageBarType.warning, localizationStrings.getPlayerString(playerStringNames.noWebMSupport));
        } else {
          MessageBarView$1.create(_$rootSmartPlayerElement, messageBarType.warning, localizationStrings.getPlayerString(playerStringNames.videoNotSupported));
        }
        break;
      }
  }
};
var setQuizModel = function setQuizModel(xmpModel) {
  if (xmpModel && xmpModel.hasQuiz) {
    _quizModel = Quiz$1.create(xmpModel);
  }
};
var initIntrinsicSizingFromImageUrl = function initIntrinsicSizingFromImageUrl(imgUrl) {
  var img = new Image();
  img.onload = function () {
    _responsiveController.initializeIntrinsicSizing(img.naturalWidth, img.naturalHeight);
  };
  img.onerror = function () {
    _responsiveController.initializeIntrinsicSizing(INIT_DEFAULT_WIDTH, INIT_DEFAULT_HEIGHT);
  };
  img.src = imgUrl;
};
var processQuizzing = function processQuizzing() {
  return Promise$1.resolve(_xmp);
};
var processCaptionSrc = function processCaptionSrc() {
  if (playerConfiguration.captionSrcList.length > 0) {
    if (_xmp === null) {
      _xmp = Xmp.create();
    }
    return _xmp.importCaptionsFromFile(playerConfiguration.captionSrcList);
  }
  return Promise$1.resolve();
};
var processXMP = function processXMP() {
  return new Promise$1(function (resolve) {
    if (playerConfiguration.xmpSrc) {
      _xmp = Xmp.create();
      if (window.TSC && typeof window.TSC.embedded_config_xml === 'string') {
        _xmp.parse(window.TSC.embedded_config_xml);
      } else {
        _xmp.load(playerConfiguration.xmpSrc, false);
      }
      _xmp.ready.then(resolve)["catch"](function () {
        _xmpInErrorState = true;
        _xmp.abortPendingRequests();
        _xmp = null;
        resolve();
      });
    } else {
      if (playerConfiguration.getTocModelFromDescription()) {
        _xmp = Xmp.create();
      }
      resolve();
    }
  });
};
var processMediaAssets = function processMediaAssets(currentInstanceUUID) {
  if (playerConfiguration.getGoogleAnalyticsID()) {
    analyticsService.initGoogleAnalytics();
  }
  processXMP().then(function () {
    if (_playerInstanceUUID === currentInstanceUUID) {
      if (_xmp) {
        playerConfiguration.configureFromXmp(_xmp);
        localizationStrings.configureFromXmp(_xmp);
      }
      processCaptionSrc().then(function () {
        if (_playerInstanceUUID === currentInstanceUUID) {
          processQuizzing().then(function (xmpModel) {
            if (_playerInstanceUUID === currentInstanceUUID) {
              if (xmpModel) {
                setQuizModel(xmpModel);
              }
              setupPlayer(currentInstanceUUID);
            }
          });
        }
      });
    }
  });
};
var captionChangeHandler = function captionChangeHandler(text) {
  if (iFrameBridge.isInIframe()) {
    iFrameBridge.postMessage('CAPTION-CHANGED', '*', text);
  }
};
var setupBasicCss = function setupBasicCss() {
  _$rootSmartPlayerElement.addClass(cssClasses.smartPlayerNamespace);
  _$rootSmartPlayerElement.addClass(cssClasses.playerControlsVisible);
  if (playerConfiguration.getUseLargerProgressBar()) {
    _$rootSmartPlayerElement.addClass(cssClasses.largerProgressBar);
  }

  // mainly for backwards compat for pre-version 3.38.0 traverse parent-chain and set height/pad/etc if default
  if (playerConfiguration.getFullViewPort()) {
    _$rootSmartPlayerElement.parents().each(function (index, parentNode) {
      var $parentNode = $(parentNode);
      $parentNode.height('100%');
      if ($parentNode.prop('tagName').toLowerCase() === 'body') {
        $parentNode.css({
          margin: 0,
          padding: 0,
          border: 0,
          overflow: 'hidden'
        });
      }
    });
  }
};
var addQueuedEventsToSmartPlayerView = function addQueuedEventsToSmartPlayerView() {
  Object.keys(_queuedEvents).forEach(function (eventName) {
    _queuedEvents[eventName].forEach(function (eventCallback) {
      addEventListener$1(eventName, eventCallback);
    });
  });
};
var setQueuedConfigurationValuesToSmartPlayerView = function setQueuedConfigurationValuesToSmartPlayerView() {
  if (_queuedExternalConfiguration.volume !== undefined) {
    _smartPlayerView.volume = _queuedExternalConfiguration.volume;
  }
  if (_queuedExternalConfiguration.muted !== undefined) {
    _smartPlayerView.muted = _queuedExternalConfiguration.muted;
  }
  if (_queuedExternalConfiguration.playbackRate !== undefined) {
    _smartPlayerView.playbackRate = _queuedExternalConfiguration.playbackRate;
  }
};
var initPlayerView = function initPlayerView(currentInstanceUUID, displayLocalWarning) {
  _smartPlayerView = SmartPlayerView$1.create(currentInstanceUUID, _$rootSmartPlayerElement, _mediaList, _xmp, _quizModel, _captionService, playerConfiguration, _responsiveController, _xmpInErrorState);
  _viewCreated = true;
  addQueuedEventsToSmartPlayerView();
  _smartPlayerView.initializedPromise.then(function () {
    if (_playerInstanceUUID === currentInstanceUUID) {
      _viewInitialized = true;
      setQueuedConfigurationValuesToSmartPlayerView();
      _smartPlayerView.addEventListener(events.External.VideoStartInitiated, playbackInitiatedHandler);
      _smartPlayerView.addEventListener(events.External.CaptionChange, captionChangeHandler);
      if (playerConfiguration.getAutoPlayMedia() || playerConfiguration.getForceAutoPlayMedia()) {
        _smartPlayerView.loadMedia();
      }
      if (displayLocalWarning) {
        MessageBarView$1.create(_$rootSmartPlayerElement, messageBarType.info, localizationStrings.getPlayerString(playerStringNames.xmpSecurity), localizationStrings.getPlayerString(playerStringNames.close));
      }
    }
  });
};
var setupPlayer = function setupPlayer(currentInstanceUUID) {
  var displayLocalWarning = false;
  if (_currentPlayerType === playerType.IMAGE) {
    _$rootSmartPlayerElement.addClass('image-view');
  } else {
    _$rootSmartPlayerElement.addClass('video-view');
  }
  if (_xmp) {
    if (_xmp.hasCaptionItems) {
      if (iFrameBridge.isInIframe()) {
        iFrameBridge.postMessage('HAS-CAPTIONS', '*');
      }
    }
  }
  if (_quizModel && _quizModel.hasQuiz) {
    if (deviceInfo.isLocal() && _quizModel.reportMethod !== reportType.NONE) {
      displayLocalWarning = true;
      _quizModel.reportMethod = reportType.NONE;
    } else if (_quizModel.useScorm && _quizModel.totalNumberOfGradedQuestionSets === 0) {
      playerConfiguration.isScormLesson = true;
    }
  }
  if (playerConfiguration.isScormLesson) {
    scormController$1.init().then(function () {
      initPlayerView(currentInstanceUUID, displayLocalWarning);
    });
  } else {
    initPlayerView(currentInstanceUUID, displayLocalWarning);
  }
};
var triggerEvent = function triggerEvent(eventName, data) {
  if (_$rootSmartPlayerElement) {
    _$rootSmartPlayerElement.trigger(eventName, data);
  }
};
var init = function init(rootElementID) {
  _playerInstanceUUID = uuidGenerator$1.getUUID();
  performanceWrapper.createMarker(events.Timing.PlayerInitialized);
  _$rootSmartPlayerElement = $(rootElementID);
  setupBasicCss();
  initPlayer(_playerInstanceUUID);
};
var getSmartPlayerRootElement = function getSmartPlayerRootElement() {
  return _$rootSmartPlayerElement;
};
var destroy$1 = function destroy() {
  _playerInstanceUUID = null;
  _currentPlayerType = null;
  _mediaList = null;
  _xmp && _xmp.abortPendingRequests();
  _xmp = null;
  _quizModel = null;
  _viewCreated = false;
  _viewInitialized = false;
  _captionService = null;
  _queuedEvents = {};
  _queuedExternalConfiguration = {};
  _xmpInErrorState = false;
  localizationStrings.reset();
  if (_$rootSmartPlayerElement) {
    _smartPlayerView.removeEventListener(events.External.VideoStartInitiated, playbackInitiatedHandler);
    _smartPlayerView.removeEventListener(events.External.CaptionChange, captionChangeHandler);
    _smartPlayerView.destroy();
    _smartPlayerView = NullSmartPlayerView$1.create();
    _$rootSmartPlayerElement.removeClass(cssClasses.smartPlayerNamespace + ' ' + cssClasses.largerProgressBar + ' video-view image-view');
    _$rootSmartPlayerElement = null;
  }
};
var getVersion = function getVersion() {
  return PLAYER_VERSION;
};
var playMedia = function playMedia() {
  _smartPlayerView.play();
};
var pauseMedia = function pauseMedia() {
  _smartPlayerView.pause();
};
var queueEventHandler = function queueEventHandler(eventName, callback) {
  if (!_queuedEvents[eventName]) {
    _queuedEvents[eventName] = [];
  }
  _queuedEvents[eventName].push(callback);
};
var dequeueEventHandler = function dequeueEventHandler(eventName, callback) {
  var eventEntry = _queuedEvents[eventName];
  if (eventEntry) {
    for (var i = 0; i < eventEntry.length; i++) {
      if (eventEntry[i] === callback) {
        eventEntry.splice(i, 1);
        break;
      }
    }
    if (eventEntry.length === 0) {
      _queuedEvents[eventName] = undefined;
    }
  }
};
var addEventListener$1 = function addEventListener(eventName, callback) {
  if (!_viewCreated) {
    queueEventHandler(eventName, callback);
  } else if (externalVideoEventIsSupported(eventName)) {
    _smartPlayerView.addMediaEventListener(eventName, callback);
  } else {
    _smartPlayerView.addEventListener(eventName, callback);
  }
};
var removeEventListener$1 = function removeEventListener(eventName, callback) {
  if (!_viewInitialized) {
    dequeueEventHandler(eventName, callback);
  } else if (externalVideoEventIsSupported(eventName)) {
    _smartPlayerView.removeMediaEventListener(eventName, callback);
  } else {
    _smartPlayerView.removeEventListener(eventName, callback);
  }
};
var getCurrentSrc = function getCurrentSrc() {
  return _viewInitialized ? _smartPlayerView.currentSrc : playerConfiguration.getMediaSrc();
};
var getCurrentTime = function getCurrentTime() {
  return _smartPlayerView.currentTime;
};
var setCurrentTime = function setCurrentTime(timeInSeconds) {
  _smartPlayerView.currentTime = timeInSeconds;
};
var getDuration = function getDuration() {
  return _smartPlayerView.duration;
};
var getEnded = function getEnded() {
  return _smartPlayerView.ended;
};
var getPaused = function getPaused() {
  return _smartPlayerView.paused;
};
var getPlaybackRate = function getPlaybackRate() {
  return _smartPlayerView.playbackRate;
};
var setPlaybackRate = function setPlaybackRate(playbackRate) {
  if (_viewInitialized) {
    _smartPlayerView.playbackRate = playbackRate;
  } else {
    _queuedExternalConfiguration.playbackRate = playbackRate;
  }
};
var getBuffered = function getBuffered() {
  return _smartPlayerView.buffered;
};
var getPlayed = function getPlayed() {
  return _smartPlayerView.played;
};
var getSeekable = function getSeekable() {
  return _smartPlayerView.seekable;
};
var getSeeking = function getSeeking() {
  return _smartPlayerView.seeking;
};
var getVolume = function getVolume() {
  return _smartPlayerView.volume;
};
var setVolume = function setVolume(volumeValue) {
  if (_viewInitialized) {
    _smartPlayerView.volume = volumeValue;
  } else {
    _queuedExternalConfiguration.volume = volumeValue;
  }
};
var getMuted = function getMuted() {
  return _viewInitialized ? _smartPlayerView.muted : _queuedExternalConfiguration.muted;
};
var setMuted$1 = function setMuted(isMuted) {
  if (_viewInitialized) {
    _smartPlayerView.muted = isMuted;
  } else {
    _queuedExternalConfiguration.muted = isMuted;
  }
};
var isInFullScreenMode = function isInFullScreenMode() {
  return _smartPlayerView.isInFullScreenMode();
};
var getScrubbing = function getScrubbing() {
  return _smartPlayerView.getScrubbing();
};
var setScrubbing = function setScrubbing(isScrubbing) {
  _smartPlayerView.setScrubbing(isScrubbing);
};
var getSafeSeekTime = function getSafeSeekTime(time) {
  return _smartPlayerView.getSafeSeekTime(time);
};
var getCaptionsVisible = function getCaptionsVisible() {
  return _smartPlayerView.getCaptionsVisible();
};
var setCaptionsVisible = function setCaptionsVisible(isVisible) {
  _smartPlayerView.setCaptionsVisible(isVisible);
};
var getIsYouTube = function getIsYouTube() {
  return _mediaList ? mediaPlayerController.getPlayerType(_mediaList) === playerType.YOUTUBE : false;
};
var getCaptionCollection = function getCaptionCollection() {
  return _captionService && _captionService.captionTrack && _captionService.captionTrack.captionCollection ? _captionService.captionTrack.captionCollection : null;
};
var getCaptionTrack = function getCaptionTrack() {
  return _captionService.captionTrack;
};
var setCaptionTrack = function setCaptionTrack(value) {
  _captionService.captionTrack = value;
};
var getTocChapters = function getTocChapters() {
  if (!_xmp || !_xmp.hasTocItems) {
    return [];
  }
  return _xmp.tocItemArray;
};
var getProgressBarDisplayWidth = function getProgressBarDisplayWidth() {
  return _smartPlayerView ? _smartPlayerView.progressBarDisplayWidth : 0;
};
var getCurrentDisplayMode = function getCurrentDisplayMode() {
  return _smartPlayerView && _smartPlayerView.currentDisplayMode;
};
var mediaPlayer = Object.defineProperties({
  init: init,
  destroy: destroy$1,
  getSmartPlayerRootElement: getSmartPlayerRootElement,
  getVersion: getVersion,
  jsSeekTime: setCurrentTime,
  jsPlay: playMedia,
  play: playMedia,
  pause: pauseMedia,
  getCurrentSrc: getCurrentSrc,
  getCurrentTime: getCurrentTime,
  setCurrentTime: setCurrentTime,
  getDuration: getDuration,
  getEnded: getEnded,
  getPaused: getPaused,
  getPlaybackRate: getPlaybackRate,
  setPlaybackRate: setPlaybackRate,
  getBuffered: getBuffered,
  getPlayed: getPlayed,
  getSeekable: getSeekable,
  getSeeking: getSeeking,
  getVolume: getVolume,
  setVolume: setVolume,
  getMuted: getMuted,
  setMuted: setMuted$1,
  isInFullScreenMode: isInFullScreenMode,
  getScrubbing: getScrubbing,
  setScrubbing: setScrubbing,
  getSafeSeekTime: getSafeSeekTime,
  addEventListener: addEventListener$1,
  removeEventListener: removeEventListener$1,
  triggerEvent: triggerEvent,
  getCaptionsVisible: getCaptionsVisible,
  setCaptionsVisible: setCaptionsVisible,
  getIsYouTube: getIsYouTube,
  getCaptionCollection: getCaptionCollection,
  getCaptionTrack: getCaptionTrack,
  setCaptionTrack: setCaptionTrack,
  getTocChapters: getTocChapters,
  getProgressBarDisplayWidth: getProgressBarDisplayWidth,
  getCurrentDisplayMode: getCurrentDisplayMode
}, {});

/**
 * @memberof TSC
 * @class Plugin
 * @classdesc Plugin Object
 * @param {String} pluginName - name of plugin
 * @param {String} viewElementType - view element type to install plugin into
 */
var Plugin = function Plugin(pluginName, viewElementType) {
  var _initialized = false;
  var _initializedPromiseResolve;
  var _initializedPromise = new Promise$1(function (resolve) {
    _initializedPromiseResolve = resolve;
  });
  var _pluginName = pluginName;
  var _viewElementType = viewElementType;

  /**
   * @function init
   * @memberOf TSC.Plugin
   * Initialize plugin with dom element container that will resolve initialized promise.
   * @param {HTMLElement} pluginContainerElement - dom element that will be the container for plugin UI
   */
  var init = function init(pluginContainerElement) {
    if (_initialized) {
      return;
    }
    _initialized = true;
    _initializedPromiseResolve({
      pluginContainerElement: pluginContainerElement
    });
  };
  return Object.defineProperties({
    init: init
  }, {
    initialized: {
      get: function get() {
        return _initialized;
      }
    },
    initializedPromise: {
      get: function get() {
        return _initializedPromise;
      }
    },
    pluginName: {
      get: function get() {
        return _pluginName;
      }
    },
    viewElementType: {
      get: function get() {
        return _viewElementType;
      }
    }
  });
};
var Plugin$1 = {
  /**
   *  Factory method that returns a new Plugin object.
   *  @function create
   *  @memberof TSC.Plugin
   *  @static
   *  @return new Plugin instance
   */
  create: Plugin
};

var REMOVE_SPACES_REGEX = /\s+/g;

/**
 * @memberof TSC
 * @class PluginController
 * @classdesc Plugin Controller to wire up external plugins
 */
var PluginController = function PluginController() {
  var _plugins = {};

  /**
   * @function isViewElementTypeSupported
   * Check to see if a viewElementType is supported.
   * @param {String} viewElementType - view element type for plugin
   * @return {Boolean} return if passed in viewElementType is supported.
   */
  var isViewElementTypeSupported = function isViewElementTypeSupported(viewElementType) {
    return Object.keys(supportedPluginViewElements).some(function (key) {
      return supportedPluginViewElements[key] === viewElementType;
    });
  };

  /**
   * @function getPluginsForViewElementType
   * Get a list of plugin objects for the passed in view element type.
   * @param {String} viewElementType - view element type for plugin
   * @return {Array} return an array of supported plugins for the passed in view element type
   */
  var getPluginsForViewElementType = function getPluginsForViewElementType(viewElementType) {
    return Object.keys(_plugins).filter(function (key) {
      return _plugins[key].viewElementType === viewElementType;
    }).map(function (key) {
      return _plugins[key];
    });
  };

  /**
   * @function getPluginContainerElement
   * Get a new div element setup for a plugin to append elements to.
   * @param {String} pluginName - name of plugin
   * @return {Element} return a new div element setup for old plugin dom
   */
  var getPluginContainerElement = function getPluginContainerElement(pluginName) {
    var pluginNameNoSpaces = pluginName.replace(REMOVE_SPACES_REGEX, '');
    var pluginNamedContainerClassName = cssClasses.pluginNamedContainerPrefix + pluginNameNoSpaces;
    var pluginContainerElement = document.createElement('div');
    pluginContainerElement.classList.add(cssClasses.generatedPluginContainer);
    pluginContainerElement.classList.add(pluginNamedContainerClassName);
    return pluginContainerElement;
  };

  /**
   * @function registerPlugin
   * @methodOf TSC.PluginController
   * @param {String} pluginName - name of plugin
   * @param {String} viewElementType - view element type to install plugin into
   * @return {Promise} return a promise that resolves when the specified view element has initialized the plugin
   */
  var registerPlugin = function registerPlugin(pluginName, viewElementType) {
    if (_plugins[pluginName]) {
      var pluginSameNameMessage = 'Plugin with name [' + pluginName + '] is already registered with the player.';
      log.logMessage(pluginSameNameMessage);
      return Promise$1.reject(pluginSameNameMessage);
    }
    if (!isViewElementTypeSupported(viewElementType)) {
      var pluginUnsupportedViewElementMessage = 'Plugin with name [' + pluginName + '] is registering with an unsupported view element [' + viewElementType + '].';
      log.logMessage(pluginUnsupportedViewElementMessage);
      return Promise$1.reject(pluginUnsupportedViewElementMessage);
    }
    var plugin = Plugin$1.create(pluginName, viewElementType);
    _plugins[pluginName] = plugin;
    return plugin.initializedPromise;
  };

  /**
   * @function initializePluginsForViewElement
   * @methodOf TSC.PluginController
   * Initialize all registered plugins for the passed in view element type
   * @param {String} viewElementType - view element type
   * @param {jQuery} $viewElementPluginContainer - jQuery element to add plugin dom elements into.
   */
  var initializePluginsForViewElement = function initializePluginsForViewElement(viewElementType, $viewElementPluginContainer) {
    if (!isViewElementTypeSupported(viewElementType)) {
      log.logMessage('Tried to initialize plugin with unsupported view element type [' + viewElementType + ']');
      return;
    }
    var elementTypePlugins = getPluginsForViewElementType(viewElementType);
    elementTypePlugins.forEach(function (plugin) {
      if (plugin.initialized) {
        return;
      }
      var pluginContainerElement = getPluginContainerElement(plugin.pluginName);
      $viewElementPluginContainer.append(pluginContainerElement);
      plugin.init(pluginContainerElement);
    });
    if (elementTypePlugins.length === 0) {
      $viewElementPluginContainer.hide();
    } else {
      $viewElementPluginContainer.show();
    }
  };
  return Object.defineProperties({
    registerPlugin: registerPlugin,
    initializePluginsForViewElement: initializePluginsForViewElement
  }, {});
};
var PluginController$1 = {
  /**
   *  Factory method that returns a new PluginController object.
   *  @function create
   *  @memberof TSC.PluginController
   *  @static
   *  @return new PluginController instance
   */
  create: PluginController
};

var CamtasiaQuizPreviewView = function CamtasiaQuizPreviewView($container, xmpString) {
  var xmpModel = Xmp.create();
  xmpModel.parse(xmpString);
  return xmpModel.ready.then(function () {
    playerConfiguration.configureFromXmp(xmpModel);
    localizationStrings.configureFromXmp(xmpModel);
    var beforeAfterPlayControlsView = BeforeAfterPlayControlsView$1.create($container, playerConfiguration);
    var noOp = function noOp() {}; // eslint-disable-line
    var playerMarkup = templateGenerator.generateVideoViewMarkup('quiz-preview-' + new Date().getTime());
    $container.html(playerMarkup);
    var ioOverlayView = IoOverlayView$1.create($container);
    var mediaView = VideoElementView$1.create($container, $container.find('.media-container'), ['video.mp4'], true, noOp, noOp, ioOverlayView);

    // hack Camtasia quiz preview template to display preview correctly
    var previewElement = document.getElementsByClassName('video-view');
    if (previewElement.length > 0) {
      previewElement[0].style.height = '100%';
    }
    mediaView.mediaElement.style.display = 'none';
    var quizModel = Quiz$1.create(xmpModel);
    var quizController = QuizController$1.create($container, mediaView, quizModel, beforeAfterPlayControlsView, true);
    quizController.displayNextQuestionSet();
  });
};
var CamtasiaQuizPreviewView$1 = {
  create: CamtasiaQuizPreviewView
};

var dependencies = {
	"@techsmith/tsc-cloud-style-guide": "^24.0.0",
	"@techsmith/tsc-media-extensions-js": "10.7.2",
	jquery: "^3.5.1",
	pepjs: "0.4.3",
	"promise-polyfill": "^8.1.0",
	tinycolor2: "^1.4.1"
};
var devDependencies = {
	"@babel/core": "^7.20.12",
	"@babel/preset-env": "^7.12.13",
	"@rollup/plugin-alias": "^5.1.0",
	"@rollup/plugin-babel": "^6.0.4",
	"@rollup/plugin-commonjs": "^25.0.7",
	"@rollup/plugin-json": "^6.1.0",
	"@rollup/plugin-node-resolve": "^15.2.3",
	"@rollup/plugin-terser": "^0.4.4",
	autoprefixer: "^6.3.5",
	"axe-core": "^3.2.2",
	commander: "^12.0.0",
	compressing: "^1.5.0",
	cssnano: "^3.5.2",
	cypress: "^10.6.0",
	"cypress-axe": "^1.0.0",
	"cypress-intellij-reporter": "^0.0.7",
	esbuild: "^0.17.4",
	eslint: "^7.5.0",
	"eslint-config-techsmith": "^1.1.0",
	grunt: "~1.6.1",
	"grunt-banner": "^0.6.0",
	"grunt-cdnify": "~1.0.2",
	"grunt-cli": "~1.4.3",
	"grunt-contrib-clean": "~2.0.0",
	"grunt-contrib-concat": "^1.0.1",
	"grunt-contrib-connect": "~2.0.0",
	"grunt-contrib-copy": "~1.0.0",
	"grunt-contrib-less": "^2.0.0",
	"grunt-contrib-watch": "~1.1.0",
	"grunt-downloadfile": "^2.1.1",
	"grunt-htmlrefs": "~0.5.0",
	"grunt-md2html": "~0.3.1",
	"grunt-newer": "~1.3.0",
	"grunt-open": "~0.2.4",
	"grunt-postcss": "^0.9.0",
	"grunt-replace": "~1.0.1",
	"grunt-shell": "^3.0.1",
	"jasmine-core": "^2.5.2",
	karma: "^6.3.20",
	"karma-chrome-launcher": "^2.2.0",
	"karma-jasmine": "^1.1.2",
	"karma-mocha-reporter": "^2.2.5",
	"karma-rollup-preprocessor": "^7.0.0",
	"load-grunt-tasks": "^0.4.0",
	lodash: "^4.17.19",
	markdown: "^0.5.0",
	"postcss-assets": "^4.0.1",
	"postcss-svg": "^1.0.6",
	rollup: "^4.14.0",
	"rollup-plugin-filesize": "^10.0.0",
	"rollup-plugin-glob-import": "^0.5.0",
	"rollup-plugin-license": "^3.3.1",
	"time-grunt": "^2.0.0",
	yamljs: "^0.2.4"
};
var license = "UNLICENSED";
var main = "dist/techsmith-smart-player.js";
var module$1 = "dist/techsmith-smart-player.esm.js";
var name = "@techsmith/techsmith-smartplayer";
var preferGlobal = false;
var repository = {
	type: "git",
	url: "https://github.com/TechSmith/SmartPlayer.git"
};
var scripts = {
	buildSmartPlayerIife: "npx rollup --config rollup.config.mjs --config-env production --config-package smartplayer --config-format iife",
	buildEmbedIife: "npx rollup --config rollup.config.mjs --config-env production --config-package embed --config-format iife",
	buildSmartPlayerEsm: "npx rollup --config rollup.config.mjs --config-env production --config-package smartplayer --config-format esm",
	buildPreRollIife: "npx rollup --config rollup.config.mjs --config-env production --config-package preroll --config-format iife",
	devSmartPlayerIife: "npx rollup --config rollup.config.mjs --config-env development --config-package smartplayer --config-format iife",
	devSmartPlayerEsm: "npx rollup --config rollup.config.mjs --config-env development --config-package smartplayer --config-format esm",
	devEmbedIife: "npx rollup --config rollup.config.mjs --config-env development --config-package embed --config-format iife",
	devPreRollIife: "npx rollup --config rollup.config.mjs --config-env development --config-package preroll --config-format iife",
	devESBIife: "node ./esbuild.config.js --config-env development --config-package smartplayer --config-format iife",
	devESBEmbedIife: "node ./esbuild.config.js --config-env development --config-package embed --config-format iife",
	devESBPrerollIife: "node ./esbuild.config.js --config-env development --config-package preroll --config-format iife",
	devESBIEsm: "node ./esbuild.config.js --config-env development --config-package smartplayer --config-format esm",
	"integration-release": "grunt integration --rs=bin/integration",
	lint: "npx eslint html5/**/*.js",
	"lint-fix": "npx eslint html5/**/*.js --fix",
	test: "npx karma start ./karma.config.js --single-run",
	"test-watch": "npx karma start ./karma.config.js"
};
var version = "5.124.0";
var packageJson = {
	dependencies: dependencies,
	devDependencies: devDependencies,
	license: license,
	main: main,
	module: module$1,
	name: name,
	preferGlobal: preferGlobal,
	repository: repository,
	scripts: scripts,
	version: version
};

var timeCodeRegex = /^((0?[0-9]:)?[0-5]?[0-9]):([0-5][0-9]) /;
var newlineRegex = /\r?\n/g;
var milliseconds = 1000;
var defaultStartTime = 0;
var defaultChapterName = localizationStrings.getPlayerString(playerStringNames.defaultFirstChapterName);
var getChapterNameFromLineString = function getChapterNameFromLineString(lineString) {
  return lineString.indexOf(' ') === -1 ? defaultChapterName : lineString.substring(lineString.indexOf(' '), lineString.length).trim();
};
var createTocItem = function createTocItem(chapterName, startTime) {
  var chapterParams = {
    name: chapterName,
    startTime: startTime
  };
  if (playerConfiguration.videoThumbnailsSrc) {
    chapterParams.image = playerConfiguration.videoThumbnailsSrc;
    var rect = getThumbnailRectangleByTime(startTime / milliseconds, playerConfiguration.videoThumbnailInterval, playerConfiguration.videoThumbnailColumns, playerConfiguration.videoThumbnailWidth, playerConfiguration.videoThumbnailHeight);
    chapterParams.imageRectangle = ImageRectangle$1.create({
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    });
  }
  return TableOfContentsItem$1.create(chapterParams);
};
var parseTableOfContentsItemFromString = function parseTableOfContentsItemFromString(lineString) {
  var timecodes = lineString.match(timeCodeRegex);
  if (timecodes) {
    var chapterName = getChapterNameFromLineString(lineString);
    var chapterStartTime = timeFormatter.convertTimecodeToMilliseconds(timecodes[0]);
    return createTocItem(chapterName, chapterStartTime);
  }
};

/**
 *  Utility function will take a block of text as a string and parse it looking for chapter information to convert to a TOC Model.
 *  @function textToTocModel
 *  @param {String} textString - A string of text to search to see if it contains chapter information to convert to a TOC model.
 *  @returns {TableOfContentsTrack} Table of Contents Track object from TSC media extensions lib.
 */
var textToTocModel = function textToTocModel(textString) {
  if (!textString || typeof textString !== 'string') {
    return null;
  }
  var textSplitNewlines = textString.split(newlineRegex);
  var chapterItems = [];
  var previousTocItemStartTime = -1;
  textSplitNewlines.forEach(function (textLine) {
    if (timeCodeRegex.test(textLine)) {
      var tocItem = parseTableOfContentsItemFromString(textLine);
      if (tocItem && tocItem.startTime > previousTocItemStartTime) {
        previousTocItemStartTime = tocItem.startTime;
        chapterItems.push(tocItem);
      }
    }
  });

  // insert a default chapter at time 0 if the input did not specify one
  if (chapterItems.length && chapterItems[0].startTime !== 0) {
    chapterItems.unshift(createTocItem(defaultChapterName, defaultStartTime));
  }
  return chapterItems.length ? TableOfContentsTrack$1.create({
    items: chapterItems
  }) : null;
};

var deprecatedConfigSetter = function deprecatedConfigSetter(deprecatedName) {
  console.info("[SmartPlayer] ".concat(deprecatedName, " setter is deprecated.")); // eslint-disable-line no-console
};
var deprecatedConfigGetter = function deprecatedConfigGetter(deprecatedName, returnValue) {
  console.info("[SmartPlayer] ".concat(deprecatedName, " getter is deprecated.")); // eslint-disable-line no-console
  return returnValue;
};

var _started = false;
var _controls = mediaInterfaceConstants.controls.autohide;
var _lastError = null;
var _pluginController = null;
var addEventListener = function addEventListener(eventName, callback) {
  if (eventName === events.External.AnalyticsEvent || eventName === events.External.GoogleAnalyticsCustomEvent) {
    playerConfiguration.useCustomEventTracking(true, callback);
  } else if (eventName === events.External.GoogleAnalytics4Event) {
    playerConfiguration.setGA4EventCallback(callback);
  } else {
    mediaPlayer.addEventListener(eventName, callback);
  }
};
var removeEventListener = function removeEventListener(eventName, callback) {
  if (eventName === events.External.AnalyticsEvent || eventName === events.External.GoogleAnalyticsCustomEvent) {
    playerConfiguration.useCustomEventTracking(false, callback);
  } else if (eventName === events.External.GoogleAnalytics4Event) {
    playerConfiguration.setGA4EventCallback(null);
  } else {
    mediaPlayer.removeEventListener(eventName, callback);
  }
};
var setAutoPlay = function setAutoPlay(value) {
  playerConfiguration.setAutoPlayMedia(String(value).toLowerCase() === 'true');
};
var getControls = function getControls() {
  return _controls;
};
var setControls = function setControls(value) {
  var lowerCaseValue = String(value).toLowerCase();
  if (lowerCaseValue === mediaInterfaceConstants.controls["false"]) {
    _controls = mediaInterfaceConstants.controls["false"];
    playerConfiguration.setDisableControls(true);
    playerConfiguration.setAutoHideControls(false);
    playerConfiguration.setDisableYouTubeControls(true);
  } else if (lowerCaseValue === mediaInterfaceConstants.controls["true"]) {
    _controls = mediaInterfaceConstants.controls["true"];
    playerConfiguration.setDisableControls(false);
    playerConfiguration.setAutoHideControls(false);
    playerConfiguration.setDisableYouTubeControls(true);
  } else if (lowerCaseValue === mediaInterfaceConstants.controls.youtube) {
    _controls = mediaInterfaceConstants.controls.youtube;
    playerConfiguration.setDisableControls(true);
    playerConfiguration.setAutoHideControls(false);
    playerConfiguration.setDisableYouTubeControls(false);
  } else {
    // default 'autohide'
    _controls = mediaInterfaceConstants.controls.autohide;
    playerConfiguration.setDisableControls(false);
    playerConfiguration.setAutoHideControls(true);
    playerConfiguration.setDisableYouTubeControls(true);
  }
  mediaPlayer.triggerEvent(events.Controls.Updated);
};
var setDisableInteractions = function setDisableInteractions(disableInteractions) {
  playerConfiguration.setDisableInteractions(disableInteractions);
  mediaPlayer.triggerEvent(events.Controls.Updated);
};
var getLoop = function getLoop() {
  var endActionParam = playerConfiguration.getEndActionParam();
  return playerConfiguration.getEndActionType().toLowerCase() === 'loop' && (endActionParam === 'true' || endActionParam === '1');
};
var setLoop = function setLoop(value) {
  if (String(value).toLowerCase() === 'true') {
    playerConfiguration.setEndActionType('loop');
    playerConfiguration.setEndActionParam('true');
  } else {
    playerConfiguration.setEndActionType('stop');
    playerConfiguration.setEndActionParam('true');
  }
};
var getError = function getError() {
  return _lastError;
};
var setMuted = function setMuted(value) {
  mediaPlayer.setMuted(String(value).toLowerCase() === 'true');
};
var getContextMenuEnabled = function getContextMenuEnabled() {
  return !playerConfiguration.getDisableContextMenuForVideo();
};
var setContextMenuEnabled = function setContextMenuEnabled(value) {
  playerConfiguration.setDisableContextMenuForVideo(!value);
};
var addMediaSrc = function addMediaSrc(src) {
  playerConfiguration.addMediaSrc(src);
};
var generalErrorHandler = function generalErrorHandler(event) {
  _lastError = event.data;
};
var run = function run(containerId) {
  if (_started) {
    return;
  }
  deviceInfo.lookAtDevice();
  playerConfiguration.setDisableFullframeMode(true);
  playerConfiguration.setFullViewPort(false);
  mediaPlayer.init('#' + containerId);
  addEventListener('error', generalErrorHandler);
  _started = true;
};
var destroy = function destroy() {
  if (!_started) {
    return;
  }
  var $spElement = mediaPlayer.getSmartPlayerRootElement();
  removeEventListener('error', generalErrorHandler);
  mediaPlayer.destroy();
  if ($spElement) {
    $spElement.removeClass();
    $spElement.empty();
  }
  playerConfiguration.clearConfiguration();
  _started = false;
  _controls = mediaInterfaceConstants.controls.autohide;
  _lastError = null;
  _pluginController = null;
};
var setTheme = function setTheme(themeName) {
  themeController.setTheme(themeName);
};
var setupPluginController = function setupPluginController() {
  _pluginController = PluginController$1.create();
  playerConfiguration.setPluginController(_pluginController);
};
var registerPlugin = function registerPlugin(pluginName, viewElementType) {
  if (!_pluginController) {
    setupPluginController();
  }
  var pluginInitPromise = _pluginController.registerPlugin(pluginName, viewElementType);
  mediaPlayer.triggerEvent(events.Plugin.Added, {
    viewElementType: viewElementType
  });
  return pluginInitPromise;
};
var displayQuizPreview = function displayQuizPreview(containerElement, xmpString) {
  var $container = $(containerElement);
  CamtasiaQuizPreviewView$1.create($container, xmpString);
};
var displayImageFullscreen = function displayImageFullscreen() {
  mediaPlayer.triggerEvent(events.External.SwitchToFullscreen);
};
var exitImageFullscreen = function exitImageFullscreen() {
  mediaPlayer.triggerEvent(events.External.ExitFullscreen);
};
var createTocFromDescription = function createTocFromDescription(descriptionText) {
  if (descriptionText && typeof descriptionText === 'string') {
    var tocModel = textToTocModel(decodeURIComponent(descriptionText));
    if (tocModel) {
      playerConfiguration.tocModelFromDescription = tocModel;
    }
  }
};
var mediaInterfaceController = Object.defineProperties({
  play: mediaPlayer.play,
  pause: mediaPlayer.pause,
  addEventListener: addEventListener,
  removeEventListener: removeEventListener,
  addSrc: addMediaSrc,
  addCaptionSrc: playerConfiguration.addCaptionSrc,
  run: run,
  destroy: destroy,
  setTheme: setTheme,
  registerPlugin: registerPlugin,
  displayQuizPreview: displayQuizPreview,
  displayImageFullscreen: displayImageFullscreen,
  exitImageFullscreen: exitImageFullscreen,
  getSafeSeekTime: mediaPlayer.getSafeSeekTime,
  createTocFromDescription: createTocFromDescription
}, {
  version: {
    get: function get() {
      return packageJson.version;
    }
  },
  autoplay: {
    get: playerConfiguration.getAutoPlayMedia,
    set: setAutoPlay
  },
  controls: {
    get: getControls,
    set: setControls
  },
  disableInteractions: {
    get: playerConfiguration.getDisableInteractions,
    set: setDisableInteractions
  },
  currentSrc: {
    get: mediaPlayer.getCurrentSrc
  },
  currentTime: {
    get: mediaPlayer.getCurrentTime,
    set: mediaPlayer.setCurrentTime
  },
  duration: {
    get: mediaPlayer.getDuration
  },
  error: {
    get: getError
  },
  ended: {
    get: mediaPlayer.getEnded
  },
  loop: {
    get: getLoop,
    set: setLoop
  },
  muted: {
    get: mediaPlayer.getMuted,
    set: setMuted
  },
  paused: {
    get: mediaPlayer.getPaused
  },
  playbackRate: {
    get: mediaPlayer.getPlaybackRate,
    set: mediaPlayer.setPlaybackRate
  },
  buffered: {
    get: mediaPlayer.getBuffered
  },
  played: {
    get: mediaPlayer.getPlayed
  },
  seekable: {
    get: mediaPlayer.getSeekable
  },
  preload: {
    get: playerConfiguration.getPreload,
    set: playerConfiguration.setPreload
  },
  seeking: {
    get: mediaPlayer.getSeeking
  },
  volume: {
    get: mediaPlayer.getVolume,
    set: mediaPlayer.setVolume
  },
  src: {
    get: playerConfiguration.getMediaSrc,
    set: playerConfiguration.setMediaSrc
  },
  // these are the SP extended interface options
  posterSrc: {
    get: playerConfiguration.getPosterImageSrc,
    set: playerConfiguration.setPosterImageSrc
  },
  xmpSrc: {
    get: playerConfiguration.getXMPSrc,
    set: playerConfiguration.setXMPSrc
  },
  tocSrc: {
    get: playerConfiguration.getTOCSpriteSrc,
    set: playerConfiguration.setTOCSpriteSrc
  },
  mediaTitle: {
    get: playerConfiguration.getMediaTitle,
    set: playerConfiguration.setMediaTitle
  },
  tocTitle: {
    get: playerConfiguration.getTOCTitle,
    set: playerConfiguration.setTOCTitle
  },
  tocChapters: {
    get: mediaPlayer.getTocChapters
  },
  prerollSrc: {
    get: playerConfiguration.getPreRollSrc,
    set: playerConfiguration.setPreRollSrc
  },
  audioDescriptionMediaSrc: {
    get: playerConfiguration.getAudioDescriptionMediaSrc,
    set: playerConfiguration.setAudioDescriptionMediaSrc
  },
  background: {
    get: playerConfiguration.getBackgroundColor,
    set: playerConfiguration.setBackgroundColor
  },
  captions: {
    get: mediaPlayer.getCaptionCollection
  },
  captionTrack: {
    get: mediaPlayer.getCaptionTrack,
    set: mediaPlayer.setCaptionTrack
  },
  captionsVisible: {
    get: mediaPlayer.getCaptionsVisible,
    set: mediaPlayer.setCaptionsVisible
  },
  ignoreStoredCaptionVisible: {
    get: playerConfiguration.getIgnoreStoredCaptionVisibleSetting,
    set: playerConfiguration.setIgnoreStoredCaptionVisibleSetting
  },
  rotation: {
    get: playerConfiguration.getMediaRotation,
    set: playerConfiguration.setMediaRotation
  },
  scrubbing: {
    get: mediaPlayer.getScrubbing,
    set: mediaPlayer.setScrubbing
  },
  isYouTube: {
    get: mediaPlayer.getIsYouTube
  },
  isInFullScreenMode: {
    get: mediaPlayer.isInFullScreenMode
  },
  // debug layer flags
  contextMenu: {
    get: getContextMenuEnabled,
    set: setContextMenuEnabled
  },
  isIphoneOrIpod: {
    get: deviceInfo.isIPhoneOrIPod
  },
  endActionType: {
    get: playerConfiguration.getEndActionType,
    set: playerConfiguration.setEndActionType
  },
  endActionParam: {
    get: playerConfiguration.getEndActionParam,
    set: playerConfiguration.setEndActionParam
  },
  ignoreXmpControllerParameters: {
    get: playerConfiguration.getIgnoreXmpControllerParameters,
    set: playerConfiguration.setIgnoreXmpControllerParameters
  },
  ignoreQuizQuestions: {
    get: playerConfiguration.getIgnoreQuizQuestions,
    set: playerConfiguration.setIgnoreQuizQuestions
  },
  singleClickControlEnabled: {
    get: playerConfiguration.getEnableSingleClickControl,
    set: playerConfiguration.setEnableSingleClickControl
  },
  doubleClickControlEnabled: {
    get: playerConfiguration.getEnableDoubleClickControl,
    set: playerConfiguration.setEnableDoubleClickControl
  },
  useLargerProgressBar: {
    get: playerConfiguration.getUseLargerProgressBar,
    set: playerConfiguration.setUseLargerProgressBar
  },
  displayHotspotsShape: {
    get: playerConfiguration.getDisplayHotspotsShape,
    set: playerConfiguration.setDisplayHotspotsShape
  },
  disablePictureInPicture: {
    get: playerConfiguration.getDisablePictureInPicture,
    set: playerConfiguration.setDisablePictureInPicture
  },
  contentBase: {
    get: playerConfiguration.getContentBase,
    set: playerConfiguration.setContentBase
  },
  skipVideoControlsEnabled: {
    get: playerConfiguration.getSkipVideoControlsEnabled,
    set: playerConfiguration.setSkipVideoControlsEnabled
  },
  skipVideoDuration: {
    get: playerConfiguration.getSkipVideoDuration,
    set: playerConfiguration.setSkipVideoDuration
  },
  allowFastForward: {
    get: playerConfiguration.getAllowFastForward,
    set: playerConfiguration.setAllowFastForward
  },
  showADACompliantCaptions: {
    get: playerConfiguration.getShowADACompliantCaptions,
    set: playerConfiguration.setShowADACompliantCaptions
  },
  disableContinueWithoutQuestions: {
    get: playerConfiguration.getDisableContinueWithoutQuestions,
    set: playerConfiguration.setDisableContinueWithoutQuestions
  },
  logScormApiCalls: {
    get: playerConfiguration.getLogScormApiCalls,
    set: playerConfiguration.setLogScormApiCalls
  },
  videoThumbnailsSrc: {
    get: playerConfiguration.getVideoThumbnailSrc,
    set: playerConfiguration.setVideoThumbnailSrc
  },
  videoThumbnailWidth: {
    get: playerConfiguration.getVideoThumbnailWidth,
    set: playerConfiguration.setVideoThumbnailWidth
  },
  videoThumbnailHeight: {
    get: playerConfiguration.getVideoThumbnailHeight,
    set: playerConfiguration.setVideoThumbnailHeight
  },
  videoThumbnailInterval: {
    get: playerConfiguration.getVideoThumbnailInterval,
    set: playerConfiguration.setVideoThumbnailInterval
  },
  videoThumbnailColumns: {
    get: playerConfiguration.getVideoThumbnailColumns,
    set: playerConfiguration.setVideoThumbnailColumns
  },
  completeScormOnRequirementsComplete: {
    get: playerConfiguration.getCompleteScormOnRequirementsComplete,
    set: playerConfiguration.setCompleteScormOnRequirementsComplete
  },
  progressBarWidth: {
    get: mediaPlayer.getProgressBarDisplayWidth
  },
  customFullScreenDomElement: {
    get: playerConfiguration.getCustomFullScreenDomElement,
    set: playerConfiguration.setCustomFullScreenDomElement
  },
  enableTheaterMode: {
    get: playerConfiguration.getEnableTheaterMode,
    set: playerConfiguration.setEnableTheaterMode
  },
  currentDisplayMode: {
    get: function get() {
      return mediaPlayer.getCurrentDisplayMode() || DisplayModes.Normal;
    }
  },
  ga4EventCallback: {
    get: playerConfiguration.getGA4EventCallback,
    set: playerConfiguration.setGA4EventCallback
  },
  showAcknowledgementLink: {
    get: playerConfiguration.getShowAcknowledgementLink,
    set: playerConfiguration.setShowAcknowledgementLink
  },
  // deprecated
  environment: {
    get: function get() {
      return deprecatedConfigGetter('mediaInterface.environment', 0);
    },
    set: function set() {
      deprecatedConfigSetter('mediaInterface.environment');
    }
  }
});

export { deviceInfo, DisplayModes as displayModes, events, languageCodes, localizationStrings, log, mediaInterfaceController as mediaInterface, mediaInterfaceConstants, mediaPlayer, playerConfiguration, preloadOptions, scormController$1 as scormController, supportedPluginViewElements, themeNames };
//# sourceMappingURL=techsmith-smart-player.esm.js.map
